(function () {
    'use strict';

    angular
        .module('sigeba', [
                'ngSanitize',
                'ngResource',
                'ui.router',
                'ui.select',
                'ngDialog',
                'angular-ladda',
                'ui.bootstrap',
                'angular.filter',
                'pascalprecht.translate'
            ]
        );
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('eighthLayerAssembler', eighthLayerAssembler);

    /** @ngInject */
    function eighthLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/eighth-layer/eighth-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: eighthLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function eighthLayerAssemblerController($rootScope) {
            var vm = this

            // console.log("INIT 8",vm)

            vm.expansion = {}
            vm.lastNode = false
            vm.hasDependency = false
            vm.pushedSections = []

            vm.level = 'eighth'

            evaluateAssemblerType()
            function evaluateAssemblerType() {

                var campo = vm.model.campoSuccessivo
                var sezione = vm.model.sezioneSuccessiva

                if ( campo && !sezione ) {
                    // Ultimo nodo
                    vm.lastNode = true
                    vm.hasDependency = false
                }

                if ( !campo && sezione ) {
                    // Aggiungere la sezione alle possibili dipendenze
                    // Solo successivamente controllerò se in base alle
                    // Risposte selezionate la mia sezione deve essere visualizzata

                    if ( !sezione.titolo ) {
                        // Se la section non continene
                        // il titolo, è subordinata
                        vm.lastNode = false
                        vm.hasDependency = true
                        return
                    }

                    vm.lastNode = false

                    var ref = generateReference()

                    vm.model.refLink = ref
                    vm.model.sezioneSuccessiva = ref
                    // vm.model.modelToRecover = vm.model.sezioneSuccessiva

                    var sectionToPush = {
                        refLink: ref,
                        sezione: sezione
                    }

                    $rootScope.$broadcast('sectionFormulario', sectionToPush);
                }


            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('thirdLayerAssembler', thirdLayerAssembler);

    /** @ngInject */
    function thirdLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/third-layer/third-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: thirdLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function thirdLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false

            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            // vm.iterable.sort(function (a, b) {
            //     return (a.numOrdine - b.numOrdine);
            // })


            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);

                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('tenthLayerAssembler', tenthLayerAssembler);

    /** @ngInject */
    function tenthLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/tenth-layer/tenth-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: tenthLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function tenthLayerAssemblerController($rootScope) {
            var vm = this

            // console.log("INIT 5",vm)

            vm.expansion = {}
            vm.lastNode = false
            vm.hasDependency = false
            vm.pushedSections = []

            vm.level = 'tenth'

            evaluateAssemblerType()
            function evaluateAssemblerType() {

                var campo = vm.model.campoSuccessivo
                var sezione = vm.model.sezioneSuccessiva

                if ( campo && !sezione ) {
                    // Ultimo nodo
                    vm.lastNode = true
                    vm.hasDependency = false
                }

                if ( !campo && sezione ) {
                    // Aggiungere la sezione alle possibili dipendenze
                    // Solo successivamente controllerò se in base alle
                    // Risposte selezionate la mia sezione deve essere visualizzata

                    if ( !sezione.titolo ) {
                        // Se la section non continene
                        // il titolo, è subordinata
                        vm.lastNode = false
                        vm.hasDependency = true
                        return
                    }

                    vm.lastNode = false

                    var ref = generateReference()

                    vm.model.refLink = ref
                    vm.model.sezioneSuccessiva = ref
                    // vm.model.modelToRecover = vm.model.sezioneSuccessiva

                    var sectionToPush = {
                        refLink: ref,
                        sezione: sezione
                    }

                    $rootScope.$broadcast('sectionFormulario', sectionToPush);
                }


            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sixthLayerAssembler', sixthLayerAssembler);

    /** @ngInject */
    function sixthLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/sixth-layer/sixth-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: sixthLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function sixthLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false

            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);

                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('seventhLayerAssembler', seventhLayerAssembler);

    /** @ngInject */
    function seventhLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/seventh-layer/seventh-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: seventhLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function seventhLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false

            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);

                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('secondLayerAssembler', secondLayerAssembler);

    /** @ngInject */
    function secondLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/second-layer/second-layer.html',
            scope: {},
            bindToController: {
                model: '=',
                expansion: '=?'
            },
            controller: secondLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function secondLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false
            
            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            // vm.iterable.sort(function (a, b) {
            //     return (a.numOrdine - b.numOrdine);
            // })

            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);
                
                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
            } 
            
            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('ninthLayerAssembler', ninthLayerAssembler);

    /** @ngInject */
    function ninthLayerAssembler($rootScope) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/ninth-layer/ninth-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: ninthLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ninthLayerAssemblerController() {
            var vm = this

            // console.log("INIT 5",vm)

            vm.expansion = {}
            vm.lastNode = false
            vm.hasDependency = false
            vm.pushedSections = []

            vm.level = 'ninth'

            evaluateAssemblerType()
            function evaluateAssemblerType() {

                var campo = vm.model.campoSuccessivo
                var sezione = vm.model.sezioneSuccessiva

                if ( campo && !sezione ) {
                    // Ultimo nodo
                    vm.lastNode = true
                    vm.hasDependency = false
                }

                if ( !campo && sezione ) {
                    // Aggiungere la sezione alle possibili dipendenze
                    // Solo successivamente controllerò se in base alle
                    // Risposte selezionate la mia sezione deve essere visualizzata

                    if ( !sezione.titolo ) {
                        // Se la section non continene
                        // il titolo, è subordinata
                        vm.lastNode = false
                        vm.hasDependency = true
                        return
                    }

                    vm.lastNode = false

                    var ref = generateReference()

                    vm.model.refLink = ref
                    vm.model.sezioneSuccessiva = ref
                    // vm.model.modelToRecover = vm.model.sezioneSuccessiva

                    var sectionToPush = {
                        refLink: ref,
                        sezione: sezione
                    }

                    $rootScope.$broadcast('sectionFormulario', sectionToPush);
                }


            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fourthLayerAssembler', fourthLayerAssembler);

    /** @ngInject */
    function fourthLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/fourth-layer/fourth-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: fourthLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fourthLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false

            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);

                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('firstLayerAssembler', firstLayerAssembler);

    /** @ngInject */
    function firstLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/first-layer/first-layer.html',
            scope: {},
            bindToController: {
                model: '=',
                expansion: '=?',
                hide: '=?'
            },
            controller: firstLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function firstLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false
            
            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            // vm.iterable.sort(function (a, b) {
            //     return (a.numOrdine - b.numOrdine);
            // })


            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);
                
                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
                vm.hide = true
            } 
            
            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fifthLayerAssembler', fifthLayerAssembler);

    /** @ngInject */
    function fifthLayerAssembler() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-assembler/fifth-layer/fifth-layer.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: fifthLayerAssemblerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fifthLayerAssemblerController( $rootScope, $scope ) {

            var vm = this
            var sezioneRecovery = false

            vm.expansion = {}
            vm.iterable = []
            vm.hasExportedSection = false

            function findIterableSection() {

                if(vm.model.valori) {
                    // console.log("valori",vm.model.valori)
                }
                else if(vm.model.campiSuccessivi) {
                    // console.log("campiSuccessivi",vm.model.campiSuccessivi)
                }
                else if(vm.model.sezioneSuccessiva) {
                    // console.log("sezioneSuccessiva",vm.model.sezioneSuccessiva)

                    if ( vm.model.sezioneSuccessiva.titolo ) {
                        castNewFormulario()
                        return false
                    }

                    if ( vm.model.sezioneSuccessiva.campi ) {
                        return vm.model.sezioneSuccessiva.campi
                    }
                }
                else if(vm.model.sezione) {
                    // console.log("sezione",vm.model.sezione)
                }
            }

            onMount()

            function onMount() {
                recoveryModel()
                vm.iterable = findIterableSection()
            }

            $scope.$on("$destroy", function () {
                if ( vm.hasExportedSection && sezioneRecovery ) removeFormulario()
            });

            function removeFormulario() {
                vm.model.sezioneRecovery = sezioneRecovery
                $rootScope.$broadcast('removeFormulario', vm.model.refLink );
            }

            function recoveryModel() {
                if ( vm.model.sezioneRecovery ) {
                    vm.model.sezioneSuccessiva = vm.model.sezioneRecovery
                }
            }

            function castNewFormulario() {

                var ref = generateReference()

                var sectionToPush = {
                    refLink: ref,
                    sezione: vm.model.sezioneSuccessiva
                }

                sezioneRecovery = JSON.parse(angular.toJson(vm.model.sezioneSuccessiva))

                $rootScope.$broadcast('pushFormulario', sectionToPush);

                vm.model.refLink = ref
                vm.model.sezioneSuccessiva = ref
                vm.hasExportedSection = true
            }

            function generateReference() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVBudget', sgbVBudget);

    /** @ngInject */
    function sgbVBudget() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-budget/sgb-v-budget.html',
            scope: {},
            bindToController: {
                label: '@',
                hideDescriptions: '@',
                model: '=',
                type: '@'
            },
            controller: SgbVBudgetController,
            controllerAs: 'vBdgt'
        };

        return directive;

        /** @ngInject */
        function SgbVBudgetController() {
            var vm = this;

            vm.getTotal = getTotal;

            function getTotal(rows) {
                var result = 0;
                if (rows && rows.length) {
                    for (var i = 0; i < rows.length; i++) {
                        result += rows[i].finanziamentoRichiesto * 1;
                    }
                }
                return result;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVText', sgbVText);

    /** @ngInject */
    function sgbVText() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-text/sgb-v-text.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                model: '='
            },
            controller: SgbVTextController,
            controllerAs: 'sgbVTextCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVTextController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVSelectFields', sgbVSelectFields);

    /** @ngInject */
    function sgbVSelectFields() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-selectFields/sgb-v-selectFields.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                labelFormat: '='
            },
            controller: SgbVSelectFieldsController,
            controllerAs: 'vSelectsCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVSelectFieldsController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVRichText', sgbVRichText);

    /** @ngInject */
    function sgbVRichText() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-rich-text/sgb-v-rich-text.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVRichTextController,
            controllerAs: 'sgbVRichTextCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVRichTextController($sce) {
            var vm = this;
            vm.prepareText = prepareText;

            function prepareText(text) {
                var result = '';
                if (text) {
                    result = text.replace(/ class="image" style="float:left"/g, ' class="image sgb-rt-left"');
                    result = result.replace(/ class="image" style="float:right"/g, ' class="image sgb-rt-right"');
                    result = result.replace(/ style="float:left"/g, ' class="sgb-rt-left"');
                    result = result.replace(/ style="float:right"/g, ' class="sgb-rt-right"');
                    result = result.replace(/ style="text-align:center"/g, ' class="sgb-rt-center"');
                }
               return $sce.trustAsHtml(result);
                // return result;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVResearchIndicatorsPart', sgbVResearchIndicatorsPart);

    /** @ngInject */
    function sgbVResearchIndicatorsPart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-researchIndicatorsPart/sgb-v-researchIndicatorsPart.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVResearchIndicatorsPartController,
            controllerAs: 'vResIndPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVResearchIndicatorsPartController() {
            var vm = this;

            vm.defaultOptions = {
                allowCorrection: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVResearchIndicators2021', sgbVResearchIndicators2021);

    /** @ngInject */
    function sgbVResearchIndicators2021() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-researchIndicators2021/sgb-v-researchIndicators2021.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVResearchIndicators2021Controller,
            controllerAs: 'vResIndCtrl2021'
        };

        return directive;

        /** @ngInject */
        function SgbVResearchIndicators2021Controller() {
            var vm = this;

            vm.defaultOptions = {
                allowCorrection: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVResearchIndicators', sgbVResearchIndicators);

    /** @ngInject */
    function sgbVResearchIndicators() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-researchIndicators/sgb-v-researchIndicators.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVResearchIndicatorsController,
            controllerAs: 'vResIndCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVResearchIndicatorsController() {
            var vm = this;

            vm.defaultOptions = {
                allowCorrection: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVReport', sgbVReport);

    /** @ngInject */
    function sgbVReport() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-report/sgb-v-report.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                modelMotivazione: '=',
                checkScostamento: '='
            },
            controller: SgbVReportController,
            controllerAs: 'vReprt'
        };

        return directive;

        /** @ngInject */
        function SgbVReportController($timeout) {
            var vm = this;
            
            //vm.selectValues = {};
            vm.asteriskRows = [];
            
            vm.getTotal = getTotal;
            vm.checkPercSpeso = checkPercSpeso;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model) {
                    /*for (var i = 0; i < vm.model.length; i++) {
                        var row = vm.model[i];
                        if (row.tipo == 'IMPORTO_FISSO') {
                            if (row.finanziamentoRichiesto)
                                vm.selectValues[row.id] = ((row.finanziamentoRichiesto * 1) / row.importo) + '';
                            else
                                vm.selectValues[row.id] = '0';
                        }
                    }*/
                    
                    angular.forEach(vm.model.vociRendicontoList, checkPercSpeso);
                }
            }
            
            function getTotal(rows, field) {
                var result = 0;
                if (rows && rows.length) {
                    for (var i = 0; i < rows.length; i++) {
                        result += rows[i][field] * 1;
                    }
                }
                return result;
            }
            
            function checkPercSpeso(row, index) {
                
                if(isNaN(row.finanziamentoSpeso))
                    vm.asteriskRows[index] = false;
                
                var concesso = row.finanziamentoRichiesto / vm.model.totaleRichiesto * vm.model.totaleConcesso;
                var delta = concesso * 0.2;
                var min = concesso - delta;
                var max = concesso + delta;
                
                if(row.finanziamentoSpeso < min || row.finanziamentoSpeso > max)
                    vm.asteriskRows[index] = true;
                else
                    vm.asteriskRows[index] = false;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVPublicationsRend', sgbVPublicationsRend);

    /** @ngInject */
    function sgbVPublicationsRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-publicationsRend/sgb-v-publicationsRend.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVPublicationsRendController,
            controllerAs: 'vPubblRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVPublicationsRendController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVPublicationsPart', sgbVPublicationsPart);

    /** @ngInject */
    function sgbVPublicationsPart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-publicationsPart/sgb-v-publicationsPart.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVPublicationsPartController,
            controllerAs: 'vPubblPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVPublicationsPartController() {
            var vm = this;

            vm.defaultOptions = {
                showImpactFactor: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVPublications', sgbVPublications);

    /** @ngInject */
    function sgbVPublications() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-publications/sgb-v-publications.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVPublicationsController,
            controllerAs: 'vPubblCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVPublicationsController() {
            var vm = this;

            vm.defaultOptions = {
                showImpactFactor: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVProgettiManual', sgbVProgettiManual);

    /** @ngInject */
    function sgbVProgettiManual() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-progettiManual/sgb-v-progettiManual.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                numMax: '@',
                model: '=',
                type: '@'
            },
            controller: SgbVProgettiManualController,
            controllerAs: 'vprogManCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVProgettiManualController() {
            var vm = this;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVPreviousFundingsNewNoPercImpegno', sgbVPreviousFundingsNewNoPercImpegno);

    /** @ngInject */
    function sgbVPreviousFundingsNewNoPercImpegno() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-previousFundingsNewNoPercImpegno/sgb-v-previousFundingsNewNoPercImpegno.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVPreviousFundingsNewNoPercImpegnoController,
            controllerAs: 'vPrevFundNPercImpCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVPreviousFundingsNewNoPercImpegnoController() {
            var vm = this;

            vm.defaultOptions = {
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVPreviousFundingsNew', sgbVPreviousFundingsNew);

    /** @ngInject */
    function sgbVPreviousFundingsNew() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-previousFundingsNew/sgb-v-previousFundingsNew.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                options: '='
            },
            controller: SgbVPreviousFundingsNewController,
            controllerAs: 'vPrevFundNCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVPreviousFundingsNewController() {
            var vm = this;

            vm.defaultOptions = {
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVPreviousFundings', sgbVPreviousFundings);

    /** @ngInject */
    function sgbVPreviousFundings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-previousFundings/sgb-v-previousFundings.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                type: '@'
            },
            controller: SgbVPreviousFundingsController,
            controllerAs: 'vPrevFundCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVPreviousFundingsController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVParticipantsRend', sgbVParticipantsRend);

    /** @ngInject */
    function sgbVParticipantsRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-participantsRend/sgb-v-participantsRend.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVParticipantsRendController,
            controllerAs: 'vPartRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVParticipantsRendController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVParticipantsManualRend', sgbVParticipantsManualRend);

    /** @ngInject */
    function sgbVParticipantsManualRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-participantsManualRend/sgb-v-participantsManualRend.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVParticipantsManualRendController,
            controllerAs: 'vPartManRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVParticipantsManualRendController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVParticipantsManual', sgbVParticipantsManual);

    /** @ngInject */
    function sgbVParticipantsManual() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-participantsManual/sgb-v-participantsManual.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVParticipantsManualController,
            controllerAs: 'vPartManCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVParticipantsManualController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVParticipants', sgbVParticipants);

    /** @ngInject */
    function sgbVParticipants() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-participants/sgb-v-participants.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                type: '@'
            },
            controller: SgbVParticipantsController,
            controllerAs: 'vPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVParticipantsController() {
            var vm = this;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVOtherFundings', sgbVOtherFundings);

    /** @ngInject */
    function sgbVOtherFundings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-otherFundings/sgb-v-otherFundings.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVOtherFundingsController,
            controllerAs: 'vOthFundCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVOtherFundingsController() {
            var vm = this;
            
            vm.getTotal = getTotal;
            
            function getTotal(rows) {
                var result = 0;
                if (rows && rows.length) {
                    for (var i = 0; i < rows.length; i++) {
                        result += rows[i].contributoOttenuto * 1;
                    }
                }
                return result;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVLineeTematiche', sgbVLineeTematiche);

    /** @ngInject */
    function sgbVLineeTematiche() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-lineeTematiche/sgb-v-lineeTematiche.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                type: '@'
            },
            controller: sgbVLineeTematicheController,
            controllerAs: 'vlinTemCtrl'
        };

        return directive;

        /** @ngInject */
        function sgbVLineeTematicheController() {
            var vm = this;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVLastFundingsNew', sgbVLastFundingsNew);

    /** @ngInject */
    function sgbVLastFundingsNew() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-lastFundingsNew/sgb-v-lastFundingsNew.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVLastFundingsNewController,
            controllerAs: 'vLastFundsNCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVLastFundingsNewController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVLastFundings', sgbVLastFundings);

    /** @ngInject */
    function sgbVLastFundings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-lastFundings/sgb-v-lastFundings.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVLastFundingsController,
            controllerAs: 'vLastFundsCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVLastFundingsController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVKeywordsSelect', sgbVKeywordsSelect);

    /** @ngInject */
    function sgbVKeywordsSelect() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-keywordsSelect/sgb-v-keywordsSelect.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                choicesLabel: '@'
            },
            controller: SgbVKeywordsSelectController,
            controllerAs: 'vKeySelCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVKeywordsSelectController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVKeywords', sgbVKeywords);

    /** @ngInject */
    function sgbVKeywords() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-keywords/sgb-v-keywords.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVKeywordsController,
            controllerAs: 'vKeywordsCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVKeywordsController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVIndicatoriImpattoSostenibilita', sgbVIndicatoriImpattoSostenibilita);

    /** @ngInject */
    function sgbVIndicatoriImpattoSostenibilita() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-indicatoriImpattoSostenibilita/sgb-v-indicatoriImpattoSostenibilita.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: sgbVIndicatoriImpattoSostenibilitaController,
            controllerAs: 'indImpSostCtrl'
        };

        return directive;

        /** @ngInject */
        function sgbVIndicatoriImpattoSostenibilitaController(ngDialog,$timeout) {
            var vm = this;


          $timeout(onInit);

            function onInit(){
              if(!(vm && vm.model && vm.model.indicatoriList.length>0)){
                vm.model={indicatoriList:[]};
              }
          }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVHIndexPart', sgbVHIndexPart);

    /** @ngInject */
    function sgbVHIndexPart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-hIndexPart/sgb-v-hIndexPart.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVHIndexPartController,
            controllerAs: 'vHIndPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVHIndexPartController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVHIndex', sgbVHIndex);

    /** @ngInject */
    function sgbVHIndex() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-hIndex/sgb-v-hIndex.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '='
            },
            controller: SgbVHIndexController,
            controllerAs: 'vHIndexCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVHIndexController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVFileUpload', sgbVFileUpload);

    /** @ngInject */
    function sgbVFileUpload() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-fileUpload/sgb-v-fileUpload.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                model: '=',
                nameOnly: '='
            },
            controller: SgbVFileUploadController,
            controllerAs: 'vFileUpCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVFileUploadController(Constants, UserData) {
            var vm = this;
            
            vm.getFileHref = getFileHref;
            
            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL + '?token=' + UserData.getToken();
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id + '/proposta?token=' + UserData.getToken();
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVFileMultipleUpload', sgbVFileMultipleUpload);

    /** @ngInject */
    function sgbVFileMultipleUpload() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-fileMultipleUpload/sgb-v-fileMultipleUpload.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                model: '=',
                nameOnly: '='
            },
            controller: SgbVFileMultipleUploadController,
            controllerAs: 'vFileMUCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVFileMultipleUploadController(Constants, UserData) {
            var vm = this;
            
            vm.getFileHref = getFileHref;
            
            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL + '?token=' + UserData.getToken();
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id + '/proposta?token=' + UserData.getToken();
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVCurrencyField', sgbVCurrencyField);

    /** @ngInject */
    function sgbVCurrencyField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-currencyField/sgb-v-currencyField.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                model: '='
            },
            controller: sgbVCurrencyFieldController,
            controllerAs: 'sgbVCurrencyField'
        };

        return directive;

        /** @ngInject */
        function sgbVCurrencyFieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVComplexField', sgbVComplexField);

    /** @ngInject */
    function sgbVComplexField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-complexField/sgb-v-complexField.html',
            scope: {},
            bindToController: {
                label: '@',
                model: '=',
                info: '='
            },
            controller: SgbVComplexFieldController,
            controllerAs: 'vCplxField'
        };

        return directive;

        /** @ngInject */
        function SgbVComplexFieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbVCheckbox', sgbVCheckbox);

    /** @ngInject */
    function sgbVCheckbox() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/view/sgb-v-checkbox/sgb-v-checkbox.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                model: '='
            },
            controller: SgbVCheckboxController,
            controllerAs: 'sgbVCheckboxCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbVCheckboxController() {
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaSeduteCert', listaSeduteCert);

    /** @ngInject */
    function listaSeduteCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/seduteCert/listaSeduteCert/listaSeduteCert.html',
            scope: {},
            bindToController: {},
            controller: ListaSeduteController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaSeduteController(AuthService, SeduteCertService, $log, $state, $timeout, ngDialog) {
            var vm = this;
            vm.goToDettaglioSeduta = goToDettaglioSeduta
            vm.getSeduteList = getSeduteList;
            vm.pagination = {
                current: 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            var utente = AuthService.getUserInfo().utente;
            vm.seduteList = null;

            getSeduteList(false)
                .catch(function (error) {
                    $log.error("Errore nel reperimento delle informazioni sulle sedute", error);
                })

            function getSeduteList(keepPagination) {

                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                return SeduteCertService.getSeduteCertList(filter)
                    .then(function (data) {
                        vm.seduteList = data.resultList
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog("Errore durante il recupero dei dati");
                    });
            }

            function showGenericErrorDialog(message) {
                var dialog = ngDialog.open({
                    template: '<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Provare a ricaricare la pagina ed eseguire nuovamente l\'operazione.<br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }

            function goToDettaglioSeduta(sedutaId) {
                $timeout(function(){
                    if (utente.tipoUtente === 'UFFICIO_CERT')
                        $state.go('sedutaCert', {'id': sedutaId});
                    else
                        $state.go('sedutaPresCert', {'id': sedutaId});
                },100)
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('sedutaCert', sedutaCert);

    /** @ngInject */
    function sedutaCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/seduteCert/sedutaCert/sedutaCert.html',
            scope: {},
            bindToController: {
                sedutaId: '=?'
            },
            controller: SedutaCertController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SedutaCertController(AuthService, SeduteCertService, CertCommissioniService, $log, $state, $q, $timeout, ngDialog) {
            var vm = this;
            var index = -1;
            vm.saveSeduta = saveSeduta;
            vm.insertRemoveProposta = insertRemoveProposta;
            vm.checkProposteIncludes = checkProposteIncludes;
            vm.getProposteCertForSeduta = getProposteCertForSeduta;
            var utente = AuthService.getUserInfo().utente;
            vm.minDate = new Date();
            vm.sedutaId = vm.sedutaId.length === 0 ? null : vm.sedutaId;
            vm.seduta = {
                dataSeduta: null,
                certCommissione: null
            };
            vm.proposteCert = null;
            vm.pagination = {
                current: 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };
            vm.certMembriProposta = [];
            var proposteCertSelezionate = [];

            if (vm.sedutaId) {
                vm.pageHeaderSeduta = "Dettaglio Seduta";
                getDettaglioSeduta()
                    .then(getProposteCertForSeduta(false))
                    .then(getCertMembriProposta())
                    .catch(function (error) {
                        $log.error("Errore nel reperimento delle informazioni sul dettaglio seduta", error);
                    });
            } else {
                vm.pageHeaderSeduta = "Nuova Seduta";
                getCertCommissioneCorrente()
                    .then(getProposteCertForSeduta(false))
                    .catch(function (error) {
                        $log.error("Errore nel reperimento delle informazioni sulla commissione corrente", error);
                    });
            }

            function saveSeduta() {
                if (proposteCertSelezionate.length === 0)
                    return showErrorProposta("Selezionare una Proposta");
                if (!vm.seduta.dataSeduta)
                    return showErrorProposta("Inserire la Data Delibera");
                if (vm.certMembriProposta.length === 0)
                    return showErrorProposta("Selezionare un Membro di Commissione");

                var certSedutaObj = {
                    certSeduta: vm.seduta,
                    certProposte: proposteCertSelezionate,
                    certMembroPropostaList: vm.certMembriProposta
                }
                var savingDialog = showSavingDialog();
                SeduteCertService.saveSedutaAndMembri(certSedutaObj)
                    .then(function (data) {
                        savingDialog.close();
                        if (utente.tipoUtente === 'UFFICIO_CERT')
                            $state.go('sedutaCert', {'id': data.id});
                        else
                            $state.go('sedutaPresCert', {'id': data.id});
                    })
                    .catch(function (error) {
                        $log.error("Error loadInstance", error);
                        savingDialog.close();
                        showGenericErrorDialog("Errore durante il salvataggio della seduta");
                    });
            }

            function getCertMembriProposta() {
                return SeduteCertService.getCertMembriPropostaBySeduta(vm.sedutaId)
                    .then(function (data) {
                        convertCertMembriProposta(data);
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog("Errore durante il recupero dei membri commissione associati alla seduta");
                    });
            }

            function convertCertMembriProposta(membriProposta) {
                for (var i = 0; i < membriProposta.length; i++) {
                    var membroProposta = {
                        presente: membriProposta[i].presente,
                        certMembroCommissioneDTO: membriProposta[i].certMembroCommissione,
                        isInterno: membriProposta[i].certMembroCommissione.classeUtente.includes("UtenteInterno")
                    }
                    vm.certMembriProposta.push(membroProposta)
                }
            }

            function getCertCommissioneCorrente() {
                return CertCommissioniService.getCertCommissioneCorrente()
                    .then(function (data) {
                        vm.seduta.certCommissione = data;
                        createCertMembriProposta(data.membri);
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog("Errore durante il recupero della commissione corrente");
                    });
            }

            function createCertMembriProposta(membriCommissione) {
                for (var i = 0; i < membriCommissione.length; i++) {
                    var membroProposta = {
                        presente: false,
                        certMembroCommissioneDTO: membriCommissione[i],
                        isInterno: membriCommissione[i].isInterno
                    }
                    vm.certMembriProposta.push(membroProposta)
                }
            }

            function getProposteCertForSeduta(keepPagination) {

                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit,
                    sedutaId: vm.sedutaId
                };

                return SeduteCertService.getProposteCertForSeduta(filter)
                    .then(function (data) {
                        vm.proposteCert = data.resultList
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog("Errore durante il recupero dei dati");
                    });
            }

            function getDettaglioSeduta() {
                return SeduteCertService.getDettaglioSeduta(vm.sedutaId)
                    .then(function (data) {
                        vm.seduta = data;
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog("Errore durante il recupero dei dati");
                    });
            }

            function showGenericErrorDialog(message) {
                return ngDialog.open({
                    template: '<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Provare a ricaricare la pagina ed eseguire nuovamente l\'operazione.<br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });
            }

            function showErrorProposta(message) {
                return ngDialog.open({
                    template: '<h3 style="margin-top: 0px;">Attenzione</h3><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });
            }

            function insertRemoveProposta(proposta) {
                if (checkProposteIncludes(proposta)) {
                    proposteCertSelezionate.splice(index, 1);
                } else {
                    proposteCertSelezionate.push(proposta);
                }
            }

            function checkProposteIncludes(proposta) {
                for (var i = 0; i < proposteCertSelezionate.length; i++) {
                    if (proposteCertSelezionate[i].id === proposta.id){
                        index = i;
                        return true;
                    }
                }
                return false;
            }

            function showSavingDialog() {
                return ngDialog.open({
                    template: 'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcTextInput', fpcTextInput);

    /** @ngInject */
    function fpcTextInput() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-text-input/fpc-text-input.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcTextInputController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcTextInputController($scope,$rootScope,$timeout) {
            var vm = this

            var required = vm.model.flagRequired

            var alertRequired = { label: 'Questo campo di testo è obbligatorio.' }
            var alertMaxChar = { label: 'Il campo non puo superare i ' + vm.model.maxLengthSize + ' caratteri di lunghezza.' }

            vm.remainingChars = vm.model.valoreDatoProposta ? vm.model.maxLengthSize - vm.model.valoreDatoProposta.length : vm.model.maxLengthSize;
            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.hide = false
            vm.validateString = validateString
            vm.debounceValidate = debounceValidate

            vm.uid = generateUID()

            $scope.$on("triggerAtomicValidation", function () {
                validateString()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function debounceValidate() {
                debounce( validateString, 250 )
            }

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function syncInstanceOfInput() {
                // if ( !required ) return
                var valid = !vm.alert ? true : false
                var data = { id: vm.uid, required: required, valid: valid, vm:vm }
                $rootScope.$broadcast('updateValidation', data );
            }

            function validateString() {
                var str = vm.model.valoreDatoProposta
                var baseMax = vm.model.maxLengthSize

                if ( !str ) {
                    vm.remainingChars = baseMax
                    if ( required ) {
                        vm.alert = alertRequired
                        syncInstanceOfInput()
                    } else {
                        vm.alert = false
                        syncInstanceOfInput()
                        pushTitoloRicerca()
                    }
                } else {
                    vm.remainingChars = baseMax - str.length
                    if ( str.length > baseMax ) {
                        vm.alert = alertMaxChar
                    } else {
                        vm.alert = false
                    }
                    syncInstanceOfInput()
                    pushTitoloRicerca()
                }
            }

            var timer;
            var debounce = function(fn, d) {
                if (timer) $timeout.cancel(timer);
                timer = $timeout(fn, d);
              }

            function pushTitoloRicerca() {
                var label = vm.model.label == "Titolo della ricerca"
                var data = vm.model.valoreDatoProposta

                if ( label && data ) {
                    $rootScope.$broadcast('setTitle', data );
                }
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcSectionTitle', fpcSectionTitle);

    /** @ngInject */
    function fpcSectionTitle() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-section-title/fpc-section-title.html',
            scope: {},
            bindToController: {
                model: "="
            },
            controller: fpcSectionTitleController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcSectionTitleController() {
            var vm = this
            // console.log("fpcSectionTitleController :", vm)

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcRecapDisplay', fpcRecapDisplay);

    /** @ngInject */
    function fpcRecapDisplay() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-recap-display/fpc-recap-display.html',
            scope: {},
            bindToController: {
                model: '='
            },
            controller: fpcRecapDisplayController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcRecapDisplayController() {
            var vm = this
            // console.log("fpcRecapDisplayController :", this)

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcRadioGroup', fpcRadioGroup);

    /** @ngInject */
    function fpcRadioGroup() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-radio-group/fpc-radio-group.html',
            scope: {},
            bindToController: {
                model: '=?',
                expansion: '=?',
                uid: '=?',
                level: '=?',
                locked: '=?'
            },
            controller: fpcRadioGroupController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcRadioGroupController($scope,$rootScope) {
            var vm = this
            var required = vm.model.flagRequired

            vm.alert = false

            vm.set = vm.model.valori
            vm.onRadioChange = onRadioChange
            vm.onRadioLoad = onRadioLoad
            vm.campoFantasma = vm.model.label ? false : true

            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.uid = generateUID()
            vm.columnLayout = evaluateLayout()
            vm.forceDisable = false

            onLoad()

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $rootScope.$on("closeModal", function (e, uidRef) {
                if ( uidRef === vm.uid ) {
                    syntheticRadioFlip()
                }
            });

            $rootScope.$on("propagateFlip", function (e, bool) {
                if ( bool ) {
                    checkForCollateralActivation()
                } else {
                    releaseCollateralActivation()
                }
            });

            function onLoad(){
                checkForRecovery()
                onRadioLoad()
            }

            function checkForRecovery() {
                // console.log("mount", vm.model)
            }

            function syntheticRadioFlip() {
                var other = null
                vm.model.valoreDatoProposta = (other && other.id) ? other.id : null
                onRadioChange()
            }

            function onRadioLoad() {
                checkForChildrenSection(true)
                checkForCollateralValidation()
                syncInstanceOfInput()
                resolveValidationError()
                checkFlussi(false)
            }

            function onRadioChange() {
                // console.log("CHANGE", vm.model)
                // Verifica se l'opzione scelta comporta
                // il rendering condizionale di altri input
                checkForChildrenSection(false)
                checkForCollateralValidation()
                syncInstanceOfInput()
                resolveValidationError()
                checkFlussi(true)
            }

            function syncInstanceOfInput() {
                if ( !required ) return
                var valid = vm.model.valoreDatoProposta ? true : false
                var data = { id: vm.uid, required: required, valid: valid }
                $rootScope.$broadcast('updateValidation', data );

            }

            function checkForCollateralValidation() {
                var sezioneUno = vm.model.id == 12
                var rispostaSi = vm.model.valoreDatoProposta == 2
                if ( sezioneUno ) {
                    var needsCollateral = rispostaSi ? true : false
                    $rootScope.$broadcast('collateralSection', needsCollateral);
                }
            }

            function checkForCollateralActivation() {
                var sezioneNove = vm.model.id == 20
                if ( sezioneNove ) {
                    vm.model.valoreDatoProposta = 18
                    onRadioChange()
                    vm.forceDisable = true
                } else {
                    vm.forceDisable = false
                }
            }

            function checkFlussi(viewModal) {
                var data = {};
                // Flusso 2
                //aggiungere l'id del record cert_campo (nel mio caso ho aggiunto 13 perché monitoro la risposta alla domanda 2 per la scelta del feed)
                //nel data.risposta aggiungere l'id del record della tabella cert_campo_valore con valore sì
                var changeFlusso2 = (vm.model.id == 29 && vm.model.valoreDatoProposta) || (vm.model.id == 13 && vm.model.valoreDatoProposta) ||
                    (vm.model.id == 270 && vm.model.valoreDatoProposta) || (vm.model.id == 30 && vm.model.valoreDatoProposta) || (vm.model.id == 28 && vm.model.valoreDatoProposta)
                if (changeFlusso2) {
                    data = {id: vm.model.id,
                        risposta: (vm.model.valoreDatoProposta == 32 || vm.model.valoreDatoProposta == 337 || vm.model.valoreDatoProposta == 34 || vm.model.valoreDatoProposta == 4 || vm.model.valoreDatoProposta == 30),
                        viewModal: viewModal,
                        idSezione: 10 }
                    $rootScope.$broadcast('checkFlussi', data);
                }
                // Flusso 8
                var changeFlusso8 = (vm.model.id == 49 && vm.model.valoreDatoProposta) || (vm.model.id == 50 && vm.model.valoreDatoProposta) || (vm.model.id == 16 && vm.model.valoreDatoProposta)
                if (changeFlusso8) {
                    data = {id: vm.model.id,
                        risposta: (vm.model.valoreDatoProposta == 62 || vm.model.valoreDatoProposta == 64 || vm.model.valoreDatoProposta == 18),
                        viewModal: viewModal,
                        idSezione: 19 }
                    $rootScope.$broadcast('checkFlussi', data);
                }
                // Flusso 5
                var changeFlusso5 = (vm.model.id == 41 && vm.model.valoreDatoProposta) || (vm.model.id == 42 && vm.model.valoreDatoProposta) || (vm.model.id == 19 && vm.model.valoreDatoProposta)
                if (changeFlusso5) {
                    data = {id: vm.model.id,
                        risposta: (vm.model.valoreDatoProposta == 49 || vm.model.valoreDatoProposta == 51 || vm.model.valoreDatoProposta == 11),
                        viewModal: viewModal,
                        idSezione: 13 }
                    $rootScope.$broadcast('checkFlussi', data);
                }
            }

            function releaseCollateralActivation() {
                var sezioneNove = vm.model.id == 20
                if ( sezioneNove ) {
                    vm.model.valoreDatoProposta = null
                    vm.forceDisable = false
                    onRadioChange()
                }
            }

            function removeInstanceOfInput() {
                // console.log("REMOVE input", vm.model.valoreDatoProposta)
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
                vm.model.valoreDatoProposta = null
            }

            function checkForChildrenSection(onLoad) {
                if ( !vm.uid ) return

                var id =  vm.model.valoreDatoProposta
                var item = vm.model.valori.find( function( item ) { return item.id == id } )

                var expandable = (
                    item &&
                    item.campiSuccessivi &&
                    item.campiSuccessivi.length
                )

                if ( expandable ) {
                    if ( nextFieldIsAlert( item ) ) {
                        item.campiSuccessivi[0].campoSuccessivo.uidRef = vm.uid
                    }
                    if (!(nextFieldIsAlert( item ) && onLoad)) // non apro i modal se sto caricando l'istanza
                        vm.expansion[vm.uid] = item.campiSuccessivi
                } else if ( vm.expansion && vm.expansion[vm.uid] ) {
                    delete vm.expansion[vm.uid]
                }
            }

            function manageErrorState() {
                var alert = {label: "Questo campo è necessario all'invio dell'istanza."}
                var value = vm.model.valoreDatoProposta
                if ( required && !value ) {
                    vm.alert = alert
                } else if ( required && value ) {
                    vm.alert = false
                }
            }

            function resolveValidationError() {
                var value = vm.model.valoreDatoProposta
                if ( required && value ) {
                    vm.alert = false
                }
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }

            function evaluateLayout() {
                return ( vm.set && vm.set.length && vm.set.length >= 2 ) ? true : false
            }

            function nextFieldIsAlert(item) {
                return (
                    item.campiSuccessivi[0] &&
                    item.campiSuccessivi[0].campoSuccessivo &&
                    item.campiSuccessivi[0].campoSuccessivo.tipoCampo &&
                    item.campiSuccessivi[0].campoSuccessivo.tipoCampo == "ALERT"
                )
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcParoleCunInput', fpcParoleCunInput);

    /** @ngInject */
    function fpcParoleCunInput() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-parole-cun-input/fpc-parole-cun-input.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '='
            },
            controller: fpcParoleCunInputController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcParoleCunInputController($scope, ParoleChiaveService, $log) {
            var vm = this

            var duplicateAlert = { label: "Non puoi inserire parole chiave duplicate." }
            var requiredAlert = { label: "Seleziona almeno una parola chiave per proseguire." }
            var required = vm.model.flagRequired

            vm.maxWords = 5;
            vm.choicesFilter = choicesFilter;
            vm.onSelect = onSelect;
            vm.selectedKeywords = []
            vm.setCun = []

            vm.readOnly = vm.locked || vm.model.flagReadonly

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            onInit()

            function onInit() {

                loadParoleCun()

                // Define range from model
                vm.range = Array.from(
                    { length: vm.maxWords },
                    function (v, i) { return i }
                );
            }

            function onSelect() {
                vm.model.valoreDatoPropostaFeed = []
                vm.selectedKeywords.forEach( function( item ){
                    if ( item ) vm.model.valoreDatoPropostaFeed.push(item.id)
                })

                validateParoleCun()

            }

            function recoverPreviousSessions() {
                if ( vm.model.valoreDatoPropostaFeed ) {
                    vm.model.valoreDatoPropostaFeed.forEach( function( item ){
                        var found = vm.setCun.find( function(_item) { return _item.id == item } )
                        if ( found ) {
                            vm.selectedKeywords.push( found )
                        }
                    })
                }
            }

            function loadParoleCun() {
                ParoleChiaveService.getParoleChiaveCUN()
                .then( function(data){
                    vm.setCun = data
                    recoverPreviousSessions()
                })
                .catch( function(e){
                    $log.error("Errore loadParoleCun", e)
                })
            }

            function choicesFilter(searchString) {

                return function(item) {
                    if (!searchString)
                        return false;
                    var label = angular.lowercase(item.valoreIT);
                    if (label)
                        return (label.indexOf(angular.lowercase(searchString)) >= 0);
                    else
                        return false;
                }
            }

            function validateParoleCun() {

                if ( hasDuplicates( vm.model.valoreDatoPropostaFeed ) ) {
                    vm.alert = duplicateAlert
                    return
                }

                manageErrorState()

                vm.alert = false
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoPropostaFeed
                if ( required && !value ) {
                    vm.alert = requiredAlert
                } else if ( required && value ) {
                    vm.alert = false
                }
            }

            function hasDuplicates(array) {
                return (new Set(array)).size !== array.length;
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcNumberInput', fpcNumberInput);

    /** @ngInject */
    function fpcNumberInput() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-number-input/fpc-number-input.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcNumberInputController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcNumberInputController($scope, $rootScope) {
            var vm = this

            var alertRequired = { label: 'Questo campo numerico è obbligatorio.' }
            var required = vm.model.flagRequired

            vm.model.valoreDatoProposta = Number(vm.model.valoreDatoProposta);
            vm.validateString = validateString
            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.uid = generateUID()

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoProposta
                if ( required && !value ) {
                    vm.alert = alertRequired
                    syncInstanceOfInput(false);
                } else if ( required && value ) {
                    vm.alert = false
                    syncInstanceOfInput(true);
                }
            }

            function validateString() {

                if ( required && !vm.model.valoreDatoProposta ) {
                    vm.alert = alertRequired
                    syncInstanceOfInput(false);
                } else {
                    vm.alert = false
                    syncInstanceOfInput(true);
                }
            }

            function syncInstanceOfInput(valore) {
                if ( !required ) return
                var data = { id: vm.uid, required: required, valid: valore }
                $rootScope.$broadcast('updateValidation', data );
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcFileUpload', fpcFileUpload);

    /** @ngInject */
    function fpcFileUpload() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-file-upload/fpc-file-upload.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '='
            },
            controller: fpcFileUploadController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcFileUploadController(MediaService, Constants, UserData, $log, $scope, $rootScope) {
            var vm = this

            var alertRequired = { label: 'Il caricamento del file è necessario alla convalida del form.' }
            var required = vm.model.flagRequired

            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.loading = false;
            vm.uploadError = null;
            vm.selectedFile = null;

            vm.uploadFile = uploadFile;
            vm.removeFile = removeFile;
            vm.getFileHref = getFileHref;
            // Controllo per verificare se devo mostrare l'upload di Lettera Revisori
            vm.checkRender = checkRender;

            vm.uid = generateUID()

            onMount()
            function onMount(){
                if ( vm.model.valoreDatoProposta ) {
                    vm.selectedFile = {}
                    vm.selectedFile.id = vm.model.valoreDatoProposta
                }
            }

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function syncInstanceOfInput(valore) {
                if ( !required ) return
                var data = { id: vm.uid, required: required, valid: valore }
                $rootScope.$broadcast('updateValidation', data );
            }

            function uploadFile(files) {
                vm.uploadError = null;
                if (files.length >= 1) {
                    vm.loading = true;

                    if(vm.maxfilesize){
                        MediaService.uploadPdfMaxFileSize(files[0],vm.model.maxLengthSize)
                            .then(function(data) {
                                vm.selectedFile = data;
                                vm.model.valoreDatoProposta = vm.selectedFile.id;
                                vm.loading = false;
                            })
                            .catch(function(error) {
                                $log.error("Errore nell'upload del file pdf", error);
                                vm.selectedFile = null;
                                vm.model.valoreDatoProposta = null;
                                vm.loading = false;
                                if (error.data.message) {
                                    vm.uploadError = error.data.message;
                                    vm.alert = { label: error.data.message }
                                } else {
                                    vm.uploadError = "Errore nell'upload del file pdf.";
                                    vm.alert = { label: "Errore nell'upload del file pdf." }
                                }
                            });
                    }else{
                        MediaService.uploadPdf(files[0])
                            .then(function(data) {
                                vm.selectedFile = data;
                                vm.model.valoreDatoProposta = vm.selectedFile.id;
                                vm.loading = false;
                                manageErrorState()
                            })
                            .catch(function(error) {
                                $log.error("Errore nell'upload del file pdf", error);
                                vm.selectedFile = null;
                                vm.model.valoreDatoProposta = null;
                                vm.loading = false;
                                if (error.data.message) {
                                    vm.uploadError = error.data.message;
                                    vm.alert = { label: error.data.message }
                                } else {
                                    vm.uploadError = "Errore nell'upload del file pdf.";
                                    vm.alert = { label: "Errore nell'upload del file pdf." }
                                }
                            });
                    }
                }
                syncInstanceOfInput();
            }

            function removeFile() {
                vm.selectedFile = null;
                vm.model.valoreDatoProposta = null;
                removeInstanceOfInput();
            }

            function getFileHref(fileModel) {
                return Constants.restApiRoot + '/media/' + fileModel.valoreDatoProposta + '/propostaCert?token=' + UserData.getToken();
            }

            function checkRender(model) {
                if (model.origineCampo) {
                    return !isNaN(model.origineCampo);
                } else {
                    return true;
                }
            }

            function manageErrorState() {
                var value = vm.selectedFile
                if ( required && !value ) {
                    vm.alert = alertRequired
                    syncInstanceOfInput(false);
                } else if ( required && value ) {
                    vm.alert = false
                    syncInstanceOfInput(true);
                }
            }

        }
    }

    function generateUID() {
        return String(Math.random().toString(36).slice(-6))
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcFieldSwitch', fpcFieldSwitch);

    /** @ngInject */
    function fpcFieldSwitch($state) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-field-switch/fpc-field-switch.html',
            scope: {},
            bindToController: {
                model: '=',
                expansion: '=?',
                hide: '=?'
            },
            controller: fpcFieldSwitchController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcFieldSwitchController() {
            var vm = this
            
            checkLocked()

            function checkLocked() {
                var state = $state.current.name
                vm.locked = ( state == "propostaCertView" || state == "propostaCertViewUc" ) ? true : false
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcEmailInput', fpcEmailInput);

    /** @ngInject */
    function fpcEmailInput() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-email-input/fpc-email-input.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcEmailInputController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcEmailInputController($scope, $rootScope) {
            var vm = this

            var required = vm.model.flagRequired
            var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

            var alertMessage = { label: "L'email inserita risulta incorretta o invalida." }
            var alertRequired = { label: 'Questo campo di testo è obbligatorio.' }

            vm.alert = false
            vm.validateMail = validateMail
            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.uid = generateUID()

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoProposta
                validateMail(value)
                if (required && (!value || vm.alert)) {
                    vm.alert = alertRequired
                    syncInstanceOfInput(false)
                } else if (required && value ) {
                    vm.alert = false
                    syncInstanceOfInput(true)
                }
            }

            function syncInstanceOfInput(valore) {
                if ( !required ) return
                var data = { id: vm.uid, required: required, valid: valore }
                $rootScope.$broadcast('updateValidation', data );
            }

            function validateMail( data ) {
                if ( regex.test(data) ) {
                    vm.alert = false
                } else {
                    vm.alert = alertMessage
                }
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcEditTable', fpcEditTable);

    /** @ngInject */
    function fpcEditTable() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-edit-table/fpc-edit-table.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcEditTableController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcEditTableController($scope, $rootScope) {
            var vm = this

            var alertRequired = { label: 'La tabella deve contenere almeno una riga valida.' }
            var required = vm.model.flagRequired

            vm.set = vm.model.valori
            vm.campoFantasma = vm.model.label ? false : true
            vm.tableItems = [[{}]]

            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.isArray = isArray
            vm.handleAdd = handleAdd
            vm.handleRemove = handleRemove
            vm.saveItems = saveItems

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            onMount()
            function onMount(){
                recoverData()
                syncInstanceOfInput()
            }

            function recoverData(){
                if ( vm.model.valoreDatoPropostaFeed ) {
                    vm.tableItems = []
                    vm.tableItems = importFromString()
                }
                // vm.model.valoreDatoPropostaFeed = importFromString()
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoPropostaFeed
                if ( required && !value ) {
                    vm.alert = alertRequired
                } else if ( required && value ) {
                    vm.alert = false
                }
            }

            function handleRemove( index ){
                vm.tableItems.splice(index,1)
                saveItems()
            }

            function handleAdd(){
                vm.tableItems.push([])
            }

            function saveItems(){
                vm.model.valoreDatoPropostaFeed = exportToString()
                syncInstanceOfInput()
                manageErrorState()
            }

            function isArray( prop ){
                return Array.isArray(prop);
            }

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function exportToString() {
                // $rootScope.$broadcast('removeValidationInstance', vm.uid );
                var data = []
                vm.tableItems.forEach(function(item){
                    item.forEach(function(value){
                        data.push(value.valore)
                    })
                })
                return (data && data.length) ? data : null
            }

            function importFromString() {
                if ( !vm.model.valoreDatoPropostaFeed ) return null

                var perChunk = vm.set.length

                var result = vm.model.valoreDatoPropostaFeed.reduce( function(resultArray, item, index) {
                    var chunkIndex = Math.floor(index/perChunk)

                    if(!resultArray[chunkIndex]) {
                        resultArray[chunkIndex] = []
                    }

                    resultArray[chunkIndex].push({valore: item})

                    return resultArray
                }, [])

                return result && result.length ? result : null

            }

            function syncInstanceOfInput() {
                // console.log("TABLE",vm)
                if ( !required ) return
                var valid = vm.model.valoreDatoPropostaFeed ? true : false
                var data = { id: vm.uid, required: required, valid: valid }
                $rootScope.$broadcast('updateValidation', data );
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcDropList', fpcDropList);

    /** @ngInject */
    function fpcDropList() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-drop-list/fpc-drop-list.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcDropListController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcDropListController($scope, $rootScope, $log) {
            var vm = this

            var alertRequired = { label: 'Seleziona almeno un elemento da questa lista.' }
            var required = vm.model.flagRequired

            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.selectedItem = null;
            vm.isRequired = false
            vm.set = vm.model.valori
            vm.onSelect = onSelect

            vm.uid = generateUID()

            onInit()

            function onInit() {
                // console.log("SELECT",vm.model)

                checkForRecovery()
                checkForReadOnly()
            }

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoProposta
                if ( required && !value ) {
                    vm.alert = alertRequired
                } else if ( required && value ) {
                    vm.alert = false
                }
            }

            function onSelect($item, $model) { //eslint-disable-line no-unused-vars
                if ( !vm.selectedItem ) {
                    vm.model.valoreDatoProposta = null
                    syncInstanceOfInput()
                    return
                }
                vm.model.valoreDatoProposta = vm.selectedItem.id
                syncInstanceOfInput()
                manageErrorState()
            }

            function checkForRecovery() {
                // if ( typeof vm.model.valoreDatoProposta == 'string') {
                    vm.selectedItem = vm.model.valori.find( function( item ){ return ( item.id == vm.model.valoreDatoProposta ) })
                    onSelect()
                // }
            }

            function syncInstanceOfInput() {
                // console.log("SYNC",vm.model)
                if ( !required ) return
                var valid = vm.model.valoreDatoProposta ? true : false
                var data = { id: vm.uid, required: required, valid: valid }
                $rootScope.$broadcast('updateValidation', data );
            }

            function checkForReadOnly() {
                if ( vm.model.flagReadOnly && vm.model.valoreDatoProposta ) {
                    var id =  vm.model.valoreDatoProposta
                    var item = vm.model.valori.find( function( item ) { return item.id == id } )
                    if (!item) {
                        $log.error("ERRORE: item with ID ", id, " is not found in the set of options for this field: ", vm.set)
                    }
                    vm.selectedItem = item
                }
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcDatepicker', fpcDatepicker);

    /** @ngInject */
    function fpcDatepicker() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-datepicker/fpc-datepicker.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcDatepickerController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcDatepickerController($scope,$rootScope,$timeout) {
            
            var vm = this
            var required = vm.model.flagRequired

            vm.minDate = new Date( new Date().setFullYear( new Date().getFullYear() - 2 ))
            
            var alertRequired = { label: 'Scegliere una data è obbligatorio.' }
            
            vm.readOnly = vm.locked || vm.model.flagReadOnly

            vm.hide = false
            vm.validateString = validateString

            vm.uid = generateUID()

            $scope.$on("triggerAtomicValidation", function () {
                validateString()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function syncInstanceOfInput() {
                if ( !required ) return
                var valid = vm.model.valoreDatoProposta ? true : false
                var data = { id: vm.uid, required: required, valid: valid }
                $rootScope.$broadcast('updateValidation', data );
            }

            function validateString() {
                var str = vm.model.valoreDatoProposta

                if ( !str ) {
                    vm.alert = alertRequired
                    syncInstanceOfInput()
                } else {
                    vm.alert = null
                    syncInstanceOfInput()
                }
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcCurrencyInput', fpcCurrencyInput);

    /** @ngInject */
    function fpcCurrencyInput() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-currency-input/fpc-currency-input.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcCurrencyInputController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcCurrencyInputController($scope, $rootScope) {
            var vm = this

            vm.alert = false
            var negativeInput = { title: "Non è concesso inserire simboli in questo campo." }
            var alertRequired = { label: 'Questo campo numero è obbligatorio' }
            var required = vm.model.flagRequired

            vm.handleBlur = handleBlur
            vm.handleFocus = handleFocus
            vm.localStringToNumber = localStringToNumber
            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.uid = generateUID()

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoProposta
                validateCurrencyString(value)
                if ( required && (( !value && value != 0 ) || vm.alert) ) {
                    vm.alert = alertRequired
                    syncInstanceOfInput(false)
                } else if ( required && value ) {
                    vm.alert = false
                    syncInstanceOfInput(true)
                }
            }

            function validateCurrencyString(value) {
                vm.alert = false
                if (value && (value.toString().match("^\\$?(([1-9]\\d{0,2}(,\\d{3})*)|0)?\\.\\d{1,2}$"))) {
                    vm.alert = negativeInput
                    vm.model.valoreDatoProposta = null;
                    return false
                } else if (value == null) {
                    vm.alert = alertRequired
                    return false;
                }
                return true
            }

            function syncInstanceOfInput(valore) {
                if ( !required ) return
                var data = { id: vm.uid, required: required, valid: valore }
                $rootScope.$broadcast('updateValidation', data );
            }

            function handleBlur( value ) {

                if ( !validateCurrencyString( value ) ) value = 0

                var currency = 'EUR'
                // https://www.currency-iso.org/dam/downloads/lists/list_one.xml

                var options = {
                    maximumFractionDigits : 2,
                    currency              : currency,
                    style                 : "currency",
                    currencyDisplay       : "symbol"
                }

                vm.model.valoreDatoProposta = (value || value === 0)
                    ? vm.localStringToNumber(value).toLocaleString(undefined, options)
                    : ''

                manageErrorState()
            }

            function handleFocus( value ) {
                if ( !validateCurrencyString( value ) ) value = 0
                vm.model.valoreDatoProposta = value ? localStringToNumber(value) : ''
            }

            function localStringToNumber( s ) {
                return Number(String(s).replace(/[^0-9.-]+/g,""))
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcCheckGroup', fpcCheckGroup);

    /** @ngInject */
    function fpcCheckGroup() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-check-group/fpc-check-group.html',
            scope: {},
            bindToController: {
                model: '=?',
                expansion: '=?',
                uid: '=?',
                locked: '=?'
            },
            controller: fpcCheckGroupController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcCheckGroupController($scope,$rootScope) {
            var vm = this
            // console.log("fpcCheckGroupController :", this)
            var alertRequired = { label: "Seleziona almeno un'opzione per proseguire." }
            var required = vm.model.flagRequired

            vm.set = vm.model.valori
            vm.campoFantasma = vm.model.label ? false : true
            
            vm.readOnly = vm.locked || vm.model.flagReadonly

            vm.onCheckChange = onCheckChange
            vm.uid = generateUID()

            onMount()

            $scope.$on("triggerAtomicValidation", function () {
                manageErrorState()
            });

            $scope.$on("$destroy", function () {
                removeInstanceOfInput()
            });

            function onMount() {
                recoveryCheckGroup()
            }

            function removeInstanceOfInput() {
                $rootScope.$broadcast('removeValidationInstance', vm.uid );
            }

            function syncInstanceOfInput() {
                if ( !required ) return
                var valid = vm.model.valoreDatoPropostaFeed ? true : false
                var data = { id: vm.uid, required: required, valid: valid }
                $rootScope.$broadcast('updateValidation', data );
            }

            function manageErrorState() {
                var value = vm.model.valoreDatoPropostaFeed
                if ( required && !value ) {
                    vm.alert = alertRequired
                } else if ( required && value ) {
                    vm.alert = false
                }
            }

            function recoveryCheckGroup() {
                var value = vm.model.valoreDatoPropostaFeed
                if ( !value ) return 

                value.forEach(function(item) {
                    vm.set.find( function(setItem){
                        if ( setItem.id == item ) {
                            setItem.selected = true
                        }
                    })
                })

                onCheckChange()
            }

            function onCheckChange() {

                var selected = vm.model.valori.filter( function( x ) { return x.selected === true })
                vm.model.valoreDatoPropostaFeed = selected.map( function(i) { return i.id } )
                var expandable = selected.filter( function( y ) { return y.campiSuccessivi && y.campiSuccessivi.length })
                
                if ( !vm.expansion ) vm.expansion = {}
                vm.expansion[vm.uid] = []

                expandable.forEach( function (item) {
                    item.campiSuccessivi.forEach( function (item,idx) {
                        vm.expansion[vm.uid].push(item)
                    })
                })

                if ( !vm.model.valoreDatoPropostaFeed.length ) vm.model.valoreDatoPropostaFeed = null

                syncInstanceOfInput()
                manageErrorState()
            }

            function generateUID() {
                return String(Math.random().toString(36).slice(-6))
            }

        }
    }

})();




(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcAtomicWrapper', fpcAtomicWrapper);

    /** @ngInject */
    function fpcAtomicWrapper() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-atomic-wrapper/fpc-atomic-wrapper.html',
            scope: {},
            bindToController: {
                model: '=',
                esterno: '='
            },
            controller: fpcAtomicWrapperController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function fpcAtomicWrapperController() {
            var vm = this

            vm.iterable = vm.model.sezioneSuccessiva || vm.model.campiSuccessivi || vm.model.campoSuccessivo || vm.model.sezione.campi
            vm.expansion = {}
            vm.toHide = false
            // console.log('ITERABLE: ', vm.iterable)

            vm.iterable.sort(function (a, b) {
                return (a.numOrdine - b.numOrdine);
            })

            if (!vm.esterno) {
                vm.iterable = vm.iterable.filter(function (item) {
                    // console.log("ESTERNO, CAMPO NASCOSTO: ", item.nascondiEsterno)
                    if (!item.nascondiEsterno) {
                        return item;
                    }
                })
            } else {
                vm.iterable = vm.iterable.filter(function (item) {
                    if (item.nascondiEsterno === true || item.nascondiEsterno == null) {
                        return item;
                    }
                })
            }


            vm.alternateView = alternateView
            function alternateView( item ) {
                var displayInRecap = [ 'Nome','Cognome','Qualifica','Regime','Data di nascita','Dipartimento','Area','E-mail','Affiliazione','Responsabile della ricerca']
                return displayInRecap.includes(item.label)
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fpcAlertBlock', fpcAlertBlock);

    /** @ngInject */
    function fpcAlertBlock() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/formPropostaCert/fpc-alert-block/fpc-alert-block.html',
            scope: {},
            bindToController: {
                model: '=',
                locked: '=?'
            },
            controller: fpcAlertBlockController,
            controllerAs: 'alert'
        };

        return directive;

        /** @ngInject */
        function fpcAlertBlockController( ngDialog, $scope, $rootScope ) {
            var alert = this

            // console.log(alert)

            alert.getSizeStyle = getSizeStyle
            alert.blocking = ( alert.model && alert.model.tipoCampo )

            onMount()
            function onMount() {

                if ( alert.blocking && !alert.locked ) {
                    showModal()
                }
            }

            $scope.$on("$destroy", function () {
                sessionStorage.setItem("modalId", null );
            });

            function showModal() {
                var dialog = ngDialog.openConfirm({
                    showClose: false,
                    template:'\
                        <h3 style="margin-bottom: 25px">Attenzione</h3>\
                        <p style="margin-bottom: 25px;font-size: 18px" ng-bind-html="message"/>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="customClose()">Chiudi</button>\
                        </div>',
                    controller: ['$scope', function($dialogScope) {

                        $dialogScope.message = alert.model.label
                        $dialogScope.customClose = customClose

                        function customClose() {
                            $dialogScope.closeThisDialog(0)
                        }

                    }],
                    plain: true
                });

            }

            function getSizeStyle() {
                return 'small'
                // if ( alert.size === 0 ) return 'small'
                // return ''
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('refereeAccept', refereeAccept);

    /** @ngInject */
    function refereeAccept() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/refereeAccept/refereeAccept.html',
            scope: {},
            bindToController: {
                refId: '=',
                refToken: '='
            },
            controller: RefereeAcceptController,
            controllerAs: 'refAcceptCtrl'
        };

        return directive;

        /** @ngInject */
        function RefereeAcceptController(UserData, RefereeExtService, $log, $translate, ngDialog) {
            var vm = this;
            
            vm.data = null;
            vm.saving = false;
            
            vm.acceptReferee = acceptReferee;
            vm.refuseReferee = refuseReferee;
            vm.showMembers = showMembers;
            
            $translate.use("en");
            UserData.setLanguage("en");
            
            getDatiReferee()
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati del referee", error);
                    vm.data = { error: 'Error retrieving referee data.' };
                });
            
            
            function getDatiReferee() {
                return RefereeExtService.getRefereeData(vm.refId, vm.refToken)
                    .then(function(resultData) {
                        vm.data = resultData;
                    });
            }
            
            function saveAcceptReferee(accept) {
                vm.saving = true;
                RefereeExtService.setAcceptReferee(vm.refId, vm.refToken, accept)
                    .then(function() {
                        getDatiReferee().then(function() {
                                vm.saving = false;
                            })
                            .catch(function(err) {
                                $log.error("Errore nel reperimento dei dati del referee", err);
                                vm.data = { error: 'Error retrieving referee data.' };
                            });
                    })
                    .catch(function(error) {
                        $log.error("Errore nel salvataggio dello status del referee", error);
                        vm.data = { error: 'Error retrieving referee data.' };
                    });
            }
            
            function acceptReferee() {
                saveAcceptReferee(true);
            }
            
            function refuseReferee() {
                saveAcceptReferee(false);
            }
            
            function showMembers() {
                ngDialog.open({
                    template:'\
                        <h2 style="margin: 0px 0px 20px;">Research Group</h2>\
                        <sgb-v-participants ng-if="ngDialogData.proponente" label="Principal Investigator" model="ngDialogData.proponente" type="simple"></sgb-v-participants>\
                        <sgb-v-participants ng-if="ngDialogData.proposta.partecipanti_coproponenti" label="Other Principal Investigators" model="ngDialogData.proposta.partecipanti_coproponenti" type="simple"></sgb-v-participants>\
                        <sgb-v-participants ng-if="ngDialogData.proposta.partecipanti_doc_ric" label="Participants in the research project" model="ngDialogData.proposta.partecipanti_doc_ric" type="simple"></sgb-v-participants>\
                        <sgb-v-participants ng-if="ngDialogData.proposta.partecipanti_dott_ass_spec" label="PhD/Assegnista/Specializzando member of the research group" model="ngDialogData.proposta.partecipanti_dott_ass_spec" type="simple"></sgb-v-participants>\
                    ',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: vm.data.proposta,
                        proponente: {
                            "partecipantiList": [vm.data.proposta.responsabile]
                        }
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('viewRendicontazione', viewRendicontazione);

    /** @ngInject */
    function viewRendicontazione() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/viewRendicontazione/viewRendicontazione.html',
            scope: {},
            bindToController: {
                rendicontazioneId: '=',
                isUr: '=',
                isRad: '=',
                print: '='
            },
            controller: ViewRendicontazioneController,
            controllerAs: 'viewRendCtrl'
        };

        return directive;

        /** @ngInject */
        function ViewRendicontazioneController(RendicontazioniService, RendicontazioniUrService, RendicontazioniRadService, FormService, $log, $q, $http, Constants, UserData) {
            var vm = this;
                        
            //vm.classeId = null;
            vm.template = null;
            vm.data = null;
            
            vm.getSelectLabel = getSelectLabel;
            vm.getYesNoValue = getYesNoValue;
            vm.getPdfExportUrl = getPdfExportUrl;
            vm.userCanEdit = userCanEdit;
            vm.getDateFieldIndetValue = getDateFieldIndetValue;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            getDatiRendicontazione()
                .then(getTemplateRendicontazione)
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della rendicontazione", error);
                });

            function getDatiRendicontazione() {
                if (vm.isUr) {
                    return RendicontazioniUrService.getRendicontazioneById(vm.rendicontazioneId)
                        .then(function(data) {
                            vm.data = data;
                            //vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else if (vm.isRad) {
                    return RendicontazioniRadService.getRendicontazioneById(vm.rendicontazioneId)
                        .then(function(data) {
                            vm.data = data;
                            //vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else {
                    return RendicontazioniService.getRendicontazioneById(vm.rendicontazioneId)
                        .then(function(data) {
                            vm.data = data;
                            //vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
            }

            function getTemplateRendicontazione() {
                var formId = vm.data.formId;
                return FormService.getFormById(formId)
                    .then(function(formResult) {
                        vm.template = angular.fromJson(formResult.modello);
                    });
            }
/*
            function getTemplateRendicontazione() {
                return $http.get('assets/template-form/' + vm.classeId + '.json')
                    .then(function(resultTemplate) {
                        vm.template = resultTemplate.data;
                    });
            }
*/
            function getSelectLabel(modelName, choicesName) {
                var element = vm.data[modelName];
                var label = '';
                
                if (element) {
                    if (choicesName == 'settoriERC')
                        label = element.codice + ' - ' + element.nome;
                    else if (choicesName == 'tematicheH2020Inter' || choicesName == 'tematicheH2020Attr' || choicesName == 'ricaduteDiffusioneCultura')
                        label = element.valore;
                    else if (choicesName == 'percentuali')
                        label = element;
                    else if (choicesName == 'sottoSettoriERC')
                        label = element.codice + ' - ' + element.descrizione;
                }
                
                return label;
            }
            
            function getYesNoValue(modelName) {
                var value = vm.data[modelName];
                var result = '';
                if (value === true)
                    result = 'Sì';
                else if (value === false)
                    result = 'No';
                
                return result;
            }
            
            function getPdfExportUrl(rendicontazioneModel) {
                var urlPrefix = '';
                if (vm.isUr)
                    urlPrefix = '/ur';
                else if (vm.isRad)
                    urlPrefix = '/rad';
                if (rendicontazioneModel)
                    return Constants.restApiRoot + urlPrefix + "/rendicontazioni/pdf/" + rendicontazioneModel.id + '?token=' + UserData.getToken();
            }
            
            function userCanEdit() {
                var userId = UserData.getUserId();
                return (userId != null && userId == vm.data.responsabile_rendicontazione.id);
            }
            
            function getDateFieldIndetValue(modelName, indeterminateValue, indeterminateDescription) {
                var value = vm.data[modelName];
                if (value === indeterminateValue)
                    return indeterminateDescription;
                else
                    return value;
            }
            
        }
    }
    
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('viewPropostaCert', viewPropostaCert);

    /** @ngInject */
    function viewPropostaCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/viewPropostaCert/viewPropostaCert.html',
            scope: {},
            bindToController: {
                propostaId: '='
            },
            controller: ViewPropostaCertController,
            controllerAs: 'form'
        };

        return directive;

        /** @ngInject */
        function ViewPropostaCertController(ProposteService, $log, $rootScope) {

            var vm = this;
            var dynamicSectionsStorage = {}

            vm.readOnlyDisplay = {}
            vm.loadProposteCert = loadProposteCert

            onMount()
            function onMount() {
                loadProposteCert(vm.propostaId)
            }

            $rootScope.$on('collateralSection', function (e, data) {
                $rootScope.$broadcast('propagateFlip', data);
            })

            $rootScope.$on('pushFormulario', function (e, data) {
                storeExpansionSection(data)
            })

            function loadProposteCert(id) {

                ProposteService.getFormularioCertById(id)
                    .then(function (data) {

                        vm.proposta = data
                        vm.formulario = data.formulario
                        vm.esterno = data.utenteProponente.esterno
                        formatReadonly()
                        checkForPreviousSessions()
                    }).catch(function (error) {
                        $log.error("Error getFormularioCertById", error);
                        leaveDetail()
                    });

            }

            function leaveDetail() {
                var detailPath = ( role == 'UFFICIO_CERT' ) ? 'listaIstanzeUserCert' : 'listaIstanzeUser'
                setTimeout(function(){
                    $state.go(detailPath)
                },100)
            }

            function formatReadonly() {

                var data = vm.formulario

                // Cerco i campi readonly nel primo blocco del riepilogo
                var readonly = data.sezioniFormulario[0].sezione.campi.filter(function (item) {
                    return item.flagReadOnly === true && displayInRecap.includes(item.label)
                })

                vm.readOnlyDisplay.title = readonly[0].label // Il primo item è sempre il titolo
                readonly.shift()
                vm.readOnlyDisplay.items = []
                readonly.forEach(function (item) {
                    vm.readOnlyDisplay.items.push({
                        label: item.label,
                        value: item.valoreDatoProposta
                    })
                })

            }

            function storeExpansionSection(data) {
                var toAdd = {
                    id: data.refLink,
                    numOrdine: data.sezione.numOrdine || data.sezione.id,
                    titolo: data.sezione.titolo,
                    sezione: data.sezione
                }

                dynamicSectionsStorage[data.refLink] = data.sezione
                // Aggiungo l'item al formulario
                vm.formulario.sezioniFormulario.push(toAdd)
                // Riordino gli item del formulario in base alla prop numOrdine
                vm.formulario.sezioniFormulario.sort(function (a, b) {
                    return (a.numOrdine - b.numOrdine);
                })
            }

            function checkForPreviousSessions() {
                var savedSession = JSON.parse(vm.proposta.datiProposta)
                if (!savedSession) return
                recursiveFillFromSession(savedSession.sezioniFormulario, vm.formulario.sezioniFormulario)
            }

            function recursiveFillFromSession(store, data) {
                store.forEach(function (child, index) {

                    if (child.campoSuccessivo) {

                        if ( child.campoSuccessivo.valoreDatoProposta ) {
                            data[index].campoSuccessivo.valoreDatoProposta = child.campoSuccessivo.valoreDatoProposta
                        }

                        if ( child.campoSuccessivo.valoreDatoPropostaFeed ) {
                            data[index].campoSuccessivo.valoreDatoPropostaFeed = child.campoSuccessivo.valoreDatoPropostaFeed
                        }

                        if ( child.campoSuccessivo.valori && data[index].campoSuccessivo.valori ) {
                            recursiveFillFromSession(child.campoSuccessivo.valori, data[index].campoSuccessivo.valori)
                        }
                    }

                    if (child.valori) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[idx] && data[idx].valori) {
                                    recursiveFillFromSession(child.valori, data[idx].valori)
                                }
                            }
                        })
                    }

                    if (child.campiSuccessivi) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[idx] && data[idx].campiSuccessivi) {
                                    recursiveFillFromSession(child.campiSuccessivi, data[idx].campiSuccessivi)
                                }
                            }
                        })
                    }

                    if (child.sezioneSuccessiva) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[idx] && data[idx].sezioneSuccessiva) {
                                    recursiveFillFromSession(child.sezioneSuccessiva.campi, data[idx].sezioneSuccessiva.campi)
                                }
                            }
                        })
                    }

                    if (child.sezione) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[index] && data[index].sezione && data[index].sezione) {
                                    recursiveFillFromSession(child.sezione.campi, data[idx].sezione.campi)
                                }
                            }
                        })
                    }

                    if (data.length) {
                        data.map(function (item) {
                            if (item.id == child.id && child.valoreDatoProposta) {
                                if ( item.tipoCampo == 'INTERO' ) {
                                    return item.valoreDatoProposta = +child.valoreDatoProposta
                                }
                                return item.valoreDatoProposta = child.valoreDatoProposta
                            }
                            if (item.id == child.id && child.valoreDatoPropostaFeed) {
                                return item.valoreDatoPropostaFeed = child.valoreDatoPropostaFeed
                            }
                        })
                    }

                })
            }

            var displayInRecap = ['Nome', 'Cognome', 'Qualifica', 'Regime', 'Data di nascita', 'Dipartimento', 'Area', 'E-mail', 'Affiliazione', 'Responsabile della ricerca']

            // End
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('viewProposta', viewProposta);

    /** @ngInject */
    function viewProposta() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/viewProposta/viewProposta.html',
            scope: {},
            bindToController: {
                propostaId: '=',
                isUr: '=',
                isMc: '=',
                isRad: '=',
                isRef: '=',
                print: '='
            },
            controller: ViewPropostaController,
            controllerAs: 'viewPropCtrl'
        };

        return directive;

        /** @ngInject */
        function ViewPropostaController(ProposteService, ProposteUrService, ProposteMcService, ProposteRadService, ProposteRefService, FormService, $log, $q, $http, Constants, UserData) {
            var vm = this;

            vm.classeId = null;
            vm.template = null;
            vm.data = null;

            vm.getSelectLabel = getSelectLabel;
            vm.getLabelFormat = getLabelFormat;
            vm.getYesNoValue = getYesNoValue;
            vm.getPdfExportUrl = getPdfExportUrl;
            vm.userCanEdit = userCanEdit;
            vm.getDateFieldIndetValue = getDateFieldIndetValue;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            getDatiProposta()
                .then(getTemplateProposta)
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della proposta", error);
                });

            function getDatiProposta() {
                if (vm.isUr) {
                    return ProposteUrService.getPropostaById(vm.propostaId)
                        .then(function(data) {
                            vm.data = data;
                            vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else if (vm.isMc) {
                    return ProposteMcService.getPropostaById(vm.propostaId)
                        .then(function(data) {
                            vm.data = data;
                            vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else if (vm.isRad) {
                    return ProposteRadService.getPropostaById(vm.propostaId)
                        .then(function(data) {
                            vm.data = data;
                            vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else if (vm.isRef) {
                    return ProposteRefService.getPropostaById(vm.propostaId)
                        .then(function(data) {
                            vm.data = data;
                            vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else {
                    return ProposteService.getPropostaById(vm.propostaId)
                        .then(function(data) {
                            vm.data = data;
                            vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
            }

            function getTemplateProposta() {
                var formId = vm.data.formId;
                return FormService.getFormById(formId)
                    .then(function(formResult) {
                        vm.template = angular.fromJson(formResult.modello);
                    });
            }

            function getSelectLabel(modelName, choicesName) {
                var element = vm.data[modelName];
                var label = '';

                if (element) {
                    if (choicesName == 'settoriERC')
                        label = element.codice + ' - ' + element.nome;
                    else if (choicesName == 'tematicheH2020Inter' || choicesName == 'tematicheH2020Attr' || choicesName == 'ricaduteDiffusioneCultura')
                        label = element.valore;
                    else if (choicesName == 'percentuali')
                        label = element;
                    else if (choicesName == 'sottoSettoriERC')
                        label = element.codice + ' - ' + element.descrizione;
                    else if (choicesName == 'strutture')
                        label = element.descrizione;
                    else if (choicesName == 'lineeTematicheHorizon')
                        label = element.descrizione;
                    else if (choicesName == 'flagshipHorizon')
                        label = element.descrizione;
                    else if (choicesName == 'ruoliSapienzaPartenariato')
                        label = element.label;
                }

                return label;
            }

            function getLabelFormat(choicesName) {
                var labelFormat = null;
                if (choicesName == 'sottoSettoriERC')
                    labelFormat = "codice + ' - ' + descrizione";
                else if(choicesName == 'strutture')
                  labelFormat = "descrizione";
                else if(choicesName == 'lineeTematicheHorizon')
                    labelFormat = "descrizione";
                else if(choicesName == 'flagshipHorizon')
                    labelFormat = "descrizione";
                return labelFormat;
            }

            function getYesNoValue(modelName) {
                var value = vm.data[modelName];
                var result = '';
                if (value === true)
                    result = 'Sì';
                else if (value === false)
                    result = 'No';

                return result;
            }

            function getPdfExportUrl(propostaModel) {
                var urlPrefix = '';
                if (vm.isUr)
                    urlPrefix = '/ur';
                else if (vm.isMc)
                    urlPrefix = '/mc';
                else if (vm.isRad)
                    urlPrefix = '/rad';
                else if (vm.isRef)
                    urlPrefix = '/referee';
                if (propostaModel)
                    return Constants.restApiRoot + urlPrefix + "/proposte/pdf/" + propostaModel.id + '?token=' + UserData.getToken();
            }

            function userCanEdit() {
                var userId = UserData.getUserId();
                return (userId != null && userId == vm.data.responsabile.id);
            }

            function getDateFieldIndetValue(modelName, indeterminateValue, indeterminateDescription) {
                var value = vm.data[modelName];
                if (value === indeterminateValue)
                    return indeterminateDescription;
                else
                    return value;
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('viewNotesIstanzaUser', viewNotesIstanzaUser);

    /** @ngInject */
    function viewNotesIstanzaUser($log) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/viewNotesIstanzaUser/viewNotesIstanzaUser.html',
            scope: {},
            bindToController: {
                confirm: '=',
                cancel: '=',
                item: '=?'
            },
            controller: viewNotesIstanzaUserController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function viewNotesIstanzaUserController() {
            var vm = this
            $log.log(this)

            vm.handleClose = handleClose

            function handleClose( data ) {
                vm.cancel( data )
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('valutazioneProgettoReferee', valutazioneProgettoReferee);

    /** @ngInject */
    function valutazioneProgettoReferee() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/valutazioneProgettoReferee/valutazioneProgettoReferee.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: valutazioneProgettoRefereeController,
            controllerAs: 'valutaProgRefCtrl'
        };

        return directive;

        /** @ngInject */
        function valutazioneProgettoRefereeController($log, RefereeService, $state, ngDialog) {
            var vm = this;
            
            vm.referee = null;
            
            vm.openProposta = openProposta;
            vm.valutaProposta = valutaProposta;
            vm.getStatusClass = getStatusClass;
            vm.getStatus = getStatus;
            vm.getStatusButtonText = getStatusButtonText;
            
            getReferee()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });
            
            function getReferee() {
                return RefereeService.getReferee()
                    .then(function(data) {
                        vm.referee = data;
                    });
            }
            
            function openProposta(id) {
                $state.go('refPropostaView', {'id': id});
            }

            function valutaProposta(referee) {
                
                var isConclusa = referee.valutazione && referee.valutazione.status == "CONCLUSA";
                
                var valutaDialog = ngDialog.openConfirm({
                    template:'<input type="text" style="width: 1px; height: 1px; border: 0px; outline: none; position: absolute;" /><valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" confirm="confirm" edit-mode="ngDialogData.editMode" is-ref="true" fase-id="ngDialogData.faseId"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: referee.proposta,
                        valutazioneId: referee.valutazione ? angular.copy(referee.valutazione.id) : null,
                        editMode: !isConclusa,
                        faseId: (referee.faseValutazioneId != null) ? angular.copy(referee.faseValutazioneId) : null
                    }
                });
                
                valutaDialog.then(function (data) {
                    if (data) {
                        getReferee();
                    }
                });
            }
            
            function getStatusClass(status) {
                if (status == 'BOZZA')
                    return 'inBozza';
                if (status == 'CONCLUSA')
                    return 'evaluated';
                return 'notEvaluated';
            }
            
            function getStatus(status) {
                if (status == 'BOZZA')
                    return 'Draft';
                if (status == 'CONCLUSA')
                    return 'Evaluated';
                return 'Not evaluated';
            }
            
            function getStatusButtonText(status) {
                if (status == 'BOZZA')
                    return 'Modify';
                if (status == 'CONCLUSA')
                    return 'Show evaluation';
                return 'Evaluate';
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('valutazioneProgetti', archivioProgetti);

    /** @ngInject */
    function archivioProgetti() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/valutazioneProgetti/valutazioneProgetti.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ValutazioneProgettiController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ValutazioneProgettiController(ProposteMcService, CommissioniService, MacroareeService, ValutazioniMcService, EsitoValutazioneMcService, $log, $state, AuthService, ngDialog, $window, $filter) {
            var vm = this;
            
            var storageName = "valutazioneProgetti-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            vm.anno = null;
            
            vm.anni = null;
            vm.selectedAnno = null;
            
            vm.proposte = null;
            
            vm.tipologieEClassi = null;
            vm.macroareeEDipartimenti = null;
            vm.selectedTipoClasse = oldFilter.tipoClasse ? oldFilter.tipoClasse : null;
            vm.selectedAreaDip = oldFilter.areaDip ? oldFilter.areaDip : null;
            
            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;
            
            vm.getProposte = getProposte;
            vm.getTipologieEProposte = getTipologieEProposte;
            vm.openProposta = openProposta;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatus = getStatus;
            vm.valutaProposta = valutaProposta;
            vm.showValutazione = showValutazione;
            vm.concediFinanziamento = concediFinanziamento;
            vm.mostraCommentoFinanziamento = mostraCommentoFinanziamento;
            vm.gestioneReferee = gestioneReferee;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.openIterValutazione = openIterValutazione;
            vm.getCsvExportUrl = getCsvExportUrl;
            vm.getCsvExportValUrl = getCsvExportValUrl;
            vm.isCurrentPresidenteCommissione = isCurrentPresidenteCommissione;
            vm.canEditReferee = canEditReferee;
            vm.riapriValutazione = riapriValutazione;
            vm.riapriEsito = riapriEsito;
            vm.openIndicatoriValutazione = openIndicatoriValutazione;
            
            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : '1',
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };
            
            vm.selectedStatusValutazione = oldFilter.statusValutazione ? oldFilter.statusValutazione : 'ALL';
            
            vm.macroAreaNonValutabileMsg = "Macroarea non valutabile";
            
            getAnni()
                .then(getTipologieProgetto)
                .then(getMacroaree)
                .then(getProposte)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle proposte", error);
                });
            
            function getAnni() {
                return ProposteMcService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno) {
                                vm.selectedAnno = { anno: vm.anno };
                            }
                            else {
                                
                                var anno = data.filter(function(anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];
                                
                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }
            
            function getTipologieEProposte() {
                getTipologieProgetto()
                    .then(getMacroaree)
                    .then(resetFiltri);
            }
            
            function getTipologieProgetto() {
                return CommissioniService.getTipologieProgetto(AuthService.getUserId(), vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.tipologieEClassi = [];
                    
                        var json = {
                            label: 'Tutte le tipologie di progetto',
                            tipologia: 'Tutte le tipologie di progetto',
                            classe: 'Tutte le classi dimensionali',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedTipoClasse)
                            vm.selectedTipoClasse = json;
                        vm.tipologieEClassi.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var tipo = data[i];
                            json = {
                                label: tipo.nome,
                                tipologiaId: tipo.id,
                                tipologia: tipo.nome,
                                classe: 'Tutte le classi dimensionali',
                                id: tipo.id + '.*',
                                isGroup: true
                            };
                            vm.tipologieEClassi.push(json);
                            for (var j = 0; j < tipo.classeList.length; j++) {
                                var classe = tipo.classeList[j];
                                json = {
                                    label: classe.nome,
                                    tipologiaId: tipo.id,
                                    classeId: classe.id,
                                    tipologia: tipo.nome,
                                    classe: classe.nome,
                                    id: tipo.id + '.' + classe.id,
                                    isGroup: false
                                };
                                vm.tipologieEClassi.push(json);
                            }
                        }
                        vm.tipologieProgetto = data;
                    });
            }
            
            function getMacroaree() {
                return MacroareeService.getMacroaree(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.macroareeEDipartimenti = [];
                        var json = {
                            label: 'Tutte le macroaree',
                            macroarea: 'Tutte le macroaree',
                            dipartimento: 'Tutti i dipartimenti',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedAreaDip)
                            vm.selectedAreaDip = json;
                        vm.macroareeEDipartimenti.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var area = data[i];
                            json = {
                                label: area.code + ' - ' + area.nome,
                                macroareaId: area.id,
                                macroarea: area.code + ' - ' + area.nome,
                                dipartimento: 'Tutti i dipartimenti',
                                id: area.id + '.*',
                                isGroup: true
                            };
                            vm.macroareeEDipartimenti.push(json);
                            var dipartimentiArea = $filter('orderBy')(area.dipartimentoList, 'nome');
                            for (var j = 0; j < dipartimentiArea.length; j++) {
                                var dip = dipartimentiArea[j];
                                json = {
                                    label: dip.nome,
                                    macroareaId: area.id,
                                    dipartimentoId: dip.id,
                                    macroarea: area.code + ' - ' + area.nome,
                                    dipartimento: dip.nome,
                                    id: area.id + '.' + dip.id,
                                    isGroup: false
                                };
                                vm.macroareeEDipartimenti.push(json);
                            }
                        }
                    });
            }
            
            function getProposte(keepPagination) {
                
                if(!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }    
                
                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    anno: vm.selectedAnno,
                    cognome: vm.selectedCognome,
                    tipoClasse: vm.selectedTipoClasse,
                    areaDip: vm.selectedAreaDip,
                    statusValutazione: vm.selectedStatusValutazione
                });
                
                vm.proposte = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                
                return ProposteMcService.getProposte(filter)
                    .then(function(data) {
                        vm.proposte = data.resultList;
                    
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    });
            }
            
            function openProposta(id) {
                $state.go('mcPropostaView', {'id': id});
            }
            
            function getStatusClass(status) {
                if (status == 'VALUTATA')
                    return 'valutata';
                if (status == 'FINANZIATA')
                    return 'finanziata';
                if (status == 'NON_FINANZIATA')
                    return 'nonFinanziata';
                return 'nonValutata';
            }
            
            function getStatusIcon(status) {
                if (status == 'VALUTATA')
                    return 'fa-check-square-o';
                if (status == 'FINANZIATA')
                    return 'fa-thumbs-o-up';
                if (status == 'NON_FINANZIATA')
                    return 'fa-thumbs-o-down';
                return 'fa-square-o';
            }
            
            function getStatus(status) {
                if (status == 'VALUTATA')
                    return 'Valutata';
                if (status == 'FINANZIATA')
                    return 'Finanziata';
                if (status == 'NON_FINANZIATA')
                    return 'Non finanziata';
                return 'Da valutare';
            }
            
            function valutaProposta(proposta, valutazione) {
                
                var valutaDialog = ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" confirm="confirm" edit-mode="true" draft-only="ngDialogData.draftOnly"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? angular.copy(valutazione.id) : null,
                        draftOnly: (proposta.mcValutazioneSoloBozza === true && !vm.isCurrentPresidenteCommissione())
                    }
                });
                
                valutaDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }
            
            function showValutazione(proposta, valutazione) {
                
                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? valutazione.id : null
                    }
                });
            }
            
            function concediFinanziamento(proposta) {
                
                var concediFinanziamentoDialog = ngDialog.openConfirm({
                    template:'<concedi-finanziamento proposta="ngDialogData.proposta" confirm="confirm" draft-only="ngDialogData.draftOnly"></concedi-finanziamento>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        draftOnly: (proposta.mcValutazioneSoloBozza === true && !vm.isCurrentPresidenteCommissione())
                    }
                });
                
                concediFinanziamentoDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }
            
            function gestioneReferee(proposta) {
                                
                var gestioneRefereeDialog = ngDialog.openConfirm({
                    template:'<gestione-referee proposta="ngDialogData.proposta" confirm="confirm"></gestione-referee>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        proposta: proposta
                    }
                });
                
                gestioneRefereeDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }
            
            function mostraCommentoFinanziamento(commento) {
                                
                ngDialog.open({
                    template:'\
                        <h3 class="title">Commento</h3>\
                        <div class="well">{{ngDialogData.commento}}</div>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        commento: commento
                    }
                });
            }
            
            function openIterValutazione(proposta) {
                
                var iterValutazioneDialog = ngDialog.openConfirm({
                    template:'<iter-valutazione proposta="ngDialogData.proposta" edit-mode="ngDialogData.editMode" is-pres-comm="ngDialogData.isPresComm" pres-can-edit="ngDialogData.presCanEdit" confirm="confirm"></iter-valutazione>',
                    plain: true,
                    appendClassName: 'ngdialog-medium ngdialog-iterValutazione',
                    data: {
                        proposta: proposta,
                        editMode: !proposta.tempoValutazioneConclusa && !proposta.statusValutazioneProposta, // false
                        isPresComm: vm.isCurrentPresidenteCommissione(),
                        presCanEdit: vm.canEditReferee()
                    }
                });
                
                iterValutazioneDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }
            
            function resetFiltri() {
                
                vm.selectedAreaDip = vm.macroareeEDipartimenti[0];
                vm.selectedTipoClasse = vm.tipologieEClassi[0];
                vm.selectedCognome = "";
                
                getProposte();
                
            }
            
            function isFiltroAttivo() {
                
                var attivo = false;
                
                if(vm.macroareeEDipartimenti && vm.selectedAreaDip.id != vm.macroareeEDipartimenti[0].id)
                    attivo = true;
                
                if(vm.tipologieEClassi && vm.selectedTipoClasse.id != vm.tipologieEClassi[0].id)
                    attivo = true;
                
                if(vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                
                return attivo;
                
            }
            
            function isCurrentPresidenteCommissione() {
                return (AuthService.getUserInfo().utente.presidenteCommissione && vm.selectedAnno && vm.anni && vm.anni[0] && vm.selectedAnno.anno == vm.anni[0].anno);
            }
            
            function canEditReferee() {
                return (vm.isCurrentPresidenteCommissione() && AuthService.getUserInfo().utente.presidenteCanEditReferee);
            }
            
            function getCsvExportUrl() {
                var filter = {
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                
                return ProposteMcService.getCsvExportUrl(filter);
            }

            function getCsvExportValUrl() {
                var filter = {
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                
                return ProposteMcService.getCsvExportValUrl(filter);
            }
            
            function riapriValutazione(propostaId) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma Riapertura</h3>\
                        <div class="alert alert-warning" role="alert">Riaprendo la valutazione della proposta verranno eliminate le informazioni sul finanziamento concesso e l\'eventuale commento.</div>\
                        <p>Vuoi riaprire la valutazione della proposta?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        ValutazioniMcService.riapriValutazione(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        });
                    }
                });
            }
            
            function riapriEsito(propostaId) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma Riapertura</h3>\
                        <p>Vuoi riaprire l\'esito del finanziamento della proposta?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        EsitoValutazioneMcService.riapriEsitoValutazione(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        });
                    }
                });
            }
            
            function openIndicatoriValutazione(proposta) {
                ngDialog.open({
                    template:'<indicatori-valutazione proposta="ngDialogData.proposta"></indicatori-valutazione>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-indicatoriValutazione',
                    data: {
                        proposta: proposta
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('valutaProposta', valutaProposta);

    /** @ngInject */
    function valutaProposta() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/valutaProposta/valutaProposta.html',
            scope: {},
            bindToController: {
                proposta: "=?",
                valutazioneId: "=",
                confirm: "=",
                editMode: "=",
                isUr: "=",
                isRef: "=",
                isUser: "=",
                faseId: "=?",
                print: "=?",
                draftOnly: "=?"
            },
            controller: valutaPropostaController,
            controllerAs: 'valutaCtrl'
        };

        return directive;

        /** @ngInject */
        function valutaPropostaController(AuthService, ValutazioniMcService, ValutazioniUrService, ValutazioniRefService, ValutazioniService, ngDialog, Constants, UserData) {
            var vm = this;

            var ValutazioniSrv = null;

            vm.valutazione = null;
            vm.senzaPunteggio = false;
            vm.saveLoading = false;

            vm.initBloccante = initBloccante;
            vm.checkBloccante = checkBloccante;
            vm.salvaInBozzaValutazione = salvaInBozzaValutazione;
            vm.concludiValutazione = concludiValutazione;
            vm.calcolaPunteggioTotale = calcolaPunteggioTotale;
            vm.checkConcludiDisable = checkConcludiDisable;
            vm.chiudi = chiudi;
            vm.usaMedia = usaMedia;
            vm.modificaMedia = modificaMedia;
            vm.getPdfExportUrl = getPdfExportUrl;
            vm.getDipartimentoQualificato = getDipartimentoQualificato;

            if(vm.isUr) {

                ValutazioniSrv = ValutazioniUrService;

                viewValutazione();
            }
            else if (vm.isUser) {

                ValutazioniSrv = ValutazioniService;

                viewValutazione();
            }
            else {

                if(vm.isRef)
                    ValutazioniSrv = ValutazioniRefService;
                else
                    ValutazioniSrv = ValutazioniMcService;

                getValutazioneObj();
            }

            function getValutazioneObj() {

                if(vm.valutazioneId) {
                    ValutazioniSrv.getValutazione(vm.valutazioneId)
                        .then(function(response) {
                            vm.valutazione = response;
                            vm.senzaPunteggio = isSenzaPunteggio();
                            vm.booleanEvaluation = isBooleanEvaluation();
                            if (!vm.proposta)
                                vm.proposta = response.proposta;
                        });
                }
                else {
                    ValutazioniSrv.newValutazione(vm.proposta.id, vm.faseId)
                        .then(function(response) {
                            vm.valutazione = response;
                            vm.senzaPunteggio = isSenzaPunteggio();
                            vm.booleanEvaluation = isBooleanEvaluation();
                        });
                }
            }

            function viewValutazione() {

                if(vm.valutazioneId) {
                    ValutazioniSrv.getValutazione(vm.valutazioneId)
                        .then(function(response) {
                            vm.valutazione = response;
                            vm.senzaPunteggio = isSenzaPunteggio();
                            vm.booleanEvaluation = isBooleanEvaluation();
                            if (!vm.proposta)
                                vm.proposta = response.proposta;
                        });
                }
            }

            function initBloccante(valutazionePunteggio) {
                if(valutazionePunteggio.enabled) {
                    checkBloccante(valutazionePunteggio);
                }
            }

            function checkBloccante(valutazionePunteggio) {

                if(valutazionePunteggio.criterio.bloccante && valutazionePunteggio.punteggio == 0) {

                    angular.forEach(vm.valutazione.valutazionePunteggioList, function(criteriObj) {
                        if(criteriObj.criterio.posizione > valutazionePunteggio.criterio.posizione) {
                            criteriObj.enabled = false;
                            criteriObj.punteggio = null;
                        }
                    });
                }
                else {

                    angular.forEach(vm.valutazione.valutazionePunteggioList, function(criteriObj) {
                        if(criteriObj.criterio.posizione > valutazionePunteggio.criterio.posizione) {
                            criteriObj.enabled = true;
                        }
                    });

                }

            }

            function salvaInBozzaValutazione() {

                vm.saveLoading = true;

                var valutazione = angular.copy(vm.valutazione);

                angular.forEach(valutazione.valutazionePunteggioList, function(criterio) {
                    delete criterio.enabled;
                    delete criterio.editValue;
                });

                ValutazioniSrv.salvaValutazione(valutazione)
                    .then(function(/*response*/) {
                        vm.confirm(true);
                    });
            }

            function concludiValutazione() {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>{{"SAVE_AND_COMPLETE" | translate}}</h3>\
                        <div class="alert alert-warning" role="alert">{{"CONFIRM_EVALUATION_SUBMIT" | translate}}</div>\
                        <p>{{"CONFIRM_EVALUATION_SUBMIT_QUESTION" | translate}}</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">{{"NO" | translate}}</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">{{"YES" | translate}}</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.saveLoading = true;

                        var valutazione = angular.copy(vm.valutazione);

                        angular.forEach(valutazione.valutazionePunteggioList, function(criterio) {
                            delete criterio.enabled;
                            delete criterio.editValue;
                            if( criterio.punteggio == null)
                                criterio.punteggio = 0;
                        });

                        ValutazioniSrv.concludiValutazione(valutazione)
                            .then(function() {
                                vm.confirm(true);
                            });

                    }
                });
            }

            function calcolaPunteggioTotale(punteggioList) {
                var sum = 0;

                angular.forEach(punteggioList, function(elem) {
                    if(elem.punteggio)
                        sum += elem.punteggio;
                })

                return sum;
            }

            function checkConcludiDisable() {
                var invalid = false;

                if(vm.valutazione){
                    var isAllInvalid = true;
                    angular.forEach(vm.valutazione.valutazionePunteggioList, function(criterioObj) {
                        if(criterioObj.punteggio !== null){
                            isAllInvalid = false;
                        }

                        if(criterioObj.criterio.valoreList.length > 0) {
                            if(criterioObj.punteggio == null && criterioObj.enabled && criterioObj.criterio.tipo != 'MEDIA_REFEREE')
                                invalid = true;
                        } else {
                            if(vm.valutazione.motivazione == null || vm.valutazione.motivazione == "")
                                invalid = true;
                        }
                    });

                    if( vm.proposta.classe.id === 522
                        && isAllInvalid
                        && vm.valutazione.motivazione !== ""
                        && vm.valutazione.motivazione !== null
                    ){
                        return false;
                    }
                }
                return vm.valutaForm.$invalid || invalid;

            }

            function isSenzaPunteggio() {

                var senzaPunteggio = true;

                if(vm.valutazione)
                    angular.forEach(vm.valutazione.valutazionePunteggioList, function(criterioObj) {
                        if(criterioObj.criterio.valoreList.length > 0) {
                            senzaPunteggio = false;
                        }
                    });

                return senzaPunteggio;
            }

            function getDipartimentoQualificato(criterioObj) {
                if(criterioObj.punteggio)
                    return criterioObj.punteggio;
                else {
                    if (vm.proposta.dipartimentoQualificato)
                        criterioObj.punteggio = 5;
                    else
                        criterioObj.punteggio = 0;
                    return criterioObj.punteggio;
                }
            }

            function isBooleanEvaluation() {

                var booleanEvaluation = false;

                if (vm.valutazione && vm.valutazione.valutazionePunteggioList.length == 1) {
                    angular.forEach(vm.valutazione.valutazionePunteggioList, function(criterioObj) {
                        if (criterioObj.criterio.valoreList.length == 1) {
                            if (criterioObj.criterio.valoreList[0].valoreFalse != null && criterioObj.criterio.valoreList[0].valoreTrue != null)
                                booleanEvaluation = true;
                        }
                    });
                }

                return booleanEvaluation;
            }

            function chiudi() {
                vm.confirm(false);
            }

            function usaMedia(criterio) {
                criterio.punteggio = criterio.mediaPrecalcolata;
                criterio.editValue = false;
            }

            function modificaMedia(criterio) {
                criterio.editValue = true;
            }

            function getPdfExportUrl(valutazioneModel) {
                var urlPrefix = '';
                if (vm.isUr)
                    urlPrefix = '/ur';
                else
                    urlPrefix = '/mc';
                if (valutazioneModel)
                    return Constants.restApiRoot + urlPrefix + "/valutazione/pdf/" + valutazioneModel.id + '?token=' + UserData.getToken();
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('storicoTitolari', storicoTitolari);

    /** @ngInject */
    function storicoTitolari() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/storicoTitolari/storicoTitolari.html',
            scope: {},
            bindToController: {
                propostaId: "=",
                proponente: "="
            },
            controller: StoricoTitolariController,
            controllerAs: 'titCtrl'
        };

        return directive;

        /** @ngInject */
        function StoricoTitolariController(ProposteUrService, Constants, UserData, $log) {
            var vm = this;
            
            vm.titolari = null;
            vm.getFileHref = getFileHref;
            
            getTitolariProgettoList()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });
            
            function getTitolariProgettoList() {
                vm.titolari = null;
                return ProposteUrService.getStoricoTitolariProgetto(vm.propostaId)
                    .then(function(data) {
                        vm.titolari = data;
                    });
            }
            
            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL + '?token=' + UserData.getToken();
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id + '/titolare?token=' + UserData.getToken();
            }
            
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('statisticheTable', statisticheTable);

    /** @ngInject */
    function statisticheTable() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/statisticheTable/statisticheTable.html',
            scope: {},
            bindToController: {
                statistiche: "="
            },
            controller: statisticheTableController,
            controllerAs: 'statTableCtrl'
        };

        return directive;

        /** @ngInject */
        function statisticheTableController($filter, $timeout) {
            var vm = this;
            vm.stats = null;

            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                vm.totalStat = calculateProposalSum(vm.statistiche, true);

                vm.stats = [];
                var tipologie = $filter('groupBy')(vm.statistiche, 'idTipologia');
                angular.forEach(tipologie, function(tipologia) {
                    var stat = {
                        level: 1,
                        key: '' + tipologia[0].idTipologia,
                        label: tipologia[0].nomeTipologia
                    };
                    angular.extend(stat, calculateProposalSum(tipologia));
                    stat.totaleFinanziabile = tipologia[0].totaleFinanziabile;
                    vm.stats.push(stat);

                    var classi = $filter('groupBy')(tipologia, 'idClasse');
                    angular.forEach(classi, function(classe) {
                        var stat = {
                            level: 2,
                            key: '' + tipologia[0].idTipologia + ' - ' + classe[0].idClasse,
                            label: classe[0].nomeClasse
                        };
                        angular.extend(stat, calculateProposalSum(classe));
                        vm.stats.push(stat);

                        var macroaree = $filter('groupBy')(classe, 'codeMacroarea');
                        angular.forEach(macroaree, function(macroarea) {
                            var stat = {
                                level: 3,
                                key: '' + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + ' - ' + macroarea[0].idMacroarea,
                                showCondition: "statTableCtrl.expanded['" + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + "']",
                                label: macroarea[0].codeMacroarea + ' - ' + macroarea[0].nomeMacroarea
                            };
                            angular.extend(stat, calculateProposalSum(macroarea));
                            vm.stats.push(stat);

                            var dipartimenti = macroarea;
                            angular.forEach(dipartimenti, function(obj) {
                                var stat = {
                                    level: 4,
                                    key: '' + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + ' - ' + macroarea[0].idMacroarea + ' - ' + obj.idDipartimento,
                                    showCondition: "statTableCtrl.expanded['" + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + "'] && statTableCtrl.expanded['" + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + ' - ' + macroarea[0].idMacroarea + "']",
                                    label: obj.nomeDipartimento,
                                    numeroProposteBozza: obj.numeroProposteBozza,
                                    numeroProposteInviate: obj.numeroProposteInviate,
                                    numeroProposteValutate: obj.numeroProposteValutate,
                                    numeroProposteFinanziate: obj.numeroProposteFinanziate,
                                    finanziamentoRichiesto: obj.finanziamentoRichiesto,
                                    assegnoRichiesto: obj.assegnoRichiesto,
                                    numeroAssegniRichiesti: obj.numeroAssegniRichiesti,
                                    finanziamentoConcesso: obj.finanziamentoConcesso,
                                    assegnoConcesso: obj.assegnoConcesso,
                                    numeroAssegniConcessi: obj.numeroAssegniConcessi
                                };
                                vm.stats.push(stat);
                            });

                            vm.stats.push({
                                level: 'Separator',
                                showCondition: "statTableCtrl.expanded['" + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + "'] && statTableCtrl.expanded['" + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + ' - ' + macroarea[0].idMacroarea + "']"
                            })
                        });

                        vm.stats.pop();

                        vm.stats.push({
                            level: 'Separator',
                            showCondition: "statTableCtrl.expanded['" + tipologia[0].idTipologia + ' - ' + classe[0].idClasse + "']"
                        })
                    });
                });
            }
            
            function calculateProposalSum(array, includiBudget) {
                includiBudget = !!includiBudget;

                var sum = {
                    numeroProposteBozza: 0,
                    numeroProposteInviate: 0,
                    numeroProposteValutate: 0,
                    numeroProposteFinanziate: 0,
                    finanziamentoRichiesto: 0,
                    assegnoRichiesto: 0,
                    numeroAssegniRichiesti: 0,
                    finanziamentoConcesso: 0,
                    assegnoConcesso: 0,
                    numeroAssegniConcessi: 0
                }
                    
                angular.forEach(array, function(value) {
                    sum.numeroProposteBozza += value.numeroProposteBozza;
                    sum.numeroProposteInviate += value.numeroProposteInviate;
                    sum.numeroProposteValutate += value.numeroProposteValutate;
                    sum.numeroProposteFinanziate += value.numeroProposteFinanziate;
                    sum.finanziamentoRichiesto += value.finanziamentoRichiesto;
                    sum.assegnoRichiesto += value.assegnoRichiesto;
                    sum.numeroAssegniRichiesti += value.numeroAssegniRichiesti;
                    sum.finanziamentoConcesso += value.finanziamentoConcesso;
                    sum.assegnoConcesso += value.assegnoConcesso;
                    sum.numeroAssegniConcessi += value.numeroAssegniConcessi;
                });
                
                if (includiBudget) {
                    sum.totaleFinanziabile = 0;
                    var tipologie = $filter('groupBy')(array, 'idTipologia');
                    angular.forEach(tipologie, function(tipologia) {
                        sum.totaleFinanziabile += tipologia[0].totaleFinanziabile;
                    });
                }
                
                return sum;
            }
            /*
            function getProposalSum(array, status) {
                var sum = 0;
                
                if(status == "TOTALE_FINANZIABILE") {
                    
                    var tipologie = $filter('groupBy')(array, 'idTipologia');
                    
                    angular.forEach(tipologie, function(tipologia) {
                        sum += tipologia[0].totaleFinanziabile;
                    });
                    
                }
                else {
                    
                    angular.forEach(array, function(value) {
                        switch(status) {
                            case 'BOZZA':
                                sum += value.numeroProposteBozza;
                                break;

                            case 'INVIATA':
                                sum += value.numeroProposteInviate;
                                break;

                            case 'VALUTATE':
                                sum += value.numeroProposteValutate;
                                break;

                            case 'FINANZIATE':
                                sum += value.numeroProposteFinanziate;
                                break;

                            case 'FINANZIAMENTO_RICHIESTO':
                                sum += value.finanziamentoRichiesto;
                                break;

                            case 'ASSEGNO_RICHIESTO':
                                sum += value.assegnoRichiesto;
                                break;
                            case 'FINANZIAMENTO_CONCESSO':
                                sum += value.finanziamentoConcesso;
                                break;

                            case 'ASSEGNO_CONCESSO':
                                sum += value.assegnoConcesso;
                                break;
                        }
                    });
                }
                
                return sum;
            }
            */
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('statisticheProgetti', statisticheProgetti);

    /** @ngInject */
    function statisticheProgetti() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/statisticheProgetti/statisticheProgetti.html',
            scope: {},
            bindToController: {
                isUr: "="
            },
            controller: StatisticheProgettiController,
            controllerAs: 'statisticheCtrl'
        };

        return directive;

        /** @ngInject */
        function StatisticheProgettiController(BandiService, ProposteUrService, ProposteMcService, $log) {
            var vm = this;
            
            vm.anno = null;
            
            vm.anni = null;
            vm.selectedAnno = null;
            
            vm.getStatistiche = getStatistiche;
            vm.getCsvExportUrl = getCsvExportUrl;
            
            getAnni()
                .then(getStatistiche)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle statistiche", error);
                });
            
            function getAnni() {
                if (vm.isUr) {
                    return BandiService.getAnni()
                        .then(function(data) {
                            if (data.length > 0) {
                                if (vm.anno)
                                    vm.selectedAnno = { anno: vm.anno };
                                else
                                    vm.selectedAnno = data[0];
                            }
                            vm.anni = data;
                        });
                }
                else {
                    return ProposteMcService.getAnni()
                        .then(function(data) {
                            if (data.length > 0) {
                                if (vm.anno)
                                    vm.selectedAnno = { anno: vm.anno };
                                else
                                    vm.selectedAnno = data[0];
                            }
                            vm.anni = data;
                        });
                }
            }
            
            function getStatistiche() {
                vm.statistiche = null;
                
                if(vm.isUr) {
                    return ProposteUrService.getStatistiche(vm.selectedAnno.anno)
                        .then(function(data) {
                            vm.statistiche = data;
                        });
                }
                else {
                    return ProposteMcService.getStatistiche(vm.selectedAnno.anno)
                        .then(function(data) {
                            vm.statistiche = data;
                        });
                }
            }
            
            function getCsvExportUrl() {
                if (vm.isUr) {
                    return ProposteUrService.getStatisticheExportUrl(vm.selectedAnno.anno);
                }
                else {
                    return ProposteMcService.getStatisticheExportUrl(vm.selectedAnno.anno);
                }
            }
            
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbYesNoRadio', sgbYesNoRadio);

    /** @ngInject */
    function sgbYesNoRadio() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-yesNoRadio/sgb-yesNoRadio.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbYesNoRadioController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbYesNoRadioController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbTextfield', sgbTextfield);

    /** @ngInject */
    function sgbTextfield() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-textfield/sgb-textfield.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                isReadonly: '@'
            },
            controller: SgbTextfieldController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbTextfieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbTextarea', sgbTextarea);

    /** @ngInject */
    function sgbTextarea() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-textarea/sgb-textarea.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                help: '@',
                model: '=',
                maxLength: '@',
                numRows: '@',
                isReadonly: '@'
            },
            controller: SgbTextareaController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbTextareaController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbTelephone', sgbTelephone);

    /** @ngInject */
    function sgbTelephone() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-telephone/sgb-telephone.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbTelephoneController,
            controllerAs: 'telCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbTelephoneController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbSelectFields', sgbSelectFields);

    /** @ngInject */
    function sgbSelectFields() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-selectFields/sgb-selectFields.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                choices: '=',
                numFields: '@',
                editable: '@'
            },
            controller: SgbSelectFieldsController,
            controllerAs: 'selectsCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbSelectFieldsController($timeout) {
            var vm = this;
            vm.range = [];

            if (vm.numFields == undefined)
                vm.numFields = 1;
            else
                vm.numFields *= 1;

            vm.onSelect = onSelect;
            vm.addRow = addRow;

            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);

            function onInit() {
                if (vm.numFields) {
                    vm.range = [];
                    for (var i = 1; i <= vm.numFields; i++)
                        vm.range.push(i);
                }
                if (!vm.model) {
                    vm.model = [];
                }else{
                  if(vm.editable) {
                    while (vm.range.length < vm.model.length) {
                      addRow()
                    }
                  }
                }
            }

          vm.filter2 = function(p){
            return p!==null && p.state !== null;
          };

            function onSelect(index, $item, $model) { //eslint-disable-line no-unused-vars
                if ($item == undefined)
                  if (vm.editable) {
                    vm.range[index]=null;
                    if(vm.model[index]){
                      vm.model[index] = null;
                    }
                  } else {
                    vm.model[index] = null;
                  }
                else
                    vm.model[index] = angular.copy($item.item);
            }

          function addRow(){
            vm.range[vm.range.length]=vm.range.length+1;
          }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbSelect', sgbSelect);

    /** @ngInject */
    function sgbSelect() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-select/sgb-select.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                choices: '=',
                simple: '=',
                isRequired: '='
            },
            controller: SgbSelectController,
            controllerAs: 'selectCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbSelectController($timeout) {
            var vm = this;
            vm.selectedItem = {};
            vm.onSelect = onSelect;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model && !vm.simple) {
                    vm.selectedItem.id = vm.model.id;
                }
            }
            
            function onSelect($item, $model) { //eslint-disable-line no-unused-vars
                if ($item == undefined)
                    vm.model = null;
                else
                    vm.model = $item.item;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbSection', sgbSection);

    /** @ngInject */
    function sgbSection() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-section/sgb-section.html',
            transclude: true,
            scope: {},
            bindToController: {
                name: '@'
            },
            controller: SgbSectionController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbSectionController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbRichText', sgbRichText);

    /** @ngInject */
    function sgbRichText() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-richText/sgb-richText.html',
            scope: {},
            bindToController: {
                label: '@',
                maxLength: '@',
                model: '=',
                help: '@',
                fullWidth: '@?'
            },
            controller: SgbRichTextController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbRichTextController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbResearchIndicatorsPart', sgbResearchIndicatorsPart);

    /** @ngInject */
    function sgbResearchIndicatorsPart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-researchIndicatorsPart/sgb-researchIndicatorsPart.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                options: '='
            },
            controller: SgbResearchIndicatorsPartController,
            controllerAs: 'resIndPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbResearchIndicatorsPartController() {
            var vm = this;

            vm.defaultOptions = {
                allowCorrection: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbResearchIndicators2021', sgbResearchIndicators2021);

    /** @ngInject */
    function sgbResearchIndicators2021() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-researchIndicators2021/sgb-researchIndicators2021.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                options: '=',
                authRequired: '='
            },
            controller: SgbResearchIndicators2021Controller,
            controllerAs: 'resIndCtrl2021'
        };

        return directive;

        /** @ngInject */
        function SgbResearchIndicators2021Controller() {
            var vm = this;
            vm.mesiCongedoRange = range(1,24);

            vm.defaultOptions = {
                allowCorrection: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);

            vm.onSelect1Change = onSelect1Change;
            vm.gte = gte;

            function range(start, end) {
                var result = [];
                for (var i = start; i <= end; i++)
                    result.push(i);
                return result;
            }

            function onSelect1Change(newValue) {
                if (angular.isNumber(newValue) && vm.model.mesiCongedo2 < newValue)
                    vm.model.mesiCongedo2 = null;
            }

            function gte(value) {
                return function(item) {
                    return !angular.isNumber(value) || item >= value;
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbResearchIndicators', sgbResearchIndicators);

    /** @ngInject */
    function sgbResearchIndicators() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-researchIndicators/sgb-researchIndicators.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                options: '=',
                authRequired: '='
            },
            controller: SgbResearchIndicatorsController,
            controllerAs: 'resIndCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbResearchIndicatorsController() {
            var vm = this;
            vm.mesiCongedoRange = range(1,24);

            vm.defaultOptions = {
                allowCorrection: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);

            vm.onSelect1Change = onSelect1Change;
            vm.gte = gte;

            function range(start, end) {
                var result = [];
                for (var i = start; i <= end; i++)
                    result.push(i);
                return result;
            }

            function onSelect1Change(newValue) {
                if (angular.isNumber(newValue) && vm.model.mesiCongedo2 < newValue)
                    vm.model.mesiCongedo2 = null;
            }

            function gte(value) {
                return function(item) {
                    return !angular.isNumber(value) || item >= value;
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbReport', sgbReport);

    /** @ngInject */
    function sgbReport() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-report/sgb-report.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                modelMotivazione: '=',
                checkScostamento: '='
            },
            controller: SgbReportController,
            controllerAs: 'reprt'
        };

        return directive;

        /** @ngInject */
        function SgbReportController($timeout) {
            var vm = this;
            
            var tempMotiv = null;
            
            //vm.selectValues = {};
            vm.asteriskRows = [];
            
            vm.getTotal = getTotal;
            vm.getChoices = getChoices;
            vm.updateImporto = updateImporto;
            vm.checkPercSpeso = checkPercSpeso;
            vm.showPercSpesoTextarea = showPercSpesoTextarea;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model) {
                    /*for (var i = 0; i < vm.model.length; i++) {
                        var row = vm.model[i];
                        if (row.tipo == 'IMPORTO_FISSO') {
                            if (row.finanziamentoRichiesto)
                                vm.selectValues[row.id] = ((row.finanziamentoRichiesto * 1) / row.importo) + '';
                            else
                                vm.selectValues[row.id] = '0';
                        }
                    }*/
                    
                    angular.forEach(vm.model.vociRendicontoList, checkPercSpeso);
                }
            }
            
            function getTotal(rows, field) {
                var result = 0;
                if (rows && rows.length) {
                    for (var i = 0; i < rows.length; i++) {
                        result += rows[i][field] * 1;
                    }
                }
                return result;
            }
            
            function getChoices(row) {
                var choices = [];
                for (var i = row.min; i <= row.max; i++)
                    choices.push(i + '');
                return choices;
            }
            
            function updateImporto($item, row) {
                var importo  = $item * 1 * row.importo;
                row.finanziamentoRichiesto = importo;
            }
            
            function checkPercSpeso(row, index) {
                if(isNaN(row.finanziamentoSpeso))
                    vm.asteriskRows[index] = false;
                
                var concesso = row.finanziamentoRichiesto / vm.model.totaleRichiesto * vm.model.totaleConcesso;
                var delta = concesso * 0.2;
                var min = concesso - delta;
                var max = concesso + delta;
                
                if (vm.checkScostamento === "up") {
                    if (row.finanziamentoSpeso > max)
                        vm.asteriskRows[index] = true;
                    else
                        vm.asteriskRows[index] = false;
                }
                else {
                    if(row.finanziamentoSpeso < min || row.finanziamentoSpeso > max)
                        vm.asteriskRows[index] = true;
                    else
                        vm.asteriskRows[index] = false;
                }
            }
            
            function showPercSpesoTextarea() {
                var flag = false;
                
                angular.forEach(vm.asteriskRows, function(show) {
                   if(show)
                       flag = true;
                });
                
                if(flag && tempMotiv != null && vm.modelMotivazione == null) {
                    vm.modelMotivazione = tempMotiv;
                    tempMotiv = null;
                }
                
                if(!flag && tempMotiv == null && vm.modelMotivazione != null) {
                    tempMotiv = vm.modelMotivazione;
                    vm.modelMotivazione = null;
                }
                
                return flag;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbPublicationsRend', sgbPublicationsRend);

    /** @ngInject */
    function sgbPublicationsRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-publicationsRend/sgb-publicationsRend.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                numMax: '@'
            },
            controller: SgbPublicationsRendController,
            controllerAs: 'pubblRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbPublicationsRendController(ngDialog, $timeout) {
            var vm = this;
            
            vm.addPublication = addPublication;
            vm.addEditPublicationManual = addEditPublicationManual;
            vm.removePublication = removePublication;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model == null)
                    vm.model = [];
            }
            
            function addPublication() {
                ngDialog.open({
                    template:'\
                        <sgb-add-publications-rend pubblicazioni="ngDialogData.pubblicazioni" num-max="{{ngDialogData.numMax}}"></sgb-add-publications-rend>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-addPublicationsRend',
                    data: {
                        pubblicazioni: vm.model,
                        numMax: vm.numMax
                    }
                });
            }
            
            function addEditPublicationManual(pubblicazione) {
                ngDialog.open({
                    template:'\
                        <sgb-add-publications-rend-man pubblicazione="ngDialogData.pubblicazione" pubblicazioni="ngDialogData.pubblicazioni" num-max="{{ngDialogData.numMax}}" close="closeThisDialog(0)"></sgb-add-publications-rend-man>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-addPublicationsRendMan',
                    data: {
                        pubblicazione: pubblicazione,
                        pubblicazioni: vm.model,
                        numMax: vm.numMax
                    }
                });
            }
            
            function removePublication(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la pubblicazione?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        pubblicazione: vm.model[index]
                    }
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbAddPublicationsRend', sgbAddPublicationsRend);

    /** @ngInject */
    function sgbAddPublicationsRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-publicationsRend/sgb-add-publications-rend.html',
            scope: {},
            bindToController: {
                pubblicazioni: '=',
                numMax: '@'
            },
            controller: SgbAddPublicationsRendController,
            controllerAs: 'addPubblRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbAddPublicationsRendController(PubblicazioniService, $log, $timeout) {
            var vm = this;
            
            vm.searching = false;
            vm.results = null;
            vm.errorMessage = null;
            
            vm.searchInput = null;
            vm.searchTimeout = null;
            
            vm.addPublication = addPublication;
            vm.findPublication = findPublication;
            vm.findPublicationDelay = findPublicationDelay;
            
            function findPublicationDelay(input) {
                if (vm.searchTimeout != null) {
                    $timeout.cancel(vm.searchTimeout);
                    vm.searchTimeout = null;
                }
                vm.searchTimeout = $timeout(function() {
                    findPublication(input);
                }, 800);
            }
            
            function findPublication(input) {
                vm.results = null;
                vm.errorMessage = null;
                if (input != '') {
                    vm.searching = true;
                    PubblicazioniService.getPubblicazioneByHandle(input)
                        .then(function(data) {
                            var risultato = data;
                            if (risultato != null) {
                                // aggiungo i flag per le pubblicazioni già selezionate
                                for (var j = 0; j < vm.pubblicazioni.length; j++) {
                                    var pubbl = vm.pubblicazioni[j];
                                    if (pubbl.prodottoId == risultato.prodottoId && pubbl.handle == risultato.handle) {
                                        risultato.isAlreadyRequested = true;
                                        break;
                                    }
                                }
                                vm.results = [risultato];
                            }
                            else {
                                vm.results = [];
                            }
                            vm.searching = false;
                        })
                        .catch(function(error) {
                            vm.searching = false;
                            if (error.data.code == 42)
                                vm.results = [];
                            else {
                                vm.errorMessage = (error.data.message ? error.data.message : " ");
                                $log.error(error);
                            }
                        });
                }
            }
            /* VECCHIA VERSIONE CON RICERCA PER ID UGOV
            function findPublication(input) {
                vm.results = null;
                vm.errorMessage = null;
                if (input != '' && !isNaN(input)) {
                    vm.searching = true;
                    PubblicazioniService.getPubblicazioneByIdUgov(input)
                        .then(function(data) {
                            var risultato = data;
                            if (risultato != null) {
                                // aggiungo i flag per le pubblicazioni già selezionate
                                for (var j = 0; j < vm.pubblicazioni.length; j++) {
                                    var pubbl = vm.pubblicazioni[j];
                                    if (pubbl.prodottoId == risultato.prodottoId && pubbl.handle == risultato.handle) {
                                        risultato.isAlreadyRequested = true;
                                        break;
                                    }
                                }
                                vm.results = [risultato];
                            }
                            else {
                                vm.results = [];
                            }
                            vm.searching = false;
                        })
                        .catch(function(error) {
                            vm.searching = false;
                            if (error.data.code == 42)
                                vm.results = [];
                            else {
                                vm.errorMessage = (error.data.message ? error.data.message : " ");
                                $log.error(error);
                            }
                        });
                }
            }
            */
            function addPublication(result) {
                result.isAlreadyRequested = true;
                var publ = angular.copy(result);
                delete publ.isAlreadyRequested;
                vm.pubblicazioni.push(publ);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbAddPublicationsRendMan', sgbAddPublicationsRendMan);

    /** @ngInject */
    function sgbAddPublicationsRendMan() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-publicationsRend/sgb-add-publications-rend-man.html',
            scope: {},
            bindToController: {
                pubblicazione: '=',
                pubblicazioni: '=',
                numMax: '@',
                close: '&'
            },
            controller: SgbAddPublicationsRendManController,
            controllerAs: 'addPubblRendManCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbAddPublicationsRendManController() {
            var vm = this;
            
            vm.tempPubblicazione = vm.pubblicazione != null ? angular.copy(vm.pubblicazione) : {
                titolo: null,
                anno: null,
                autori: null,
                testo: null
            };
            
            vm.confirm = confirm;
            
            function confirm() {
                
                if(vm.pubblicazione)
                    angular.extend(vm.pubblicazione, vm.tempPubblicazione);
                else
                    vm.pubblicazioni.push(vm.tempPubblicazione);
                
                vm.close();
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbPublicationsPart', sgbPublicationsPart);

    /** @ngInject */
    function sgbPublicationsPart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-publicationsPart/sgb-publicationsPart.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                options: '='
            },
            controller: SgbPublicationsPartController,
            controllerAs: 'pubblPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbPublicationsPartController() {
            var vm = this;

            vm.defaultOptions = {
                showImpactFactor: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbPublications', sgbPublications);

    /** @ngInject */
    function sgbPublications() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-publications/sgb-publications.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                numMax: '@',
                options: '='
            },
            controller: SgbPublicationsController,
            controllerAs: 'pubblCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbPublicationsController(ngDialog) {
            var vm = this;

            vm.defaultOptions = {
                showImpactFactor: true
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
            
            vm.addPublication = addPublication;
            vm.removePublication = removePublication;
            
            function addPublication() {
                ngDialog.open({
                    template:'\
                        <sgb-add-publications pubblicazioni="ngDialogData.pubblicazioni" num-max="{{ngDialogData.numMax}}" options="ngDialogData.options"></sgb-add-publications>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-addPublications',
                    data: {
                        pubblicazioni: vm.model,
                        numMax: vm.numMax,
                        options: vm.opts
                    }
                });
            }
            
            function removePublication(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la pubblicazione?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        pubblicazione: vm.model[index]
                    }
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbAddPublications', sgbAddPublications);

    /** @ngInject */
    function sgbAddPublications() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-publications/sgb-add-publications.html',
            scope: {},
            bindToController: {
                pubblicazioni: '=',
                numMax: '@',
                options: '='
            },
            controller: SgbAddPublicationsController,
            controllerAs: 'addPubblCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbAddPublicationsController(PubblicazioniService, $log) {
            var vm = this;
            
            vm.searching = false;
            vm.results = null;
            vm.errorMessage = null;
            
            vm.limit = 20;
            vm.nextOffset = 0;
            vm.hasNext = false;
            
            vm.loadPublications = loadPublications;
            vm.addPublication = addPublication;
            
            loadPublications();
            
            function loadPublications() {
                vm.searching = true;
                vm.errorMessage = null;
                PubblicazioniService.getPubblicazioni(vm.limit, vm.nextOffset)
                    .then(function(data) {
                        var risultati = data.resultList;
                        // aggiungo i flag per le pubblicazioni già selezionate
                        for (var i = 0; i < risultati.length; i++) {
                            for (var j = 0; j < vm.pubblicazioni.length; j++) {
                                var pubbl = vm.pubblicazioni[j];
                                if (pubbl.pubblicazione.prodottoId == risultati[i].pubblicazione.prodottoId && pubbl.pubblicazione.handle == risultati[i].pubblicazione.handle) {
                                    risultati[i].isAlreadyRequested = true;
                                    break;
                                }
                            }
                        }
                    
                        if (!vm.results)
                            vm.results = [];
                        vm.results = vm.results.concat(risultati);
                    
                        if (data.totale == vm.limit) {
                            vm.hasNext = true;
                            vm.nextOffset = data.end;
                        }
                        else
                            vm.hasNext = false;
                    
                        vm.searching = false;
                    })
                    .catch(function(error) {
                        vm.searching = false;
                        vm.errorMessage = error.data.message;
                        $log.error(error);
                    });
            }
            
            function addPublication(result) {
                result.isAlreadyRequested = true;
                vm.pubblicazioni.push(result);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbProgettiManual', sgbProgettiManual);

    /** @ngInject */
    function sgbProgettiManual() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-progettiManual/sgb-progettiManual.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                numMax: '@',
                model: '=',
                type: '@'
            },
            controller: SgbProgettiManualController,
            controllerAs: 'progManCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbProgettiManualController(ngDialog) {
            var vm = this;



            vm.addProj = addProj;
            vm.removeProj = removeProj;

            function addProj() {
                if (!vm.model){
                    vm.model = [];
                }
                vm.model.push({
                    id:vm.model.length!==0?vm.model[vm.model.length-1].id+1:1
                });
            }

            function removeProj(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare {{ngDialogData.progetto.titolo}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        progetto: vm.model[index]
                    }
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                        for (var i = 0; i < vm.model.length; i++) {
                            if (vm.model[i].id !== i + 1) {
                                vm.model[i].id = i + 1
                            }
                        }
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbPreviousFundingsNewNoPercImpegno', sgbPreviousFundingsNewNoPercImpegno);

    /** @ngInject */
    function sgbPreviousFundingsNewNoPercImpegno() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-previousFundingsNewNoPercImpegno/sgb-previousFundingsNewNoPercImpegno.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                options: '='
            },
            controller: SgbPreviousFundingsNewNoPercImpegnoController,
            controllerAs: 'prevFundNPercImpCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbPreviousFundingsNewNoPercImpegnoController(ngDialog, $timeout) {
            var vm = this;

            vm.defaultOptions = {
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);

            vm.addFunding = addFunding;
            vm.removeFunding = removeFunding;

            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);

            function onInit() {
                if (vm.model == null)
                    vm.model = [];
            }

            function addFunding() {
                var baseModel = {
                    titolare: '',
                    enteFinanziatore: '',
                    importo: '',
                    titoloProgetto: '',
                    dataInizio: '',
                    dataFine: ''
                };
                vm.model.push(baseModel);
            }

            function removeFunding(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare il finanziamento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbPreviousFundingsNew', sgbPreviousFundingsNew);

    /** @ngInject */
    function sgbPreviousFundingsNew() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-previousFundingsNew/sgb-previousFundingsNew.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                options: '='
            },
            controller: SgbPreviousFundingsNewController,
            controllerAs: 'prevFundNCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbPreviousFundingsNewController(ngDialog, $timeout) {
            var vm = this;
            vm.percentuali = getPercentuali(0, 100, 5);

            vm.defaultOptions = {
            };

            vm.opts = angular.extend({}, vm.defaultOptions, vm.options);
            
            vm.addFunding = addFunding;
            vm.removeFunding = removeFunding;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model == null)
                    vm.model = [];
            }
            
            function addFunding() {
                var baseModel = {
                    titolare: '',
                    enteFinanziatore: '',
                    importo: '',
                    titoloProgetto: '',
                    dataInizio: '',
                    dataFine: '',
                    percentualeImpegno: ''
                };
                vm.model.push(baseModel);
            }
            
            function removeFunding(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare il finanziamento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }

            function getPercentuali(start, end, step) {
                var result = [];
                for (var i = start; i <= end; i += step)
                    result.push(i + '%');
                return result;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbPreviousFundings', sgbPreviousFundings);

    /** @ngInject */
    function sgbPreviousFundings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-previousFundings/sgb-previousFundings.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                type: '@'
            },
            controller: SgbPreviousFundingsController,
            controllerAs: 'prevFundCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbPreviousFundingsController(ngDialog, $timeout) {
            var vm = this;
            
            vm.addFunding = addFunding;
            vm.removeFunding = removeFunding;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model == null)
                    vm.model = [];
            }
            
            function addFunding() {
                var baseModel = {
                    titolare: '',
                    enteFinanziatore: '',
                    importo: '',
                    titoloProgetto: ''
                };
                if (vm.type == 'withYears') {
                    baseModel.dataInizio = '';
                    baseModel.dataFine = '';
                }
                vm.model.push(baseModel);
            }
            
            function removeFunding(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare il finanziamento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbParticipantsRend', sgbParticipantsRend);

    /** @ngInject */
    function sgbParticipantsRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-participantsRend/sgb-participantsRend.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbParticipantsRendController,
            controllerAs: 'partRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbParticipantsRendController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbParticipantsManualRend', sgbParticipantsManualRend);

    /** @ngInject */
    function sgbParticipantsManualRend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-participantsManualRend/sgb-participantsManualRend.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbParticipantsManualRendController,
            controllerAs: 'partManRendCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbParticipantsManualRendController(ngDialog, $timeout) {
            var vm = this;
            
            vm.addParticipant = addParticipant;
            vm.removeParticipant = removeParticipant;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.model == null)
                    vm.model = [];
            }
            
            function addParticipant() {
                vm.model.push({
                    cognome: '',
                    nome: '',
                    qualifica: '',
                    struttura: ''
                });
            }
            
            function removeParticipant(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare il partecipante {{ngDialogData.persona.cognome}} {{ngDialogData.persona.nome}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        persona: vm.model[index]
                    }
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbParticipantsManual', sgbParticipantsManual);

    /** @ngInject */
    function sgbParticipantsManual() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-participantsManual/sgb-participantsManual.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbParticipantsManualController,
            controllerAs: 'partManCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbParticipantsManualController(ngDialog) {
            var vm = this;

            vm.addParticipant = addParticipant;
            vm.removeParticipant = removeParticipant;

            function addParticipant() {
                vm.model.partecipantiList.push({
                    cognome: '',
                    nome: '',
                    qualifica: '',
                    struttura: ''
                });
            }

            function removeParticipant(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare il partecipante {{ngDialogData.persona.cognome}} {{ngDialogData.persona.nome}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        persona: vm.model.partecipantiList[index]
                    }
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.partecipantiList.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbParticipants', sgbParticipants);

    /** @ngInject */
    function sgbParticipants() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-participants/sgb-participants.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                help: '@',
                model: '=',
                propostaId: '=',
                numMax: '@',
                type: '@',
                specificType: '@'
            },
            controller: SgbParticipantsController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbParticipantsController(ngDialog, $filter,$rootScope, $scope) {
            var vm = this;
            // console.log(vm);


            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.addPending = addPending;
            vm.removeParticipant = removeParticipant;
            vm.removePending = removePending;
            vm.getNumPartecipantiERichieste = getNumPartecipantiERichieste;
            vm.checkPISelection = checkPISelection;


            var listenerLineeTematiche = $rootScope.$on('requestList', function (e,data) {
                if (vm.label == 'Co-PI' || (vm.type == 'dipartimentali' && vm.specificType == 'partecipanti_doc_ric')) {
                    for (var i = 0; i < vm.model.partecipantiList.length; i++) {
                        $rootScope.$broadcast('pendingCoPi', vm.model.partecipantiList[i]);
                    }
                    for (var i = 0; i < vm.model.pendingList.length; i++) {
                        $rootScope.$broadcast('pendingCoPi', vm.model.pendingList[i].utente);
                    }
                }
            });

            $scope.$on("$destroy", function () {
                // Distrugge i listener
                listenerLineeTematiche()
            });


            function checkPISelection(partecipantiList, partecipante){
              var checked = partecipante.piSostituito;
              if (checked) {
                for (var i=0;i<partecipantiList.length;i++) {
                  if (partecipantiList[i] !== partecipante) {
                    partecipantiList[i].piSostituito = false;
                  }
                }
              }
            }

            function getStatusClass(status) {
                if (status == 'PENDING')
                    return 'pending';
                if (status == 'RIFIUTATA')
                    return 'rejected';
                return '';
            }

            function getStatusIcon(status) {
                if (status == 'PENDING')
                    return 'fa-question';
                if (status == 'RIFIUTATA')
                    return 'fa-ban';
                return '';
            }

            function addPending() {
                ngDialog.open({
                    template:'\
                        <sgb-add-participants categoria-id="ngDialogData.categoriaId" classe-id="ngDialogData.classeId" proposta-id="ngDialogData.propostaId" richieste="ngDialogData.richieste" partecipanti="ngDialogData.partecipanti" num-max="{{ngDialogData.numMax}}"></sgb-add-participants>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        categoriaId: vm.model.categoriaId,
                        classeId: vm.model.classeId,
                        propostaId: vm.propostaId,
                        richieste: vm.model.pendingList,
                        partecipanti: vm.model.partecipantiList,
                        numMax: vm.numMax
                    }
                });
            }

            function removeParticipant(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare il partecipante {{ngDialogData.persona.cognome}} {{ngDialogData.persona.nome}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        persona: vm.model.partecipantiList[index]
                    }
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.partecipantiList.splice(index, 1);
                    }
                });
            }

            function removePending(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare la richiesta di partecipazione per {{ngDialogData.persona.utente.cognome}} {{ngDialogData.persona.utente.nome}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        persona: vm.model.pendingList[index]
                    }
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        $rootScope.$broadcast('pendingCoPi', vm.model.pendingList[index].utente.id);
                        vm.model.pendingList.splice(index, 1);
                    }
                });
            }

            function getNumPartecipantiERichieste() {
                var num = vm.model.partecipantiList.length + $filter('filter')(vm.model.pendingList, {status: 'PENDING'}).length;
                return num;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbAddParticipants', sgbAddParticipants);

    /** @ngInject */
    function sgbAddParticipants() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-participants/sgb-add-participants.html',
            scope: {},
            bindToController: {
                categoriaId: '=',
                classeId: '=',
                propostaId: '=',
                richieste: '=',
                partecipanti: '=',
                numMax: '@'
            },
            controller: SgbAddParticipantsController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbAddParticipantsController(UtentiService, $filter, $rootScope) {
            var vm = this;

            vm.searchString = '';
            vm.searching = false;
            vm.results = null;

            vm.search = search;
            vm.addPending = addPending;
            vm.getNumPartecipantiERichieste = getNumPartecipantiERichieste;

            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtenti(vm.categoriaId, vm.classeId, vm.propostaId, text)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le richieste già effettuate e nuove
                            for (var i = 0; i < vm.results.length; i++) {
                                for (var j = 0; j < vm.richieste.length; j++) {
                                    var richiesta = vm.richieste[j];
                                    if (richiesta.utente.id == vm.results[i].utente.id) {
                                        if (richiesta.status == 'RIFIUTATA')
                                            vm.results[i].isAlreadyRejected = true;
                                        else {
                                            vm.results[i].isAlreadyRequested = true;
                                            if (richiesta.new)
                                                vm.results[i].isNewRequest = true;
                                        }
                                        break;
                                    }
                                }
                                for (j = 0; j < vm.partecipanti.length; j++) {
                                    var partecipante = vm.partecipanti[j];
                                    if (partecipante.id == vm.results[i].utente.id) {
                                        vm.results[i].isAlreadyAccepted = true;
                                        break;
                                    }
                                }
                            }
                        })
                        .catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                }
                else {
                    vm.searching = false;
                }
            }

            function addPending(result) {
                result.isAlreadyRequested = true;
                result.isNewRequest = true;
                $rootScope.$broadcast('pendingCoPi',result.utente);
                vm.richieste.push({
                    status: 'PENDING',
                    new: true,
                    utente: result.utente
                });
            }

            function getNumPartecipantiERichieste() {
                var num = vm.partecipanti.length + $filter('filter')(vm.richieste, {status: 'PENDING'}).length;
                return num;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbOtherFundings', sgbOtherFundings);

    /** @ngInject */
    function sgbOtherFundings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-otherFundings/sgb-otherFundings.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbOtherFundingsController,
            controllerAs: 'othFundCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbOtherFundingsController($timeout, ngDialog) {
            var vm = this;
            
            vm.getTotal = getTotal;
            vm.addFund = addFund;
            vm.removeFund = removeFund;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (!vm.model) {
                    vm.model = [];
                }
            }
            
            function getTotal(rows) {
                var result = 0;
                if (rows && rows.length) {
                    for (var i = 0; i < rows.length; i++) {
                        result += rows[i].contributoOttenuto * 1;
                    }
                }
                return result;
            }
            
            function addFund() {
                vm.model.push({
                    ente: '',
                    contributoOttenuto: 0,
                    note: ''
                });
            }
            
            function removeFund(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare il contributo da altri enti?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbNumberField', sgbNumberField);

    /** @ngInject */
    function sgbNumberField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-numberField/sgb-numberField.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbNumberFieldController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbNumberFieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbLineeTematiche', sgbLineeTematiche);

    /** @ngInject */
    function sgbLineeTematiche() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-lineeTematiche/sgb-lineeTematiche.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                numMax: '@',
                type: '@',
                model: '='
            },
            controller: sgbLineeTematicheController,
            controllerAs: 'linTemCtrl'
        };

        return directive;

        /** @ngInject */
        function sgbLineeTematicheController(ngDialog,$rootScope) {
            var vm = this;
            vm.coPi = [];
            // console.log(vm.model);
            // console.log(vm.numMax);



            function onMount() {
                $rootScope.$broadcast('requestList', true);

            }

            $rootScope.$on('pendingCoPi', function (e, data) {
                if (typeof data == "number"){
                    vm.coPi.splice(vm.coPi.indexOf(data),1);
                }else{
                    var nomeCog = {
                        id : data.id,
                        nome: data.nome,
                        cognome: data.cognome
                    };
                    vm.coPi.push(nomeCog);
                }
            });





            vm.addProj = addProj;
            vm.removeProj = removeProj;
            onMount();

            function addProj() {
                if (!vm.model){
                    vm.model = [];
                }
                vm.model.push({
                    id: vm.model.length!==0?vm.model[vm.model.length-1].id+1:1
                });
            }

            function removeProj(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        progetto: vm.model[index]
                    }
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.splice(index, 1);
                            for (var i = 0; i < vm.model.length; i++) {
                                if (vm.model[i].id !== i + 1) {
                                    vm.model[i].id = i + 1
                                }
                            }
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbLastFundingsNew', sgbLastFundingsNew);

    /** @ngInject */
    function sgbLastFundingsNew() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-lastFundingsNew/sgb-lastFundingsNew.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbLastFundingsNewController,
            controllerAs: 'lastFundsNCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbLastFundingsNewController(ngDialog) {
            var vm = this;
            vm.addFunding = addFunding;
            vm.removeFunding = removeFunding;
            
            function addFunding(row) {
                var baseModel = {
                    progetto: '',
                    fondo_assegnato: '',
                    fondo_non_utilizzato: '',
                    motivazione_mancato_utilizzo: ''
                };
                if (!row.altro)
                    row.altro = [];
                row.altro.push(baseModel);
            }
            
            function removeFunding(row, index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare il finanziamento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        row.altro.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbLastFundings', sgbLastFundings);

    /** @ngInject */
    function sgbLastFundings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-lastFundings/sgb-lastFundings.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                baseModel: '='
            },
            controller: SgbLastFundingsController,
            controllerAs: 'lastFundsCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbLastFundingsController($timeout) {
            var vm = this;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (!vm.model) {
                    vm.model = angular.copy(vm.baseModel);
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbKeywordsSelect', sgbKeywordsSelect);

    /** @ngInject */
    function sgbKeywordsSelect() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-keywordsSelect/sgb-keywordsSelect.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                maxWords: '@',
                choices: '=',
                choicesLabel: '@'
            },
            controller: SgbKeywordsSelectController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbKeywordsSelectController($timeout) {
            var vm = this;
            vm.range = [];
            
            if (vm.maxWords == undefined)
                vm.maxWords = 1;
            else
                vm.maxWords *= 1;
            
            vm.onSelect = onSelect;
            vm.choicesFilter = choicesFilter;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.maxWords) {
                    vm.range = [];
                    for (var i = 1; i <= vm.maxWords; i++)
                        vm.range.push(i);
                }
                if (!vm.model) {
                    vm.model = [];
                }
            }
            
            function onSelect(index, $item, $model) { //eslint-disable-line no-unused-vars
                if ($item == undefined)
                    vm.model[index] = null;
                else
                    vm.model[index] = angular.copy($item);
            }
            
            function choicesFilter(searchString) {
                return function(item) {
                    if (!searchString)
                        return false;
                    
                    var label = angular.lowercase(item[vm.choicesLabel]);
                    if (label)
                        return (label.indexOf(angular.lowercase(searchString)) >= 0);
                    else
                        return false;
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbKeywords', sgbKeywords);

    /** @ngInject */
    function sgbKeywords() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-keywords/sgb-keywords.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                maxWords: '@'
            },
            controller: SgbKeywordsController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbKeywordsController($timeout) {
            var vm = this;
            
            vm.range = range;
            
            if (vm.maxWords == undefined)
                vm.maxWords = 1;
            else
                vm.maxWords *= 1;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (!vm.model) {
                    vm.model = [];
                }
            }
            
            function range(num) {
                var result = [];
                for (var i = 1; i <= num; i++)
                    result.push(i);
                return result;
            }
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('sigeba')
    .directive('sgbJsScript', sgbJsScript);

  /** @ngInject */
  function sgbJsScript() {
    var directive = {
      restrict: 'E',
      scope: {},
      bindToController: {
        script: '@',
        model: '='
      },
      controller: SgbJsScriptController,
      controllerAs: 'jsScript'
    };

    return directive;

    /** @ngInject */
    function SgbJsScriptController($timeout) {
      var vm = this;

      $timeout(onInit);

      function onInit(){
        eval(vm.script);
      }

    }
  }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbIndicatoriImpattoSostenibilita', sgbIndicatoriImpattoSostenibilita);

    /** @ngInject */
    function sgbIndicatoriImpattoSostenibilita() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-indicatoriImpattoSostenibilita/sgb-indicatoriImpattoSostenibilita.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: sgbIndicatoriImpattoSostenibilitaController,
            controllerAs: 'indImpSostCtrl'
        };

        return directive;

        /** @ngInject */
        function sgbIndicatoriImpattoSostenibilitaController(ngDialog,$timeout) {
            var vm = this;

            vm.addIndicatore = addIndicatore;
            vm.removeIndicatore = removeIndicatore;


          $timeout(onInit);

            function onInit(){
              if(!(vm && vm.model && vm.model.indicatoriList.length>0)){
                vm.model={indicatoriList:[]};
              }
          }

            function addIndicatore() {
                vm.model.indicatoriList.push({
                  indicatore: '',
                  valore: '',
                  readOnly: false
                });
            }

            function removeIndicatore(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare l\'indicatore {{ngDialogData.ind.indicatore}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        ind: vm.model.indicatoriList[index]
                    }
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.model.indicatoriList.splice(index, 1);
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbHIndexPart', sgbHIndexPart);

    /** @ngInject */
    function sgbHIndexPart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-hIndexPart/sgb-hIndexPart.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbHIndexPartController,
            controllerAs: 'hIndPartCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbHIndexPartController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbHIndex', sgbHIndex);

    /** @ngInject */
    function sgbHIndex() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-hIndex/sgb-hIndex.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: SgbHIndexController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbHIndexController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbFileUpload', sgbFileUpload);

    /** @ngInject */
    function sgbFileUpload() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-fileUpload/sgb-fileUpload.html',
            scope: {},
            bindToController: {
                label: '@',
                description: '@',
                help: '@',
                fileTemplateUrl: '@',
                fileTemplateLabel: '@',
                model: '=',
                maxfilesize: '@'
            },
            controller: SgbFileUploadController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbFileUploadController(MediaService, Constants, UserData, $log) {
            var vm = this;

            vm.loading = false;
            vm.uploadError = null;

            vm.uploadFile = uploadFile;
            vm.removeFile = removeFile;
            vm.getFileHref = getFileHref;

            function uploadFile(files) {
                vm.uploadError = null;
                if (files.length >= 1) {
                    vm.loading = true;

                    if(vm.maxfilesize){
                      MediaService.uploadPdfMaxFileSize(files[0],vm.maxfilesize)
                        .then(function(data) {
                          vm.model = data;
                          vm.loading = false;
                        })
                        .catch(function(error) {
                          $log.error("Errore nell'upload del file pdf", error);
                          vm.model = null;
                          vm.loading = false;
                          if (error.data.message)
                            vm.uploadError = error.data.message;
                          else
                            vm.uploadError = "Errore nell'upload del file pdf";
                        });
                    }else{
                      MediaService.uploadPdf(files[0])
                        .then(function(data) {
                          vm.model = data;
                          vm.loading = false;
                        })
                        .catch(function(error) {
                          $log.error("Errore nell'upload del file pdf", error);
                          vm.model = null;
                          vm.loading = false;
                          if (error.data.message)
                            vm.uploadError = error.data.message;
                          else
                            vm.uploadError = "Errore nell'upload del file pdf";
                        });
                    }
                }
            }

            function removeFile() {
                vm.model = null;
            }

            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL + '?token=' + UserData.getToken();
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id + '/proposta?token=' + UserData.getToken();
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbFileMultipleUpload', sgbFileMultipleUpload);

    /** @ngInject */
    function sgbFileMultipleUpload() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-fileMultipleUpload/sgb-fileMultipleUpload.html',
            scope: {},
            bindToController: {
                label: '@',
                filetype: '@',
                description: '@',
                fileTemplateUrl: '@',
                fileTemplateLabel: '@',
                help: '@',
                model: '=',
                maxFiles: '@'
            },
            controller: SgbFileMultipleUploadController,
            controllerAs: 'fileMUCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbFileMultipleUploadController(MediaService, Constants, UserData, $log) {
            var vm = this;

            vm.loading = false;
            vm.uploadError = null;
            if (!vm.model || !vm.model.length) {
                vm.model = [];
            }
            vm.uploadFile = uploadFile;
            vm.removeFile = removeFile;
            vm.getFileHref = getFileHref;

            function uploadFile(files) {
                vm.uploadError = null;
                if (files.length >= 1) {
                    vm.loading = true;
                    var numOfUpload = (vm.maxFiles?vm.maxFiles:(files.length+vm.model.length)) - vm.model.length;
                    for (var i = 0; i < numOfUpload && i < files.length; i++) {
                      MediaService.uploadFile(files[i],vm.filetype)
                        .then(function(data) {
                          vm.model.push(data);
                          vm.loading = false;
                        })
                        .catch(function(error) {
                          $log.error("Errore nell'upload del file pdf", error);
                          vm.loading = false;
                          if (error.data.message)
                            vm.uploadError = error.data.message;
                          else
                            vm.uploadError = "Errore nell'upload del file pdf";
                        });
                    }
                }
            }

            function removeFile(index) {
                vm.model.splice(index, 1);
            }

            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL + '?token=' + UserData.getToken();
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id + '/proposta?token=' + UserData.getToken();
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbDateRangeField', sgbDateRangeField);

    /** @ngInject */
    function sgbDateRangeField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-dateRangeField/sgb-dateRangeField.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                minDate: '@',
                maxDate: '@'
            },
            controller: SgbDateRangeFieldController,
            controllerAs: 'dateCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbDateRangeFieldController() {
        }
    }

})();

/*
        {
          "tipo": "datefield-indet",
          "label": "Data fine rapporto del proponente / Employment end date of the Principal Investigator",
          "model": "data_termine_rapporto",
          "indeterminateDescription": "Rapporto lavorativo a tempo indeterminato (di cui non si conosce ancora la data del pensionamento)",
          "indeterminateValue": "02/02/2222",
          "help": "Inserire la data di fine del proprio rapporto lavorativo, ovvero la scadenza del contratto (o la data del pensionamento)"
        }
*/

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbDateFieldIndet', sgbDateFieldIndet);

    /** @ngInject */
    function sgbDateFieldIndet() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-dateFieldIndet/sgb-dateFieldIndet.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                minDate: '@',
                maxDate: '@',
                nonFuture: '@',
                indeterminateDescription: '@',
                indeterminateValue: '@'
            },
            controller: SgbDateFieldIndetController,
            controllerAs: 'dateIndetCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbDateFieldIndetController($timeout, $filter) {
            
            var vm = this;
            vm.indeterminateCheck = false;
            
            vm.toggleIndeterminateValue = toggleIndeterminateValue;
            
            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);
            
            function onInit() {
                if (vm.indeterminateValue != null) {
                    vm.indeterminateCheck = (vm.model === vm.indeterminateValue);
                }
            }
            
            function toggleIndeterminateValue() {
                if (vm.model === vm.indeterminateValue) {
                    vm.model = $filter('date')(new Date(), 'dd/MM/yyyy');
                    $timeout(function() { vm.model = null; });
                    vm.indeterminateCheck = false;
                }
                else {
                    vm.model = vm.indeterminateValue;
                    vm.indeterminateCheck = true;
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbDateField', sgbDateField);

    /** @ngInject */
    function sgbDateField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-dateField/sgb-dateField.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                minDate: '@',
                maxDate: '@',
                nonFuture: '@'
            },
            controller: SgbDateFieldController,
            controllerAs: 'dateCtrl'
        };

        return directive;

        /** @ngInject */
        function SgbDateFieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbCurrencyField', sgbCurrencyField);

    /** @ngInject */
    function sgbCurrencyField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-currencyField/sgb-currencyField.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '='
            },
            controller: sgbCurrencyFieldController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function sgbCurrencyFieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbComplexField', sgbComplexField);

    /** @ngInject */
    function sgbComplexField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-complexField/sgb-complexField.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                info: '='
            },
            controller: SgbComplexFieldController,
            controllerAs: 'cplxField'
        };

        return directive;

        /** @ngInject */
        function SgbComplexFieldController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbCheckbox', sgbCheckbox);

    /** @ngInject */
    function sgbCheckbox() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-checkbox/sgb-checkbox.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                isReadonly: '@'
            },
            controller: SgbCheckboxController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbCheckboxController() {
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbCalculatedField', sgbCalculatedField);

    /** @ngInject */
    function sgbCalculatedField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-calculatedField/sgb-calculatedField.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                model: '=',
                calcModel: '=',
                calc: '@'
            },
            controller: SgbCalculatedFieldController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function SgbCalculatedFieldController($scope) {
            var vm = this;
            vm.doCalculation = doCalculation;
            
            function doCalculation() {
                return $scope.$eval(vm.calc, {'sum': sum});
            }
            
            function sum(array, property) {
                var result = 0;
                if (angular.isString(array) && angular.isArray(vm.calcModel[array])) {
                    for (var i = 0; i < vm.calcModel[array].length; i++) {
                        var arrayItem = vm.calcModel[array][i];
                        if (angular.isObject(arrayItem) && property)
                            result += arrayItem[property] * 1;
                    }
                }
                else if (angular.isArray(array)) {
                    for (var j = 0; j < array.length; j++) {
                        var item = array[j];
                        if (angular.isNumber(item))
                            result += item;
                        else if (angular.isString(item))
                            result += (vm.calcModel[item] ? vm.calcModel[item] * 1 : 0);
                    }
                }
                return result;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('sgbBudget', sgbBudget);

    /** @ngInject */
    function sgbBudget() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sgb-budget/sgb-budget.html',
            scope: {},
            bindToController: {
                label: '@',
                help: '@',
                hideDescriptions: '@',
                model: '=',
                type: '@'
            },
            controller: SgbBudgetController,
            controllerAs: 'bdgt'
        };

        return directive;

        /** @ngInject */
        function SgbBudgetController($timeout) {
            var vm = this;
            vm.selectValues = {};

            vm.getTotal = getTotal;
            vm.getChoices = getChoices;
            vm.updateImporto = updateImporto;

            //vm.$onInit = onInit; // per angular 1.5
            $timeout(onInit);

            function onInit() {
                if (vm.model) {
                    for (var i = 0; i < vm.model.length; i++) {
                        var row = vm.model[i];
                        if (row.tipo == 'IMPORTO_FISSO') {
                            if (row.finanziamentoRichiesto)
                                vm.selectValues[row.id] = ((row.finanziamentoRichiesto * 1) / row.importo) + '';
                            else
                                vm.selectValues[row.id] = '0';

                        }
                        if (vm.type === 'pnrr'){
                            if (!row.eventualeCoFinanziamento){
                                row.eventualeCoFinanziamento = '0';
                            }

                        }
                    }
                }
            }

            function getTotal(rows) {
                var result = 0;
                if (rows && rows.length) {
                    for (var i = 0; i < rows.length; i++) {
                        result += rows[i].finanziamentoRichiesto * 1;

                    }
                }
                return result;
            }

            function getChoices(row) {
                var choices = [];
                for (var i = row.min; i <= row.max; i++)
                    choices.push(i + '');
                return choices;
            }

            function updateImporto($item, row) {
                var importo  = $item * 1 * row.importo;
                row.finanziamentoRichiesto = importo;
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .factory('RestApiInterceptor', RestApiInterceptor);

    /** @ngInject */
    function RestApiInterceptor(Constants, UserData, $q, $rootScope) {

        return {
            'request': function (config) {
                if (config.url.indexOf(Constants.restApiRoot) == 0) {
                    if (UserData.getLanguage())
                        config.headers['Accept-Language'] = UserData.getLanguage();
                    else
                        config.headers['Accept-Language'] = 'it';
                    config.headers['Client-Id'] = Constants.clientId;
                    if (UserData.getToken()) {
                        config.headers['User-Id'] = UserData.getUserId();
                        config.headers['Authorization'] = UserData.getToken();
                    }
                }
                return config;
            },

            'requestError': function (rejection) {
                return $q.reject(rejection);
            },

            'response': function (response) {
                return response;
            },

            'responseError': function (rejection) {
                if (rejection.data && rejection.data.code) {
                    switch (rejection.data.code) {
                        case 11:
                            //case 31:
                            $rootScope.$broadcast("sigeba.invalidUser");
                            break;
                    }
                }
                /*              if(rejection.data && rejection.data.code) {

                                  switch(rejection.data.code) {
                                      case 11:
                                          $rootScope.$broadcast("InvalidUser");
                                          break;
                                  }
                              }

                              if(rejection.status <= 0)
                                  $rootScope.$broadcast("ConnectionRefused");
              */
                return $q.reject(rejection);
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('profiloUtente', profiloUtente);

    /** @ngInject */
    function profiloUtente() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/profiloUtente/profiloUtente.html',
            scope: {},
            bindToController: {
                utenteId: '=?'
            },
            controller: ProfiloUtenteController,
            controllerAs: 'profiloCtrl'
        };

        return directive;

        /** @ngInject */
        function ProfiloUtenteController(AuthService, ProfiloUtenteService, DipartimentiService, AreecunService, $log, ngDialog) {
            var vm = this;

            vm.selectedMacroarea = null;
            vm.dipartimenti = null;
            vm.areeCun = null;
            vm.salvato = false;

            vm.updateProfilo = updateProfilo;
            vm.aggiornaUgov = aggiornaUgov;
            //vm.isAvvioRicerca = isAvvioRicerca;
            vm.isSpecializzando = isSpecializzando;
            vm.isAssegnista = isAssegnista;
            vm.onSelectDipartimento = onSelectDipartimento;

            /// Congedo
            vm.validCongedo = false
            vm.congedoSuccess = false;
            vm.indicatoreA = 0
            vm.indicatoreBC = null
            vm.alertA = null
            vm.alertBC = null
            vm.email = null
            vm.affiliazione = '';
            vm.maxLengthSize = 250;
            var alertRequired = { label: 'Questo campo di testo è obbligatorio.' }
            var alertMaxChar = { label: 'Il campo non puo superare i ' + vm.maxLengthSize + ' caratteri di lunghezza.' }
            vm.confirmCongedo = confirmCongedo;
            vm.confirmDatiEsterno = confirmDatiEsterno;
            vm.validateNumber = validateNumber;
            vm.validateString = validateString;
            vm.debounceValidate = debounceValidate;
            vm.remainingChars = 0;
            vm.countRemainingChars = countRemainingChars;



            getDatiProfilo()
                .then(getDipartimenti)
                .then(getAreeCun)
                .then(getCongedo)
                .then(getMesiCongedoInseriti)
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati del profilo", error);
                });


            function countRemainingChars(){
                vm.remainingChars = vm.affiliazione ? vm.maxLengthSize - vm.affiliazione.length : vm.maxLengthSize;
                vm.validateString();
            }

            function debounceValidate() {
                debounce( validateString, 250 )
            }

            function validateString() {
                var str = vm.affiliazione
                var baseMax = vm.maxLengthSize

                    vm.remainingChars = baseMax - str.length
                    if ( str.length > baseMax ) {
                        vm.alert = alertMaxChar
                    } else {
                        vm.alert = false
                    }

            }

            function getDatiProfilo() {
                if (angular.isUndefined(vm.utenteId)) {
                    vm.utenteId = AuthService.getUserId();
                }
                return ProfiloUtenteService.getProfilo(vm.utenteId)
                    .then(function(resultData) {
                        vm.data = resultData;
                        vm.email = resultData.utente.email;
                        vm.affiliazione = resultData.affiliazione || '';
                        if (vm.data['dataTermineRapporto'] !== null && vm.data['dataTermineRapporto'] === "02/02/2222")
                            vm.data['dataTermineRapporto'] = 'Tempo Indeterminato';
                        vm.editData = {
                            utenteInternoId: vm.utenteId,
                            titoloStudioTerzoLivello: null,
                            dipartimentoId: null,
                            areaId: null,
                            tipoSapienza: null
                        };
                        vm.countRemainingChars();
                    });
            }

            function getDipartimenti() {
                if (vm.data.dipartimento === null) {
                    return DipartimentiService.getDipartimenti()
                        .then(function(resultData) {
                            vm.dipartimenti = resultData;
                        });
                }
            }

            function getAreeCun() {
                if (vm.data.areaCun === null) {
                    return AreecunService.getAreeCun()
                        .then(function(resultData) {
                            vm.areeCun = resultData;
                        });
                }
            }

            function getCongedo() {
                if (angular.isUndefined(vm.utenteId)) {
                    vm.utenteId = AuthService.getUserId();
                }
                return ProfiloUtenteService.checkPermessiCongedo( vm.utenteId )
                    .then(function(data) {
                        vm.stateCongedo = data.data
                    });
            }

            function getMesiCongedoInseriti() {
                if (angular.isUndefined(vm.utenteId)) {
                    vm.utenteId = AuthService.getUserId();
                }
                return ProfiloUtenteService.getMesiCongedo(vm.utenteId)
                    .then(function(resultData) {
                        vm.indicatoreA = resultData.mesiCongedoA
                        vm.indicatoreBC = resultData.mesiCongedoBC
                        if ( resultData.mesiCongedoA && resultData.mesiCongedoBC ) {
                            vm.congedoSuccess = true
                        }
                    });
            }

            function confirmCongedo() {
                ProfiloUtenteService.mesiCongedo( vm.utenteId, vm.indicatoreA, vm.indicatoreBC )
                    .then(function(resultData) {
                        vm.congedoSuccess = true
                    })
                    .catch( function(err){
                        $log.error(err)
                    })
            }

            function confirmDatiEsterno() {
                ProfiloUtenteService.datiEsterno( vm.utenteId, vm.email, vm.affiliazione )
                    .then(function(resultData) {
                        $log.log('profilo utente modificato con successo');
                        vm.data = null;
                        vm.editData = null;
                        vm.salvato = true;
                        AuthService.refreshUserInfo()
                            .then(getDatiProfilo)
                            .catch(function(error) {
                                $log.error("Errore nel reperimento dei dati del profilo", error);
                            });
                    });
            }

            function updateProfilo() {
                ProfiloUtenteService.updateProfilo(vm.utenteId, vm.editData)
                    .then(function() {
                        $log.log('profilo utente modificato con successo');
                        vm.data = null;
                        vm.editData = null;
                        vm.salvato = true;
                        AuthService.refreshUserInfo()
                            .then(getDatiProfilo)
                            .catch(function(error) {
                                $log.error("Errore nel reperimento dei dati del profilo", error);
                            });
                    });
            }

            function aggiornaUgov() {
                vm.data = null;
                ProfiloUtenteService.updateUgov(vm.utenteId)
                    .then(function(resultData) {
                        $log.log('profilo aggiornato da ugov con successo');
                        vm.data = resultData;
                    })
                    .catch(function(error) {
                        showErrorDialog(error.data.message);
                        AuthService.refreshUserInfo()
                            .then(getDatiProfilo)
                            .catch(function(error) {
                                $log.error("Errore nel reperimento dei dati del profilo", error);
                            });
                    });
            }
            /*
            function isAvvioRicerca(ruolo) {
                if (ruolo.codice == 'DR' || ruolo.codice == 'SP' || ruolo.codice == 'AR')
                    return true;
                return false;
            }
            */

            function validateNumber(){
                var max = 24; var min = 0;
                var _a = vm.indicatoreA; var _bc = vm.indicatoreBC;

                if ( _a > max ) vm.indicatoreA = max
                if ( _a < min ) vm.indicatoreA = min
                if ( _bc > max ) vm.indicatoreBC = max
                if ( _bc < min ) vm.indicatoreBC = min

                vm.congedoSuccess = false
            }

            function isSpecializzando(ruolo) {
                if (ruolo.codice == 'SP')
                    return true;
                return false;
            }

            function isAssegnista(ruolo) {
                if (ruolo.codice == 'AR')
                    return true;
                return false;
            }

            function onSelectDipartimento(dipartimento) {
                vm.selectedMacroarea = dipartimento.macroArea.code + ' - ' + dipartimento.macroArea.nome;
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Aggiornamento non riuscito</h3><div class="alert alert-danger"><b>Non &egrave; stato possibile aggiornare il profilo da UGOV a causa del seguente errore:</b><br /><br />{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('modaleTerzaMissione', modaleTerzaMissione);

    /** @ngInject */
    function modaleTerzaMissione() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/modaleTerzaMissione/modaleTerzaMissione.html',
            scope: {},
            bindToController: {
                confirm: '=',
                cancel: '=',
                proposta: '=',
                valutazione: '='
            },
            controller: modaleTerzaMissioneController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function modaleTerzaMissioneController() {

            var vm = this

            vm.valid = false
            vm.validita = false


            vm.set = {
                "valoreDatoProposta": null,
                "valoreNota": null,
                "valori": [
                    { "id": "Yes", "valore": "Si" },
                    { "id": "No", "valore": "No" }
                ]
            }

            vm.handleSuccess = handleSuccess
            vm.handleClose = handleClose

            onMount()
            function onMount() {
                console.log("VALUTAZIONE!!!!", vm.valutazione);
                var rend = vm.valutazione.rendicontazione.valutazioneRend
                //var valid =
                var now = Date.now();
                vm.validita = vm.valutazione.rendicontazione.consolida === false && (now >= vm.valutazione.startTimestamp && now <= vm.valutazione.endTimestamp);
                if ( rend != null ) {
                    vm.set.valoreDatoProposta = rend == 'true' ? 'Si' : 'No'
                }
                vm.set.valoreNota = vm.valutazione.rendicontazione.notaValutazioneRend;
            }

            function handleSuccess( concludi ) {
                var options = {
                    id: vm.valutazione.rendicontazione.id,
                    value: vm.set.valoreDatoProposta == 'Si' ? true : false,
                    nota: vm.set.valoreNota,
                    consolido: concludi
                }
                vm.confirm( options )
            }

            function handleClose( data ) {
                vm.cancel( data )
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaRendicontazioni', listaRendicontazioni);

    /** @ngInject */
    function listaRendicontazioni() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaRendicontazioni/listaRendicontazioni.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaRendicontazioniController,
            controllerAs: 'rendListCtrl'
        };

        return directive;

        /** @ngInject */
        function ListaRendicontazioniController(ProposteService, RendicontazioniService, ngDialog, $log, $state, $window) {
            var vm = this;
            
            vm.anno = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.rendProgetti = null;
            
            vm.now = null;
            
            vm.getRendicontazioni = getRendicontazioni;
            vm.openPropostaView = openPropostaView;
            vm.openRendicontazione = openRendicontazione;
            vm.openRendicontazioneView = openRendicontazioneView;
            vm.newRendicontazione = newRendicontazione;
            vm.eliminaRendicontazione = eliminaRendicontazione;
            vm.getStatusRendicontazioneClass = getStatusRendicontazioneClass;
            
            
            var storageName = "listaRendicontazioni-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};
            
            getAnni()
                .then(getRendicontazioni)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle rendicontazioni", error);
                });
            
            function getAnni() {
                return ProposteService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = { anno: vm.anno };
                            else {
                                var anno = data.filter(function(anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];
                                
                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }
            
            function getRendicontazioni() {
                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    anno: vm.selectedAnno
                });
                vm.rendProgetti = null;
                
                return ProposteService.getProposteFinanziate(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.rendProgetti = data;
                        vm.now = (new Date()).getTime();
                    });
            }
            
            function openPropostaView(proposta) {
                $state.go('propostaView', {'id': proposta.id});
            }
            
            function openRendicontazione(rendicontazioneId) {
                $state.go('rendicontazioneDetail', {'id': rendicontazioneId});
            }
            
            function openRendicontazioneView(rendicontazioneId) {
                $state.go('rendicontazioneView', {'id': rendicontazioneId});
            }
            
            function newRendicontazione(propostaId, stepId) {
                $state.go('newRendicontazione', {'proposta': propostaId, 'step': stepId});
            }
            
            function eliminaRendicontazione(rendicontazione) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la bozza di rendicontazione?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        var dialog = showDeletingDialog();
                        RendicontazioniService.deleteRendicontazione(rendicontazione)
                        .then(function(resultData) { //eslint-disable-line no-unused-vars
                            getRendicontazioni();
                            dialog.close();
                        });
                    }
                });
            }
            
            function showDeletingDialog() {
                var dialog = ngDialog.open({
                    template:'Eliminazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function getStatusRendicontazioneClass(progetto) {
                if (progetto.stepRendicontazione.length > 0) {
                    for (var i = progetto.stepRendicontazione.length - 1; i >= 0; i--) {
                        var step = progetto.stepRendicontazione[i];
                        if (step.rendicontazione && step.rendicontazione.status === 'INVIATA')
                            return 'sent';
                        else if (step.endTimestamp != null && step.endTimestamp < vm.now && (step.rendicontazione === null || step.rendicontazione.status != 'INVIATA'))
                            return 'missed';
                        else if (step.startTimestamp != null && step.startTimestamp < vm.now && step.endTimestamp != null && step.endTimestamp > vm.now && (step.rendicontazione === null || step.rendicontazione.status != 'INVIATA'))
                            return 'open';
                    }
                }
                return '';
            }
            
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaRadStrutture', listaRadStrutture);

    /** @ngInject */
    function listaRadStrutture() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaRadStrutture/listaRadStrutture.html',
            scope: {},
            bindToController: {
            },
            controller: listaRadStruttureController,
            controllerAs: 'listaRadStruttureCtrl'
        };

        return directive;

        /** @ngInject */
        function listaRadStruttureController(StruttureUrService, ngDialog, $log) {
            var vm = this;

            vm.strutture = null;
            vm.isLoading = false;
            vm.editRadStruttura = editRadStruttura;

            getStrutture()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle strutture", error);
                });

            function getStrutture() {
                //vm.strutture = null;
                vm.isLoading = true;
                return StruttureUrService.getStrutture()
                    .then(function(data) {
                        vm.strutture = data;
                        vm.isLoading = false;
                    });
            }

            function editRadStruttura(strutturaId) {
                if (vm.isLoading)
                    return;
                var dialog = ngDialog.openConfirm({
                    template:'\
                        <edit-rad-struttura struttura-id="ngDialogData.strId" confirm="confirm" cancel="closeThisDialog"></edit-rad-struttura>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        strId: strutturaId
                    }
                });

                dialog.then(function (data) {
                    if (data === true) {
                        getStrutture()
                            .catch(function(error) {
                                $log.error("Errore nel reperimento delle informazioni sulle strutture", error);
                            });
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaRad', listaRad);

    /** @ngInject */
    function listaRad() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaRad/listaRad.html',
            scope: {},
            bindToController: {},
            controller: listaRadController,
            controllerAs: 'listaRadCtrl'
        };

        return directive;

        /** @ngInject */
        function listaRadController(DipartimentiUrService, ngDialog, $log) {
            var vm = this;

            vm.dipartimenti = null;
            vm.isLoading = false;
            vm.editRadDipartimento = editRadDipartimento;
            vm.editDirettoreDipartimento = editDirettoreDipartimento;
            vm.editRefeereDipartimento = editRefeereDipartimento;

            getDipartimenti()
                .catch(function (error) {
                    $log.error("Errore nel reperimento delle informazioni sui dipartimenti", error);
                });

            function getDipartimenti() {
                //vm.dipartimenti = null;
                vm.isLoading = true;
                return DipartimentiUrService.getDipartimenti()
                    .then(function (data) {
                        vm.dipartimenti = data;
                        vm.isLoading = false;
                    });
            }

            function editRadDipartimento(dipartimentoId) {
                if (vm.isLoading)
                    return;
                var dialog = ngDialog.openConfirm({
                    template: '\
                        <edit-rad-dipartimento dipartimento-id="ngDialogData.dipId" confirm="confirm" cancel="closeThisDialog"></edit-rad-dipartimento>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        dipId: dipartimentoId
                    }
                });

                dialog.then(function (data) {
                    if (data === true) {
                        getDipartimenti()
                            .catch(function (error) {
                                $log.error("Errore nel reperimento delle informazioni sui dipartimenti", error);
                            });
                    }
                });
            }

            function editDirettoreDipartimento(dipartimentoId) {
                if (vm.isLoading)
                    return;
                var dialog = ngDialog.openConfirm({
                    template: '\
                        <edit-direttore-dipartimento dipartimento-id="ngDialogData.dipId" confirm="confirm" cancel="closeThisDialog"></edit-direttore-dipartimento>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        dipId: dipartimentoId
                    }
                });

                dialog.then(function (data) {
                    if (data === true) {
                        getDipartimenti()
                            .catch(function (error) {
                                $log.error("Errore nel reperimento delle informazioni sui dipartimenti", error);
                            });
                    }
                });
            }

            function editRefeereDipartimento(dipartimentoId) {
                if (vm.isLoading)
                    return;
                var dialog = ngDialog.openConfirm({
                    template: '\
                        <edit-referee-dipartimento dipartimento-id="ngDialogData.dipId" confirm="confirm" cancel="closeThisDialog"></edit-referee-dipartimento>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        dipId: dipartimentoId
                    }
                });

                dialog.then(function (data) {
                    if (data === true) {
                        getDipartimenti()
                            .catch(function (error) {
                                $log.error("Errore nel reperimento delle informazioni sui dipartimenti", error);
                            });
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaProposte', listaProposte);

    /** @ngInject */
    function listaProposte() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaProposte/listaProposte.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaProposteController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaProposteController($timeout, ProposteService, RichiestePartecipazioneService, $log, $state, $q, $window, ngDialog) {
            var vm = this;

            vm.anno = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.proposte = null;
            vm.richieste = null;

            vm.getProposteERichieste = getProposteERichieste;
            vm.eliminaProposta = eliminaProposta;
            vm.openProposta = openProposta;
            vm.openPropostaView = openPropostaView;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatus = getStatus;
            vm.accettaPartecipazione = accettaPartecipazione;
            vm.rifiutaPartecipazione = rifiutaPartecipazione;
            vm.visualizzaAbstract = visualizzaAbstract;
            vm.showValutazione = showValutazione;
            vm.mostraCommentoFinanziamento = mostraCommentoFinanziamento;
            vm.showDettagliEsito = showDettagliEsito;
            vm.openIndicatori = openIndicatori;

            var storageName = "listaProposte-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            getAnni()
                .then(getProposteERichieste)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle proposte", error);
                });

            function getAnni() {
                return ProposteService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = { anno: vm.anno };
                            else {
                                var anno = data.filter(function(anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];

                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }

            function getProposteERichieste() {
                vm.proposte = null;
                vm.richieste = null;
                var promises = [getProposte()];
                if (vm.selectedAnno.anno == vm.anni[0].anno)
                    promises.push(getRichieste());
                else
                    vm.richieste = [];

                return $q.all(promises);
            }

            function getRichieste() {
                return RichiestePartecipazioneService.getRichiestePartecipazione()
                    .then(function(data) {
                        vm.richieste = data;
                    });
            }

            function getProposte() {
                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    anno: vm.selectedAnno
                });
                return ProposteService.getProposte(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.proposte = data;
                    });
            }

            function eliminaProposta(proposta) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la bozza di proposta?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        var dialog = showDeletingDialog();
                        ProposteService.deleteProposta(proposta)
                        .then(function(resultData) { //eslint-disable-line no-unused-vars
                            for (var i = 0; i < vm.proposte.length; i++) {
                                if (vm.proposte[i].id == proposta.id) {
                                    vm.proposte.splice(i, 1);
                                    dialog.close();
                                    break;
                                }
                            }
                        });
                    }
                });
            }

            function openProposta(proposta) {
                if (proposta.isResponsabile)
                $timeout(function(){
                    $state.go('propostaDetail', {'id': proposta.id});
                },100)
                else if (proposta.categoriaUtente == 'Tutor di riferimento' || proposta.categoriaUtenteDescrizione === 'Componenti' || proposta.categoriaUtenteDescrizione === 'Dottorandi/Assegnisti/Specializzandi componenti')
                    return;
                else
                    $timeout(function(){
                        $state.go('propostaFormPartecipante', {'id': proposta.id});
                    },100)
            }

            function openPropostaView(proposta) {
                $timeout(function(){
                    $state.go('propostaView', {'id': proposta.id});
                },100)
            }

            function getStatusClass(proposta) {
                if (proposta.esito && proposta.esito.status == 'FINANZIATA')
                    return 'accepted';
                if (proposta.esito && proposta.esito.status == 'NON_FINANZIATA')
                    return 'rejected';
                if (proposta.status == 'INVIATA')
                    return 'sent';
                return '';
            }

            function getStatusIcon(proposta) {
                if (proposta.status == 'BOZZA')
                    return 'fa-pencil-square-o';
                if (proposta.esito && proposta.esito.status == 'FINANZIATA')
                    return 'fa-thumbs-o-up';
                if (proposta.esito && proposta.esito.status == 'NON_FINANZIATA')
                    return 'fa-thumbs-o-down';
                if (proposta.status == 'INVIATA')
                    return 'fa-sign-out';
                return '';
            }

            function getStatus(proposta) {
                if (proposta.status == 'BOZZA')
                    return 'Bozza';
                if (proposta.esito && proposta.esito.status == 'FINANZIATA')
                    return 'Finanziata';
                if (proposta.esito && proposta.esito.status == 'NON_FINANZIATA')
                    return 'Non finanziata';
                if (proposta.status == 'INVIATA')
                    return 'Inviata';
                return '';
            }

            function accettaPartecipazione(richiesta) {
                var dialogTemplate = '\
                        <h3>Accetta partecipazione</h3>\
                        <p class="alert alert-warning">Accettando la partecipazione a questo progetto potrebbe non essere possibile partecipare ad altri progetti per quest\'anno (vedi le condizioni del bando).</p>\
                        <p>Vuoi accettare la partecipazione al progetto?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>';

                if (richiesta.categoria.descrizioneSingolare == 'Tutor di riferimento') {
                    dialogTemplate = '\
                        <h3>Accetta tutoraggio</h3>\
                        <p>Vuoi accettare di essere il Tutor di riferimento per il progetto?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>';
                }

                var confirmDialog = ngDialog.openConfirm({
                    template: dialogTemplate,
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        RichiestePartecipazioneService.accettaRichiestaPartecipazione(richiesta.proposta.id)
                            .then(getProposteERichieste)
                            .catch(function(error) {
                                $log.error("Errore nell'accettazione della richiesta di partecipazione", error);
                                if (error && error.data && error.data.code == 91)
                                    showErrorDialog(error.data.message);
                                else
                                    showGenericErrorDialog();
                            });
                    }
                });
            }

            function rifiutaPartecipazione(richiesta) {
                var dialogTemplate = '\
                        <h3>Rifiuta partecipazione</h3>\
                        <p>Vuoi rifiutare la partecipazione al progetto?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>';

                if (richiesta.categoria.descrizioneSingolare == 'Tutor di riferimento') {
                    dialogTemplate = '\
                        <h3>Rifiuta tutoraggio</h3>\
                        <p>Vuoi rifiutare di essere il Tutor di riferimento per il progetto di Avvio alla ricerca?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>';
                }

                var confirmDialog = ngDialog.openConfirm({
                    template: dialogTemplate,
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        RichiestePartecipazioneService.rifiutaRichiestaPartecipazione(richiesta.proposta.id)
                            .then(function() {
                                for (var i = 0; i < vm.richieste.length; i++) {
                                    if (vm.richieste[i].proposta.id == richiesta.proposta.id) {
                                        vm.richieste.splice(i, 1);
                                        break;
                                    }
                                }
                            })
                            .catch(function(error) {
                                $log.error("Errore nel rifiuto della richiesta di partecipazione", error);
                                showGenericErrorDialog();
                            });
                    }
                });
            }

            function visualizzaAbstract(richiesta) {
                ngDialog.open({
                    template:'\
                        <h3>Abstract</h3>\
                        <p class="well" style="white-space: pre-wrap;">{{ngDialogData.datiRichiesta.abstractProposta ? ngDialogData.datiRichiesta.abstractProposta : \'&lt;progetto senza abstract&gt;\'}}</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-showAbstract',
                    data: {
                        datiRichiesta: richiesta
                    }
                });
            }

            function showDeletingDialog() {
                var dialog = ngDialog.open({
                    template:'Eliminazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Impossibile accettare la richiesta</h3><div class="well"><b>Non è possibile completare l\'operazione poiché altrimenti verrebbero violate le condizioni imposte dal bando.</b>' +
                                '<br />Probabilmente risulti già proponente o componente di altre proposte incompatibili con questa.<br />Se vuoi accettare questa richiesta devi prima eliminare la tua partecipazione ai progetti incompatibili.</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }

            function showGenericErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Provare a ricaricare la pagina ed eseguire nuovamente l\'operazione.<br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }

            function showValutazione(proposta, valutazione) {
                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" is-user="true" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? valutazione.id : null
                    }
                });
            }

            function mostraCommentoFinanziamento(commento) {
                ngDialog.open({
                    template:'\
                        <h3 class="title">Commento</h3>\
                        <div class="well">{{ngDialogData.commento}}</div>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        commento: commento
                    }
                });
            }

            function showDettagliEsito(proposta) {
                ngDialog.open({
                    template:'\
                        <dettagli-esito proposta="ngDialogData.proposta"></dettagli-esito>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        proposta: proposta
                    }
                });
            }

            function openIndicatori(proposta) {
                ngDialog.open({
                    template:'<indicatori-val-prop proposta="ngDialogData.proposta"></indicatori-val-prop>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-indicatoriValProp',
                    data: {
                        proposta: proposta
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaIstanzeUser', listaProposte);

    /** @ngInject */
    function listaProposte() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaIstanzeUser/listaIstanzeUser.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaProposteController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaProposteController(ProposteService, $log, $state, ngDialog, AuthService, Constants, UserData) {

            var vm = this;

            vm.proposte = null;
            vm.loading = null;

            vm.eliminaProposta = eliminaProposta;
            vm.openProposta = openProposta;
            vm.goToPropostaEdit = goToPropostaEdit;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatus = getStatus;
            vm.openValutazioneIstanza = openValutazioneIstanza
            vm.creaNuovaProposta = creaNuovaProposta
            vm.downloadDelibera = downloadDelibera

            var role = AuthService.getUserInfo().utente.tipoUtente;
            vm.loggedUser = (AuthService.getUserInfo() ? AuthService.getUserInfo() : null);

            loadProposteCert()

            function loadProposteCert() {
                vm.loading = true
                ProposteService.getProposteCert()
                    .then(function(data) {
                        vm.proposte = data
                        vm.loading = false
                    }).catch(function(error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog( "Errore durante il recupero dei dati" )
                        vm.loading = false
                    });

            }

            function creaNuovaProposta() {

                vm.loading = true
                ProposteService.getFormularioCertById()
                .then( function (data) {
                    vm.goToPropostaEdit(data.id)
                }).catch( function (error) {
                    $log.error("Error getFormularioCertById", error);
                    vm.loading = false
                });
            }

            function goToPropostaEdit(id) {
                vm.loading = true
                var detailPath = ( role == 'UFFICIO_CERT' ) ? 'istanzeCertDetail' : 'propostaCertDetail'
                setTimeout(function(){
                    $state.go(detailPath, {'id': id })
                },100)
            }

            function downloadDelibera(mediaId) {
                if (mediaId)
                    return Constants.restApiRoot + "/media/" + mediaId + "/propostaCert?token=" + UserData.getToken();
                else
                    return null;
            }

            function eliminaProposta(id) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la bozza di proposta?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        var dialog = showDeletingDialog();
                        ProposteService.deletePropostaCert(id)
                        .then( function (data) {
                            dialog.close();
                            loadProposteCert()
                        }).catch( function (error) {
                            $log.error("Error getFormularioCertById", error);
                            dialog.close();
                        });
                    }
                });
            }

            function openProposta(id) {
                vm.loading = true
                var detailPath = ( role == 'UFFICIO_CERT' ) ? 'propostaCertViewUc' : 'propostaCertView'
                setTimeout(function(){
                    $state.go(detailPath, {'id': id })
                },100)
            }

            function getStatusClass(proposta) {

                if ( !proposta.stato || proposta.stato.codice == 1 )
                    return ''
                if ( proposta.stato.codice == 4  )
                    return 'revisioni'; // Arancione
                if ( proposta.stato.codice == 5 || proposta.stato.codice == 7  )
                    return 'rejected'; // Rosso
                if ( proposta.stato.codice == 2 || proposta.stato.codice == 3 )
                    return 'accepted'; // Verde
                if ( proposta.stato.codice == 6 )
                    return 'sent'; // Giallo

            }

            function getStatusIcon(proposta) {

                if ( !proposta.stato || proposta.stato.codice == 1 )
                    return 'fa-square-o'
                if ( proposta.stato.codice == 4 || proposta.stato.codice == 5 || proposta.stato.codice == 7 )
                    return 'fa-thumbs-o-down';
                if ( proposta.stato.codice == 2 || proposta.stato.codice == 3  )
                    return 'fa-thumbs-o-up';
                if ( proposta.stato.codice == 6 )
                    return 'fa-pencil-square-o';
            }

            function getStatus(proposta) {

                if ( proposta.stato.codice == 1 )
                    return 'Bozza';
                if ( proposta.stato.codice == 2 )
                    return 'Approvata';
                if ( proposta.stato.codice == 3 )
                    return 'Con condizione';
                if ( proposta.stato.codice == 4 )
                    return 'Richiesta revisioni';
                if ( proposta.stato.codice == 5 )
                    return 'Non approvata';
                if ( proposta.stato.codice == 6 )
                    return 'Inviata';
                if ( proposta.stato.codice == 7 )
                    return 'Non valutabile';

                return '';
            }

            function showDeletingDialog() {
                var dialog = ngDialog.open({
                    template:'Eliminazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function showGenericErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Provare a ricaricare la pagina ed eseguire nuovamente l\'operazione.<br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }

            function openValutazioneIstanza( id ) {

                // console.log(id)

                var valutaionItem = {
                    valutation: "a1",
                    valutationNotes: "b2"
                }

                var confirmDialog = ngDialog.openConfirm({
                    template:'<view-notes-istanza-user item="ngDialogData.item" confirm="confirm" cancel="closeThisDialog"></view-notes-istanza-user>',
                    plain: true,
                    data: {
                        item: valutaionItem
                    }
                })

                confirmDialog.then(function (data) {
                    // console.log("Salva Valutazione", data)
                })

            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaIstanze', listaIstanze);

    /** @ngInject */
    function listaIstanze() {
        var directive = {
            restrict: 'E',
            require: 'ngModel',
            templateUrl: 'app/components/listaIstanze/listaIstanze.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaIstanzeController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaIstanzeController(ProposteService, $log, $window, ngDialog, $state, $httpParamSerializer, UserData, AuthService, Constants) {

            var vm = this;
            vm.loggedUser = AuthService.getUserInfo().utente

            var storageName = "archivioIstanze-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            vm.anno = null;
            vm.anni = null;
            vm.selectedAnno = null;
            vm.proposte = null;
            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;
            vm.selectedStatusValutazione = oldFilter.statusValutazione ? oldFilter.statusValutazione : 'ALL';
            vm.gettingList = false;

            var utente = AuthService.getUserInfo().utente;
            vm.isPresidente = utente.presidenteCommissioneCert || utente.tipoUtente == "UFFICIO_CERT";
            vm.isCert = utente.tipoUtente == 'UFFICIO_CERT';


            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            vm.openIstanzaNotes = openIstanzaNotes;
            vm.openIstanza = openIstanza;
            vm.viewIstanza = viewIstanza;
            vm.getProposte = getProposte;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatus = getStatus;
            vm.showValutazione = showValutazione;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.getCsvExportUrlProposte = getCsvExportUrlProposte;
            vm.getLabelStatoValutazione = getLabelStatoValutazione
            vm.visibilitaValutazioneList = visibilitaValutazioneList
            vm.checkDownloadDelibera = checkDownloadDelibera
            vm.downloadDelibera = downloadDelibera
            vm.visibilitaNote = visibilitaNote
            vm.riapriIstanza = riapriIstanza;
            vm.openCommissioneTipologia = openCommissioneTipologia;
            vm.openFeedCompilati = openFeedCompilati;

            vm.hasValutazione = hasValutazione
            vm.hasNotes = hasNotes

            getProposte()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle proposte", error);
                })

            function hasValutazione( proposta ) {
                if (
                    proposta.stato.id == 2 ||
                    proposta.stato.id == 3 ||
                    proposta.stato.id == 4 ||
                    proposta.stato.id == 5
                ) { return true }
                return false
            }

            function hasNotes( proposta ) {
                var countNote = 0;
                for (var i = 0; i < proposta.membroProposta.length; i++) {
                    if (proposta.membroProposta[i].note)
                        countNote++;
                }

                // var noteMembriProposta = getNoteMembriProposta(proposta.id);
                if ( proposta.notaValutazione || countNote > 0) { return true }
                return false
            }

            function visibilitaValutazioneList(_proposta) {
                var pendingApproval = _proposta.stato.id == '6'
                var isPresidente = vm.loggedUser.presidenteCommissioneCert
                var isCert = vm.loggedUser.tipoUtente == 'UFFICIO_CERT'
                var isEsterno = vm.loggedUser.membroEsternoCommissioneCert
                var isInterno = vm.loggedUser.membroInternoCommissioneCert
                var isAssignedToLoggedUser = null
                var isValutata = _proposta.certSeduta != null;
                if ( _proposta.membroProposta && _proposta.membroProposta.length ) {
                    isAssignedToLoggedUser = _proposta.membroProposta.find( function( membro ) {
                        return ( membro.certMembroCommissione.id == vm.loggedUser.id )
                    })
                }

                var valutable = ( isAssignedToLoggedUser || ((isPresidente || isCert || isEsterno || isInterno) && isValutata))
                return ( pendingApproval && valutable ) ? true : false
            }

            function visibilitaNote() {
                //TODO attesa info per segreteria
                var isPresidente = vm.loggedUser.presidenteCommissioneCert
                var isCert = vm.loggedUser.tipoUtente == 'UFFICIO_CERT'
                var inCommissione = vm.loggedUser.membroInternoCommissioneCert;
                //se membro commissione allora return true
                return ( isPresidente || isCert || inCommissione) ? true : false
            }

            // Il file Delibera è possibile scaricarlo solo in Approvata, Approvata con condizione e non approvata
            function checkDownloadDelibera(stato) {
                return stato == '2' || stato == '3' || stato == '4' || stato == '5';
            }

            function downloadDelibera(mediaId) {
                if (mediaId)
                    return Constants.restApiRoot + "/media/" + mediaId + "/propostaCert?token=" + UserData.getToken();
                else
                    return null;
            }

            function getProposte(keepPagination) {

                vm.gettingList = true;

                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    anno: vm.selectedAnno,
                    cognome: vm.selectedCognome,
                    statusValutazione: vm.selectedStatusValutazione
                });

                vm.proposte = null;

                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione == 'ALL' ? 0 : vm.selectedStatusValutazione;
                }

                return ProposteService.getProposteCertValutazione(filter)
                    .then(function (data) {
                        var renderData = data.resultList
                        //
                        // if ( vm.selectedStatusValutazione != null && vm.selectedStatusValutazione != "ALL" ) {
                        //     renderData = renderData.filter( function( x ) { return x.stato.codice == vm.selectedStatusValutazione } )
                        // }

                        vm.proposte = renderData;
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                        vm.selectedStatusValutazione = filter.statusValutazione == 0 ? 'ALL' : filter.statusValutazione;

                        vm.gettingList = false;
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        showGenericErrorDialog("Errore durante il recupero dei dati");
                        vm.gettingList = false;
                    });
            }

            function viewIstanza(id) {
                vm.loading = true
                setTimeout(function(){
                    $state.go('propostaCertViewUc', {'id': id });
                },50)
            }

            function openIstanza(proposta) {

                var confirmDialog = ngDialog.openConfirm({
                    template: '<edit-status-istanza confirm="confirm" proposta="ngDialogData.proposta" cancel="closeThisDialog"></edit-status-istanza>',
                    plain: true,
                    data: {
                        proposta: proposta
                    }
                })

                confirmDialog.then(function (data) {
                    updateStatoProposta(data, proposta.id)
                })

            }

            function updateStatoProposta(data, id) {
                var savingDialog = null;
                var query = {
                    'propostaCertId': id,
                    'statoId': getStatoValutazione( data.valutation ),
                    'note': data.valutationNotes || null,
                    'noteComponenti': data.noteComponenti || null,
                    'notaRevisione': data.noteCambioStato || null,
                    'conflittoInteressi': data.conflittoInteressi || null,
                    'dataSeduta': data.dataSeduta || null,
                    'favorevoli': data.favorevoli || null,
                    'astenuti': data.astenuti || null,
                    'contrari': data.contrari || null,
                    'numeroDelibera': data.numeroDelibera || null,
                    'membriPropostaDTOList': data.membriCommissione || null,
                    'notePresidenteCert': data.notePresidenteCert || null
                }
                savingDialog = showSavingDialog();
                ProposteService.putUpdateStatoPropostaCert(query)
                .then(function (data) {

                    vm.proposte.forEach( function ( item, index ) {
                        if (  item.id == id ) {
                            vm.proposte[index].notaValutazione = query.note
                            vm.proposte[index].stato.id = query.statoId
                        }
                    })

                    getProposte()
                    savingDialog.close();
                    ngDialog.open({
                        template: '' +
                            '<div class="alert alert-success"><b>Operazione effettuata con successo.</b></div>',
                        plain: true,
                        showClose: true,
                        data: {}
                    });

                }).catch(function (error) {
                    $log.error("Error updatePropostaCert", error);
                    vm.loading = false
                    savingDialog.close();
                });
            }

            function updateNoteCert(datas) {
                var savingDialog = null;
                savingDialog = showSavingDialog();
                ProposteService.updateNoteCert(datas)
                    .then(function (data) {
                        getProposte()
                        savingDialog.close();
                        ngDialog.open({
                            template: '' +
                                '<div class="alert alert-success"><b>Operazione effettuata con successo.</b></div>',
                            plain: true,
                            showClose: true,
                            data: {}
                        });

                    }).catch(function (error) {
                    $log.error("Error updatePropostaCert", error);
                    vm.loading = false
                    savingDialog.close();
                });
            }

            function showSavingDialog() {
                return ngDialog.open({
                    template: 'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
            }

            function openIstanzaNotes( id ) {

                var valutaionItem;
                vm.proposte.forEach( function ( item, index ) {
                    if (  item.id == id ) {
                        valutaionItem = item
                    }
                })

                var confirmDialog = ngDialog.openConfirm({
                    template:'<edit-status-istanza-notes item="ngDialogData.item" proposta="ngDialogData.idProposta" confirm="confirm" cancel="closeThisDialog"></edit-status-istanza-notes>',
                    plain: true,
                    data: {
                        idProposta: id,
                        item: valutaionItem
                    }
                })

                confirmDialog.then(function (data) {
                    updateNoteCert(data);
                    // console.log("Salva Valutazione", data)
                })

            }

            function openCommissioneTipologia(membroPropostaList) {
                ngDialog.open({
                    template:'<commissione-tipologia-cert membri="ngDialogData.membri"></commissione-tipologia-cert>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-associatiDialog',
                    data: {
                        membri: membroPropostaList
                    }
                });
            }

            function openFeedCompilati(propostaIdCert) {
                ngDialog.open({
                    template:'<feed-compilati-cert proposta="ngDialogData.proposta"></feed-compilati-cert>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-associatiDialog',
                    data: {
                        proposta: propostaIdCert
                    }
                });
            }

            function getStatusClass(status) {

                if (status == '1')
                    return 'inBozza';
                if (status == '6')
                    return 'daValutare';
                if (status == '2' || status == '3')
                    return 'finanziata';
                if (status == '4')
                    return 'revisioni';
                if (status == '5' || status == '7')
                    return 'nonFinanziata';
                return 'nonValutata';
            }

            function getStatusIcon(status) {
                if (status == '1')
                    return 'fa-square-o';
                if (status == '2' || status == '3')
                    return 'fa-thumbs-o-up';
                if (status == '4' || status == '5')
                    return 'fa-thumbs-o-down';
                if (status == '6')
                    return 'fa-check-square-o';
                if (status == '7')
                    return 'fa-ban';
                return 'fa-square-o';
            }

            function getStatoValutazione( status ) {
                if ( status == 'APPROVATA' )
                    return 2;
                if ( status == 'APPROVATA_CONDIZIONE' )
                    return 3;
                if ( status == 'REVISIONE' )
                    return 4;
                if ( status == 'NON_APPROVATA' )
                    return 5;
            }

            function getStatus(status) {

                if (status == '1')
                    return 'In bozza';
                if (status == '2')
                    return 'Approvata';
                if (status == '3')
                    return 'Con condizione';
                if (status == '4')
                    return 'Richiesta revisioni';
                if (status == '5')
                    return 'Non approvata';
                if (status == '6')
                    return 'Da Valutare';
                if (status == '7')
                    return 'Non Valutabile';
                return 'Da valutare';
            }

            function getLabelStatoValutazione( status ) {
                if ( status == '2' )
                    return 'Approvata';
                if ( status == '3' )
                    return 'Approvata con condizione';
                if ( status == '4' )
                    return 'Richiesta Revisione';
                if ( status == '5' )
                    return 'Non Approvata';
                return '';
            }

            function showValutazione(proposta, valutazione) {

                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" is-ur="true" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? valutazione.id : null
                    }
                });
            }

            function resetFiltri() {

                vm.selectedCognome = "";

                getProposte();

            }

            function isFiltroAttivo() {
                var attivo = false;
                if(vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                return attivo;
            }

            function getCsvExportUrlProposte() {
                var filter = {'statoId': 7};
                filter.token = UserData.getToken();
                $window.open(ProposteService.getNonValutabili($httpParamSerializer(filter)));
                // return null;
            }

            function showGenericErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Provare a ricaricare la pagina ed eseguire nuovamente l\'operazione.<br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }

            function riapriIstanza(propostaId) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                            <h3>Conferma Riapertura</h3>\
                            <p>Vuoi riaprire l\'Istanza?</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                            </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        ProposteService.riapriPropostaCert(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        })
                            .catch(function (error) {
                                $log.error("Errore durante la riapertura della proposta", error);
                                showErrorDialog(error.data.message);
                            });
                    }
                });
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaDaRendicontare', listaDaRendicontare);

    /** @ngInject */
    function listaDaRendicontare() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaDaRendicontare/listaDaRendicontare.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaDaRendicontareController,
            controllerAs: 'dRendListCtrl'
        };

        return directive;

        /** @ngInject */
        function ListaDaRendicontareController(ProposteService, RendicontazioniService, ngDialog, $log, $state) {
            var vm = this;
            
            vm.rendProgetti = null;
            
            vm.now = null;
            
            vm.getRendProgetti = getRendProgetti;
            vm.openPropostaView = openPropostaView;
            vm.openRendicontazione = openRendicontazione;
            vm.openRendicontazioneView = openRendicontazioneView;
            vm.newRendicontazione = newRendicontazione;
            vm.eliminaRendicontazione = eliminaRendicontazione;
            vm.getStatusRendicontazioneClass = getStatusRendicontazioneClass;
            
            
            getRendProgetti()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sui progetti da rendicontare", error);
                });
            
            function getRendProgetti() {
                vm.rendProgetti = null;
                
                return ProposteService.getProposteDaRendicontare()
                    .then(function(data) {
                        vm.rendProgetti = data;
                        vm.now = (new Date()).getTime();
                    });
            }
            
            function openPropostaView(proposta) {
                $state.go('propostaView', {'id': proposta.id});
            }
            
            function openRendicontazione(rendicontazioneId) {
                $state.go('rendicontazioneDetail', {'id': rendicontazioneId});
            }
            
            function openRendicontazioneView(rendicontazioneId) {
                $state.go('rendicontazioneView', {'id': rendicontazioneId});
            }
            
            function newRendicontazione(propostaId, stepId) {
                $state.go('newRendicontazione', {'proposta': propostaId, 'step': stepId});
            }
            
            function eliminaRendicontazione(rendicontazione) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la bozza di rendicontazione?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        var dialog = showDeletingDialog();
                        RendicontazioniService.deleteRendicontazione(rendicontazione)
                        .then(function(resultData) { //eslint-disable-line no-unused-vars
                            getRendProgetti();
                            dialog.close();
                        });
                    }
                });
            }
            
            function showDeletingDialog() {
                var dialog = ngDialog.open({
                    template:'Eliminazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function getStatusRendicontazioneClass(progetto) {
                if (progetto.stepRendicontazione.length > 0) {
                    for (var i = progetto.stepRendicontazione.length - 1; i >= 0; i--) {
                        var step = progetto.stepRendicontazione[i];
                        if (step.rendicontazione && step.rendicontazione.status === 'INVIATA')
                            return 'sent';
                        else if (step.endTimestamp != null && step.endTimestamp < vm.now && (step.rendicontazione === null || step.rendicontazione.status != 'INVIATA'))
                            return 'missed';
                        else if (step.startTimestamp != null && step.startTimestamp < vm.now && step.endTimestamp != null && step.endTimestamp > vm.now && (step.rendicontazione === null || step.rendicontazione.status != 'INVIATA'))
                            return 'open';
                    }
                }
                return '';
            }
            
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaCommissioniCert', listaCommissioniCert);

    /** @ngInject */
    function listaCommissioniCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaCommissioniCert/listaCommissioniCert.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaCommissioniCertController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaCommissioniCertController(BandiService, CertCommissioniService, $log, $state, ngDialog, AuthService) {
            var vm = this;

            vm.commissioni = null;
            var loggedUser = AuthService.getUserInfo().utente

            vm.editDisabled = false;

            vm.getCommissioni = getCommissioni;
            vm.openCommissione = openCommissione;

            getCommissioni()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle commissioni", error);
                });



            function getCommissioni() {
                vm.commissioni = null;
                return CertCommissioniService.getCertCommissioni()
                    .then(function(data) {
                        vm.commissioni = data;
                    });
            }

            function openCommissione(id) {
                if (loggedUser.presidenteCommissioneCert) {
                    $state.go('certCommissionePresDetail', {'id': id});
                } else {
                    $state.go('certCommissioneDetail', {'id': id});
                }
            }


            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaCommissioni', listaCommissioni);

    /** @ngInject */
    function listaCommissioni() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listaCommissioni/listaCommissioni.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaCommissioniController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaCommissioniController(BandiService, CommissioniService, $log, $state, ngDialog) {
            var vm = this;
            
            vm.anno = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.commissioni = null;
            
            vm.editDisabled = true;
            
            vm.getCommissioni = getCommissioni;
            vm.openCommissione = openCommissione;
            vm.eliminaCommissione = eliminaCommissione;
            
            getAnni()
                .then(getCommissioni)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle commissioni", error);
                });
            
            function getAnni() {
                return BandiService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = { anno: vm.anno };
                            else
                                vm.selectedAnno = data[0];
                        }
                        vm.anni = data;
                    });
            }
            
            function getCommissioni() {
                vm.commissioni = null;
                return CommissioniService.getCommissioni(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.commissioni = data;
                        if (vm.selectedAnno.anno == vm.anni[0].anno)
                            vm.editDisabled = false;
                        else
                            vm.editDisabled = true;
                    });
            }
            
            function openCommissione(id) {
                $state.go('urCommissioneDetail', {'id': id});
            }
            
            function eliminaCommissione(id) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Sei sicuro di voler eliminare la commissione?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        var dialog = showDeletingDialog();
                        CommissioniService.deleteCommissione({'id': id})
                            .then(function() {
                                $log.log('commissione eliminata con successo');
                                for (var i = 0; i < vm.commissioni.length; i++) {
                                    if (vm.commissioni[i].id == id) {
                                        vm.commissioni.splice(i, 1);
                                        dialog.close();
                                        break;
                                    }
                                }
                            })
                            .catch(function(error) {
                                $log.error("Errore nell'eliminazione della commissione", error);
                                dialog.close();
                                showErrorDialog(error.data.message);
                            });
                    }
                });
            }
            
            function showDeletingDialog() {
                var dialog = ngDialog.open({
                    template:'Eliminazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });
                
                return dialog;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('listaBandi', listaBandi);

    /** @ngInject */
    function listaBandi() {
        var directive = {
            restrict: 'E',
            require: 'ngModel',
            templateUrl: 'app/components/listaBandi/listaBandi.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ListaBandiController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ListaBandiController(BandiService, Constants, $log, ngDialog, StruttureService) {
            var vm = this;

            vm.anno = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.bandi = null;
            vm.strutture = null;
            vm.selectedStruttura = null;

            vm.getBandi = getBandi;
            vm.getFileHref = getFileHref;

            getStrutture();
            getAnni()
                .then(getBandi)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sui bandi", error);
                });

            function getAnni() {
                return BandiService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = { anno: vm.anno };
                            else
                                vm.selectedAnno = data[0];
                        }
                        vm.anni = data;
                    });
            }

            function getBandi() {
                vm.bandi = null;
                return BandiService.getBandi(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.bandi = data;
                    });
            }

          function getStrutture() {
              return StruttureService.getStrutture()
                .then(function(resultData) {
                  vm.strutture = resultData;
                });
          }

          function showErrorDialog(message) { //eslint-disable-line no-unused-vars
            var msg = message ? message : 'Si è verificato un errore durante l\'esecuzione dell\'azione richiesta';
            return ngDialog.open({
              template: '<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>'+msg+'</b></div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
              plain: true,
              showClose: true,
              data: {
                //errorMessage: message
              }
            });
          }

          function showMessage(text) { //eslint-disable-line no-unused-vars
            return ngDialog.open({
              template: text+'<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
              plain: true,
              showClose: false
            });
          }

            function getFileHref(url) {
                return Constants.restApiRoot + url;
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('listDettaglioProposte', listDettaglioProposte);

    /** @ngInject */
    function listDettaglioProposte() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/listDettaglioProposte/listDettaglioProposte.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: listDettaglioProposteController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function listDettaglioProposteController(UtentiService, ProposteUrService, ProposteService, RichiestePartecipazioneService, $log, $state, $q, $window, ngDialog, $stateParams) {
            var vm = this;


            var utenteId = $stateParams.id;
            vm.anno = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.proposte = {
                end: 0,
                resultList: [],
                start: 0,
                totale: 0,
                ruoloComponente: []
            };
            vm.selectedStatusValutazione = 'ALL';
            vm.pagination = {
                current: 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };
            // vm.ruoloComponente = [];


            vm.getProposteERichieste = getProposteERichieste;
            vm.openProposta = openProposta;
            vm.openPropostaView = openPropostaView;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getNome = getNome;
            vm.getStatus = getStatus;
            vm.visualizzaAbstract = visualizzaAbstract;
            vm.mostraCommentoFinanziamento = mostraCommentoFinanziamento;
            vm.showDettagliEsito = showDettagliEsito;
            vm.getProposte = getProposte;
            vm.getRuolo = getRuolo;

            var storageName = "listaProposte-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            getAnni()
                .then(getNome)
                .then(getProposteERichieste)
                .catch(function (error) {
                    $log.error("Errore nel reperimento delle informazioni sulle proposte", error);
                });

            function getAnni() {
                return ProposteService.getAnni()
                    .then(function (data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = {anno: vm.anno};
                            else {
                                var anno = data.filter(function (anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];

                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }

            function getProposteERichieste() {
                vm.proposte = null;
                vm.richieste = null;
                var promises = [getProposte()];
                if (vm.selectedAnno.anno == vm.anni[0].anno)
                    promises.push(getRichieste());
                else
                    vm.richieste = [];

                return $q.all(promises);
            }

            function getRichieste() {
                return RichiestePartecipazioneService.getRichiestePartecipazione()
                    .then(function (data) {
                        vm.richieste = data;
                    });
            }

            function getProposte() {
                //salva il filtraggio nel sessionStorage
                vm.proposte = null;
                $window.sessionStorage[storageName] = angular.toJson({
                    statusValutazione: vm.selectedStatusValutazione,
                    anno: vm.selectedAnno
                });
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                filter.utenteId = utenteId;
                return ProposteUrService.getProposteByUtente(filter)
                    .then(function (data) {
                        vm.proposte = data.resultList;
                        // getRuolo(vm.proposte);
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                        vm.proposte.forEach(function (proposta) {
                            if (utenteId == proposta.responsabile.id) {
                                proposta.ruoloComponente = 'Responsabile';
                            } else {
                                getRuolo(proposta.id).then(function (ruolo) {
                                    proposta.ruoloComponente = ruolo.ruolo;
                                });
                            }
                        });
                        $log.log('ruoli: ', vm.proposte);
                    });
            }

            function openProposta(proposta) {
                if (proposta.isResponsabile)
                    $state.go('propostaDetail', {'id': proposta.id});
                else if (proposta.categoriaUtente == 'Tutor di riferimento' || proposta.categoriaUtenteDescrizione === 'Componenti' || proposta.categoriaUtenteDescrizione === 'Dottorandi/Assegnisti/Specializzandi componenti')
                    return;
                else
                    $state.go('propostaFormPartecipante', {'id': proposta.id});
            }

            function openPropostaView(proposta) {
                $log.log(proposta.id);
                $state.go('urPropostaView', {'id': proposta.id});
            }

            function getStatusClass(proposta) {
                if (proposta.esito && proposta.esito.status == 'FINANZIATA')
                    return 'accepted';
                if (proposta.esito && proposta.esito.status == 'NON_FINANZIATA')
                    return 'rejected';
                if (proposta.status == 'INVIATA')
                    return 'sent';
                return '';
            }

            function getStatusIcon(proposta) {
                if (proposta.status == 'BOZZA')
                    return 'fa-pencil-square-o';
                if (proposta.esito && proposta.esito.status == 'FINANZIATA')
                    return 'fa-thumbs-o-up';
                if (proposta.esito && proposta.esito.status == 'NON_FINANZIATA')
                    return 'fa-thumbs-o-down';
                if (proposta.status == 'INVIATA')
                    return 'fa-sign-out';
                return '';
            }

            function getStatus(proposta) {
                if (proposta.status == 'BOZZA')
                    return 'Bozza';
                if (proposta.esito && proposta.esito.status == 'FINANZIATA')
                    return 'Finanziata';
                if (proposta.esito && proposta.esito.status == 'NON_FINANZIATA')
                    return 'Non finanziata';
                if (proposta.status == 'INVIATA')
                    return 'Inviata';
                return '';
            }

            function getNome() {
                return UtentiService.getUtente(utenteId)
                    .then(function (data) {
                        vm.nome = data.cognome + ' ' + data.nome;
                        $log.log(vm.nome)
                    });
            }

            function visualizzaAbstract(richiesta) {
                ngDialog.open({
                    template: '\
                        <h3>Abstract</h3>\
                        <p class="well" style="white-space: pre-wrap;">{{ngDialogData.datiRichiesta.abstractProposta ? ngDialogData.datiRichiesta.abstractProposta : \'&lt;progetto senza abstract&gt;\'}}</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-showAbstract',
                    data: {
                        datiRichiesta: richiesta
                    }
                });
            }

            function mostraCommentoFinanziamento(commento) {
                ngDialog.open({
                    template: '\
                        <h3 class="title">Commento</h3>\
                        <div class="well">{{ngDialogData.commento}}</div>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        commento: commento
                    }
                });
            }

            function showDettagliEsito(proposta) {
                ngDialog.open({
                    template: '\
                        <dettagli-esito proposta="ngDialogData.proposta"></dettagli-esito>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        proposta: proposta
                    }
                });
            }

            function getRuolo(proposta) {
                // proposte.forEach(function (proposta) {
                // if (responsabile != utenteId) {
                    return ProposteUrService.getRuoloComponente(proposta, utenteId)
                // } else {
                //     return 'Responsabile';
                // }
                // })
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('iterValutazione', iterValutazione);

    /** @ngInject */
    function iterValutazione() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/iterValutazione/iterValutazione.html',
            scope: {},
            bindToController: {
                proposta: "=",
                editMode: "=",
                isUr: "=",
                isPresComm: "=",
                presCanEdit: "=",
                confirm: "="
            },
            controller: IterValutazioneController,
            controllerAs: 'iterValCtrl'
        };

        return directive;

        /** @ngInject */
        function IterValutazioneController($scope, FasiValutazioneService, ngDialog, $log) {
            var vm = this;
            
            vm.fasiObj = null;
            
            vm.getFasiValutazione = getFasiValutazione;
            vm.valutaProposta = valutaProposta;
            vm.showValutazione = showValutazione;
            vm.close = close;
            vm.getCheckEvaluationIconClass = getCheckEvaluationIconClass;
            vm.reloadAndCheckFasi = reloadAndCheckFasi;
            
            getFasiValutazione()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });
            
            function getFasiValutazione() {
                vm.fasiObj = null;
                return FasiValutazioneService.getFasiValutazioneByPropostaId(vm.proposta.id)
                    .then(function(data) {
                        vm.fasiObj = data;
                    });
            }
            
            function valutaProposta(proposta, valutazione, faseValutazioneId) {
                
                var valutaDialog = ngDialog.openConfirm({
                    template:'<input type="text" style="width: 1px; height: 1px; border: 0px; outline: none; position: absolute;" /><valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" confirm="confirm" edit-mode="true" fase-id="ngDialogData.faseId" draft-only="ngDialogData.draftOnly"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? angular.copy(valutazione.id) : null,
                        faseId: faseValutazioneId,
                        draftOnly: (proposta.mcValutazioneSoloBozza === true && !vm.isPresComm)
                    }
                });
                
                valutaDialog.then(function (data) {
                    if (data) {
                        getFasiValutazione();
                        vm.confirm(true);
                    }
                });
            }
            
            function showValutazione(proposta, valutazione) {
                
                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" is-ur="ngDialogData.isUr" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    closeByNavigation: true,
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? valutazione.id : null,
                        isUr: vm.isUr ? true : false
                    }
                });
            }

            function close() {
                ngDialog.close();
            }
            
            function getCheckEvaluationIconClass(punteggio) {
                var integer = Math.round(punteggio);
                var className = '';
                if (integer === 0)
                    className = 'fa-thumbs-o-down';
                if (integer === 1)
                    className = 'fa-thumbs-o-up';
                
                return className;
            }

            function reloadAndCheckFasi() {
                getFasiValutazione().then(function() {
                    var conclusa = true;
                    angular.forEach(vm.fasiObj, function(faseObj) {
                        if (!faseObj.conclusa)
                            conclusa = false;
                    });
                    if (conclusa)
                        vm.confirm(true);
                });
            }
            
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('indicatoriValutazione', indicatoriValutazione);

    /** @ngInject */
    function indicatoriValutazione() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/indicatoriValutazione/indicatoriValutazione.html',
            scope: {},
            bindToController: {
                proposta: "=",
                isUr: "=?"
            },
            controller: IndicatoriValutazioneController,
            controllerAs: 'indValCtrl'
        };

        return directive;

        /** @ngInject */
        function IndicatoriValutazioneController(ProposteMcService, ProposteUrService, ngDialog, $log, $filter) {
            var vm = this;
            
            vm.indObj = null;
            
            vm.getIndicatoriValutazione = getIndicatoriValutazione;
            vm.close = close;
            
            getIndicatoriValutazione()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });
            
            function getIndicatoriValutazione() {
                vm.indObj = null;

                var handleResult = function(data) {
                    var result = angular.copy(data);
                    var medieCat = {};
                    var numCat = {};
                    var categorie = $filter('groupBy')(result, 'categoria');
                    angular.forEach(categorie, function(categoria) {
                        var media = 0;
                        var num = 0;
                        angular.forEach(categoria, function(comp) {
                            if (comp.coefficiente != null) {
                                media += comp.coefficiente;
                                num += 1;
                            }
                        });
                        media = media / num;
                        medieCat[categoria[0].categoria] = media;
                        numCat[categoria[0].categoria] = categoria.length;

                    });
                    var checkedCat = {};
                    for (var i = 0; i < result.length; i++) {
                        var pers = result[i];
                        if (checkedCat[pers.categoria] !== true) {
                            pers.mediaNum = numCat[pers.categoria];
                            pers.mediaCoefficiente = medieCat[pers.categoria];
                            checkedCat[pers.categoria] = true;
                        }
                    }
                    vm.indObj = result;
                };

                if (vm.isUr === true) {
                    return ProposteUrService.getIndicatoriValutazioneProposta(vm.proposta.id).then(handleResult);
                }
                else {
                    return ProposteMcService.getIndicatoriValutazioneProposta(vm.proposta.id).then(handleResult);
                }
            }

            function close() {
                ngDialog.close();
            }
            
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('indicatoriValProp', indicatoriValProp);

    /** @ngInject */
    function indicatoriValProp() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/indicatoriValProp/indicatoriValProp.html',
            scope: {},
            bindToController: {
                proposta: "="
            },
            controller: IndicatoriValPropController,
            controllerAs: 'indValPropCtrl'
        };

        return directive;

        /** @ngInject */
        function IndicatoriValPropController(ProposteService, ngDialog, $log) {
            var vm = this;
            
            vm.indObj = null;
            
            vm.getIndicatori = getIndicatori;
            vm.close = close;
            
            getIndicatori()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });
            
            function getIndicatori() {
                vm.indObj = null;
                return ProposteService.getIndicatoriValutazioneProposta(vm.proposta.id)
                    .then(function(data) {
                        vm.indObj = angular.copy(data);
                    });
            }

            function close() {
                ngDialog.close();
            }
            
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('impersona', impersona);

    /** @ngInject */
    function impersona() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/impersona/impersona.html',
            scope: {},
            bindToController: {},
            controller: impersonaController,
            controllerAs: 'impCtrl'
        };

        return directive;

        /** @ngInject */
        function impersonaController(UtentiUrService, AuthService, $log, $state, $window) {
            var vm = this;

            // variabili
            vm.utenti = null;

            // filtro
            var storageName = "impersona-filter";
            var     oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};
            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;
            vm.selectedNome = oldFilter.nome ? oldFilter.nome : null;

            // metodi
            vm.getUtenti = getUtenti;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.getCsvExportUrl = getCsvExportUrl;
            vm.editUtente = editUtente;
            vm.impersona = impersona;

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            getUtenti()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sugli utenti", error);
                });

            /**
             * @param keepPagination
             * @returns {*} la lista degli utenti, filtrati se è specificato un filtro
             */
            function getUtenti(keepPagination) {
                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                // salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    cognome: vm.selectedCognome,
                    nome: vm.selectedNome
                });

                vm.utenti = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedCognome != null && vm.selectedCognome != '')
                    filter.cognome = vm.selectedCognome;
                if (vm.selectedNome != null && vm.selectedNome != '')
                    filter.nome = vm.selectedNome;
                filter.imper = true;
                return UtentiUrService.getUtenti(filter)
                    .then(function (data) {
                        vm.utenti = data.resultList;
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    });
            }

            /**
             * resetta i filtri inseriti dall'utente
             */
            function resetFiltri() {
                vm.selectedCognome = "";
                vm.selectedNome = "";
                getUtenti();
            }

            function impersona(utente){
                AuthService.loginImpersona(utente)
                    .then(function() {
                        $window.sessionStorage.clear();
                        //$location.path('/');
                        var role = AuthService.getUserInfo().utente.tipoUtente;
                        if (role == 'UTENTE')
                            $state.go('home');
                        else if (role == 'UFFICIO_RICERCA')
                            $state.go('urHome');
                        else if (role == 'HELP_DESK')
                            $state.go('hdHome');
                        else if (role == 'RAD')
                            $state.go('radHome');
                        else if (role == 'REFEREE')
                            $state.go('refHome');
                        else if (role == 'UFFICIO_CERT')
                            $state.go('certHome');
                    })
            }

            /**
             * @returns {boolean} true se il filtro è attivo
             */
            function isFiltroAttivo() {
                var attivo = false;
                if (vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                if (vm.selectedNome && vm.selectedNome != "")
                    attivo = true;
                return attivo;
            }

            /**
             * @returns {*} l'export in csv della lista utenti (filtrata o meno)
             */
            function getCsvExportUrl() {
                var filter = {};
                if (vm.selectedCognome != null && vm.selectedCognome != '')
                    filter.cognome = vm.selectedCognome;
                if (vm.selectedNome && vm.selectedNome != "")
                    filter.nome = vm.selectedNome;
                return UtentiUrService.getCsvExportUrl(filter);
            }

            function editUtente(user) {
                $state.go('urGestioneUtenteEdit', {'id': user.id});

                // ngDialog.open({template:'<gestione-utente user="ngDialogData.user"></gestione-utente>', plain:true, showClose:true, data: {user:user}})
            }

        }
    }

})();

(function () {
  'use strict';

  angular
    .module('sigeba')
    .directive('gestioneUtente', gestioneUtente);

  /** @ngInject */
  function gestioneUtente() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/gestioneUtente/gestioneUtente.html',
      scope: {},
      bindToController: {
        userId: "="
        // editMode: "=",
        // isUr: "=",
        // confirm: "=?",
        // faseId: "=?"
      },
      controller: gestioneUtenteController,
      controllerAs: 'utenteCtrl'
    };

    return directive;

    /** @ngInject */
    function gestioneUtenteController($scope, ngDialog, $log, UtentiUrService, UtentiService, DipartimentiService, RuoliService, SsdService, $state, $window) {
      var vm = this;


      vm.saveUtente = saveUtente;
      vm.addIndicatore = addIndicatore;
      vm.close = close;
      vm.setTempoIndeterminato = setTempoIndeterminato;
      vm.isTempoIndeterminato = isTempoIndeterminato;

      vm.dipartimenti = null;
      vm.ruoli = null;
      vm.ssdList = null;

      getDipartimenti();
      getRuoli();
      getRegimi();
      getAllSsd();

      if (vm.userId) {
        vm.loading = true;
        vm.pageHeader = 'Modifica Utente';
        UtentiService.getUtente(vm.userId).then(function (u) {
          vm.oldutente = u;
          vm.utente = angular.copy(vm.oldutente);
          vm.tempoIndeterminato = isTempoIndeterminato(u.dataTermineRapporto);
          vm.loading = false;
          vm.utenteInternoValido = u.utenteInternoValido;
        });
      } else {
        vm.oldutente = {};
        vm.utente = {};
        vm.pageHeader = 'Nuovo Utente';
      }

      function showSavingDialog() {
        var dialog = ngDialog.open({
          template: 'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
          plain: true,
          showClose: false
        });

        return dialog;
      }

      function setTempoIndeterminato(isIndeterminato){
        if (isIndeterminato) {
          vm.utente.dataTermineRapporto = '02/02/2222';
          vm.tempoIndeterminato = true;
        }else {
            var moment = $window.moment;
            vm.utente.dataTermineRapporto = moment().format('DD/MM/YYYY');
            vm.tempoIndeterminato = false;
        }
      }

      function isTempoIndeterminato(date){
        return date==='02/02/2222';
      }

      function getDipartimenti() {
        return DipartimentiService.getDipartimenti()
          .then(function (resultData) {
            vm.dipartimenti = resultData;
          });
      }

      function getRuoli() {
        return RuoliService.getRuoli()
          .then(function (resultData) {
            vm.ruoli = resultData;
          });
      }

      function getRegimi() {
        vm.regimi = [
          {
            "nome": null,
            "descrizione": "Nessun regime"
          },
          {
            "nome": "Tempo Pieno",
            "descrizione": "Tempo Pieno"
          },
          {
            "nome": "Tempo Definito",
            "descrizione": "Tempo Definito"
          }
        ];
      }

        function getAllSsd() {
            return SsdService.getAllSsd()
                .then(function (resultData) {
                    vm.ssdList = resultData;
                });
        }

      function updateFileds(newObj, oldObj) {
        var keysNewObj = Object.keys(newObj);
        var retObj = {};
        keysNewObj.filter(function (x) {
          return !x.startsWith('$') && newObj[x] !== oldObj[x];
        }).forEach(function (x) {
          retObj[x] = newObj[x]
        });
        return retObj;
      }

      function addIndicatore() {
        vm.utente.indicatoriRicerca = {
          "id": null,
          "dataIndicatore": "",
          "ssd": "",
          "soglia1": 0,
          "soglia2": 0,
          "soglia3": 0,
          "indicatore1": 0,
          "indicatore2": 0,
          "indicatore3": 0,
          "anno": new Date().getFullYear(),
          "sc": ""
        };
      }

      function thenFunction(savingDialog) {
        return function () {
          $log.log('Utente salvato con successo');
          savingDialog.close();
          $state.go('urAnagrafica');
        }
      }

      function catchFunction(savingDialog) {
        return function (error) {
          $log.error("Errore nel salvataggio dell' utente", error);
          savingDialog.close();
          showErrorDialog(error.data.message);
        }
      }

      function showErrorDialog(message) { //eslint-disable-line no-unused-vars
        var dialog = ngDialog.open({
          template: '<h3 style="margin-top: 0px;">Errore</h3>' +
            '<div class="alert alert-danger" ng-if="!ngDialogData.errorMessage"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div>' +
            '<div class="alert alert-danger" ng-if="ngDialogData.errorMessage"><b>{{ngDialogData.errorMessage}}</b></div>',
          plain: true,
          showClose: true,
          data: {
            errorMessage: message
          }
        });

        return dialog;
      }

      function saveUtente() {
        var savingDialog = showSavingDialog();
        if (vm.utente.id) {
          var diff = updateFileds(vm.utente, vm.oldutente);
          UtentiUrService.updateUtente(vm.utente.id, diff).then(thenFunction(savingDialog)).catch(catchFunction(savingDialog));
        } else {
          UtentiUrService.addUtente(vm.utente).then(thenFunction(savingDialog)).catch(catchFunction(savingDialog));
        }
      }

      function close() {
        ngDialog.close();
      }

    }
  }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('gestioneReferee', gestioneReferee);

    /** @ngInject */
    function gestioneReferee() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/gestioneReferee/gestioneReferee.html',
            scope: {},
            bindToController: {
                proposta: "=",
                editMode: "=",
                isUr: "=",
                confirm: "=?",
                faseId: "=?"
            },
            controller: gestioneRefereeController,
            controllerAs: 'refereeCtrl'
        };

        return directive;

        /** @ngInject */
        function gestioneRefereeController($scope, RefereeService, ngDialog, $log, ValutazioniUrService, ValutazioniMcService) {
            var vm = this;
            
            vm.refereeObj = null;
            vm.newReferee = null;
            vm.mostraSoloAccettati = vm.editMode ? false : true;
            
            vm.addReferee = addReferee;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatusIconLabel = getStatusIconLabel;
            vm.getStatusDate = getStatusDate;
            vm.concludiValutazione = concludiValutazione;
            vm.refereeFilter = refereeFilter;
            vm.cancelReferee = cancelReferee;
            vm.showValutazione = showValutazione;
            vm.close = close;
            vm.concludiFaseValutazione = concludiFaseValutazione;
            vm.mostraAcceptLink = mostraAcceptLink;
            vm.enableNonNecessari = enableNonNecessari;
            
            getRefereeList()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });
            
            function getRefereeList() {
                vm.refereeObj = null;
                return RefereeService.getRefereeByPropostaId(vm.proposta.id)
                    .then(function(data) {
                        prepareRefereeHistory(data.refereeList);
                        vm.refereeObj = data;
                    });
            }
            
            function prepareRefereeHistory(data) {
                for (var i = 0; i < data.length; i++) {
                    var ref = data[i];
                    ref.history = [];
                    ref.history.push({
                        type: 'invito',
                        icon: 'fa-envelope-o',
                        color: 'gray',
                        label: 'Invito inviato',
                        date: ref.createdTimestamp
                    });
                    if (ref.invioSollecito) {
                        ref.history.push({
                            type: 'sollecito',
                            icon: 'fa-envelope-o',
                            color: 'gray',
                            label: 'Sollecito inviato',
                            date: ref.invioSollecito
                        });
                    }
                    if (ref.accettazioneTimestamp) {
                        ref.history.push({
                            type: 'accettazione',
                            icon: 'fa-check',
                            color: 'green',
                            label: 'Accettato',
                            date: ref.accettazioneTimestamp
                        });
                    }
                    if (ref.rifiutoValutazione) {
                        ref.history.push({
                            type: 'rifiuto',
                            icon: 'fa-times',
                            color: 'red',
                            label: 'Rifiutato',
                            date: ref.rifiutoValutazione
                        });
                    }
                    if (ref.disabilitazioneTimestamp) {
                        ref.history.push({
                            type: 'disabilitazione',
                            icon: 'fa-ban',
                            color: 'red',
                            label: 'Disabilitato',
                            date: ref.disabilitazioneTimestamp
                        });
                    }
                }
            }
            
            function addReferee() {
                
                RefereeService.addReferee(vm.newReferee, vm.proposta, vm.faseId).then(function() {
                    getRefereeList();
                    vm.newReferee = null;
                    vm.showAddReferee = false;
                });
            }
            
            function concludiValutazione() {
                ValutazioniUrService.concludiValutazioneReferee(vm.proposta.id).then(function() {
                    vm.confirm(true);
                });
            }
            
            function showValutazione(valutazione) {
                
                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" is-ur="ngDialogData.isUr" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    closeByNavigation: true,
                    data: {
                        proposta: vm.proposta,
                        valutazioneId: valutazione ? valutazione.id : null,
                        isUr: vm.isUr ? true : false
                    }
                });
            }
            
            function refereeFilter() {
                return function(referee) {
                    return ((vm.mostraSoloAccettati && referee.accettato && !referee.disabilitato && !referee.nonNecessario) || !vm.mostraSoloAccettati);
                };
            }
            
            function cancelReferee(referee) {
                
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Disabilita</h3>\
                        <div class="alert alert-warning" role="alert">Disabilitando il referee non potrà effetturare nessuna operazione.</div>\
                        <p>Vuoi disabilitare il referee?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        RefereeService.disableRefereeById(referee.id).then(function() {
                            getRefereeList();
                        });
                    }
                });
            }
            
            function getStatusClass(referee) {
                if (referee.nonNecessario == true)
                    return 'nonNecessary';
                if (referee.accettato == false || referee.disabilitato == true)
                    return 'rejected';
                if (referee.accettato == true)
                    return 'accepted';
                return '';
            }
            
            function getStatusIcon(referee) {
                if (referee.disabilitato == true)
                    return 'fa-ban';
                if (referee.nonNecessario == true)
                    return 'fa-circle-o';
                if (referee.accettato == true)
                    return 'fa-check';
                if (referee.accettato == false)
                    return 'fa-times';
                return 'fa-envelope-o';
            }
            
            function getStatusIconLabel(referee) {
                if (referee.disabilitato == true)
                    return 'Disabilitato';
                if (referee.nonNecessario == true)
                    return 'Non Necessario';
                if (referee.accettato == true)
                    return 'Accettato';
                if (referee.accettato == false)
                    return 'Rifiutato';
                if(referee.invioSollecito)
                    return 'Sollecito inviato';
                return 'Invito inviato';
            }
            
            function getStatusDate(referee) {
                if (referee.disabilitato == true)
                    return referee.disabilitazioneTimestamp;
                if (referee.accettato == true)
                    return referee.accettazioneTimestamp;
                if (referee.accettato == false)
                    return referee.rifiutoValutazione;
                if(referee.invioSollecito)
                    return referee.invioSollecito;
                return referee.createdTimestamp;
            }
            
            function close() {
                ngDialog.close();
            }
            
            function concludiFaseValutazione() {
                if (vm.isUr) {
                    ValutazioniUrService.concludiFaseValutazioneReferee(vm.proposta.id, vm.faseId).then(function() {
                        vm.confirm(true);
                    });
                }
                else {
                    ValutazioniMcService.concludiFaseValutazioneReferee(vm.proposta.id, vm.faseId).then(function() {
                        vm.confirm(true);
                    });
                }
            }
            
            function mostraAcceptLink(acceptLink) {
                ngDialog.open({
                    template:'\
                        <h3 class="title">Link Accettazione Referee</h3>\
                        <div class="well">{{ngDialogData.acceptLink}}</div>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        acceptLink: acceptLink
                    }
                });
            }
            
            function enableNonNecessari() {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Riabilitazione referee non necessari</h3>\
                        <div class="alert alert-warning" role="alert">Anziché aggiungere un nuovo referee, verranno abilitati quelli già esistenti che sono stati qualificati come "non necessari".<br />\
                        Qualora uno di essi avesse già completato la sua valutazione, verrà presa direttamente quella.<br />Qualora invece nessuno di essi avesse completato la sua valutazione, \
                        verranno abilitati tutti i referee "non necessari" (e eventualmente poi sarà possibile aggiungerne altri). Quando poi uno di essi completerà la sua valutazione \
                        tutti gli altri saranno disabilitati o resi nuovamente come "non necessari".</div>\
                        <p>Vuoi abilitare i referee non necessari?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        RefereeService.enableNonNecessari(vm.proposta.id).then(function() {
                            //getRefereeList();
                            vm.confirm(true);
                        });
                    }
                });
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('gestioneIter', gestioneIter);

    /** @ngInject */
    function gestioneIter() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/gestioneIter/gestioneIter.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: GestioneIterController,
            controllerAs: 'iterCtrl'
        };

        return directive;

        /** @ngInject */
        function GestioneIterController(BandiService, IterBandiUrService, StepRendicontazioneService, $log, ngDialog) {
            var vm = this;

            vm.anno = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.iterBandi = null;
            vm.tm = false;

            vm.getIterBandi = getIterBandi;
            vm.ufficializzaClasse = ufficializzaClasse;
            vm.editDataRendicontazione = editDataRendicontazione;
            vm.sendMailDateRendicontazione = sendMailDateRendicontazione;
            vm.sendMailValutazioneRendicontazione = sendMailValutazioneRendicontazione;


            getAnni()
                .then(getIterBandi)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sugli iter", error);
                });

            function getAnni() {
                return BandiService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = { anno: vm.anno };
                            else
                                vm.selectedAnno = data[0];
                        }
                        vm.anni = data;
                    });
            }

            function getIterBandi() {
                vm.iterBandi = null;

                return IterBandiUrService.getIterBandi(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.iterBandi = data;
                        for (var i=0;i<vm.iterBandi.length;i++){
                            if (vm.iterBandi[i].visibilita == 'TM'){
                                vm.tm=true;
                                break;
                            }
                        }
                    });

            }

            function ufficializzaClasse(classeId) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma ufficializzazione</h3>\
                        <p>Ufficializzando i risultati per una classe, gli esiti dei finanziamenti saranno visibili ai proponenti e componenti delle proposte e ai RAD.</p>\
                        <p>Inoltre sarà inviata in automatico una email a tutti i proponenti informandoli dell\'esito positivo o negativo.</p>\
                        <p>Vuoi procedere con l\'ufficializzazione?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function(data) {
                    if (data === true) {
                        var dialog = showUfficDialog();
                        IterBandiUrService.ufficializzaClasse(classeId)
                            .then(function() {
                                getIterBandi();
                                dialog.close();
                            })
                            .catch(function(error) {
                                $log.error("errore nell'ufficializzazione della classe", error);
                                dialog.close();
                                if (error && error.data && error.data.code == 91)
                                    showErrorUfficDialog(error.data.message);
                                else
                                    showErrorDialog(error.data.message);
                            });
                    }
                });
            }

            function showUfficDialog() {
                var dialog = ngDialog.open({
                    template:'Ufficializzazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b></div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }

            function showValutNullDialog(list) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Sono presenti rendicontazioni non ancora valutate</b></div>' +
                        '<div class="well" ng-repeat="daValutare in ngDialogData.listContainer"><b>- Titolo:</b> {{daValutare.titolo}} <b>Responsabile:</b> {{daValutare.responsabile}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        listContainer: list
                    }
                });

                return dialog;
            }

            function showErrorUfficDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Impossibile ufficializzare la classe</h3><div class="well"><b>Impossibile completare l\'operazione richiesta poiché ci sono alcune proposte per la classe in questione per cui non è stato inserito l\'esito.</b></div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }

            function editDataRendicontazione(rendicontazione, classe) {
                var dialog = ngDialog.open({
                    template:'\
                        <edit-rendicontazione-date rendicontazione="ngDialogData.rendicontazione" classe="ngDialogData.classe" close="closeThisDialog"></edit-rendicontazione-date>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-rendicontazione-date',
                    data: {
                        rendicontazione: rendicontazione,
                        classe: classe
                    }
                });

                dialog.closePromise.then(function (data) {
                    if(data.value == 'confirmCallback')
                        getIterBandi();
                });
            }

            function sendMailDateRendicontazione(stepId, logInvioMail) {
                var clicked = false;
                var tm = vm.tm;
                var dialog = ngDialog.open({
                    template:'\
                        <h3>Comunica date rendicontazione via email</h3>\
                        <p>Tramite questa funzionalità puoi comunicare via email le date di inizio e fine rendicontazione a tutti i titolari dei progetti della classe dimensionale selezionata.</p>\
                        <p ng-show="tm == false" >Puoi scegliere se inviare il testo relativo alla prima comunicazione delle date, oppure quello per le eventuali modifiche.</p>\
                        <p>Clicca sul pulsante corrispondente all\'azione desiderata per inviare la mail.<input type="text" style="width: 0px; height: 0px; visibility: hidden;"/></p>\
                        <p style="text-align: center; margin-top: 15px;"><button class="btn btn-primary" ng-click="ngDialogData.sendFirstEmail()" style="width: 200px; margin-right: 20px;">INVIA MAIL<br />Prima comunicazione<br />delle date</button><button ng-show="tm == false" class="btn btn-primary" ng-click="ngDialogData.sendUpdateEmail()" style="width: 200px;">INVIA MAIL<br />Comunicazione proroga<br />scadenza</button></p>\
                        <div ng-if="ngDialogData.logInvio != null"><b>Comunicazioni inviate</b><p class="well">{{ngDialogData.logInvio}}</p></div>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-sendEmailRend',
                    data: {
                        logInvio: logInvioMail,
                        sendFirstEmail: function() {
                            if (!clicked) {
                                clicked = true;
                                StepRendicontazioneService.inviaMailComunicazioneDate(stepId)
                                    .then(function(data) { //eslint-disable-line no-unused-vars
                                        getIterBandi();
                                        dialog.close();
                                        clicked = false;
                                    })
                                    .catch(function(error) {
                                        $log.error("errore nell'invio mail rendicontazione", error);
                                        dialog.close();
                                        showErrorDialog(error.data.message);
                                    });
                            }
                        },
                        sendUpdateEmail: function() {
                            if (!clicked) {
                                clicked = true;
                                StepRendicontazioneService.inviaMailModificaDate(stepId)
                                    .then(function(data) { //eslint-disable-line no-unused-vars
                                        getIterBandi();
                                        dialog.close();
                                        clicked = false;
                                    })
                                    .catch(function(error) {
                                        $log.error("errore nell'invio mail rendicontazione", error);
                                        dialog.close();
                                        showErrorDialog(error.data.message);
                                    });
                            }
                        }
                    }
                });
            }

            function sendMailValutazioneRendicontazione(stepId, logInvioMail) {
                var clicked = false;
                var tm = vm.tm;
                var dialog = ngDialog.open({
                    template:'\
                        <h3>Comunica la valutazione della rendicontazione via email</h3>\
                        <p>Tramite questa funzionalità puoi comunicare via email la valutazione della rendicontazione a tutti i titolari dei progetti della classe dimensionale selezionata.</p>\
                        <p>Clicca sul pulsante corrispondente all\'azione desiderata per inviare la mail.<input type="text" style="width: 0px; height: 0px; visibility: hidden;"/></p>\
                        <p style="text-align: center; margin-top: 15px;"><button class="btn btn-primary" ng-click="ngDialogData.sendFirstEmail()" style="width: 200px; margin-right: 20px;">INVIA MAIL<br />Comunicazione<br />delle valutazioni</button></p>\
                        <div ng-if="ngDialogData.logInvio != null"><b>Comunicazioni inviate</b><p class="well">{{ngDialogData.logInvio}}</p></div>',
                    plain: true,
                    className: 'ngdialog-theme-default ngdialog-sendEmailRend',
                    data: {
                        logInvio: logInvioMail,
                        sendFirstEmail: function() {
                            if (!clicked) {
                                clicked = true;
                                StepRendicontazioneService.inviaMailValutazioneRend(stepId)
                                    .then(function(data) { //eslint-disable-line no-unused-vars
                                        getIterBandi();
                                        dialog.close();
                                        clicked = false;
                                        var checkError = data != null?data.length !== 0:false;
                                        if (checkError) {
                                            showValutNullDialog(data);
                                        }
                                    })
                                    .catch(function(error) {
                                        $log.error("errore nell'invio mail rendicontazione", error);
                                        dialog.close();
                                        showErrorDialog(error.data.message);
                                    });
                            }
                        }
                    }
                });
            }

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('gestioneInattivi', gestioneInattivi);

    /** @ngInject */
    function gestioneInattivi() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/gestioneInattivi/gestioneInattivi.html',
            scope: {},
            bindToController: {},
            controller: GestioneInattiviController,
            controllerAs: 'inatCtrl'
        };

        return directive;

        /** @ngInject */
        function GestioneInattiviController(GestInattiviUrService, InattiviService, $log, $state, $window, ngDialog, $scope) {
            var vm = this;

            // filtro
            var storageName = "gestioneInattivi-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            // variabili
            vm.inattiviValidi = null;
            vm.inattiviNonValidi = null;

            vm.anno = null;
            vm.tipologia = null;
            vm.selectedAnno = null;
            vm.anni = null;
            vm.tipologie = null;
            vm.selectedTipologia = oldFilter.tipologia ? oldFilter.tipologia : '-- tutte le tipologie --';
            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;
            vm.editDisabled = true;
            vm.motivazione = null;

            // metodi
            vm.getInattivi = getInattivi;
            vm.getTipologieInattivi = getTipologieInattivi;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.eliminaInattivo = eliminaInattivo;
            vm.viewInattivo = viewInattivo;

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 10,
                total: 0,
                start: 0,
                end: 0
            };

            /**
             * @param keepPagination
             * @returns {*} la lista degli inattivi, filtrati se è specificato un filtro
             */
            function getInattivi(keepPagination, refreshNV) {
                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                // salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    cognome: vm.selectedCognome,
                    anno: vm.selectedAnno,
                    tipologia: vm.selectedTipologia
                });

                vm.inattiviValidi = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit,
                    validi: true
                };
                if (vm.selectedAnno != null)
                    filter.anno = vm.selectedAnno.anno;
                if (vm.selectedCognome != null && vm.selectedCognome != '')
                    filter.cognome = vm.selectedCognome;
                if (vm.selectedTipologia != null)
                    filter.tipologia = vm.selectedTipologia === "-- tutte le tipologie --" ? "ALL" : vm.selectedTipologia;

                return GestInattiviUrService.getInattivi(filter)
                    .then(function (data) {
                        vm.inattiviValidi = data.resultList;
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;

                        if (vm.selectedAnno.anno == vm.anni[0].anno)
                            vm.editDisabled = false;
                        else
                            vm.editDisabled = true;
                        if (refreshNV == null || refreshNV) {
                            // prendo tutti i non validi
                            vm.inattiviNonValidi = null;
                            var filter = {
                                validi: false
                            };
                            if (vm.selectedAnno != null)
                                filter.anno = vm.selectedAnno.anno;
                            if (vm.selectedTipologia != null)
                                filter.tipologia = vm.selectedTipologia === "-- tutte le tipologie --" ? "ALL" : vm.selectedTipologia;

                            return GestInattiviUrService.getInattivi(filter)
                                .then(function (data) {
                                    vm.inattiviNonValidi = data.resultList;
                                });
                        }
                    });
            }

            /**
             * resetta i filtri inseriti dall'utente
             */
            function resetFiltri() {
                vm.selectedCognome = "";
                vm.selectedTipologia = vm.tipologie[0];
                getInattivi(false, false);
            }

            /**
             * @returns {boolean} true se il filtro è attivo
             */
            function isFiltroAttivo() {
                var attivo = false;
                if (vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                if (vm.selectedTipologia != null && vm.tipologie != null && vm.selectedTipologia != vm.tipologie[0])
                    attivo = true;
                return attivo;
            }

            getAnni()
                .then(getTipologieInattivi)
                .then(getInattivi)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sugli inattivi", error);
                });

            function getAnni() {
                return InattiviService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno) {
                                vm.selectedAnno = { anno: vm.anno };
                            } else {
                                var anno = data.filter(function(anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];
                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }

            function getTipologieInattivi() {
                return InattiviService.getTipologie()
                    .then(function(data) {
                        vm.tipologie = [];
                        var tipo = '-- tutte le tipologie --';
                        vm.tipologie.push(tipo);
                        if(!vm.selectedTipologia)
                            vm.selectedTipologia = tipo;
                        for (var i = 0; i < data.length; i++) {
                            tipo = data[i];
                            vm.tipologie.push(tipo);
                        }
                        // vm.tipologie = data;
                    });
            }

            function eliminaInattivo(id) {
                var newScope = $scope.$new();
                newScope.vm = vm;
                vm.motivazione = '';
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <br>\
                        <p>Inserire una motivazione:</p>\
                        <input type="text" class="form-control" ng-model="vm.motivazione" maxlength="255"/>\
                        <br>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Elimina</button>\
                        </div>',
                    plain: true,
                    scope: newScope
                });
                confirmDialog.then(function (data) {
                    if (data === true) {
                        if (vm.motivazione != null && vm.motivazione !== '') {
                            var delData = {
                                id: id,
                                motivazione: vm.motivazione
                            }
                            var dialog = showDeletingDialog();
                            GestInattiviUrService.deleteInattivo(delData)
                                .then(function () {
                                    $log.log('inattivo eliminato con successo');
                                    dialog.close();
                                    vm.motivazione = null;
                                    getInattivi(null, true);
                                })
                                .catch(function (error) {
                                    $log.error("Errore durante l'eliminazione del record", error);
                                    dialog.close();
                                    showErrorDialog(error.data.message);
                                });
                        } else {
                            dialog = ngDialog.open({
                                template:'<h3 style="margin-top: 0px;">Attenzione</h3><div class="alert alert-danger"><b>Inserire una motivazione.</b><br /></div>',
                                plain: true,
                                showClose: true
                            });

                            return dialog;
                        }
                    }
                });
            }

            function showDeletingDialog() {
                var dialog = ngDialog.open({
                    template:'Eliminazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function showErrorDialog(message) {
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }

            function viewInattivo(inattivo) {
                ngDialog.openConfirm({
                    template:'\
                        <h3>Dettaglio inattivo</h3>\
                        <br/>\
                        <p><strong>Cognome e Nome:</strong> {{ngDialogData.persona}}</p>\
                        <p><strong>Tipologia:</strong> {{ngDialogData.tipologia}}</p>\
                        <p><strong>Motivazione</strong>\
                        <div class="well"">{{ngDialogData.motivazione}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        persona: inattivo.persona,
                        tipologia: inattivo.tipologia,
                        motivazione: inattivo.motivazioneEliminazione
                    }
                });
            }

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('gestioneAnagrafica', gestioneAnagrafica);

    /** @ngInject */
    function gestioneAnagrafica() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/gestioneAnagrafica/gestioneAnagrafica.html',
            scope: {},
            bindToController: {},
            controller: GestioneAnagraficaController,
            controllerAs: 'anagCtrl'
        };

        return directive;

        /** @ngInject */
        function GestioneAnagraficaController(UtentiUrService, $log, $state, $window) {
            var vm = this;

            // variabili
            vm.utenti = null;

            // filtro
            var storageName = "gestioneAnagrafica-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};
            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;

            // metodi
            vm.getUtenti = getUtenti;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.getCsvExportUrl = getCsvExportUrl;
            vm.editUtente = editUtente;

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            getUtenti()
                .catch(function (error) {
                    $log.error("Errore nel reperimento delle informazioni sugli utenti", error);
                });

            /**
             * @param keepPagination
             * @returns {*} la lista degli utenti, filtrati se è specificato un filtro
             */
            function getUtenti(keepPagination) {
                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                // salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    cognome: vm.selectedCognome
                });

                vm.utenti = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedCognome != null && vm.selectedCognome != '')
                    filter.cognome = vm.selectedCognome;
                return UtentiUrService.getUtenti(filter)
                    .then(function (data) {
                        vm.utenti = data.resultList;
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    });
            }

            /**
             * resetta i filtri inseriti dall'utente
             */
            function resetFiltri() {
                vm.selectedCognome = "";
                getUtenti();
            }

            /**
             * @returns {boolean} true se il filtro è attivo
             */
            function isFiltroAttivo() {
                var attivo = false;
                if (vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                return attivo;
            }

            /**
             * @returns {*} l'export in csv della lista utenti (filtrata o meno)
             */
            function getCsvExportUrl() {
                var filter = {};
                if (vm.selectedCognome != null && vm.selectedCognome != '')
                    filter.cognome = vm.selectedCognome;
                return UtentiUrService.getCsvExportUrl(filter);
            }

            function editUtente(user) {
                $state.go('urGestioneUtenteEdit', {'id': user.id});

                // ngDialog.open({template:'<gestione-utente user="ngDialogData.user"></gestione-utente>', plain:true, showClose:true, data: {user:user}})
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('formIndex', formIndex);

    /** @ngInject */
    function formIndex() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/form-index/form-index.html',
            scope: {
                container: '@'
            },
            bindToController: {
                sezioni: '='
            },
            controller: FormIndexController,
            controllerAs: 'vm',
            link: function (scope, elem, attr, controller) {
                var $container = angular.element(elem).parents(scope.container).first();
                var containerOffset = $container.offset().top;
                
                var $index = angular.element(elem).find('.formIndex').first();
                var indexScroll = $index.offset().top - containerOffset;
                
                $container.scroll(function() {
                    var scrollTop = $container.scrollTop();
                    if (scrollTop >= indexScroll)
                        $index.addClass('fixed');
                    else
                        $index.removeClass('fixed');
                    var currentSection = 0;
                    for (var i = 0; i < controller.sezioni.length; i++) {
                        if ($container.find('#section' + (i + 1)).length > 0) {
                            var sectionOffset = angular.element('#section' + (i + 1)).offset().top;
                            if (sectionOffset <= containerOffset)
                                currentSection = i;
                        }
                    }
                    if (currentSection != controller.currentSection) {
                        controller.setCurrentSection(currentSection);
                        scope.$apply();
                    }
                });
            }
        };

        return directive;
        
        /** @ngInject */
        function FormIndexController($state, $location, $anchorScroll) {
            var vm = this;
            
            vm.currentSection = 0;
            vm.setCurrentSection = setCurrentSection;
            vm.goToSection = goToSection;
            
            if (vm.sezioni == undefined)
                vm.sezioni = [];
            
            function setCurrentSection(index) {
                vm.currentSection = index;
            }
            
            function goToSection(index) {
                vm.currentSection = index;
                $location.hash('section' + (index + 1)).replace();
                $anchorScroll();
            }
        }
    }

})();

/*(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('formIndex', formIndex);

    /** @ngInject */
/*    function formIndex($state) {
        var directive = {
            restrict: 'A',
            scope: {},
            link: function (scope, elem, attr) {
                var sections = [];
                var containerOffset = $(elem).parents('.mainContainer').offset().top;
                var indexScroll = $('.formContainer').offset().top - containerOffset;
                $(elem).parents('.mainContainer').scroll(function() {
                    if (sections.length == 0)
                        sections = $(elem).find('li');
                    var current = sections[0];
                    var currentIndex = 1;
                    sections.each(function(index) {
                        $(this).removeClass('active');
                        if ($('#section' + (index + 1)).offset().top <= containerOffset) {
                            current = this;
                            currentIndex = index + 1;
                        }
                    });
                    $(current).addClass('active');
                    if ($(this).scrollTop() >= indexScroll)
                        $(elem).addClass('fixed');
                    else
                        $(elem).removeClass('fixed');
                });
            }
        };

        return directive;
    }

})();
*/
(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('fixedHeader', fixedHeader);

    /** @ngInject */
    function fixedHeader() {
        var directive = {
            restrict: 'A',
            scope: {
                container: '@'
            },
            link: function (scope, elem, attr) { //eslint-disable-line no-unused-vars
                var $container = angular.element(elem).parents(scope.container).first();
                var containerOffset = $container.offset().top;
                
                var $elem = angular.element(elem);
                var elemScroll = $elem.offset().top - containerOffset;
                var $clonedElem = null;
                var resizeHandler = null;
                
                $container.scroll(function() {
                    var scrollTop = $container.scrollTop();
                    if (scrollTop >= elemScroll) {
                        if ($clonedElem == null) {
                            $clonedElem = angular.copy($elem);
                            resizeHandler = function() {
                                $elem.width($clonedElem.width());
                            };
                            $elem.parent().prepend($clonedElem);
                            $elem.addClass('fixed');
                            resizeHandler();
                            angular.element(window).on('resize', resizeHandler);
                        }
                    }
                    else {
                        if ($clonedElem != null) {
                            $clonedElem.remove();
                            angular.element(window).off('resize', resizeHandler);
                            $clonedElem = null;
                            resizeHandler = null;
                            $elem.removeClass('fixed');
                            $elem.width('auto');
                        }
                    }
                });
            }
        };

        return directive;
    }

})();
(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('telephoneFieldParser', telephoneFieldParser);

    /** @ngInject */
    function telephoneFieldParser() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.unshift(function (inputValue) {
                    var transformedInput = '';
                    if (inputValue) {
                        transformedInput = inputValue.replace(/[^\d\s]/g,'');
                        if (inputValue[0] == '+')
                            transformedInput = '+' + transformedInput;
                    }
                    if (transformedInput != inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    return transformedInput;
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('integerFieldParser', integerFieldParser);

    /** @ngInject */
    function integerFieldParser() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                allowEmpty: '=',
                min: '=',
                max: '='
            },
            link: function(scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.unshift(function (inputValue) {
                    var transformedInput = inputValue ? inputValue.replace(/[^\d]/g,'') : '';
                    transformedInput = (transformedInput != '') ? (transformedInput * 1) + '' : (scope.allowEmpty ? '' : '0');
                    
                    if(parseInt(transformedInput) < scope.min) {
                        modelCtrl.$setValidity('integer', false);
                    }
                    else if(parseInt(transformedInput) > scope.max) {
                        modelCtrl.$setValidity('integer', false);
                    }
                    else {
                        modelCtrl.$setValidity('integer', true);
                    }
                    
                    if (transformedInput != inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    return parseInt(transformedInput);
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('floatFieldParser', floatFieldParser);

    /** @ngInject */
    function floatFieldParser() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                decimalLimit: '=?',
                min: '=?',
                max: '=?'
            },
            link: function(scope, element, attrs, modelCtrl) {
            
                if(scope.decimalLimit == null) {
                    scope.decimalLimit = 2;
                }
            
                modelCtrl.$parsers.unshift(function (inputValue) {
                    
                    var transformedInput = '';
                    if (inputValue) {
                        transformedInput = inputValue.replace(/[,]/g,'.');
                        transformedInput = transformedInput.replace(/[^\d.]/g,'');
                        
                        /*
                        var lastChar = transformedInput[transformedInput.length - 1];
                        
                        transformedInput = parseFloat(transformedInput) + "";
                        
                        if(lastChar == ".")
                            transformedInput += ".";
                        */
                        
                        var commaIndex = transformedInput.indexOf('.');
                        var decimal = null;
                        
                        if(commaIndex == 0)
                            transformedInput = "";
                        
                        else if(commaIndex > 0) {

                            while(commaIndex < transformedInput.lastIndexOf('.')) {
                                
                                var lastCommaIndex = transformedInput.lastIndexOf('.');
                                
                                transformedInput = transformedInput.slice(0, lastCommaIndex) + transformedInput.slice(lastCommaIndex + 1);
                            }

                            transformedInput = transformedInput.slice(0, commaIndex + 1 + scope.decimalLimit);
                            
                            decimal = transformedInput.split(".")[1];
                        }
                        
                        transformedInput = transformedInput != "" ? (transformedInput * 1) + "" : "";
                        
                        if(decimal != null && decimal.length == 0)
                            transformedInput += ".";
                        
                        if(scope.min != null && parseFloat(transformedInput) < scope.min) {
                            modelCtrl.$setValidity('float', false);
                        }
                        else if(scope.max != null && parseFloat(transformedInput) > scope.max) {
                            modelCtrl.$setValidity('float', false);
                        }
                        else {
                            modelCtrl.$setValidity('float', true);
                        }
                        
                    }
                    
                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    
                    var result = parseFloat(transformedInput);
                    
                    return isNaN(result) ? null : result;
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('dateFieldParser', dateFieldParser);

    /** @ngInject */
    function dateFieldParser($window) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                dateFieldParser: '@'
            },
            link: function(scope, element, attrs, modelCtrl) {
                element.on('blur', function() {
                    if (modelCtrl.$invalid) {
                        modelCtrl.$setViewValue(null);
                        modelCtrl.$render();
                    }
                });
                modelCtrl.$parsers.unshift(function (inputValue) {
                    var valid = $window.moment(inputValue, scope.dateFieldParser, true).isValid();
                    modelCtrl.$setValidity('valid-date', (angular.isUndefined(inputValue) || inputValue == null || inputValue == '' || valid));
                    return valid ? inputValue : null;
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .filter('currencyFilter', currencyFilter);

    /** @ngInject */
    function currencyFilter($filter) {
        return function (value) {
            var text = $filter('number')(value, 2).replace(/,00/g,'');
            return text;
        }
    }
    
    angular
        .module('sigeba')
        .filter('currencyFilterNoThousands', currencyFilterNoThousands);

    /** @ngInject */
    function currencyFilterNoThousands($filter) {
        return function (value) {
            var text = $filter('number')(value, 2).replace(/\./g,'').replace(/,00/g,'');
            return text;
        }
    }
    
})();
(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('currencyFieldParser', currencyFieldParser);

    /** @ngInject */
    function currencyFieldParser($filter) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                allowEmpty: '=?',
                min: '=?',
                max: '=?'
            },
            link: function(scope, element, attrs, modelCtrl) {
                
                scope.lastValue = '';
                
                modelCtrl.$parsers.unshift(function (inputValue) {
                    var el = element[0];
                    
                    function clean(x) {
                        var text = x && x.replace(/[\.]/g,',').replace(/[^\d,]/g,'');
                        
                        var commaCount = (text.match(/,/g) || []).length;
                        
                        if (commaCount > 1)
                            return scope.lastValue;
                        
                        var commaIndex = text.indexOf(',');
                        var integer = null;
                        var decimal = null;
                        
                        if (commaIndex == 0) {
                            integer = '0';
                            decimal = text.split(",")[1];
                        }
                        else if(commaIndex > 0) {
                            integer = text.split(",")[0] * 1;
                            decimal = text.split(",")[1];
                        }
                        else {
                            integer = text * 1;
                        }
                        
                        if (decimal != null && decimal.length > 2)
                            return scope.lastValue;
                        
                        return (decimal === null ? integer + '' : integer + ',' + decimal);
                    }
                    
                    var cleaned = clean(inputValue + '');

                    if (cleaned !== inputValue) {
                        var start = el.selectionStart;
                        var end = el.selectionEnd + cleaned.length - inputValue.length;

                        modelCtrl.$setViewValue(cleaned);
                        modelCtrl.$render();

                        el.setSelectionRange(start, end);
                    }
                    
                    scope.lastValue = cleaned;
                    
                    return cleaned.replace(/,/g,'.') * 1;
                });
            
                modelCtrl.$formatters.unshift(function (value) {
                    var text = $filter('number')(value, 2).replace(/[\.]/g,'').replace(/,00/g,'');
                    
                    return text;
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('feedCompilatiCert', feedCompilatiCert);

    /** @ngInject */
    function feedCompilatiCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/feedCompilatiCert/feedCompilatiCert.html',
            scope: {},
            bindToController: {
                proposta: "="
            },
            controller: FeedCompilatiCertController,
            controllerAs: 'feedCompCtrl'
        };

        return directive;

        /** @ngInject */
        function FeedCompilatiCertController(ProposteService) {
            var vm = this;

            ProposteService.getFeedPropostaCertById(vm.proposta).then(function (data) {
                vm.feed = data;
            });


        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editStatusIstanzaNotes', editStatusIstanzaNotes);

    /** @ngInject */
    function editStatusIstanzaNotes() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editStatusIstanzaNotes/editStatusIstanzaNotes.html',
            scope: {},
            bindToController: {
                confirm: '=',
                cancel: '=',
                item: '=?',
                proposta: "="
            },
            controller: EditStatusIstanzaNotesController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function EditStatusIstanzaNotesController(ProposteService, AuthService) {
            var vm = this
            vm.saveButtonVisible = false;
            var utente = AuthService.getUserInfo().utente;
            vm.isPresidente = utente.presidenteCommissioneCert || utente.tipoUtente == "UFFICIO_CERT";
            vm.noteMembri = null;
            vm.handleClose = handleClose
            vm.showSaveButton = showSaveButton
            vm.salvaModificaNote = salvaModificaNote

            ProposteService.getAllNoteProposta(vm.proposta).then(function (data) {
                vm.noteMembri = data;

            });

            function salvaModificaNote() {
                vm.confirm(vm.noteMembri)
            }

            function showSaveButton() {
                vm.saveButtonVisible = true;
            }

            function handleClose( data ) {
                vm.cancel( data )
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editStatusIstanza', editStatusIstanza);

    /** @ngInject */
    function editStatusIstanza() {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editStatusIstanza/editStatusIstanza.html',
            scope: {},
            bindToController: {
                confirm: '=',
                proposta: "=",
                cancel: '='
            },
            controller: EditStatusIstanzaController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function EditStatusIstanzaController(AuthService, ProposteService, SeduteCertService) {

            var vm = this
            var loggedUser = AuthService.getUserInfo().utente
            vm.contaMembriPresenti = contaMembriPresenti
            vm.numeroDelibera = null
            vm.selectedStatus = null
            vm.valutationNotes = ""
            vm.notePresidenteCert = ""
            vm.noteComponenti = ""
            vm.noteCambioStato = ""
            vm.conflittoDiInteressi = false
            vm.membriCommissione = []

            vm.favorevoli = null;
            vm.astenuti = null;
            vm.contrari = null;

            // vm.hasTextArea = null

            // vm.changeValutazioneStatus = changeValutazioneStatus
            vm.visibilitaValutazione = visibilitaValutazione
            vm.handleSuccess = handleSuccess
            vm.handleClose = handleClose

            // function changeValutazioneStatus() {
            //     vm.hasTextArea = vm.selectedStatus == "APPROVATA_CONDIZIONE" || vm.selectedStatus == "REVISIONE" ? true : false
            // }

            // Recupero se presente la nota inserita dall'utente
            ProposteService.getInfoMembroCommissione(vm.proposta.id).then(function (data) {
                vm.valutationNotes = data.note;
                vm.conflittoDiInteressi = data.conflittoDiInteressi;
            });

            // Se sono presidente recupero tutti i membri della commissione
            if (visibilitaValutazione()) {
                SeduteCertService.getCertMembriPropostaBySeduta(vm.proposta.certSeduta.id)
                    .then(function (data) {
                        vm.membriCommissione = data;
                        vm.membriPresenti = contaMembriPresenti();
                        vm.favorevoli = vm.membriPresenti;
                    });

            }

            function handleSuccess() {

                if (visibilitaValutazione()) {
                    if (!vm.selectedStatus && vm.selectedStatus != "REVISIONE") {
                        alert("Selezionare una valutazione")
                        return
                    } else if (!vm.selectedStatus) {
                        alert("Selezionare una valutazione per l'istanza")
                        return
                    }if (!vm.numeroDelibera || vm.numeroDelibera === 0) {
                        alert("Inserire il Numero Delibera")
                        return
                    }

                    if ((vm.selectedStatus == "APPROVATA_CONDIZIONE" || vm.selectedStatus == "APPROVATA" || vm.selectedStatus == "NON_APPROVATA") && !vm.noteComponenti) {
                        alert("Inserire note componenti")
                        return
                    }
                    if (/*(vm.selectedStatus == "APPROVATA_CONDIZIONE" || vm.selectedStatus == "APPROVATA" || vm.selectedStatus == "REVISIONE" || vm.selectedStatus == "NON_APPROVATA") &&*/ !vm.valutationNotes) {
                        alert("Inserisci una nota")
                        return
                    }
                    var conteggioPresenti = 0;
                    var favorevoli = vm.favorevoli ? vm.favorevoli : 0;
                    var astenuti = vm.astenuti ? vm.astenuti : 0;
                    var contrari = vm.contrari ? vm.contrari : 0;

                    for (var i = 0; i < vm.membriCommissione.length; i++) {
                        if (vm.membriCommissione[i].presente)
                            conteggioPresenti++
                    }

                    if (vm.selectedStatus == "REVISIONE") {
                        vm.membriCommissione = null;
                        vm.dataSeduta = null;
                    } else {
                        if (favorevoli + astenuti + contrari !== conteggioPresenti) {
                            alert("Il totale votanti non corrisponde al numero dei presenti")
                            return;
                        }
                    }
                }

                if (vm.proposta.membroProposta && vm.proposta.membroProposta.length ) {
                    var membro = vm.proposta.membroProposta.find( function( membro ) {
                        return ( membro.certMembroCommissione.id == loggedUser.id )
                    })
                    if (membro && membro.flag_minor_major &&
                        (membro.flag_minor_major == 'Relatore 2' || membro.flag_minor_major == 'Relatore 1' || membro.flag_minor_major == 'Assegnatario principale') && !vm.valutationNotes) {
                        alert("Inserisci una nota")
                        return
                    }
                }

                var data = {
                    valutation: vm.selectedStatus,
                    valutationNotes: vm.valutationNotes,
                    numeroDelibera: vm.numeroDelibera,
                    noteComponenti: vm.noteComponenti,
                    noteCambioStato: vm.noteCambioStato,
                    conflittoInteressi: vm.conflittoDiInteressi,
                    dataSeduta: vm.dataSeduta,
                    membriCommissione: vm.membriCommissione,
                    favorevoli: vm.favorevoli || 0,
                    astenuti: vm.astenuti || 0,
                    contrari: vm.contrari || 0,
                    notePresidenteCert: vm.notePresidenteCert
                }
                vm.confirm(data)
            }

            function visibilitaValutazione() {
                var isPresidente = loggedUser.presidenteCommissioneCert
                var isCert = loggedUser.tipoUtente == 'UFFICIO_CERT'
                return ( isPresidente || isCert ) ? true : false
            }

            function contaMembriPresenti() {
                var conta = 0;
                if (vm.membriCommissione) {
                    for (var i = 0; i < vm.membriCommissione.length; i++) {
                        if (vm.membriCommissione[i].presente)
                            conta++
                    }
                }
                vm.membriPresenti = conta;
                return conta
            }

            function handleClose( data ) {
                vm.cancel( data )
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editRendicontazioneDate', editRendicontazioneDate);

    /** @ngInject */
    function editRendicontazioneDate() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRendicontazioneDate/editRendicontazioneDate.html',
            scope: {},
            bindToController: {
                rendicontazione: '=',
                classe: '=',
                close: '='
            },
            controller: EditRendicontazioneDateController,
            controllerAs: 'editRendDateCtrl'
        };

        return directive;

        /** @ngInject */
        function EditRendicontazioneDateController(PubblicazioniService, $log, $timeout, moment, StepRendicontazioneService, ngDialog) {
            var vm = this;
            
            vm.confirmLoading = false;
            vm.period = null;
            
            vm.confirm = confirm;
            vm.isValidPeriod = isValidPeriod;
            
            
            init();
            
            function init() {
                
                if(vm.rendicontazione.startTimestamp && vm.rendicontazione.endTimestamp) {
                    vm.period = {
                        since: moment(vm.rendicontazione.startTimestamp).format('DD/MM/YYYY'),
                        sinceTime: new Date(vm.rendicontazione.startTimestamp),
                        until: moment(vm.rendicontazione.endTimestamp).format('DD/MM/YYYY'),
                        untilTime: new Date(vm.rendicontazione.endTimestamp)
                    }
                }
                else {
                    vm.period = null;
                }
                
                vm.theoExpiration = new Date(moment(vm.classe.dataUfficializzazione, 'DD/MM/YYYY HH:mm:ss').add(vm.rendicontazione.mesi, 'M'));
            }
            
            function confirm() {
                
                vm.confirmLoading = true;
                
                var since = composeDate(vm.period.since, vm.period.sinceTime);
                var until = composeDate(vm.period.until, vm.period.untilTime);
                
                StepRendicontazioneService.updatePeriod(vm.rendicontazione.idStep, since.format('DD/MM/YYYY HH:mm'), until.format('DD/MM/YYYY HH:mm'))
                    .then(function() {
                        vm.close("confirmCallback");
                    })
                    .catch(function(error) {
                        $log.error("Errore nell'update del periodo", error);
                        showErrorDialog();
                        vm.confirmLoading = false;
                    });
                
            }
            
            function isValidPeriod() {
                var since = composeDate(vm.period.since, vm.period.sinceTime);
                var until = composeDate(vm.period.until, vm.period.untilTime);
                
                if(!since || !until)
                    return false;
                
                return since.valueOf() <= until.valueOf();
            }
            
            function composeDate(dateString, time) {
                
                if(!dateString || !time)
                    return null;
                
                var momentDate = moment(dateString + ' ' + moment(time).format('HH:mm'), 'DD/MM/YYYY HH:mm');
                return momentDate.isValid() ? momentDate : null;
            }
            
            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });
                
                return dialog;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editRendicontazione', editRendicontazione);

    /** @ngInject */
    function editRendicontazione() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRendicontazione/editRendicontazione.html',
            scope: {},
            bindToController: {
                rendicontazioneId: '=?',
                propostaId: '=?',
                stepId: '=?'
            },
            controller: EditRendicontazioneController,
            controllerAs: 'formRend'
        };

        return directive;

        /** @ngInject */
        function EditRendicontazioneController(RendicontazioniService, FormService, $log, $q, $state, ngDialog, $scope, $timeout/*, $window, $http*/) {
            var vm = this;

            vm.template = null;
            vm.data = null;
            vm.savedData = null;
            vm.validazione = null;
            vm.rendicontazioneSalvata = null;
            vm.rendicontazioneValidata = null;

            vm.dizionari = {};
            
            vm.salvaRendicontazione = salvaRendicontazione;
            vm.validaRendicontazione = validaRendicontazione;
            vm.inviaRendicontazione = inviaRendicontazione;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            getDatiRendicontazione()
                .then(getTemplateRendicontazione)
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della rendicontazione", error);
                    showErrorDialog(error.data.message);
                });
            
            $scope.$watch(function() { return vm.data; }, function(newValue, oldValue) {
                if (newValue != oldValue) {
                    vm.rendicontazioneSalvata = angular.equals(vm.data, vm.savedData);
                }
            }, true);

            function getDatiRendicontazione() {
                if (vm.rendicontazioneId) {
                    return RendicontazioniService.getRendicontazioneById(vm.rendicontazioneId)
                        .then(function(data) {
                            vm.data = data;
                            vm.savedData = angular.copy(data);
                            vm.validazione = null;
                            vm.rendicontazioneValidata = null;
                        });
                }
                else {
                    return RendicontazioniService.getNewRendicontazione(vm.propostaId, vm.stepId)
                        .then(function(data) {
                            vm.data = data;
                        });
                }
            }

            function getTemplateRendicontazione() {
                var formId = vm.data.formId;
                return FormService.getFormById(formId)
                    .then(function(formResult) {
                        vm.template = angular.fromJson(formResult.modello);
                    });
            }
            
            function salvaRendicontazione() {
                var savingDialog = null;
                if (vm.rendicontazioneId && vm.data.id) {
                    savingDialog = showSavingDialog();
                    // update
                    RendicontazioniService.updateRendicontazione(vm.data)
                        .then(function() {
                            $log.log('rendicontazione modificata con successo');
                            getDatiRendicontazione().then(function() {
                                savingDialog.close();
                            })
                            .catch(function(err) {
                                $log.error("Errore nel reperimento dei dati della rendicontazione", err);
                                savingDialog.close();
                                showErrorDialog(err.data.message);
                            });
                        })
                        .catch(function(error) {
                            $log.error("Errore nel salvataggio della rendicontazione", error);
                            savingDialog.close();
                            if (error && error.data && error.data.code == 2)
                                showErrorBandoDialog(error.data.message);
                            else
                                showErrorDialog(error.data.message);
                        });
                }
                else {
                    savingDialog = showSavingDialog();
                    // save
                    RendicontazioniService.saveRendicontazione(vm.data)
                        .then(function(resultData) {
                            $log.log('nuova rendicontazione salvata con successo');
                            vm.rendicontazioneId = angular.copy(resultData.id);
                            getDatiRendicontazione()
                                .then(function() {
                                    $state.go('rendicontazioneDetail', {'id': resultData.id}, {'location': 'replace', notify: false});
                                    var template = angular.copy(vm.template);
                                    vm.template = null;
                                    vm.template = template;
                                    savingDialog.close();
                                })
                                .catch(function(err) {
                                    $log.error("Errore nel reperimento dei dati della rendicontazione", err);
                                    savingDialog.close();
                                    showErrorDialog(err.data.message);
                                });
                        })
                        .catch(function(error) {
                            $log.error("Errore nel salvataggio della rendicontazione", error);
                            savingDialog.close();
                            if (error && error.data && error.data.code == 2)
                                showErrorBandoDialog(error.data.message);
                            else
                                showErrorDialog(error.data.message);
                        });
                }
            }
            
            function showSavingDialog() {
                var dialog = ngDialog.open({
                    template:'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function validaRendicontazione() {
                if (vm.rendicontazioneId) {
                    var validatingDialog = showValidatingDialog();
                    RendicontazioniService.validaRendicontazione(vm.rendicontazioneId)
                        .then(function(result) {
                            $log.log('esito validazione ottenuto');
                            vm.validazione = result;
                            vm.rendicontazioneValidata = result.valida;
                            validatingDialog.close();
                            $timeout(scrollToFirstError);
                        })
                        .catch(function(error) {
                            $log.error("impossibile ottenere l'esito della validazione", error);
                            validatingDialog.close();
                            if (error && error.data && error.data.code == 2)
                                showErrorBandoDialog(error.data.message);
                            else
                                showErrorDialog(error.data.message);
                        });
                }
            }
            
            function showValidatingDialog() {
                var dialog = ngDialog.open({
                    template:'Validazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function scrollToFirstError() {
                var $container = angular.element('.mainContainer').first();
                var $target = angular.element('.withErrors').first();
                if ($target.length)
                    $container.animate({scrollTop: $container.scrollTop() + ($target.offset().top - $container.offset().top - 80)}, "swing");
            }
            
            function inviaRendicontazione() {
                if (vm.rendicontazioneId) {
                    var dialogTemplate = '\
                            <h3>Chiudi e invia rendicontazione</h3>\
                            <p class="alert alert-warning"><b>ATTENZIONE</b> - Una volta effettuato l\'invio non sarà più possibile modificare la rendicontazione.</p>\
                            <p>Procedere con la chiusura e l\'invio della rendicontazione?</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                            </div>';

                    var confirmDialog = ngDialog.openConfirm({
                        template: dialogTemplate,
                        plain: true
                    });

                    confirmDialog.then(function (data) {
                        if (data === true) {
                            var sendingDialog = showSendingDialog();
                            RendicontazioniService.inviaRendicontazione(vm.rendicontazioneId)
                                .then(function(result) { //eslint-disable-line no-unused-vars
                                    $log.log('rendicontazione sottomessa con successo');
                                    sendingDialog.close();
                                    $state.go('rendicontazione');
                                })
                                .catch(function(error) {
                                    $log.error("errore nella sottomissione della rendicontazione", error);
                                    sendingDialog.close();
                                    if (error && error.data && error.data.code == 2)
                                        showErrorBandoDialog(error.data.message);
                                    else
                                        showErrorDialog(error.data.message);
                                });
                        }
                    });
                }
            }
            
            function showSendingDialog() {
                var dialog = ngDialog.open({
                    template:'Invio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });
                
                return dialog;
            }
            
            function showErrorBandoDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Termine presentazione domande</h3><div class="well"><b>Impossibile completare l\'operazione richiesta poiché sono scaduti i termini per la presentazione delle domande del bando.</b></div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });
                
                return dialog;
            }
        }
    }
    
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editRefereeDipartimento', editRefereeDipartimento);

    /** @ngInject */
    function editRefereeDipartimento() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRefereeDipartimento/editRefereeDipartimento.html',
            scope: {},
            bindToController: {
                dipartimentoId: '=',
                confirm: '=',
                cancel: '='
            },
            controller: EditRefereeDipartimentoController,
            controllerAs: 'editRefDipCtrl'
        };

        return directive;

        /** @ngInject */
        function EditRefereeDipartimentoController(DipartimentiUrService, ngDialog, $log) {
            var vm = this;
            vm.dipartimento = null;

            vm.addReferee = addReferee;
            vm.removeReferee = removeReferee;
            vm.updateRefereeDipartimento = updateRefereeDipartimento;

            getDipartimento()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sul dipartimento", error);
                });


            function getDipartimento() {
                return DipartimentiUrService.getDipartimentoById(vm.dipartimentoId)
                    .then(function(data) {
                        vm.dipartimento = data;
                    });
            }

            function addReferee(modelObject, modelNameStr) {
                ngDialog.open({
                    template:'\
                        <dipartimento-add-referee model-obj="ngDialogData.modelObj" model-name="ngDialogData.modelName"></dipartimento-add-referee>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        modelObj: modelObject,
                        modelName: modelNameStr
                    }
                });
            }

            function removeReferee(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare l\'associazione del referente al dipartimento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.dipartimento.refereeList.splice(index, 1);
                    }
                });
            }

            function updateRefereeDipartimento() {
                DipartimentiUrService.updateRadRefDipartimento(vm.dipartimento)
                    .then(function() {
                        $log.log('associazioni Referee-Dipartimento salvate con successo');
                        vm.confirm(true);
                    })
                    .catch(function(error) {
                        $log.error("Errore nel salvataggio delle associazioni Referee-Dipartimento", error);
                    });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('dipartimentoAddReferee', dipartimentoAddReferee);

    /** @ngInject */
    function dipartimentoAddReferee() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRefereeDipartimento/dipartimento-add-refeere.html',
            scope: {},
            bindToController: {
                modelObj: '=',
                modelName: '='
            },
            controller: DipartimentoAddRefereeController,
            controllerAs: 'dipAddDirCtrl'
        };

        return directive;

        /** @ngInject */
        function DipartimentoAddRefereeController(UtentiService) {
            var vm = this;

            vm.searchString = '';
            vm.searching = false;
            vm.results = null;
            vm.persone = vm.modelObj[vm.modelName];

            vm.search = search;
            vm.addPerson = addPerson;

            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtentiRefereeDip(text)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le persone già selezionate
                            for (var i = 0; i < vm.results.length; i++) {
                                if (vm.persone && vm.persone.length) {
                                    for (var j = 0; j < vm.persone.length; j++) {
                                        var partecipante = vm.persone[j];
                                        if (partecipante.id == vm.results[i].utente.id) {
                                            vm.results[i].isAlreadyRequested = true;
                                            break;
                                        }
                                    }
                                }
                                else {
                                    if (vm.persone && vm.persone.id == vm.results[i].utente.id) {
                                        vm.results[i].isAlreadyRequested = true;
                                    }
                                }
                            }
                        })
                        .catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                }
                else {
                    vm.searching = false;
                }
            }

            function addPerson(result) {
                result.isAlreadyRequested = true;
                delete result.utente.ruolo;
                delete result.utente.dataDiNascita;
                delete result.utente.dipartimentoManuale;
                delete result.utente.dipartimento;
                delete result.utente.regime;
                delete result.utente.ssd;
                vm.persone.push(result.utente);
            }
        }
    }

})();

(function () {
        'use strict';

        angular
            .module('sigeba')
            .directive('strutturaAddRad', strutturaAddRad);

        /** @ngInject*/
        function strutturaAddRad() {
            var directive = {
                restrict: 'E',
                templateUrl: 'app/components/editRadStruttura/struttura-add-rad.html',
                scope: {},
                bindToController: {
                    modelObj: '=',
                    modelName: '='
                },
                controller: StrutturaAddRadController,
                controllerAs: 'strAddRadCtrl'
            };

            return directive;

            /** @ngInject*/
            function StrutturaAddRadController(UtentiService) {
                var vm = this;

                vm.searchString = '';
                vm.searching = false;
                vm.result = null;
                vm.persone = vm.modelObj[vm.modelName];

                vm.search = search;
                vm.addPerson = addPerson;

                function search(text) {
                    vm.result = null;
                    if (text != '') {
                        vm.searching = true;
                        UtentiService.getUtentiRad(text)
                            .then(function (data) {
                                vm.searching = false;
                                vm.results = data.resultList;
                                for (var i = 0; i < vm.results.length; i++) {
                                    if (vm.persone && vm.persone.length) {
                                        for (var j = 0; j < vm.persone.length; j++) {
                                            var partecipante = vm.persone[j];
                                            if (partecipante.id == vm.results[i].utente.id) {
                                                vm.results[i].isAlreadyRequested = true;
                                                break;
                                            }
                                        }
                                    } else {
                                        if (vm.persone && vm.persone.id == vm.results[i].utente.id) {
                                            vm.results[i].isAlreadyRequested = true;
                                        }
                                    }
                                }
                            })
                            .catch(function () {
                                vm.searching = false;
                                vm.result = [];
                            });
                    } else {
                        vm.searching = false;
                    }
                }

                function addPerson(result) {
                    result.isAlreadyRequested = true;
                    delete result.utente.ruolo;
                    delete result.utente.dataDiNascita;
                    delete result.utente.dipartimentoManuale;
                    delete result.utente.dipartimento;
                    delete result.utente.regime;
                    delete result.utente.ssd;
                    vm.persone[0] = result.utente;
                }

            }

        }
    }
)();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editRadStruttura', editRadStruttura);

    /** @ngInject */
    function editRadStruttura() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRadStruttura/editRadStruttura.html',
            scope: {},
            bindToController: {
                strutturaId: '=',
                confirm: '=',
                cancel: '='
            },
            controller: EditRadStrutturaController,
            controllerAs: 'editRadStrCtrl'
        };

        return directive;

        /** @ngInject */
        function EditRadStrutturaController(StruttureUrService, ngDialog, $log) {
            var vm = this;
            vm.struttura = null;

            vm.addRad = addRad;
            vm.removeRad = removeRad;
            vm.updateRadStruttura = updateRadStruttura;

            getStruttura()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulla struttura", error);
                });


            function getStruttura() {
                return StruttureUrService.getStrutturaById(vm.strutturaId)
                    .then(function(data) {
                        vm.struttura = data;
                    });
            }

            function addRad(modelObject, modelNameStr) {
                ngDialog.open({
                    template:'\
                        <struttura-add-rad model-obj="ngDialogData.modelObj" model-name="ngDialogData.modelName"></struttura-add-rad>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        modelObj: modelObject,
                        modelName: modelNameStr
                    }
                });
            }

            function removeRad(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare l\'associazione del RAD alla struttura?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.struttura.radList.splice(index, 1);
                    }
                });
            }

            function updateRadStruttura() {
                StruttureUrService.updateRadDirStruttura(vm.struttura)
                    .then(function() {
                        $log.log('associazioni RAD-Struttura salvate con successo');
                        vm.confirm(true);
                    })
                    .catch(function(error) {
                        $log.error("Errore nel salvataggio delle associazioni RAD-Struttura", error);
                    });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editRadDipartimento', editRadDipartimento);

    /** @ngInject */
    function editRadDipartimento() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRadDipartimento/editRadDipartimento.html',
            scope: {},
            bindToController: {
                dipartimentoId: '=',
                confirm: '=',
                cancel: '='
            },
            controller: EditRadDipartimentoController,
            controllerAs: 'editRadDipCtrl'
        };

        return directive;

        /** @ngInject */
        function EditRadDipartimentoController(DipartimentiUrService, ngDialog, $log) {
            var vm = this;
            vm.dipartimento = null;
            
            vm.addRad = addRad;
            vm.removeRad = removeRad;
            vm.updateRadDipartimento = updateRadDipartimento;
            
            getDipartimento()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sul dipartimento", error);
                });
            
            
            function getDipartimento() {
                return DipartimentiUrService.getDipartimentoById(vm.dipartimentoId)
                    .then(function(data) {
                        vm.dipartimento = data;
                    });
            }
            
            function addRad(modelObject, modelNameStr) {
                ngDialog.open({
                    template:'\
                        <dipartimento-add-rad model-obj="ngDialogData.modelObj" model-name="ngDialogData.modelName"></dipartimento-add-rad>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        modelObj: modelObject,
                        modelName: modelNameStr
                    }
                });
            }
            
            function removeRad(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare l\'associazione del RAD al dipartimento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.dipartimento.radList.splice(index, 1);
                    }
                });
            }
            
            function updateRadDipartimento() {
                DipartimentiUrService.updateRadDirDipartimento(vm.dipartimento)
                    .then(function() {
                        $log.log('associazioni RAD-Dipartimento salvate con successo');
                        vm.confirm(true);
                    })
                    .catch(function(error) {
                        $log.error("Errore nel salvataggio delle associazioni RAD-Dipartimento", error);
                    });
            }
            /*
            vm.searchString = '';
            vm.searching = false;
            vm.results = null;
            vm.persone = vm.modelObj[vm.modelName];
            
            vm.search = search;
            vm.maxNumReached = maxNumReached;
            vm.addPerson = addPerson;
            
            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtentiMC(text)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le persone già selezionate
                            for (var i = 0; i < vm.results.length; i++) {
                                if (vm.persone && vm.persone.length) {
                                    for (var j = 0; j < vm.persone.length; j++) {
                                        var partecipante = vm.persone[j];
                                        if (partecipante.utenteId == vm.results[i].utente.id) {
                                            vm.results[i].isAlreadyRequested = true;
                                            break;
                                        }
                                    }
                                }
                                else {
                                    if (vm.persone && vm.persone.utenteId == vm.results[i].utente.id) {
                                        vm.results[i].isAlreadyRequested = true;
                                    }
                                }
                            }
                        })
                        .catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                }
                else {
                    vm.searching = false;
                }
            }
            
            function maxNumReached() {
                if (angular.isArray(vm.persone))
                    return (vm.numMax && vm.persone.length >= vm.numMax);
                else
                    return (vm.persone != null);
            }
            
            function addPerson(result) {
                result.isAlreadyRequested = true;
                result.utente.utenteId = result.utente.id;
                result.utente.id = 0;
                delete result.utente.dataDiNascita;
                delete result.utente.email;
                delete result.utente.tipoUtente;
                delete result.utente.dipartimentoManuale;
                delete result.utente.regime;
                if (vm.numMax == 1) {
                    vm.persone = result.utente;
                    vm.modelObj[vm.modelName] = result.utente;
                }
                else
                    vm.persone.push(result.utente);
            }
            */
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('dipartimentoAddRad', dipartimentoAddRad);

    /** @ngInject */
    function dipartimentoAddRad() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editRadDipartimento/dipartimento-add-rad.html',
            scope: {},
            bindToController: {
                modelObj: '=',
                modelName: '='
            },
            controller: DipartimentoAddRadController,
            controllerAs: 'dipAddRadCtrl'
        };

        return directive;

        /** @ngInject */
        function DipartimentoAddRadController(UtentiService) {
            var vm = this;

            vm.searchString = '';
            vm.searching = false;
            vm.results = null;
            vm.persone = vm.modelObj[vm.modelName];

            vm.search = search;
            vm.addPerson = addPerson;

            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtentiRad(text)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le persone già selezionate
                            for (var i = 0; i < vm.results.length; i++) {
                                if (vm.persone && vm.persone.length) {
                                    for (var j = 0; j < vm.persone.length; j++) {
                                        var partecipante = vm.persone[j];
                                        if (partecipante.id == vm.results[i].utente.id) {
                                            vm.results[i].isAlreadyRequested = true;
                                            break;
                                        }
                                    }
                                } else {
                                    if (vm.persone && vm.persone.id == vm.results[i].utente.id) {
                                        vm.results[i].isAlreadyRequested = true;
                                    }
                                }
                            }
                        })
                        .catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                }
                else {
                    vm.searching = false;
                }
            }

            function addPerson(result) {
                result.isAlreadyRequested = true;
                delete result.utente.ruolo;
                delete result.utente.dataDiNascita;
                delete result.utente.dipartimentoManuale;
                delete result.utente.dipartimento;
                delete result.utente.regime;
                delete result.utente.ssd;
                vm.persone.push(result.utente);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editPropostaPartecipante', editPropostaPartecipante);

    /** @ngInject */
    function editPropostaPartecipante() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editPropostaPartecipante/editPropostaPartecipante.html',
            scope: {},
            bindToController: {
                propostaId: '=?'
            },
            controller: FormPartecipanteController,
            controllerAs: 'form'
        };

        return directive;

        /** @ngInject */
        function FormPartecipanteController(ProposteService, FormService, SettoriErcService, SottoSettoriErcService, $scope, $log, $q, $state, ngDialog/*, $http*/) {
            var vm = this;

            vm.template = null;
            vm.data = null;
            vm.savedData = null;
            vm.propostaSalvata = null;

            vm.dizionari = {};
            
            vm.salvaPropostaPart = salvaPropostaPart;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            getDizionari()
                .then(getDatiPropostaPart)
                .then(getTemplatePropostaPart)
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della proposta", error);
                    showErrorDialog(error.data.message);
                });

            $scope.$watch(function() { return vm.data; }, function(newValue, oldValue) {
                if (newValue != oldValue) {
                    vm.propostaSalvata = angular.equals(vm.data, vm.savedData);
                }
            }, true);

            function getDizionari() {
                return $q.all([
                    SettoriErcService.getSettoriERC()
                        .then(function(data) {
                            vm.dizionari.settoriERC = addLabels(data, "codice + ' - ' + nome");
                        }),
                    SottoSettoriErcService.getSottoSettoriERC()
                        .then(function(data) {
                            vm.dizionari.sottoSettoriERC = addLabels(data, "codice + ' - ' + descrizione");
                        })
                ]);
            }
            
            function addLabels(array, labelExpression) {
                var elements = [];
                for (var i = 0; i < array.length; i++) {
                    elements.push({
                        id: array[i].id,
                        label: $scope.$eval(labelExpression, array[i]),
                        item: array[i]
                    });
                }
                return elements;
            }

            function getDatiPropostaPart() {
                return ProposteService.getPropostaPartById(vm.propostaId)
                    .then(function(data) {
                        vm.data = data;
                        vm.savedData = angular.copy(data);
                    });
            }

            function getTemplatePropostaPart() {
                var formId = vm.data.formId;
                return FormService.getFormById(formId)
                    .then(function(formResult) {
                        vm.template = angular.fromJson(formResult.modello);
                    });
            }
/*
            function getTemplatePropostaPart() {
                var templateName = 'coproponente';
                if (vm.data.categoriaUtente == 'Componente')
                    templateName = 'partecipante';
                else if (vm.data.categoriaUtente == 'Co-proponente')
                    templateName = 'coproponente';
                if (templateName != null) {
                    return $http.get('assets/template-form/' + templateName + '.json')
                        .then(function(resultTemplate) {
                            vm.template = resultTemplate.data;
                        });
                }
                else
                    return $q.reject("L'utente non può compilare la form");
            }
*/
            function salvaPropostaPart() {
                var savingDialog = showSavingDialog();
                ProposteService.updatePropostaPart(vm.data)
                    .then(function() {
                        $log.log('proposta partecipante modificata con successo');
                        getDatiPropostaPart().then(function() {
                            savingDialog.close();
                        })
                        .catch(function(err) {
                            $log.error("Errore nel reperimento dei dati della proposta", err);
                            savingDialog.close();
                            showErrorDialog(err.data.message);
                        });
                    })
                    .catch(function(err) {
                        $log.error("Errore nel salvataggio della proposta partecipante", err);
                        savingDialog.close();
                        showErrorDialog(err.data.message);
                    });
            }
            
            function showSavingDialog() {
                var savingDialog = ngDialog.open({
                    template:'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return savingDialog;
            }
            
            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });
                
                return dialog;
            }
        }
    }
    
})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('editPropostaCert', editPropostaCert);

    /** @ngInject */
    function editPropostaCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editPropostaCert/editPropostaCert.html',
            scope: {},
            bindToController: {
                propostaId: '=?'
            },
            controller: FormController,
            controllerAs: 'form'
        };

        return directive;

        /** @ngInject */
        function FormController(ProposteService, $scope, $log, $rootScope, AuthService, $state, ngDialog) {

            var vm = this;
            var role = AuthService.getUserInfo().utente.tipoUtente;
            var dynamicSectionsStorage = {}
            var registredInputs = []

            vm.propostaSalvata = false
            vm.propostaValidata = null
            vm.readOnlyDisplay = {}
            vm.loading = false

            vm.salvaProposta = salvaProposta;
            vm.validaProposta = validaProposta;
            vm.inviaProposta = inviaProposta;
            vm.loadProposteCert = loadProposteCert

            // flusso 2
            var macrodomanda_flusso2=null;
            var flusso2_risposta29 = null;
            var flusso2_risposta28 = null;
            var flusso2_risposta270 = null;
            var flusso2_risposta30 = null;
            var hasFeed2 = false;
            // flusso 5
            var macrodomanda_flusso5=null;
            var flusso5_risposta41 = null;
            var flusso5_risposta42 = null;
            var hasFeed5a = false,hasFeed5b = false;
            // flusso 8
            var macrodomanda_flusso8=null;
            var flusso8_risposta49 = null;
            var flusso8_risposta50 = null;
            var hasFeed8a = false, hasFeed8b = false, hasFeed8c = false;

            onMount()
            function onMount() {
                loadProposteCert(vm.propostaId)
            }

            var listenerUpdateValidation = $rootScope.$on('updateValidation', function (e, data) {
                vm.propostaValidata = null
                manageValidationData(data)
            })

            var listenerRemoveValidation = $rootScope.$on('removeValidationInstance', function (e, uid) {
                removeDestroiedInputs(uid)
            })

            var listenerSetTitle = $rootScope.$on('setTitle', function (e, title) {
                vm.proposta.titolo = title
            })

            var listenerNonValutabile = $rootScope.$on('istanzaNonValutabile', function (e) {
                initFlussoNonValutabil()
            })

            var listenerRemForm = $rootScope.$on('removeFormulario', function (e, data) {
                var feed1 = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 9 });
                var feed3 = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 11 });
                var feed4 = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 12 });
                var feed6 = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 14 });
                var feed7a = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 15 });
                var feed7b = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 16 });
                var feed9 = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 20 });
                if(feed1 || feed3 || feed4 ||feed6 ||feed9 || feed7a || feed7b){
                    removeExpansionSection(data)
                }else{
                    var feed2 = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 10 });
                    if (feed2 && hasFeed2) {
                        if (macrodomanda_flusso2 != true || flusso2_risposta28 != true  || (flusso2_risposta29 != true && flusso2_risposta270 != true && flusso2_risposta30 != true)) {
                            hasFeed2 = false;
                            removeExpansionSection(feed2.id)
                        }
                    }

                    var feed5a = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 13 });
                    var feed5b = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 23 });
                    if(feed5a && hasFeed5a){
                        if(macrodomanda_flusso5 != true || flusso5_risposta41 != true) {
                            hasFeed5a=false;
                            removeExpansionSection(feed5a.id)
                        }
                    }
                    if(feed5b && hasFeed5b){
                        if(macrodomanda_flusso5 != true || flusso5_risposta42 != true) {
                            hasFeed5b=false;
                            removeExpansionSection(feed5b.id)
                        }
                    }
                    var feed8a = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 17 });
                    if(macrodomanda_flusso8 != true ){
                        if(hasFeed8a){
                            hasFeed8a = false;
                            removeExpansionSection(feed8a.id)
                        }

                        var feed8b = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 18 });
                        if (hasFeed8b) {
                            hasFeed8b = false;
                            removeExpansionSection(feed8b.id)
                        }

                        var feed8c = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 19 });

                        if (hasFeed8c) {
                            hasFeed8c = false;
                            removeExpansionSection(feed8c.id)
                        }
                    } else{
                        if (feed8a && hasFeed8a) {
                            if (flusso8_risposta49 != true) {
                                hasFeed8a = false;
                                removeExpansionSection(feed8a.id)
                            }
                        }
                        var feed8b = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 18 });
                        if (feed8b && hasFeed8b) {
                            if (flusso8_risposta50 != true) {
                                hasFeed8b = false;
                                removeExpansionSection(feed8b.id)
                            }
                        }
                        var feed8c = vm.formulario.sezioniFormulario.find(function (item) { return item.sezione.id == 19 });
                        if (feed8c && hasFeed8c) {
                            if (flusso8_risposta49 != true && flusso8_risposta50 != true) {
                                hasFeed8c = false;
                                removeExpansionSection(feed8c.id)
                            }
                        }

                    }
                }
            })

            var listenerCollSec = $rootScope.$on('collateralSection', function (e, data) {
                $rootScope.$broadcast('propagateFlip', data);
            })

            var listenerAddForm = $rootScope.$on('pushFormulario', function (e, data) {
                switch (data.sezione.id) {
                    case 10:
                        if (!hasFeed2) {
                            storeExpansionSection(data)
                            hasFeed2 = true;
                        } else
                            dynamicSectionsStorage[data.refLink] = data.sezione
                        break;
                    case 13:
                        if (!hasFeed5a) {
                            storeExpansionSection(data)
                            hasFeed5a = true;
                        } else
                            dynamicSectionsStorage[data.refLink] = data.sezione
                        break;
                    case 23:
                        if (!hasFeed5b) {
                            storeExpansionSection(data)
                            hasFeed5b = true;
                        } else
                            dynamicSectionsStorage[data.refLink] = data.sezione
                        break;
                    case 17:
                        if (!hasFeed8a) {
                            storeExpansionSection(data)
                            hasFeed8a = true;
                        } else
                            dynamicSectionsStorage[data.refLink] = data.sezione
                        break;
                    case 18:
                        if (!hasFeed8b) {
                            storeExpansionSection(data)
                            hasFeed8b = true;
                        } else
                            dynamicSectionsStorage[data.refLink] = data.sezione
                        break;
                    case 19:
                        if (!hasFeed8c) {
                            storeExpansionSection(data)
                            hasFeed8c = true;
                        } else
                            dynamicSectionsStorage[data.refLink] = data.sezione
                        break;
                    default:
                        storeExpansionSection(data)
                        break;
                }
            })

            var listenerFlussi = $rootScope.$on('checkFlussi', function (e, data) {
                flussiHandler(data)
            })

            $scope.$on("$destroy", function () {
                // Distrugge i listener
                listenerUpdateValidation()
                listenerRemoveValidation()
                listenerSetTitle()
                listenerNonValutabile()
                listenerRemForm()
                listenerCollSec()
                listenerAddForm()
                listenerFlussi()
            });

            function loadProposteCert(id) {
                ProposteService.getFormularioCertById(id)
                    .then(function (data) {

                        vm.proposta = data
                        vm.formulario = data.formulario
                        vm.esterno = data.utenteProponente.esterno
                        formatReadonly()
                        checkForPreviousSessions()
                    }).catch(function (error) {
                        $log.error("Error getFormularioCertById", error);
                        leaveDetail()
                    });

            }

            function formatReadonly() {

                var data = vm.formulario

                // Cerco i campi readonly nel primo blocco del riepilogo
                var readonly = data.sezioniFormulario[0].sezione.campi.filter(function (item) {
                    return item.flagReadOnly === true && displayInRecap.includes(item.label)
                })

                vm.readOnlyDisplay.title = readonly[0].label // Il primo item è sempre il titolo
                readonly.shift()
                vm.readOnlyDisplay.items = []
                readonly.forEach(function (item) {
                    vm.readOnlyDisplay.items.push({
                        label: item.label,
                        value: item.valoreDatoProposta
                    })
                })

            }

            function salvaProposta() {
                vm.loading = true
                ProposteService.putUpdatePropostaCert(clearPropostaDTO())
                    .then(function (data) {
                        vm.propostaSalvata = true;
                        vm.loading = false
                    }).catch(function (error) {
                        $log.error("Error updatePropostaCert", error);
                        vm.loading = false
                    });
                vm.propostaValidata = null;
            }

            function initFlussoNonValutabil() {
                vm.loading = true

                $log.info("loading",vm.loading)

                var query = {
                    'propostaCertId': vm.propostaId,
                    'statoId': 7,
                    'note': null
                }

                ProposteService.putUpdatePropostaCert(clearPropostaDTO())
                    .then(function () {

                        ProposteService.putUpdateStatoPropostaCert(query)
                        .then(function () {
                            leaveDetail()
                        }).catch(function (error) {
                            $log.error("Error updatePropostaCert", error);
                            vm.loading = false
                        });

                    }).catch(function (error) {
                        $log.error("Error updatePropostaCert", error);
                        vm.loading = false
                    });
            }

            function inviaProposta() {
                vm.loading = true
                var query = {
                    'propostaCertId': vm.propostaId,
                    'statoId': 6,
                    'note': null
                }
                // 1. Salvo il l'istanza del formulario
                ProposteService.putUpdatePropostaCert(clearPropostaDTO())
                    .then(function (data) {
                        // 2. Effettuo il cambio di stato
                        ProposteService.putUpdateStatoPropostaCert(query)
                            .then(function (data) {
                                leaveDetail()
                            }).catch(function (error) {
                            $log.error("Error updatePropostaCert", error);
                            vm.loading = false
                        });
                    }).catch(function (error) {
                    $log.error("Error updatePropostaCert", error);
                    vm.loading = false
                });
            }

            function leaveDetail() {
                var detailPath = ( role == 'UFFICIO_CERT' ) ? 'listaIstanzeUserCert' : 'listaIstanzeUser'
                setTimeout(function(){
                    $state.go(detailPath)
                },100)
            }

            function clearPropostaDTO() {

                var mirror = JSON.parse(angular.toJson(vm.proposta))
                var banned = ['uid', 'uidRef', 'refLink', 'sezioneRecovery', 'selected']

                mirror.formulario.sezioniFormulario = mirror.formulario.sezioniFormulario
                    .filter(function (item) {
                        return (!item.id)
                    })

                var output = JSON.parse(
                    angular.toJson(mirror),
                    function (key, value) {
                        var instanceOfFeed = (key == 'sezioneSuccessiva' && typeof value == 'string')

                        if (instanceOfFeed) {
                            return JSON.parse(
                                angular.toJson(dynamicSectionsStorage[value]),
                                function (key, value) {
                                    return banned.includes(key) ? undefined : value
                                }
                            )
                        }
                        return banned.includes(key) ? undefined : value
                    }
                );

                return output
            }

            function validaProposta() {
                registredInputs = [];
                var doc = vm.proposta.formulario.sezioniFormulario[0].sezione.campi.find(function (item) { return item.id == 361 });
                var qualifica = vm.proposta.formulario.sezioniFormulario[0].sezione.campi.find(function (item) { return item.id == 4 });


                $rootScope.$broadcast('triggerAtomicValidation');


                var hasErrors = Object.values(registredInputs).filter(function (item) {
                    return item.valid === false
                })
                vm.propostaValidata = (hasErrors && hasErrors.length) ?  false : true

                if((qualifica.valoreDatoProposta === ('Dottorando') || qualifica.valoreDatoProposta === ('Titolare di Assegno di ricerca')) && doc.valoreDatoProposta === null){
                    vm.propostaValidata = false;
                    openModalAlert("Dottorandi e Assegnisti devono allegare l'autodichiarazione");
                }


                if (vm.propostaValidata) {
                    // se non è uscito alcun feed, modal per cambio stato
                    var hasFeed = vm.proposta.formulario.sezioniFormulario.length > 4;
                    if (!hasFeed) {
                        ngDialog.openConfirm({
                            showClose: false,
                            template: '\
                        <h3 style="margin-bottom: 25px">Attenzione</h3>\
                        <p style="margin-bottom: 25px;font-size: 18px" ng-bind-html="message"/>\
                        <p><b>Proseguendo l\'istanza non sarà più valutabile da CER e non si potrà più modificare, sei sicuro di proseguire?</b></p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="customClose()">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="customConfirm()">Sì</button>\
                        </div>',
                            controller: ['$scope', function ($dialogScope) {

                                $dialogScope.message = 'Non è possibile la compilazione di feed in questo ambito per la valutazione CER della proposta di ricerca perché di competenza del Comitato Etico del S.S.N.'
                                $dialogScope.customConfirm = customConfirm
                                $dialogScope.customClose = customClose

                                function customConfirm() {
                                    // console.log("NON VALUTABILE")
                                    $dialogScope.closeThisDialog(0)
                                    initFlussoNonValutabil()
                                }

                                function customClose() {
                                    $dialogScope.closeThisDialog(0)
                                }

                            }],
                            plain: true
                        });

                        vm.propostaValidata = false
                        return
                    }
                }

            }

            function manageValidationData(data) {
                registredInputs[data.id] = {
                    required: data.required,
                    valid: data.valid,
                    vm: data.vm
                }
            }

            function removeDestroiedInputs(uid) {
                if ( !uid ) return
                delete registredInputs[uid]
            }

            function storeExpansionSection(data) {
                var toAdd = {
                    id: data.refLink,
                    numOrdine: data.sezione.numOrdine || data.sezione.id,
                    titolo: data.sezione.titolo,
                    sezione: data.sezione
                }

                dynamicSectionsStorage[data.refLink] = data.sezione
                // Aggiungo l'item al formulario
                vm.formulario.sezioniFormulario.push(toAdd)
                // Riordino gli item del formulario in base alla prop numOrdine
                vm.formulario.sezioniFormulario.sort(function (a, b) {
                    return (a.numOrdine - b.numOrdine);
                })
            }

            function removeExpansionSection( uid ) {
                vm.formulario.sezioniFormulario.forEach(function (item, index) {
                    if (item.id == uid) {
                        vm.formulario.sezioniFormulario.splice(index, 1)
                    }
                })
            }

            function flussiHandler(data) {
                //AGGIUNGERE L'id da fpc-radio-group.directive.js, bisogna aggiungere l'id del record cert_campo al case
                //vedere checkFlussi di fpc-radio-group.directive per vedere come passare il data
                switch (data.id) {
                    case 13:
                        macrodomanda_flusso2 = data.risposta
                        break;
                    case 16:
                        macrodomanda_flusso5 = data.risposta
                        break;
                    case 19:
                        macrodomanda_flusso8 = data.risposta
                        break;
                    case 28:
                        flusso2_risposta28 = data.risposta
                        break;
                    case 29:
                        flusso2_risposta29 = data.risposta
                        break;
                    case 270:
                        flusso2_risposta270 = data.risposta
                        break;
                    case 30:
                        flusso2_risposta30 = data.risposta
                        break;
                    case 49:
                        flusso8_risposta49 = data.risposta
                        break;
                    case 50:
                        flusso8_risposta50 = data.risposta
                        break;
                    case 41:
                        flusso5_risposta41 = data.risposta
                        break;
                    case 42:
                        flusso5_risposta42 = data.risposta
                        break;
                    default:
                        break;
                }

                if (data.idSezione == 10) { // Alert Flusso 2
                    if (data.viewModal && flusso2_risposta29 == false && flusso2_risposta28 == false && flusso2_risposta270 == false && flusso2_risposta30 == false) {
                        openModalAlert('Non è necessaria la compilazione di feed in questo ambito per la valutazione CER della proposta di ricerca');
                    }
                } else if (data.idSezione == 19) { // Alert Flusso 8
                    if (data.viewModal && flusso8_risposta49 == false && flusso8_risposta50 == false) {
                        //openModalAlert();
                    }
                } else if (data.idSezione == 13) // Alert Flusso 5
                    if (data.viewModal && flusso5_risposta41 == true && flusso5_risposta42 == true) { // ho tutti e due "no"
                        openModalAlert('Non è necessaria la compilazione di feed in questo ambito per la valutazione CER della proposta di ricerca');
                    }
            }

            function openModalAlert(message) {
                // alert
                ngDialog.openConfirm({
                    showClose: false,
                    template: '\
                            <h3 style="margin-bottom: 25px">Attenzione</h3>\
                            <p style="margin-bottom: 25px;font-size: 18px" ng-bind-html="message"/>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="customClose()">Chiudi</button>\
                            </div>',
                    controller: ['$scope', function ($dialogScope) {

                        $dialogScope.message = message
                        $dialogScope.customClose = customClose

                        function customClose() {
                            $dialogScope.closeThisDialog(0)
                        }

                    }],
                    plain: true
                })
            }

            function checkForPreviousSessions() {
                var savedSession = JSON.parse(vm.proposta.datiProposta)
                if (!savedSession) return
                recursiveFillFromSession(savedSession.sezioniFormulario, vm.formulario.sezioniFormulario)
            }

            function recursiveFillFromSession(store, data) {
                store.forEach(function (child, index) {

                    if (child.campoSuccessivo) {

                        if ( child.campoSuccessivo.valoreDatoProposta ) {
                            data[index].campoSuccessivo.valoreDatoProposta = child.campoSuccessivo.valoreDatoProposta
                        }

                        if ( child.campoSuccessivo.valoreDatoPropostaFeed ) {
                            data[index].campoSuccessivo.valoreDatoPropostaFeed = child.campoSuccessivo.valoreDatoPropostaFeed
                        }

                        if ( child.campoSuccessivo.valori && data[index].campoSuccessivo.valori ) {
                            recursiveFillFromSession(child.campoSuccessivo.valori, data[index].campoSuccessivo.valori)
                        }
                    }

                    if (child.valori) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[idx] && data[idx].valori) {
                                    recursiveFillFromSession(child.valori, data[idx].valori)
                                }
                            }
                        })
                    }

                    if (child.campiSuccessivi) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[idx] && data[idx].campiSuccessivi) {
                                    recursiveFillFromSession(child.campiSuccessivi, data[idx].campiSuccessivi)
                                }
                            }
                        })
                    }

                    if (child.sezioneSuccessiva) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[idx] && data[idx].sezioneSuccessiva) {
                                    recursiveFillFromSession(child.sezioneSuccessiva.campi, data[idx].sezioneSuccessiva.campi)
                                }
                            }
                        })
                    }

                    if (child.sezione) {
                        data.forEach(function(item, idx){
                            if ( child.id == item.id ) {
                                if (data[index] && data[index].sezione && data[index].sezione) {
                                    recursiveFillFromSession(child.sezione.campi, data[idx].sezione.campi)
                                }
                            }
                        })
                    }

                    if (data.length) {
                        data.map(function (item) {
                            if (item.id == child.id && child.valoreDatoProposta) {
                                if ( item.tipoCampo == 'INTERO' ) {
                                    return item.valoreDatoProposta = +child.valoreDatoProposta
                                }
                                return item.valoreDatoProposta = child.valoreDatoProposta
                            }
                            if (item.id == child.id && child.valoreDatoPropostaFeed) {
                                return item.valoreDatoPropostaFeed = child.valoreDatoPropostaFeed
                            }
                        })
                    }

                })
            }

            var displayInRecap = ['Nome', 'Cognome', 'Qualifica', 'Regime', 'Data di nascita', 'Dipartimento', 'Area', 'E-mail', 'Affiliazione', 'Responsabile della ricerca']

            // End
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editProposta', editProposta);

    /** @ngInject */
    function editProposta() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editProposta/editProposta.html',
            scope: {},
            bindToController: {
                classeId: '=?',
                propostaId: '=?'
            },
            controller: FormController,
            controllerAs: 'form'
        };

        return directive;

        /** @ngInject */
        function FormController(ProposteService, FormService, SettoriErcService, TematicheH2020Service, RicaduteCulturaService, ParoleChiaveService, SottoSettoriErcService, $log, $q, $state, ngDialog, $scope, $timeout/*, $window, $http*/,StruttureService, DizionariHorizonService) {
            var vm = this;

            vm.template = null;
            vm.data = null;
            vm.savedData = null;
            vm.validazione = null;
            vm.propostaSalvata = null;
            vm.propostaValidata = null;

            vm.dizionari = {};

            vm.salvaProposta = salvaProposta;
            vm.validaProposta = validaProposta;
            vm.inviaProposta = inviaProposta;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            getDizionari()
                .then(getDatiProposta)
                .then(getTemplateProposta)
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della proposta", error);
                    showErrorDialog(error.data.message);
                });

            $scope.$watch(function() { return vm.data; }, function(newValue, oldValue) {
                if (newValue != oldValue) {
                    vm.propostaSalvata = angular.equals(vm.data, vm.savedData);
                }
            }, true);
            /*
            $window.onbeforeunload = function(event) {
                if (!vm.propostaSalvata) {
                    return 'Abbandonando la pagina tutte le modifiche non salvate saranno perse. Sei sicuro di voler abbandonare la pagina?'
                }
            }

            var unregisterListener = $scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams, options) { //eslint-disable-line angular/on-watch, no-unused-vars
                if (!vm.propostaSalvata) {
                    var dialogTemplate = '\
                            <h3>Abbandonare la pagina?</h3>\
                            <p class="alert alert-warning"><b>ATTENZIONE</b> - La proposta contiene modifiche non salvate. Abbandonando la pagina tali modifiche saranno perse.</p>\
                            <p>Sei sicuro di voler abbandonare la pagina?</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                            </div>';

                    var confirmDialog = ngDialog.openConfirm({
                        template: dialogTemplate,
                        plain: true
                    });

                    confirmDialog.then(function (data) {
                        if (data === true) {
                            unregisterListener();
                            $state.go(toState, toParams);
                        }
                    });
                    event.preventDefault();
                }
            });*/

            function getDizionari() {
                return $q.all([
                    SettoriErcService.getSettoriERC()
                        .then(function(data) {
                            vm.dizionari.settoriERC = addLabels(data, "codice + ' - ' + nome");
                        }),
                    TematicheH2020Service.getTematiche()
                        .then(function(data) {
                            vm.dizionari.tematicheH2020Inter = addLabels(data.tematicheH2020Inter, "valore");
                            vm.dizionari.tematicheH2020Attr = addLabels(data.tematicheH2020Attr, "valore");
                        }),
                    RicaduteCulturaService.getRicadute()
                        .then(function(data) {
                            vm.dizionari.ricaduteDiffusioneCultura = addLabels(data, "valore");
                        }),
                    ParoleChiaveService.getParoleChiaveCUN()
                        .then(function(data) {
                            vm.dizionari.paroleChiaveCUN = data;
                        }),
                    SottoSettoriErcService.getSottoSettoriERC()
                        .then(function(data) {
                            vm.dizionari.sottoSettoriERC = addLabels(data, "codice + ' - ' + descrizione");
                        }),
                   StruttureService.getStrutture()
                        .then(function(data) {
                            vm.dizionari.strutture = addLabels(data, "nome");
                        }),
                    DizionariHorizonService.getLineeTematicheHorizon()
                        .then(function(data) {
                            vm.dizionari.lineeTematicheHorizon = addLabels(data, "nome");
                        }),
                    DizionariHorizonService.getFlagShipHorizon()
                        .then(function(data) {
                            vm.dizionari.flagshipHorizon = addLabels(data, "nome");
                        }),
                    $q.resolve(getPercentuali())
                        .then(function(data) {
                            vm.dizionari.percentuali = data;
                        }),
                    $q.resolve(getRuoliSapienzaPartenariato())
                      .then(function(data) {
                        vm.dizionari.ruoliSapienzaPartenariato = addLabels(data, "label");
                      })
                ]);
            }

            function addLabels(array, labelExpression) {
                var elements = [];
                for (var i = 0; i < array.length; i++) {
                    elements.push({
                        id: array[i].id,
                        label: $scope.$eval(labelExpression, array[i]),
                        item: array[i]
                    });
                }
                return elements;
            }

            function getPercentuali() {
                var elements = [];
                for (var i = 0; i <=100; i += 10) {
                    var label = i + '%';
                    elements.push(label);
                }
                return elements;
            }

            function getRuoliSapienzaPartenariato(){
              return [{id:1,codice:'COORD',label:'Coordinatore'},{id:2,codice: 'BENEF',label:'Beneficiario'}];
            }

            function getDatiProposta() {
                if (vm.propostaId) {
                    return ProposteService.getPropostaById(vm.propostaId)
                        .then(function(data) {
                            vm.data = data;
                            vm.savedData = angular.copy(data);
                            vm.validazione = null;
                            vm.propostaValidata = null;
                            vm.classeId = angular.copy(vm.data.classe.id);
                        });
                }
                else {
                    return ProposteService.getNewProposta(vm.classeId)
                        .then(function(data) {
                            vm.data = data;
                        });
                }
            }

            function getTemplateProposta() {
                var formId = vm.data.formId;
                return FormService.getFormById(formId)
                    .then(function(formResult) {
                        vm.template = angular.fromJson(formResult.modello);
                    });
            }
/*
            function getTemplateProposta() {
                return $http.get('assets/template-form/' + vm.classeId + '.json')
                    .then(function(resultTemplate) {
                        vm.template = resultTemplate.data;
                    });
            }
*/
            function salvaProposta() {
                var savingDialog = null;
                if (vm.propostaId && vm.data.id) {
                    savingDialog = showSavingDialog();
                    // update
                    ProposteService.updateProposta(vm.data)
                        .then(function() {
                            $log.log('proposta modificata con successo');
                            getDatiProposta().then(function() {
                                savingDialog.close();
                            })
                            .catch(function(err) {
                                $log.error("Errore nel reperimento dei dati della proposta", err);
                                savingDialog.close();
                                showErrorDialog(err.data.message);
                            });
                        })
                        .catch(function(error) {
                            $log.error("Errore nel salvataggio della proposta", error);
                            savingDialog.close();
                            if (error && error.data && error.data.code == 2)
                                showErrorBandoDialog(error.data.message);
                            else
                                showErrorDialog(error.data.message);
                        });
                }
                else {
                    savingDialog = showSavingDialog();
                    // save
                    ProposteService.saveProposta(vm.data)
                        .then(function(resultData) {
                            $log.log('nuova proposta salvata con successo');
                            vm.propostaId = angular.copy(resultData.id);
                            getDatiProposta()
                                .then(function() {
                                    $state.go('propostaDetail', {'id': resultData.id}, {'location': 'replace', notify: false});
                                    var template = angular.copy(vm.template);
                                    vm.template = null;
                                    vm.template = template;
                                    savingDialog.close();
                                })
                                .catch(function(err) {
                                    $log.error("Errore nel reperimento dei dati della proposta", err);
                                    savingDialog.close();
                                    showErrorDialog(err.data.message);
                                });
                        })
                        .catch(function(error) {
                            $log.error("Errore nel salvataggio della proposta", error);
                            savingDialog.close();
                            if (error && error.data && error.data.code == 2)
                                showErrorBandoDialog(error.data.message);
                            else
                                showErrorDialog(error.data.message);
                        });
                }
            }

            function showSavingDialog() {
                var dialog = ngDialog.open({
                    template:'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function validaProposta() {
                if (vm.propostaId) {
                    var validatingDialog = showValidatingDialog();
                    ProposteService.validaProposta(vm.propostaId)
                        .then(function(result) {
                            $log.log('esito validazione ottenuto');
                            vm.validazione = result;
                            vm.propostaValidata = result.valida;
                            validatingDialog.close();
                            $timeout(scrollToFirstError);
                        })
                        .catch(function(error) {
                            $log.error("impossibile ottenere l'esito della validazione", error);
                            validatingDialog.close();
                            if (error && error.data && error.data.code == 2)
                                showErrorBandoDialog(error.data.message);
                            else
                                showErrorDialog(error.data.message);
                        });
                }
            }

            function showValidatingDialog() {
                var dialog = ngDialog.open({
                    template:'Validazione in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function scrollToFirstError() {
                var $container = angular.element('.mainContainer').first();
                var $target = angular.element('.withErrors').first();
                if ($target.length)
                    $container.animate({scrollTop: $container.scrollTop() + ($target.offset().top - $container.offset().top - 80)}, "swing");
            }

            function inviaProposta() {
                if (vm.propostaId) {
                    var dialogTemplate = '\
                            <h3>Chiudi e invia proposta</h3>\
                            <p class="alert alert-warning"><b>ATTENZIONE</b> - Una volta effettuato l\'invio non sarà più possibile modificare la proposta.</p>\
                            <p>Procedere con la chiusura e l\'invio della proposta?</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                            </div>';

                    var confirmDialog = ngDialog.openConfirm({
                        template: dialogTemplate,
                        plain: true
                    });

                    confirmDialog.then(function (data) {
                        if (data === true) {
                            var sendingDialog = showSendingDialog();
                            ProposteService.inviaProposta(vm.propostaId)
                                .then(function(result) { //eslint-disable-line no-unused-vars
                                    $log.log('proposta sottomessa con successo');
                                    sendingDialog.close();
                                    $state.go('proposte');
                                })
                                .catch(function(error) {
                                    $log.error("errore nella sottomissione della proposta", error);
                                    sendingDialog.close();
                                    if (error && error.data && error.data.code == 2)
                                        showErrorBandoDialog(error.data.message);
                                    else
                                        showErrorDialog(error.data.message);
                                });
                        }
                    });
                }
            }

            function showSendingDialog() {
                var dialog = ngDialog.open({
                    template:'Invio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore nella comunicazione con il server.</b><br />Se l\'errore persiste contatta l\'ufficio CER.</div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }

            function showErrorBandoDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Termine presentazione domande</h3><div class="well"><b>Impossibile completare l\'operazione richiesta poiché sono scaduti i termini per la presentazione delle domande del bando.</b></div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editDirettoreDipartimento', editDirettoreDipartimento);

    /** @ngInject */
    function editDirettoreDipartimento() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editDirettoreDipartimento/editDirettoreDipartimento.html',
            scope: {},
            bindToController: {
                dipartimentoId: '=',
                confirm: '=',
                cancel: '='
            },
            controller: EditDirettoreDipartimentoController,
            controllerAs: 'editDirDipCtrl'
        };

        return directive;

        /** @ngInject */
        function EditDirettoreDipartimentoController(DipartimentiUrService, ngDialog, $log) {
            var vm = this;
            vm.dipartimento = null;

            vm.addDirettore = addDirettore;
            vm.removeDirettore = removeDirettore;
            vm.updateDirettoreDipartimento = updateDirettoreDipartimento;

            getDipartimento()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sul dipartimento", error);
                });


            function getDipartimento() {
                return DipartimentiUrService.getDipartimentoById(vm.dipartimentoId)
                    .then(function(data) {
                        vm.dipartimento = data;
                    });
            }

            function addDirettore(modelObject, modelNameStr) {
                ngDialog.open({
                    template:'\
                        <dipartimento-add-direttore model-obj="ngDialogData.modelObj" model-name="ngDialogData.modelName"></dipartimento-add-direttore>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        modelObj: modelObject,
                        modelName: modelNameStr
                    }
                });
            }

            function removeDirettore(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare l\'associazione del direttore al dipartimento?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.dipartimento.direttoreList.splice(index, 1);
                    }
                });
            }

            function updateDirettoreDipartimento() {
                DipartimentiUrService.updateRadDirDipartimento(vm.dipartimento)
                    .then(function() {
                        $log.log('associazioni Direttore-Dipartimento salvate con successo');
                        vm.confirm(true);
                    })
                    .catch(function(error) {
                        $log.error("Errore nel salvataggio delle associazioni Direttore-Dipartimento", error);
                    });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('dipartimentoAddDirettore', dipartimentoAddDirettore);

    /** @ngInject */
    function dipartimentoAddDirettore() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editDirettoreDipartimento/dipartimento-add-refeere.html',
            scope: {},
            bindToController: {
                modelObj: '=',
                modelName: '='
            },
            controller: DipartimentoAddDirettoreController,
            controllerAs: 'dipAddDirCtrl'
        };

        return directive;

        /** @ngInject */
        function DipartimentoAddDirettoreController(UtentiService) {
            var vm = this;

            vm.searchString = '';
            vm.searching = false;
            vm.results = null;
            vm.persone = vm.modelObj[vm.modelName];

            vm.search = search;
            vm.addPerson = addPerson;

            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtentiDirettoreDip(text)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le persone già selezionate
                            for (var i = 0; i < vm.results.length; i++) {
                                if (vm.persone && vm.persone.length) {
                                    for (var j = 0; j < vm.persone.length; j++) {
                                        var partecipante = vm.persone[j];
                                        if (partecipante.id == vm.results[i].utente.id) {
                                            vm.results[i].isAlreadyRequested = true;
                                            break;
                                        }
                                    }
                                }
                                else {
                                    if (vm.persone && vm.persone.id == vm.results[i].utente.id) {
                                        vm.results[i].isAlreadyRequested = true;
                                    }
                                }
                            }
                        })
                        .catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                }
                else {
                    vm.searching = false;
                }
            }

            function addPerson(result) {
                result.isAlreadyRequested = true;
                delete result.utente.ruolo;
                delete result.utente.dataDiNascita;
                delete result.utente.dipartimentoManuale;
                delete result.utente.dipartimento;
                delete result.utente.regime;
                delete result.utente.ssd;
                vm.persone.push(result.utente);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('editCommissione', editCommissione);

    /** @ngInject */
    function editCommissione() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editCommissione/editCommissione.html',
            scope: {},
            bindToController: {
                commissioneId: '='
            },
            controller: EditCommissioneController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function EditCommissioneController(CommissioniService, TipologieProgettoService, $log, $state, $q, ngDialog) {
            var vm = this;
            
            vm.loading = true;
            vm.anno = null;
            
            vm.editDisabled = false;
            
            vm.data = {
                nome: '',
                specializzata: false,
                refereeNascosti: false,
                refereeGestitiDaPresidente: false,
                tipologiaProgettoList: [],
                presidente: null,
                membroCommissioneList: []
            };
            vm.tipologieProgetto = null;
            
            if (vm.commissioneId == undefined) {
                vm.isNew = true;
                vm.pageHeader = 'Nuova Commissione';
            }
            else {
                vm.isNew = false;
                vm.pageHeader = 'Modifica Commissione';
            }
            
            vm.containsTipologia = containsTipologia;
            vm.toggleTipologia = toggleTipologia;
            vm.removePresident = removePresident;
            vm.removeMember = removeMember;
            vm.addPerson = addPerson;
            vm.saveCommissione = saveCommissione;
            
            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };
            
            getDatiCommissione()
                .then(getTipologieProgetto)
                .then(function() {
                    vm.loading = false;
                })
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della commissione", error);
                    showErrorDialog(error.data.message);
                });
            
            
            function getDatiCommissione() {
                if (vm.commissioneId != undefined)
                    return CommissioniService.getCommissioneById(vm.commissioneId)
                        .then(function(data) {
                            vm.data = data;
                            vm.anno = data.anno;
                        });
                else
                    return $q.when();
            }
            
            function getTipologieProgetto() {
                return TipologieProgettoService.getTipologieProgetto(vm.anno)
                    .then(function(data) {
                        vm.tipologieProgetto = data;
                    });
            }
            
            function containsTipologia(id) {
                for (var i = 0; i < vm.data.tipologiaProgettoList.length; i++) {
                    var tipologia = vm.data.tipologiaProgettoList[i];
                    if (tipologia.id == id)
                        return true;
                }
                return false;
            }
            
            function toggleTipologia(id) {
                var index = -1;
                for (var i = 0; i < vm.data.tipologiaProgettoList.length; i++) {
                    var tipologia = vm.data.tipologiaProgettoList[i];
                    if (tipologia.id == id) {
                        index = i;
                        break;
                    }
                }
                if (index < 0) {
                    vm.data.tipologiaProgettoList.push({'id': id});
                }
                else {
                    vm.data.tipologiaProgettoList.splice(index, 1);
                }
            }
            
            function removePresident() {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare il presidente della commissione {{ngDialogData.persona.cognome}} {{ngDialogData.persona.nome}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        persona: vm.data.presidente
                    }
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.data.presidente = null;
                    }
                });
            }
            
            function removeMember(index) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma eliminazione</h3>\
                        <p>Vuoi eliminare il membro della commissione {{ngDialogData.persona.cognome}} {{ngDialogData.persona.nome}}?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true,
                    data: {
                        persona: vm.data.membroCommissioneList[index]
                    }
                });
                
                confirmDialog.then(function (data) {
                    if (data === true) {
                        vm.data.membroCommissioneList.splice(index, 1);
                    }
                });
            }
            
            function addPerson(modelObject, modelNameStr, max) {
                ngDialog.open({
                    template:'\
                        <commissione-add-members model-obj="ngDialogData.modelObj" model-name="ngDialogData.modelName" num-max="{{ngDialogData.numMax}}"></commissione-add-members>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        modelObj: modelObject,
                        modelName: modelNameStr,
                        numMax: max
                    }
                });
            }
            
            function saveCommissione() {
                var savingDialog = null;
                if (vm.isNew) {
                    savingDialog = showSavingDialog();
                    CommissioniService.saveCommissione(vm.data)
                        .then(function() {
                            $log.log('nuova commissione salvata con successo');
                            savingDialog.close();
                            $state.go('urCommissioni');
                        })
                        .catch(function(error) {
                            $log.error("Errore nel salvataggio della commissione", error);
                            savingDialog.close();
                            showErrorDialog(error.data.message);
                        });
                }
                else {
                    savingDialog = showSavingDialog();
                    CommissioniService.updateCommissione(vm.data)
                        .then(function() {
                            $log.log('commissione modificata con successo');
                            savingDialog.close();
                            $state.go('urCommissioni');
                        })
                        .catch(function(error) {
                            $log.error("Errore nel salvataggio della commissione", error);
                            savingDialog.close();
                            showErrorDialog(error.data.message);
                        });
                }
            }
            
            function showSavingDialog() {
                var dialog = ngDialog.open({
                    template:'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
                
                return dialog;
            }
            
            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });
                
                return dialog;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('commissioneAddMembers', commissioneAddMembers);

    /** @ngInject */
    function commissioneAddMembers() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/editCommissione/commissione-add-members.html',
            scope: {},
            bindToController: {
                modelObj: '=',
                modelName: '=',
                numMax: '@'
            },
            controller: CommissioneAddMembersController,
            controllerAs: 'commAddMembersCtrl'
        };

        return directive;

        /** @ngInject */
        function CommissioneAddMembersController(UtentiService) {
            var vm = this;
            
            vm.searchString = '';
            vm.searching = false;
            vm.results = null;
            vm.persone = vm.modelObj[vm.modelName];
            
            vm.search = search;
            vm.maxNumReached = maxNumReached;
            vm.addPerson = addPerson;
            
            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtentiMC(text)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le persone già selezionate
                            for (var i = 0; i < vm.results.length; i++) {
                                if (vm.persone && vm.persone.length) {
                                    for (var j = 0; j < vm.persone.length; j++) {
                                        var partecipante = vm.persone[j];
                                        if (partecipante.utenteId == vm.results[i].utente.id) {
                                            vm.results[i].isAlreadyRequested = true;
                                            break;
                                        }
                                    }
                                }
                                else {
                                    if (vm.persone && vm.persone.utenteId == vm.results[i].utente.id) {
                                        vm.results[i].isAlreadyRequested = true;
                                    }
                                }
                            }
                        })
                        .catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                }
                else {
                    vm.searching = false;
                }
            }
            
            function maxNumReached() {
                if (angular.isArray(vm.persone))
                    return (vm.numMax && vm.persone.length >= vm.numMax);
                else
                    return (vm.persone != null);
            }
            
            function addPerson(result) {
                result.isAlreadyRequested = true;
                result.utente.utenteId = result.utente.id;
                result.utente.id = 0;
                delete result.utente.dataDiNascita;
                delete result.utente.email;
                delete result.utente.tipoUtente;
                delete result.utente.dipartimentoManuale;
                delete result.utente.regime;
                if (vm.numMax == 1) {
                    vm.persone = result.utente;
                    vm.modelObj[vm.modelName] = result.utente;
                }
                else
                    vm.persone.push(result.utente);
            }
        }
    }

})();

(function () {
            'use strict';

            angular
                .module('sigeba')
                .directive('dettaglioProposte', dettaglioProposte);

            /** @ngInject */
            function dettaglioProposte() {
                var directive = {
                    restrict: 'E',
                    templateUrl: 'app/components/dettaglioProposte/dettaglioProposte.html',
                    scope: {},
                    bindToController: {},
                    controller: dettaglioProposteController,
                    controllerAs: 'propCtrl'
                };

                return directive;

        /** @ngInject */
        function dettaglioProposteController(UtentiUrService, $log, $state, $window) {
            var vm = this;

            // variabili
            vm.utenti = null;

            // filtro
            var storageName = "dettaglioProposte-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};
            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;

            // metodi
            vm.getUtenti = getUtenti;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.listDettaglioProp = listDettaglioProp;

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            getUtenti()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sugli utenti", error);
                });

            /**
             * @param keepPagination
             * @returns {*} la lista degli utenti, filtrati se è specificato un filtro
             */
            function getUtenti(keepPagination) {
                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                // salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    cognome: vm.selectedCognome
                });

                vm.utenti = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedCognome != null && vm.selectedCognome != '')
                    filter.cognome = vm.selectedCognome;
                return UtentiUrService.getUtenti(filter)
                    .then(function (data) {
                        vm.utenti = data.resultList;
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    });
            }

            /**
             * resetta i filtri inseriti dall'utente
             */
            function resetFiltri() {
                vm.selectedCognome = "";
                getUtenti();
            }

            /**
             * @returns {boolean} true se il filtro è attivo
             */
            function isFiltroAttivo() {
                var attivo = false;
                if (vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                return attivo;
            }

            function listDettaglioProp(user) {
              $state.go('urListDettaglioProp', {'id': user.id});

               // ngDialog.open({template:'<gestione-utente user="ngDialogData.user"></gestione-utente>', plain:true, showClose:true, data: {user:user}})
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('dettagliEsito', dettagliEsito);

    /** @ngInject */
    function dettagliEsito() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/dettagliEsito/dettagliEsito.html',
            scope: {},
            bindToController: {
                proposta: "="
            },
            controller: DettagliEsitoController,
            controllerAs: 'dettEsitoCtrl'
        };

        return directive;

        /** @ngInject */
        function DettagliEsitoController(ngDialog) {
            var vm = this;
            
            vm.showValutazione = showValutazione;
            vm.getCheckEvaluationIconClass = getCheckEvaluationIconClass;
            
            function showValutazione(proposta, valutazione) {
                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" is-user="true" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? valutazione.id : null
                    }
                });
            }
            
            function getCheckEvaluationIconClass(punteggio) {
                var integer = Math.round(punteggio);
                var className = '';
                if (integer === 0)
                    className = 'fa-thumbs-o-down';
                if (integer === 1)
                    className = 'fa-thumbs-o-up';
                
                return className;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('dateRangePicker', dateRangePicker);

    /** @ngInject */
    function dateRangePicker($window) {
        var directive = {
            require: '?ngModel',
            scope: {
                "singleDate": '=',
                "minDate": '=',
                "maxDate": '=',
                "nonFuture": '='
            },
            link: function (scope, elm, attr, ngModel) {
                var config = {
                    "locale": {
                        "format": "DD/MM/YYYY",
                        "separator": " - ",
                        "applyLabel": "Ok",
                        "cancelLabel": "Annulla",
                        "fromLabel": "Da",
                        "toLabel": "A",
                        "customRangeLabel": "Custom",
                        "daysOfWeek": [
                            "Do",
                            "Lu",
                            "Ma",
                            "Me",
                            "Gi",
                            "Ve",
                            "Sa"
                        ],
                        "monthNames": [
                            "Gennaio",
                            "Febbraio",
                            "Marzo",
                            "Aprile",
                            "Maggio",
                            "Giugno",
                            "Luglio",
                            "Agosto",
                            "Settembre",
                            "Ottobre",
                            "Novembre",
                            "Dicembre"
                        ],
                        "firstDay": 1
                    },
                    "parentEl": ".formContainer",
                    "autoUpdateInput": false
                };
                if (scope.minDate && scope.minDate != '')
                    config.minDate = scope.minDate;
                if (scope.maxDate && scope.maxDate != '')
                    config.maxDate = scope.maxDate;
                if (scope.nonFuture && scope.nonFuture != '') {
                    var moment = $window.moment;
                    var today = moment().format('DD/MM/YYYY');
                    if (config.maxDate) {
                        if (moment(today, "DD/MM/YYYY").isBefore(moment(config.maxDate, "DD/MM/YYYY")))
                            config.maxDate = today;
                    }
                    else
                        config.maxDate = today;
                }
                if (scope.singleDate) {
                    config.singleDatePicker = true;
                    config.showDropdowns = true;
                }
                
                elm.daterangepicker(config);
                elm.on('apply.daterangepicker', function(ev, picker) {
                    if (config.singleDatePicker)
                        elm.val(picker.startDate.format('DD/MM/YYYY'));
                    else
                        elm.val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
                    elm.trigger('change');
                });
                
                ngModel.$render = function(/*value*/) { 
                    var value = ngModel.$modelValue;
                    elm.val(value);
                    if (value != null && value != '') {
                        var start = null;
                        var end = null;
                        if (config.singleDatePicker) {
                            start = value;
                            end = value;
                        }
                        else {
                            var split = value.split(' - ');
                            start = split[0];
                            end = split[1];
                        }
                        var datepicker = elm.data('daterangepicker');
                        datepicker.setStartDate(start);
                        datepicker.setEndDate(end);
                    }
                };
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ValutazioniUrService', ValutazioniUrService);

    /** @ngInject */
    function ValutazioniUrService(Constants, $resource) {

        var valutazioneResource = $resource(Constants.restApiRoot + '/ur/valutazione/:id');

        var riapriResource = $resource(Constants.restApiRoot + '/ur/valutazione/open/:propostaId', null, {
            'update': { method:'PUT' }
        });
        var rendicontaResource = $resource(Constants.restApiRoot + '/ur/rendicontazioni/valutazione/:id', null, {
            'update': {
                method:'PUT',
                params: { valutazione: '@valutazione',  nota: '@nota', consolida: '@consolida' }
            }
        });
        var impostaValutataResource = $resource(Constants.restApiRoot + '/ur/valutazione/imposta-proposta-valutata/:propostaId', null, {
            'put': { method:'PUT' }
        });
        var concludiFaseValutazioneResource = $resource(Constants.restApiRoot + '/ur/valutazione/concludi-fase-referee/:propostaId', null, {
            'put': { method:'PUT' }
        });
        var dichiaraNonAmmissibileResource = $resource(Constants.restApiRoot + '/ur/valutazione/dichiara-non-ammissibile/:propostaId', null, {
            'put': { method:'PUT' }
        });

        var service = {
            getValutazione: getValutazione,
            riapriValutazione: riapriValutazione,
            concludiValutazioneReferee: concludiValutazioneReferee,
            concludiFaseValutazioneReferee: concludiFaseValutazioneReferee,
            dichiaraNonAmmissibile: dichiaraNonAmmissibile,
            rendicontaValutazione: rendicontaValutazione
        };

        return service;

        function getValutazione(id) {
            var obj = (id) ? {id: id} : {};
            return valutazioneResource.get(obj).$promise;
        }

        function riapriValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return riapriResource.update(obj, {}).$promise;
        }

        function rendicontaValutazione( id, valutazione, nota, consolida ) {
            return rendicontaResource.update( {id: id, valutazione: valutazione, nota:nota, consolida: consolida}, {}).$promise;
        }

        function concludiValutazioneReferee(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return impostaValutataResource.put(obj, {}).$promise;
        }

        function concludiFaseValutazioneReferee(propostaId, faseId) {
            var obj = (propostaId) ? {propostaId: propostaId, faseValutazioneId : faseId} : {};
            return concludiFaseValutazioneResource.put(obj, {}).$promise;
        }

        function dichiaraNonAmmissibile(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return dichiaraNonAmmissibileResource.put(obj, {}).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ValutazioniRefService', ValutazioniRefService);

    /** @ngInject */
    function ValutazioniRefService(Constants, $resource) {
        
        var newValutazioneResource = $resource(Constants.restApiRoot + '/referee/valutazione/new/:propostaId');
        
        var valutazioneResource = $resource(Constants.restApiRoot + '/referee/valutazione/:id', null, {
            'update': { method:'PUT' }
        });
        var concludiResource = $resource(Constants.restApiRoot + '/referee/valutazione/concludi/:id', null, {
            'update': { method:'PUT' }
        });

        var service = {
            salvaValutazione: salvaValutazione,
            concludiValutazione: concludiValutazione,
            newValutazione: newValutazione,
            getValutazione: getValutazione
        };

        return service;
        
        function salvaValutazione(valutazione) {
            var obj = {};
            if (valutazione && valutazione.id) {
                obj = (valutazione) ? {id: valutazione.id} : {};
                return valutazioneResource.update(obj, valutazione).$promise;
            }
            else {
                obj = (valutazione) ? valutazione : {};
                return valutazioneResource.save(obj).$promise;
            }
        }
        
        function concludiValutazione(valutazione) {
            var obj = {};
            if (valutazione && valutazione.id) {
                obj = (valutazione) ? {id: valutazione.id} : {};
                return concludiResource.update(obj, valutazione).$promise;
            }
            else {
                obj = (valutazione) ? valutazione : {};
                return concludiResource.save(obj).$promise;
            }
        }
        
        function getValutazione(id) {
            var obj = (id) ? {id: id} : {};
            return valutazioneResource.get(obj).$promise;
        }
        
        function newValutazione(propostaId, faseId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            if (faseId != null)
                obj.faseValutazioneId = faseId;
            return newValutazioneResource.get(obj).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ValutazioniMcService', ValutazioniMcService);

    /** @ngInject */
    function ValutazioniMcService(Constants, $resource) {
        
        var newValutazioneResource = $resource(Constants.restApiRoot + '/mc/valutazione/new/:propostaId');
        
        var valutazioneResource = $resource(Constants.restApiRoot + '/mc/valutazione/:id', null, {
            'update': { method:'PUT' }
        });
        var concludiResource = $resource(Constants.restApiRoot + '/mc/valutazione/concludi/:id', null, {
            'update': { method:'PUT' }
        });
        /*var impostaValutataResource = $resource(Constants.restApiRoot + '/mc/valutazione/imposta-proposta-valutata/:propostaId', null, {
            'put': { method:'PUT' }
        });*/
        var riapriResource = $resource(Constants.restApiRoot + '/mc/valutazione/open/:propostaId', null, {
            'update': { method:'PUT' }
        });
        var concludiFaseValutazioneResource = $resource(Constants.restApiRoot + '/mc/valutazione/concludi-fase-referee/:propostaId', null, {
            'put': { method:'PUT' }
        });

        var service = {
            salvaValutazione: salvaValutazione,
            concludiValutazione: concludiValutazione,
            newValutazione: newValutazione,
            getValutazione: getValutazione,
            //concludiValutazioneReferee: concludiValutazioneReferee,
            riapriValutazione: riapriValutazione,
            concludiFaseValutazioneReferee: concludiFaseValutazioneReferee
        };

        return service;
        
        function salvaValutazione(valutazione) {
            var obj = {};
            if (valutazione && valutazione.id) {
                obj = (valutazione) ? {id: valutazione.id} : {};
                return valutazioneResource.update(obj, valutazione).$promise;
            }
            else {
                obj = (valutazione) ? valutazione : {};
                return valutazioneResource.save(obj).$promise;
            }
        }
        
        function concludiValutazione(valutazione) {
            var obj = {};
            if (valutazione && valutazione.id) {
                obj = (valutazione) ? {id: valutazione.id} : {};
                return concludiResource.update(obj, valutazione).$promise;
            }
            else {
                obj = (valutazione) ? valutazione : {};
                return concludiResource.save(obj).$promise;
            }
        }
        
        function getValutazione(id) {
            var obj = (id) ? {id: id} : {};
            return valutazioneResource.get(obj).$promise;
        }
        
        function newValutazione(propostaId, faseId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            if (faseId != null)
                obj.faseValutazioneId = faseId;
            return newValutazioneResource.get(obj).$promise;
        }
        
        /*function concludiValutazioneReferee(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return impostaValutataResource.put(obj).$promise;
        }*/
        
        function riapriValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return riapriResource.update(obj, {}).$promise;
        }
        
        function concludiFaseValutazioneReferee(propostaId, faseId) {
            var obj = (propostaId) ? {propostaId: propostaId, faseValutazioneId : faseId} : {};
            return concludiFaseValutazioneResource.put(obj, {}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ValutazioniService', ValutazioniService);

    /** @ngInject */
    function ValutazioniService(Constants, $resource) {
        
        
        var valutazioneResource = $resource(Constants.restApiRoot + '/valutazione/:id');

        var service = {
            getValutazione: getValutazione
        };

        return service;
        
        function getValutazione(id) {
            var obj = (id) ? {id: id} : {};
            return valutazioneResource.get(obj).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('UtentiUrService', UtentiUrService);

    /** @ngInject */
    function UtentiUrService(Constants, $resource, $httpParamSerializer, UserData) {

        var utentiResource = $resource(Constants.restApiRoot + '/ur/utenti');
        var newUtentiResource = $resource(Constants.restApiRoot + '/ur/utenti/save');
        var updateUtentiResource = $resource(Constants.restApiRoot + '/ur/utenti/save/:id', null, {'update':{method:'PUT'}});

        var service = {
            getUtenti: getUtenti,
            getCsvExportUrl: getCsvExportUrl,
            addUtente: addUtente,
            updateUtente: updateUtente
        };

        return service;

        function getUtenti(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            return utentiResource.get(filter).$promise;
        }

      function addUtente(utente){
        return newUtentiResource.save(utente).$promise;
      }

      function updateUtente(idUser, utente){
        return updateUtentiResource.update({
          id:idUser
        }, utente).$promise;
      }

        function getCsvExportUrl(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/ur/utenti/export';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('UtentiService', UtentiService);

    /** @ngInject */
    function UtentiService(Constants, $resource) {

        var utentiResource = $resource(Constants.restApiRoot + '/utenti');
        var utentiFindByIdResource = $resource(Constants.restApiRoot + '/utenti/findById');
        var utentiMCResource = $resource(Constants.restApiRoot + '/utenti/mc-ricerca');
        var utentiRadResource = $resource(Constants.restApiRoot + '/utenti/rad-ricerca');
        var utentiDirDipResource = $resource(Constants.restApiRoot + '/utenti/dir-dip-ricerca');
        var utentiRefDipResource = $resource(Constants.restApiRoot + '/utenti/ref-dip-ricerca');
        var utentiNewTitolareResource = $resource(Constants.restApiRoot + '/utenti/new-titolare-ricerca');
        var utentiNewTitolareComponenteResource = $resource(Constants.restApiRoot + '/utenti/new-titolare-componente/:propostaId');

        var service = {
            getUtenti: getUtenti,
            getUtente: getUtente,
            getUtentiMC: getUtentiMC,
            getUtentiRad: getUtentiRad,
            getUtentiDirettoreDip: getUtentiDirettoreDip,
            getUtentiRefereeDip: getUtentiRefereeDip,
            getUtentiNewTitolare: getUtentiNewTitolare,
            getUtentiNewTitolareComponente: getUtentiNewTitolareComponente
        };

        return service;

        function getUtenti(categoriaId, classeId, propostaId, text) {
            return utentiResource.get({
                'categoriaId': categoriaId,
                'classeId': classeId,
                'propostaId': propostaId,
                'text': text
            }).$promise;
        }

        function getUtente(userId){
          return utentiFindByIdResource.get({'idUtente':userId}).$promise;
        }

        function getUtentiMC(text) {
            return utentiMCResource.get({
                'text': text
            }).$promise;
        }

        function getUtentiRad(text) {
            return utentiRadResource.get({
                'text': text
            }).$promise;
        }

        function getUtentiDirettoreDip(text) {
            return utentiDirDipResource.get({
                'text': text
            }).$promise;
        }

        function getUtentiRefereeDip(text) {
            return utentiRefDipResource.get({
                'text': text
            }).$promise;
        }

        function getUtentiNewTitolare(text) {
            return utentiNewTitolareResource.get({
                'text': text
            }).$promise;
        }

        function getUtentiNewTitolareComponente(propostaId) {
            return utentiNewTitolareComponenteResource.get({'propostaId': propostaId}).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('TipologieProgettoService', TipologieProgettoService);

    /** @ngInject */
    function TipologieProgettoService(Constants, $resource) {
        
        var tipologieProgettoResource = $resource(Constants.restApiRoot + '/tipologie-progetto');

        var service = {
            getTipologieProgetto: getTipologieProgetto
        };

        return service;
        
        function getTipologieProgetto(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return tipologieProgettoResource.query(filter).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ThemeService', ThemeService);

    /** @ngInject */
    function ThemeService($document) {
        // Definiamo le risorse che ci servono
        var BODY_ELEMENT = $document.find('body').eq(0);
        var HEAD_ELEMENT = $document.find('head').eq(0);
        var THEME_LINK_ID = 'dynamic-theme-stylesheet';

        // Definiamo l'interfaccia pubblica del servizio
        var service = {
            initializeTheme: initializeTheme,
            setBodyClass: setBodyClass,
            getThemeVariables: getThemeVariables,
            loadThemeStylesheet: loadThemeStylesheet
        };

        return service;

        /**
         * Recupera le variabili d'ambiente dall'oggetto window.__appConfig
         * @returns {Object} L'oggetto contenente le variabili d'ambiente
         */
        function getThemeVariables() {
            console.log('__appConfig', window.__appConfig)
            // Utilizziamo un oggetto vuoto come fallback se window.__appConfig non esiste
            return window.__appConfig || {};
        }

        /**
         * Recupera le classi esistenti del body in modo sicuro
         * @returns {Array} Array delle classi esistenti
         */
        function getExistingClasses() {
            // Recuperiamo l'attributo class in modo sicuro
            var classAttr = BODY_ELEMENT.attr('class');
            
            // Se non ci sono classi, ritorniamo un array vuoto
            if (!classAttr) {
                return [];
            }
            
            // Altrimenti, splittiamo la stringa delle classi
            return classAttr.split(' ').filter(function(cls) {
                // Rimuoviamo eventuali stringhe vuote
                return cls && cls.trim().length > 0;
            });
        }

        /**
         * Aggiunge una classe al body basata sulla configurazione
         * @param {string} className - La classe da aggiungere al body
         */
        function setBodyClass(className) {
            if (!className) {
                return;
            }

            // Recuperiamo le classi esistenti in modo sicuro
            var existingClasses = getExistingClasses();
            
            // Filtriamo le classi che iniziano con 'config-'
            var configClasses = existingClasses.filter(function(cls) {
                return cls.startsWith('config-');
            });
            
            // Rimuoviamo le vecchie classi di configurazione
            configClasses.forEach(function(cls) {
                BODY_ELEMENT.removeClass(cls);
            });

            // Aggiungiamo la nuova classe
            BODY_ELEMENT.addClass(className);
            // Carichiamo anche il foglio di stile corrispondente
            loadThemeStylesheet(className);
        }

        /**
         * Carica dinamicamente il file CSS del tema
         * @param {string} themeClass - Il nome della classe del tema (es. 'tema-rosso')
         */
        function loadThemeStylesheet(themeClass) {
            // Rimuoviamo eventuali fogli di stile dei temi precedenti
            var existingLink = $document[0].getElementById(THEME_LINK_ID);
            if (existingLink) {
                existingLink.parentNode.removeChild(existingLink);
            }

            // Creiamo il nuovo elemento link
            var linkElement = $document[0].createElement('link');
            linkElement.id = THEME_LINK_ID;
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            // Costruiamo il percorso del file CSS basandoci sulla classe del tema
            linkElement.href = 'assets/theme/' + themeClass + '.css';

            // Aggiungiamo il nuovo foglio di stile all'head
            HEAD_ELEMENT.append(linkElement);
        }

        /**
         * Inizializza il servizio applicando le configurazioni dell'ambiente
         */
        function initializeTheme() {
            var env = getThemeVariables();
            
            // Se abbiamo una variabile environment, aggiungiamo la classe corrispondente
            if (env.themeClass) {
                setBodyClass(env.themeClass);
            }

            // Qui possiamo aggiungere altre inizializzazioni basate su variabili d'ambiente
            return env;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('LogoService', LogoService)
        .directive('dynamicLogo', dynamicLogo);

    /** @ngInject */
    function LogoService() {
        var service = {
            getLogoPath: getLogoPath,
            getConfig: getConfig
        };

        return service;

        /**
         * Recupera la configurazione dell'applicazione
         * @returns {Object} La configurazione dell'applicazione
         */
        function getConfig() {
            return window.__appConfig || {};
        }

        /**
         * Recupera il percorso del logo basato sulla configurazione
         * @returns {string} Il percorso del logo
         */
        function getLogoPath() {
            var config = getConfig();
            // Se non c'è una configurazione specifica, usiamo il logo di default
            return config.logoPath || 'assets/images/logo.unibari.png'
        }
    }

    /** @ngInject */
    function dynamicLogo(LogoService) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                // Aggiorniamo l'attributo src con il percorso del logo dalla configurazione
                element.attr('src', LogoService.getLogoPath());
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('TematicheH2020Service', TematicheH2020Service);

    /** @ngInject */
    function TematicheH2020Service(Constants, $resource) {
        
        var tematicheResource = $resource(Constants.restApiRoot + '/tematiche-H-2020');

        var service = {
            getTematiche: getTematiche
        };

        return service;
        
        function getTematiche() {
            return tematicheResource.get().$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('StruttureUrService', StruttureUrService);

    /** @ngInject */
    function StruttureUrService(Constants, $resource) {

        var struttureResource = $resource(Constants.restApiRoot + '/ur/strutture');
        var strutturaIdResource = $resource(Constants.restApiRoot + '/ur/strutture/:id', null, { 'update': { method:'PUT' } });

        var service = {
            getStrutture: getStrutture,
            getStrutturaById: getStrutturaById,
            updateRadDirStruttura: updateRadDirStruttura
        };

        return service;

        function getStrutture() {
            return struttureResource.query().$promise;
        }

        function getStrutturaById(id) {
            return strutturaIdResource.get({'id': id}).$promise;
        }

        function updateRadDirStruttura(struttura) {
            return strutturaIdResource.update({id: struttura.id}, struttura).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('StruttureRadService', StruttureRadService);

    /** @ngInject */
    function StruttureRadService(Constants, $resource) {

        var struttureResource = $resource(Constants.restApiRoot + '/rad/strutture');

        var service = {
            getStruttureRad: getStruttureRad
        };

        return service;

        function getStruttureRad() {
            return struttureResource.query().$promise;
        }

    }
})();

(function() {
  'use strict';

  angular
    .module('sigeba')
    .factory('StruttureService', StruttureService);

  /** @ngInject */
  function StruttureService(Constants, $resource) {

    var struttureResource = $resource(Constants.restApiRoot + '/strutture');

    var service = {
      getStrutture: getStrutture
    };

    return service;

    function getStrutture() {
      return struttureResource.query().$promise;
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('StepRendicontazioneService', StepRendicontazioneService);

    /** @ngInject */
    function StepRendicontazioneService(Constants, $resource) {

        var stepRendResource = $resource(Constants.restApiRoot + '/step-rendicontazione/:id', null, { 'update': { method:'PUT' } });
        var stepRendFirstMailResource = $resource(Constants.restApiRoot + '/step-rendicontazione/mail-comunicazione-date/:id', null, { 'update': { method:'PUT' } });
        var stepRendValMailResource = $resource(Constants.restApiRoot + '/step-rendicontazione/mail-valutazione-rend/:id', null, { 'update': { method:'POST', isArray: true} });
        var stepRendSecondMailResource = $resource(Constants.restApiRoot + '/step-rendicontazione/mail-modifica-date/:id', null, { 'update': { method:'PUT' } });

        var service = {
            updatePeriod: updatePeriod,
            inviaMailComunicazioneDate: inviaMailComunicazioneDate,
            inviaMailValutazioneRend: inviaMailValutazioneRend,
            inviaMailModificaDate: inviaMailModificaDate
        };

        return service;

        function updatePeriod(stepId, startDate, endDate) {

            var obj = {
                id: stepId,
                startDate: startDate,
                endDate: endDate
            }

            return stepRendResource.update({'id': stepId}, obj).$promise;
        }

        function inviaMailComunicazioneDate(stepId) {
            return stepRendFirstMailResource.update({'id': stepId}, null).$promise;
        }

        function inviaMailValutazioneRend(stepId) {
            return stepRendValMailResource.update({'id': stepId}, null).$promise;
        }

        function inviaMailModificaDate(stepId) {
            return stepRendSecondMailResource.update({'id': stepId}, null).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('SsdService', SsdService);

    /** @ngInject */
    function SsdService(Constants, $resource) {

        var ssdResource = $resource(Constants.restApiRoot + '/ssds');

        var service = {
            getAllSsd: getAllSsd
        };

        return service;

        function getAllSsd() {
            return ssdResource.query().$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('SottoSettoriErcService', SottoSettoriErcService);

    /** @ngInject */
    function SottoSettoriErcService(Constants, $resource) {
        
        var sottoSettoriERCResource = $resource(Constants.restApiRoot + '/sotto-settori-erc');

        var service = {
            getSottoSettoriERC: getSottoSettoriERC
        };

        return service;
        
        function getSottoSettoriERC() {
            return sottoSettoriERCResource.query().$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('SettoriErcService', SettoriErcService);

    /** @ngInject */
    function SettoriErcService(Constants, $resource) {
        
        var settoriResource = $resource(Constants.restApiRoot + '/settoriERC');

        var service = {
            getSettoriERC: getSettoriERC
        };

        return service;
        
        function getSettoriERC() {
            return settoriResource.query().$promise;
        }
        
    }
})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .factory('SeduteCertService', SeduteCertService);

    /** @ngInject */
    function SeduteCertService(Constants, $resource) {

        var pathSeduta = "/cert/seduta/";

        var seduteList = $resource(Constants.restApiRoot + pathSeduta + 'getSeduteCertList');
        var dettaglioSeduta = $resource(Constants.restApiRoot + pathSeduta + ':id');
        var proposteCertForSeduta = $resource(Constants.restApiRoot + pathSeduta + 'getProposteCertForSeduta');
        var membriPropostaBySeduta = $resource(Constants.restApiRoot + pathSeduta + 'membriProposta/:id');
        var saveSeduta = $resource(Constants.restApiRoot + pathSeduta + 'save');

        var service = {
            getSeduteCertList: getSeduteCertList,
            getDettaglioSeduta: getDettaglioSeduta,
            getProposteCertForSeduta: getProposteCertForSeduta,
            getCertMembriPropostaBySeduta: getCertMembriPropostaBySeduta,
            saveSedutaAndMembri: saveSedutaAndMembri
        };
        return service;

        function saveSedutaAndMembri(certSedutaObj) {
            return saveSeduta.save(certSedutaObj).$promise;
        }

        function getCertMembriPropostaBySeduta(sedutaId) {
            return membriPropostaBySeduta.query({'id': sedutaId}).$promise;
        }

        function getProposteCertForSeduta(filter) {
            return proposteCertForSeduta.get(filter).$promise;
        }

        function getSeduteCertList(filter) {
            return seduteList.get(filter).$promise;
        }

        function getDettaglioSeduta(sedutaId) {
            return dettaglioSeduta.get({'id': sedutaId}).$promise;
        }

    }
})();

(function() {
  'use strict';

  angular
    .module('sigeba')
    .factory('RuoliService', RuoliService);

  /** @ngInject */
  function RuoliService(Constants, $resource) {

    var ruoliResource = $resource(Constants.restApiRoot + '/ruoli');

    var service = {
      getRuoli: getRuoli
    };

    return service;

    function getRuoli() {
      return ruoliResource.query().$promise;
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RichiestePartecipazioneService', RichiestePartecipazioneService);

    /** @ngInject */
    function RichiestePartecipazioneService(Constants, $resource) {
        
        var partecipazioniResource = $resource(Constants.restApiRoot + '/partecipazioni');
        var partecipazioniAcceptResource = $resource(Constants.restApiRoot + '/partecipazioni/accept', null, { 'update': { method:'PUT' } });
        var partecipazioniRefuseResource = $resource(Constants.restApiRoot + '/partecipazioni/refuse', null, { 'update': { method:'PUT' } });

        var service = {
            getRichiestePartecipazione: getRichiestePartecipazione,
            accettaRichiestaPartecipazione: accettaRichiestaPartecipazione,
            rifiutaRichiestaPartecipazione: rifiutaRichiestaPartecipazione
        };

        return service;
        
        function getRichiestePartecipazione() {
            return partecipazioniResource.query().$promise;
        }
        
        function accettaRichiestaPartecipazione(propostaId) {
            return partecipazioniAcceptResource.update({id: propostaId}, null).$promise;
        }
        
        function rifiutaRichiestaPartecipazione(propostaId) {
            return partecipazioniRefuseResource.update({id: propostaId}, null).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RicaduteCulturaService', RicaduteCulturaService);

    /** @ngInject */
    function RicaduteCulturaService(Constants, $resource) {
        
        var ricaduteResource = $resource(Constants.restApiRoot + '/ricadute-diffusione-cultura');

        var service = {
            getRicadute: getRicadute
        };

        return service;
        
        function getRicadute() {
            return ricaduteResource.query().$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RendicontazioniUrService', RendicontazioniUrService);

    /** @ngInject */
    function RendicontazioniUrService(Constants, $resource) {

        var rendicontazioneIdResource = $resource(Constants.restApiRoot + '/ur/rendicontazioni/:id');
        var riapriResource = $resource(Constants.restApiRoot + '/ur/rendicontazioni/open/:rendicontazioneId', null, {
            'update': { method:'PUT' }
        });
        var valutazioneRendResource = $resource(Constants.restApiRoot + '/ur/rendicontazioni/valutazione/:id/:val', null, {
            'update': { method:'PUT' }
        });

        var service = {
            getRendicontazioneById: getRendicontazioneById,
            riapriRendicontazione: riapriRendicontazione,
            valutazioneRendicontazione: valutazioneRendicontazione
        };

        return service;

        function getRendicontazioneById(id) {
            return rendicontazioneIdResource.get({'id': id}).$promise;
        }

        function riapriRendicontazione(rendicontazioneId) {
            var obj = (rendicontazioneId) ? {rendicontazioneId: rendicontazioneId} : {};
            return riapriResource.update(obj, {}).$promise;
        }

        function valutazioneRendicontazione(rendicontazioneId, val, consolida) {
            var obj= {};
                obj = (rendicontazioneId) ? {rendicontazioneId: rendicontazioneId} : {};
                obj.valutazione = val;
                obj.consolida = consolida;
                return valutazioneRendResource.update(obj, null).$promise;

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RendicontazioniRadService', RendicontazioniRadService);

    /** @ngInject */
    function RendicontazioniRadService(Constants, $resource) {
        
        var rendicontazioneIdResource = $resource(Constants.restApiRoot + '/rad/rendicontazioni/:id');

        var service = {
            getRendicontazioneById: getRendicontazioneById
        };

        return service;
        
        function getRendicontazioneById(id) {
            return rendicontazioneIdResource.get({'id': id}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RendicontazioniService', RendicontazioniService);

    /** @ngInject */
    function RendicontazioniService(Constants, $resource) {
        
        var rendicontazioniResource = $resource(Constants.restApiRoot + '/rendicontazioni');
        var rendicontazioneIdResource = $resource(Constants.restApiRoot + '/rendicontazioni/:id', null, { 'update': { method:'PUT' } });
        var newRendicontazioneResource = $resource(Constants.restApiRoot + '/rendicontazioni/new/:propostaId/:stepId');
        var rendValidazioneResource = $resource(Constants.restApiRoot + '/rendicontazioni/validazione/:id');
        var rendSottomissioneResource = $resource(Constants.restApiRoot + '/rendicontazioni/sottomissione/:id', null, { 'update': { method:'PUT' } });

        var service = {
            //getRendicontazioni: getRendicontazioni,
            getRendicontazioneById: getRendicontazioneById,
            getNewRendicontazione: getNewRendicontazione,
            saveRendicontazione: saveRendicontazione,
            updateRendicontazione: updateRendicontazione,
            deleteRendicontazione: deleteRendicontazione,
            validaRendicontazione: validaRendicontazione,
            inviaRendicontazione: inviaRendicontazione
        };

        return service;
        
        /*function getRendicontazioni() {
            var filter = (anno) ? {'anno': anno} : {};
            return rendicontazioniResource.query(filter).$promise;
        }*/
        
        function getRendicontazioneById(id) {
            return rendicontazioneIdResource.get({'id': id}).$promise;
        }
        
        function getNewRendicontazione(propostaId, stepId) {
            return newRendicontazioneResource.get({'propostaId': propostaId, 'stepId': stepId}).$promise;
        }
        
        function saveRendicontazione(rendicontazione) {
            return rendicontazioniResource.save(rendicontazione).$promise;
        }
        
        function updateRendicontazione(rendicontazione) {
            return rendicontazioneIdResource.update({id: rendicontazione.id}, rendicontazione).$promise;
        }
        
        function deleteRendicontazione(rendicontazione) {
            return rendicontazioneIdResource.delete({id: rendicontazione.id}).$promise;
        }
        
        function validaRendicontazione(id) {
            return rendValidazioneResource.get({'id': id}).$promise;
        }
        
        function inviaRendicontazione(id) {
            return rendSottomissioneResource.update({'id': id}, null).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RefereeExtService', RefereeExtService);

    /** @ngInject */
    function RefereeExtService(Constants, $resource) {
        
        var refereeExtResource = $resource(Constants.restApiRoot + '/referee/:id/ext');

        var service = {
            getRefereeData: getRefereeData,
            setAcceptReferee: setAcceptReferee
        };

        return service;
        
        function getRefereeData(refereeId, refereeToken) {
            return refereeExtResource.get({id: refereeId, rToken: refereeToken}).$promise;
        }
        
        function setAcceptReferee(refereeId, refereeToken, accept) {
            return refereeExtResource.save({id: refereeId, rToken: refereeToken}, {id: refereeId, accettato: accept}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('RefereeService', RefereeService);

    /** @ngInject */
    function RefereeService(Constants, $resource) {
        
        var refereeResource = $resource(Constants.restApiRoot + '/referee/:id', null, {
            'update': { method:'PUT' }
        });
        var refereListResource = $resource(Constants.restApiRoot + '/referee/proposta/:propostaId');
        
        var disableResource = $resource(Constants.restApiRoot + '/referee/disable/:id');

        var nonNecessariResource = $resource(Constants.restApiRoot + '/referee/proposta/:propostaId/enable-non-necessari');

        var service = {
            addReferee: addReferee,
            getReferee: getReferee,
            getRefereeByPropostaId: getRefereeByPropostaId,
            disableRefereeById: disableRefereeById,
            enableNonNecessari: enableNonNecessari
        };

        return service;
        
        function getReferee(refereeId) {
            var obj = (refereeId) ? {id: refereeId}  : {};
            return refereeResource.get(obj).$promise;
        }
        
        function addReferee(referee, proposta, faseId) {
            var obj = {};
            
            if(referee) {
                obj = referee;
                obj.proposta = {
                    id: proposta.id
                };
                if (faseId != null)
                    obj.faseValutazioneId = faseId;
            }
            return refereeResource.save(obj).$promise;
        }
        
        function getRefereeByPropostaId(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId}  : {};
            return refereListResource.get(obj).$promise;
        }
        
        function disableRefereeById(id) {
            var obj = (id) ? {id: id}  : {};
            return disableResource.save(obj, {}).$promise;
        }

        function enableNonNecessari(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId}  : {};
            return nonNecessariResource.save(obj, {}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('PubblicazioniService', PubblicazioniService);

    /** @ngInject */
    function PubblicazioniService(Constants, $resource) {
        
        var pubblicazioniResource = $resource(Constants.restApiRoot + '/pubblicazioni');
        var pubblicazioniByIdUgovResource = $resource(Constants.restApiRoot + '/pubblicazioni/id-ugov/:idUgov');
        var pubblicazioniByHandleResource = $resource(Constants.restApiRoot + '/pubblicazioni/handle');

        var service = {
            getPubblicazioni: getPubblicazioni,
            getPubblicazioneByIdUgov: getPubblicazioneByIdUgov,
            getPubblicazioneByHandle: getPubblicazioneByHandle
        };

        return service;
        
        function getPubblicazioni(limit, offset) {
            return pubblicazioniResource.get({
                'limit': limit,
                'offset': offset
            }).$promise;
        }
        
        function getPubblicazioneByIdUgov(idUgov) {
            return pubblicazioniByIdUgovResource.get({
                'idUgov': idUgov
            }).$promise;
        }
        
        function getPubblicazioneByHandle(handle) {
            return pubblicazioniByHandleResource.get({
                'handle': handle
            }).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProposteUrService', ProposteUrService);

    /** @ngInject */
    function ProposteUrService(Constants, $resource, $httpParamSerializer, UserData, $log) {

        var proposteResource = $resource(Constants.restApiRoot + '/ur/proposte');
        var propostaIdResource = $resource(Constants.restApiRoot + '/ur/proposte/:id');
        // var anniUrResource = $resource(Constants.restApiRoot + '/proposte/anni/:id');
        var propostaIdResourceUtente = $resource(Constants.restApiRoot + '/ur/proposte/listaProposte/proposteByUtente');
        var statisticheResource = $resource(Constants.restApiRoot + '/ur/proposte/riepilogo');
        var titolariResource = $resource(Constants.restApiRoot + '/ur/proposte/:id/titolari', null, { 'update': { method:'PUT' } });
        var indPropostaResource = $resource(Constants.restApiRoot + '/ur/proposte/:id/indicatori-valutazione');
        var ruoloCompontente = $resource(Constants.restApiRoot + '/ur/proposte/ruoloCompontente');
        var riapriPropostaResource = $resource(Constants.restApiRoot + '/ur/proposte/:id/riapri-proposta', null, { 'put': { method:'PUT' } });

        var service = {
            getProposte: getProposte,
            getRuoloComponente:getRuoloComponente,
            // getAnni: getAnni,
            getProposteByUtente: getProposteByUtente,
            getPropostaById: getPropostaById,
            getStatistiche: getStatistiche,
            getCsvExportUrl: getCsvExportUrl,
            cambiaTitolareProgetto: cambiaTitolareProgetto,
            getStoricoTitolariProgetto: getStoricoTitolariProgetto,
            getStatisticheExportUrl: getStatisticheExportUrl,
            getIndicatoriValutazioneProposta: getIndicatoriValutazioneProposta,
            riapriProposta: riapriProposta
        };

        return service;

        function getRuoloComponente(proposta,utenteId) {
            var filter={
                "proposta":proposta,
                "utenteId":utenteId
            }
            $log.log(typeof filter.proposta);
            $log.log(typeof filter.utenteId);
            return ruoloCompontente.get(filter).$promise;
        }

        function getProposteByUtente(filter) {
            // var filter ={"anno":anno,"utenteId":utenteId}
            return propostaIdResourceUtente.get(filter).$promise;
        }

        function getProposte(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            return proposteResource.get(filter).$promise;
        }

        function getPropostaById(id) {
            return propostaIdResource.get({'id': id}).$promise;
        }

        function getStatistiche(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return statisticheResource.query(filter).$promise;
        }

        function getCsvExportUrl(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/ur/proposte/export';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }

        function cambiaTitolareProgetto(propostaId, cambio) {
            return titolariResource.save({id: propostaId}, cambio).$promise;
        }

        function getStoricoTitolariProgetto(propostaId) {
            return titolariResource.query({id: propostaId}).$promise;
        }

        function getStatisticheExportUrl(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/ur/proposte/riepilogo/export';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }

        function getIndicatoriValutazioneProposta(id) {
            return indPropostaResource.query({'id': id}).$promise;
        }

        function riapriProposta(propostaId) {
            var obj = (propostaId) ? {id: propostaId} : {};
            return riapriPropostaResource.put(obj, null).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProposteRefService', ProposteRefService);

    /** @ngInject */
    function ProposteRefService(Constants, $resource) {
        
        var propostaIdResource = $resource(Constants.restApiRoot + '/referee/proposte/:id');

        var service = {
            getPropostaById: getPropostaById
        };

        return service;
        
        function getPropostaById(id) {
            return propostaIdResource.get({'id': id}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProposteRadService', ProposteRadService);

    /** @ngInject */
    function ProposteRadService(Constants, $resource, $httpParamSerializer, UserData) {
        
        var proposteResource = $resource(Constants.restApiRoot + '/rad/proposte');
        var propostaIdResource = $resource(Constants.restApiRoot + '/rad/proposte/:id');

        var service = {
            getProposte: getProposte,
            getPropostaById: getPropostaById,
            getCsvExportUrl: getCsvExportUrl
        };

        return service;
        
        function getProposte(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            return proposteResource.get(filter).$promise;
        }
        
        function getPropostaById(id) {
            return propostaIdResource.get({'id': id}).$promise;
        }
        
        function getCsvExportUrl(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/rad/proposte/export';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProposteMcService', ProposteMcService);

    /** @ngInject */
    function ProposteMcService(Constants, $resource, $httpParamSerializer, UserData) {
        
        var proposteResource = $resource(Constants.restApiRoot + '/mc/proposte');
        var propostaIdResource = $resource(Constants.restApiRoot + '/mc/proposte/:id');
        var statisticheResource = $resource(Constants.restApiRoot + '/mc/proposte/riepilogo');
        var anniResource = $resource(Constants.restApiRoot + '/mc/proposte/anni');
        var indPropostaResource = $resource(Constants.restApiRoot + '/mc/proposte/:id/indicatori-valutazione');

        var service = {
            getProposte: getProposte,
            getPropostaById: getPropostaById,
            getStatistiche: getStatistiche,
            getAnni: getAnni,
            getCsvExportUrl: getCsvExportUrl,
            getCsvExportValUrl: getCsvExportValUrl,
            getStatisticheExportUrl: getStatisticheExportUrl,
            getIndicatoriValutazioneProposta: getIndicatoriValutazioneProposta
        };

        return service;
        
        function getProposte(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            return proposteResource.get(filter).$promise;
        }
        
        function getPropostaById(id) {
            return propostaIdResource.get({'id': id}).$promise;
        }
        
        function getStatistiche(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return statisticheResource.query(filter).$promise;
        }
        
        function getAnni() {
            return anniResource.query().$promise;
        }
        
        function getCsvExportUrl(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/mc/proposte/export';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }
        
        function getCsvExportValUrl(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/mc/proposte/export/valutazioni';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }
        
        function getStatisticheExportUrl(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            filter.token = UserData.getToken();
            var url = Constants.restApiRoot + '/mc/proposte/riepilogo/export';
            url += '?' + $httpParamSerializer(filter);
            return url;
        }
        
        function getIndicatoriValutazioneProposta(id) {
            return indPropostaResource.query({'id': id}).$promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProposteService', ProposteService);

    /** @ngInject */
    function ProposteService(Constants, $resource, $http) {

        var proposteResource = $resource(Constants.restApiRoot + '/proposte');
        var anniResource = $resource(Constants.restApiRoot + '/proposte/anni');
        var propostaIdResource = $resource(Constants.restApiRoot + '/proposte/:id', null, { 'update': { method:'PUT' } });
        var newPropostaResource = $resource(Constants.restApiRoot + '/proposte/new/:classeId');
        var propostaIdPartResource = $resource(Constants.restApiRoot + '/proposte-partecipanti/:id', null, { 'update': { method:'PUT' } });
        var propostaValidazioneResource = $resource(Constants.restApiRoot + '/proposte/validazione/:id');
        var propostaSottomissioneResource = $resource(Constants.restApiRoot + '/proposte/sottomissione/:id', null, { 'update': { method:'PUT' } });
        var proposteDaRendicontareResource = $resource(Constants.restApiRoot + '/proposte/da-rendicontare');
        var proposteFinanziateResource = $resource(Constants.restApiRoot + '/proposte/finanziate');
        var indPropostaResource = $resource(Constants.restApiRoot + '/proposte/:id/indicatori-valutazione');

        var proposteCert = $resource(Constants.restApiRoot + '/cert/');
        var proposteCertValutazione = $resource(Constants.restApiRoot + '/cert/getListValutazione');
        var propostaCertById = $resource(Constants.restApiRoot + '/cert/formulario');
        var feedPropostaCert = $resource(Constants.restApiRoot + '/cert/feedCompilati');
        var updatePropostaCert = $resource(Constants.restApiRoot + '/cert/updatePropostaCert', null, { 'update': { method:'PUT' } });
        var downloadNonValutabili = Constants.restApiRoot + '/cert/download/proposteCert?'
        var upDeletePropostaCert = $resource(Constants.restApiRoot + '/cert/deletePropostaCert', null, { 'delete': { method:'DELETE' } });
        var updateStatoPropostaCert = Constants.restApiRoot + '/cert/updateStatoAndInfoPropostaCert';
        var updateNoteCertUrl = Constants.restApiRoot + '/cert/note/salvaModificaNotaCert';
        var infoMembroCommissione = $resource(Constants.restApiRoot + '/cert/infoMembroCommissione');
        var allnoteProposteCert = $resource(Constants.restApiRoot + '/cert/note/:propostaCertId');
        var riapriPropostaCertResource = $resource(Constants.restApiRoot + '/cert/:id/riapri-proposta', null, { 'put': { method:'PUT' } });



        var service = {
            getProposte: getProposte,
            getAnni: getAnni,
            getPropostaById: getPropostaById,
            getNewProposta: getNewProposta,
            saveProposta: saveProposta,
            updateProposta: updateProposta,
            deleteProposta: deleteProposta,
            getPropostaPartById: getPropostaPartById,
            updatePropostaPart: updatePropostaPart,
            validaProposta: validaProposta,
            inviaProposta: inviaProposta,
            getProposteDaRendicontare: getProposteDaRendicontare,
            getProposteFinanziate: getProposteFinanziate,
            getIndicatoriValutazioneProposta: getIndicatoriValutazioneProposta,
            getProposteCert: getProposteCert,
            getProposteCertValutazione: getProposteCertValutazione,
            getFormularioCertById: getFormularioCertById,
            getFeedPropostaCertById: getFeedPropostaCertById,
            putUpdatePropostaCert: putUpdatePropostaCert,
            putUpdateStatoPropostaCert: putUpdateStatoPropostaCert,
            updateNoteCert: updateNoteCert,
            getNonValutabili: getNonValutabili,
            deletePropostaCert: deletePropostaCert,
            getInfoMembroCommissione: getInfoMembroCommissione,
            getAllNoteProposta: getAllNoteProposta,
            riapriPropostaCert: riapriPropostaCert
        };

        return service;

        function getProposte(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return proposteResource.query(filter).$promise;
        }

        function getAnni() {
            return anniResource.query().$promise;
        }

        function getPropostaById(id) {
            return propostaIdResource.get({'id': id}).$promise;
        }

        function getNewProposta(classeId) {
            return newPropostaResource.get({'classeId': classeId}).$promise;
        }

        function saveProposta(proposta) {
            return proposteResource.save(proposta).$promise;
        }

        function updateProposta(proposta) {
            return propostaIdResource.update({id: proposta.id}, proposta).$promise;
        }

        function deleteProposta(proposta) {
            return propostaIdResource.delete({id: proposta.id}).$promise;
        }

        function getPropostaPartById(id) {
            return propostaIdPartResource.get({'id': id}).$promise;
        }

        function updatePropostaPart(proposta) {
            return propostaIdPartResource.update({id: proposta.id}, proposta).$promise;
        }

        function validaProposta(id) {
            return propostaValidazioneResource.get({'id': id}).$promise;
        }

        function inviaProposta(id) {
            return propostaSottomissioneResource.update({'id': id}, null).$promise;
        }

        function getProposteDaRendicontare() {
            return proposteDaRendicontareResource.query().$promise;
        }

        function getProposteFinanziate(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return proposteFinanziateResource.query(filter).$promise;
        }

        function getIndicatoriValutazioneProposta(id) {
            return indPropostaResource.query({'id': id}).$promise;
        }

        function getProposteCert() {
            return proposteCert.query().$promise;
        }

        function getProposteCertValutazione(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            // return proposteCertValutazione.query(filter).$promise;
            return proposteCertValutazione.get(filter).$promise;
        }

        function getFormularioCertById(id) {
            var propostaId = (id) ? {'propostaCertId': id} : null;
            return propostaCertById.get(propostaId).$promise;
        }

        function getFeedPropostaCertById(id) {
            var propostaId = (id) ? {'propostaCertId': id} : null;
            return feedPropostaCert.query(propostaId).$promise;
        }

        function putUpdatePropostaCert( payload ) {
            return updatePropostaCert.update( null, payload ).$promise;
        }

        function putUpdateStatoPropostaCert(query) {
            return $http({
                method: 'PUT',
                url: updateStatoPropostaCert,
                data: query
            });
        }

        function updateNoteCert(query) {
            return $http({
                method: 'PUT',
                url: updateNoteCertUrl,
                data: query
            });
        }

        function deletePropostaCert( id ) {
            var propostaId = (id) ? {'propostaCertId': id} : null;
            return upDeletePropostaCert.delete( propostaId, null ).$promise;
        }

        function getNonValutabili(parameter) {
            return downloadNonValutabili += parameter
        }

        function getInfoMembroCommissione(propostaId) {
            var queryList = {'propostaCertId': propostaId};
            return infoMembroCommissione.get(queryList).$promise;
        }

        function getAllNoteProposta(propostaId) {
            return allnoteProposteCert.query({'propostaCertId': propostaId}).$promise;
        }

        function riapriPropostaCert(propostaId) {
            var obj = (propostaId) ? {id: propostaId} : {};
            return riapriPropostaCertResource.put(obj, null).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProfiloUtenteEsternoService', ProfiloUtenteEsternoService);

    /** @ngInject */
    function ProfiloUtenteEsternoService(Constants, $resource) {
        
        var profiloIdResource = $resource(Constants.restApiRoot + '/profilo-utente-esterno/:id');

        var service = {
            getProfilo: getProfilo
        };

        return service;
        
        function getProfilo(id) {
            return profiloIdResource.get({'id': id}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ProfiloUtenteService', ProfiloUtenteService);

    /** @ngInject */
    function ProfiloUtenteService(Constants, $resource, $http) {

        var profiloIdResource = $resource(Constants.restApiRoot + '/profilo-utente/:id', null, { 'update': { method:'PUT' } });
        var profiloIdUgovResource = $resource(Constants.restApiRoot + '/profilo-utente/:id/U-GOV');
        var checkPermessiResource = $resource(Constants.restApiRoot + '/profilo-utente/:id/checkPermessi');
        var mesiCongedoResource = $resource(Constants.restApiRoot + '/profilo-utente/:id/mesiCongedo', null , {
            update: { method:'POST', params: { mesiCongedoA: '@mesiCongedoA',  mesiCongedoBC: '@mesiCongedoBC' } }
        });
        var datiEsternoResource = $resource(Constants.restApiRoot + '/profilo-utente/:id/datiEsterno', null , {
            update: { method:'PUT', params: { email: '@email',  affiliazione: '@affiliazione' } }
        });
        var mailCongedoResource = $resource(Constants.restApiRoot + '/profilo-utente/invioMailCongedo');

        var service = {
            getProfilo: getProfilo,
            updateProfilo: updateProfilo,
            updateUgov: updateUgov,
            invioMailCongedo: invioMailCongedo,
            getMesiCongedo: getMesiCongedo,
            checkPermessiCongedo: checkPermessiCongedo,
            mesiCongedo: mesiCongedo,
            datiEsterno: datiEsterno
        };

        return service;

        function getProfilo(id) {
            return profiloIdResource.get({'id': id}).$promise;
        }

        function updateProfilo(id, modifiche) {
            return profiloIdResource.update({id: id}, modifiche).$promise;
        }

        function updateUgov(id) {
            return profiloIdUgovResource.save({id: id}, null).$promise;
        }

        function invioMailCongedo() {
            return mailCongedoResource.save({}).$promise;
        }

        function checkPermessiCongedo(id) {
            // return checkPermessiResource.get({id: id}).$promise;
            // Non chiedetemi perchè... non andava con $resource
            return $http.get( Constants.restApiRoot  + '/profilo-utente/' + id + '/checkPermessi')
        }

        function getMesiCongedo(id) {
            return mesiCongedoResource.get({id: id}).$promise;
        }

        function mesiCongedo( id, _a, _bc ) {
            return mesiCongedoResource.update({ id:id, mesiCongedoA: _a, mesiCongedoBC: _bc }, null).$promise;
        }

        function datiEsterno( id, email, affiliazione ) {
            return datiEsternoResource.update({ id:id, email: email, affiliazione: affiliazione }, null).$promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('ParoleChiaveService', ParoleChiaveService);

    /** @ngInject */
    function ParoleChiaveService(Constants, $resource) {
        
        var paroleChiaveResource = $resource(Constants.restApiRoot + '/parole-chiave-cun');

        var service = {
            getParoleChiaveCUN: getParoleChiaveCUN
        };

        return service;
        
        function getParoleChiaveCUN() {
            return paroleChiaveResource.query().$promise;
        }
        
    }
})();

(function () {
        'use strict';

        angular
            .module('sigeba')
            .factory('MediaService', MediaService);

        /** @ngInject */
        function MediaService(Constants, $resource,$httpParamSerializer) {

            var mediaPdfResource = $resource(Constants.restApiRoot + '/media/pdf', null, {
                'save': {
                    method: 'POST',
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            });
            var mediaXlsxResource = $resource(Constants.restApiRoot + '/media/xlsx', null, {
                'save': {
                    method: 'POST',
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            });
            var mediaFileUploadResource = $resource(Constants.restApiRoot + '/media/fileUpload', null, {
                'save': {
                    method: 'POST',
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            });
            var mediaImageResource = $resource(Constants.restApiRoot + '/media/img', null, {
                'save': {
                    method: 'POST',
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }
            });
            var mediaNewResource = $resource(Constants.restApiRoot + '/media/massivo');
            // var massivoResource = ;

            var service = {
                getMassivo: getMassivo,
                uploadPdf: uploadPdf,
                uploadXlsx: uploadXlsx,
                uploadPdfMaxFileSize: uploadPdfMaxFileSize,
                uploadImage: uploadImage,
                uploadFile: uploadFile,
                salvaDati: salvaDati,
                downloadTemplate: downloadTemplate,
                downloadSpecifiedFile: downloadSpecifiedFile
            };

            return service;

            function getMassivo(filter) {
                return $resource(Constants.restApiRoot + '/media/massivi/listaprogettimassivo', null, {
                    'query': {
                        method: 'GET',
                        isArray: false
                    }
                }).query(filter).$promise;
            }

            function salvaDati(data) {
                return mediaNewResource.save(data).$promise;
            }

            function downloadTemplate(tipologia) {
                var filter = tipologia ? {'tipologia': tipologia} : null;
                var url = Constants.restApiRoot + "/media/downloadTemplate/tipo";
                url += "?" + $httpParamSerializer(filter);
                return url;
            }

            function downloadSpecifiedFile() {
                return Constants.restApiRoot;
            }

            function uploadFile(file, filetype) {
                if (filetype) {
                    var fd = new FormData();
                    fd.append('file', file);
                    fd.append('filetype', filetype)

                    return mediaFileUploadResource.save(fd).$promise;
                }
                return uploadPdf(file);
            }

            function uploadPdf(file) {
                var fd = new FormData();
                fd.append('file', file);

                return mediaPdfResource.save(fd).$promise;
            }

            function uploadXlsx(file) {
                var formdata = new FormData();
                formdata.append('file', file);
                return mediaXlsxResource.save(formdata).$promise;
            }

            function uploadPdfMaxFileSize(file, maxfilesize) {
                var fd = new FormData();
                fd.append('file', file);
                if (maxfilesize) {
                    fd.append('maxfilesize', maxfilesize);
                }
                return mediaPdfResource.save(fd).$promise;
            }

            function uploadImage(file) {
                var fd = new FormData();
                fd.append('file', file);
                return mediaImageResource.save(fd).$promise;
            }
        }
    }

)();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('MacroareeService', MacroareeService);

    /** @ngInject */
    function MacroareeService(Constants, $resource) {
        
        var macroareeResource = $resource(Constants.restApiRoot + '/macroaree');

        var service = {
            getMacroaree: getMacroaree
        };

        return service;
        
        function getMacroaree(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return macroareeResource.query(filter).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('IterBandiUrService', IterBandiUrService);

    /** @ngInject */
    function IterBandiUrService(Constants, $resource) {
        
        var iterBandiResource = $resource(Constants.restApiRoot + '/ur/iter-bandi');
        var iterBandiUfficializzazioneResource = $resource(Constants.restApiRoot + '/ur/iter-bandi/ufficializzazione/:id', null, { 'update': { method:'PUT' } });

        var service = {
            getIterBandi: getIterBandi,
            ufficializzaClasse: ufficializzaClasse
        };

        return service;
        
        function getIterBandi(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return iterBandiResource.query(filter).$promise;
        }
        
        function ufficializzaClasse(classeId) {
            return iterBandiUfficializzazioneResource.update({'id': classeId}, null).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('InattiviService', InattiviService);

    /** @ngInject */
    function InattiviService(Constants, $resource) {

        var anniResource = $resource(Constants.restApiRoot + '/ur/inattivi/anni');
        var tipiInattiviResource = $resource(Constants.restApiRoot + '/ur/inattivi/tipologie');

        var service = {
            getAnni: getAnni,
            getTipologie: getTipologie
        };

        return service;

        function getAnni() {
            return anniResource.query().$promise;
        }

        function getTipologie() {
            return tipiInattiviResource.query().$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('GestInattiviUrService', GestInattiviUrService);

    /** @ngInject */
    function GestInattiviUrService(Constants, $resource) {

        var inattiviResource = $resource(Constants.restApiRoot + '/ur/inattivi');
        var inattiviIdResource = $resource(Constants.restApiRoot + '/ur/inattivi/:id', null, { 'update': { method:'PUT' } });
        var inattiviNewResource = $resource(Constants.restApiRoot + '/ur/inattivi/new');

        var service = {
            getInattivi: getInattivi,
            deleteInattivo: deleteInattivo,
            saveInattivi: saveInattivi
        };

        return service;

        function getInattivi(searchFilter) {
            var filter = (searchFilter) ? searchFilter : {};
            return inattiviResource.get(filter).$promise;
        }

        function deleteInattivo(data) {
            return inattiviIdResource.save({id: data.id}, {motivazione: data.motivazione}).$promise;
        }

        function saveInattivi(data) {
            return inattiviNewResource.save(data).$promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('FormService', FormService);

    /** @ngInject */
    function FormService(Constants, $resource) {
        
        var formIdResource = $resource(Constants.restApiRoot + '/form/:id');

        var service = {
            getFormById: getFormById
        };

        return service;
        
        function getFormById(id) {
            return formIdResource.get({'id': id}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('FasiValutazioneService', FasiValutazioneService);

    /** @ngInject */
    function FasiValutazioneService(Constants, $resource) {
        
        var fasiListResource = $resource(Constants.restApiRoot + '/fasi-valutazione/proposta/:propostaId');

        var service = {
            getFasiValutazioneByPropostaId: getFasiValutazioneByPropostaId
        };

        return service;
        
        function getFasiValutazioneByPropostaId(propostaId) {
            var obj = (propostaId) ? {'propostaId': propostaId}  : {};
            return fasiListResource.query(obj).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('EsitoValutazioneUrService', EsitoValutazioneUrService);

    /** @ngInject */
    function EsitoValutazioneUrService(Constants, $resource) {
        
        var newEsitoResource = $resource(Constants.restApiRoot + '/ur/esito-valutazione/new/:propostaId');
        
        var updateEsitoResource = $resource(Constants.restApiRoot + '/ur/esito-valutazione/update/:propostaId', null, {
            'update': { method:'PUT' }
        });
        
        var esitoResource = $resource(Constants.restApiRoot + '/ur/esito-valutazione/:propostaId');
        
        var riapriEsitoResource = $resource(Constants.restApiRoot + '/ur/esito-valutazione/open/:propostaId', null, {
            'update': { method:'PUT' }
        });
        
        var service = {
            getEsitoValutazione: getEsitoValutazione,
            salvaEsitoValutazione: salvaEsitoValutazione,
            newEsitoValutazione: newEsitoValutazione,
            riapriEsitoValutazione: riapriEsitoValutazione
        };

        return service;
        
        function getEsitoValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return esitoResource.get(obj).$promise;
        }
        
        function salvaEsitoValutazione(esito, propostaId, concludi) {
            var obj = {};
            if (esito && esito.id) {
                obj = (propostaId) ? {propostaId: propostaId} : {};
                if (concludi)
                    obj.concludi = true
                return updateEsitoResource.update(obj, esito).$promise;
            }
            else {
                obj = {};
                if (concludi)
                    obj.concludi = true
                return esitoResource.save(obj, esito).$promise;
            }
        }
        
        function newEsitoValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return newEsitoResource.get(obj).$promise;
        }
        
        function riapriEsitoValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return riapriEsitoResource.update(obj, {}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('EsitoValutazioneMcService', EsitoValutazioneMcService);

    /** @ngInject */
    function EsitoValutazioneMcService(Constants, $resource) {
        
        var newEsitoResource = $resource(Constants.restApiRoot + '/mc/esito-valutazione/new/:propostaId');
        
        var updateEsitoResource = $resource(Constants.restApiRoot + '/mc/esito-valutazione/update/:propostaId', null, {
            'update': { method:'PUT' }
        });
        
        var esitoResource = $resource(Constants.restApiRoot + '/mc/esito-valutazione/:propostaId');
        
        var riapriEsitoResource = $resource(Constants.restApiRoot + '/mc/esito-valutazione/open/:propostaId', null, {
            'update': { method:'PUT' }
        });
        
        var service = {
            getEsitoValutazione: getEsitoValutazione,
            salvaEsitoValutazione: salvaEsitoValutazione,
            newEsitoValutazione: newEsitoValutazione,
            riapriEsitoValutazione: riapriEsitoValutazione
        };

        return service;
        
        function getEsitoValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return esitoResource.get(obj).$promise;
        }
        
        function salvaEsitoValutazione(esito, propostaId, concludi) {
            var obj = {};
            if (esito && esito.id) {
                obj = (propostaId) ? {propostaId: propostaId} : {};
                if (concludi)
                    obj.concludi = true
                return updateEsitoResource.update(obj, esito).$promise;
            }
            else {
                obj = {};
                if (concludi)
                    obj.concludi = true
                return esitoResource.save(obj, esito).$promise;
            }
        }
        
        function newEsitoValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return newEsitoResource.get(obj).$promise;
        }
        
        function riapriEsitoValutazione(propostaId) {
            var obj = (propostaId) ? {propostaId: propostaId} : {};
            return riapriEsitoResource.update(obj, {}).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('DizionariHorizonService', DizionariHorizonService);

    /** @ngInject */
    function DizionariHorizonService(Constants, $resource) {

        var lineeTematicheHorizonResource = $resource(Constants.restApiRoot + '/dizionariHorizon/lineeTematiche');
        var flagshipHorizonResource = $resource(Constants.restApiRoot + '/dizionariHorizon/flagship');

        var service = {
            getLineeTematicheHorizon: getLineeTematicheHorizon,
            getFlagShipHorizon: getFlagShipHorizon
        };

        return service;

        function getLineeTematicheHorizon() {
            return lineeTematicheHorizonResource.query().$promise;
        }

        function getFlagShipHorizon() {
            return flagshipHorizonResource.query().$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('DipartimentiUrService', DipartimentiUrService);

    /** @ngInject */
    function DipartimentiUrService(Constants, $resource) {

        var dipartimentiResource = $resource(Constants.restApiRoot + '/ur/dipartimenti');
        var dipartimentoIdResource = $resource(Constants.restApiRoot + '/ur/dipartimenti/:id', null, { 'update': { method:'PUT' } });

        var service = {
            getDipartimenti: getDipartimenti,
            getDipartimentoById: getDipartimentoById,
            updateRadDirDipartimento: updateRadDirDipartimento,
            updateRadRefDipartimento : updateRadRefDipartimento
        };

        return service;

        function getDipartimenti() {
            return dipartimentiResource.query().$promise;
        }

        function getDipartimentoById(id) {
            return dipartimentoIdResource.get({'id': id}).$promise;
        }

        function updateRadDirDipartimento(dipartimento) {
            return dipartimentoIdResource.update({id: dipartimento.id}, dipartimento).$promise;
        }

        function updateRadRefDipartimento(dipartimento) {
            return dipartimentoIdResource.update({id: dipartimento.id}, dipartimento).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('DipartimentiRadService', DipartimentiRadService);

    /** @ngInject */
    function DipartimentiRadService(Constants, $resource) {
        
        var dipartimentiResource = $resource(Constants.restApiRoot + '/rad/dipartimenti');

        var service = {
            getDipartimentiRad: getDipartimentiRad
        };

        return service;
        
        function getDipartimentiRad() {
            return dipartimentiResource.query().$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('DipartimentiDirDipService', DipartimentiDirDipService);

    /** @ngInject */
    function DipartimentiDirDipService(Constants, $resource) {
        
        var dipartimentiResource = $resource(Constants.restApiRoot + '/dirdip/dipartimenti');

        var service = {
            getDipartimentiDirDip: getDipartimentiDirDip
        };

        return service;
        
        function getDipartimentiDirDip() {
            return dipartimentiResource.query().$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('DipartimentiService', DipartimentiService);

    /** @ngInject */
    function DipartimentiService(Constants, $resource) {
        
        var dipartimentiResource = $resource(Constants.restApiRoot + '/dipartimenti');

        var service = {
            getDipartimenti: getDipartimenti
        };

        return service;
        
        function getDipartimenti() {
            return dipartimentiResource.query().$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('CriteriValutazioneService', CriteriValutazioneService);

    /** @ngInject */
    function CriteriValutazioneService(Constants, $resource) {
        
        var criteriPropostaResource = $resource(Constants.restApiRoot + '/criteri-valutazione/proposta/:propostaId');

        var service = {
            getCriteriByPropostaId: getCriteriByPropostaId
        };

        return service;
        
        function getCriteriByPropostaId(propostaId) {
            var filter = (propostaId) ? {'propostaId': propostaId} : {};
            return criteriPropostaResource.query(filter).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('CommissioniService', CommissioniService);

    /** @ngInject */
    function CommissioniService(Constants, $resource) {
        
        var commissioniResource = $resource(Constants.restApiRoot + '/commissioni');
        var commissioneIdResource = $resource(Constants.restApiRoot + '/commissioni/:id', null, { 'update': { method:'PUT' } });
        var tipologieProgettoResource = $resource(Constants.restApiRoot + '/commissioni/tipologie-progetto/:userId');

        var service = {
            getCommissioni: getCommissioni,
            getCommissioneById: getCommissioneById,
            saveCommissione: saveCommissione,
            updateCommissione: updateCommissione,
            deleteCommissione: deleteCommissione,
            getTipologieProgetto: getTipologieProgetto
        };

        return service;
        
        function getCommissioni(anno) {
            var filter = (anno) ? {'anno': anno} : {};
            return commissioniResource.query(filter).$promise;
        }
        
        function getCommissioneById(id) {
            return commissioneIdResource.get({'id': id}).$promise;
        }
        
        function saveCommissione(commissione) {
            return commissioniResource.save(commissione).$promise;
        }
        
        function updateCommissione(commissione) {
            return commissioneIdResource.update({id: commissione.id}, commissione).$promise;
        }
        
        function deleteCommissione(commissione) {
            return commissioneIdResource.delete({id: commissione.id}).$promise;
        }
        
        function getTipologieProgetto(userId, anno) {
            return tipologieProgettoResource.query({
                userId: userId,
                anno: anno
            }).$promise;
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('CertCommissioniService', CertCommissioniService);

    /** @ngInject */
    function CertCommissioniService(Constants, $resource) {

        var certCommissioniResource = $resource(Constants.restApiRoot + '/cert/commissioni');
        var certCommissioneIdResource = $resource(Constants.restApiRoot + '/cert/commissioni/:id', null, { 'update': { method:'PUT' } });
        var certMembroPropostaResource = $resource(Constants.restApiRoot + '/cert/commissioni/proposte');
        var certCommissioneAssociazione = $resource(Constants.restApiRoot + '/cert/commissioni/associazione');
        var commissioneCorrente = $resource(Constants.restApiRoot + '/cert/commissioni/corrente');


        var service = {
            getCertCommissioni: getCertCommissioni,
            getCommissioneById: getCommissioneById,
            saveCommissione: saveCommissione,
            getMembroProposte: getMembroProposte,
            getCertCommissioneCorrente: getCertCommissioneCorrente,
        };

        return service;

        function getCertCommissioneCorrente() {
            return commissioneCorrente.get().$promise;
        }

        function saveCommissione(data){
            return certCommissioneAssociazione.save(data).$promise;
        }

        function getCertCommissioni() {
            return certCommissioniResource.query().$promise;
        }

        function getCommissioneById(id) {
            return certCommissioneIdResource.get({'id': id}).$promise;
        }

        function getMembroProposte(searchFilter){
            var filter = (searchFilter) ? searchFilter : {};
            return certMembroPropostaResource.get(filter).$promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('BandiService', BandiService);

    /** @ngInject */
    function BandiService(Constants, $resource, $state, $q, $http, $log, ngDialog) {

        var bandiResource = $resource(Constants.restApiRoot + '/bandi');
        var anniResource = $resource(Constants.restApiRoot + '/bandi/anni');
        var bandiFilterResource = $resource(Constants.restApiRoot + '/bandi/getBandiByAnnoAndTipologia');
        var insertDuplicaBando = Constants.restApiRoot + '/bandi/insertBando';
        var updateBandoResource = $resource(Constants.restApiRoot + '/bandi/updateBando', null, {'update':{method:'PUT'}});

        var service = {
            getBandi: getBandi,
            getAnni: getAnni,
            getBandiByTipologia: getBandiByTipologia,
            getBandiValidi: getBandiValidi,
            getBandoDaId: getBandoDaId,
            insertBando: insertBando,
            updateBando: updateBando
        };

        return service;

        function getBandi(anno) {
            var filter = {};
            if (anno) {
                filter = {'anno': anno};
            }
            return bandiResource.query(filter).$promise;
        }

        function getBandiByTipologia(anno, tipologia) {
            var filter = { 'anno': null, 'tipologia': null};
            if (anno) {
                filter.anno = anno;
            }
            if (tipologia) {
                filter.tipologia = tipologia;
            }
            return bandiFilterResource.query(filter).$promise;
        }

        function getBandiValidi() {
            return $resource(Constants.restApiRoot + '/bandi/getBandiValidi').query().$promise;
        }

        function getBandoDaId(id) {
            return $resource(Constants.restApiRoot + '/bandi/' + id + '?completo=true').get().$promise;
        }

        function getAnni() {
            return anniResource.query().$promise;
        }

        function showSavingDialog() {
            var dialog = ngDialog.open({
                template: 'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                plain: true,
                showClose: false
            });

            return dialog;
        }

        function thenFunction(savingDialog, bandoId) {
            savingDialog.close();
            $state.go('urConfigBandoView', {'id': bandoId});

        }

        function catchFunction(savingDialog) {
            return function (error) {
                savingDialog.close();
                showErrorDialog(error.data.message);
            }
        }

        function showErrorDialog(message) { //eslint-disable-line no-unused-vars
            var dialog = ngDialog.open({
                template: '<h3 style="margin-top: 0px;">Errore</h3>' +
                    '<div class="alert alert-danger" ng-if="!ngDialogData.errorMessage"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div>' +
                    '<div class="alert alert-danger" ng-if="ngDialogData.errorMessage"><b>{{ngDialogData.errorMessage}}</b></div>',
                plain: true,
                showClose: true,
                data: {
                    errorMessage: message
                }
            });

            return dialog;
        }

        function insertBando(anno, dataInizio, dataFine, bando) {
            var deferred = $q.defer();
            var savingDialog = showSavingDialog();

            $http({
                url: insertDuplicaBando,
                method: "POST",
                params: {anno: anno, start_timestamp: dataInizio, end_timestamp: dataFine, bandoId: bando.id}
            }).then(function (result) {
                savingDialog.close();
                thenFunction(savingDialog, result.data);
                deferred.resolve();
                }, function (error) {
                $log.error(error);
                deferred.reject(error);
            }).catch(catchFunction(savingDialog));


        }

        function updateBando(bando) {
            return updateBandoResource.update(bando).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('AreecunService', AreecunService);

    /** @ngInject */
    function AreecunService(Constants, $resource) {

        var areeResource = $resource(Constants.restApiRoot + '/areeCUN');

        var service = {
            getAreeCun: getAreeCun
        };

        return service;

        function getAreeCun() {
            return areeResource.query().$promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('creazioneBandi', creazioneBandi);
    /** @ngInject **/
    function creazioneBandi() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/creazioneBandi/creazioneBandi.html',
            scope: {},
            bindToController: {},
            controller: creazioneBandiController,
            controllerAs: 'createController'
        };

        return directive;

        /** @ngInject **/
        function creazioneBandiController($location, $log, $state, ngDialog, BandiService, TipologieProgettoService) {
            var vm = this;

            vm.isCreate = $state.current && $state.current.name === 'urCreaBando';
            vm.isLoading = true;
            vm.selectedAnnoFilter = null;
            vm.selectedAnnoBando = new Date().getFullYear();
            vm.anni = null;
            vm.dataInizio = null;
            vm.dataFine = null;
            vm.startTime = '';
            vm.endTime = '';
            vm.selectedTipoClasse = null;
            vm.tipologiaFilter = null;
            vm.tipologieEClassi = [];
            vm.tipologieProgetto = [];
            vm.bandi = [];
            vm.minDate = new Date();
            vm.maxDate = new Date();
            vm.getTipologieProgetto = getTipologieProgetto;
            vm.getBandi = getBandi;
            vm.getProjectDetails = getProjectDetails;
            vm.getParam = getParam;
            vm.saveBando = saveBando;

            getAnni();

            function getAnni() {
                BandiService.getAnni()
                    .then(function (data) {
                            if (data.length > 0) {
                                vm.selectedAnnoFilter = data[0].anno;
                                vm.anni = data.map(function (value) {
                                    return value.anno;
                                })
                                getTipologieProgetto();
                                getBandi();
                            }
                        }
                    )
            }

            function getTipologieProgetto() {
                return TipologieProgettoService.getTipologieProgetto(vm.selectedAnnoFilter)
                    .then(function (data) {
                        var json = {
                            label: 'Tutte le tipologie di progetto',
                            tipologia: 'Tutte le tipologie di progetto',
                            classe: 'Tutte le classi dimensionali',
                            id: '*.*',
                            isGroup: true
                        };
                        if (!vm.selectedTipoClasse)
                            vm.selectedTipoClasse = json;
                        vm.tipologieEClassi.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var tipo = data[i];
                            json = {
                                label: tipo.nome,
                                tipologiaId: tipo.id,
                                tipologia: tipo.nome,
                                classe: 'Tutte le classi dimensionali',
                                id: tipo.id + '.*',
                                isGroup: true
                            };
                            vm.tipologieEClassi.push(json);
                            for (var j = 0; j < tipo.classeList.length; j++) {
                                var classe = tipo.classeList[j];
                                json = {
                                    label: classe.nome,
                                    tipologiaId: tipo.id,
                                    classeId: classe.id,
                                    tipologia: tipo.nome,
                                    classe: classe.nome,
                                    id: tipo.id + '.' + classe.id,
                                    isGroup: false
                                };
                                vm.tipologieEClassi.push(json);
                            }
                        }
                        var allTipologics = {
                            nome: "Tutte le tipologie di progetto"
                        }
                        vm.selectedTipoClasse = allTipologics;
                        vm.tipologieProgetto = data;
                        vm.tipologieProgetto.unshift(allTipologics);
                    });
            }

            function saveBando(bando) {
                if (vm.isCreate) {

                    var startTimestamp = createDateWithTime(vm.dataInizio, vm.startTime);
                    var endTimestamp = createDateWithTime(vm.dataFine, vm.endTime);

                    if (endTimestamp > startTimestamp) {
                        BandiService.insertBando(vm.selectedAnnoBando, startTimestamp.toString(), endTimestamp.toString(), bando);
                    } else {
                        ngDialog.open({
                            template: '' +
                                '<div class="alert-danger" style="height: 30px;"><b style="vertical-align: middle;">La data e ora fine devono essere maggiori della data e ora inizio</b></div>',
                            plain: true,
                            showClose: true
                        });
                    }

                } else {
                    $state.go('urConfigBandoView', {'id': bando.id});
                }
            }

            function createDateWithTime(dataString, time) {

                var dateParts = dataString.toString().split("/");
                var dateObject = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0], +time.getHours(), +time.getMinutes());
                return dateObject.getTime();
            }

            function getBandi() {
                vm.isLoading = true;
                if (vm.isCreate) {
                    return BandiService.getBandiByTipologia(vm.selectedAnnoFilter, vm.selectedTipoClasse && vm.selectedTipoClasse.id ? vm.selectedTipoClasse.id : null).then(function (value) {
                        vm.bandi = value;
                        vm.isLoading = false;
                    })
                } else {
                    return BandiService.getBandiValidi().then(function (value) {
                        vm.isLoading = false;
                        vm.bandi = value;
                    })
                }
            }



            function getProjectDetails(attributiList) {
                if (attributiList) {
                    var attributoValido = [];
                    attributiList.forEach(function (attributo) {
                        switch (attributo.codice) {
                            case 'FINANZIAMENTO_MAX':
                                attributo.descrizione = 'Importo massimo finanziabile';
                                attributoValido.push(attributo)
                                //TODO gestire i valori con istruzioni condizionali
                                break;
                            case 'FINANZIAMENTO_MIN':
                                attributo.descrizione = 'Importo minimo finanziabile'
                                var numlist = attributo.valore.match(/^\d+|\d+\b|\d+(?=\w)/g);
                                attributo.valore = numlist[0];
                                attributoValido.push(attributo);
                                //TODO aggiungere gli importi con la macroarea presente
                                break;
                            case 'PARTECIPANTI_MIN':
                                attributo.descrizione = 'Numero partecipanti minimo'
                                attributoValido.push(attributo);
                                break;
                            case 'PARTECIPANTI_MAX':
                                attributo.descrizione = 'Numero partecipanti massimo'
                                attributoValido.push(attributo);
                                break;
                            case 'NUMERO_PROGETTI_MIN':
                                attributo.descrizione = 'Numero minimo progetti'
                                attributoValido.push(attributo);
                                break;
                            case 'REFEREE_MAX':
                                attributo.descrizione = 'Numero massimo referee'
                                attributoValido.push(attributo);
                                break;
                            case 'MESI_FINANZIAMENTO':
                                attributo.descrizione = 'Mesi finanziamento'
                                attributoValido.push(attributo);
                                break;
                        }
                    });
                    return attributoValido;
                }
            }

            function getParam(paramlist) {
                if (paramlist) {
                    var lista = [];
                    for (var i = 0; i < paramlist.length; i++) {
                        if (paramlist[i].tipo === "ASSEGNO_RICERCA") {
                            lista.push(paramlist[i]);
                        }
                    }
                }
                return lista;
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('createCert', createCert);

    /** @ngInject */
    function createCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/createCert/createCert.html',
            scope: {},
            bindToController: {},
            controller: createCertController,
            controllerAs: 'formCert'
        };

        return directive;

        /** @ngInject */
        function createCertController($scope, $log, $state, $window) {
            var vm = this;

            vm.template = null;
            vm.data = null;
            vm.savedData = null;
            vm.validazione = null;
            vm.propostaSalvata = null;
            vm.propostaValidata = null;

            vm.salvaProposta = salvaProposta;
            vm.validaProposta = validaProposta;
            vm.inviaProposta = inviaProposta;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            $scope.$watch(function() { return vm.data; }, function(newValue, oldValue) {
                if (newValue != oldValue) {
                    vm.propostaSalvata = angular.equals(vm.data, vm.savedData);
                }
            }, true);

            function getDatiProposta() {

            }

            function inviaProposta() {
                
            }

            function validaProposta() {
                
            }

            function salvaProposta() {
                
            }


        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('configuraBando', configuraBando);

    /** @ngInject */
    function configuraBando() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/configuraBando/configuraBando.html',
            scope: {},
            bindToController: {
                bandoId: '='
            },
            controller: configuraBandoController,
            controllerAs: 'confCtrl'
        };


        /** @ngInject **/
        function configuraBandoController($log, $state, ngDialog, BandiService) {
            var vm = this;

            vm.bandoId = $state.params.id;
            vm.bando = {};
            vm.tipologia = "";
            vm.nomeClasse = "";
            vm.descrizioneClasse = "";
            vm.importoMinimoFin = null;
            vm.importoMassimoFin = null;
            vm.mesiFinanziamento = null;
            vm.criteriVal = false;
            vm.showDetail = showDetail;
            vm.showDetailVociSpesa = showDetailVociSpesa;
            vm.getProjectDetails = getProjectDetails;
            vm.getParam = getParam;
            vm.updateBando = updateBando;

            getBandoById();

            function getBandoById() {
                if (vm.bandoId && vm.bandoId > 0) {
                    BandiService.getBandoDaId(vm.bandoId)
                        .then(function (data) {
                            vm.bando = data;
                        })
                }
            }

            function getParam(paramlist) {
                if (paramlist) {
                    var lista = [];
                    for (var i = 0; i < paramlist.length; i++) {
                        if (paramlist[i].tipo === "ASSEGNO_RICERCA") {
                            lista.push(paramlist[i]);
                        }
                    }
                }
                return lista;
            }

            function showDetail(idClasse) {
                var compositeString = idClasse.toString();
                var elem = document.getElementById('criteriValDiv' + compositeString);
                var elem2 = document.getElementById('visualizzaCriteriValDiv' + compositeString);
                if (elem && elem.style.display !== 'none') {
                    elem.style.display = 'none';
                    elem2.style.display = 'initial';
                } else {
                    elem.style.display = 'block';
                    elem2.style.display = 'none';
                }
            }

            function showDetailVociSpesa(idClasse) {
                var compositeString = idClasse.toString();
                var elem = document.getElementById('vociSpesaDiv' + compositeString);
                var elem2 = document.getElementById('visualizzaVociSpesaDiv' + compositeString);
                if (elem && elem.style.display !== 'none') {
                    elem.style.display = 'none';
                    elem2.style.display = 'initial';
                } else {
                    elem.style.display = 'block';
                    elem2.style.display = 'none';
                }
            }

            function getProjectDetails(attributiList) {
                if (attributiList) {
                    var attributoValido = [];
                    attributiList.forEach(function (attributo) {
                        switch (attributo.codice) {
                            case 'FINANZIAMENTO_MAX':
                                attributo.descrizione = 'Importo massimo finanziabile (€)';
                                attributoValido.push(attributo)
                                //TODO gestire i valori con istruzioni condizionali
                                break;
                            case 'FINANZIAMENTO_MIN':
                                attributo.descrizione = 'Importo minimo finanziabile (€)'
                                var numlist = attributo.valore.match(/^\d+|\d+\b|\d+(?=\w)/g);
                                attributo.valore = numlist[0];
                                attributoValido.push(attributo);
                                //TODO aggiungere gli importi con la macroarea presente
                                break;
                            case 'PARTECIPANTI_MIN':
                                attributo.descrizione = 'Numero partecipanti minimo'
                                attributoValido.push(attributo);
                                break;
                            case 'PARTECIPANTI_MAX':
                                attributo.descrizione = 'Numero partecipanti massimo'
                                attributoValido.push(attributo);
                                break;
                            case 'NUMERO_PROGETTI_MIN':
                                attributo.descrizione = 'Numero minimo progetti'
                                attributoValido.push(attributo);
                                break;
                            case 'REFEREE_MAX':
                                attributo.descrizione = 'Numero massimo referee'
                                attributoValido.push(attributo);
                                break;
                            case 'MESI_FINANZIAMENTO':
                                attributo.descrizione = 'Mesi finanziamento'
                                attributoValido.push(attributo);
                                break;
                        }
                    });
                    return attributoValido;
                }
            }

            function showSavingDialog() {
                var dialog = ngDialog.open({
                    template: 'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function thenFunction(savingDialog) {
                return function () {
                    savingDialog.close();
                    $log.log('Bando salvato con successo');
                    var dialog = ngDialog.open({
                        template: '' +
                            '<div class="alert-success" style="height: 30px;"><b style="vertical-align: middle;">Bando salvato con successo.</b></div>',
                        plain: true,
                        showClose: true
                    });
                    dialog.close();
                }
            }

            function catchFunction(savingDialog) {
                return function (error) {
                    $log.error("Errore nel salvataggio del bando", error);
                    savingDialog.close();
                    showErrorDialog(error.data.message);
                }
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template: '<h3 style="margin-top: 0px;">Errore</h3>' +
                        '<div class="alert alert-danger" ng-if="!ngDialogData.errorMessage"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div>' +
                        '<div class="alert alert-danger" ng-if="ngDialogData.errorMessage"><b>{{ngDialogData.errorMessage}}</b></div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }

            function updateBando() {
                var savingDialog = showSavingDialog();
                BandiService.updateBando(vm.bando).then(thenFunction(savingDialog)).catch(catchFunction(savingDialog));
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('concediFinanziamento', concediFinanziamento);

    /** @ngInject */
    function concediFinanziamento() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/concediFinanziamento/concediFinanziamento.html',
            scope: {},
            bindToController: {
                proposta: "=",
                confirm: "=",
                isUr: "=",
                draftOnly: "=?"
            },
            controller: concediFinanziamentoController,
            controllerAs: 'concediFinCtrl'
        };

        return directive;

        /** @ngInject */
        function concediFinanziamentoController($scope, EsitoValutazioneMcService, EsitoValutazioneUrService, ngDialog) {
            var vm = this;

            vm.saveLoading = false;

            var finanziamento = vm.proposta.classe.finanziamenti.filter(function(fin) {
                if(fin.fonteFinanziamento.codice == "ASSEGNO_DI_RICERCA")
                    return true;
            });

            vm.assegnoSingolo = finanziamento && finanziamento.length > 0 ? finanziamento[0].singoloFinanziabile : -1;

            vm.assegniDisponibili = [0];
            vm.assegniConcessi = 0;

            vm.calcolaImportoAssegno = calcolaImportoAssegno;
            vm.salvaEsitoFinanziamento = salvaEsitoFinanziamento;
            vm.concludiEsitoFinanziamento = concludiEsitoFinanziamento;
            vm.rifiutaFinanziamento = rifiutaFinanziamento;

            vm.isFinanziamentoInibito = isFinanziamentoInibito;

            getEsitoValutazioneObj();

            function getEsitoValutazioneObj() {

                if(vm.isUr) {
                    if(vm.proposta.esitoValutazione) {
                        EsitoValutazioneUrService.getEsitoValutazione(vm.proposta.id)
                            .then(function(response) {
                                vm.esito = response;
                                initForm();
                            });
                    }
                    else {
                        EsitoValutazioneUrService.newEsitoValutazione(vm.proposta.id)
                            .then(function(response) {
                                vm.esito = response;
                                initForm();
                            });
                    }
                }
                else {
                    if(vm.proposta.esitoValutazione) {
                        EsitoValutazioneMcService.getEsitoValutazione(vm.proposta.id)
                            .then(function(response) {
                                vm.esito = response;
                                initForm();
                            });
                    }
                    else {
                        EsitoValutazioneMcService.newEsitoValutazione(vm.proposta.id)
                            .then(function(response) {
                                vm.esito = response;
                                initForm();
                            });
                    }
                }

            }

            function initForm() {

                if(vm.assegnoSingolo > 0) {

                    var size = vm.proposta.assegnoRichiesto / vm.assegnoSingolo;

                    for(var i=0; i < size; i++)
                        vm.assegniDisponibili.push(i);
                }

                if(vm.esito.finanziamentoAssegnato == null && vm.esito.assegnoAssegnato == null)
                    vm.concesso = null;
                else if(vm.esito.finanziamentoAssegnato == 0 && (vm.esito.assegnoAssegnato == 0 || vm.esito.assegnoAssegnato == null))
                    vm.concesso = false;
                else
                    vm.concesso = true;

                if(vm.esito.assegnoAssegnato > 0)
                    vm.assegniConcessi = vm.esito.assegnoAssegnato / vm.assegnoSingolo;

            }

            function calcolaImportoAssegno() {
                vm.esito.assegnoAssegnato = vm.assegniConcessi * vm.assegnoSingolo;
            }

            function salvaEsitoFinanziamento(concludi) {

                vm.saveLoading = true;

                if (vm.isUr) {
                    EsitoValutazioneUrService.salvaEsitoValutazione(vm.esito, vm.proposta.id, concludi)
                        .then(function(/*response*/) {
                            //vm.esito = response;
                            vm.confirm(true);
                        });
                }
                else {
                    EsitoValutazioneMcService.salvaEsitoValutazione(vm.esito, vm.proposta.id, concludi)
                        .then(function(/*response*/) {
                            //vm.esito = response;
                            vm.confirm(true);
                        });
                }
            }

            function concludiEsitoFinanziamento() {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Salva e Concludi Esito</h3>\
                        <div class="alert alert-warning" role="alert">Concludendo l\'esito non sarà più possibile modificare il finanziamento.</div>\
                        <p>Sei sicuro di voler concludere l\'esito?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        salvaEsitoFinanziamento(true);
                    }
                });
            }

            function rifiutaFinanziamento() {
                vm.esito.finanziamentoAssegnato = 0;
                vm.assegniConcessi = 0;

                calcolaImportoAssegno();
            }

            function isFinanziamentoInibito() {
                if (vm.proposta.nonAmmissibile == true || vm.proposta.valutazioneRespinta == true)
                    return true;
              var media = vm.proposta.mediaSogliaFinanziabilita !== null && angular.isDefined(vm.proposta.mediaSogliaFinanziabilita) && !isNaN(vm.proposta.mediaSogliaFinanziabilita) ? vm.proposta.mediaSogliaFinanziabilita : vm.proposta.media;
              if (vm.proposta.sogliaFinanziabilita != null && media * 1 < vm.proposta.sogliaFinanziabilita * 1)
                    return true;

                return false;
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('commissioneTipologiaCert', commissioneTipologiaCert);

    /** @ngInject */
    function commissioneTipologiaCert() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/commissioneTipologiaCert/commissioneTipologiaCert.html',
            scope: {},
            bindToController: {
                membri: "="
            },
            controller: CommissioneTipologiaCertController,
            controllerAs: 'comTipCeCtrl'
        };

        return directive;

        /** @ngInject */
        function CommissioneTipologiaCertController() {
            var vm = this;
            vm.listaMinor = [];
            vm.listaMajor = [];
            vm.listaEsterni = [];


            dividiLista();

            function dividiLista() {
                for (var i = 0; vm.membri.length>i; i++){
                    if (vm.membri[i].flag_minor_major === "Relatore 2"){
                        vm.listaMajor.push(vm.membri[i]);
                    }else if (vm.membri[i].flag_minor_major === "Relatore 1") {
                        vm.listaMinor.push(vm.membri[i]);
                        }else{
                            if (vm.membri[i].flag_minor_major === "Esperto esterno") {
                                vm.listaEsterni.push(vm.membri[i]);
                            }
                        }
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('ckEditor', ckEditor);

    /** @ngInject */
    function ckEditor($window, $log, MediaService, Constants) {
        var directive = {
            require: '?ngModel',
            scope: {
                maxLength: '=',
                editorHeight: '@'
            },
            link: function ($scope, elm, attr, ngModel) {
                var config = {
                    customConfig: '',
                    height: ($scope.editorHeight ? $scope.editorHeight : '200px'),
                    extraPlugins: 'wordcount,notification',
                    removePlugins: 'elementspath',
                    toolbar: [
                        { name: 'document', items: [ 'Undo', 'Redo' ] },
                        { name: 'styles', items: [ 'Format' ] },
                        { name: 'editing', groups: [ 'basicstyles', 'list' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'NumberedList', 'BulletedList' ] },
                        { name: 'insert', items: [ 'Image' ] },
                        { name: 'clean', items: [ 'RemoveFormat' ] }
                    ],
                    format_tags: 'h3;p',
                    wordcount: {
                        showParagraphs: false,
                        showWordCount: false,
                        showCharCount: true,
                        countSpacesAsChars: true,
                        maxCharCount: ($scope.maxLength ? $scope.maxLength : -1)
                    },
                    forcePasteAsPlainText: true,
                    title: false
                };
                
                $window.CKEDITOR.on('dialogDefinition', function(ev) {
                    if (ev.data) {
                        var dialogName = ev.data.name;
                        var dialogDefinition = ev.data.definition;
                        // se è il dialog di editing immagine
                        if ( dialogName == 'image2' ) {
                            var info = dialogDefinition.getContents('info');
                            // se non ho già aggiunto gli elementi per l'upload delle immagini li aggiungo
                            if (info.elements[0].id != 'fileButton') {
                                info.elements.unshift({
                                    id: 'fileButton',
                                    type: 'button',
                                    label: 'Seleziona file (jpg o png, max 1 MB)',
                                    onLoad: function() {
                                        this.getElement().setStyle('width', '100%');
                                    },
                                    onClick: function() {
                                        var dialog = this.getDialog();
                                        var fileElement = dialog.getContentElement('info', 'file');
                                        $window.$(fileElement.getElement().$).find('input').click();
                                    },
                                    setup: function(widget) {
                                        var imageUrl = widget.data.src;
                                        if (imageUrl && imageUrl != '')
                                            this.getElement().hide();
                                        else
                                            this.getElement().show();
                                    }
                                }, {
                                    id: 'file',
                                    type: 'html',
                                    html: '<div><input type="file" accept="image/png,image/jpeg" /></div>',
                                    onLoad: function() {
                                        this.getElement().hide();
                                        var dialog = this.getDialog();
                                        $window.$(this.getElement().$).find('input').change(function() {
                                            var files = this.files;
                                            var buttonElement = dialog.getContentElement('info', 'fileButton');
                                            var previewElement = dialog.getContentElement('info', 'filePreview');
                                            var srcElement = dialog.getContentElement('info', 'src');
                                            if (files.length >= 1) {
                                                buttonElement.getElement().hide();
                                                $window.$(previewElement.getElement().$).html('<i class="fa fa-spinner fa-spin" style="font-size: 16px; font-family: FontAwesome;"></i>');
                                                previewElement.getElement().show();
                                                MediaService.uploadImage(files[0])
                                                    .then(function(data) {
                                                        var imageUrl = Constants.restApiRoot + '/media/img/' + data.id;
                                                        buttonElement.getElement().hide();
                                                        $window.$(previewElement.getElement().$).html('<img src="' + imageUrl + '" style="max-width: 200px; max-height: 150px;" />');
                                                        previewElement.getElement().show();
                                                        srcElement.setValue(imageUrl);
                                                    })
                                                    .catch(function(error) {
                                                        $log.error("Errore nell'upload del file immagine", error);
                                                        buttonElement.getElement().show();
                                                        var message = "Errore nell'upload del file immagine";
                                                        if (error.data.message)
                                                            message = error.data.message;
                                                        $window.$(previewElement.getElement().$).html('<div style="color: red; text-align: center;">' + message + '</div>');
                                                    });
                                            }
                                        });
                                    },
                                    setup: function(widget) { //eslint-disable-line no-unused-vars
                                        $window.$(this.getElement().$).find('input').val('');
                                    }
                                }, {
                                    id: 'filePreview',
                                    type: 'html',
                                    html: '<div style="text-align: center;"></div>',
                                    onLoad: function() {
                                        this.getElement().hide();
                                        var dialog = this.getDialog();
                                        var srcElement = dialog.getContentElement('info', 'src');
                                        srcElement.getElement().hide();
                                    },
                                    setup: function(widget) {
                                        var imageUrl = widget.data.src;
                                        var dialog = this.getDialog();
                                        var srcElement = dialog.getContentElement('info', 'src');
                                        srcElement.setValue(imageUrl);
                                        if (imageUrl && imageUrl != '') {
                                            $window.$(this.getElement().$).html('<img src="' + imageUrl + '" style="max-width: 200px; max-height: 150px;" />');
                                            this.getElement().show();
                                        }
                                        else {
                                            $window.$(this.getElement().$).html('');
                                            this.getElement().hide();
                                        }
                                    }
                                });
                            }
                        }
                    }
                });
                
                var ck = $window.CKEDITOR.replace(elm[0], config);

                ck.on('pasteState', function () {
                    $scope.$apply(function () {
                        ngModel.$setViewValue(ck.getData());
                    });
                });

                ngModel.$render = function(/*value*/) {
                    ck.setData(ngModel.$modelValue);
                };
                
                ngModel.$parsers.push(function(viewValue) {
                    if (viewValue === "") {
                        return null;
                    }
                    return viewValue;
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('certAssociaCommissione', certAssociaCommissione);

    /** @ngInject */
    function certAssociaCommissione() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/certAssociaCommissione/certAssociaCommissione.html',
            scope: {},
            bindToController: {
                commissioneId: '='
            },
            controller: CertAssociaCommissioneController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function CertAssociaCommissioneController(CertCommissioniService, ProposteService, $log, $state, $q, ngDialog, $window) {
            var vm = this;

            var storageName = "AssociaIstanze-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            vm.loading = true;
            vm.anno = null;
            vm.proposte = null;
            vm.gettingList = false;
            vm.valida = false;


            vm.flags = ["Relatore 1","Relatore 2"];

            vm.selectedAssocia = null;

            vm.editDisabled = false;

            vm.data = null;

            vm.pageHeader = 'Associa Commissione';
            vm.proposteSelezionate = [];
            vm.titoliSelezionati = [];
            vm.saveCommissione = saveCommissione;
            vm.openIstanzeAssociate = openIstanzeAssociate;
            vm.openCommissioneTipologia = openCommissioneTipologia;
            vm.openFeedCompilati = openFeedCompilati;
            vm.getProposte = getProposte;
            vm.insertRemoveProposta = insertRemoveProposta;
            vm.ifChecked = ifChecked;
            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            getDatiCommissione()
                .then(getProposte)
                .then(function() {
                    vm.loading = false;
                    validitaCommissione();
                })
                .catch(function(error) {
                    $log.error("Errore nel reperimento dei dati della commissione", error);
                    showErrorDialog(error.data.message);
                });


            function getDatiCommissione() {
                if (vm.commissioneId != undefined)
                    return CertCommissioniService.getCommissioneById(vm.commissioneId)
                        .then(function(data) {
                            vm.data = data;
                        });
                else
                    return $q.when();
            }

            function ifChecked(id){
                return vm.proposteSelezionate.includes(id) ? true : false;
            }
            function getProposte(keepPagination) {

                vm.gettingList = true;

                if (!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    anno: null,
                    cognome: "",
                    statusValutazione: vm.selectedStatusValutazione
                });

                vm.proposte = null;

                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                filter.statusValutazione = 6;

                return ProposteService.getProposteCertValutazione(filter)
                    .then(function (data) {
                        var renderData = data.resultList
                        //
                        // if ( vm.selectedStatusValutazione != null && vm.selectedStatusValutazione != "ALL" ) {
                        //     renderData = renderData.filter( function( x ) { return x.stato.codice == vm.selectedStatusValutazione } )
                        // }

                        vm.proposte = renderData;
                        vm.gettingList = false;
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                        vm.selectedStatusValutazione = filter.statusValutazione;
                    }).catch(function (error) {
                        $log.error("Error loadInstance", error);
                        vm.gettingList = false;
                    });
            }


            function saveCommissione() {
                var savingDialog = null;
                var listaMembri= [];
                var listaIstanze= [];


                for (var j = 0; j < vm.data.membri.length; j++) {
                    if (vm.data.membri[j].flag != null) {
                        listaMembri.push({id: vm.data.membri[j].utenteId,
                        flag: vm.data.membri[j].flag == "Relatore 1"? 0 : 1});
                    }
                }

                for (var a = 0; a < vm.proposte.length; a++) {
                    if (vm.proposte[a].seleziona) {
                        listaIstanze.push({id: vm.proposte[a].id, titolo: vm.proposte[a].titolo});
                    }
                }
                for (var a = 0; a < vm.proposteSelezionate.length; a++) {
                    if (!listaIstanze.includes(vm.proposteSelezionate[a])) {
                        listaIstanze.push({id: vm.proposteSelezionate[a], titolo: vm.titoliSelezionati[a]});
                    }
                }
                var dati = {
                    jsonMembri: listaMembri,
                    jsonIstanze: listaIstanze
                }

                if (listaIstanze.length == 0 || listaMembri.length == 0) {
                    $log.log('selezione non effettuata');
                    showErrorDialog('Selezionare almeno un\'istanza e un membro di commissione');
                } else {
                    savingDialog = showSavingDialog();
                    CertCommissioniService.saveCommissione(dati)
                        .then(function () {
                            $log.log('associazione salvata con successo');
                            savingDialog.close();
                            thenFunction();
                            // $state.go('certCommissioneDetail');
                        })
                        .catch(function (error) {
                            $log.error("Errore nel salvataggio", error);
                            savingDialog.close();
                            showErrorDialog(error.data.message);
                        });
                }
            }

            function validitaCommissione(){
                var now = new Date().getTime();
                var valid = now >= vm.data.dataInizio && now <= vm.data.dataFine;
                vm.valid = valid;
            }

            function openCommissioneTipologia(membroPropostaList) {
                ngDialog.open({
                    template:'<commissione-tipologia-cert membri="ngDialogData.membri"></commissione-tipologia-cert>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-associatiDialog',
                    data: {
                        membri: membroPropostaList
                    }
                });
            }
            function openFeedCompilati(propostaIdCert) {
                ngDialog.open({
                    template:'<feed-compilati-cert proposta="ngDialogData.proposta"></feed-compilati-cert>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-associatiDialog',
                    data: {
                        proposta: propostaIdCert
                    }
                });
            }


            function openIstanzeAssociate(userId) {
                    ngDialog.open({
                        template:'<associazioni-membro-proposta utente="ngDialogData.userId"></associazioni-membro-proposta>',
                        plain: true,
                        appendClassName: 'ngdialog-large ngdialog-associatiDialog',
                        data: {
                            userId: userId
                        }
                    });
            }
            function insertRemoveProposta(id,titolo) {
                if (ifChecked(id)) {
                    var index = vm.proposteSelezionate.indexOf(id);
                    vm.proposteSelezionate.splice(index, 1);
                    vm.titoliSelezionati.push(titolo);
                } else {
                    vm.proposteSelezionate.push(id);
                    vm.titoliSelezionati.push(titolo)
                }
            }

            function showSavingDialog() {
                var dialog = ngDialog.open({
                    template:'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function thenFunction() {
                var dialog = ngDialog.open({
                    template: '' +
                        '<div class="alert alert-success"><b>Operazione effettuata con successo.</b></div>',
                    plain: true,
                    showClose: true,
                    preCloseCallback: function () {
                        $window.location.reload()
                    },
                    data:{}
                });
                return dialog;
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var msg = message == null || message === "" ? "" : message;
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: msg
                    }
                });

                return dialog;
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('caricamentoMassivo', caricamentoMassivo);
    /** @ngInject */
    function caricamentoMassivo() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/caricamentoMassivo/caricamentoMassivo.html',
            scope: {},
            bindToController: {},
            controller: caricamentoMassivoController,
            controllerAs: 'caricCtrl'
        };

        return directive;

        /** @ngInject */
        function caricamentoMassivoController(BandiService, MediaService,Constants, ngDialog, $log, $scope,$window,$location) {
            var vm = this;

            vm.loadingFile = false;
            vm.tableIsLoading = false
            vm.uploadError = null;
            vm.selectedAnno = null;
            vm.anni = [];
            vm.selectedTipologia1 = {'key': 0, 'value': 'Seleziona una tipologia di template'};
            vm.selectedTipologia2 = {};
            vm.pagination = {
                current: 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };
            vm.data = {
                id: '',
                anno: '',
                template: '',
                tipologia: ''
            };
            vm.tipologiaOpts = [
                {
                    'key': 0,
                    'value': 'Seleziona una tipologia di template'
                },
                {
                    'key': 1,
                    'value': 'Governance'
                }, {
                    'key': 2,
                    'value': 'Specializzandi'
                }, {
                    'key': 3,
                    'value': 'Indicatori'
                }, {
                    'key': 4,
                    'value': 'Inattivi'
                }, {
                    'key': 5,
                    'value': 'Aspettativa'
                }, {
                    'key': 6,
                    'value': 'Dottorandi'
                }
            ];
            vm.optGov = [
                {
                    'key': 1,
                    'value': 'Rettore'
                }, {
                    'key': 2,
                    'value': 'Pro Rettore'
                }, {
                    'key': 3,
                    'value': 'Pro Rettore Vicario'
                }, {
                    'key': 4,
                    'value': 'Senatore Accademico'
                }, {
                    'key': 5,
                    'value': 'Consigliere Amministrazione'
                }]
            vm.optInact = [
                {'key': 1, 'value': 'Codice etico'},
                {'key': 2, 'value': 'Rendicontazione Didattica'},
                {'key': 3, 'value': 'Inattivo'}
            ];
            vm.uploadError= null;

            vm.listaErrori = "";
            vm.showError = false;
            vm.massivi = [];

            vm.salvaDati = salvaDati;
            vm.doSmth = doSmth;
            vm.uploadXlsx = uploadXlsx;
            vm.getFileHref = getFileHref;
            vm.removeFile = removeFile;
            vm.getMassivo = getMassivo;
            vm.downloadTemplate = downloadTemplate;
            vm.downloadSpecifiedFile = downloadSpecifiedFile;


            getAnni();


            function getAnni() {
                return BandiService.getAnni()
                    .then(function (data) {
                        if (data.length > 0) {
                            if (vm.anno)
                                vm.selectedAnno = {anno: vm.anno};
                            else
                                vm.selectedAnno = data[0];
                        }
                        vm.anni = data;
                        getMassivo();
                    });
            }

            function getMassivo() {
                vm.tableIsLoading = true;
                var filters = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit,
                    anno: vm.selectedAnno.anno
                };
                return MediaService.getMassivo(filters).then(function (massivi) {
                    vm.massivi = massivi.resultList;
                    vm.pagination.end = massivi.end;
                    vm.pagination.start = massivi.start;
                    vm.pagination.total = massivi.totale;
                }).catch(function (errore) {
                    throw errore;
                }).finally(function () {
                    vm.tableIsLoading = false;
                });
            }

            function uploadXlsx(files) {

                vm.uploadError = null;
                if (files.length >= 1) {
                    vm.loadingFile = true;
                    // files[0].name = vm.selectedAnno.anno + "_" + vm.selectedTipologia1.value +"_"+files[0].name;
                    MediaService.uploadXlsx(files[0])
                        .then(function (data) {
                            vm.model = data;
                            vm.loadingFile = false;
                            vm.data.id = data.id;
                            vm.data.anno = vm.selectedAnno.anno;
                            vm.data.template = vm.selectedTipologia1.value;
                            vm.data.tipologia = vm.selectedTipologia2 == null ? "vuoto" : vm.selectedTipologia2.value;
                            salvaDati(vm.data)
                        }).catch(function (error) {
                        $log.error("Errore nell'upload del file xlsx", error);
                        vm.model = null;
                        vm.loadingFile = false;
                        if (error.data.message)
                            vm.uploadError = error.data.message;
                        else
                            vm.uploadError = "Errore nell'upload del file xlsx";
                        showErrorDialog(vm.uploadError);
                    });
                }
            }

            function salvaDati(data) {
                var savingDialog = showSavingDialog();
                return MediaService.salvaDati(data).then(function (massivo) {
                    // vm.listaErrori = massivo.listErr;
                    thenFunction(savingDialog,massivo);
                }).catch(function (error) {
                    $log.error("Errore formattazione", error);
                    vm.model = null;
                    vm.loadingFile = false;
                    savingDialog.close();
                    if (error.data.message)
                        vm.uploadError = error.data.message;
                    else
                        vm.uploadError = "errore formattazione";
                    showErrorDialog(vm.uploadError);
                });
            }

            function removeFile() {
                vm.model = null;
            }

            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL;
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id+".xlsx";
            }

            function doSmth(selectInfo, isTemplateSelect) {
                if (isTemplateSelect) {
                    vm.selectedTipologia2 = null;
                }
            }

            function thenFunction(savingDialog,massivo) {
                savingDialog.close();
                    var dialog = ngDialog.open({
                        template: '' +
                            '<div class="alert alert-success"><b>File caricato con successo.</b></div>' +
                            '<div ng-if="ngDialogData.errori" class="alert alert-danger">{{ngDialogData.errori}}</div>',
                        plain: true,
                        showClose: true,
                        preCloseCallback: getAnni(),
                        data:{errori: massivo.listErr}
                    });
                    dialog.close();

            }

            function showSavingDialog() {
                return ngDialog.open({
                    template: 'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                return ngDialog.open({
                    template: '<h3 style="margin-top: 0px;">Errore</h3>' +
                        '<div class="alert alert-danger" ng-if="!ngDialogData.errorMessage"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div>' +
                        '<div class="alert alert-danger" ng-if="ngDialogData.errorMessage"><b>{{ngDialogData.errorMessage}}</b></div>',
                    plain: true,
                    showClose: true,
                    preCloseCallback: getAnni(),
                    data: {
                        errorMessage: message
                    }
                });
            }

            function catchFunction(savingDialog) {
                return function (error) {
                    savingDialog.close();
                    showErrorDialog(error.data.message);
                }
            }

            function downloadTemplate() {
                if (vm.selectedTipologia1.key !== 0) {
                    return MediaService.downloadTemplate(vm.selectedTipologia1.value);
                }
            }

            function downloadSpecifiedFile(id) {
                return Constants.restApiRoot + '/media/' + id + '/downloadMassivo';
            }

            $scope.$on('ngDialog.closing', function () {
                vm.selectedTipologia1 = {
                    'key': 0,
                    'value': 'Seleziona una tipologia di template'
                };
                vm.selectedTipologia2 = {};
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .directive('cambiaTitolare', cambiaTitolare);

    /** @ngInject */
    function cambiaTitolare() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/cambiaTitolare/cambiaTitolare.html',
            scope: {},
            bindToController: {
                proposta: "=",
                confirm: "="
            },
            controller: cambiaTitolareController,
            controllerAs: 'titolareCtrl'
        };

        return directive;

        /** @ngInject */
        function cambiaTitolareController(Constants, UserData, MediaService, UtentiService, ProposteUrService, ngDialog, $log) {
            var vm = this;

            vm.modelCambio = {
                titolareId: null,
                motivazioneCambio: null,
                allegato: null
            };

            vm.loadingFile = false;
            vm.uploadError = null;

            vm.searchText = '';
            vm.searching = false;
            vm.results = null;

            vm.componenti = null;
            vm.nuovoTitolare = null;

            vm.saveLoading = false;

            vm.uploadFile = uploadFile;
            vm.removeFile = removeFile;
            vm.getFileHref = getFileHref;

            vm.search = search;
            vm.selectTitolare = selectTitolare;
            vm.resetTitolare = resetTitolare;

            vm.chiudi = chiudi;
            vm.salvaModificaTitolare = salvaModificaTitolare;

            getComponenti();

            function uploadFile(files) {
                vm.uploadError = null;
                if (files.length >= 1) {
                    vm.loadingFile = true;
                    MediaService.uploadPdf(files[0])
                        .then(function (data) {
                            vm.modelCambio.allegato = data;
                            vm.loadingFile = false;
                        })
                        .catch(function (error) {
                            $log.error("Errore nell'upload del file pdf", error);
                            vm.modelCambio.allegato = null;
                            vm.loadingFile = false;
                            if (error.data.message)
                                vm.uploadError = error.data.message;
                            else
                                vm.uploadError = "Errore nell'upload del file pdf";
                        });
                }
            }

            function removeFile() {
                vm.modelCambio.allegato = null;
            }

            function getFileHref(fileModel) {
                if (fileModel.URL)
                    return Constants.restApiRoot + fileModel.URL + '?token=' + UserData.getToken();
                else
                    return Constants.restApiRoot + '/media/' + fileModel.id + '/titolare?token=' + UserData.getToken();
            }

            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    UtentiService.getUtentiNewTitolare(text)
                        .then(function (data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                        })
                        .catch(function () {
                            vm.searching = false;
                            vm.results = [];
                        });
                } else {
                    vm.searching = false;
                }
            }

            function selectTitolare(utente) {
                vm.nuovoTitolare = utente;
                vm.modelCambio.titolareId = vm.nuovoTitolare.id;
            }

            function resetTitolare() {
                vm.nuovoTitolare = null;
                vm.modelCambio.titolareId = null;
                vm.searchText = '';
                vm.results = null;
            }

            function chiudi() {
                vm.confirm(false);
            }

            function salvaModificaTitolare() {
                vm.saveLoading = true;
                ProposteUrService.cambiaTitolareProgetto(vm.proposta.id, vm.modelCambio)
                    .then(function (data) { //eslint-disable-line no-unused-vars
                        vm.confirm(true);
                    })
                    .catch(function (error) {
                        vm.saveLoading = false;
                        showErrorDialog(error.message);
                    });
            }

            function getComponenti() {
                vm.componenti = null;
                vm.searching = true;
                UtentiService.getUtentiNewTitolareComponente(vm.proposta.id)
                    .then(function (data) {
                        vm.searching = false;
                        vm.componenti = data.resultList;
                    })
                    .catch(function () {
                        vm.searching = false;
                        vm.componenti = [];
                    });
            }

            function showErrorDialog(message) { //eslint-disable-line no-unused-vars
                var dialog = ngDialog.open({
                    template: '<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>Si è verificato un errore durante l\'esecuzione dell\'azione richiesta.</b></div><div class="well" ng-if="ngDialogData.errorMessage">{{ngDialogData.errorMessage}}</div>',
                    plain: true,
                    showClose: true,
                    data: {
                        //errorMessage: message
                    }
                });

                return dialog;
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('calculatedModel', calculatedModel);

    /** @ngInject */
    function calculatedModel() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                scope.$watch(attrs.calculatedModel, function(newValue, oldValue) {
                    if (newValue != oldValue) {
                        ngModel.$setViewValue(newValue);
                        ngModel.$render();
                    }
                });
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('UserData', UserData);

    /** @ngInject */
    function UserData() {

        var token = null;
        var tokenImpersona = null;
        var language = null;
        var userId = null;

        var service = {
            getToken: getToken,
            getTokenImpersona: getTokenImpersona,
            setTokenImpersona: setTokenImpersona,
            setToken: setToken,
            getLanguage: getLanguage,
            setLanguage: setLanguage,
            getUserId: getUserId,
            setUserId: setUserId,
            clear: clear
        };

        return service;

        function getToken() {
            return token;
        }

        function getTokenImpersona() {
            return tokenImpersona;
        }

        function setToken(value) {
            token = value;
        }

        function setTokenImpersona(value) {
            tokenImpersona = value;
        }

        function getLanguage() {
            return language;
        }

        function setLanguage(value) {
            language = value;
        }

        function getUserId() {
            return userId;
        }

        function setUserId(value) {
            userId = value;
        }

        function clear() {
            token = null;
            language = null;
            userId = null;
            tokenImpersona = null;

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .factory('AuthService', AuthService);

    /** @ngInject */
    function AuthService(Constants, ProfiloUtenteService, ProfiloUtenteEsternoService, UserData, $q, $http, $log, $window) {

        var localStorage_userToken = 'sigeba-userToken';
        var localStorage_userTokenImpersona = 'sigeba-userTokenImpersona';
        var localStorage_userId = 'sigeba-userId';
        var userToken = null;
        var userTokenImpersona = null;
        var userId = null;
        var userInfo = null;

        init();

        var service = {
            login: login,
            SSOlogin: SSOlogin,
            loginImpersona: loginImpersona,
            logout: logout,
            SSOlogout: SSOlogout,
            logoutImpersona: logoutImpersona,
            getUserId: getUserId,
            getUserInfo: getUserInfo,
            getUserToken: getUserToken,
            getUserTokenImpersona: getUserTokenImpersona,
            refreshUserInfo: refreshUserInfo,
            clearUserInfo: clearUserInfo
        };

        return service;

        // login
        function login(username, password) {
            var deferred = $q.defer();

            $http.post(Constants.restApiRoot + '/login', { username: username, password: password, versione: Constants.appVersion })
                .then(function (result) {
                    setUserInfo(result.data);
                    deferred.resolve();

                }, function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        // SSOlogin
        function SSOlogin(username, password) {
            var deferred = $q.defer();

            $http.post(Constants.restApiRoot + '/login', { username: username, password: password, versione: Constants.appVersion, sso: true })
                .then(function (result) {
                    setUserInfo(result.data);
                    deferred.resolve();

                }, function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function loginImpersona(utente){
            var deferred = $q.defer();

            $http.post(Constants.restApiRoot + '/login/impersonaUtente', { id: utente.id})
                .then(function (result) {
                    setUserInfo(result.data);
                    deferred.resolve();

                }, function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        // logout
        function logout() {
            var deferred = $q.defer();

            $http.post(Constants.restApiRoot + '/logout')
                .then(function (result) { //eslint-disable-line no-unused-vars
                    clearUserInfo();
                    deferred.resolve();

                }, function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        // SSOlogout
        function SSOlogout(logoutSSOUrl) {
            var deferred = $q.defer();

            $http.get(logoutSSOUrl)
                .then(function (result) {
                    deferred.resolve();
                }, function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }


        function logoutImpersona() {
            var deferred = $q.defer();

            $http.post(Constants.restApiRoot + '/logout/esciImpersona')
                .then(function (result) {
                    clearUserInfo();
                    setUserInfo(result.data);
                    deferred.resolve();

                }, function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });


            return deferred.promise;
        }

        // getUserInfo
        function getUserInfo() {
            return userInfo;
        }

        // setUserInfo
        function setUserInfo(data) {
            userToken = data.token;
            userTokenImpersona = data.tokenImpersona;
            userId = data.utente.id;
            userInfo = { utente: angular.copy(data.utente),tokenImpersona: angular.copy(userTokenImpersona)};
            UserData.setToken(userToken);
            UserData.setUserId(userId);
            UserData.setTokenImpersona(userTokenImpersona);
            $window.localStorage.clear();
            $window.localStorage[localStorage_userToken] = angular.copy(userToken);
            $window.localStorage[localStorage_userTokenImpersona] = angular.copy(userTokenImpersona);
            $window.localStorage[localStorage_userId] = angular.copy(userId);

        }

        // refreshUserInfo
        function refreshUserInfo() {

            var deferred = $q.defer();

            ProfiloUtenteService.getProfilo(userId)
                .then(function(resultData) {
                    if (userInfo)
                        userInfo.utente = resultData.utente;
                    else
                        userInfo = {
                            utente: angular.copy(resultData.utente),
                            tokenImpersona: angular.copy(userTokenImpersona === "null" ? null : userTokenImpersona)
                        };

                    deferred.resolve();
                })
                .catch(function(error) {
                    $log.error(error);
                    ProfiloUtenteEsternoService.getProfilo(userId)
                        .then(function(resultData) {
                            if (userInfo)
                                userInfo.utente = resultData.utente;
                            else
                                userInfo = { utente: angular.copy(resultData.utente) };
                            deferred.resolve();
                        })
                        .catch(function(error) {
                            $log.error(error);
                            userInfo = null;
                            deferred.reject(error);
                        });
                });

            return deferred.promise;
        }

        // clearUserInfo
        function clearUserInfo() {
            userToken = null;
            userId = null;
            userInfo = null;
            userTokenImpersona = null;
            UserData.clear();
            $window.localStorage.clear();
        }

        // getUserId
        function getUserId() {
            return userId;
        }

        // getUserToken
        function getUserToken() {
            return userToken;
        }

        function getUserTokenImpersona() {
            return userTokenImpersona;
        }

        // init
        function init() {
            if ($window.localStorage && $window.localStorage[localStorage_userToken] && $window.localStorage[localStorage_userId] && $window.localStorage[localStorage_userTokenImpersona]) {
                userToken = angular.copy($window.localStorage[localStorage_userToken]);
                userTokenImpersona = angular.copy($window.localStorage[localStorage_userTokenImpersona]);
                userId = angular.copy($window.localStorage[localStorage_userId]);
                UserData.setToken(userToken);
                UserData.setTokenImpersona(userTokenImpersona);
                UserData.setUserId(userId);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('associazioniMembroProposta', associazioniMembroProposta);

    /** @ngInject */
    function associazioniMembroProposta() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/associazioniMembroProposta/associazioniMembroProposta.html',
            scope: {},
            bindToController: {
                utente: "="
            },
            controller: AssociazioniMembroPropostaController,
            controllerAs: 'assMemProCtrl'
        };

        return directive;

        /** @ngInject */
        function AssociazioniMembroPropostaController(CertCommissioniService, ngDialog, $log, $window, $filter) {
            var vm = this;

            var storageName = "associazioniMembroProposta-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : '1',
                limit: 5,
                total: 0,
                start: 0,
                end: 0
            };

            vm.obj = null;

            vm.getMembroProposte = getMembroProposte;
            vm.close = close;

            getMembroProposte()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni: ", error);
                });

            function getMembroProposte(keepPagination) {
                vm.obj = null;
                if(!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current
                });
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };

                filter.id = vm.utente;

                return CertCommissioniService.getMembroProposte(filter)
                    .then(function(data) {
                        vm.obj = angular.copy(data.resultList);
                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    });
            }

            function close() {
                ngDialog.close();
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('archivioProgettiRad', archivioProgettiRad);

    /** @ngInject */
    function archivioProgettiRad() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/archivioProgettiRad/archivioProgettiRad.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
                isDirDip: '='
            },
            controller: ArchivioProgettiRadController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ArchivioProgettiRadController(BandiService, TipologieProgettoService, DipartimentiRadService, StruttureRadService, ProposteRadService, DipartimentiDirDipService, $log, $state, $window) {
            var vm = this;

            var storageName = "archivioProgettiRad-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            vm.anno = null;

            vm.anni = null;
            vm.selectedAnno = null;

            vm.proposte = null;

            vm.tipologieEClassi = null;
            vm.macroareeEDipartimenti = null;
            vm.strutture = null;
            vm.selectedTipoClasse = oldFilter.tipoClasse ? oldFilter.tipoClasse : null;
            vm.selectedAreaDip = oldFilter.areaDip ? oldFilter.areaDip : null;
            vm.selectedAreaStrut = oldFilter.areaStrut ? oldFilter.areaStrut : null;

            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;

            vm.getProposte = getProposte;
            vm.getTipologieEProposte = getTipologieEProposte;
            vm.openProposta = openProposta;
            vm.openRendicontazione = openRendicontazione;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatus = getStatus;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;

            vm.getCsvExportUrl = getCsvExportUrl;

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            //20181105 - MODIFICA VISIBILITA' PROPOSTE RAD (SOLO FINANZIATE E UFFICIALIZZATE)
            //vm.selectedStatusValutazione = oldFilter.statusValutazione ? oldFilter.statusValutazione : 'ALL';
            vm.selectedStatusValutazione = oldFilter.statusValutazione ? oldFilter.statusValutazione : 'FINANZIATE';

            getAnni()
                .then(getTipologieProgetto)
                .then(getDipartimenti)
                .then(getStrutture)
                .then(getProposte)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle proposte", error);
                });

            function getAnni() {
                return BandiService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno) {
                                vm.selectedAnno = { anno: vm.anno };
                            }
                            else {

                                var anno = data.filter(function(anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];

                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }

            function getTipologieEProposte() {
                getTipologieProgetto()
                    .then(resetFiltri);
            }

            function getTipologieProgetto() {
                return TipologieProgettoService.getTipologieProgetto(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.tipologieEClassi = [];
                        var json = {
                            label: 'Tutte le tipologie di progetto',
                            tipologia: 'Tutte le tipologie di progetto',
                            classe: 'Tutte le classi dimensionali',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedTipoClasse)
                            vm.selectedTipoClasse = json;
                        vm.tipologieEClassi.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var tipo = data[i];
                            json = {
                                label: tipo.nome,
                                tipologiaId: tipo.id,
                                tipologia: tipo.nome,
                                classe: 'Tutte le classi dimensionali',
                                id: tipo.id + '.*',
                                isGroup: true
                            };
                            vm.tipologieEClassi.push(json);
                            for (var j = 0; j < tipo.classeList.length; j++) {
                                var classe = tipo.classeList[j];
                                json = {
                                    label: classe.nome,
                                    tipologiaId: tipo.id,
                                    classeId: classe.id,
                                    tipologia: tipo.nome,
                                    classe: classe.nome,
                                    id: tipo.id + '.' + classe.id,
                                    isGroup: false
                                };
                                vm.tipologieEClassi.push(json);
                            }
                        }
                        vm.tipologieProgetto = data;
                    });
            }

            function getDipartimenti() {
                var promise = null;

                if (vm.isDirDip) {
                    promise = DipartimentiDirDipService.getDipartimentiDirDip();
                }
                else {
                    promise = DipartimentiRadService.getDipartimentiRad();
                }

                return promise
                    .then(function(data) {
                        vm.macroareeEDipartimenti = [];
                        var json = {
                            label: 'Tutti i dipartimenti',
                            macroarea: 'Tutti i dipartimenti',
                            dipartimento: 'assegnati a te',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedAreaDip)
                            vm.selectedAreaDip = json;
                        vm.macroareeEDipartimenti.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var dip = data[i];
                            var area = dip.macroArea;
                            json = {
                                label: dip.nome,
                                macroareaId: area.id,
                                dipartimentoId: dip.id,
                                macroarea: area.code + ' - ' + area.nome,
                                dipartimento: dip.nome,
                                id: area.id + '.' + dip.id,
                                isGroup: false
                            };
                            vm.macroareeEDipartimenti.push(json);
                        }
                    });
            }

            function getStrutture() {
                var promise = null;
                    promise = StruttureRadService.getStruttureRad();
                return promise
                    .then(function(data) {
                        vm.strutture = [];
                        var json = {
                            label: 'Tutte le strutture',
                            struttura: 'assegnate a te',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedAreaStrut)
                            vm.selectedAreaStrut = json;
                        vm.strutture.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var stru = data[i];
                            json = {
                                label: stru.nome,
                                strutturaId: stru.id,
                                struttura: stru.nome,
                                isGroup: false
                            };
                            vm.strutture.push(json);
                        }
                    });
            }

            function getProposte(keepPagination) {

                if(!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    anno: vm.selectedAnno,
                    cognome: vm.selectedCognome,
                    tipoClasse: vm.selectedTipoClasse,
                    areaDip: vm.selectedAreaDip,
                    areaStrut: vm.selectedAreaStrut,
                    statusValutazione: vm.selectedStatusValutazione
                });

                vm.proposte = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedAreaStrut != null) {
                    if (vm.selectedAreaStrut.strutturaId)
                        filter.strutturaId = vm.selectedAreaStrut.strutturaId;
                    }

                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                return ProposteRadService.getProposte(filter)
                    .then(function(data) {
                        vm.proposte = data.resultList;

                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;
                    });
            }

            function openProposta(id) {
                $state.go('radPropostaView', {'id': id});
            }

            function openRendicontazione(id) {
                $state.go('radRendicontazioneView', {'id': id});
            }

            function getStatusClass(status, valutazioneStatus) {
                /*if (status == 'BOZZA')
                    return 'inBozza';
                if (valutazioneStatus == 'VALUTATA')
                    return 'valutata';*/
                if (valutazioneStatus == 'FINANZIATA')
                    return 'finanziata';
                if (valutazioneStatus == 'NON_FINANZIATA')
                    return 'nonFinanziata';
                return 'nonValutata';
            }

            function getStatusIcon(status, valutazioneStatus) {
                /*if (status == 'BOZZA')
                    return 'fa-pencil-square-o';
                if (valutazioneStatus == 'VALUTATA')
                    return 'fa-check-square-o';*/
                if (valutazioneStatus == 'FINANZIATA')
                    return 'fa-thumbs-o-up';
                if (valutazioneStatus == 'NON_FINANZIATA')
                    return 'fa-thumbs-o-down';
                return 'fa-square-o';
            }

            function getStatus(status, valutazioneStatus) {
                /*if (status == 'BOZZA')
                    return 'In bozza';
                if (valutazioneStatus == 'VALUTATA')
                    return 'Valutata';*/
                if (valutazioneStatus == 'FINANZIATA')
                    return 'Finanziata';
                if (valutazioneStatus == 'NON_FINANZIATA')
                    return 'Non finanziata';
                return 'Inviata';
            }

            function resetFiltri() {

                vm.selectedAreaDip = vm.macroareeEDipartimenti[0];
                vm.selectedAreaStrut = vm.strutture[0];
                vm.selectedTipoClasse = vm.tipologieEClassi[0];
                vm.selectedCognome = "";

                getProposte();

            }

            function isFiltroAttivo() {

                var attivo = false;

                if(vm.macroareeEDipartimenti && vm.selectedAreaDip.id != vm.macroareeEDipartimenti[0].id)
                    attivo = true;

                if (vm.strutture && vm.selectedAreaStrut.id != vm.strutture[0].strutturaId)
                    attivo = true;

                if(vm.tipologieEClassi && vm.selectedTipoClasse.id != vm.tipologieEClassi[0].id)
                    attivo = true;

                if(vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;

                return attivo;

            }

            function getCsvExportUrl() {
                var filter = {
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedAreaStrut != null) {
                    if (vm.selectedAreaStrut.strutturaId)
                        filter.strutturaId = vm.selectedAreaStrut.strutturaId;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }

                return ProposteRadService.getCsvExportUrl(filter);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('archivioProgetti', archivioProgetti);

    /** @ngInject */
    function archivioProgetti() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/archivioProgetti/archivioProgetti.html',
            scope: {},
            bindToController: {
                /*anno: '@'*/
            },
            controller: ArchivioProgettiController,
            controllerAs: 'vm'
        };

        return directive;

        /** @ngInject */
        function ArchivioProgettiController(BandiService, ProposteUrService, RendicontazioniUrService, TipologieProgettoService, ValutazioniUrService, MacroareeService, EsitoValutazioneUrService, $log, $state, $window, ngDialog, $filter,AuthService) {
            var vm = this;

            var storageName = "archivioProgetti-filter";
            var oldFilter = $window.sessionStorage[storageName] ? angular.fromJson($window.sessionStorage[storageName]) : {};

            vm.anno = null;

            vm.anni = null;
            vm.selectedAnno = null;

            vm.proposte = null;

            vm.tipologieEClassi = null;
            vm.macroareeEDipartimenti = null;
            vm.selectedTipoClasse = oldFilter.tipoClasse ? oldFilter.tipoClasse : null;
            vm.selectedAreaDip = oldFilter.areaDip ? oldFilter.areaDip : null;

            vm.selectedCognome = oldFilter.cognome ? oldFilter.cognome : null;

            vm.under40Filter = oldFilter.soloUnder40 ? oldFilter.soloUnder40 : null;

            vm.gettingList = false;

            vm.getProposte = getProposte;
            vm.getTipologieEProposte = getTipologieEProposte;
            vm.openProposta = openProposta;
            vm.openRendicontazione = openRendicontazione;
            vm.riapriValutazione = riapriValutazione;
            vm.gestioneReferee = gestioneReferee;
            vm.getStatusClass = getStatusClass;
            vm.getStatusIcon = getStatusIcon;
            vm.getStatus = getStatus;
            vm.showValutazione = showValutazione;
            vm.concediFinanziamento = concediFinanziamento;
            vm.mostraCommentoFinanziamento = mostraCommentoFinanziamento;
            vm.gestioneReferee = gestioneReferee;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.riapriRendicontazione = riapriRendicontazione;
            vm.dichiaraNonAmmissibile = dichiaraNonAmmissibile;
            vm.openIterValutazione = openIterValutazione;
            vm.riapriEsito = riapriEsito;
            vm.openIndicatoriValutazione = openIndicatoriValutazione;

            vm.getCsvExportUrl = getCsvExportUrl;
            vm.cambiaTitolare = cambiaTitolare;
            vm.openStoricoTitolari = openStoricoTitolari;
            vm.riapriProposta = riapriProposta;

            vm.pagination = {
                current: oldFilter.pagination ? oldFilter.pagination : 1,
                limit: 20,
                total: 0,
                start: 0,
                end: 0
            };

            vm.selectedStatusValutazione = oldFilter.statusValutazione ? oldFilter.statusValutazione : 'ALL';

            getAnni()
                .then(getTipologieProgetto)
                .then(getMacroaree)
                .then(getProposte)
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle informazioni sulle proposte", error);
                });

            function getAnni() {
                return BandiService.getAnni()
                    .then(function(data) {
                        if (data.length > 0) {
                            if (vm.anno) {
                                vm.selectedAnno = { anno: vm.anno };
                            }
                            else {

                                var anno = data.filter(function(anno) {
                                    if (oldFilter.anno && anno.anno == oldFilter.anno.anno)
                                        return true;
                                })[0];

                                vm.selectedAnno = anno ? anno : data[0];
                            }
                        }
                        vm.anni = data;
                    });
            }

            function getTipologieEProposte() {
                getTipologieProgetto()
                    .then(getMacroaree)
                    .then(resetFiltri);
            }

            function getTipologieProgetto() {
                return TipologieProgettoService.getTipologieProgetto(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.tipologieEClassi = [];
                        var json = {
                            label: 'Tutte le tipologie di progetto',
                            tipologia: 'Tutte le tipologie di progetto',
                            classe: 'Tutte le classi dimensionali',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedTipoClasse)
                            vm.selectedTipoClasse = json;
                        vm.tipologieEClassi.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var tipo = data[i];
                            json = {
                                label: tipo.nome,
                                tipologiaId: tipo.id,
                                tipologia: tipo.nome,
                                classe: 'Tutte le classi dimensionali',
                                id: tipo.id + '.*',
                                isGroup: true
                            };
                            vm.tipologieEClassi.push(json);
                            for (var j = 0; j < tipo.classeList.length; j++) {
                                var classe = tipo.classeList[j];
                                json = {
                                    label: classe.nome,
                                    tipologiaId: tipo.id,
                                    classeId: classe.id,
                                    tipologia: tipo.nome,
                                    classe: classe.nome,
                                    id: tipo.id + '.' + classe.id,
                                    isGroup: false
                                };
                                vm.tipologieEClassi.push(json);
                            }
                        }
                        vm.tipologieProgetto = data;
                    });
            }

            function getMacroaree() {
                return MacroareeService.getMacroaree(vm.selectedAnno.anno)
                    .then(function(data) {
                        vm.macroareeEDipartimenti = [];
                        var json = {
                            label: 'Tutte le macroaree',
                            macroarea: 'Tutte le macroaree',
                            dipartimento: 'Tutti i dipartimenti',
                            id: '*.*',
                            isGroup: true
                        };
                        if(!vm.selectedAreaDip)
                            vm.selectedAreaDip = json;
                        vm.macroareeEDipartimenti.push(json);
                        for (var i = 0; i < data.length; i++) {
                            var area = data[i];
                            json = {
                                label: area.code + ' - ' + area.nome,
                                macroareaId: area.id,
                                macroarea: area.code + ' - ' + area.nome,
                                dipartimento: 'Tutti i dipartimenti',
                                id: area.id + '.*',
                                isGroup: true
                            };
                            vm.macroareeEDipartimenti.push(json);
                            var dipartimentiArea = $filter('orderBy')(area.dipartimentoList, 'nome');
                            for (var j = 0; j < dipartimentiArea.length; j++) {
                                var dip = dipartimentiArea[j];
                                json = {
                                    label: dip.nome,
                                    macroareaId: area.id,
                                    dipartimentoId: dip.id,
                                    macroarea: area.code + ' - ' + area.nome,
                                    dipartimento: dip.nome,
                                    id: area.id + '.' + dip.id,
                                    isGroup: false
                                };
                                vm.macroareeEDipartimenti.push(json);
                            }
                        }
                    });
            }

            function getProposte(keepPagination) {

                vm.gettingList = true;

                if(!keepPagination) {
                    vm.pagination.current = 1;
                    vm.pagination.total = 0;
                    vm.pagination.start = 0;
                    vm.pagination.end = 0;
                }

                //salva il filtraggio nel sessionStorage
                $window.sessionStorage[storageName] = angular.toJson({
                    pagination: vm.pagination.current,
                    anno: vm.selectedAnno,
                    cognome: vm.selectedCognome,
                    tipoClasse: vm.selectedTipoClasse,
                    areaDip: vm.selectedAreaDip,
                    statusValutazione: vm.selectedStatusValutazione,
                    soloUnder40: vm.under40Filter
                });

                vm.proposte = null;
                var filter = {
                    limit: vm.pagination.limit,
                    offset: (vm.pagination.current - 1) * vm.pagination.limit
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                if (vm.under40Filter === true) {
                    filter.soloUnder40 = true;
                }
                return ProposteUrService.getProposte(filter)
                    .then(function(data) {
                        vm.proposte = data.resultList;

                        vm.pagination.total = data.totale;
                        vm.pagination.start = data.start;
                        vm.pagination.end = data.end;

                        vm.gettingList = false;
                    }).catch(function (error) {
                        $log.error("Error loadProgetti", error);
                        showErrorDialog("Errore durante il recupero dei dati");
                        vm.gettingList = false;
                    });
            }

            function showErrorDialog(message) {
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>{{ngDialogData.errorMessage}}</b><br />',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: message
                    }
                });

                return dialog;
            }

            function openProposta(id) {
                $state.go('urPropostaView', {'id': id});
            }

            function openRendicontazione(id) {
                $state.go('urRendicontazioneView', {'id': id});
            }

            function riapriValutazione(propostaId) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma Riapertura</h3>\
                        <div class="alert alert-warning" role="alert">Riaprendo la valutazione della proposta verranno eliminate le informazioni sul finanziamento concesso e l\'eventuale commento.</div>\
                        <p>Vuoi riaprire la valutazione della proposta?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        ValutazioniUrService.riapriValutazione(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        });
                    }
                });
            }

            function getStatusClass(status, valutazioneStatus) {
                if (status == 'BOZZA')
                    return 'inBozza';
                if (valutazioneStatus == 'VALUTATA')
                    return 'valutata';
                if (valutazioneStatus == 'FINANZIATA')
                    return 'finanziata';
                if (valutazioneStatus == 'NON_FINANZIATA')
                    return 'nonFinanziata';
                return 'nonValutata';
            }

            function getStatusIcon(status, valutazioneStatus) {
                if (status == 'BOZZA')
                    return 'fa-pencil-square-o';
                if (valutazioneStatus == 'VALUTATA')
                    return 'fa-check-square-o';
                if (valutazioneStatus == 'FINANZIATA')
                    return 'fa-thumbs-o-up';
                if (valutazioneStatus == 'NON_FINANZIATA')
                    return 'fa-thumbs-o-down';
                return 'fa-square-o';
            }

            function getStatus(status, valutazioneStatus) {
                if (status == 'BOZZA')
                    return 'In bozza';
                if (valutazioneStatus == 'VALUTATA')
                    return 'Valutata';
                if (valutazioneStatus == 'FINANZIATA')
                    return 'Finanziata';
                if (valutazioneStatus == 'NON_FINANZIATA')
                    return 'Non finanziata';
                return 'Da valutare';
            }

            function showValutazione(proposta, valutazione) {

                ngDialog.openConfirm({
                    template:'<valuta-proposta proposta="ngDialogData.proposta" valutazione-id="ngDialogData.valutazioneId" is-ur="true" confirm="confirm"></valuta-proposta>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta,
                        valutazioneId: valutazione ? valutazione.id : null
                    }
                });
            }

            function concediFinanziamento(proposta) {

                var concediFinanziamentoDialog = ngDialog.openConfirm({
                    template:'<concedi-finanziamento proposta="ngDialogData.proposta" confirm="confirm" is-ur="true"></concedi-finanziamento>',
                    plain: true,
                    appendClassName: 'ngdialog-large',
                    data: {
                        proposta: proposta
                    }
                });

                concediFinanziamentoDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }

            function gestioneReferee(proposta) {

                var gestioneRefereeDialog = ngDialog.openConfirm({
                    template:'<gestione-referee proposta="ngDialogData.proposta" edit-mode="ngDialogData.editMode" is-ur="true" confirm="confirm"></gestione-referee>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        proposta: proposta,
                        editMode: !proposta.tempoValutazioneConclusa && !proposta.statusValutazioneProposta // false
                    }
                });

                gestioneRefereeDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }

            function mostraCommentoFinanziamento(commento) {

                ngDialog.open({
                    template:'\
                        <h3 class="title">Commento</h3>\
                        <div class="well">{{ngDialogData.commento}}</div>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                        </div>',
                    plain: true,
                    data: {
                        commento: commento
                    }
                });
            }

            function resetFiltri() {

                vm.selectedAreaDip = vm.macroareeEDipartimenti[0];
                vm.selectedTipoClasse = vm.tipologieEClassi[0];
                vm.selectedCognome = "";
                vm.under40Filter = null;

                getProposte();

            }

            function isFiltroAttivo() {

                var attivo = false;

                if(vm.macroareeEDipartimenti && vm.selectedAreaDip.id != vm.macroareeEDipartimenti[0].id)
                    attivo = true;

                if(vm.tipologieEClassi && vm.selectedTipoClasse.id != vm.tipologieEClassi[0].id)
                    attivo = true;

                if(vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;

                if(vm.under40Filter === true)
                    attivo = true;

                return attivo;

            }

            function getCsvExportUrl() {
                var filter = {
                };
                if (vm.selectedAnno != null) {
                    filter.anno = vm.selectedAnno.anno;
                }
                if (vm.selectedCognome != null && vm.selectedCognome != '') {
                    filter.cognome = vm.selectedCognome;
                }
                if (vm.selectedTipoClasse != null) {
                    if (vm.selectedTipoClasse.classeId)
                        filter.classeId = vm.selectedTipoClasse.classeId;
                    else if (vm.selectedTipoClasse.tipologiaId)
                        filter.tipologiaProgettoId = vm.selectedTipoClasse.tipologiaId;
                }
                if (vm.selectedAreaDip != null) {
                    if (vm.selectedAreaDip.dipartimentoId)
                        filter.dipartimentoId = vm.selectedAreaDip.dipartimentoId;
                    else if (vm.selectedAreaDip.macroareaId)
                        filter.macroAreaId = vm.selectedAreaDip.macroareaId;
                }
                if (vm.selectedStatusValutazione != null) {
                    filter.statusValutazione = vm.selectedStatusValutazione;
                }
                if (vm.under40Filter === true) {
                    filter.soloUnder40 = true;
                }

                return ProposteUrService.getCsvExportUrl(filter);
            }

            function cambiaTitolare(proposta) {

                var cambiaTitolareDialog = ngDialog.openConfirm({
                    template:'<cambia-titolare proposta="ngDialogData.proposta" confirm="confirm"></cambia-titolare>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        proposta: proposta
                    }
                });

                cambiaTitolareDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }

            function riapriRendicontazione(rendicontazioneId) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma Riapertura</h3>\
                        <div class="alert alert-warning" role="alert">Riaprendo la rendicontazione essa verrà rimessa nello stato di BOZZA. Il titolare potrà modificare e inviare di nuovo il rendiconto solo se i termini per la rendicontazione non sono trascorsi.</div>\
                        <p>Vuoi riportare la rendicontazione allo stato di BOZZA?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        RendicontazioniUrService.riapriRendicontazione(rendicontazioneId).then(function(/*result*/) {
                            getProposte(true);
                        });
                    }
                });
            }

            function openStoricoTitolari(proposta) {
                ngDialog.open({
                    template:'<storico-titolari proposta-id="ngDialogData.propostaId" proponente="ngDialogData.proponente"></storico-titolari>\
                                <div class="ngdialog-buttons">\
                                    <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Chiudi</button>\
                                </div>',
                    plain: true,
                    appendClassName: 'ngdialog-medium',
                    data: {
                        'propostaId': proposta.id,
                        'proponente': proposta.responsabile
                    }
                });
            }

            function dichiaraNonAmmissibile(propostaId) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Dichiara come Non Ammissibile</h3>\
                        <div class="alert alert-warning" role="alert">Dichiarando la proposta come Non Ammissibile, saranno cancellate tutte le valutazioni compilate o in corso di compilazione e verranno disabilitati tutti gli eventuali referee associati alla proposta.</div>\
                        <p>Vuoi dichiarare la proposta come Non Ammissibile?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        ValutazioniUrService.dichiaraNonAmmissibile(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        });
                    }
                });
            }

            function openIterValutazione(proposta) {

                var iterValutazioneDialog = ngDialog.openConfirm({
                    template:'<iter-valutazione proposta="ngDialogData.proposta" edit-mode="ngDialogData.editMode" is-ur="true" confirm="confirm"></iter-valutazione>',
                    plain: true,
                    appendClassName: 'ngdialog-medium ngdialog-iterValutazione',
                    data: {
                        proposta: proposta,
                        editMode: !proposta.tempoValutazioneConclusa && !proposta.statusValutazioneProposta // false
                    }
                });

                iterValutazioneDialog.then(function (data) {
                    if (data) {
                        getProposte(true);
                    }
                });
            }

            function riapriEsito(propostaId) {
                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                        <h3>Conferma Riapertura</h3>\
                        <p>Vuoi riaprire l\'esito del finanziamento della proposta?</p>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                            <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                        </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        EsitoValutazioneUrService.riapriEsitoValutazione(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        });
                    }
                });
            }

            function openIndicatoriValutazione(proposta) {
                ngDialog.open({
                    template:'<indicatori-valutazione proposta="ngDialogData.proposta" is-ur="true"></indicatori-valutazione>',
                    plain: true,
                    appendClassName: 'ngdialog-large ngdialog-indicatoriValutazione xxl',
                    data: {
                        proposta: proposta
                    }
                });
            }

            vm.openValutazioneConclusiva = openValutazioneConclusiva;
            function openValutazioneConclusiva( proposta, state ) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'<modale-terza-missione confirm="confirm" proposta="ngDialogData.proposta" valutazione="ngDialogData.valutazione" cancel="closeThisDialog"></modale-terza-missione>',
                    plain: true,
                    data: {
                        proposta: proposta,
                        valutazione: state
                    }
                })

                confirmDialog.then( function ( data ) {

                    ValutazioniUrService.rendicontaValutazione( data.id, data.value, data.nota, data.consolido )
                    .then( function() {
                        getProposte(true);
                    })
                    .catch(function (error) {
                        $log.error("Errore durante la valutazione della rendicontazione.", error);
                        showErrorDialog(error.data.message);
                    });

                })
            }

            vm.checkForValutabile = checkForValutabile

            function checkForValutabile( step ) {
                // var now = new Date()

                var valid = step.rendicontazione.status == 'INVIATA'
                    &&  AuthService.getUserInfo().utente.email == "terzamissione.asurtt@uniroma1.it"
                // && now >= step.rendicontazione.startTimestampValutazione
                    // && now <= step.rendicontazione.endTimestampValutazione

                return valid ? true : false
            }

            function riapriProposta(propostaId) {

                var confirmDialog = ngDialog.openConfirm({
                    template:'\
                            <h3>Conferma Riapertura</h3>\
                            <p>Vuoi riaprire la proposta?</p>\
                            <div class="ngdialog-buttons">\
                                <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>\
                                <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(true)">Sì</button>\
                            </div>',
                    plain: true
                });

                confirmDialog.then(function (data) {
                    if (data === true) {
                        ProposteUrService.riapriProposta(propostaId).then(function(/*result*/) {
                            getProposte(true);
                        })
                        .catch(function (error) {
                            $log.error("Errore durante la riapertura della proposta", error);
                            showErrorDialog(error.data.message);
                        });
                    }
                });
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .directive('addInattivo', addInattivo);

    /** @ngInject */
    function addInattivo() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/addInattivo/addInattivo.html',
            scope: {},
            bindToController: {
                inattivoId: '='
            },
            controller: AddInattivoController,
            controllerAs: 'inattivoCtrl'
        };

        return directive;

        /** @ngInject */
        function AddInattivoController(InattiviService, GestInattiviUrService, UtentiUrService, $log, $state, ngDialog) {
            var vm = this;

            // variabili
            vm.results = null;

            // filtro
            vm.selectedCognome = null;

            vm.loading = false; // true
            vm.anno = null;
            vm.tipologieInattivi = null;
            vm.selectedTipologia = null;

            vm.data = {
                id: [],
                tipologia: ''
            };

            vm.search = search;
            vm.getTipologieInattivi = getTipologieInattivi;
            vm.resetFiltri = resetFiltri;
            vm.isFiltroAttivo = isFiltroAttivo;
            vm.saveInattivi = saveInattivi;

            vm.getDataJson = function() {
                return angular.toJson(vm.data, 2);
            };

            function search(text) {
                vm.results = null;
                if (text != '') {
                    vm.searching = true;
                    var filter = {
                        cognome: text
                    };
                    UtentiUrService.getUtenti(filter)
                        .then(function(data) {
                            vm.searching = false;
                            vm.results = data.resultList;
                            // aggiungo i flag per le persone già selezionate
                            for (var i = 0; i < vm.results.length; i++) {
                                vm.results[i].selected = false;
                            }
                        }).catch(function() {
                            vm.searching = false;
                            vm.results = [];
                        });
                } else {
                    vm.searching = false;
                }
            }

            getTipologieInattivi()
                .catch(function(error) {
                    $log.error("Errore nel reperimento delle tipologie di inattivi", error);
                });

            function getTipologieInattivi() {
                return InattiviService.getTipologie()
                    .then(function(data) {
                        vm.tipologieInattivi = [];
                        var tipo = {
                            label: 'Nessuna Tipologia',
                            value: ''
                        };
                        vm.tipologieInattivi.push(tipo);
                        if (!vm.selectedTipologia)
                            vm.selectedTipologia = tipo;
                        for (var i = 0; i < data.length; i++) {
                            tipo = {
                                label: data[i],
                                value: data[i]
                            };
                            vm.tipologieInattivi.push(tipo);
                        }
                    });
            }

            /**
             * resetta i filtri inseriti dall'utente
             */
            function resetFiltri() {
                vm.selectedCognome = "";
                getTipologieInattivi();
            }

            /**
             * @returns {boolean} true se il filtro è attivo
             */
            function isFiltroAttivo() {
                var attivo = false;
                if (vm.selectedCognome && vm.selectedCognome != "")
                    attivo = true;
                return attivo;
            }

            function saveInattivi() {
                if (vm.results != null && vm.results.length > 0) {
                    for (var i = 0; i < vm.results.length; i++) {
                        if (vm.results[i].selected) {
                            vm.data.id.push(vm.results[i].utente.id)
                        }
                    }
                }
                if (vm.selectedTipologia.value !== '' && vm.data.id.length > 0) {
                    var savingDialog = showSavingDialog();
                    vm.data.tipologia = vm.selectedTipologia.value;
                    GestInattiviUrService.saveInattivi(vm.data)
                        .then(function () {
                            $log.log('Nuovi inattivi salvati con successo');
                            savingDialog.close();
                            $state.go('urGestInattivi');
                        })
                        .catch(function (error) {
                            vm.data.id = [];
                            $log.error("Errore nel salvataggio dei nuovi inattivi", error);
                            savingDialog.close();
                            showErrorDialog(error.data.message);
                        });
                } else
                    showErrorDialog("Selezionare almeno un utente e una tipologia");
            }

            function showSavingDialog() {
                var dialog = ngDialog.open({
                    template:'Salvataggio in corso...<button style="opacity: 0; width: 0px; height: 0px; outline: none;"></button>',
                    plain: true,
                    showClose: false
                });

                return dialog;
            }

            function showErrorDialog(message) {
                var msg = message == null || message === "" ? "Si è verificato un errore durante l\'esecuzione dell\'azione richiesta." : message;
                var dialog = ngDialog.open({
                    template:'<h3 style="margin-top: 0px;">Errore</h3><div class="alert alert-danger"><b>{{ngDialogData.errorMessage}}</b></div>',
                    plain: true,
                    showClose: true,
                    data: {
                        errorMessage: msg
                    }
                });

                return dialog;
            }
        }
    }

})();

angular.module('sigeba').controller('MenuUfficioRicercaController', function ($location) {
    var vm = this;

    var currentPage = $location.url() + "";//.split("/").pop();
    var isGestUtenti = currentPage === "/ur/anagrafica" || currentPage === "/ur/gestioneInattivi" || currentPage === "/ur/gestioneInattivi/new"|| currentPage === "/ur/dettaglioProposte" || currentPage === "/ur/caricamentoMassivo" ? true : false;
    var isGestBandi = currentPage === "/ur/creaBando" || currentPage === "/ur/configBandi";


    vm.status = {
        isGestioneUtentiOpen: isGestUtenti,
        isGestioneBandiOpen: isGestBandi
    };

    vm.closeGestioneUtenti = function () {
        vm.status = {
            isGestioneUtentiOpen: false,
            isGestioneBandiOpen: false
        };
    }
});

(function() {
    'use strict';

    angular
        .module('sigeba')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(AuthService, $location, $window,$state) {
        var vm = this;

        vm.loggedUser = (AuthService.getUserInfo() ? AuthService.getUserInfo() : null);
        vm.doLogout = doLogout;
        vm.doLogoutImpersona = doLogoutImpersona;

        vm.ufficio = AuthService.getUserInfo().utente.tipoUtente == "UFFICIO_RICERCA";
        // vm.helpdesk = AuthService.getUserInfo().tokenImpersona == null;
        // vm.terza = AuthService.getUserInfo().utente.email == "terzamissione.asurtt@uniroma1.it"
        // vm.award = AuthService.getUserInfo().utente.email == "grantoffice@uniroma1.it"

        vm.helpdesk = AuthService.getUserInfo().tokenImpersona == null;
        vm.canImpersona =  AuthService.getUserInfo().utente.canImpersona;

        function doLogout() {
            var userInfo = AuthService.getUserInfo().utente
            console.log('Logout userInfo:', userInfo);
            AuthService.logout().then(function () {
                if ( userInfo.useSSO && userInfo.logoutSSOUrl ) {
                    window.location.href = userInfo.logoutSSOUrl
                } else {
                    $window.location.reload();
                }
            });
        }

        function doLogoutImpersona(){
            AuthService.logoutImpersona().then(function () {
                if (AuthService.getUserInfo().utente.tipoUtente != "UFFICIO_RICERCA") {
                    $state.go('hdImpersona');
                } else {
                    $state.go('urImpersona');
                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .controller('LoginHdController', LoginHdController);

    /** @ngInject */
    function LoginHdController(AuthService, UserData, $location, $state, $window, $translate) {
        var vm = this;

        vm.username = null;
        vm.password = null;
        vm.logging = false;
        vm.errorMessages = [];
        vm.doLogin = doLogin;

        if (AuthService.getUserToken())
            $location.path('/');

        $translate.use("it");
        UserData.setLanguage("it");

        function doLogin() {
            vm.logging = true;
            vm.errorMessage = null;
            if (vm.username != null)
                vm.username = vm.username.toLowerCase();
            if (vm.username == '')
                vm.username = null;
            if (vm.password == '')
                vm.password = null;
            AuthService.login(vm.username, vm.password)
                .then(function() {
                    $window.sessionStorage.clear();
                    //$location.path('/');
                    var role = AuthService.getUserInfo().utente.tipoUtente;
                    if (role == 'UTENTE')
                        $state.go('home');
                    else if (role == 'UFFICIO_RICERCA')
                        $state.go('urHome');
                    else if (role == 'HELP_DESK')
                        $state.go('hdHome');
                    else if (role == 'RAD')
                        $state.go('radHome');
                    else if (role == 'UFFICIO_CERT')
                        $state.go('certHome');
                })
                .catch(function(error) {
                    vm.logging = false;
                    vm.errorMessages = [];
                    if (error.data && error.data.message)
                        vm.errorMessages.push(error.data.message);
                    else if (error.data.violationReport) {
                        var vr = error.data.violationReport;
                        for (var prop in vr)
                            vm.errorMessages.push(vr[prop]);
                    }
                    else
                        vm.errorMessages.push('Errore di comunicazione con il server');
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .controller('LoginRefereeController', LoginRefereeController);

    /** @ngInject */
    function LoginRefereeController(AuthService, UserData, $location, $state, $stateParams, $translate) {
        var vm = this;

        vm.username = $stateParams.ref;
        vm.password = null;
        vm.refLink = $stateParams.ref ? true : false;
        vm.logging = false;
        vm.errorMessages = [];
        vm.doLogin = doLogin;
        
        if (AuthService.getUserToken())
            $location.path('/');
        
        $translate.use("en");
        UserData.setLanguage("en");
        
        function doLogin() {
            vm.logging = true;
            vm.errorMessage = null;
            if (vm.username != null)
                vm.username = vm.username.toLowerCase();
            if (vm.username == '')
                vm.username = null;
            if (vm.password == '')
                vm.password = null;
            AuthService.login(vm.username, vm.password)
                .then(function() {
                    //$location.path('/');
                    var role = AuthService.getUserInfo().utente.tipoUtente;
                    if (role == 'UTENTE')
                        $state.go('home');
                    else if (role == 'UFFICIO_RICERCA')
                        $state.go('urHome');
                    else if (role == 'REFEREE')
                        $state.go('refHome');
                    else if (role == 'UFFICIO_CERT')
                        $state.go('certHome');
                })
                .catch(function(error) {
                    vm.logging = false;
                    vm.errorMessages = [];
                    if (error.data && error.data.message)
                        vm.errorMessages.push(error.data.message);
                    else if (error.data.violationReport) {
                        var vr = error.data.violationReport;
                        for (var prop in vr)
                            vm.errorMessages.push(vr[prop]);
                    }
                    else
                        vm.errorMessages.push('Errore di comunicazione con il server');
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .controller('LoginCertController', LoginCertController);

    /** @ngInject */
    function LoginCertController(AuthService, UserData, $location, $state, $stateParams, $translate) {
        var vm = this;

        vm.username = $stateParams.ref;
        vm.password = null;
        vm.refLink = $stateParams.ref ? true : false;
        vm.logging = false;
        vm.errorMessages = [];
        vm.doLogin = doLogin;

        if (AuthService.getUserToken())
            $location.path('/');

        $translate.use("it");
        UserData.setLanguage("it");

        function doLogin() {
            vm.logging = true;
            vm.errorMessage = null;
            if (vm.username != null)
                vm.username = vm.username.toLowerCase();
            if (vm.username == '')
                vm.username = null;
            if (vm.password == '')
                vm.password = null;
            AuthService.login(vm.username, vm.password)
                .then(function() {
                    //$location.path('/');
                    var role = AuthService.getUserInfo().utente.tipoUtente;
                    if (role == 'UTENTE')
                        $state.go('home');
                    else if (role == 'UFFICIO_RICERCA')
                        $state.go('urHome');
                    else if (role == 'REFEREE')
                        $state.go('refHome');
                    else if (role == 'UFFICIO_CERT')
                        $state.go('certHome');
                    else if (role == 'MEMBRO_COMMISSIONE_CERT')
                        $state.go('certHome');
                })
                .catch(function(error) {
                    vm.logging = false;
                    vm.errorMessages = [];
                    if (error.data && error.data.message)
                        vm.errorMessages.push(error.data.message);
                    else if (error.data.violationReport) {
                        var vr = error.data.violationReport;
                        for (var prop in vr)
                            vm.errorMessages.push(vr[prop]);
                    }
                    else
                        vm.errorMessages.push('Errore di comunicazione con il server');
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(AuthService, UserData, $location, $state, $window, $translate) {
        var vm = this;

        vm.username = null;
        vm.password = null;
        vm.logging = false;
        vm.errorMessages = [];
        vm.doSSOLogin = doSSOLogin;
        vm.redirectToSSOAteneo = redirectToSSOAteneo;
        vm.redirectToSSOSPID = redirectToSSOSPID;

        checkQParamsOnMount()

        if (AuthService.getUserToken())
            $location.path('/');

        $translate.use("it");
        UserData.setLanguage("it");

        function redirectToSSOAteneo() {
            var ssoPath = '/Shibboleth.sso/Login?target=' + encodeURIComponent('/sigeba-api-web/v1/login/ssoauth');
            window.location.href = window.location.origin + ssoPath;
        }

        function redirectToSSOSPID() {
            var ssoPath = '/Shibboleth.sso/SPID?target=' + encodeURIComponent('/sigeba-api-web/v1/login/ssoauth');
            window.location.href = window.location.origin + ssoPath;
        }

        function checkQParamsOnMount() {
            // Recupero i query params tramite $location API di AngularJS
            var params = $location.search();
            console.log('Reading params: ',params)
            // Verifico esistenza di query parameters per SSO...
            // Per ottenere un login valido necessito di tokensso e ssosessionid
            if (params.tokensso && params.ssosessionid) {
                doSSOLogin(params.tokensso, params.ssosessionid)
            }
        }

        function doSSOLogin(username, password) {
            AuthService.SSOlogin(username, password)
                .then(function() {
                    $window.sessionStorage.clear();
                    //$location.path('/');
                    var role = AuthService.getUserInfo().utente.tipoUtente;
                    if (role == 'UTENTE')
                        $state.go('home');
                    else if (role == 'UFFICIO_RICERCA')
                        $state.go('urHome');
                    else if (role == 'HELP_DESK')
                        $state.go('hdHome');
                    else if (role == 'RAD')
                        $state.go('radHome');
                    else if (role == 'UFFICIO_CERT')
                        $state.go('certHome');
                })
                .catch(function(error) {
                    vm.logging = false;
                    vm.errorMessages = [];
                    if (error.data && error.data.message)
                        vm.errorMessages.push(error.data.message);
                    else if (error.data.violationReport) {
                        var vr = error.data.violationReport;
                        for (var prop in vr)
                            vm.errorMessages.push(vr[prop]);
                    }
                    else
                        vm.errorMessages.push('Errore di comunicazione con il server');
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $location, $state, AuthService, $window, ngDialog, $timeout, ThemeService) {

        initEnvService()

        $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams, options) { //eslint-disable-line angular/on-watch, no-unused-vars
            if (toState.url == '/') {
                event.preventDefault();
                var userId = AuthService.getUserId();
                if (userId) {
                    var userInfo = AuthService.getUserInfo();
                    if (userInfo) {
                        redirectToHome();
                    }
                    else {
                        return AuthService.refreshUserInfo()
                            .then(function() {
                                redirectToHome();
                            });
                    }
                }
                else {
                    $state.go('login');
                }
            }

            function redirectToHome() {
                var role = AuthService.getUserInfo().utente.tipoUtente;
                if (role == 'UTENTE')
                    $state.go('home');
                else if (role == 'UFFICIO_RICERCA')
                    $state.go('urHome');
                else if (role == 'RAD')
                    $state.go('radHome');
                else if (role == 'HELP_DESK')
                    $state.go('hdHome');
                else if (role == 'REFEREE')
                    $state.go('refHome');
                else if (role == 'UFFICIO_CERT')
                    $state.go('certHome');
                else if (role == 'MEMBRO_COMMISSIONE_CERT')
                    $state.go('certHome');
            }
        });

        $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) { //eslint-disable-line angular/on-watch
            if (error.authenticated === false || error.membroCommissione === false) {
                $log.debug('User not authorized to access route:', toState.url);
                event.preventDefault();
                if (toState.parent && toState.parent == 'mainNoMenu.referee')
                    $location.path("/login-referee");
                else
                    $location.path("/login");
                //$window.location.reload();
            }
        });

        $rootScope.$on("sigeba.invalidUser", function() { //eslint-disable-line angular/on-watch
            $log.debug('User not authorized (maybe token expired)');
            //event.preventDefault();
            AuthService.clearUserInfo();
            ngDialog.open({
                template:'\
                        <h3 style="margin-top: 0px;">Sessione Scaduta</h3><div class="alert alert-danger"><b>Devi effettuare nuovamente l\'accesso al sistema.</b><br/><br/>Premendo il pulsante Chiudi, sarai redirezionato automaticamente sulla pagina di login.</div>\
                        <div class="ngdialog-buttons">\
                            <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">chiudi</button>\
                        </div>',
                plain: true,
                showClose: false,
                preCloseCallback: function () {
                    //$location.path("/login");
                    $timeout(function() {
                        $window.location.reload();
                    });
                },
                data: {}
            });
        });

        function initEnvService() {
            // Inizializzo il servizio all'avvio dell'applicazione
            var theme = ThemeService.initializeTheme();
            
            // Se necessario possiamo inserire qui altri comportamenti custom dipendenti dall'attivazione del tema
            if (theme) {
                console.log('Tema Inizializzato:', theme);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('sigeba')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('root', {
                url: '/'
            })
            .state('login', {
                url: '/login',
                templateUrl: 'app/login/login.html',
                controller: 'LoginController',
                controllerAs: 'login'
            })
            .state('login-hd', {
                url: '/login-hd',
                templateUrl: 'app/login-hd/login-hd.html',
                controller: 'LoginHdController',
                controllerAs: 'login'
            })
            .state('loginReferee', {
                url: '/login-referee?ref',
                templateUrl: 'app/login/login-referee.html',
                controller: 'LoginRefereeController',
                controllerAs: 'login'
            })
            .state('main', {
                abstract: true,
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main',
                resolve: {
                    auth: authenticationResolve
                }
            })
            .state('mainNoMenu', {
                abstract: true,
                templateUrl: 'app/main/main-no-menu.html',
                controller: 'MainController',
                controllerAs: 'main',
                resolve: {
                    auth: authenticationResolve
                }
            })
            .state('mainNoAuth', {
                abstract: true,
                templateUrl: 'app/main/main-no-auth.html'
            })
            .state('loginCert', {
                url: '/login-cert?ref',
                templateUrl: 'app/login/login-cert.html',
                controller: 'LoginCertController',
                controllerAs: 'login'
            })

            .state('propostaPrint', {
                url: '/proposte/:id/print?userType&token',
                templateUrl: 'app/print/print.html',
                controller: function ($stateParams, UserData) {
                    var vm = this;
                    vm.propostaId = $stateParams.id;
                    UserData.setToken($stateParams.token);
                    vm.isUr = false;
                    vm.isMc = false;
                    vm.isRad = false;
                    vm.isRef = false;
                    if ($stateParams.userType == 'ur') {
                        vm.isUr = true;
                    } else if ($stateParams.userType == 'mc') {
                        vm.isMc = true;
                    } else if ($stateParams.userType == 'rad') {
                        vm.isRad = true;
                    } else if ($stateParams.userType == 'ref') {
                        vm.isRef = true;
                    }
                },
                controllerAs: 'viewPropPrint'
            })

            .state('rendicontazionePrint', {
                url: '/rendicontazioni/:id/print?userType&token',
                templateUrl: 'app/print/printRend.html',
                controller: function ($stateParams, UserData) {
                    var vm = this;
                    vm.rendicontazioneId = $stateParams.id;
                    UserData.setToken($stateParams.token);
                    vm.isUr = false;
                    vm.isRad = false;
                    if ($stateParams.userType == 'ur') {
                        vm.isUr = true;
                    } else if ($stateParams.userType == 'rad') {
                        vm.isRad = true;
                    }
                },
                controllerAs: 'viewRendPrint'
            })

            .state('valutazionePrint', {
                url: '/valutazioni/:id/print?userType&token',
                templateUrl: 'app/print/printVal.html',
                controller: function ($stateParams, UserData) {
                    var vm = this;
                    vm.valutazioneId = $stateParams.id;
                    UserData.setToken($stateParams.token);
                    vm.isUr = false;
                    if ($stateParams.userType == 'ur') {
                        vm.isUr = true;
                    }
                },
                controllerAs: 'viewValPrint'
            })

            // ACCESSO UTENTE
            .state('main.utente', {
                abstract: true,
                resolve: {
                    userRes: utenteResolve
                },
                views: {
                    'rightmenu': {templateUrl: 'app/main/menu-utente.html'},
                    'content': {template: '<div ui-view="content"></div>'}
                }
            })
            .state('home', {
                url: '/home',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/utente/home/home.html'}
                }
            })
            .state('profilo', {
                url: '/profilo',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/utente/profilo/profilo.html'}
                }
            })
            .state('bandi', {
                url: '/bandi',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/utente/bandi/bandi.html'}
                }
            })
            .state('proposte', {
                url: '/proposte',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/utente/proposte/proposte.html'}
                }
            })
            .state('propostaDetail', {
                url: '/proposte/:id',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<edit-proposta proposta-id="editProp.propostaId"></edit-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'editProp'
                    }
                }
            })
            .state('propostaCertDetail', {
                url: '/proposteCert/:id',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<edit-proposta-cert proposta-id="editProp.propostaId"></edit-proposta-cert>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'editProp'
                    }
                }
            })
            .state('propostaCertView', {
                url: '/proposteCert/:id/view',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<view-proposta-cert proposta-id="editProp.propostaId"></view-proposta-cert>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'editProp'
                    }
                }
            })
            .state('propostaFormPartecipante', {
                url: '/proposte/:id/partecipante',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<edit-proposta-partecipante proposta-id="editPropPart.propostaId"></edit-proposta-partecipante>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'editPropPart'
                    }
                }
            })
            .state('propostaView', {
                url: '/proposte/:id/view',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<view-proposta proposta-id="viewProp.propostaId"></view-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'viewProp'
                    }
                }
            })
            .state('mcPropostaView', {
                url: '/proposte/mc/:id/view',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<view-proposta proposta-id="mcViewProp.propostaId" is-mc="true"></view-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'mcViewProp'
                    }
                }
            })
            .state('newProposta', {
                url: '/proposte/new/:classe',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<edit-proposta classe-id="editProp.classeId"></edit-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.classeId = $stateParams.classe;
                        },
                        controllerAs: 'editProp'
                    }
                }
            })
            .state('listaIstanzeUser', {
                url: '/cert',
                parent: 'main.utente',
                views: {
                    'content': { templateUrl: 'app/utente/cert/cert.html'}
                }
            })
            .state('rendicontazione', {
                url: '/rendicontazione',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/utente/rendicontazione/rendicontazione.html'}
                }
            })
            .state('rendicontazioni', {
                url: '/rendicontazioni',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/utente/rendicontazioni/rendicontazioni.html'}
                }
            })
            .state('newRendicontazione', {
                url: '/rendicontazioni/new/:proposta/:step',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<edit-rendicontazione proposta-id="editRndcz.propostaId" step-id="editRndcz.stepId"></edit-rendicontazione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.proposta;
                            vm.stepId = $stateParams.step;
                        },
                        controllerAs: 'editRndcz'
                    }
                }
            })
            .state('rendicontazioneDetail', {
                url: '/rendicontazioni/:id',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<edit-rendicontazione rendicontazione-id="editRndcz.rendicontazioneId"></edit-rendicontazione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.rendicontazioneId = $stateParams.id;
                        },
                        controllerAs: 'editRndcz'
                    }
                }
            })
            .state('rendicontazioneView', {
                url: '/rendicontazioni/:id/view',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<view-rendicontazione rendicontazione-id="viewRend.rendicontazioneId"></view-rendicontazione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.rendicontazioneId = $stateParams.id;
                        },
                        controllerAs: 'viewRend'
                    }
                }
            })
            .state('mcValutazione', {
                url: '/mc/valutazione',
                parent: 'main.utente',
                resolve: {
                    isMembroCommissione: membroCommissioneResolve
                    // isPresidenteCommissione: presidenteCommissioneCertResolve
                },
                views: {
                    'content': {templateUrl: 'app/utente/valutazione/valutazione.html'}
                }
            })
            .state('mcValutazioneCert', {
                url: '/mc/valutazioneCert',
                parent: 'main.utente',
                resolve: {
                    isMembroCommissione: membroCommissioneCertResolve
                    // isPresidenteCommissione: presidenteCommissioneCertResolve
                },
                views: {
                    'content': {templateUrl: 'app/cert/archivio/archivio.html'}
                }
            })
            .state('certPresCommissioni', {
                url: '/commissioni',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/cert/commissioni/commissioni.html'}
                }
            })
            .state('sedutePresCertList', {
                url: '/sedute',
                parent: 'main.utente',
                views: {
                    'content': {templateUrl: 'app/cert/sedute/sedute.html'}
                }
            })
            .state('sedutaPresCert', {
                url: '/seduta/:id',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<seduta-cert seduta-id="sedutaParam.sedutaId"></seduta-cert>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.sedutaId = $stateParams.id;
                        },
                        controllerAs: 'sedutaParam'
                    }
                }
            })
            .state('certCommissionePresDetail', {
                url: '/cert/commissioni/:id',
                parent: 'main.utente',
                views: {
                    'content': {
                        template: '<cert-associa-commissione commissione-id="comm.commissioneId"></cert-associa-commissione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.commissioneId = $stateParams.id;
                        },
                        controllerAs: 'comm'
                    }
                }
            })
            .state('mcStatistiche', {
                url: '/mc/statistiche',
                parent: 'main.utente',
                resolve: {
                    isMembroCommissione: membroCommissioneResolve
                },
                views: {
                    'content': {templateUrl: 'app/utente/statistiche/statistiche.html'}
                }
            })
            .state('dirDipProgetti', {
                url: '/dirdip/progetti',
                parent: 'main.utente',
                resolve: {
                    isDirettoreDipartimento: direttoreDipartimentoResolve
                },
                views: {
                    'content': {templateUrl: 'app/utente/progetti/progetti.html'}
                }
            })

            // ACCESSO UFFICIO RICERCA
            .state('main.ufficioricerca', {
                abstract: true,
                url: '/ur',
                resolve: {
                    urRes: ufficioricercaResolve
                },
                views: {
                    'rightmenu': {templateUrl: 'app/main/menu-ufficioricerca.html'},
                    'content': {template: '<div ui-view="content"></div>'}
                }
            })
            .state('urHome', {
                url: '/home',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/home/home.html'}
                }
            })
            // ACCESSO help desk
            .state('main.helpdesk', {
                abstract: true,
                url: '/hd',
                resolve: {
                    hdRes: helpdeskResolve
                },
                views: {
                    'rightmenu': {templateUrl: 'app/main/menu-helpdesk.html'},
                    'content': {template: '<div ui-view="content"></div>'}
                }
            })
            .state('hdHome', {
                url: '/home',
                parent: 'main.helpdesk',
                views: {
                    'content': {templateUrl: 'app/helpdesk/home/home.html'}
                }
            })
            .state('urCommissioni', {
                url: '/commissioni',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/commissioni/commissioni.html'}
                }
            })
            .state('urNewCommissione', {
                url: '/commissioni/new',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {template: '<edit-commissione></edit-commissione>'}
                }
            })
            .state('urGestioneUtenteNew', {
                url: '/anagrafica/utente/new',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {template: '<gestione-utente></gestione-utente>'}
                }
            })
            .state('urGestioneUtenteEdit', {
                url: '/anagrafica/utente/:id',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {
                        template: '<gestione-utente user-id="usr.idUtente"></gestione-utente>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.idUtente = $stateParams.id;
                        },
                        controllerAs: 'usr'
                    }
                }
            })
            .state('urListDettaglioProp', {
                url: '/dettaglioProp/listaDettaglioProp/:id',
                parent: 'main.ufficioricerca',
                views: {
                    'content': { template: '<list-Dettaglio-Proposte></list-Dettaglio-Proposte>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.idUtente = $stateParams.id;
                        },
                        controllerAs: 'usr'
                    }
                }
            })
            .state('urCommissioneDetail', {
                url: '/commissioni/:id',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {
                        template: '<edit-commissione commissione-id="comm.commissioneId"></edit-commissione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.commissioneId = $stateParams.id;
                        },
                        controllerAs: 'comm'
                    }
                }
            })
            .state('urProgetti', {
                url: '/progetti',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/progetti/progetti.html'}
                }
            })
            .state('urStatistiche', {
                url: '/statistiche',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/statistiche/statistiche.html'}
                }
            })
            .state('urPropostaView', {
                url: '/proposte/:id/view',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {
                        template: '<view-proposta proposta-id="urViewProp.propostaId" is-ur="true"></view-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'urViewProp'
                    }
                }
            })
            .state('urIter', {
                url: '/iter',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/iter/iter.html'}
                }
            })
            .state('urCreaBando', {
                url: '/creaBando',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/gestioneBandi/creazBandi.html'}
                }
            })
            .state('urBandoView', {
                url: '/configBandi',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/gestioneBandi/configBandi.html'}
                }
            })
            .state('urConfigBandoView', {
                url: '/configuraBando/:id',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {
                        template: '<configura-bando bando-id="urConfigBando.bandoId" is-ur="true""></configura-bando>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.bandoId = $stateParams.id;
                        },
                        controllerAs: 'urConfigBando'
                    }
                }
            })
            .state('urRendicontazioneView', {
                url: '/rendicontazioni/:id/view',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {
                        template: '<view-rendicontazione rendicontazione-id="urViewRend.rendicontazioneId" is-ur="true"></view-rendicontazione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.rendicontazioneId = $stateParams.id;
                        },
                        controllerAs: 'urViewRend'
                    }
                }
            })
            .state('urAnagrafica', {
                url: '/anagrafica',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/gestioneutenti/anagrafica.html'}
                }
            })
            .state('urGestInattivi', {
                url: '/gestioneInattivi',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/gestioneutenti/gestInattivi.html'}
                }
            })
            .state('urNewInattivo', {
                url: '/gestioneInattivi/new',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {template: '<add-inattivo></add-inattivo>'}
                }
            })
            .state('urDettaglioProposte', {
                url: '/dettaglioProposte',
                parent: 'main.ufficioricerca',
                views: {
                    'content': { templateUrl: 'app/ufficioricerca/gestioneutenti/dettaglioProposte.html' }
                }
            })
            .state('urCaricamentoMassivo', {
                url: '/caricamentoMassivo',
                parent: 'main.ufficioricerca',
                views: {
                    'content': { templateUrl: 'app/ufficioricerca/gestioneutenti/caricamentoMassivo.html' }
                }
            })
            .state('urImpersona', {
                url: '/impersona',
                parent: 'main.ufficioricerca',
                views: {
                    'content': { templateUrl: 'app/ufficioricerca/impersona/impersona.html' }
                }
            })
            .state('certImpersona', {
                url: '/impersona',
                parent: 'main.cert',
                views: {
                    'content': { templateUrl: 'app/ufficioricerca/impersona/impersona.html' }
                }
            })
            .state('hdImpersona', {
                url: '/impersona',
                parent: 'main.helpdesk',
                views: {
                    'content': { templateUrl: 'app/ufficioricerca/impersona/impersona.html' }
                }
            })
            // ACCESSO REFEREE
            .state('refereeAccept', {
                url: '/referee-accept?rId&rToken',
                parent: 'mainNoAuth',
                views: {
                    'content': {
                        template: '<referee-accept ref-id="refAcpt.refId" ref-token="refAcpt.refToken"></referee-accept>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.refId = $stateParams.rId;
                            vm.refToken = $stateParams.rToken;
                            if (!vm.refId)
                                vm.refId = 0;
                        },
                        controllerAs: 'refAcpt'
                    }
                }
            })
            .state('mainNoMenu.referee', {
                abstract: true,
                url: '/ref',
                resolve: {
                    refRes: refereeResolve
                },
                views: {
                    'content': {template: '<div ui-view="content"></div>'}
                }
            })
            .state('refHome', {
                url: '/home',
                parent: 'mainNoMenu.referee',
                views: {
                    'content': {
                        templateUrl: 'app/referee/home/home.html'
                    }
                }
            })

            .state('refPropostaView', {
                url: '/proposte/:id/view',
                parent: 'mainNoMenu.referee',
                views: {
                    'content': {
                        template: '<view-proposta proposta-id="refViewProp.propostaId" is-ref="true"></view-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'refViewProp'
                    }
                }
            })
            .state('urDipartimenti', {
                url: '/dipartimenti',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/dipartimenti/dipartimenti.html'}
                }
            })
            .state('urStrutture', {
                url: '/strutture',
                parent: 'main.ufficioricerca',
                views: {
                    'content': {templateUrl: 'app/ufficioricerca/strutture/strutture.html'}
                }
            })

            // ACCESSO RAD
            .state('main.rad', {
                abstract: true,
                url: '/rad',
                resolve: {
                    radRes: radResolve
                },
                views: {
                    'rightmenu': {templateUrl: 'app/main/menu-rad.html'},
                    'content': {template: '<div ui-view="content"></div>'}
                }
            })
            .state('radHome', {
                url: '/home',
                parent: 'main.rad',
                views: {
                    'content': {templateUrl: 'app/rad/home/home.html'}
                }
            })
            .state('radProgetti', {
                url: '/progetti',
                parent: 'main.rad',
                views: {
                    'content': {templateUrl: 'app/rad/progetti/progetti.html'}
                }
            })
            .state('radPropostaView', {
                url: '/proposte/:id/view',
                parent: 'main.rad',
                views: {
                    'content': {
                        template: '<view-proposta proposta-id="radViewProp.propostaId" is-rad="true"></view-proposta>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'radViewProp'
                    }
                }
            })
            .state('radRendicontazioneView', {
                url: '/rendicontazioni/:id/view',
                parent: 'main.rad',
                views: {
                    'content': {
                        template: '<view-rendicontazione rendicontazione-id="radViewRend.rendicontazioneId" is-rad="true"></view-rendicontazione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.rendicontazioneId = $stateParams.id;
                        },
                        controllerAs: 'radViewRend'
                    }
                }
            })

            /// CERT

            .state('main.cert', {
                abstract: true,
                url: '/cert',
                resolve: {
                    urRes: ufficioCertResolve
                },
                views: {
                    'rightmenu': {templateUrl: 'app/main/menu-cert.html'},
                    'content': {template: '<div ui-view="content"></div>'}
                }
            })
            .state('certHome', {
                url: '/home',
                parent: 'main.cert',
                views: {
                    'content': {templateUrl: 'app/cert/home/home.html'}
                }
            })
            .state('valutazioneCert', {
                url: '/valutazione',
                parent: 'main.cert',
                views: {
                    'content': { templateUrl: 'app/cert/archivio/archivio.html' }
                }
            })
            .state('certCommissioni', {
                url: '/commissioni',
                parent: 'main.cert',
                views: {
                    'content': {templateUrl: 'app/cert/commissioni/commissioni.html'}
                }
            })
            .state('certCommissioneDetail', {
                url: '/cert/commissioni/:id',
                parent: 'main.cert',
                views: {
                    'content': {
                        template: '<cert-associa-commissione commissione-id="comm.commissioneId"></cert-associa-commissione>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.commissioneId = $stateParams.id;
                        },
                        controllerAs: 'comm'
                    }
                }
            })
            .state('listaIstanzeUserCert', {
                url: '/istanze',
                parent: 'main.cert',
                views: {
                    'content': { templateUrl: 'app/cert/listaIstanze/listaIstanze.html'}
                }
            })
            .state('propostaCertViewUc', {
                url: '/istanze/:id/view',
                parent: 'main.cert',
                views: {
                    'content': {
                        template: '<view-proposta-cert proposta-id="editProp.propostaId"></view-proposta-cert>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'editProp'
                    }
                }
            })
            .state('istanzeCertDetail', {
                url: '/istanze/:id',
                parent: 'main.cert',
                views: {
                    'content': {
                        template: '<edit-proposta-cert proposta-id="editProp.propostaId"></edit-proposta-cert>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.propostaId = $stateParams.id;
                        },
                        controllerAs: 'editProp'
                    }
                }
            })
            .state('seduteCertList', {
                url: '/sedute',
                parent: 'main.cert',
                views: {
                    'content': {templateUrl: 'app/cert/sedute/sedute.html'}
                }
            })
            .state('sedutaCert', {
                url: '/seduta/:id',
                parent: 'main.cert',
                views: {
                    'content': {
                        template: '<seduta-cert seduta-id="sedutaParam.sedutaId"></seduta-cert>',
                        controller: function ($stateParams) {
                            var vm = this;
                            vm.sedutaId = $stateParams.id;
                        },
                        controllerAs: 'sedutaParam'
                    }
                }
            })

        $urlRouterProvider.otherwise('/');
    }

    /** @ngInject */
    function authenticationResolve(AuthService, UserData, $q, $translate) {

        $translate.use("it");
        UserData.setLanguage("it");

        var userId = AuthService.getUserId();
        if (userId) {
            var userInfo = AuthService.getUserInfo();
            if (userInfo) {
                return $q.when(userInfo);
            } else {
                return AuthService.refreshUserInfo()
                    .then(function () {
                        return $q.when(AuthService.getUserInfo());
                    });
            }
        } else {
            return $q.reject({
                authenticated: false
            });
        }
    }

    /** @ngInject */
    function utenteResolve(auth, AuthService, $q) {
        var role = auth.utente.tipoUtente;
        if (role != 'UTENTE') {
            return $q.reject({
                authenticated: false
            });
        } else {
            return $q.when(AuthService.getUserInfo());
        }
    }

    /** @ngInject */
    function ufficioricercaResolve(auth, AuthService, $q) {
        var role = auth.utente.tipoUtente;
        if (role != 'UFFICIO_RICERCA') {
            return $q.reject({
                authenticated: false
            });
        } else {
            return $q.when(AuthService.getUserInfo());
        }
    }

    /** @ngInject */
    function ufficioCertResolve(auth, AuthService, $q) {
        var role = auth.utente.tipoUtente;
        var membroCommissione = auth.utente.membroInternoCommissioneCert;
        var presidente = auth.utente.presidenteCommissioneCert;
        if (role !== 'UFFICIO_CERT' && role !== 'MEMBRO_COMMISSIONE_CERT' && !membroCommissione && !presidente) {
            return $q.reject({
                authenticated: false
            });
        } else {
            return $q.when(AuthService.getUserInfo());
        }
    }

    /** @ngInject */
    function helpdeskResolve(auth, AuthService, $q) {
        var role = auth.utente.tipoUtente;
        if (role != 'HELP_DESK') {
            return $q.reject({
                authenticated: false,
                membroInternoCommissioneCert: false,
                presidenteCommissioneCert: false
            });
        } else {
            return $q.when(AuthService.getUserInfo());
        }
    }

    /** @ngInject */
    function membroCommissioneCertResolve(auth, AuthService, $q) {
        var membroCommissione = auth.utente.membroInternoCommissioneCert;
        var presidente = auth.utente.presidenteCommissioneCert;
        if (!membroCommissione && !presidente) {
            return $q.reject({
                membroInternoCommissioneCert: false,
                presidenteCommissioneCert: false
            });
        }
    }

    /** @ngInject */
    function membroCommissioneResolve(auth, AuthService, $q) {
        var membroCommissione = auth.utente.membroCommissione;
        if (!membroCommissione) {
            return $q.reject({
                membroCommissione: false
            });
        }
    }

    /** @ngInject */
    function presidenteCommissioneCertResolve(auth, AuthService, $q) {
        var presidenteCommissioneCert = auth.utente.presidenteCommissioneCert;
        if (!presidenteCommissioneCert) {
            return $q.reject({
                presidenteCommissioneCert: false
            });
        }
    }

    /** @ngInject */
    function refereeResolve(auth, AuthService, UserData, $q, $translate) {

        $translate.use("en");
        UserData.setLanguage("en");

        var role = auth.utente.tipoUtente;
        if (role != 'REFEREE') {
            return $q.reject({
                authenticated: false
            });
        } else {
            return $q.when(AuthService.getUserInfo());
        }
    }

    /** @ngInject */
    function radResolve(auth, AuthService, $q) {
        var role = auth.utente.tipoUtente;
        if (role != 'RAD') {
            return $q.reject({
                authenticated: false
            });
        } else {
            return $q.when(AuthService.getUserInfo());
        }
    }

    /** @ngInject */
    function direttoreDipartimentoResolve(auth, AuthService, $q) {
        var direttoreDipartimento = auth.utente.direttoreDipartimento;
        if (!direttoreDipartimento) {
            return $q.reject({
                direttoreDipartimento: false
            });
        }
    }

})();

/* global moment:false */
(function() {
    'use strict';

    angular
        .module('sigeba')
        .constant('moment', moment)
        .constant('Constants', {
            //restApiRoot: 'http://192.168.137.5:8080/sigeba-api-web/v1',
            //restApiRoot: 'http://192.168.137.7:8080/sigeba-api-web/v1',
            //  restApiRoot: 'http://localhost:8082/sigeba-api-web/v1',
            restApiRoot: '/sigeba-api-web/v1',
            // restApiRoot: 'https://web99.linksmt.it/sigeba-api-web/v1',
            clientId: '1',
            appVersion: '1.5.5'
        })
    ;

})();

(function() {
    'use strict';

    angular
        .module('sigeba')
        .config(config);

    /** @ngInject */
    function config($logProvider, $httpProvider, ngDialogProvider, $translateProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        // Enable http interceptor
        $httpProvider.interceptors.push('RestApiInterceptor');

        // Set defaults for ngDialogProvider
        ngDialogProvider.setDefaults({
            showClose: true,
            closeByEscape: false,
            closeByDocument: false,
            closeByNavigation: true
        });

        //transalte
        $translateProvider.translations('it', {
            PRINT: 'Stampa',
            PRINT_PDF: 'Scarica PDF',
            REQUEST_FOR_FUNDING: "Domanda di finanziamento",
            NAME_AND_SURNAME: "Cognome e nome",
            NAME: "Nome",
            SURNAME: "Cognome",
            ROLE: "Qualifica",
            DEPARTMENT: "Dipartimento",
            DEPARTMENT_ORGANIZATION: "Dipartimento/Organizzazione",
            ERC_SECTOR: "Sett. ERC",
            ERC_SUB_SECTOR: "Sotto sett. ERC",
            PUBLICATION: "Pubblicazione",
            PARTICIPANT: "Partecipante",
            NO_COMPONENT: "Nessun componente",
            NO_PUBLICATION: "Nessuna pubblicazione",
            DESCRIPTION: "Descrizione",
            AMOUNT: "Importo",
            BUDGET_ITEM: "Voce di spesa",
            TOTAL: "Totale",
            YEAR: "Anno",
            FUNDED_PROJECT: "Progetto Finanziato",
            ASSIGNED_FUND: "Fondo assegnato",
            NOT_YET_USED_FUND: "Fondo non ancora utilizzato",
            REASON_FOR_UNUSED_FUND: "Motivazione per mancato utilizzo fondo",
            OTHER_PI: "Co-Proponente",
            REFERENCE_DATABASE: "Database di riferimento",
            NO_OTHER_PI: "Nessun co-proponente",
            EVALUATE_PROJECT: "Valutazione proposta",
            TITLE: "Titolo",
            RESPONSIBLE: "Responsabile",
            TYPE_AND_CLASS: "Tipologia e classe",
            LAST_MODIFIED: "Ultima modifica",
            EVALUTATION: "Valutazione",
            MOTIVATION: "Motivazione",
            EVAL_COMMENT: "Eventuale commento",
            EVALUATION_CRITERIA: "Criteri di valutazione",
            SAVE_AND_COMPLETE: "Salva e Concludi",
            SAVE_AS_DRAFT: "Salva in Bozza",
            CLOSE: "Chiudi",
            CONFIRM_EVALUATION_SUBMIT: "Concludendo la valutazione, non sarà più possibile modificarla.",
            CONFIRM_EVALUATION_SUBMIT_QUESTION: "Sei sicuro di voler concludere la valutazione?",
            YES: "Sì",
            NO: "No"
        });
        $translateProvider.translations('en', {
            PRINT: 'Print',
            PRINT_PDF: 'Download PDF',
            REQUEST_FOR_FUNDING: "Funding request",
            NAME_AND_SURNAME: "Surname and name",
            NAME: "Name",
            SURNAME: "Surname",
            ROLE: "Qualification",
            DEPARTMENT: "Department",
            DEPARTMENT_ORGANIZATION: "Department/Organization",
            ERC_SECTOR: "ERC Sector",
            ERC_SUB_SECTOR: "ERC Sub Sector",
            PUBLICATION: "Publication",
            PARTICIPANT: "Participant",
            NO_COMPONENT: "No components",
            NO_PUBLICATION: "No publications",
            DESCRIPTION: "Description",
            AMOUNT: "Amount",
            BUDGET_ITEM: "Budget item",
            TOTAL: "Total",
            YEAR: "Year",
            FUNDED_PROJECT: "Funded Project",
            ASSIGNED_FUND: "Assigned fund",
            NOT_YET_USED_FUND: "Not yet used fund",
            REASON_FOR_UNUSED_FUND: "Reason for unused fund",
            OTHER_PI: "Other PI",
            REFERENCE_DATABASE: "Reference database",
            NO_OTHER_PI: "No other PI",
            EVALUATE_PROJECT: "Project Evaluation",
            TITLE: "Title",
            RESPONSIBLE: "Principal Investigator",
            TYPE_AND_CLASS: "Type and class",
            LAST_MODIFIED: "Last modified",
            EVALUTATION: "Evaluation",
            MOTIVATION: "Motivation",
            EVAL_COMMENT: "Possible comment",
            EVALUATION_CRITERIA: "Evaluation criteria",
            SAVE_AND_COMPLETE: "Save and Submit",
            SAVE_AS_DRAFT: "Save as draft",
            CLOSE: "Close",
            CONFIRM_EVALUATION_SUBMIT: "By submitting the evaluation, you will no longer be able to change it.",
            CONFIRM_EVALUATION_SUBMIT_QUESTION: "Are you sure you want to submit the evaluation?",
            YES: "Yes",
            NO: "No"
        });

        $translateProvider.preferredLanguage("it");
        $translateProvider.fallbackLanguage("it");
        $translateProvider.useSanitizeValueStrategy("escape");

        // L' oggetto __appConfig sará riempito in base alla 
        // configurazione dello step gulp di 'generate-config'
        window.__appConfig = {
                themeClass: 'theme-unibari',
                logoPath: 'assets/theme/theme-unibari.logo.png'
            }      
    }

})();

angular.module("sigeba").run(["$templateCache", function($templateCache) {$templateCache.put("app/login/login-cert.html","<div class=\"mainLoginContainer\"><div class=\"loginContainer\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1 class=\"referee\">SPHERE</h1><p style=\"margin-bottom: 30px;\">Sistema per la Progettazione, la Gestione dei bandi e l’Etica di Ricerca dell’Ateneo<br>(System for Projects, Handling of Applications, Research Ethics)</p><form class=\"loginForm\"><div><h3 class=\"referee\">Accesso Membri Esterni</h3></div><div class=\"form-group\"><label for=\"username\">Username</label><input type=\"text\" class=\"form-control\" id=\"username\" name=\"username\" ng-model=\"login.username\" ng-disabled=\"login.logging\" placeholder=\"enter username provided by email\"></div><div class=\"form-group\"><label for=\"password\">Password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" ng-model=\"login.password\" ng-disabled=\"login.logging\" placeholder=\"enter password provided by email\"></div><div class=\"form-group\"><div class=\"errorMessages\"><div ng-repeat=\"message in login.errorMessages\">{{message}}</div></div><button type=\"submit\" class=\"btn btn-default\" ng-click=\"login.doLogin()\" ng-disabled=\"login.logging\"><i class=\"fa\" ng-class=\"{\'fa-sign-out\': !login.logging, \'fa-spin fa-spinner\': login.logging}\"></i> Login</button></div></form></div></div>");
$templateCache.put("app/login/login-referee.html","<div class=\"mainLoginContainer\"><div class=\"loginContainer\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1 class=\"referee\">SPHERE</h1><form class=\"loginForm\"><div><h3 class=\"referee\">Referee Access</h3></div><div class=\"form-group\"><label for=\"username\">Username</label><input type=\"text\" class=\"form-control\" id=\"username\" name=\"username\" ng-model=\"login.username\" ng-disabled=\"login.logging\" placeholder=\"enter username provided by email\"></div><div class=\"form-group\"><label for=\"password\">Password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" ng-model=\"login.password\" ng-disabled=\"login.logging\" placeholder=\"enter password provided by email\"></div><div class=\"form-group\"><div class=\"errorMessages\"><div ng-repeat=\"message in login.errorMessages\">{{message}}</div></div><button type=\"submit\" class=\"btn btn-default\" ng-click=\"login.doLogin()\" ng-disabled=\"login.logging\"><i class=\"fa\" ng-class=\"{\'fa-sign-out\': !login.logging, \'fa-spin fa-spinner\': login.logging}\"></i> Login</button></div></form></div></div>");
$templateCache.put("app/login/login.html","<div class=\"mainLoginContainer\"><div class=\"loginContainer\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1 style=\"margin-bottom: 20px;\">SPHERE</h1><p style=\"margin-bottom: 30px;\">Sistema per la Progettazione, la Gestione dei bandi e l\'Etica di Ricerca dell\'Ateneo<br>(System for Projects, Handling of Applications, Research Ethics)</p><form class=\"loginForm\"><div class=\"form-group\"><div class=\"errorMessages\"><div ng-repeat=\"message in login.errorMessages\">{{message}}</div></div><button type=\"button\" class=\"btn btn-default sso-redirect btn-ateneo\" ng-click=\"login.redirectToSSOAteneo()\" ng-disabled=\"login.logging\" tabindex=\"4\">Login</button></div></form></div></div>");
$templateCache.put("app/login-hd/login-hd.html","<div class=\"mainLoginContainer\"><div class=\"loginContainer\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1 style=\"margin-bottom: 20px;\">SPHERE</h1><p style=\"margin-bottom: 30px;\">Sistema per la Progettazione, la Gestione dei bandi e l’Etica di Ricerca dell’Ateneo<br>(System for Projects, Handling of Applications, Research Ethics)</p><form class=\"loginForm\"><div class=\"form-group\"><label for=\"username\">Username</label> <input type=\"text\" class=\"form-control\" id=\"username\" name=\"username\" ng-model=\"login.username\" ng-disabled=\"login.logging\" placeholder=\"email istituzionale (@uniba.it)\" tabindex=\"1\"></div><div class=\"form-group\"><label for=\"password\">Password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" ng-model=\"login.password\" ng-disabled=\"login.logging\" placeholder=\"password\" tabindex=\"2\"></div><div class=\"form-group\"><div class=\"errorMessages\"><div ng-repeat=\"message in login.errorMessages\">{{message}}</div></div><button type=\"submit\" class=\"btn btn-default\" ng-click=\"login.doLogin()\" ng-disabled=\"login.logging\" tabindex=\"3\"><i class=\"fa\" ng-class=\"{\'fa-sign-out\': !login.logging, \'fa-spin fa-spinner\': login.logging}\"></i> Login</button></div></form></div></div>");
$templateCache.put("app/main/main-no-auth.html","<div class=\"mainHeader\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1>SPHERE</h1></div><div class=\"mainContainer noMenu\" ui-view=\"content\" autoscroll=\"\"></div>");
$templateCache.put("app/main/main-no-menu.html","<div class=\"mainHeader\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1>SPHERE</h1><div class=\"logoutArea\"><i class=\"fa fa-user\"></i> {{main.loggedUser.utente.cognome + \' \' + main.loggedUser.utente.nome}}<br><a href=\"\" ng-click=\"main.doLogout()\"><i class=\"fa fa-sign-out\"></i> Logout</a><br></div></div><div class=\"mainContainer noMenu\" ui-view=\"content\" autoscroll=\"\"></div>");
$templateCache.put("app/main/main.html","<div class=\"mainHeader\"><img dynamic-logo=\"\" src=\"assets/images/logo.unibari.png\"><h1>SPHERE</h1><div class=\"logoutArea\"><i class=\"fa fa-user\"></i> {{main.loggedUser.utente.cognome + \' \' + main.loggedUser.utente.nome}}<br><a href=\"\" ng-show=\"main.loggedUser.tokenImpersona != null\" ng-click=\"main.doLogoutImpersona()\"><i class=\"fa fa-eye-slash\"></i> Esci impersona</a> <a href=\"\" ng-show=\"main.loggedUser.tokenImpersona == null\" ng-click=\"main.doLogout()\"><i class=\"fa fa-sign-out\"></i> Logout</a><br></div></div><div class=\"mainMenu\" ui-view=\"rightmenu\"></div><div class=\"mainContainer\" ui-view=\"content\" autoscroll=\"\"></div>");
$templateCache.put("app/main/menu-cert.html","<div><div ng-if=\"main.loggedUser.utente.tipoUtente == \'UFFICIO_CERT\' || main.loggedUser.utente.membroInternoCommissioneCert || main.loggedUser.utente.membroEsternoCommissioneCert || main.loggedUser.utente.presidenteCommissioneCert\"><h4 class=\"menuTitle\">COMMISSIONE VALUTAZIONE</h4><a href=\"\" class=\"menuItem\" ng-class=\"{ active: (\'valutazioneCert\' | includedByState) || (\'propostaCertViewUc\' | includedByState) }\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"valutazioneCert\" uib-tooltip=\"Valutazione Etica\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-check-square-o\"></i>Valutazione</a> <a ng-if=\"main.loggedUser.utente.tipoUtente == \'UFFICIO_CERT\' || main.loggedUser.utente.presidenteCommissioneCert\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"certCommissioni\" uib-tooltip=\"Commissioni\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-users\"></i> Commissioni</a> <a ng-if=\"main.loggedUser.utente.tipoUtente == \'UFFICIO_CERT\' || main.loggedUser.utente.presidenteCommissioneCert\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"seduteCertList\" uib-tooltip=\"Lista Sedute\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-file-o\"></i> Sedute</a> <a ng-if=\"main.loggedUser.utente.tipoUtente == \'UFFICIO_CERT\' || main.loggedUser.utente.presidenteCommissioneCert\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"certImpersona\" uib-tooltip=\"Impersona\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-eye\"></i> Impersona</a></div></div>");
$templateCache.put("app/main/menu-helpdesk.html","<a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"hdHome\" uib-tooltip=\"Home\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-home\"></i> Home</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"hdImpersona\" uib-tooltip=\"Impersona\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-eye\"></i> Impersona</a>");
$templateCache.put("app/main/menu-rad.html","<a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"radHome\" uib-tooltip=\"Home\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-home\"></i> Home</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"radProgetti\" uib-tooltip=\"Archivio Progetti\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-pencil-square-o\"></i> Archivio Progetti</a>");
$templateCache.put("app/main/menu-ufficioricerca.html","<div ng-controller=\"MenuUfficioRicercaController\"><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urHome\" uib-tooltip=\"Home\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-home\"></i> Home</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urCommissioni\" uib-tooltip=\"Commissioni\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-users\"></i> Commissioni</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urDipartimenti\" uib-tooltip=\"Dipartimenti\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-check-circle-o\"></i> Dipartimenti</a> <a ng-if=\"main.terza\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urStrutture\" uib-tooltip=\"Strutture\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-check-circle-o\"></i> Strutture</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urProgetti\" uib-tooltip=\"Archivio Progetti\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-pencil-square-o\"></i> Archivio Progetti</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urStatistiche\" uib-tooltip=\"Statistiche\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-bar-chart\"></i> Statistiche</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urIter\" uib-tooltip=\"Gestione Iter\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-newspaper-o\"></i> Gestione Iter</a><div ng-if=\"main.ufficio || main.terza\" class=\"menuItems\" ng-class=\"{\'showElements\' : status.isGestioneUtentiOpen}\"><div class=\"element itemLabel\"><a href=\"\" class=\"menuItem\" ng-class=\"{\'active\' : status.isGestioneUtentiOpen}\" ui-sref-active=\"active\" tooltip-animation=\"false\" uib-tooltip=\"Gestione Utenti\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" ng-click=\"status.isGestioneUtentiOpen = !status.isGestioneUtentiOpen\" tooltip-append-to-body=\"true\"><i class=\"fa fa-users\"></i> Gestione Utenti <i class=\"fa alignRight\" ng-class=\"{\'fa-caret-up\':status.isGestioneUtentiOpen, \'fa-caret-down\':!status.isGestioneUtentiOpen}\"></i></a></div><div class=\"element\" ng-if=\"main.ufficio || main.terza\"><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urAnagrafica\" uib-tooltip=\"Anagrafica\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-user\"></i> Anagrafica</a></div><div class=\"element\" ng-if=\"main.ufficio\"><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urCaricamentoMassivo\" uib-tooltip=\"Caricamento Massivo\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-upload\"></i> Caricamento Massivo</a></div><div class=\"element\" ng-if=\"main.ufficio\"><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urGestInattivi\" uib-tooltip=\"Gestione Inattivi\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-user-times\"></i> Gestione Inattivi</a></div><div class=\"element\" ng-if=\"main.ufficio\"><a href=\"\" class=\"menuItem\" ng-class=\"{ active: (\'urDettaglioProposte\' | includedByState) || (\'urListDettaglioProp\' | includedByState) }\" tooltip-animation=\"false\" ui-sref=\"urDettaglioProposte\" uib-tooltip=\"Dettaglio Proposte\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-search\"></i> Dettaglio Proposte</a></div></div><div ng-if=\"main.ufficio || main.terza || main.award\" class=\"menuItems\" ng-class=\"{\'showElements\' : status.isGestioneBandiOpen}\"><div class=\"element itemLabel\"><a href=\"\" class=\"menuItem\" ng-class=\"{\'active\' : status.isGestioneBandiOpen}\" ui-sref-active=\"active\" tooltip-animation=\"false\" uib-tooltip=\"Gestione bandi\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" ng-click=\"status.isGestioneBandiOpen = !status.isGestioneBandiOpen\" tooltip-append-to-body=\"true\"><i class=\"fa fa-mortar-board\"></i> Gestione Bandi <i class=\"fa alignRight\" ng-class=\"{\'fa-caret-up\':status.isGestioneBandiOpen, \'fa-caret-down\':!status.isGestioneBandiOpen}\"></i></a></div><div class=\"element\"><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urCreaBando\" uib-tooltip=\"Creazione bando\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-magic\"></i> Creazione bando</a></div><div class=\"element\"><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urBandoView\" uib-tooltip=\"Configurazione bando\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-sliders\"></i> Configurazione bando</a></div></div><a ng-if=\"main.canImpersona && main.helpdesk\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"urImpersona\" uib-tooltip=\"Impersona\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-eye\"></i> Impersona</a></div>");
$templateCache.put("app/main/menu-utente.html","<a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"home\" uib-tooltip=\"Home\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-home\"></i> Home</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"profilo\" uib-tooltip=\"Profilo\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-user\"></i> Profilo<i class=\"fa fa-warning menuIndicator\" ng-if=\"!main.loggedUser.utente.profiloValidato\"></i></a><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" ng-class=\"{ active: (\'listaIstanzeUser\' | includedByState) || (\'propostaCertView\' | includedByState) || (\'propostaCertDetail\' | includedByState) }\" tooltip-animation=\"false\" ui-sref=\"listaIstanzeUser\" uib-tooltip=\"Valutazione Etica CER\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-leaf\"></i> Valutazione Etica CER</a><div ng-if=\"main.loggedUser.utente.membroCommissione\"><div class=\"separator\"></div><h4 class=\"menuTitle\">COMMISSIONE VALUTAZIONE</h4><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"mcValutazione\" uib-tooltip=\"Valutazione\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-check-square-o\"></i> Valutazione</a> <a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"mcStatistiche\" uib-tooltip=\"Statistiche\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-bar-chart\"></i> Statistiche</a></div><div ng-if=\"main.loggedUser.utente.membroInternoCommissioneCert || main.loggedUser.utente.membroEsternoCommissioneCert || main.loggedUser.utente.presidenteCommissioneCert\"><div class=\"separator\"></div><h4 class=\"menuTitle\">COMMISSIONE VALUTAZIONE CER</h4><a href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"mcValutazioneCert\" uib-tooltip=\"Valutazione\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-check-square-o\"></i> Valutazione</a> <a ng-if=\"main.loggedUser.utente.presidenteCommissioneCert\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"certPresCommissioni\" uib-tooltip=\"Commissioni\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-users\"></i> Commissioni</a> <a ng-if=\"main.loggedUser.utente.presidenteCommissioneCert\" href=\"\" class=\"menuItem\" ui-sref-active=\"active\" tooltip-animation=\"false\" ui-sref=\"sedutePresCertList\" uib-tooltip=\"Sedute\" tooltip-class=\"menuItemTooltip\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\" ng-click=\"closeGestioneUtenti()\"><i class=\"fa fa-file-o\"></i> Sedute</a></div>");
$templateCache.put("app/print/print.html","<div class=\"printContainer\"><view-proposta proposta-id=\"viewPropPrint.propostaId\" print=\"true\" is-ur=\"viewPropPrint.isUr\" is-mc=\"viewPropPrint.isMc\" is-rad=\"viewPropPrint.isRad\" is-ref=\"viewPropPrint.isRef\"></view-proposta></div>");
$templateCache.put("app/print/printRend.html","<div class=\"printContainer\"><view-rendicontazione rendicontazione-id=\"viewRendPrint.rendicontazioneId\" print=\"true\" is-ur=\"viewRendPrint.isUr\" is-rad=\"viewRendPrint.isRad\"></view-rendicontazione></div>");
$templateCache.put("app/print/printVal.html","<div class=\"printContainer\"><valuta-proposta valutazione-id=\"viewValPrint.valutazioneId\" print=\"true\" is-ur=\"viewValPrint.isUr\"></valuta-proposta></div>");
$templateCache.put("app/cert/archivio/archivio.html","<lista-istanze></lista-istanze>");
$templateCache.put("app/cert/commissioni/commissioni.html","<lista-commissioni-cert></lista-commissioni-cert>");
$templateCache.put("app/cert/home/home.html","<h1 class=\"page-header\">Home</h1><p class=\"lead\">Benvenuto in SPHERE.</p><p class=\"lead\">Tramite questo sistema puoi controllare e gestire le istanze presentate per CER.</p><p class=\"well\">Per visualizzare tutte le istanze <a href=\"\" ui-sref=\"valutazioneCert\"><i class=\"fa fa-external-link-square\"></i> <b>vai a “Archivio Istanze”</b></a>.</p>");
$templateCache.put("app/cert/listaIstanze/listaIstanze.html","<lista-istanze-user></lista-istanze-user>");
$templateCache.put("app/cert/profilo/profilo.html","<h1 class=\"page-header\">Profilo Utente</h1><profilo-utente></profilo-utente>");
$templateCache.put("app/cert/sedute/sedute.html","<lista-sedute-cert></lista-sedute-cert>");
$templateCache.put("app/components/addInattivo/addInattivo.html","<h1 class=\"page-header\">Nuovo Inattivo</h1><div class=\"spinner\" ng-if=\"inattivoCtrl.loading\"></div><form class=\"inattivoForm\" ng-if=\"!inattivoCtrl.loading\"><div class=\"commissioneAddMembers\"><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca utenti per cognome\" ng-model=\"inattivoCtrl.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"inattivoCtrl.search(inattivoCtrl.selectedCognome)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"inattivoCtrl.selectedCognome.length > 0 && inattivoCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"inattivoCtrl.selectedCognome.length > 0 && inattivoCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti che si sono già collegati al sistema almeno una volta.<br><br>Se non trovi la persona che stai cercando, comunicagli di collegarsi al sistema.</div><div class=\"spinner\" ng-if=\"inattivoCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in inattivoCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.ruolo.descrizione}}</div><div class=\"dipartimento\">{{result.dipartimento.nome}}</div></div><div class=\"addUser\"><input type=\"checkbox\" ng-model=\"result.selected\"></div></div></div></div><span class=\"spanTipologia\">Tipologia</span><div class=\"form-group tipoInattivoSelect\"><ui-select class=\"tipoSelect\" on-select=\"inattivoCtrl.getTipologieInattivi()\" ng-model=\"inattivoCtrl.selectedTipologia\"><ui-select-match><div class=\"item\">{{inattivoCtrl.selectedTipologia.label}}</div></ui-select-match><ui-select-choices repeat=\"tipologia in (inattivoCtrl.tipologieInattivi) track by tipologia.value\"><div ng-bind-html=\"tipologia.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"inattivoCtrl.saveInattivi()\">Salva</button> <button class=\"btn btn-default\" ui-sref=\"urGestInattivi\">Chiudi senza salvare</button></div></form>");
$templateCache.put("app/components/archivioProgetti/archivioProgetti.html","<div class=\"archivioProgetti\"><div><h1 class=\"page-header\">Archivio Progetti <small>{{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getTipologieEProposte()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"form-group tipoClasseSelect\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedTipoClasse\"><ui-select-match><div class=\"group\">{{$select.selected.tipologia}}</div><div class=\"item\">{{$select.selected.classe}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.tipologieEClassi | filter: $select.search) track by item.id\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group areaDipSelect\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedAreaDip\"><ui-select-match><div class=\"group\">{{$select.selected.macroarea}}</div><div class=\"item\">{{$select.selected.dipartimento}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.macroareeEDipartimenti | filter: $select.search) track by item.id\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"vm.getProposte()\" placeholder=\"Cognome Responsabile\"><div><label><input type=\"checkbox\" ng-model=\"vm.under40Filter\" ng-change=\"vm.getProposte()\">Solo Under 40</label></div></div><a href=\"\" class=\"resetFilter\" ng-if=\"vm.isFiltroAttivo()\" ng-click=\"vm.resetFiltri()\">Reset filtri</a></form></div><div class=\"statusFilter\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'BOZZA\'\" ng-disabled=\"vm.gettingList\">In bozza</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'ALL\'\" ng-disabled=\"vm.gettingList\">Tutte le proposte</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'DA_VALUTARE\'\" ng-disabled=\"vm.gettingList\">Da valutare</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'VALUTATE\'\" ng-disabled=\"vm.gettingList\">Valutate</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'FINANZIATE\'\" ng-disabled=\"vm.gettingList\">Finanziate</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'NON_FINANZIATE\'\" ng-disabled=\"vm.gettingList\">Non finanziate</label></div></div></div><div class=\"archivioProgettiContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"hiddenHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th ng-if=\"vm.selectedTipoClasse.label === \'Terza Missione\'\"><div class=\"th-inner\">Struttura</div></th><th><div class=\"th-inner\">Valutazione</div></th><th><div class=\"th-inner\">Fin.&nbsp;rich.</div></th><th><div class=\"th-inner\">Fin.&nbsp;conc.</div></th><th><div class=\"th-inner\">Fin.&nbsp;speso</div></th><th><div class=\"th-inner\">Azioni</div></th></tr><tr class=\"fixedHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th ng-if=\"vm.selectedTipoClasse.label === \'Terza Missione\'\"><div class=\"th-inner\">Struttura</div></th><th><div class=\"th-inner\">Valutazione</div></th><th><div class=\"th-inner\">Fin.&nbsp;rich.</div></th><th><div class=\"th-inner\">Fin.&nbsp;conc.</div></th><th><div class=\"th-inner\">Fin.&nbsp;speso</div></th><th><div class=\"th-inner\">Azioni</div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"vm.proposte == null\"></div><div ng-if=\"vm.proposte != null\"><tr ng-if=\"vm.proposte.length == 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"progettoBox\" ng-repeat=\"proposta in vm.proposte\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{vm.getStatus(proposta.status, proposta.statusValutazioneProposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\"><span ng-repeat=\"componenti in proposta.nComponenti\">{{$index == 0 ? \'\' : \' - \'}}<b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div></td><td><div ng-class=\"{\'striked\': (proposta.titolare != null)}\">{{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}</div><div><span class=\"label label-under\" ng-if=\"proposta.etaAllaDomanda < 40\">Under 40</span> <span class=\"label label-ricercatore\" ng-if=\"proposta.responsabileRicercatore\">Ricercatore</span></div><div class=\"dipartimento\">{{proposta.responsabile.dipartimento.nome}}</div><div class=\"titolare\" ng-if=\"proposta.titolare != null\">{{proposta.titolare.cognome + \' \' + proposta.titolare.nome}}<span>(titolare corrente)</span><div><a href=\"\" class=\"tableButton\" ng-click=\"vm.openStoricoTitolari(proposta)\">storico titolari</a></div></div></td><td ng-if=\"vm.selectedTipoClasse.label === \'Terza Missione\'\">{{ proposta.struttura.descrizione }}</td><td><div ng-if=\"proposta.nonAmmissibile\"><div class=\"refereeAddedMessage\">Non Ammissibile</div></div><div ng-if=\"!proposta.nonAmmissibile && proposta.tipoValutazione != \'ITER_VALUTAZIONE\'\"><div ng-if=\"proposta.valutazioneList.length > 0\" class=\"valBox\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{proposta.media*1 != proposta.media.toFixed(1)*1 ? proposta.media : \'\'}}\"><i ng-if=\"proposta.media == null\" class=\"fa fa-file-text-o\"></i> {{ proposta.media !== null ? (proposta.media === 0 ? \'N/A\' : (proposta.media).toFixed(1)*1) : \'\' }}</div><div class=\"valutatori\"><div ng-repeat=\"valutazione in proposta.valutazioneList\"><span ng-if=\"!valutazione.referee\">{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span> <span ng-if=\"valutazione.referee\">{{valutazione.referee.cognome}} {{valutazione.referee.nome}} <span class=\"valore\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\">{{valutazione.punteggio}}</span></span><div><a class=\"tableButton\" ng-click=\"vm.showValutazione(proposta, valutazione)\" ng-if=\"proposta.classe.refereeAttivi == null\">Visualizza</a></div></div></div></div><div ng-if=\"proposta.valutazioneList.length == 0 && proposta.numeroRefereeAssociati > 0\"><div class=\"refereeAddedMessage\">Referee inseriti</div></div><div ng-if=\"proposta.classe.refereeAttivi > 0 && proposta.status != \'BOZZA\'\"><a class=\"tableButton\" ng-click=\"vm.gestioneReferee(proposta)\">Gestione Referee</a></div></div><div ng-if=\"!proposta.nonAmmissibile && proposta.tipoValutazione == \'ITER_VALUTAZIONE\' && proposta.status != \'BOZZA\'\"><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == true\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><i class=\"fa fa-thumbs-o-down\"></i></div></div><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == false && proposta.numeroRefereeAssociati == 0\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><i class=\"fa fa-thumbs-o-up\"></i></div></div><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == null\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{proposta.media*1 != proposta.media.toFixed(1)*1 ? proposta.media : \'\'}}\"><i ng-if=\"proposta.media == null\" class=\"fa fa-file-text-o\"></i> {{ proposta.media !== null ? (proposta.media === 0 ? \'N/A\' : (proposta.media).toFixed(1)*1) : \'\' }}</div></div><div ng-if=\"(proposta.valutazioneList.length == 0 || proposta.valutazioneRespinta == false) && proposta.numeroRefereeAssociati > 0\"><div class=\"refereeAddedMessage\">Referee inseriti</div></div><a class=\"tableButton\" ng-click=\"vm.openIterValutazione(proposta)\">Iter Valutazione</a></div><a class=\"tableButton indicatori\" ng-if=\"proposta.indicatoriValutazione === true\" ng-click=\"vm.openIndicatoriValutazione(proposta)\"><i class=\"fa fa-table\"></i>Indicatori</a></td><td><div class=\"finBox\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.finanziamentoRichiesto | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.assegnoRichiesto | number}}</div></div></div></td><td><div ng-if=\"proposta.statusValutazioneProposta == \'VALUTATA\' && !proposta.tempoValutazioneConclusa\"><a class=\"tableButton\" ng-click=\"vm.concediFinanziamento(proposta)\">Finanziamento</a></div><div class=\"finBox assegnato\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\'\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.esitoValutazione.finanziamentoAssegnato | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.esitoValutazione.assegnoAssegnato | number}}</div></div><a class=\"tableButton comment\" ng-if=\"proposta.esitoValutazione.commento && proposta.esitoValutazione.commento != \'\'\" ng-click=\"vm.mostraCommentoFinanziamento(proposta.esitoValutazione.commento)\"><i class=\"fa fa-file-text-o\" uib-tooltip=\"Commento\"></i></a></div><div class=\"ultimaModifica\" ng-if=\"(proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\') && proposta.esitoValutazione != null\" ng-init=\"utenteFin = proposta.esitoValutazione.ufficioRicerca ? proposta.esitoValutazione.ufficioRicerca.utente : proposta.esitoValutazione.membroCommissione; timestampFin = proposta.esitoValutazione.updatedTimestamp ? proposta.esitoValutazione.updatedTimestamp : proposta.esitoValutazione.createdTimestamp\"><span>{{utenteFin.cognome}} {{utenteFin.nome}}&nbsp;&nbsp;<i class=\"fa fa-clock-o\" uib-tooltip=\"ultima modifica: {{timestampFin | date: \'medium\'}}\"></i></span></div><div ng-if=\"(proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\') && !proposta.tempoValutazioneConclusa && (proposta.esitoValutazione == null || proposta.esitoValutazione.esitoConcluso !== true)\"><a class=\"tableButton\" ng-click=\"vm.concediFinanziamento(proposta)\">Modifica</a></div></td><td><div class=\"finBox speso\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\'\"><div ng-repeat=\"step in proposta.stepRendicontazione\" ng-if=\"step.rendicontazione !== null\"><div ng-if=\"step.rendicontazione !== null && step.rendicontazione.status === \'BOZZA\'\"><div class=\"bozzaRendicontazione\"><span>BOZZA</span></div><a class=\"tableButton\" ng-click=\"vm.openRendicontazione(step.rendicontazione.id)\">{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</a></div><div ng-if=\"step.rendicontazione !== null && step.rendicontazione.status !== \'BOZZA\'\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{step.rendicontazione.finanziamentoSpeso | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(step.rendicontazione.assegnoSpeso ? step.rendicontazione.assegnoSpeso : 0) | number}}</div><a class=\"tableButton\" ng-click=\"vm.openRendicontazione(step.rendicontazione.id)\">{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</a><div><a ng-if=\"vm.checkForValutabile( step )\" class=\"tableButton\" ng-click=\"vm.openValutazioneConclusiva(proposta, step)\">Valutazione {{step.nome}}</a></div></div></div></div></div></td><td class=\"withButton\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-default dropdown-toggle\" aria-expanded=\"false\" uib-dropdown-toggle=\"\"><i class=\"fa fa-caret-down\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\" ng-click=\"vm.openProposta(proposta.id)\">Visualizza Proposta</a></li><li ng-if=\"proposta.statusValutazioneProposta && !proposta.tempoValutazioneConclusa && (proposta.esitoValutazione == null || proposta.esitoValutazione.esitoConcluso !== true)\"><a href=\"\" ng-click=\"vm.riapriValutazione(proposta.id)\">Riapri Valutazione</a></li><li ng-if=\"proposta.statusValutazioneProposta && !proposta.tempoValutazioneConclusa && proposta.esitoValutazione != null && proposta.esitoValutazione.esitoConcluso === true\"><a href=\"\" ng-click=\"vm.riapriEsito(proposta.id)\">Riapri Esito Fin.</a></li><li ng-if=\"!proposta.statusValutazioneProposta && !proposta.tempoValutazioneConclusa\"><a href=\"\" ng-click=\"vm.dichiaraNonAmmissibile(proposta.id)\">Dichiara come Non Ammissibile</a></li><li ng-if=\"proposta.statusValutazioneProposta === \'FINANZIATA\' && proposta.esitoUfficializzato === true && proposta.tipoCambioTitolare !== \'NESSUNO\'\"><a href=\"\" ng-click=\"vm.cambiaTitolare(proposta)\">Cambia Titolare</a></li><li ng-repeat=\"step in proposta.stepRendicontazione\" ng-if=\"proposta.statusValutazioneProposta === \'FINANZIATA\' && step.rendicontazione !== null && step.rendicontazione.status === \'INVIATA\'\"><a href=\"\" ng-click=\"vm.riapriRendicontazione(step.rendicontazione.id)\">Riporta {{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}} in BOZZA</a></li><li ng-if=\"!proposta.statusValutazioneProposta && proposta.status === \'INVIATA\'\"><a href=\"\" ng-click=\"vm.riapriProposta(proposta.id)\">Riapri Proposta</a></li><li ng-if=\"proposta.id === 1968259\"><a href=\"\" ng-click=\"vm.riapriProposta(proposta.id)\">Riapri Proposta</a></li></ul></div></td></tr></div></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span> <a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta l\'elenco dei progetti secondo il filtro corrente\" ng-href=\"{{vm.getCsvExportUrl()}}\"><i class=\"fa fa-file-o\"></i> Esporta elenco</a><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposte(true)\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/archivioProgettiRad/archivioProgettiRad.html","<div class=\"archivioProgettiRad\"><div><h1 class=\"page-header\">Archivio Progetti <small>{{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getTipologieEProposte()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"form-group tipoClasseSelect\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedTipoClasse\"><ui-select-match><div class=\"group\">{{$select.selected.tipologia}}</div><div class=\"item\">{{$select.selected.classe}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.tipologieEClassi | filter: $select.search) track by item.id\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group areaDipSelect\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedAreaDip\"><ui-select-match><div class=\"group\">{{$select.selected.macroarea}}</div><div class=\"item\">{{$select.selected.dipartimento}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.macroareeEDipartimenti | filter: $select.search) track by item.id\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group areaDipSelect\" ng-if=\"vm.strutture[1]\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedAreaStrut\"><ui-select-match><div class=\"group\">{{$select.selected.label}}</div><div class=\"item\">{{$select.selected.struttura}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.strutture | filter: $select.search) track by item.strutturaId\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"vm.getProposte()\" placeholder=\"Cognome Responsabile\"></div><a href=\"\" class=\"resetFilter\" ng-if=\"vm.isFiltroAttivo()\" ng-click=\"vm.resetFiltri()\">Reset filtri</a></form></div><div class=\"statusFilter\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'FINANZIATE\'\">Finanziate</label></div></div></div><div class=\"archivioProgettiContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"hiddenHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Fin.&nbsp;rich.</div></th><th><div class=\"th-inner\">Fin.&nbsp;conc.</div></th><th><div class=\"th-inner\">Fin.&nbsp;speso</div></th><th><div class=\"th-inner\">Visualizza</div></th></tr><tr class=\"fixedHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Fin.&nbsp;rich.</div></th><th><div class=\"th-inner\">Fin.&nbsp;conc.</div></th><th><div class=\"th-inner\">Fin.&nbsp;speso</div></th><th><div class=\"th-inner\">Visualizza</div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"vm.proposte == null\"></div><div ng-if=\"vm.proposte != null\"><tr ng-if=\"vm.proposte.length == 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"progettoBox\" ng-repeat=\"proposta in vm.proposte\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{vm.getStatus(proposta.status, proposta.statusValutazioneProposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\"><span ng-repeat=\"componenti in proposta.nComponenti\">{{$index == 0 ? \'\' : \' - \'}}<b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div></td><td><div ng-class=\"{\'striked\': (proposta.titolare != null)}\">{{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}</div><div><span class=\"label label-under\" ng-if=\"proposta.etaAllaDomanda < 40\">Under 40</span> <span class=\"label label-ricercatore\" ng-if=\"proposta.responsabileRicercatore\">Ricercatore</span></div><div class=\"dipartimento\">{{proposta.responsabile.dipartimento.nome}}</div><div class=\"titolare\" ng-if=\"proposta.titolare != null\">{{proposta.titolare.cognome + \' \' + proposta.titolare.nome}}<span>(titolare corrente)</span></div></td><td><div class=\"finBox\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.finanziamentoRichiesto | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.assegnoRichiesto | number}}</div></div></div></td><td><div class=\"finBox assegnato\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\'\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.esitoValutazione.finanziamentoAssegnato | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.esitoValutazione.assegnoAssegnato | number}}</div></div></div></td><td><div class=\"finBox speso\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\'\"><div ng-repeat=\"step in proposta.stepRendicontazione\" ng-if=\"step.rendicontazione !== null\"><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{step.rendicontazione.finanziamentoSpeso | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(step.rendicontazione.assegnoSpeso ? step.rendicontazione.assegnoSpeso : 0) | number}}</div><a class=\"tableButton\" ng-click=\"vm.openRendicontazione(step.rendicontazione.id)\">{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</a></div></div></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></div></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span> <a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta l\'elenco dei progetti secondo il filtro corrente\" ng-href=\"{{vm.getCsvExportUrl()}}\"><i class=\"fa fa-file-o\"></i> Esporta elenco</a><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposte(true)\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/associazioniMembroProposta/associazioniMembroProposta.html","<div class=\"associazioneMemProp\"><h3 class=\"title\">Istanze associate</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!assMemProCtrl.obj\"><div class=\"spinner\"></div></div><div ng-if=\"assMemProCtrl.obj != null\"><table class=\"table\"><thead><tr><th class=\"valueColumn\">Titolo</th><th class=\"valueColumn\">Numero Protocollo</th><th class=\"valueColumn\">Tipologia</th><th class=\"valueColumn\">Stato Istanza</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"assMemProCtrl.obj.length == 0\"><td colspan=\"11\">Nessun istanza associata</td></tr><tr ng-repeat=\"istanza in assMemProCtrl.obj\"><td class=\"valueColumn\">{{istanza.certProposta.titolo}}</td><td class=\"valueColumn\">{{istanza.certProposta.numeroProtocollo}}</td><td class=\"valueColumn\">{{istanza.flag_minor_major}}</td><td class=\"valueColumn\">{{istanza.certProposta.stato.descrizione}}</td></tr></tbody></table></div></div><div><div class=\"paginationBox\"><span class=\"itemNumber\">{{assMemProCtrl.pagination.start}}</span> - <span class=\"itemNumber\">{{assMemProCtrl.pagination.end}}</span> di <span class=\"itemNumber\">{{assMemProCtrl.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"assMemProCtrl.pagination.total\" items-per-page=\"assMemProCtrl.pagination.limit\" ng-model=\"assMemProCtrl.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"assMemProCtrl.getMembroProposte(true)\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/cambiaTitolare/cambiaTitolare.html","<div class=\"cambiaTitolare\"><h3 class=\"title\">Cambia titolare progetto</h3><div class=\"well\"><div class=\"valueRow\"><label>Titolo</label> <span>{{titolareCtrl.proposta.titolo ? titolareCtrl.proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</span></div><div class=\"valueRow\"><label>Responsabile</label> <span>{{titolareCtrl.proposta.responsabile.cognome + \' \' + titolareCtrl.proposta.responsabile.nome}}</span></div><div class=\"valueRow\"><label>Macroarea</label> <span>{{titolareCtrl.proposta.responsabile.dipartimento.macroArea.code}} - {{titolareCtrl.proposta.responsabile.dipartimento.macroArea.nome}}</span></div><div class=\"valueRow\"><label>Dipartimento</label> <span>{{titolareCtrl.proposta.responsabile.dipartimento.nome}}</span></div><div class=\"valueRow\"><label>Tipologia e Classe</label> <span>{{titolareCtrl.proposta.tipologiaProgetto.nome}} - {{titolareCtrl.proposta.classe.nome}}</span></div></div><div class=\"content\"><div class=\"form-group row\"><div class=\"col-sm-12\"><label>Nuovo Titolare</label><div class=\"ricercaNuovoTitolare\"><div ng-if=\"titolareCtrl.nuovoTitolare === null\"><div ng-if=\"titolareCtrl.proposta.tipoCambioTitolare === \'COMPONENTE\'\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"titolareCtrl.results.length == 0\">nessun risultato</div><div class=\"spinner\" ng-if=\"titolareCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in titolareCtrl.componenti\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.ruolo.descrizione}}</div><div class=\"altreInfo\">Data di nascita: {{result.utente.dataDiNascita}} - Email: {{result.utente.email}}</div><div class=\"dipartimento\">{{result.utente.dipartimento.nome}}</div></div><div class=\"addUser\" ng-class=\"{\'disabled\': !result.ammissibile, \'selected\': ((titolareCtrl.proposta.titolare !== null && result.utente.id === titolareCtrl.proposta.titolare.id) || (titolareCtrl.proposta.titolare === null && result.utente.id === titolareCtrl.proposta.responsabile.id))}\"><div class=\"notAvailable\" ng-if=\"!result.ammissibile\">Non ammissibile</div><div class=\"alreadyRequested\" ng-if=\"titolareCtrl.proposta.titolare !== null && result.utente.id === titolareCtrl.proposta.titolare.id && result.utente.id !== titolareCtrl.proposta.responsabile.id\"><i class=\"fa fa-check\"></i><div>Titolare corrente</div></div><div class=\"alreadyRequested\" ng-if=\"(titolareCtrl.proposta.titolare === null || result.utente.id === titolareCtrl.proposta.titolare.id) && result.utente.id === titolareCtrl.proposta.responsabile.id\"><i class=\"fa fa-check\"></i><div>Titolare corrente (proponente)</div></div><a href=\"\" ng-click=\"titolareCtrl.selectTitolare(result.utente)\" ng-if=\"result.ammissibile && !((titolareCtrl.proposta.titolare !== null && result.utente.id === titolareCtrl.proposta.titolare.id) || (titolareCtrl.proposta.titolare === null && result.utente.id === titolareCtrl.proposta.responsabile.id))\"><i class=\"fa fa-square-o\"></i></a><div class=\"proponente\" ng-if=\"titolareCtrl.proposta.titolare !== null && result.utente.id !== titolareCtrl.proposta.titolare.id && result.utente.id === titolareCtrl.proposta.responsabile.id\"><div>(proponente)</div></div></div></div></div></div><div ng-if=\"titolareCtrl.proposta.tipoCambioTitolare === \'STRUTTURATO\'\"><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"titolareCtrl.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"titolareCtrl.search(titolareCtrl.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"titolareCtrl.searchText.length > 0 && titolareCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"titolareCtrl.searchText.length > 0 && titolareCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti che si sono già collegati al sistema almeno una volta.<br><br>Se non trovi la persona che stai cercando comunicagli di collegarsi al sistema.</div><div class=\"spinner\" ng-if=\"titolareCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in titolareCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.ruolo.descrizione}}</div><div class=\"altreInfo\">Data di nascita: {{result.utente.dataDiNascita}} - Email: {{result.utente.email}}</div><div class=\"dipartimento\">{{result.utente.dipartimento.nome}}</div></div><div class=\"addUser\" ng-class=\"{\'disabled\': !result.ammissibile, \'selected\': ((titolareCtrl.proposta.titolare !== null && result.utente.id === titolareCtrl.proposta.titolare.id) || (titolareCtrl.proposta.titolare === null && result.utente.id === titolareCtrl.proposta.responsabile.id))}\"><div class=\"notAvailable\" ng-if=\"!result.ammissibile\">Non ammissibile</div><div class=\"alreadyRequested\" ng-if=\"titolareCtrl.proposta.titolare !== null && result.utente.id === titolareCtrl.proposta.titolare.id && result.utente.id !== titolareCtrl.proposta.responsabile.id\"><i class=\"fa fa-check\"></i><div>Titolare corrente</div></div><div class=\"alreadyRequested\" ng-if=\"(titolareCtrl.proposta.titolare === null || result.utente.id === titolareCtrl.proposta.titolare.id) && result.utente.id === titolareCtrl.proposta.responsabile.id\"><i class=\"fa fa-check\"></i><div>Titolare corrente (proponente)</div></div><a href=\"\" ng-click=\"titolareCtrl.selectTitolare(result.utente)\" ng-if=\"result.ammissibile && !((titolareCtrl.proposta.titolare !== null && result.utente.id === titolareCtrl.proposta.titolare.id) || (titolareCtrl.proposta.titolare === null && result.utente.id === titolareCtrl.proposta.responsabile.id))\"><i class=\"fa fa-square-o\"></i></a><div class=\"proponente\" ng-if=\"titolareCtrl.proposta.titolare !== null && result.utente.id !== titolareCtrl.proposta.titolare.id && result.utente.id === titolareCtrl.proposta.responsabile.id\"><div>(proponente)</div></div></div></div></div></div></div><div ng-if=\"titolareCtrl.nuovoTitolare != null\"><div class=\"resultsContainerAuto well\"><div class=\"userResult\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{titolareCtrl.nuovoTitolare.cognome}} {{titolareCtrl.nuovoTitolare.nome}}</div><div class=\"ruolo\">{{titolareCtrl.nuovoTitolare.ruolo.descrizione}}</div><div class=\"altreInfo\">Data di nascita: {{titolareCtrl.nuovoTitolare.dataDiNascita}} - Email: {{titolareCtrl.nuovoTitolare.email}}</div><div class=\"dipartimento\">{{titolareCtrl.nuovoTitolare.dipartimento.nome}}</div></div><div style=\"text-align: center;\"><a href=\"\" ng-click=\"titolareCtrl.resetTitolare()\"><i class=\"fa fa-times\"></i></a></div></div></div></div></div></div></div><div class=\"form-group row\"><div class=\"col-sm-12\"><label for=\"motivazioneCambio\">Motivazione Cambio</label> <textarea class=\"form-control\" rows=\"5\" id=\"motivazioneCambio\" maxlength=\"4000\" ng-model=\"titolareCtrl.modelCambio.motivazioneCambio\"></textarea></div></div><div class=\"form-group row fileUpload\"><label class=\"col-sm-12\">Allegato PDF</label><div class=\"col-sm-12\"><label class=\"btn btn-primary\" ladda=\"titolareCtrl.loadingFile\" ng-if=\"titolareCtrl.modelCambio.allegato == null\"><i class=\"fa fa-upload btn-icon\"></i>Seleziona File <input type=\"file\" accept=\"application/pdf\" ng-disabled=\"titolareCtrl.loadingFile\" onchange=\"angular.element(this).scope().titolareCtrl.uploadFile(this.files); angular.element(this).scope().$apply();\"></label><div class=\"upload-error\" ng-if=\"titolareCtrl.uploadError != null\">{{titolareCtrl.uploadError}}</div><div class=\"btn-group\" ng-if=\"titolareCtrl.modelCambio.allegato != null\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{titolareCtrl.getFileHref(titolareCtrl.modelCambio.allegato)}}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{titolareCtrl.modelCambio.allegato.nome}}</a> <a class=\"btn btn-danger btn-toggle\" href=\"\" ng-click=\"titolareCtrl.removeFile()\"><i class=\"fa fa-times\"></i></a></div></div></div><br></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" ng-click=\"titolareCtrl.salvaModificaTitolare()\" class=\"ngdialog-button ngdialog-button-primary\" ng-class=\"{\'ng-button-invalid\': (titolareCtrl.modelCambio.titolareId === null || titolareCtrl.modelCambio.motivazioneCambio === null || titolareCtrl.modelCambio.motivazioneCambio === \'\')}\" ng-disabled=\"concediFinCtrl.saveLoading || titolareCtrl.modelCambio.titolareId === null || titolareCtrl.modelCambio.motivazioneCambio === null || titolareCtrl.modelCambio.motivazioneCambio === \'\'\">Salva</button> <button type=\"button\" ng-click=\"titolareCtrl.chiudi()\" class=\"ngdialog-button ngdialog-button-secondary\">Annulla</button></div>");
$templateCache.put("app/components/caricamentoMassivo/caricamentoMassivo.html","<div class=\"caricamentoMassivo\"><div><h1 class=\"page-header\">Caricamento Massivo</h1><div class=\"row\"><div class=\"col-md-2 h-100 pt-5px\"><b>Tipologia template*</b></div><div class=\"form-group col-md-4\"><ui-select class=\"tipoSelect\" on-select=\"caricCtrl.doSmth($select, true)\" ng-model=\"caricCtrl.selectedTipologia1\"><ui-select-match><div class=\"group\">{{$select.selected.value}}</div></ui-select-match><ui-select-choices repeat=\"tipologia in (caricCtrl.tipologiaOpts) track by tipologia.value\"><div ng-bind-html=\"tipologia.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"row\"><div ng-if=\"caricCtrl.selectedTipologia1.key == 1 || caricCtrl.selectedTipologia1.key == 4\"><div class=\"col-md-2 h-100 pt-5px\"><b>Tipologia*</b></div><div class=\"form-group col-md-4\"><ui-select class=\"tipoClasseSelect\" on-select=\"caricCtrl.doSmth($select, false)\" ng-model=\"caricCtrl.selectedTipologia2\"><ui-select-match><div class=\"group\">{{$select.selected.value}}</div></ui-select-match><ui-select-choices repeat=\"tipologia in (caricCtrl.selectedTipologia1 && caricCtrl.selectedTipologia1.key == 1 ? caricCtrl.optGov : caricCtrl.optInact) track by tipologia.value\"><div ng-bind-html=\"tipologia.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-2 h-100 pt-5px\"><b>Anno*</b></div><div class=\"form-group col-md-4 h-100 pt-5px\"><ui-select class=\"tipoSelect\" ng-model=\"caricCtrl.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (caricCtrl.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select><small class=\"text-danger\" ng-if=\"caricCtrl.showError && !caricCtrl.anno\">Seleziona un anno</small></div></div><div class=\"row\"><div class=\"form-group col-md-2\"><a target=\"_new\" class=\"btn btn-primary w-100\" ng-href=\"{{caricCtrl.downloadTemplate()}}\" ng-disabled=\"(caricCtrl.selectedTipologia1.key === 0 || vm.selectedAnno === null)\" ladda=\"vm.loading\" ng-if=\"vm.model == null\">Download Template</a></div><div class=\"form-group col-md-2\"><label class=\"btn btn-primary w-100\" for=\"fileUpload\" ng-class=\"{ \'disabled\': caricCtrl.loadingFile || (caricCtrl.selectedTipologia1.key === 0 || caricCtrl.selectedAnno === null) || (caricCtrl.selectedTipologia1.key === 1 && caricCtrl.selectedTipologia2 === null) || (caricCtrl.selectedTipologi)}\">Upload file</label> <input id=\"fileUpload\" type=\"file\" style=\"visibility: hidden\" accept=\"application/xlsx\" ng-disabled=\"caricCtrl.loadingFile || (caricCtrl.selectedTipologia1.key === 0 || vm.selectedAnno === null) || (caricCtrl.selectedTipologia1.key === 1 && caricCtrl.selectedTipologia2 === null) || (caricCtrl.selectedTipologia1.key === 4 && caricCtrl.selectedTipologia2 === null)\" onchange=\"angular.element(this).scope().caricCtrl.uploadXlsx(this.files); angular.element(this).scope().$apply();\"></div><div class=\"upload-error\" ng-if=\"caricCtrl.vm.uploadError != null\">{{caricCtrl.vm.uploadError}}</div><div class=\"btn-group\" ng-if=\"caricCtrl.vm.model != null\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{caricCtrl.vm.getFileHref(vm.model)}}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{caricCtrl.vm.model.nome}}</a> <a class=\"btn btn-danger btn-toggle\" href=\"\" ng-click=\"caricCtrl.vm.removeFile()\"><i class=\"fa fa-times\"></i></a></div></div><div class=\"row\" style=\"margin-top: -5px; color: #822433;\"><div class=\"col-md-12\">I campi con * sono obbligatori</div></div><div class=\"spinner\" ng-if=\"caricCtrl.tableIsLoading\"></div><div class=\"fixTableHead\"><table class=\"table table-responsive mt-15px\" ng-if=\"!caricCtrl.tableIsLoading\"><thead><tr><th class=\"text-center font-weight-bold\">Tipo</th><th class=\"text-center font-weight-bold\">Nome file</th><th class=\"text-center font-weight-bold\">Data caricamento</th><th class=\"text-center font-weight-bold\">Download</th></tr></thead><tr ng-repeat=\"massivo in caricCtrl.massivi\"><td class=\"text-center\">{{massivo.nomeThumb ? massivo.nomeThumb : \'\'}}</td><td class=\"text-center\">{{massivo.nome ? massivo.nome : \'\'}}</td><td class=\"text-center\">{{massivo.lastUpd | date}}</td><td class=\"text-center\"><a target=\"_new\" ng-href=\"{{caricCtrl.downloadSpecifiedFile(massivo.id)}}\" class=\"btn btn-primary\"><i class=\"fa fa-download\"></i></a></td></tr></table></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{caricCtrl.pagination.start}}</span> - <span class=\"itemNumber\">{{caricCtrl.pagination.end}}</span> di <span class=\"itemNumber\">{{caricCtrl.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"caricCtrl.pagination.total\" items-per-page=\"caricCtrl.pagination.limit\" ng-model=\"caricCtrl.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"caricCtrl.getMassivo()\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/certAssociaCommissione/certAssociaCommissione.html","<h1 class=\"page-header\">{{vm.pageHeader}}</h1><div class=\"spinner\" ng-if=\"vm.loading\"></div><form class=\"certCommissioneForm\" ng-if=\"!vm.loading\"><div class=\"form-group\"><label>Nome Commissione</label> <input disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.data.nome\"></div><div class=\"archivioProgettiContainer\"><div><div><table class=\"table peopleTable\"><thead><tr class=\"fixedHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Feed</div></th><th><div class=\"th-inner\">Commissione</div></th><th><div class=\"th-inner\" style=\"transform: translateX(-6px)\"></div></th><th><div class=\"th-inner\" style=\"transform: translateX(-6px)\"></div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"vm.proposte == null\"></div><div ng-if=\"vm.proposte != null\"><tr ng-if=\"vm.proposte.length == 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"progettoBox\" ng-repeat=\"proposta in vm.proposte\" ng-class=\"vm.getStatusClass(proposta.stato.codice)\"><td class=\"status\"><input type=\"checkbox\" ng-model=\"proposta.seleziona\" ng-checked=\"vm.ifChecked(proposta.id)\" ng-click=\"vm.insertRemoveProposta(proposta.id, proposta.titolo)\"></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td><div class=\"titolare\">{{proposta.utenteProponente.cognome}} {{proposta.utenteProponente.nome}}</div><div class=\"dipartimento\">{{proposta.utenteProponente.dipartimento}}</div></td><td class=\"withButton\"><button ng-if=\"proposta.stato.id != \'1\'\" type=\"button\" uib-tooltip=\"Feed Compilati\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openFeedCompilati(proposta.id)\" style=\"margin-left: 5px;\"><i class=\"fa fa-list-alt\"></i></button></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Membri commissione per tipologia\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openCommissioneTipologia(proposta.membroProposta)\" style=\"margin-left: 5px;\"><i class=\"fa fa-users\"></i></button></td><td></td><td class=\"withButton\"></td></tr></div></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposte(true)\"></uib-pagination></div></div><div class=\"form-group\"><label>Presidente</label><table class=\"table peopleTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.data.presidente == null\"><td colspan=\"5\">Nessun presidente</td></tr><tr ng-if=\"vm.data.presidente != null\"><td class=\"nameColumn\">{{vm.data.presidente.cognome}} {{vm.data.presidente.nome}}</td></tr></tbody></table></div><div class=\"form-group\"><label>Membri della Commissione</label><table class=\"table peopleTable\"><thead><tr><th></th><th class=\"nameColumn\">Cognome e Nome</th><th class=\"roleColumn\"></th><th class=\"depColumn\"></th><th class=\"areaColumn\"></th><th class=\"actionColumn\">Tipologia</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.data.membri.length == 0\"><td colspan=\"6\">Nessun membro</td></tr><tr ng-repeat=\"membro in vm.data.membri\"><td class=\"numberColumn\"></td><td class=\"nameColumn\">{{membro.cognome}} {{membro.nome}}<p ng-if=\"!membro.isInterno\">(Esperto Esterno)</p></td><td class=\"roleColumn\"></td><td class=\"istanzeLink\"><a ng-click=\"vm.openIstanzeAssociate(membro.id)\">Lista Istanze associate</a></td><td class=\"areaColumn\"></td><td><span class=\"selezioneControl\"><ui-select class=\"selezioneSelect\" ng-model=\"membro.flag\"><ui-select-match placeholder=\"Seleziona tipologia\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in (vm.flags| filter: $select.search)\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></span></td></tr></tbody></table></div><button ng-if=\"vm.valid\" class=\"btn btn-primary\" ng-click=\"vm.saveCommissione()\">Salva associazione</button> <button class=\"btn btn-default\" ui-sref=\"certCommissioni\">Chiudi senza salvare</button></form>");
$templateCache.put("app/components/commissioneTipologiaCert/commissioneTipologiaCert.html","<div class=\"commissioneTipologiaCert\"><h3 class=\"title\">Membri commissione per tipologia</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!comTipCeCtrl.membri\"><div class=\"spinner\"></div></div><div ng-if=\"comTipCeCtrl.membri != null\"><div><h4 class=\"title\">Relatore 1</h4></div><table class=\"table\"><thead><tr><th class=\"valueColumn\">Nome e Cognome</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"comTipCeCtrl.listaMinor.length == 0\"><td colspan=\"11\">Nessun membro</td></tr><tr ng-repeat=\"membro in comTipCeCtrl.listaMinor\"><td class=\"valueColumn\">{{membro.certMembroCommissione.nome}} {{membro.certMembroCommissione.cognome}}</td></tr></tbody></table><div><h4 class=\"title\">Relatore 2</h4></div><table class=\"table\"><thead><tr><th class=\"valueColumn\">Nome e Cognome</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"comTipCeCtrl.listaMajor.length == 0\"><td colspan=\"11\">Nessun membro</td></tr><tr ng-repeat=\"membro in comTipCeCtrl.listaMajor\"><td class=\"valueColumn\">{{membro.certMembroCommissione.nome}} {{membro.certMembroCommissione.cognome}}</td></tr></tbody></table><div><h4 class=\"title\">Esperti Esterni</h4></div><table class=\"table\"><thead><tr><th class=\"valueColumn\">Nome e Cognome</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"comTipCeCtrl.listaEsterni.length == 0\"><td colspan=\"11\">Nessun membro</td></tr><tr ng-repeat=\"membro in comTipCeCtrl.listaEsterni\"><td class=\"valueColumn\">{{membro.certMembroCommissione.nome}} {{membro.certMembroCommissione.cognome}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/concediFinanziamento/concediFinanziamento.html","<form name=\"concediFinCtrl.condeciFinForm\" novalidate=\"\"><div class=\"concediFinanziamento\"><h3 class=\"title\">Finanziamento</h3><div class=\"well\"><div class=\"valueRow\"><label>Titolo</label> <span>{{concediFinCtrl.proposta.titolo ? concediFinCtrl.proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</span></div><div class=\"valueRow\"><label>Responsabile</label> <span>{{concediFinCtrl.proposta.responsabile.cognome + \' \' + concediFinCtrl.proposta.responsabile.nome}}</span></div><div class=\"valueRow\"><label>Macroarea</label> <span>{{concediFinCtrl.proposta.responsabile.dipartimento.macroArea.code}} - {{concediFinCtrl.proposta.responsabile.dipartimento.macroArea.nome}}</span></div><div class=\"valueRow\"><label>Dipartimento</label> <span>{{concediFinCtrl.proposta.responsabile.dipartimento.nome}}</span></div><div class=\"valueRow\"><label>Tipologia e Classe</label> <span>{{concediFinCtrl.proposta.tipologiaProgetto.nome}} - {{concediFinCtrl.proposta.classe.nome}}</span></div><div class=\"divider\"></div><div class=\"valueRow punteggio\" ng-if=\"concediFinCtrl.proposta.media != null\"><label ng-if=\"concediFinCtrl.proposta.classe.refereeAttivi > 0\">Punteggio medio</label> <label ng-if=\"concediFinCtrl.proposta.classe.refereeAttivi == null\">Punteggio</label> <span>{{concediFinCtrl.proposta.media}} {{(concediFinCtrl.proposta.sogliaFinanziabilita != null && concediFinCtrl.proposta.mediaSogliaFinanziabilita!=null)?(\'(di cui calcolato: \'+concediFinCtrl.proposta.mediaSogliaFinanziabilita+\')\'):\'\'}}</span></div><div class=\"valueRow\" ng-if=\"concediFinCtrl.proposta.sogliaFinanziabilita != null\"><label>Soglia Finanziabilità</label> <span>{{concediFinCtrl.proposta.sogliaFinanziabilita}}</span></div><div class=\"valueRow punteggio\" ng-if=\"concediFinCtrl.proposta.nonAmmissibile == true\"><label>Giudizio</label> <span>Non Ammissibile</span></div><div ng-if=\"!concediFinCtrl.proposta.nonAmmissibile\"><div class=\"valueRow punteggio\" ng-if=\"concediFinCtrl.proposta.valutazioneRespinta == true\"><label>Giudizio</label> <span>Non ammessa a valutazione successiva</span></div><div class=\"valueRow punteggio\" ng-if=\"concediFinCtrl.proposta.valutazioneRespinta != true && concediFinCtrl.proposta.media == null\"><label>Giudizio</label> <span>{{concediFinCtrl.proposta.valutazioneList[0].motivazione}}&nbsp;</span></div></div></div><div class=\"content\"><div class=\"loading\" ng-if=\"!concediFinCtrl.esito\"><div class=\"spinner\"></div></div><div class=\"form-group row\" ng-if=\"concediFinCtrl.esito\"><div class=\"col-sm-12\" ng-if=\"concediFinCtrl.isFinanziamentoInibito()\"><p class=\"alert alert-warning\" style=\"text-align: center;\">Il punteggio assegnato non permette la finanziabilità del progetto.</p></div><div class=\"col-sm-12 concediRadio\"><div class=\"question\">Vuoi concedere il finanziamento?</div><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"concediFinCtrl.concesso\" ng-value=\"true\" ng-required=\"concediFinCtrl.concesso == null\" ng-disabled=\"concediFinCtrl.isFinanziamentoInibito()\"> Sì</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"concediFinCtrl.concesso\" ng-change=\"concediFinCtrl.rifiutaFinanziamento()\" ng-value=\"false\" ng-required=\"concediFinCtrl.concesso == null\"> No</label></div><div class=\"finanziamentoBox\" ng-if=\"concediFinCtrl.concesso\"><div class=\"col-sm-6\"><label for=\"finConcesso\">Finanziamento richiesto</label><div class=\"well\">{{concediFinCtrl.proposta.finanziamentoRichiesto}}</div></div><div class=\"col-sm-6 form-group\" ng-class=\"{\'has-error\' : concediFinCtrl.condeciFinForm.finConcesso.$invalid && concediFinCtrl.condeciFinForm.finConcesso.$dirty}\"><label for=\"finConcesso\">Finanziamento concesso</label> <input type=\"text\" class=\"form-control\" id=\"finConcesso\" name=\"finConcesso\" max=\"concediFinCtrl.proposta.finanziamentoRichiesto\" ng-model=\"concediFinCtrl.esito.finanziamentoAssegnato\" placeholder=\"Importo\" integer-field-parser=\"\" required=\"\"></div><div class=\"assegnoBox\" ng-if=\"concediFinCtrl.proposta.assegnoRichiesto > 0\"><div class=\"col-sm-6\"><label for=\"finConcesso\">Assegno richiesto</label><div class=\"well\">{{concediFinCtrl.proposta.assegnoRichiesto}}</div></div><div class=\"col-sm-6 form-group\"><label for=\"finConcesso\">Assegno concesso</label><div><ui-select search-enabled=\"false\" ng-model=\"concediFinCtrl.assegniConcessi\" on-select=\"concediFinCtrl.calcolaImportoAssegno()\"><ui-select-match>{{$select.selected * concediFinCtrl.assegnoSingolo}}</ui-select-match><ui-select-choices repeat=\"(item, $index) in concediFinCtrl.assegniDisponibili\">{{$index * concediFinCtrl.assegnoSingolo}}</ui-select-choices></ui-select></div></div><div class=\"col-sm-12\"><div class=\"totalRow\">TOTALE: <span class=\"punteggioValue\">{{concediFinCtrl.esito.finanziamentoAssegnato + concediFinCtrl.esito.assegnoAssegnato | number: 0}}</span></div></div></div></div><div class=\"col-sm-12 commentoBox\" ng-if=\"concediFinCtrl.concesso != null\"><label for=\"comment\">Commento</label> <textarea class=\"form-control\" rows=\"4\" id=\"comment\" ng-model=\"concediFinCtrl.esito.commento\"></textarea></div></div></div><div class=\"ultimaModifica\" ng-if=\"concediFinCtrl.esito.createdTimestamp || concediFinCtrl.esito.updatedTimestamp\" ng-init=\"utente = concediFinCtrl.esito.ufficioRicerca ? concediFinCtrl.esito.ufficioRicerca.utente : concediFinCtrl.esito.membroCommissione; timestamp = concediFinCtrl.esito.updatedTimestamp ? concediFinCtrl.esito.updatedTimestamp : concediFinCtrl.esito.createdTimestamp\">Ultima modifica: <span class=\"membroCommissione\">{{utente.cognome}} {{utente.nome}} - {{timestamp | date: \'medium\'}}</span></div></div><div class=\"ngdialog-buttons\" ng-if=\"concediFinCtrl.esito\"><button type=\"button\" ng-click=\"concediFinCtrl.concludiEsitoFinanziamento()\" class=\"ngdialog-button ngdialog-button-primary\" ng-class=\"{\'ng-button-invalid\': concediFinCtrl.condeciFinForm.$invalid}\" ng-if=\"!concediFinCtrl.draftOnly\" ng-disabled=\"concediFinCtrl.saveLoading || concediFinCtrl.condeciFinForm.$invalid\">Salva e concludi</button> <button type=\"button\" ng-click=\"concediFinCtrl.salvaEsitoFinanziamento()\" class=\"ngdialog-button ngdialog-button-primary\" ng-class=\"{\'ng-button-invalid\': concediFinCtrl.condeciFinForm.$invalid}\" ng-disabled=\"concediFinCtrl.saveLoading || concediFinCtrl.condeciFinForm.$invalid\">Salva</button></div></form>");
$templateCache.put("app/components/configuraBando/configuraBando.html","<div class=\"configuraBando\"><div ng-if=\"confCtrl.bandoId && confCtrl.bandoId.length > 0\"><h1 class=\"page-header ng-scope\" ng-if=\"!createController.isCreate\">Configurazione bando</h1><div class=\"bandoContainer panel panel-default mt-30px\"><div class=\"panel-heading\"><b>Bando:</b> <input class=\"form-control\" ng-model=\"confCtrl.bando.nome\" type=\"text\" maxlength=\"2048\"><br><p class=\"periodoValidita\"><span style=\"font-weight: bold\">Inizio compilazione:</span> <label class=\"fieldWithIcon\" for=\"dataInizioCompilazioneBando\" ng-if=\"confCtrl.bando.startTimestamp\"><input class=\"form-control\" id=\"dataInizioCompilazioneBando\" name=\"dataInizio\" ng-model=\"confCtrl.bando.startTimestamp | date:\'dd/MM/yyyy HH:mm\'\" non-future=\"false\" readonly=\"true\" single-date=\"true\" type=\"text\"></label> <label class=\"fieldWithIcon\" for=\"dataInizioCompilazioneTipologia\" ng-if=\"confCtrl.bando.tipologiaProgetti[0].startTimestamp\"><input class=\"form-control\" id=\"dataInizioCompilazioneTipologia\" name=\"dataInizio\" ng-model=\"confCtrl.bando.tipologiaProgetti[0].startTimestamp | date:\'dd/MM/yyyy HH:mm\'\" non-future=\"false\" readonly=\"true\" single-date=\"true\" type=\"text\"></label> <span style=\"margin-top: 10px; font-weight: bold;\">Scadenza compilazione:</span> <label class=\"fieldWithIcon\" for=\"dataFineCompilazioneBando\" ng-if=\"confCtrl.bando.startTimestamp\"><input class=\"form-control\" id=\"dataFineCompilazioneBando\" name=\"dataFine\" ng-model=\"confCtrl.bando.endTimestamp | date:\'dd/MM/yyyy HH:mm\'\" non-future=\"false\" readonly=\"true\" single-date=\"true\" type=\"text\"></label> <label class=\"fieldWithIcon\" for=\"dataFineCompilazioneTipologia\" ng-if=\"confCtrl.bando.tipologiaProgetti[0].startTimestamp\"><input class=\"form-control\" id=\"dataFineCompilazioneTipologia\" name=\"dataFine\" ng-model=\"confCtrl.bando.tipologiaProgetti[0].endTimestamp | date:\'dd/MM/yyyy HH:mm\'\" non-future=\"false\" readonly=\"true\" single-date=\"true\" type=\"text\"></label></p></div><div class=\"panel-body\"><div class=\"bs-callout bs-callout-sapienza\" ng-repeat=\"tipologia in confCtrl.bando.tipologiaProgetti\"><b>Tipologia progetto:</b> <input class=\"form-control\" ng-if=\"tipologia.nome\" ng-model=\"tipologia.nome\" type=\"text\" maxlength=\"2048\"> <span ng-if=\"tipologia.id === 5 && tipologia.nome == \'Attrezzature Scientifiche\'\" style=\"font-size: 16px; color: red; margin-left: 50px;\">Scadenza compilazione: <b>20/05/2016 14:00</b></span><li ng-repeat=\"classe in tipologia.classi\" style=\"list-style-type: none; margin-top: 15px\"><hr><b>Nome classe:</b> <input class=\"form-control\" ng-model=\"classe.nome\" style=\"margin-bottom: 20px;\" type=\"text\"> <b>Descrizione classe:</b><textarea class=\"textAreaCriteri form-control\" rows=\"3\" maxlength=\"2048\" ng-model=\"classe.descrizione\"></textarea><table class=\"table table-hover\" style=\"display: flex; margin-top: 20px;\"><tr><th ng-repeat=\"attributo in confCtrl.getProjectDetails(classe.attributi)\"><b>{{ attributo.descrizione }}</b></th><th ng-repeat=\"voce in confCtrl.getParam(classe.rendicontoVoce)\"><b>{{voce.descrizione}}</b></th></tr><tr><td ng-repeat=\"attributo in confCtrl.getProjectDetails(classe.attributi)\"><input class=\"form-control\" ng-model=\"attributo.valore\" type=\"text\"></td><td ng-repeat=\"voce in confCtrl.getParam(classe.rendicontoVoce)\"><input class=\"form-control\" ng-model=\"voce.importo\" type=\"text\"></td></tr></table><div class=\"row\" style=\"border-width: thin;border-style: solid;margin: 0px;border-color: lightgray;\"><div class=\"criteriValPanel\"><label class=\"col-sm-12\" style=\"font-size: larger; margin-top: 5px;\">Criteri Valutazione <a href=\"\" id=\"visualizzaCriteriValDiv{{classe.id.toString()}}\" ng-click=\"confCtrl.showDetail(classe.id)\" style=\"padding-left: 10px; font-size: medium;\"><i class=\"fa fa-plus\"></i>Visualizza</a></label><div class=\"col-sm-12\"><div id=\"criteriValDiv{{classe.id.toString()}}\" style=\"display: none\"><div class=\"row\" style=\"flex-direction: row; display: flex; justify-content: right; padding-right: 20px; padding-bottom: 20px;\"><a ng-click=\"confCtrl.showDetail(classe.id)\"><i class=\"fa fa-close\" style=\"cursor: pointer;\"></i></a></div><div class=\"row\"><div ng-if=\"classe.faseValutazione && classe.faseValutazione.length > 0\"><div class=\"faseContainer\" ng-repeat=\"fase in classe.faseValutazione\"><div class=\"col-sm-12\"><div class=\"row\" style=\"margin-left: 5px;margin-top: 30px;\"><h4 style=\"font-size: medium;\">{{fase.fase}}. {{fase.nome}}</h4></div></div><div><div class=\"col-sm-12\"><div class=\"row\" style=\"border-bottom-style: solid;border-width: thin;border-color: lightgray;\"><div class=\"col-sm-10\"><div class=\"row\" style=\"display: flex;flex-direction: row;justify-content: center;\"><b>Criterio</b></div></div><div class=\"col-sm-2\"><div class=\"row\" style=\"display: flex;flex-direction: row;justify-content: center;\"><b>Valore</b></div></div></div></div><div class=\"criterioPanel\" ng-repeat=\"criterio in fase.criterioValutazioneList\"><div class=\"col-sm-12\"><div class=\"row\" style=\"margin-top: 10px; padding-bottom: 10px; border-bottom-style: solid;border-width: thin;border-color: lightgray;\"><div class=\"col-sm-10\"><div class=\"row\" style=\"margin-left: 2px;\"><div class=\"descrizioneBox\"><textarea class=\"textAreaCriteri form-control\" rows=\"3\" ng-model=\"criterio.descrizione\"></textarea></div></div></div><div class=\"col-sm-2\"><div class=\"row\" style=\"display: flex;flex-direction: row;justify-content: center;\"><div ng-if=\"criterio.valoreList.length > 0\"><div class=\"inputBox\" ng-if=\"criterio.tipo == \'MEDIA_REFEREE_MODIFICABILE\' && criterio.valoreList[0].valore == null && criterio.valoreList[0].valoreTrue === null\"><div class=\"row\"><div>Min: <b>{{criterio.valoreList[0].minimo}}</b> Max: <b>{{criterio.valoreList[0].massimo}}</b></div></div></div><div ng-if=\"!criterio.tipo && criterio.valoreList[0].valore != null\"><div ng-repeat=\"elem in criterio.valoreList\">{{elem.valore}} - {{elem.descrizione}}</div></div><div ng-if=\"!criterio.tipo && criterio.valoreList[0].valore == null && criterio.valoreList[0].valoreTrue !== null\"><div class=\"booleanDiv\">Sì/No</div></div><div class=\"inputBox\" ng-if=\"!criterio.tipo && criterio.valoreList[0].valore == null && criterio.valoreList[0].valoreTrue === null\"><div class=\"row\"><div>Min: <b>{{criterio.valoreList[0].minimo}}</b> Max: <b>{{criterio.valoreList[0].massimo}}</b></div></div></div></div></div></div></div></div></div></div></div></div><div ng-if=\"classe.criteriValutazione && classe.criteriValutazione.length > 0\"><div class=\"classeCriteriContainer\"><div class=\"col-sm-12\"><div class=\"row\" style=\"border-bottom-style: solid;border-width: thin;border-color: lightgray;\"><div class=\"col-sm-10\"><div class=\"row\" style=\"display: flex;flex-direction: row;justify-content: center;\"><b>Criterio</b></div></div><div class=\"col-sm-2\"><div class=\"row\" style=\"display: flex;flex-direction: row;justify-content: center;\"><b>Valore</b></div></div></div></div><div class=\"criterioPanel\" ng-repeat=\"criterio in classe.criteriValutazione\"><div class=\"col-sm-12\"><div class=\"row\" style=\"margin-top: 10px; padding-bottom: 10px; border-bottom-style: solid;border-width: thin;border-color: lightgray;\"><div class=\"col-sm-10\"><div class=\"row\" style=\"margin-left: 2px;\"><div class=\"descrizioneBox\"><textarea class=\"textAreaCriteri form-control\" rows=\"2\" ng-model=\"criterio.descrizione\"></textarea></div></div></div><div class=\"col-sm-2\"><div class=\"row\" style=\"display: flex;flex-direction: row;justify-content: center;\"><div ng-if=\"criterio.valoreList.length > 0\"><div class=\"inputBox\" ng-if=\"criterio.tipo == \'MEDIA_REFEREE_MODIFICABILE\' && criterio.valoreList[0].valore == null && criterio.valoreList[0].valoreTrue === null\"><div class=\"row\"><div>Min: <b>{{criterio.valoreList[0].minimo}}</b> Max: <b>{{criterio.valoreList[0].massimo}}</b></div></div></div><div ng-if=\"!criterio.tipo && criterio.valoreList[0].valore != null\"><div ng-repeat=\"elem in criterio.valoreList\">{{elem.valore}} - {{elem.descrizione}}</div></div><div ng-if=\"!criterio.tipo && criterio.valoreList[0].valore == null && criterio.valoreList[0].valoreTrue !== null\"><div class=\"booleanDiv\">Sì/No</div></div><div class=\"inputBox\" ng-if=\"!criterio.tipo && criterio.valoreList[0].valore == null && criterio.valoreList[0].valoreTrue === null\"><div class=\"row\"><div>Min: <b>{{criterio.valoreList[0].minimo}}</b> Max: <b>{{criterio.valoreList[0].massimo}}</b></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"row\" style=\"border-width: thin;border-style: solid;margin: 0px;border-color: lightgray; margin-top: 10px;\"><div class=\"vociSpesaPanel\"><label class=\"col-sm-12\" style=\"font-size: larger; margin-top: 5px;\">Voci di spesa <a href=\"\" id=\"visualizzaVociSpesaDiv{{classe.id.toString()}}\" ng-click=\"confCtrl.showDetailVociSpesa(classe.id)\" style=\"padding-left: 10px; font-size: medium;\"><i class=\"fa fa-plus\"></i>Visualizza</a></label><div class=\"col-sm-12\"><div id=\"vociSpesaDiv{{classe.id.toString()}}\" style=\"display: none\"><div class=\"row\" style=\"flex-direction: row; display: flex; justify-content: right; padding-right: 20px; padding-bottom: 20px;\"><a ng-click=\"confCtrl.showDetailVociSpesa(classe.id)\"><i class=\"fa fa-close\" style=\"cursor: pointer;\"></i></a></div><div class=\"row\"><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"expenseColumn\" style=\"text-align: center;\">{{\"BUDGET_ITEM\" | translate}}</th><th class=\"valueColumn\" style=\"text-align: center;\">{{\"AMOUNT\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"voce in classe.rendicontoVoce\" ng-if=\"voce.tipoImporto != \'IMPORTO_FISSO\'\"><td class=\"expenseColumn\"><textarea class=\"textAreaCriteri form-control\" rows=\"3\" ng-model=\"voce.descrizione\"></textarea></td><td class=\"valueColumn\"><div style=\"text-align: center;\">Min: <b ng-if=\"voce.min\">{{voce.min | currency}}</b> <b ng-if=\"!voce.min\">-</b> Max: <b ng-if=\"voce.min\">{{voce.max | currency}}</b> <b ng-if=\"!voce.max\">-</b></div></td></tr></tbody></table></div></div></div></div></div></div></li></div></div></div><div><button class=\"btn btn-primary\" ng-click=\"confCtrl.updateBando()\">Salva</button> <button class=\"btn btn-default\" ui-sref=\"urBandoView\">Chiudi senza salvare</button></div></div><div ng-if=\"!confCtrl.bandoId\">Configura Bando</div></div>");
$templateCache.put("app/components/createCert/createCert.html","<div class=\"createCert\"><form class=\"certProposta\"><div class=\"propostaCertHeader\" fixed-header=\"fixed-header\" container=\".mainContainer\"><h2>Proposta di Ricerca</h2><div class=\"buttonArea\"><button class=\"btn btn-primary\" ng-click=\"formCert.salvaProposta()\" ng-disabled=\"formCert.propostaSalvata || formCert.template == null || formCert.data == null\" ng-if=\"!formCert.propostaSalvata\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i> {{formCert.propostaSalvata ? \'Salvata\' : \'Salva\'}}</button><div class=\"btn-group\" role=\"group\" ng-if=\"formCert.propostaSalvata\"><button class=\"btn btn-success\" ng-disabled=\"formCert.propostaSalvata\" style=\"width: 106px;\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i> {{formCert.propostaSalvata ? \'Salvata\' : \'Salva\'}}</button> <button class=\"btn btn-primary\" ui-sref=\"propostaView({\'id\': formCert.propostaId})\" uib-tooltip=\"Anteprima\" tooltip-placement=\"bottom\" style=\"width: 40px; border-radius: 0px 4px 4px 0px;\"><i class=\"fa fa-file-text-o\"></i></button></div>&nbsp;<i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn\" ng-class=\"{\'btn-default\': formCert.propostaValidata === null, \'btn-success\': formCert.propostaValidata === true, \'btn-danger\': formCert.propostaValidata === false}\" ng-click=\"formCert.validaProposta()\" ng-disabled=\"!formCert.propostaSalvata || formCert.propostaValidata === true\"><i class=\"fa\" style=\"margin-right: 8px;\" ng-class=\"{\'fa-question\': formCert.propostaValidata === null, \'fa-check\': formCert.propostaValidata === true, \'fa-ban\': formCert.propostaValidata === false}\"></i> {{(formCert.propostaValidata === null) ? \'Controlla\' : ((formCert.propostaValidata === true) ? \'Validata\' : \'Con Errori\')}}</button> <i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn btn-default\" ng-click=\"formCert.inviaProposta()\" ng-disabled=\"!formCert.propostaSalvata || !formCert.propostaValidata\"><i class=\"fa fa-sign-out\" style=\"margin-right: 8px;\"></i>Invia domanda</button></div></div><div class=\"spinner\" ng-if=\"formCert.template == null || formCert.data == null\"></div><div class=\"formContainer\" ng-if=\"formCert.template != null && formCert.data != null\"><div class=\"formSideMenu\"><form-index sezioni=\"formCert.template.sezioni\" container=\".mainContainer\"></form-index></div></div></form></div>");
$templateCache.put("app/components/creazioneBandi/creazioneBandi.html","<div class=\"creazioneBandi\"><form class=\"gestioneBandi\" name=\"createController.bandoForm\" novalidate=\"\"><div class=\"spinner\" ng-if=\"createController.isLoading\"></div><div ng-if=\"!createController.isLoading\"><h1 class=\"page-header ng-scope\" ng-if=\"createController.isCreate\">Crea bando</h1><h3 style=\"font-size: 16px; font-weight: bold; margin-bottom: 20px;\" ng-if=\"createController.isCreate\">Dati del nuovo bando:</h3><h1 class=\"page-header ng-scope\" ng-if=\"!createController.isCreate\">Configurazione bando</h1><div class=\"datiBandoDiv\" style=\"margin-bottom: 50px;\" ng-if=\"createController.isCreate\"><div class=\"row\"><div class=\"col-md-2 h-100 pt-5px\"><b>Anno*</b></div><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\' : createController.bandoForm.annoBando.$invalid}\"><input class=\"form-control\" id=\"annoBando\" name=\"annoBando\" ng-model=\"createController.selectedAnnoBando\" placeholder=\"Inserisci Anno\" required=\"\" type=\"number\"></div><div class=\"form-group col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-2 pt-5px\"><b>Data Inizio*</b></div><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\' : createController.bandoForm.dataInizio.$invalid}\"><label class=\"fieldWithIcon\" for=\"dataInizio\"><input class=\"form-control\" date-range-picker=\"\" id=\"dataInizio\" name=\"dataInizio\" required=\"\" ng-model=\"createController.dataInizio\" readonly=\"\" single-date=\"true\" min-date=\"createController.minDate\" type=\"text\"> <i class=\"fa fa-calendar\"></i></label></div><div class=\"col-md-2 pt-5px\" style=\"margin-left: 70px;\"><b>Ora inizio*</b></div><div class=\"form-group col-md-4\" style=\"width: auto;\" ng-class=\"{\'has-error\' : createController.bandoForm.startTime.$invalid}\"><div uib-timepicker=\"\" name=\"startTime\" ng-model=\"createController.startTime\" show-meridian=\"false\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-2 pt-5px\"><b>Data Fine*</b></div><div class=\"form-group col-md-4\"><label class=\"fieldWithIcon\" for=\"dataFine\" ng-class=\"{\'has-error\' : createController.bandoForm.dataFine.$invalid}\"><input class=\"form-control\" date-range-picker=\"\" id=\"dataFine\" name=\"dataFine\" required=\"\" ng-model=\"createController.dataFine\" readonly=\"\" single-date=\"true\" min-date=\"createController.maxDate\" type=\"text\"> <i class=\"fa fa-calendar\"></i></label></div><div class=\"col-md-2 pt-5px\" style=\"margin-left: 70px;\"><b>Ora fine*</b></div><div class=\"form-group col-md-4\" style=\"width: auto;\" ng-class=\"{\'has-error\' : createController.bandoForm.endTime.$invalid}\"><div uib-timepicker=\"\" name=\"endTime\" ng-model=\"createController.endTime\" show-meridian=\"false\" required=\"\"></div></div></div><div class=\"row\" style=\"margin-left: 5px; color: #822433;\">I campi con * sono obbligatori</div></div><div class=\"row background-filters p-5px\" ng-if=\"createController.isCreate\" style=\"display: flex;\"><div class=\"col-md-2\"><h3 style=\"font-size: 16px; font-weight: bold; margin-bottom: 20px;\">Ricerca bando</h3></div><div class=\"col-md-10\" style=\"display: flex;flex-direction: row;\"><div class=\"col-md-1\" style=\"display: flex;flex-direction: row;align-items: center;\"><b>Anno</b></div><div class=\"col-md-2\" style=\"display: flex;flex-direction: row;align-items: center;\"><ui-select class=\"annoSelect w-100\" id=\"annoSelect\" on-select=\"createController.getBandi()\" ng-model=\"createController.selectedAnnoFilter\" ng-change=\"createController.getTipologieProgetto()\"><ui-select-match id=\"annoSelectFilter\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in (createController.anni | filter: $select.search)\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-1\" style=\"display: flex;flex-direction: row;align-items: center;\"><b>Tipo</b></div><div class=\"col-md-8\" style=\"display: flex;flex-direction: row;align-items: center;\"><ui-select class=\"hierarchicalSelect\" on-select=\"createController.getBandi()\" ng-model=\"createController.selectedTipoClasse\" style=\"width: 100%;\"><ui-select-match><div class=\"group\" style=\"margin-top: 8px\">{{$select.selected.nome}}</div></ui-select-match><ui-select-choices repeat=\"item in (createController.tipologieProgetto | filter: $select.search) track by item.id\"><div class=\"group\" ng-bind-html=\"item.nome | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div></div><div class=\"text-center\" ng-if=\"((createController.bandi === null || createController.bandi.length === 0) && createController.isLoading == false)\"><div ng-if=\"createController.isCreate\">Nessun bando per i filtri selezionati</div><div ng-if=\"!createController.isCreate\">Nessun bando valido</div></div><div class=\"bandoContainer panel panel-default mt-30px\" ng-if=\"createController.isLoading === false && createController.bandi.length > 0\" ng-repeat=\"bando in createController.bandi\"><div class=\"panel-heading\"><h3 class=\"panel-title\">{{bando.nome}} <button class=\"btn btn-light btn-sapienza\" ng-click=\"createController.saveBando(bando)\" ng-disabled=\"createController.bandoForm.$invalid\">{{createController.isCreate ? \'Duplica\' : \'Modifica\'}}</button></h3></div><div class=\"panel-body\"><p ng-if=\"bando.descrizione\">{{bando.descrizione}}</p><div class=\"bs-callout bs-callout-sapienza\" ng-repeat=\"tipologia in bando.tipologiaProgetti\"><h4>{{tipologia.nome}} <span style=\"font-size: 16px; color: red; margin-left: 50px;\" ng-if=\"tipologia.id === 5 && tipologia.nome == \'Attrezzature Scientifiche\'\">Scadenza compilazione: <b>20/05/2016 14:00</b></span></h4><p ng-if=\"tipologia.descrizione\">{{tipologia.descrizione}}</p><p class=\"periodoValidita\" ng-if=\"bando.startTimestamp\"><span>Inizio compilazione:</span>{{bando.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}}<br><span>Scadenza compilazione:</span>{{bando.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</p><p class=\"periodoValidita\" ng-if=\"tipologia.startTimestamp\"><span>Inizio compilazione:</span>{{tipologia.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}}<br><span>Scadenza compilazione:</span>{{tipologia.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</p><ul><li ng-repeat=\"classe in tipologia.classi\"><span><b>{{classe.nome}}</b> - {{classe.descrizione}}</span><div id=\"dettagli{{bando.id.toString() + classe.id.toString()}}\"><table class=\"table table-hover\"><tr><th ng-repeat=\"attributo in createController.getProjectDetails(classe.attributi)\"><b>{{ attributo.descrizione }}</b></th><th ng-repeat=\"voce in createController.getParam(classe.rendicontoVoce)\"><b>{{voce.descrizione}}</b></th></tr><tr><td ng-repeat=\"attributo in createController.getProjectDetails(classe.attributi)\">{{attributo.descrizione.indexOf(\'Importo\') != -1 ? (attributo.valore | currency) : attributo.valore }}</td><td ng-repeat=\"voce in createController.getParam(classe.rendicontoVoce)\">{{ voce.importo | currency }}</td></tr></table></div></li></ul></div></div></div></form></div>");
$templateCache.put("app/components/dettagliEsito/dettagliEsito.html","<div class=\"dettagliEsito\"><h3 class=\"title\">Dettagli Valutazione</h3><div class=\"content\"><div ng-if=\"dettEsitoCtrl.proposta != null && dettEsitoCtrl.proposta.esito != null && dettEsitoCtrl.proposta.esito.fasiValutazione != null\"><div class=\"faseContainer\" ng-repeat=\"fase in dettEsitoCtrl.proposta.esito.fasiValutazione\"><h4>{{fase.fase}}. {{fase.nome}}</h4><div class=\"faseContent\" ng-if=\"fase.valutazioneList != null && fase.valutazioneList.length > 0\"><div class=\"valutatori\" ng-if=\"fase.tipo == \'REFEREE_PARZIALE\'\"><div class=\"valRow\" ng-repeat=\"valutazione in fase.valutazioneList\">Referee {{$index + 1}} <span class=\"valore\">{{valutazione.punteggio}}<a class=\"tableButton scheda\" ng-click=\"dettEsitoCtrl.showValutazione(dettEsitoCtrl.proposta, valutazione)\">scheda</a></span></div></div><div ng-if=\"fase.tipo == \'COMMISSIONE\'\"><div class=\"valutazioneBox\" ng-repeat=\"valutazione in fase.valutazioneList\"><div class=\"punteggio\" uib-tooltip=\"{{valutazione.punteggio*1 != valutazione.punteggio.toFixed(1)*1 ? valutazione.punteggio : \'\'}}\"><i ng-if=\"valutazione.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{valutazione.punteggio !== null ? (valutazione.punteggio).toFixed(1)*1 : \'\'}}</div><div class=\"valutatori\"><div><a href=\"\" class=\"tableButton\" ng-click=\"dettEsitoCtrl.showValutazione(dettEsitoCtrl.proposta, valutazione)\">Visualizza scheda</a></div></div></div></div><div ng-if=\"fase.tipo == \'CHECK_BLOCCANTE\'\"><div class=\"valutazioneBox\" ng-repeat=\"valutazione in fase.valutazioneList\"><div class=\"punteggio\"><i class=\"fa\" ng-class=\"dettEsitoCtrl.getCheckEvaluationIconClass(valutazione.punteggio)\"></i></div><div class=\"valutatori\"><div><a href=\"\" class=\"tableButton\" ng-click=\"dettEsitoCtrl.showValutazione(dettEsitoCtrl.proposta, valutazione)\">scheda</a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/dettaglioProposte/dettaglioProposte.html","<div class=\"dettaglioProposte\"><div><h1 class=\"page-header\">Dettaglio Proposte</h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"propCtrl.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"propCtrl.getUtenti()\" placeholder=\"Cognome\"></div><a href=\"\" class=\"resetFilter\" ng-if=\"propCtrl.isFiltroAttivo()\" ng-click=\"propCtrl.resetFiltri()\">Reset filtri</a></form></div><div class=\"dettaglioProposteContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"fixedHeader\" ng-if=\"propCtrl.utenti != null\"><th><div class=\"th-inner nomeColumn\">Nome e Cognome</div></th><th><div class=\"th-inner dipartimentoColumn\">Dipartimento</div></th><th><div class=\"th-inner ruoloColumn\">Ruolo</div></th><th><div class=\"th-inner actionColumn\">Dettaglio Proposte</div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"propCtrl.utenti == null\"></div><tr class=\"utenteBox\" ng-repeat=\"user in propCtrl.utenti\"><td class=\"nomeColumn\">{{user.utente.nome}} {{user.utente.cognome}}</td><td class=\"dipartimentoColumn\">{{user.dipartimento.nome}}</td><td class=\"ruoloColumn\">{{user.ruolo.descrizione}}</td><td></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"propCtrl.listDettaglioProp(user.utente)\"><i class=\"btn btn-default fa fa-folder-open\"></i></a></td></tr></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{propCtrl.pagination.start}}</span> - <span class=\"itemNumber\">{{propCtrl.pagination.end}}</span> di <span class=\"itemNumber\">{{propCtrl.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"propCtrl.pagination.total\" items-per-page=\"propCtrl.pagination.limit\" ng-model=\"propCtrl.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"propCtrl.getUtenti(true)\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/components/editCommissione/commissione-add-members.html","<div class=\"commissioneAddMembers\"><h3>Aggiungi persona</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"commAddMembersCtrl.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"commAddMembersCtrl.search(commAddMembersCtrl.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"commAddMembersCtrl.searchText.length > 0 && commAddMembersCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"commAddMembersCtrl.searchText.length > 0 && commAddMembersCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti che si sono già collegati al sistema almeno una volta.<br><br>Se non trovi la persona che stai cercando comunicagli di collegarsi al sistema.</div><div class=\"spinner\" ng-if=\"commAddMembersCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in commAddMembersCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.ruolo.descrizione}}</div><div class=\"dipartimento\">{{result.utente.dipartimento.nome}}</div></div><div class=\"addUser\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"commAddMembersCtrl.addPerson(result)\" ng-if=\"!result.isAlreadyRequested && !commAddMembersCtrl.maxNumReached()\"><i class=\"fa fa-plus\"></i></a><div class=\"notAvailable\" ng-if=\"!result.isAlreadyRequested && commAddMembersCtrl.maxNumReached()\">Numero massimo raggiunto</div><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>Utente selezionato</div></div></div></div></div></div>");
$templateCache.put("app/components/editCommissione/editCommissione.html","<h1 class=\"page-header\">{{vm.pageHeader}}</h1><div class=\"spinner\" ng-if=\"vm.loading\"></div><form class=\"commissioneForm\" ng-if=\"!vm.loading\"><div class=\"form-group\"><label>Nome Commissione</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.nome\"></div><div class=\"form-group\"><label>Tipologie di Progetto associate</label><div class=\"checkbox\" ng-class=\"{\'disabled alreadyAssociated\': (tipologia.commissioneId != null && tipologia.commissioneId != vm.data.id)}\" ng-repeat=\"tipologia in vm.tipologieProgetto\"><label><input type=\"checkbox\" ng-disabled=\"tipologia.commissioneId != null && tipologia.commissioneId != vm.data.id\" ng-checked=\"vm.containsTipologia(tipologia.id)\" ng-click=\"vm.toggleTipologia(tipologia.id)\"> {{tipologia.nome}}<span ng-if=\"tipologia.commissioneId != null && tipologia.commissioneId != vm.data.id\">(già associata ad un\'altra commissione)</span></label></div></div><div class=\"form-group\"><label>Presidente</label><table class=\"table peopleTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento</th><th class=\"areaColumn\">Macroarea</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.data.presidente == null\"><td colspan=\"5\">Nessun presidente</td></tr><tr ng-if=\"vm.data.presidente != null\"><td class=\"nameColumn\">{{vm.data.presidente.cognome}} {{vm.data.presidente.nome}}</td><td class=\"roleColumn\">{{vm.data.presidente.ruolo.descrizione}}</td><td class=\"depColumn\">{{vm.data.presidente.dipartimento.nome}}</td><td class=\"areaColumn\">{{vm.data.presidente.dipartimento.macroArea.code}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"vm.removePresident()\" ng-if=\"!vm.editDisabled\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"vm.addPerson(vm.data, \'presidente\', 1)\" ng-if=\"vm.data.presidente == null && !vm.editDisabled\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"form-group\"><label>Membri della Commissione</label><table class=\"table peopleTable\"><thead><tr><th></th><th class=\"nameColumn\">Cognome e Nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento</th><th class=\"areaColumn\">Macroarea</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.data.membroCommissioneList.length == 0\"><td colspan=\"6\">Nessun membro</td></tr><tr ng-repeat=\"membro in vm.data.membroCommissioneList\"><td class=\"numberColumn\">{{$index + 1}}</td><td class=\"nameColumn\">{{membro.cognome}} {{membro.nome}}</td><td class=\"roleColumn\">{{membro.ruolo.descrizione}}</td><td class=\"depColumn\">{{membro.dipartimento.nome}}</td><td class=\"areaColumn\">{{membro.dipartimento.macroArea.code}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"vm.removeMember($index)\" ng-if=\"!vm.editDisabled\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"vm.addPerson(vm.data, \'membroCommissioneList\')\" ng-if=\"!vm.editDisabled\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.specializzata\"> <b>Commissione Specializzata</b> (i membri della commissione possono valutare solo i progetti della propria area di afferenza)</label></div></div><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.refereeNascosti\"> <b>Nascondi Referee</b> (i membri della commissione non vedranno i nomi dei referee associati ai progetti)</label></div></div><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.refereeGestitiDaPresidente\"> <b>Referee gestiti dal presidente</b> (i referee possono essere gestiti anche dal presidente della commissione, oltre che dall\'ufficio ricerca)</label></div></div><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"vm.saveCommissione()\" ng-if=\"!vm.editDisabled\">Salva</button> <button class=\"btn btn-default\" ui-sref=\"urCommissioni\">Chiudi senza salvare</button></div></form>");
$templateCache.put("app/components/editDirettoreDipartimento/dipartimento-add-direttore.html","<div class=\"dipartimentoAddDirettore\"><h3>Aggiungi Direttore</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"dipAddDirCtrl.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"dipAddDirCtrl.search(dipAddDirCtrl.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"dipAddDirCtrl.searchText.length > 0 && dipAddDirCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"dipAddDirCtrl.searchText.length > 0 && dipAddDirCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti che si sono già collegati al sistema almeno una volta.<br><br>Se non trovi la persona che stai cercando comunicagli di collegarsi al sistema.</div><div class=\"spinner\" ng-if=\"dipAddDirCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in dipAddDirCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.ruolo.descrizione}}</div><div class=\"dipartimento\">{{result.utente.dipartimento.nome}}</div></div><div class=\"addUser\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"dipAddDirCtrl.addPerson(result)\" ng-if=\"!result.isAlreadyRequested\"><i class=\"fa fa-plus\"></i></a><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>Direttore selezionato</div></div></div></div></div></div>");
$templateCache.put("app/components/editDirettoreDipartimento/editDirettoreDipartimento.html","<div class=\"editDirettoreDipartimento\"><h3>Modifica Direttore Dipartimento</h3><div class=\"spinner\" ng-if=\"editDirDipCtrl.dipartimento == null\"></div><div ng-if=\"editDirDipCtrl.dipartimento != null\"><div class=\"well\"><div class=\"valueRow\"><label>Dipartimento</label> <span>{{editDirDipCtrl.dipartimento.nome}}</span></div></div><div class=\"form-group\"><label>Direttore</label><table class=\"table peopleTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"emailColumn\">Email</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"editDirDipCtrl.dipartimento.direttoreList.length == 0\"><td colspan=\"2\">Nessun direttore associato</td></tr><tr ng-repeat=\"direttore in editDirDipCtrl.dipartimento.direttoreList\"><td class=\"nameColumn\">{{direttore.cognome + \' \' + direttore.nome}}</td><td class=\"emailColumn\">{{direttore.email}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"editDirDipCtrl.removeDirettore($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"editDirDipCtrl.addDirettore(editDirDipCtrl.dipartimento, \'direttoreList\')\"><i class=\"fa fa-plus\"></i> aggiungi</a></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"editDirDipCtrl.cancel(0)\">Annulla</button> <button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"editDirDipCtrl.updateDirettoreDipartimento()\">Salva</button></div>");
$templateCache.put("app/components/editProposta/editProposta.html","<form class=\"editProposta\"><div class=\"propostaHeader\" fixed-header=\"\" container=\".mainContainer\"><h2>Domanda di finanziamento</h2><div class=\"tipologia\">{{form.data.classe.tipologiaProgetto.nome}} - {{form.data.classe.nome}}</div><div class=\"buttonArea\"><button class=\"btn btn-primary\" ng-click=\"form.salvaProposta()\" ng-disabled=\"form.propostaSalvata || form.template == null || form.data == null\" ng-if=\"!form.propostaSalvata\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>{{form.propostaSalvata ? \'Salvata\' : \'Salva\'}}</button><div class=\"btn-group\" role=\"group\" ng-if=\"form.propostaSalvata\"><button class=\"btn btn-success\" ng-disabled=\"form.propostaSalvata\" style=\"width: 106px;\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i>{{form.propostaSalvata ? \'Salvata\' : \'Salva\'}}</button> <button class=\"btn btn-primary\" ui-sref=\"propostaView({\'id\': form.propostaId})\" uib-tooltip=\"Anteprima\" tooltip-placement=\"bottom\" style=\"width: 40px; border-radius: 0px 4px 4px 0px;\"><i class=\"fa fa-file-text-o\"></i></button></div>&nbsp;<i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn\" ng-class=\"{\'btn-default\': form.propostaValidata === null, \'btn-success\': form.propostaValidata === true, \'btn-danger\': form.propostaValidata === false}\" ng-click=\"form.validaProposta()\" ng-disabled=\"!form.propostaSalvata || form.propostaValidata === true\"><i class=\"fa\" style=\"margin-right: 8px;\" ng-class=\"{\'fa-question\': form.propostaValidata === null, \'fa-check\': form.propostaValidata === true, \'fa-ban\': form.propostaValidata === false}\"></i>{{(form.propostaValidata === null) ? \'Controlla\' : ((form.propostaValidata === true) ? \'Validata\' : \'Con Errori\')}}</button> <i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn btn-default\" ng-click=\"form.inviaProposta()\" ng-disabled=\"!form.propostaSalvata || !form.propostaValidata\"><i class=\"fa fa-sign-out\" style=\"margin-right: 8px;\"></i>Invia domanda</button></div></div><div class=\"spinner\" ng-if=\"form.template == null || form.data == null\"></div><div class=\"formContainer\" ng-if=\"form.template != null && form.data != null\"><div class=\"formSideMenu\"><form-index sezioni=\"form.template.sezioni\" container=\".mainContainer\"></form-index></div><div class=\"formContent\"><p class=\"alert alert-warning\" style=\"position: relative; top:80px\" ng-if=\"form.template.language === \'en\'\"><b>ATTENZIONE</b> - La domanda di finanziamento deve essere redatta in lingua inglese.</p><p class=\"alert alert-warning\" style=\"position: relative; top:80px\" ng-if=\"form.template.alertMessage\"><b>ATTENZIONE</b> - {{ form.template.alertMessage }}</p><sgb-section ng-repeat=\"sezione in form.template.sezioni\" name=\"{{($index + 1)}}. {{sezione.titolo}}\" id=\"section{{($index + 1)}}\"><div class=\"sgbFieldContainer\" ng-class=\"{\'withErrors\': form.validazione.risultato[campo.model].result === false}\" ng-repeat=\"campo in sezione.campi\"><sgb-textfield ng-if=\"campo.tipo == \'textfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" is-readonly=\"{{campo.isReadonly}}\"></sgb-textfield><sgb-telephone ng-if=\"campo.tipo == \'telephone\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-telephone><sgb-date-field ng-if=\"campo.tipo == \'datefield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\" non-future=\"{{campo.nonFuture}}\"></sgb-date-field><sgb-date-field-indet ng-if=\"campo.tipo == \'datefield-indet\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\" non-future=\"{{campo.nonFuture}}\" indeterminate-description=\"{{campo.indeterminateDescription}}\" indeterminate-value=\"{{campo.indeterminateValue}}\"></sgb-date-field-indet><sgb-date-range-field ng-if=\"campo.tipo == \'date-range-field\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\"></sgb-date-range-field><sgb-number-field ng-if=\"campo.tipo == \'numberfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-number-field><sgb-currency-field ng-if=\"campo.tipo == \'currencyfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-currency-field><sgb-calculated-field ng-if=\"campo.tipo == \'calculatedfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" calc-model=\"form.data\" calc=\"{{campo.calc}}\"></sgb-calculated-field><sgb-textarea ng-if=\"campo.tipo == \'textarea\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-length=\"{{campo.maxLength}}\" num-rows=\"{{campo.numRows}}\"></sgb-textarea><sgb-rich-text ng-if=\"campo.tipo == \'rich-text\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-length=\"{{campo.maxLength}}\"></sgb-rich-text><sgb-keywords ng-if=\"campo.tipo == \'keywords\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-words=\"{{campo.maxWords}}\"></sgb-keywords><sgb-keywords-select ng-if=\"campo.tipo == \'keywords-select\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-words=\"{{campo.maxWords}}\" choices=\"form.dizionari[campo.choices]\" choices-label=\"{{campo.choicesLabel}}\"></sgb-keywords-select><sgb-participants ng-if=\"campo.tipo == \'participants\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" specific-type=\"{{campo.model}}\" proposta-id=\"form.propostaId\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\"></sgb-participants><sgb-participants-manual ng-if=\"campo.tipo == \'participants_manual\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-participants-manual><sgb-progetti-manual ng-if=\"campo.tipo == \'progetti_manual\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\" model=\"form.data[campo.model]\"></sgb-progetti-manual><sgb-linee-tematiche ng-if=\"campo.tipo == \'linee_tematiche\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\" model=\"form.data[campo.model]\"></sgb-linee-tematiche><sgb-publications ng-if=\"campo.tipo == \'publications\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" num-max=\"{{campo.numMax}}\" options=\"campo.options\"></sgb-publications><sgb-publications-part ng-if=\"campo.tipo == \'publications-part\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\"></sgb-publications-part><sgb-complex-field ng-if=\"campo.tipo == \'complex-field\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" info=\"campo.info\"></sgb-complex-field><sgb-file-upload ng-if=\"campo.tipo == \'file-upload\'\" maxfilesize=\"{{campo.maxfilesize}}\" file-template-url=\"{{campo.fileTemplateUrl}}\" file-template-label=\"{{campo.fileTemplateLabel}}\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-file-upload><sgb-file-multiple-upload ng-if=\"campo.tipo == \'file-multiple-upload\'\" filetype=\"{{campo.filetype}}\" file-template-url=\"{{campo.fileTemplateUrl}}\" file-template-label=\"{{campo.fileTemplateLabel}}\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-files=\"{{campo.maxFiles}}\"></sgb-file-multiple-upload><sgb-checkbox ng-if=\"campo.tipo == \'checkbox\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-checkbox><sgb-yes-no-radio ng-if=\"campo.tipo == \'yes-no-radio\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-yes-no-radio><sgb-h-index ng-if=\"campo.tipo == \'h-index\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-h-index><sgb-h-index-part ng-if=\"campo.tipo == \'h-index-part\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-h-index-part><sgb-select ng-if=\"campo.tipo == \'select\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" choices=\"form.dizionari[campo.choices]\" simple=\"campo.simple\" is-required=\"campo.isRequired\"></sgb-select><sgb-select-fields ng-if=\"campo.tipo == \'select-fields\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" choices=\"form.dizionari[campo.choices]\" editable=\"{{campo.editable}}\" num-fields=\"{{campo.numFields}}\"></sgb-select-fields><sgb-budget ng-if=\"campo.tipo == \'budget\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" hide-descriptions=\"{{campo.hideDescriptions}}\" type=\"{{campo.type}}\" model=\"form.data[campo.model]\"></sgb-budget><sgb-last-fundings ng-if=\"campo.tipo == \'last-fundings\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" base-model=\"campo.baseModel\"></sgb-last-fundings><sgb-last-fundings-new ng-if=\"campo.tipo == \'last-fundings-new\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-last-fundings-new><sgb-other-fundings ng-if=\"campo.tipo == \'other-fundings\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-other-fundings><sgb-previous-fundings ng-if=\"campo.tipo == \'previous-fundings\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" type=\"{{campo.type}}\"></sgb-previous-fundings><sgb-previous-fundings-new ng-if=\"campo.tipo == \'previous-fundings-new\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\"></sgb-previous-fundings-new><sgb-previous-fundings-new-no-perc-impegno ng-if=\"campo.tipo == \'previous-fundings-new-no-perc-impegno\'\" label=\"{{campo.label}}\" model=\"form.data[campo.model]\" options=\"campo.options\"></sgb-previous-fundings-new-no-perc-impegno><sgb-research-indicators ng-if=\"campo.tipo == \'research-indicators\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\" auth-required=\"campo.authRequired\"></sgb-research-indicators><sgb-research-indicators-part ng-if=\"campo.tipo == \'research-indicators-part\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\"></sgb-research-indicators-part><sgb-research-indicators-2021 ng-if=\"campo.tipo == \'research-indicators-2021\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\" auth-required=\"campo.authRequired\"></sgb-research-indicators-2021><sgb-indicatori-impatto-sostenibilita ng-if=\"campo.tipo == \'indicatori-impatto-sostenibilita\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-indicatori-impatto-sostenibilita><sgb-js-script ng-if=\"campo.tipo == \'js-script\'\" script=\"{{campo.script}}\" model=\"form.data[campo.model]\"></sgb-js-script><div class=\"form-group row sgbField\" ng-if=\"campo.tipo == \'text-label\'\"><label class=\"col-sm-12\" ng-bind-html=\"campo.text\"></label></div><div class=\"fieldValidationErrors\"><div ng-repeat=\"messaggioErrore in form.validazione.risultato[campo.model].errori\">{{messaggioErrore}}</div></div></div></sgb-section></div></div></form>");
$templateCache.put("app/components/editPropostaCert/editPropostaCert.html","<form class=\"editProposta cert\"><div class=\"propostaHeader\" fixed-header=\"\" container=\".mainContainer\"><div class=\"titles\"><h2>Domanda per la valutazione CER</h2></div><div class=\"buttonArea\"><button class=\"btn btn-primary\" ng-click=\"form.salvaProposta()\" ng-disabled=\"form.formulario == null\" ng-if=\"!form.propostaSalvata\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>{{form.propostaSalvata ? \'Salvata\' : \'Salva\'}}</button><div class=\"btn-group\" role=\"group\" ng-if=\"form.propostaSalvata\"><button class=\"btn btn-success\" ng-disabled=\"form.propostaSalvata\" style=\"width: 106px;\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i>{{form.propostaSalvata ? \'Salvata\' : \'Salva\'}}</button> <button class=\"btn btn-primary\" ng-click=\"form.salvaProposta()\" uib-tooltip=\"Aggiorna\" tooltip-placement=\"bottom\" style=\"width: 40px; border-radius: 0px 4px 4px 0px;\"><i class=\"fa fa-file-text-o\"></i></button></div>&nbsp;<i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn\" ng-class=\"{\'btn-default\': form.propostaValidata === null, \'btn-success\': form.propostaValidata === true, \'btn-danger\': form.propostaValidata === false}\" ng-click=\"form.validaProposta()\" ng-disabled=\"!form.propostaSalvata || form.propostaValidata === true\"><i class=\"fa\" style=\"margin-right: 8px;\" ng-class=\"{\'fa-question\': form.propostaValidata === null, \'fa-check\': form.propostaValidata === true, \'fa-ban\': form.propostaValidata === false}\"></i>{{(form.propostaValidata === null) ? \'Controlla\' : ((form.propostaValidata === true) ? \'Validata\' : \'Controlla\')}}</button> <i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn btn-default\" ng-click=\"form.inviaProposta()\" ng-disabled=\"!form.propostaSalvata || !form.propostaValidata\"><i class=\"fa fa-sign-out\" style=\"margin-right: 8px;\"></i>Invia domanda</button></div></div><div class=\"spinner\" ng-if=\"form.formulario == null || form.loading\"></div><div class=\"formContainer\" ng-if=\"form.formulario != null\" ng-class=\"{\'hide-panel\': form.loading}\"><div class=\"formSideMenu\"><form-index sezioni=\"form.formulario.sezioniFormulario\" container=\".mainContainer\"></form-index></div><div id=\"editFormContainerCert\" class=\"formContent\" style=\"margin-top: 60px\"><div class=\"formSection\" id=\"section{{$index + 1}}\" ng-repeat=\"formItem in form.formulario.sezioniFormulario\"><div class=\"sgbSection\"><div class=\"sgbLegend\" style=\"margin-top: 0; padding-top: 0\">{{$index + 1}}. {{formItem.titolo}}</div><div></div></div><div class=\"atomic-wrapper\"><fpc-recap-display ng-if=\"$index == 0\" model=\"form.readOnlyDisplay\"></fpc-recap-display><fpc-atomic-wrapper model=\"formItem\" esterno=\"form.esterno\"></fpc-atomic-wrapper></div></div></div></div></form>");
$templateCache.put("app/components/editPropostaPartecipante/editPropostaPartecipante.html","<form class=\"editPropostaPartecipante\" name=\"formPart\" novalidate=\"\"><div class=\"propostaHeader\" fixed-header=\"\" container=\".mainContainer\"><h2>Domanda di finanziamento</h2><div class=\"tipologia\">{{form.data.classe.tipologiaProgetto.nome}} - {{form.data.classe.nome}}</div><div class=\"buttonArea\"><button class=\"btn btn-primary\" ng-click=\"form.salvaPropostaPart()\" ng-disabled=\"form.template == null || form.data == null || formPart.$invalid\" ng-if=\"!form.propostaSalvata || formPart.$invalid\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>Salva</button> <button class=\"btn btn-success\" ng-disabled=\"form.propostaSalvata\" ng-if=\"form.propostaSalvata && !formPart.$invalid\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i>Salvata</button><div class=\"overlayDisabledButton\" uib-tooltip=\"Prima di salvare, devi compilare almeno le informazioni obbligatorie.\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" ng-if=\"formPart.$invalid\"></div></div></div><div class=\"spinner\" ng-if=\"form.template == null || form.data == null\"></div><div class=\"formContainer\" ng-if=\"form.template != null && form.data != null\"><div class=\"formSideMenu\"><form-index sezioni=\"form.template.sezioni\" container=\".mainContainer\"></form-index></div><div class=\"formContent\"><sgb-section ng-repeat=\"sezione in form.template.sezioni\" name=\"{{($index + 1)}}. {{sezione.titolo}}\" id=\"section{{($index + 1)}}\"><div ng-repeat=\"campo in sezione.campi\"><sgb-textfield ng-if=\"campo.tipo == \'textfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" is-readonly=\"{{campo.isReadonly}}\"></sgb-textfield><sgb-telephone ng-if=\"campo.tipo == \'telephone\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-telephone><sgb-date-field ng-if=\"campo.tipo == \'datefield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\" non-future=\"{{campo.nonFuture}}\"></sgb-date-field><sgb-date-field-indet ng-if=\"campo.tipo == \'datefield-indet\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\" non-future=\"{{campo.nonFuture}}\" indeterminate-description=\"{{campo.indeterminateDescription}}\" indeterminate-value=\"{{campo.indeterminateValue}}\"></sgb-date-field-indet><sgb-date-range-field ng-if=\"campo.tipo == \'date-range-field\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\"></sgb-date-range-field><sgb-number-field ng-if=\"campo.tipo == \'numberfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-number-field><sgb-calculated-field ng-if=\"campo.tipo == \'calculatedfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" calc-model=\"form.data\" calc=\"{{campo.calc}}\"></sgb-calculated-field><sgb-textarea ng-if=\"campo.tipo == \'textarea\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-length=\"{{campo.maxLength}}\" num-rows=\"{{campo.numRows}}\"></sgb-textarea><sgb-rich-text ng-if=\"campo.tipo == \'rich-text\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-length=\"{{campo.maxLength}}\"></sgb-rich-text><sgb-keywords ng-if=\"campo.tipo == \'keywords\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" max-words=\"{{campo.maxWords}}\"></sgb-keywords><sgb-progetti-manual ng-if=\"campo.tipo == \'progetti_manual\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\" model=\"form.data[campo.model]\"></sgb-progetti-manual><sgb-linee-tematiche ng-if=\"campo.tipo == \'linee_tematiche\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\" model=\"form.data[campo.model]\"></sgb-linee-tematiche><sgb-participants ng-if=\"campo.tipo == \'participants\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" specific-type=\"{{campo.model}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" proposta-id=\"form.propostaId\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\"></sgb-participants><sgb-participants-manual ng-if=\"campo.tipo == \'participants_manual\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-participants-manual><sgb-publications ng-if=\"campo.tipo == \'publications\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" num-max=\"{{campo.numMax}}\" options=\"campo.options\"></sgb-publications><sgb-publications-part ng-if=\"campo.tipo == \'publications-part\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\"></sgb-publications-part><sgb-complex-field ng-if=\"campo.tipo == \'complex-field\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" info=\"campo.info\"></sgb-complex-field><sgb-file-upload ng-if=\"campo.tipo == \'file-upload\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-file-upload><sgb-yes-no-radio ng-if=\"campo.tipo == \'yes-no-radio\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-yes-no-radio><sgb-h-index ng-if=\"campo.tipo == \'h-index\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-h-index><sgb-h-index-part ng-if=\"campo.tipo == \'h-index-part\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\"></sgb-h-index-part><sgb-select ng-if=\"campo.tipo == \'select\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" choices=\"form.dizionari[campo.choices]\" simple=\"campo.simple\" is-required=\"campo.isRequired\"></sgb-select><sgb-research-indicators ng-if=\"campo.tipo == \'research-indicators\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\" auth-required=\"campo.authRequired\"></sgb-research-indicators><sgb-research-indicators-2021 ng-if=\"campo.tipo == \'research-indicators-2021\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" options=\"campo.options\" auth-required=\"campo.authRequired\"></sgb-research-indicators-2021></div></sgb-section></div></div></form>");
$templateCache.put("app/components/editRadDipartimento/dipartimento-add-rad.html","<div class=\"dipartimentoAddRad\"><h3>Aggiungi RAD</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"dipAddRadCtrl.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"dipAddRadCtrl.search(dipAddRadCtrl.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"dipAddRadCtrl.searchText.length > 0 && dipAddRadCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"dipAddRadCtrl.searchText.length > 0 && dipAddRadCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti di tipo RAD.<br><br>Se devi aggiungere un nuovo utente di tipo RAD non presente tra i risultati della ricerca, contatta gli amministratori del sistema.</div><div class=\"spinner\" ng-if=\"dipAddRadCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in dipAddRadCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.tipoUtente}}</div></div><div class=\"addUser\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"dipAddRadCtrl.addPerson(result)\" ng-if=\"!result.isAlreadyRequested\"><i class=\"fa fa-plus\"></i></a><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>RAD selezionato</div></div></div></div></div></div>");
$templateCache.put("app/components/editRadDipartimento/editRadDipartimento.html","<div class=\"editRadDipartimento\"><h3>Modifica RAD Dipartimento</h3><div class=\"spinner\" ng-if=\"editRadDipCtrl.dipartimento == null\"></div><div ng-if=\"editRadDipCtrl.dipartimento != null\"><div class=\"well\"><div class=\"valueRow\"><label>Dipartimento</label> <span>{{editRadDipCtrl.dipartimento.nome}}</span></div></div><div class=\"form-group\"><label>RAD</label><table class=\"table peopleTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"emailColumn\">Email</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"editRadDipCtrl.dipartimento.radList.length == 0\"><td colspan=\"2\">Nessun RAD associato</td></tr><tr ng-repeat=\"rad in editRadDipCtrl.dipartimento.radList\"><td class=\"nameColumn\">{{rad.cognome + \' \' + rad.nome}}</td><td class=\"emailColumn\">{{rad.email}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"editRadDipCtrl.removeRad($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"editRadDipCtrl.addRad(editRadDipCtrl.dipartimento, \'radList\')\"><i class=\"fa fa-plus\"></i> aggiungi</a></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"editRadDipCtrl.cancel(0)\">Annulla</button> <button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"editRadDipCtrl.updateRadDipartimento()\">Salva</button></div>");
$templateCache.put("app/components/editRadStruttura/editRadStruttura.html","<div class=\"editRadStruttura\"><h3>Modifica RAD Struttura</h3><div class=\"spinner\" ng-if=\"editRadStrCtrl.struttura == null\"></div><div ng-if=\"editRadStrCtrl.struttura != null\"><div class=\"well\"><div class=\"valueRow\"><label>Struttura</label> <span>{{editRadStrCtrl.struttura.nome}}</span></div></div><div class=\"form-group\"><label>RAD</label><table class=\"table peopleTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"emailColumn\">Email</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"editRadStrCtrl.struttura.radList.length == 0\"><td colspan=\"2\">Nessun RAD associato</td></tr><tr ng-repeat=\"rad in editRadStrCtrl.struttura.radList\"><td class=\"nameColumn\">{{rad.cognome + \' \' + rad.nome}}</td><td class=\"emailColumn\">{{rad.email}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"editRadStrCtrl.removeRad($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"editRadStrCtrl.addRad(editRadStrCtrl.struttura, \'radList\')\" ng-if=\"editRadStrCtrl.struttura.radList.length == 0\"><i class=\"fa fa-plus\"></i> aggiungi</a> <a href=\"\" ng-click=\"editRadStrCtrl.addRad(editRadStrCtrl.struttura, \'radList\')\" ng-if=\"editRadStrCtrl.struttura.radList.length != 0\"><i class=\"fa fa-plus\"></i> sostituisci</a></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"editRadStrCtrl.cancel(0)\">Annulla</button> <button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"editRadStrCtrl.updateRadStruttura()\">Salva</button></div>");
$templateCache.put("app/components/editRadStruttura/struttura-add-rad.html","<div class=\"strutturaAddRad\"><h3>Aggiungi RAD</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"strAddRadCtrl.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"strAddRadCtrl.search(strAddRadCtrl.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"strAddRadCtrl.searchText.length > 0 && strAddRadCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"strAddRadCtrl.searchText.length > 0 && strAddRadCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti di tipo RAD.<br><br>Se devi aggiungere un nuovo utente di tipo RAD non presente tra i risultati della ricerca, contatta gli amministratori del sistema.</div><div class=\"spinner\" ng-if=\"strAddRadCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in strAddRadCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.tipoUtente}}</div></div><div class=\"addUser\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"strAddRadCtrl.addPerson(result)\" ng-if=\"!result.isAlreadyRequested\"><i class=\"fa fa-plus\"></i></a><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>RAD selezionato</div></div></div></div></div></div>");
$templateCache.put("app/components/editRefereeDipartimento/dipartimento-add-refeere.html","<div class=\"dipartimentoAddReferee\"><h3>Aggiungi Referente Ricerca</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"dipAddDirCtrl.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"dipAddDirCtrl.search(dipAddDirCtrl.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"dipAddDirCtrl.searchText.length > 0 && dipAddDirCtrl.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"dipAddDirCtrl.searchText.length > 0 && dipAddDirCtrl.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti che si sono già collegati al sistema almeno una volta.<br><br>Se non trovi la persona che stai cercando comunicagli di collegarsi al sistema.</div><div class=\"spinner\" ng-if=\"dipAddDirCtrl.searching\"></div><div class=\"userResult\" ng-repeat=\"result in dipAddDirCtrl.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.ruolo.descrizione}}</div><div class=\"dipartimento\">{{result.utente.dipartimento.nome}}</div></div><div class=\"addUser\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"dipAddDirCtrl.addPerson(result)\" ng-if=\"!result.isAlreadyRequested\"><i class=\"fa fa-plus\"></i></a><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>Referente selezionato</div></div></div></div></div></div>");
$templateCache.put("app/components/editRefereeDipartimento/editRefereeDipartimento.html","<div class=\"editRefeereDipartimento\"><h3>Modifica Referente Dipartimento</h3><div class=\"spinner\" ng-if=\"editRefDipCtrl.dipartimento == null\"></div><div ng-if=\"editRefDipCtrl.dipartimento != null\"><div class=\"well\"><div class=\"valueRow\"><label>Dipartimento</label> <span>{{editRefDipCtrl.dipartimento.nome}}</span></div></div><div class=\"form-group\"><label>Referenti Dipartimento</label><table class=\"table peopleTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"emailColumn\">Email</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"editRefDipCtrl.dipartimento.refereeList.length == 0\"><td colspan=\"2\">Nessun referente associato</td></tr><tr ng-repeat=\"referee in editRefDipCtrl.dipartimento.refereeList\"><td class=\"nameColumn\">{{referee.cognome + \' \' + referee.nome}}</td><td class=\"emailColumn\">{{referee.email}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"editRefDipCtrl.removeReferee($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"editRefDipCtrl.addReferee(editRefDipCtrl.dipartimento, \'refereeList\')\"><i class=\"fa fa-plus\"></i> aggiungi</a></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"editRefDipCtrl.cancel(0)\">Annulla</button> <button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"editRefDipCtrl.updateRefereeDipartimento()\">Salva</button></div>");
$templateCache.put("app/components/editRendicontazione/editRendicontazione.html","<form class=\"editRendicontazione\"><div class=\"rendicontazioneHeader\" fixed-header=\"\" container=\".mainContainer\"><h2>{{formRend.template.titolo ? formRend.template.titolo : \'Rendiconto Progetto\'}}</h2><div class=\"tipologia\">{{formRend.data.classe.tipologiaProgetto.nome}} - {{formRend.data.classe.nome}}</div><div class=\"buttonArea\"><button class=\"btn btn-primary\" ng-click=\"formRend.salvaRendicontazione()\" ng-disabled=\"formRend.rendicontazioneSalvata || formRend.template == null || formRend.data == null\" ng-if=\"!formRend.rendicontazioneSalvata\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>{{formRend.rendicontazioneSalvata ? \'Salvata\' : \'Salva\'}}</button><div class=\"btn-group\" role=\"group\" ng-if=\"formRend.rendicontazioneSalvata\"><button class=\"btn btn-success\" ng-disabled=\"formRend.rendicontazioneSalvata\" style=\"width: 106px;\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i>{{formRend.rendicontazioneSalvata ? \'Salvata\' : \'Salva\'}}</button> <button class=\"btn btn-primary\" ui-sref=\"rendicontazioneView({\'id\': formRend.rendicontazioneId})\" uib-tooltip=\"Anteprima\" tooltip-placement=\"bottom\" style=\"width: 40px; border-radius: 0px 4px 4px 0px;\"><i class=\"fa fa-file-text-o\"></i></button></div>&nbsp;<i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn\" ng-class=\"{\'btn-default\': formRend.rendicontazioneValidata === null, \'btn-success\': formRend.rendicontazioneValidata === true, \'btn-danger\': formRend.rendicontazioneValidata === false}\" ng-click=\"formRend.validaRendicontazione()\" ng-disabled=\"!formRend.rendicontazioneSalvata || formRend.rendicontazioneValidata === true\"><i class=\"fa\" style=\"margin-right: 8px;\" ng-class=\"{\'fa-question\': formRend.rendicontazioneValidata === null, \'fa-check\': formRend.rendicontazioneValidata === true, \'fa-ban\': formRend.rendicontazioneValidata === false}\"></i>{{(formRend.rendicontazioneValidata === null) ? \'Controlla\' : ((formRend.rendicontazioneValidata === true) ? \'Validata\' : \'Con Errori\')}}</button> <i class=\"fa fa-caret-right\" style=\"margin: 0px 5px;\"></i> <button class=\"btn btn-default\" ng-click=\"formRend.inviaRendicontazione()\" ng-disabled=\"!formRend.rendicontazioneSalvata || !formRend.rendicontazioneValidata\"><i class=\"fa fa-sign-out\" style=\"margin-right: 8px;\"></i>Invia</button></div></div><div class=\"spinner\" ng-if=\"formRend.template == null || formRend.data == null\"></div><div class=\"formContainer\" ng-if=\"formRend.template != null && formRend.data != null\"><div class=\"formSideMenu\"><form-index sezioni=\"formRend.template.sezioni\" container=\".mainContainer\"></form-index></div><div class=\"formContent\"><sgb-section ng-repeat=\"sezione in formRend.template.sezioni\" name=\"{{($index + 1)}}. {{sezione.titolo}}\" id=\"section{{($index + 1)}}\"><div class=\"sgbFieldContainer\" ng-class=\"{\'withErrors\': formRend.validazione.risultato[campo.model].result === false || formRend.validazione.risultato[campo.modelMotivazione].result === false}\" ng-repeat=\"campo in sezione.campi\"><sgb-textfield ng-if=\"campo.tipo == \'textfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" is-readonly=\"{{campo.isReadonly}}\"></sgb-textfield><sgb-telephone ng-if=\"campo.tipo == \'telephone\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\"></sgb-telephone><sgb-date-field ng-if=\"campo.tipo == \'datefield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\" non-future=\"{{campo.nonFuture}}\"></sgb-date-field><sgb-date-field-indet ng-if=\"campo.tipo == \'datefield-indet\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"form.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\" non-future=\"{{campo.nonFuture}}\" indeterminate-description=\"{{campo.indeterminateDescription}}\" indeterminate-value=\"{{campo.indeterminateValue}}\"></sgb-date-field-indet><sgb-date-range-field ng-if=\"campo.tipo == \'date-range-field\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" min-date=\"{{campo.minDate}}\" max-date=\"{{campo.maxDate}}\"></sgb-date-range-field><sgb-number-field ng-if=\"campo.tipo == \'numberfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\"></sgb-number-field><sgb-calculated-field ng-if=\"campo.tipo == \'calculatedfield\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" calc-model=\"formRend.data\" calc=\"{{campo.calc}}\"></sgb-calculated-field><sgb-textarea ng-if=\"campo.tipo == \'textarea\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" max-length=\"{{campo.maxLength}}\" num-rows=\"{{campo.numRows}}\" is-readonly=\"{{campo.isReadonly}}\"></sgb-textarea><sgb-rich-text ng-if=\"campo.tipo == \'rich-text\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" max-length=\"{{campo.maxLength}}\" full-width=\"{{campo.fullWidth}}\"></sgb-rich-text><sgb-keywords ng-if=\"campo.tipo == \'keywords\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" max-words=\"{{campo.maxWords}}\"></sgb-keywords><sgb-complex-field ng-if=\"campo.tipo == \'complex-field\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" info=\"campo.info\"></sgb-complex-field><sgb-file-upload ng-if=\"campo.tipo == \'file-upload\'\" maxfilesize=\"{{campo.maxfilesize}}\" file-template-url=\"{{campo.fileTemplateUrl}}\" file-template-label=\"{{campo.fileTemplateLabel}}\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\"></sgb-file-upload><sgb-file-multiple-upload ng-if=\"campo.tipo == \'file-multiple-upload\'\" filetype=\"{{campo.filetype}}\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" max-files=\"{{campo.maxFiles}}\"></sgb-file-multiple-upload><sgb-yes-no-radio ng-if=\"campo.tipo == \'yes-no-radio\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\"></sgb-yes-no-radio><sgb-select ng-if=\"campo.tipo == \'select\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" choices=\"formRend.dizionari[campo.choices]\" simple=\"campo.simple\"></sgb-select><sgb-report ng-if=\"campo.tipo == \'report\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" model-motivazione=\"formRend.data[campo.modelMotivazione]\" check-scostamento=\"campo.checkScostamento\"></sgb-report><sgb-v-text ng-if=\"campo.tipo == \'read-only-text\'\" label=\"{{campo.label}}\" model=\"formRend.data[campo.model]\"></sgb-v-text><sgb-participants-rend ng-if=\"campo.tipo == \'participants-rend\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\"></sgb-participants-rend><sgb-participants-manual-rend ng-if=\"campo.tipo == \'participants-manual-rend\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\"></sgb-participants-manual-rend><sgb-publications-rend ng-if=\"campo.tipo == \'publications-rend\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" model=\"formRend.data[campo.model]\" num-max=\"{{campo.numMax}}\"></sgb-publications-rend><div class=\"fieldValidationErrors\" ng-if=\"campo.tipo != \'report\'\"><div ng-repeat=\"messaggioErrore in formRend.validazione.risultato[campo.model].errori\">{{messaggioErrore}}</div></div><div class=\"fieldValidationErrors\" ng-if=\"campo.tipo == \'report\'\"><div ng-repeat=\"messaggioErrore in formRend.validazione.risultato[campo.model].errori\">{{messaggioErrore}}</div><div ng-repeat=\"messaggioErrore in formRend.validazione.risultato[campo.modelMotivazione].errori\">{{messaggioErrore}}</div></div></div></sgb-section></div></div></form>");
$templateCache.put("app/components/editRendicontazioneDate/editRendicontazioneDate.html","<div class=\"editRendicontazioneDate\"><h3>Periodo rendicontazione <span ng-if=\"editRendDateCtrl.rendicontazione.nome != null\">({{editRendDateCtrl.rendicontazione.nome}})</span></h3><form name=\"editRendDateCtrl.periodForm\"><div class=\"well\"><div class=\"well-label\">TIPOLOGIA</div><div class=\"well-content\">{{editRendDateCtrl.classe.nomeTipologia}} - {{editRendDateCtrl.classe.nomeClasse}}</div><div class=\"well-label\" style=\"margin-top: 10px;\">ANNO FINANZIARIO</div><div class=\"well-content\">{{editRendDateCtrl.classe.anno}}</div><div class=\"theo-expiration\" ng-if=\"editRendDateCtrl.classe.dataUfficializzazione != null\">Scadenza teorica: <span class=\"exp-value\">{{editRendDateCtrl.theoExpiration | date:\'dd/MM/yyyy HH:mm\'}}</span></div></div><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group\"><label>Data inizio</label><div class=\"fieldWithIcon\"><input type=\"text\" class=\"form-control\" ng-model=\"editRendDateCtrl.period.since\" readonly=\"\" date-range-picker=\"\" single-date=\"true\" required=\"\"> <i class=\"fa fa-calendar\"></i></div><div uib-timepicker=\"\" ng-model=\"editRendDateCtrl.period.sinceTime\" show-meridian=\"false\" required=\"\"></div></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label>Data scadenza</label><div class=\"fieldWithIcon\"><input type=\"text\" class=\"form-control\" ng-model=\"editRendDateCtrl.period.until\" readonly=\"\" date-range-picker=\"\" single-date=\"true\" required=\"\"> <i class=\"fa fa-calendar\"></i></div><div uib-timepicker=\"\" ng-model=\"editRendDateCtrl.period.untilTime\" show-meridian=\"false\" required=\"\"></div></div></div></div><div class=\"alert alert-danger\" ng-if=\"!editRendDateCtrl.periodForm.$invalid && !editRendDateCtrl.isValidPeriod()\">La scadenza non può essere precedente alla data di inizio!</div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"editRendDateCtrl.close()\">Chiudi</button> <button type=\"button\" ng-disabled=\"editRendDateCtrl.periodForm.$invalid || !editRendDateCtrl.isValidPeriod()\" class=\"ngdialog-button ngdialog-button-primary\" ladda=\"editRendDateCtrl.confirmLoading\" ng-click=\"editRendDateCtrl.confirm()\">Conferma</button></div></form></div>");
$templateCache.put("app/components/editStatusIstanza/editStatusIstanza.html","<h3>Valuta Istanza</h3><div ng-if=\"vm.visibilitaValutazione()\"><p>Seleziona lo stato dell\'istanza:</p><div class=\"status-container\"><label for=\"approvata\" class=\"status-select\"><input id=\"approvata\" type=\"radio\" name=\"valuta-istanza\" ng-value=\"\'APPROVATA\'\" ng-model=\"vm.selectedStatus\"><p>Approvata</p></label> <label for=\"appr_cond\" class=\"status-select\"><input id=\"appr_cond\" type=\"radio\" name=\"valuta-istanza\" ng-value=\"\'APPROVATA_CONDIZIONE\'\" ng-model=\"vm.selectedStatus\"><p>Approvata con condizione</p></label> <label for=\"rev\" class=\"status-select\"><input id=\"rev\" type=\"radio\" name=\"valuta-istanza\" ng-value=\"\'REVISIONE\'\" ng-model=\"vm.selectedStatus\"><p>Necessaria revisione</p></label> <label for=\"rej\" class=\"status-select\"><input id=\"rej\" type=\"radio\" name=\"valuta-istanza\" ng-value=\"\'NON_APPROVATA\'\" ng-model=\"vm.selectedStatus\"><p>Non approvata</p></label></div><div class=\"col\" ng-if=\"vm.selectedStatus && vm.selectedStatus != \'REVISIONE\'\"><hr><p>Data della Seduta</p><div class=\"fieldWithIcon\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.proposta.certSeduta.dataSeduta\" readonly=\"\" disabled=\"\" date-range-picker=\"\" non-future=\"true\" single-date=\"true\"> <i class=\"fa fa-calendar\"></i></div><hr><h4>Indicazioni presenti e votanti (Totale: {{vm.membriPresenti}})</h4><table id=\"membroTable\"><tr ng-repeat=\"membro in vm.membriCommissione\"><th><input disabled=\"\" type=\"checkbox\" ng-model=\"membro.presente\"></th><th style=\"width: 200px\"><h5>{{membro.certMembroCommissione.nome}} {{membro.certMembroCommissione.cognome}}</h5></th></tr></table><hr><div class=\"row\" id=\"votazione\"><div class=\"form-group valueRow\"><label for=\"inFavorevoli\">Favorevoli</label> <span><input class=\"form-control\" id=\"inFavorevoli\" name=\"inFavorevoli\" ng-model=\"vm.favorevoli\" min=\"0\" max=\"{{vm.membriPresenti}}\" placeholder=\"Inserisci Valore\" ng-value=\"vm.favorevoli\" required=\"\" type=\"number\" style=\"width: 300px\"></span></div><div class=\"form-group valueRow\"><label for=\"inAstenuti\">Astenuti</label> <span><input class=\"form-control\" id=\"inAstenuti\" name=\"inAstenuti\" ng-model=\"vm.astenuti\" min=\"0\" placeholder=\"Inserisci Valore\" required=\"\" type=\"number\" style=\"width: 300px\"></span></div><div class=\"form-group valueRow\"><label for=\"inContrari\">Contrari</label> <span><input class=\"form-control\" id=\"inContrari\" name=\"inContrari\" ng-model=\"vm.contrari\" min=\"0\" placeholder=\"Inserisci Valore\" required=\"\" type=\"number\" style=\"width: 300px\"></span></div><div class=\"form-group valueRow\"><label for=\"inTotVotanti\">Votanti</label> <span><input class=\"form-control\" id=\"inTotVotanti\" name=\"inTotVotanti\" ng-value=\"vm.favorevoli + vm.astenuti + vm.contrari\" readonly=\"true\" required=\"\" type=\"number\" style=\"width: 300px\"></span></div></div></div></div><div class=\"notes-container\"><div class=\"row\" ng-if=\"vm.visibilitaValutazione()\"><div class=\"col-md-4\"><label>Numero Delibera:</label></div><div class=\"form-group col-md-12\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.numeroDelibera\"></div></div><p ng-if=\"vm.selectedStatus == \'REVISIONE\'\">Inserisci le note sulla Revisione :</p><p ng-if=\"vm.selectedStatus != \'REVISIONE\'\">Inserisci le note della Discussione Generale :</p><textarea class=\"notes\" name=\"noteValutazione\" ng-model=\"vm.valutationNotes\" maxlength=\"4000\"></textarea><div ng-if=\"!vm.visibilitaValutazione()\"><label><input type=\"checkbox\" ng-model=\"vm.conflittoDiInteressi\"> Mi trovo in una condizione di conflitto di interessi</label></div></div><hr ng-if=\"vm.visibilitaValutazione()\"><div class=\"notes-container\" ng-if=\"vm.visibilitaValutazione() && vm.selectedStatus != \'REVISIONE\'\"><p>Inserisci le note Osservazione dei Componenti :</p><textarea class=\"notes\" name=\"noteComponenti\" ng-model=\"vm.noteComponenti\" maxlength=\"4000\"></textarea></div><hr ng-if=\"vm.visibilitaValutazione()\"><div class=\"notes-container\" ng-if=\"vm.visibilitaValutazione() && vm.selectedStatus != \'REVISIONE\'\"><p>Inserisci le note presidente :</p><textarea class=\"notes\" name=\"notePresidenteCert\" ng-model=\"vm.notePresidenteCert\" maxlength=\"1000\"></textarea></div><hr ng-if=\"vm.visibilitaValutazione()\"><div class=\"notes-container\" ng-if=\"vm.visibilitaValutazione() && (vm.selectedStatus == \'APPROVATA_CONDIZIONE\' || vm.selectedStatus == \'NON_APPROVATA\')\"><p ng-if=\"vm.selectedStatus == \'APPROVATA_CONDIZIONE\'\">Inserisci le note sulle Condizioni di Approvazione :</p><p ng-if=\"vm.selectedStatus == \'NON_APPROVATA\'\">Inserisci le note di Non Approvazione :</p><textarea class=\"notes\" name=\"noteCambioStato\" ng-model=\"vm.noteCambioStato\" maxlength=\"4000\"></textarea></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"vm.handleSuccess(true)\">Conferma</button> <button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"vm.handleClose(0)\">Annulla</button></div>");
$templateCache.put("app/components/editStatusIstanzaNotes/editStatusIstanzaNotes.html","<h3>Riepilogo Stato</h3><div class=\"status-container\"><h4>Stato della richiesta</h4><div class=\"panel panel-default\"><div class=\"panel-body bolder\"><span ng-if=\"vm.item.stato.id == \'2\'\">Approvata</span> <span ng-if=\"vm.item.stato.id == \'3\'\">Approvata con condizione</span> <span ng-if=\"vm.item.stato.id == \'4\'\">Necessaria Revisione</span> <span ng-if=\"vm.item.stato.id == \'5\'\">Non Approvata</span> <span ng-if=\"vm.item.stato.id == \'6\'\">Da Valutare</span></div></div></div><hr><div ng-if=\"vm.item.notaValutazione != null && vm.item.notaValutazione.length > 0\" class=\"notes-container\"><h4>Nota inserita dal valutatore</h4><textarea class=\"notes\" name=\"noteValutazione\" ng-model=\"vm.item.notaValutazione\" disabled=\"disabled\"></textarea></div><hr><div ng-if=\"vm.noteMembri != null && vm.noteMembri.length > 0\" class=\"notes-container\"><h4>Note inserite dai Membri</h4><div ng-repeat=\"membroNota in vm.noteMembri\"><span style=\"font-weight: bold\">{{membroNota.certMembroCommissione.nome}} {{membroNota.certMembroCommissione.cognome}}:</span><br><textarea class=\"notes\" ng-disabled=\"!vm.isPresidente\" name=\"noteValutazione\" ng-model=\"membroNota.note\" ng-change=\"vm.showSaveButton()\"></textarea><br><br></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-primary\" ng-show=\"vm.saveButtonVisible\" ng-click=\"vm.salvaModificaNote()\">Salva</button> <button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"vm.handleClose(0)\">Chiudi</button></div>");
$templateCache.put("app/components/feedCompilatiCert/feedCompilatiCert.html","<div class=\"feedCompilatiCert\"><h3 class=\"title\">Feed compilati</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!feedCompCtrl.feed\"><div class=\"spinner\"></div></div><div ng-if=\"feedCompCtrl.feed != null\"><table class=\"table\"><thead><tr><th class=\"valueColumn\">Feed</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"feedCompCtrl.feed.length==0\"><td colspan=\"11\">Nessun feed compilato</td></tr><tr ng-repeat=\"campo in feedCompCtrl.feed\"><td class=\"valueColumn\">{{campo.titolo}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/form-index/form-index.html","<div class=\"formIndex\"><ol><li ng-repeat=\"sezione in vm.sezioni\" ng-class=\"{\'active\': (vm.currentSection == $index)}\"><a href=\"\" data-section-id=\"{{$index + 1}}\" ui-sref=\"{\'#\': \'section\' + ($index + 1)}\" ui-sref-opts=\"{location: false}\" ng-click=\"vm.goToSection($index)\">{{sezione.titolo}}</a></li></ol></div>");
$templateCache.put("app/components/gestioneAnagrafica/gestioneAnagrafica.html","<div class=\"gestioneAnagrafica\"><div><h1 class=\"page-header\">Anagrafica</h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"anagCtrl.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"anagCtrl.getUtenti()\" placeholder=\"Cognome\"></div><a href=\"\" class=\"resetFilter\" ng-if=\"anagCtrl.isFiltroAttivo()\" ng-click=\"anagCtrl.resetFiltri()\">Reset filtri</a></form></div><div class=\"gestioneAnagraficaContainer\"><div class=\"row btnNewUtente\"><button class=\"btn btn-default\" ui-sref=\"urGestioneUtenteNew\"><i class=\"fa fa-plus\"></i> Nuovo</button></div><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"fixedHeader\" ng-if=\"anagCtrl.utenti != null\"><th><div class=\"th-inner nomeColumn\">Nome e Cognome</div></th><th><div class=\"th-inner dipartimentoColumn\">Dipartimento</div></th><th><div class=\"th-inner ruoloColumn\">Ruolo</div></th><th><div class=\"th-inner actionColumn\">Modifica</div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"anagCtrl.utenti == null\"></div><tr class=\"utenteBox\" ng-repeat=\"user in anagCtrl.utenti\"><td class=\"nomeColumn\">{{ user.utente.nome == null && user.utente.cognome == null ? user.utente.email : user.utente.nome+\" \"+ user.utente.cognome }}</td><td class=\"dipartimentoColumn\">{{user.dipartimento.nome}}</td><td class=\"ruoloColumn\">{{user.ruolo.descrizione}}</td><td></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"anagCtrl.editUtente(user.utente)\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{anagCtrl.pagination.start}}</span> - <span class=\"itemNumber\">{{anagCtrl.pagination.end}}</span> di <span class=\"itemNumber\">{{anagCtrl.pagination.total}}</span> <a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta l\'elenco degli utenti secondo il filtro corrente\" ng-href=\"{{anagCtrl.getCsvExportUrl()}}\"><i class=\"fa fa-file-o\"></i> Esporta elenco</a><uib-pagination class=\"pull-right pagination-sm\" total-items=\"anagCtrl.pagination.total\" items-per-page=\"anagCtrl.pagination.limit\" ng-model=\"anagCtrl.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"anagCtrl.getUtenti(true)\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/components/gestioneInattivi/gestioneInattivi.html","<div class=\"gestioneInattivi\"><div><h1 class=\"page-header\">Gestione Inattivi <small>{{inatCtrl.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"inatCtrl.getInattivi()\" ng-model=\"inatCtrl.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"anno in (inatCtrl.anni | filter: $select.search) track by anno.anno\"><div ng-bind-html=\"anno.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"searchFilter\"><form class=\"form-inline\"><span class=\"spanTipologia\">Tipologia</span><div class=\"form-group tipoInattivoSelect\"><ui-select class=\"tipoSelect\" on-select=\"inatCtrl.getInattivi(false, false)\" ng-model=\"inatCtrl.selectedTipologia\" placeholder=\"Tipologia\"><ui-select-match placeholder=\"Tipologia\"><div class=\"item\">{{inatCtrl.selectedTipologia}}</div></ui-select-match><ui-select-choices repeat=\"tipologia in (inatCtrl.tipologie | filter: $select.search) track by tipologia\"><div ng-bind-html=\"tipologia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"inatCtrl.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"inatCtrl.getInattivi(false, false)\" placeholder=\"Cognome\"></div><a href=\"\" class=\"resetFilter\" ng-if=\"inatCtrl.isFiltroAttivo()\" ng-click=\"inatCtrl.resetFiltri()\">Reset filtri</a></form></div><button class=\"btn btn-default btnNewInattivo\" ui-sref=\"urNewInattivo\" ng-if=\"!inatCtrl.editDisabled\"><i class=\"fa fa-plus\"></i> Nuovo Inattivo</button><div class=\"gestioneInattiviContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"hiddenHeader\"><th><div class=\"th-inner\">Cognome e Nome</div></th><th><div class=\"th-inner\">Tipologia</div></th></tr><tr class=\"fixedHeader\"><th><div class=\"th-inner\">Cognome e Nome</div></th><th><div class=\"th-inner\">Tipologia</div></th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"(inatCtrl.inattiviValidi).length == 0\"><td colspan=\"5\">Nessun risultato trovato</td></tr><tr class=\"inattivoBox\" ng-repeat=\"inattivo in inatCtrl.inattiviValidi\"><td>{{inattivo.persona}}</td><td>{{inattivo.tipologia}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"inatCtrl.eliminaInattivo(inattivo.id); $event.stopPropagation();\" ng-if=\"!inatCtrl.editDisabled\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{inatCtrl.pagination.start}}</span> - <span class=\"itemNumber\">{{inatCtrl.pagination.end}}</span> di <span class=\"itemNumber\">{{inatCtrl.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"inatCtrl.pagination.total\" items-per-page=\"inatCtrl.pagination.limit\" ng-model=\"inatCtrl.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"inatCtrl.getInattivi(true, false)\"></uib-pagination></div><div ng-if=\"(inatCtrl.inattiviNonValidi).length > 0\" class=\"nonValidi\"><br><div><strong>Inattivi eliminati</strong></div><br><table class=\"table table-hover\"><thead><tr class=\"fixedHeader\"><th><div class=\"th-inner\">Cognome e Nome</div></th><th><div class=\"th-inner\">Tipologia</div></th><th><div class=\"th-inner\">Dettaglio</div></th></tr></thead><tbody><tr class=\"inattivoBox\" ng-repeat=\"inattivo in inatCtrl.inattiviNonValidi\"><td>{{inattivo.persona}}</td><td>{{inattivo.tipologia}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"inatCtrl.viewInattivo(inattivo); $event.stopPropagation();\"><i class=\"fa fa-commenting\"></i></a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/gestioneIter/gestioneIter.html","<h1 class=\"page-header\">Gestione Iter <small>{{iterCtrl.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"iterCtrl.getIterBandi()\" ng-model=\"iterCtrl.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (iterCtrl.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"gestioneIter\"><div class=\"spinner\" ng-if=\"iterCtrl.iterBandi == null\"></div><div ng-if=\"iterCtrl.iterBandi != null\"><table class=\"table table-hover\"><thead><tr><th class=\"classeColumn\">Tipologia - Classe</th><th class=\"esitoColumn\">Ufficializzazione</th><th class=\"rendColumn\">Rendicontazione</th><th ng-if=\"iterCtrl.tm\" class=\"ValrendColumn\">Valutazione Rendicontazione</th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"iterCtrl.iterBandi.length == 0\"><td colspan=\"2\">Nessuna classe dimensionale presente</td></tr><tr class=\"tipologiaBox\" ng-repeat=\"classe in iterCtrl.iterBandi\"><td class=\"classeColumn\">{{classe.nomeTipologia}} - {{classe.nomeClasse}}</td><td class=\"esitoColumn\"><div ng-if=\"classe.esitoUfficializzato\"><i class=\"fa fa-check success\"></i><span ng-if=\"classe.dataUfficializzazione != null\">&nbsp;{{classe.dataUfficializzazione}}</span></div><div ng-if=\"!classe.esitoUfficializzato\"><a class=\"tableButton\" ng-click=\"iterCtrl.ufficializzaClasse(classe.idClasse)\">ufficializza esito</a></div></td><td class=\"rendColumn\"><div ng-if=\"classe.esitoUfficializzato\" class=\"stepRow\" ng-repeat=\"step in classe.stepRendicontazione\"><div class=\"stepName\" ng-if=\"step.nome != null\">{{step.nome}}</div><div class=\"stepName\" ng-if=\"step.mesi != null && iterCtrl.tm\">Mesi: {{step.mesi}}</div><div ng-if=\"step.startTimestamp == null && iterCtrl.tm\"><a class=\"tableButton\" ng-click=\"iterCtrl.editDataRendicontazione(step, classe)\">inserisci date</a></div><div ng-if=\"step.startTimestamp != null\"><i class=\"fa fa-calendar\"></i> {{step.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}} <i class=\"fa fa-arrow-right\"></i> {{step.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}<br><a ng-if=\"classe.visibilita != \'TM\'\" class=\"tableButton\" ng-click=\"iterCtrl.editDataRendicontazione(step, classe)\">modifica</a>&nbsp;&nbsp;&nbsp;<a class=\"tableButton\" ng-click=\"iterCtrl.sendMailDateRendicontazione(step.idStep, step.logInvioMail)\">invia mail</a></div></div></td><td ng-if=\"classe.visibilita == \'TM\'\" class=\"ValrendColumn\"><div ng-if=\"classe.esitoUfficializzato\" class=\"stepRow\" ng-repeat=\"step in classe.stepRendicontazioneValutazione\"><div class=\"stepName\" ng-if=\"step.nome != null\">{{step.nome}}</div><div class=\"stepName\" ng-if=\"step.mesi != null\">Mesi: {{step.mesi}}</div><div ng-if=\"step.startTimestamp != null\"><i class=\"fa fa-calendar\"></i> {{step.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}} <i class=\"fa fa-arrow-right\"></i> {{step.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}<br>&nbsp;&nbsp;&nbsp;<a class=\"tableButton\" ng-click=\"iterCtrl.sendMailValutazioneRendicontazione(step.idStep, step.logInvioMail)\">invia mail valutazione</a></div></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/gestioneReferee/gestioneReferee.html","<div class=\"gestioneReferee\"><h3 class=\"title\">Referee <a href=\"\" ng-click=\"refereeCtrl.mostraSoloAccettati = !refereeCtrl.mostraSoloAccettati\" class=\"linkButton filterButton\"><i class=\"fa fa-filter\"></i> {{refereeCtrl.mostraSoloAccettati ? \"mostra tutti\" : \"mostra solo accettati\"}}</a> <a href=\"\" ng-click=\"refereeCtrl.mostraDettagliStato = !refereeCtrl.mostraDettagliStato\" class=\"linkButton filterButton\"><i class=\"fa fa-filter\"></i> {{refereeCtrl.mostraDettagliStato ? \"nascondi dettagli\" : \"mostra dettagli\"}}</a></h3><div class=\"content\"><div class=\"loading\" ng-if=\"!refereeCtrl.refereeObj\"><div class=\"spinner\"></div></div><div ng-if=\"refereeCtrl.refereeObj\"><table class=\"table table-hover\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"statusColumn\">Stato richiesta</th><th class=\"valutazioneColumn\">Valutazione</th><th class=\"actionColumn\" ng-if=\"refereeCtrl.editMode\">Azioni</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"refereeCtrl.filteredReferee.length == 0\"><td colspan=\"{{refereeCtrl.editMode ? 4 : 3}}\">Nessun referee</td></tr><tr ng-repeat=\"referee in refereeCtrl.filteredReferee = (refereeCtrl.refereeObj.refereeList | filter: refereeCtrl.refereeFilter(referee))\" ng-class=\"refereeCtrl.getStatusClass(referee)\"><td class=\"nameColumn\"><div>{{referee.cognome}} {{referee.nome}}</div><div class=\"emailReferee\">{{referee.email}}</div></td><td class=\"statusColumn\"><div class=\"statusBox\" uib-tooltip=\"{{refereeCtrl.getStatusIconLabel(referee)}}\" ng-if=\"!refereeCtrl.mostraDettagliStato\"><i class=\"fa\" ng-class=\"refereeCtrl.getStatusIcon(referee)\"><i ng-if=\"referee.invioSollecito && referee.accettato == null && !referee.disabilitato\" class=\"fa fa-repeat iconaSollecito\" aria-hidden=\"true\"></i></i><div class=\"statusDate\">{{refereeCtrl.getStatusDate(referee) | date: \'dd/MM/yyyy\'}}</div></div><div ng-if=\"refereeCtrl.mostraDettagliStato\"><div ng-repeat=\"history in referee.history | orderBy: \'date\'\"><i class=\"fa historyIcon\" ng-class=\"[ history.icon, history.color]\" uib-tooltip=\"{{history.label}}\"><i ng-if=\"history.type == \'sollecito\'\" class=\"fa fa-repeat iconaSollecitoMini\" aria-hidden=\"true\"></i></i><span class=\"statusDate\">{{history.date | date: \'dd/MM/yyyy HH:mm\'}}</span></div></div></td><td class=\"valutazioneColumn\"><div ng-if=\"!referee.valutazione && refereeCtrl.editMode && referee.acptLink && referee.accettato == null && !referee.disabilitato\"><a ng-click=\"refereeCtrl.mostraAcceptLink(referee.acptLink)\"><i class=\"fa fa-link\" uib-tooltip=\"Link Accettazione Referee\"></i></a></div><div ng-if=\"referee.valutazione\"><div><div class=\"punteggio\" ng-class=\"{\'bozza\': referee.valutazione.status == \'BOZZA\'}\"><i ng-if=\"referee.valutazione.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{referee.valutazione.punteggio}}</div><a href=\"\" class=\"linkButton\" ng-if=\"referee.valutazione.status == \'CONCLUSA\'\" ng-click=\"refereeCtrl.showValutazione(referee.valutazione)\">Visualizza</a><div class=\"inProgress\" ng-if=\"referee.valutazione.status == \'BOZZA\' && !refereeCtrl.isUr\">In corso...<div class=\"lastUpdateDate\">{{referee.valutazione.updatedTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</div></div><a href=\"\" class=\"linkButton\" ng-if=\"referee.valutazione.status == \'BOZZA\' && refereeCtrl.isUr\" ng-click=\"refereeCtrl.showValutazione(referee.valutazione)\">Visualizza</a></div></div></td><td class=\"actionColumn\" ng-if=\"refereeCtrl.editMode\"><a href=\"\" uib-tooltip=\"Disabilita\" ng-click=\"refereeCtrl.cancelReferee(referee)\" ng-if=\"!(referee.accettato == false || referee.disabilitato == true || referee.nonNecessario == true) && referee.valutazione.status != \'CONCLUSA\'\"><i class=\"fa fa-ban\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"refereeCtrl.showAddReferee = true;\" class=\"linkButton\" ng-if=\"!refereeCtrl.showAddReferee && refereeCtrl.editMode && (refereeCtrl.refereeObj.addReferee || refereeCtrl.refereeObj.addRefereeMax)\" ng-init=\"refereeCtrl.showAddReferee = false\"><i class=\"fa fa-plus\"></i> aggiungi referee <span ng-if=\"refereeCtrl.refereeObj.addRefereeMax\">addizionale</span></a> <a href=\"\" class=\"linkButton\" ng-if=\"refereeCtrl.editMode && refereeCtrl.refereeObj.enableNonNecessari\" ng-click=\"refereeCtrl.enableNonNecessari()\"><i class=\"fa fa-plus\"></i> aggiungi referee</a><form name=\"refereeCtrl.refereeForm\" novalidate=\"\"><br><div class=\"panel panel-default\" ng-if=\"refereeCtrl.showAddReferee\"><h5 class=\"panel-heading\">Aggiungi referee</h5><div class=\"panel-body row\"><div class=\"col-sm-6 form-group\" ng-class=\"{\'has-error\' : refereeCtrl.refereeForm.refereeSurname.$invalid && refereeCtrl.refereeForm.refereeSurname.$dirty}\"><label for=\"refereeSurname\">Cognome</label> <input type=\"text\" class=\"form-control\" id=\"refereeSurname\" name=\"refereeSurname\" ng-model=\"refereeCtrl.newReferee.cognome\" placeholder=\"Inserisci cognome\" required=\"\"></div><div class=\"col-sm-6 form-group\" ng-class=\"{\'has-error\' : refereeCtrl.refereeForm.refereeName.$invalid && refereeCtrl.refereeForm.refereeName.$dirty}\"><label for=\"refereeName\">Nome</label> <input type=\"text\" class=\"form-control\" id=\"refereeName\" name=\"refereeName\" ng-model=\"refereeCtrl.newReferee.nome\" placeholder=\"Inserisci nome\" required=\"\"></div><div class=\"col-sm-7 form-group\" ng-class=\"{\'has-error\' : refereeCtrl.refereeForm.refereeEmail.$invalid && refereeCtrl.refereeForm.refereeEmail.$dirty}\"><label for=\"refereeEmail\">Email</label> <input type=\"email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" class=\"form-control\" id=\"refereeEmail\" name=\"refereeEmail\" ng-model=\"refereeCtrl.newReferee.email\" placeholder=\"Inserisci email\" required=\"\"></div><div class=\"col-sm-12\"><button class=\"btn btn-primary btn-sm\" ng-click=\"refereeCtrl.addReferee()\" ng-disabled=\"refereeCtrl.refereeForm.$invalid\"><i class=\"fa fa-plus\"></i> Aggiungi</button> <button class=\"btn btn-default btn-sm\" ng-click=\"refereeCtrl.showAddReferee = false\"><i class=\"fa fa-times\"></i> Annulla</button></div></div></div></form></div></div></div><div class=\"ngdialog-buttons\" ng-if=\"refereeCtrl.refereeObj && !refereeCtrl.faseId\"><button type=\"button\" ng-click=\"refereeCtrl.close()\" class=\"ngdialog-button ngdialog-button-secondary\">Chiudi</button> <button type=\"button\" ng-if=\"refereeCtrl.editMode\" ng-class=\"{\'ng-button-invalid\': !refereeCtrl.refereeObj.concludiValutazione}\" ng-disabled=\"!refereeCtrl.refereeObj.concludiValutazione\" ng-click=\"refereeCtrl.concludiValutazione()\" class=\"ngdialog-button ngdialog-button-primary\">Concludi valutazione</button></div><div class=\"ngdialog-buttons\" ng-if=\"refereeCtrl.refereeObj && refereeCtrl.faseId\"><button type=\"button\" ng-if=\"refereeCtrl.editMode\" ng-class=\"{\'ng-button-invalid\': !refereeCtrl.refereeObj.concludiValutazione}\" ng-disabled=\"!refereeCtrl.refereeObj.concludiValutazione\" ng-click=\"refereeCtrl.concludiFaseValutazione()\" class=\"ngdialog-button ngdialog-button-primary\">Concludi fase</button></div>");
$templateCache.put("app/components/gestioneUtente/gestioneUtente.html","<h1 class=\"page-header\">{{utenteCtrl.pageHeader}}</h1><div class=\"spinner\" ng-if=\"utenteCtrl.loading\"></div><form class=\"gestioneUtente\" name=\"utenteCtrl.utenteForm\" ng-if=\"!utenteCtrl.loading\" novalidate=\"\"><div class=\"col-sm-12 form-group\" ng-class=\"{\'has-error\' : utenteCtrl.utenteForm.surname.$invalid && utenteCtrl.utenteForm.surname.$dirty}\"><label for=\"surname\">Cognome</label> <input class=\"form-control\" id=\"surname\" name=\"surname\" ng-model=\"utenteCtrl.utente.cognome\" placeholder=\"Inserisci cognome\" required=\"\" type=\"text\"></div><div class=\"col-sm-12 form-group\" ng-class=\"{\'has-error\' : utenteCtrl.utenteForm.name.$invalid && utenteCtrl.utenteForm.name.$dirty}\"><label for=\"name\">Nome</label> <input class=\"form-control\" id=\"name\" name=\"name\" ng-model=\"utenteCtrl.utente.nome\" placeholder=\"Inserisci nome\" required=\"\" type=\"text\"></div><div class=\"col-sm-12 form-group\" ng-class=\"{\'has-error\' : utenteCtrl.utenteForm.cf.$invalid && utenteCtrl.utenteForm.cf.$dirty}\"><label for=\"cf\">Codice Fiscale</label> <input class=\"form-control\" id=\"cf\" name=\"cf\" ng-model=\"utenteCtrl.utente.codiceFiscale\" ng-pattern=\"/^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i\" placeholder=\"Inserisci codice fiscale\" required=\"\" type=\"text\"></div><div class=\"col-sm-12 form-group\" ng-class=\"{\'has-error\' : utenteCtrl.utenteForm.dataNascita.$invalid && utenteCtrl.utenteForm.dataNascita.$dirty}\" style=\"padding-left: 0px;padding-right: 0px;\"><label class=\"col-sm-12\">Data di nascita</label><div class=\"col-sm-12\"><label class=\"fieldWithIcon\" for=\"dataNascita\"><input class=\"form-control\" date-range-picker=\"\" id=\"dataNascita\" name=\"dataNascita\" required=\"\" ng-model=\"utenteCtrl.utente.dataDiNascita\" non-future=\"true\" readonly=\"\" single-date=\"true\" type=\"text\"><i class=\"fa fa-calendar\"></i></label></div></div><div class=\"col-sm-12 form-group\" ng-class=\"{\'has-error\' : utenteCtrl.utenteForm.email.$invalid && utenteCtrl.utenteForm.email.$dirty}\"><label for=\"email\">Email</label> <input class=\"form-control\" id=\"email\" name=\"email\" ng-model=\"utenteCtrl.utente.email\" ng-pattern=\"/^[^\\s@?!*,//]+@uniroma1\\.it$/\" placeholder=\"Inserisci email\" required=\"\" type=\"email\"></div><div class=\"col-sm-12 form-group\"><label for=\"dipartimento\">Dipartimento</label><ui-select id=\"dipartimento\" name=\"dipartimento\" ng-model=\"utenteCtrl.utente.dipartimento.id\" required=\"\" search-enabled=\"false\"><ui-select-match>{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat=\"item.id as item in utenteCtrl.dipartimenti\"><div ng-bind-html=\"item.nome\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-12 form-group\"><label for=\"ruolo\">Ruolo</label><ui-select id=\"ruolo\" name=\"ruolo\" ng-model=\"utenteCtrl.utente.ruolo.id\" on-select=\"utenteCtrl.utente.ruolo.codice=$item.codice\" required=\"\" search-enabled=\"false\"><ui-select-match>{{$select.selected.descrizione}}</ui-select-match><ui-select-choices repeat=\"item.id as item in utenteCtrl.ruoli\"><div ng-bind-html=\"item.descrizione\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-12 form-group\"><label for=\"regime\">Regime</label><ui-select id=\"regime\" name=\"regime\" ng-model=\"utenteCtrl.utente.regime\" required=\"\" search-enabled=\"false\"><ui-select-match>{{$select.selected.descrizione}}</ui-select-match><ui-select-choices repeat=\"item as item in utenteCtrl.regimi\"><div ng-bind-html=\"item.descrizione\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-12 form-group\" ng-class=\"{\'has-error\' : utenteCtrl.utenteForm.dataTermineRapporto.$invalid && utenteCtrl.utenteForm.dataTermineRapporto.$dirty}\" style=\"padding-left: 0px;padding-right: 0px;\"><label class=\"col-sm-12\">Data termine rapporto <input style=\"margin-left: 10px\" type=\"checkbox\" ng-checked=\"utenteCtrl.tempoIndeterminato\" ng-model=\"utenteCtrl.tempoIndeterminato\" ng-click=\"utenteCtrl.setTempoIndeterminato(utenteCtrl.tempoIndeterminato)\"> Tempo Indeterminato</label><div class=\"col-sm-12\" ng-if=\"!utenteCtrl.tempoIndeterminato\"><label class=\"fieldWithIcon\" for=\"dataTermineRapporto\"><input class=\"form-control\" date-range-picker=\"\" id=\"dataTermineRapporto\" name=\"dataTermineRapporto\" required=\"\" ng-model=\"utenteCtrl.utente.dataTermineRapporto\" readonly=\"\" single-date=\"true\" ng-disabled=\"utenteCtrl.tempoIndeterminato\" ng-change=\"utenteCtrl.tempoIndeterminato = utenteCtrl.isTempoIndeterminato(utenteCtrl.utente.dataTermineRapporto)\" type=\"text\"><i class=\"fa fa-calendar\"></i></label></div><div class=\"col-sm-12\" ng-if=\"utenteCtrl.tempoIndeterminato\"><input class=\"form-control\" readonly=\"\" disabled=\"\" type=\"text\" value=\"(tempo indeterminato)\"></div></div><div class=\"col-sm-12 form-group\" style=\"padding-left: 0px;padding-right: 0px;\"><label class=\"col-sm-12\">Profilo bloccato <input style=\"margin-left: 10px\" type=\"checkbox\" ng-checked=\"utenteCtrl.utenteInternoValido\" ng-model=\"utenteCtrl.utente.utenteInternoValido\" name=\"utenteInternoValido\"></label><div style=\"font-weight: 300; font-size: 12px; margin-left: 10px;\">Se disabilitato riapre il profilo dell\'utente per poter effetturare modifiche</div></div><div class=\"col-sm-12 form-group\" ng-if=\"utenteCtrl.utente.ruolo.codice===\'DR\'\"><label for=\"annoCorso\">Anno di corso</label><ui-select id=\"annoCorso\" name=\"annoCorso\" ng-model=\"utenteCtrl.utente.annoCorso\" required=\"\" search-enabled=\"false\"><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item as item in [\'1\',\'2\',\'3\']\"><div ng-bind-html=\"item\"></div></ui-select-choices></ui-select></div><div class=\"form-group col-sm-12 indicatoriRicercaPanel\" style=\"padding-left: 0px; padding-right: 0px;\"><label class=\"col-sm-12\">Indicatori di ricerca <a style=\"padding-left: 10px\" href=\"\" ng-click=\"utenteCtrl.addIndicatore()\" ng-if=\"!utenteCtrl.utente.indicatoriRicerca\"><i class=\"fa fa-plus\"></i> Aggiungi</a></label><div class=\"col-sm-12\"><div class=\"indicatoriDiv\" ng-if=\"utenteCtrl.utente.indicatoriRicerca\"><div class=\"row\" ng-if=\"!utenteCtrl.utente.id || !utenteCtrl.oldutente.indicatoriRicerca\" style=\"flex-direction: row; display: flex; justify-content: right; padding-right: 20px;\"><a ng-click=\"utenteCtrl.utente.indicatoriRicerca = null\"><i class=\"fa fa-close\" style=\"cursor: pointer;\"></i></a></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group valueRow\"><label>Soglia 1</label> <span><input class=\"form-control\" id=\"irSoglia1\" name=\"irSoglia1\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.soglia1\" placeholder=\"Inserisci Soglia 1\" required=\"\" type=\"number\"></span></div></div><div class=\"col-sm-2\"><div class=\"form-group valueRow\"><label>Soglia 2</label> <span><input class=\"form-control\" id=\"irSoglia2\" name=\"irSoglia2\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.soglia2\" placeholder=\"Inserisci Soglia 2\" required=\"\" type=\"number\"></span></div></div><div class=\"col-sm-2\"><div class=\"form-group valueRow\"><label>Soglia 3</label> <span><input class=\"form-control\" id=\"irSoglia3\" name=\"irSoglia3\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.soglia3\" placeholder=\"Inserisci Soglia 3\" required=\"\" type=\"number\"></span></div></div><div class=\"col-sm-2\"><div class=\"form-group valueRow\"><label>Indicatore 1</label> <span><input class=\"form-control\" id=\"irIndicatore1\" name=\"irIndicatore1\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.indicatore1\" placeholder=\"Inserisci Indicatore 1\" required=\"\" type=\"number\"></span></div></div><div class=\"col-sm-2\"><div class=\"form-group valueRow\"><label>Indicatore 2</label> <span><input class=\"form-control\" id=\"irIndicatore2\" name=\"irIndicatore2\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.indicatore2\" placeholder=\"Inserisci Indicatore 2\" required=\"\" type=\"number\"></span></div></div><div class=\"col-sm-2\"><div class=\"form-group valueRow\"><label>Indicatore 3</label> <span><input class=\"form-control\" id=\"irIndicatore3\" name=\"irIndicatore3\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.indicatore3\" placeholder=\"Inserisci Indicatore 3\" required=\"\" type=\"number\"></span></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group valueRow\"><label>Anno</label> <span><input class=\"form-control\" id=\"irAnno\" name=\"irAnno\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.anno\" placeholder=\"Inserisci Anno\" required=\"\" type=\"number\"></span></div></div><div class=\"col-sm-3\"><div class=\"form-group valueRow\"><label>SC</label> <input class=\"form-control\" id=\"irSc\" name=\"irSc\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.sc\" placeholder=\"Inserisci SC\" required=\"\" type=\"text\"></div></div><div class=\"col-sm-3\"><div class=\"form-group valueRow\"><label for=\"irSsd\">SSD</label><ui-select id=\"irSsd\" name=\"irSsd\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.ssd\" required=\"\" search-enabled=\"false\"><ui-select-match>{{utenteCtrl.utente.indicatoriRicerca.ssd}}</ui-select-match><ui-select-choices repeat=\"item.codice as item in utenteCtrl.ssdList\"><div ng-bind-html=\"item.codice\"></div></ui-select-choices></ui-select></div></div><div class=\"col-sm-3\"><div class=\"form-group valueRow\"><label>Data Indicatore</label> <span class=\"fieldWithIcon\"><input class=\"form-control\" date-range-picker=\"\" id=\"irDataIndicatore\" name=\"irDataIndicatore\" ng-model=\"utenteCtrl.utente.indicatoriRicerca.dataIndicatore\" readonly=\"\" required=\"\" single-date=\"true\" type=\"text\"> <i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></div><div class=\"form-group col-sm-12\"><label for=\"note\"><span>Note</span></label> <textarea class=\"form-control\" id=\"note\" ng-model=\"utenteCtrl.utente.note\" name=\"note\" rows=\"4\">\n  </textarea></div><div class=\"ultimaModifica\" ng-if=\"utenteCtrl.utente.timestampModifica\">Ultima modifica: <span class=\"utente\">{{utenteCtrl.utente.utenteInternoLastUpdate.cognome}} {{utenteCtrl.utente.utenteInternoLastUpdate.nome}} - {{utenteCtrl.utente.timestampModifica | date: \'medium\'}}</span></div><div class=\"form-group col-sm-12\" style=\"padding-top: 30px;padding-bottom: 30px;\"><button class=\"btn btn-primary\" ng-click=\"utenteCtrl.saveUtente()\" ng-disabled=\"utenteCtrl.utenteForm.$invalid\">Salva</button> <button class=\"btn btn-default\" ui-sref=\"urAnagrafica\">Chiudi senza salvare</button></div></form>");
$templateCache.put("app/components/impersona/impersona.html","<div class=\"impersona\"><div><h1 class=\"page-header\">Impersona</h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"impCtrl.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"impCtrl.getUtenti()\" placeholder=\"Cognome\"></div><a href=\"\" class=\"resetFilter\" ng-if=\"impCtrl.isFiltroAttivo()\" ng-click=\"impCtrl.resetFiltri()\">Reset filtri</a></form></div><div class=\"impersonaContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"fixedHeader\" ng-if=\"impCtrl.utenti != null\"><th><div class=\"th-inner nomeColumn\">Nome e Cognome</div></th><th><div class=\"th-inner dipartimentoColumn\">Dipartimento</div></th><th><div class=\"th-inner ruoloColumn\">Ruolo</div></th><th><div class=\"th-inner actionColumn\">Impersona</div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"impCtrl.utenti == null\"></div><tr class=\"utenteBox\" ng-repeat=\"user in impCtrl.utenti\"><td class=\"nomeColumn\">{{user.utente.nome}} {{user.utente.cognome}}</td><td class=\"dipartimentoColumn\">{{user.dipartimento.nome}}</td><td class=\"ruoloColumn\">{{user.ruolo.descrizione}}</td><td></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"impCtrl.impersona(user.utente)\"><i class=\"btn btn-default fa fa-user\"></i></a></td></tr></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{impCtrl.pagination.start}}</span> - <span class=\"itemNumber\">{{impCtrl.pagination.end}}</span> di <span class=\"itemNumber\">{{impCtrl.pagination.total}}</span> <a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta l\'elenco degli utenti secondo il filtro corrente\" ng-href=\"{{impCtrl.getCsvExportUrl()}}\"><i class=\"fa fa-file-o\"></i> Esporta elenco</a><uib-pagination class=\"pull-right pagination-sm\" total-items=\"impCtrl.pagination.total\" items-per-page=\"impCtrl.pagination.limit\" ng-model=\"impCtrl.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"impCtrl.getUtenti(true)\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/components/indicatoriValProp/indicatoriValProp.html","<div class=\"indicatoriValProp\"><h3 class=\"title\">Indicatori del gruppo di ricerca</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!indValPropCtrl.indObj\"><div class=\"spinner\"></div></div><div ng-if=\"indValPropCtrl.indObj != null\"><table class=\"table\"><thead><tr><th class=\"nameColumn\">Cognome</th><th class=\"roleColumn\"></th><th class=\"valueColumn\">Soglia 1</th><th class=\"valueColumn\">Soglia 2</th><th class=\"valueColumn\">Soglia 3</th><th class=\"valueColumn\">Indic. 1</th><th class=\"valueColumn\">Indic. 2</th><th class=\"valueColumn\">Indic. 3</th><th class=\"valueColumn\">SC</th><th class=\"valueColumn\">SSD</th><th class=\"valueColumn\">Data Indic.</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"indValPropCtrl.indObj.length == 0\"><td colspan=\"11\">Nessun Componente</td></tr><tr ng-repeat=\"partecipante in indValPropCtrl.indObj\"><td class=\"nameColumn\">{{partecipante.cognome}} {{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.categoria}}</td><td class=\"valueColumn\">{{partecipante.soglia1}}</td><td class=\"valueColumn\">{{partecipante.soglia2}}</td><td class=\"valueColumn\">{{partecipante.soglia3}}</td><td class=\"valueColumn\">{{partecipante.indicatore1}}</td><td class=\"valueColumn\">{{partecipante.indicatore2}}</td><td class=\"valueColumn\">{{partecipante.indicatore3}}</td><td class=\"descColumn\">{{partecipante.sc}}</td><td class=\"descColumn\">{{partecipante.ssd}}</td><td class=\"descColumn\">{{partecipante.dataIndicatore}}</td></tr></tbody></table></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" ng-click=\"indValPropCtrl.close()\" class=\"ngdialog-button ngdialog-button-secondary\">Chiudi</button></div>");
$templateCache.put("app/components/indicatoriValutazione/indicatoriValutazione.html","<div class=\"indicatoriValutazione\"><h3 class=\"title\">Indicatori del gruppo di ricerca</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!indValCtrl.indObj\"><div class=\"spinner\"></div></div><div ng-if=\"indValCtrl.indObj != null\"><table class=\"table\"><thead><tr><th class=\"nameColumn\">Cognome</th><th class=\"roleColumn\"></th><th class=\"valueColumn\">Soglia 1</th><th class=\"valueColumn\">Soglia 2</th><th class=\"valueColumn\">Soglia 3</th><th class=\"valueColumn\">Indic. 1</th><th class=\"valueColumn\">Indic. 2</th><th class=\"valueColumn\">Indic. 3</th><th class=\"valueColumn\" ng-if=\"indValCtrl.isUr\">SC</th><th class=\"valueColumn\" ng-if=\"indValCtrl.isUr\">SSD</th><th class=\"valueColumn\" ng-if=\"indValCtrl.isUr\">Data Indic.</th><th class=\"valueColumn\">Coefficiente</th><th class=\"valueColumn\">Media&nbsp;Coeff.</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"indValCtrl.indObj.length == 0\"><td colspan=\"{{indValCtrl.isUr ? 13 : 10}}\">Nessun Componente</td></tr><tr ng-repeat=\"partecipante in indValCtrl.indObj\"><td class=\"nameColumn\">{{partecipante.cognome}} {{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.categoria}}</td><td class=\"valueColumn\">{{partecipante.soglia1}}</td><td class=\"valueColumn\">{{partecipante.soglia2}}</td><td class=\"valueColumn\">{{partecipante.soglia3}}</td><td class=\"valueColumn\">{{partecipante.indicatore1}}</td><td class=\"valueColumn\">{{partecipante.indicatore2}}</td><td class=\"valueColumn\">{{partecipante.indicatore3}}</td><td class=\"descColumn\" ng-if=\"indValCtrl.isUr\">{{partecipante.sc}}</td><td class=\"descColumn\" ng-if=\"indValCtrl.isUr\">{{partecipante.ssd}}</td><td class=\"descColumn\" ng-if=\"indValCtrl.isUr\">{{partecipante.dataIndicatore}}</td><td class=\"valueColumn\">{{partecipante.coefficiente | number : 3}}</td><td class=\"valueColumn\" rowspan=\"{{partecipante.mediaNum}}\" ng-if=\"partecipante.mediaNum > 0\">{{partecipante.mediaCoefficiente | number : 3}}</td></tr></tbody></table></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" ng-click=\"indValCtrl.close()\" class=\"ngdialog-button ngdialog-button-secondary\">Chiudi</button></div>");
$templateCache.put("app/components/iterValutazione/iterValutazione.html","<div class=\"iterValutazione\"><h3 class=\"title\">Iter Valutazione</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!iterValCtrl.fasiObj\"><div class=\"spinner\"></div></div><div ng-if=\"iterValCtrl.fasiObj != null\"><div class=\"faseContainer\" ng-repeat=\"fase in iterValCtrl.fasiObj\"><h4>{{fase.fase}}. {{fase.nome}}</h4><div class=\"faseContent\" ng-if=\"fase.attiva\"><div ng-if=\"fase.tipo == \'REFEREE_PARZIALE\'\"><gestione-referee proposta=\"iterValCtrl.proposta\" edit-mode=\"(iterValCtrl.editMode && (iterValCtrl.isUr || (iterValCtrl.isPresComm && iterValCtrl.presCanEdit)) && !fase.conclusa)\" is-ur=\"iterValCtrl.isUr\" fase-id=\"fase.id\" confirm=\"iterValCtrl.reloadAndCheckFasi\"></gestione-referee></div><div ng-if=\"fase.tipo == \'COMMISSIONE\'\"><div ng-if=\"!iterValCtrl.isUr\"><div ng-if=\"(fase.valutazioneList == null || fase.valutazioneList.length == 0) && !fase.conclusa && iterValCtrl.editMode\"><a class=\"tableButton\" ng-class=\"{\'disabled\' : !iterValCtrl.proposta.macroAreaValutabile}\" tooltip-enable=\"!iterValCtrl.proposta.macroAreaValutabile\" uib-tooltip=\"Macroarea non valutabile\" ng-click=\"!iterValCtrl.proposta.macroAreaValutabile || iterValCtrl.valutaProposta(iterValCtrl.proposta, null, fase.id)\"><i ng-if=\"!iterValCtrl.proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Valuta</a></div><div ng-if=\"fase.valutazioneList != null && fase.valutazioneList.length > 0\"><div class=\"valutazioneBox\" ng-repeat=\"valutazione in fase.valutazioneList\"><div class=\"punteggio\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\" uib-tooltip=\"{{valutazione.punteggio*1 != valutazione.punteggio.toFixed(1)*1 ? valutazione.punteggio : \'\'}}\"><i ng-if=\"valutazione.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{valutazione.punteggio !== null ? (valutazione.punteggio).toFixed(1)*1 : \'\'}}</div><div class=\"valutatori\"><span>{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span><div><a href=\"\" class=\"tableButton\" ng-if=\"valutazione.status == \'CONCLUSA\'\" ng-click=\"iterValCtrl.showValutazione(iterValCtrl.proposta, valutazione)\">Visualizza</a> <a href=\"\" class=\"tableButton\" ng-if=\"valutazione.status == \'BOZZA\' && !fase.conclusa && iterValCtrl.editMode\" ng-class=\"{\'disabled\' : !iterValCtrl.proposta.macroAreaValutabile}\" tooltip-enable=\"!iterValCtrl.proposta.macroAreaValutabile\" uib-tooltip=\"Macroarea non valutabile\" ng-click=\"!iterValCtrl.proposta.macroAreaValutabile || iterValCtrl.valutaProposta(iterValCtrl.proposta, valutazione, fase.id)\"><i ng-if=\"!iterValCtrl.proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Modifica</a></div></div></div></div></div><div ng-if=\"iterValCtrl.isUr\"><div ng-if=\"(fase.valutazioneList == null || fase.valutazioneList.length == 0) && !fase.conclusa && iterValCtrl.editMode\">Questa fase della valutazione deve essere effettuata da un membro della commissione.</div><div ng-if=\"fase.valutazioneList != null && fase.valutazioneList.length > 0\"><div class=\"valutazioneBox\" ng-repeat=\"valutazione in fase.valutazioneList\"><div class=\"punteggio\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\" uib-tooltip=\"{{valutazione.punteggio*1 != valutazione.punteggio.toFixed(1)*1 ? valutazione.punteggio : \'\'}}\"><i ng-if=\"valutazione.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{valutazione.punteggio !== null ? (valutazione.punteggio).toFixed(1)*1 : \'\'}}</div><div class=\"valutatori\"><span>{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span><div><a href=\"\" class=\"tableButton\" ng-click=\"iterValCtrl.showValutazione(iterValCtrl.proposta, valutazione)\">Visualizza</a></div></div></div></div></div></div><div ng-if=\"fase.tipo == \'CHECK_BLOCCANTE\'\"><div ng-if=\"!iterValCtrl.isUr\"><div ng-if=\"(fase.valutazioneList == null || fase.valutazioneList.length == 0) && !fase.conclusa && iterValCtrl.editMode\"><a class=\"tableButton\" ng-class=\"{\'disabled\' : !iterValCtrl.proposta.macroAreaValutabile}\" tooltip-enable=\"!iterValCtrl.proposta.macroAreaValutabile\" uib-tooltip=\"Macroarea non valutabile\" ng-click=\"!iterValCtrl.proposta.macroAreaValutabile || iterValCtrl.valutaProposta(iterValCtrl.proposta, null, fase.id)\"><i ng-if=\"!iterValCtrl.proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Valuta</a></div><div ng-if=\"fase.valutazioneList != null && fase.valutazioneList.length > 0\"><div class=\"valutazioneBox\" ng-repeat=\"valutazione in fase.valutazioneList\"><div class=\"punteggio\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\"><i class=\"fa\" ng-class=\"iterValCtrl.getCheckEvaluationIconClass(valutazione.punteggio)\"></i></div><div class=\"valutatori\"><span>{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span><div><a href=\"\" class=\"tableButton\" ng-if=\"valutazione.status == \'CONCLUSA\'\" ng-click=\"iterValCtrl.showValutazione(iterValCtrl.proposta, valutazione)\">Visualizza</a> <a href=\"\" class=\"tableButton\" ng-if=\"valutazione.status == \'BOZZA\' && !fase.conclusa && iterValCtrl.editMode\" ng-class=\"{\'disabled\' : !iterValCtrl.proposta.macroAreaValutabile}\" tooltip-enable=\"!iterValCtrl.proposta.macroAreaValutabile\" uib-tooltip=\"Macroarea non valutabile\" ng-click=\"!iterValCtrl.proposta.macroAreaValutabile || iterValCtrl.valutaProposta(iterValCtrl.proposta, valutazione, fase.id)\"><i ng-if=\"!iterValCtrl.proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Modifica</a></div></div></div></div></div><div ng-if=\"iterValCtrl.isUr\"><div ng-if=\"(fase.valutazioneList == null || fase.valutazioneList.length == 0) && !fase.conclusa && iterValCtrl.editMode\">Questa fase della valutazione deve essere effettuata da un membro della commissione.</div><div ng-if=\"fase.valutazioneList != null && fase.valutazioneList.length > 0\"><div class=\"valutazioneBox\" ng-repeat=\"valutazione in fase.valutazioneList\"><div class=\"punteggio\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\"><i class=\"fa\" ng-class=\"iterValCtrl.getCheckEvaluationIconClass(valutazione.punteggio)\"></i></div><div class=\"valutatori\"><span>{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span><div><a href=\"\" class=\"tableButton\" ng-click=\"iterValCtrl.showValutazione(iterValCtrl.proposta, valutazione)\">Visualizza</a></div></div></div></div></div></div></div></div></div></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" ng-click=\"iterValCtrl.close()\" class=\"ngdialog-button ngdialog-button-secondary\">Chiudi</button></div>");
$templateCache.put("app/components/listDettaglioProposte/listDettaglioProposte.html","<h1 class=\"page-header\">Proposte <small>{{vm.nome}} {{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getProposteERichieste()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"listaProposteContainer\"><div class=\"spinner\" ng-if=\"vm.proposte == null\"></div><div ng-if=\"vm.proposte != null && vm.richieste != null\"><div class=\"noResults\" ng-if=\"vm.proposte.length == 0 && vm.richieste.length == 0\">Non ha partecipato a nessuna proposta per l\'anno selezionato</div><div class=\"statusFilter\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'BOZZA\'\">In bozza</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'ALL\'\">Tutte le proposte</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'DA_VALUTARE\'\">Da valutare</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'VALUTATE\'\">Valutate</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'FINANZIATE\'\">Finanziate</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'NON_FINANZIATE\'\">Non finanziate</label></div></div><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead style=\"border-top: 0\"><tr style=\"border-top: 0\"><td class=\"th-inner\"></td><td class=\"th-inner\">Titolo oggetto</td><td class=\"th-inner\">Responsabile</td><td class=\"th-inner\">Ruolo</td><td class=\"th-inner\">Valutazione</td><td class=\"th-inner\">Fin rich.</td><td class=\"th-inner\">Fin conc.</td><td class=\"th-inner\">Fin Speso</td><td class=\"th-inner\">Azioni</td></tr></thead><tbody><div ng-if=\"vm.proposte === null\">proposte null</div><div ng-if=\"vm.proposte !== null\"><tr ng-if=\"vm.proposte.length == 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"progettoBox\" ng-repeat=\"proposta in vm.proposte\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{vm.getStatus(proposta.status, proposta.statusValutazioneProposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\"><span ng-repeat=\"componenti in proposta.nComponenti\">{{$index == 0 ? \'\' : \' - \'}}<b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div></td><td><div ng-class=\"{\'striked\': (proposta.titolare != null)}\">{{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}</div><div><span class=\"label label-under\" ng-if=\"proposta.etaAllaDomanda < 40\">Under 40</span> <span class=\"label label-ricercatore\" ng-if=\"proposta.responsabileRicercatore\">Ricercatore</span></div><div class=\"dipartimento\">{{proposta.responsabile.dipartimento.nome}}</div></td><td><span>{{proposta.ruoloComponente}}</span></td><td><div ng-if=\"proposta.nonAmmissibile\"><div class=\"refereeAddedMessage\">Non Ammissibile</div></div><div ng-if=\"!proposta.nonAmmissibile && proposta.tipoValutazione != \'ITER_VALUTAZIONE\'\"><div ng-if=\"proposta.valutazioneList.length > 0\" class=\"valBox\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{proposta.media*1 != proposta.media.toFixed(1)*1 ? proposta.media : \'\'}}\"><i ng-if=\"proposta.media == null\" class=\"fa fa-file-text-o\"></i> {{proposta.media !== null ? (proposta.media).toFixed(1) * 1 : \'\'}}</div><div class=\"valutatori\"><div ng-repeat=\"valutazione in proposta.valutazioneList\"><span ng-if=\"!valutazione.referee\">{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span> <span ng-if=\"valutazione.referee\">{{valutazione.referee.cognome}} {{valutazione.referee.nome}} <span class=\"valore\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\">{{valutazione.punteggio}}</span></span></div></div></div></div><div ng-if=\"!proposta.nonAmmissibile && proposta.tipoValutazione == \'ITER_VALUTAZIONE\' && proposta.status != \'BOZZA\'\"><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == true\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><i class=\"fa fa-thumbs-o-down\"></i></div></div><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == false && proposta.numeroRefereeAssociati == 0\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\"><i class=\"fa fa-thumbs-o-up\"></i></div></div><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == null\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.status, proposta.statusValutazioneProposta)\" uib-tooltip=\"{{proposta.media*1 != proposta.media.toFixed(1)*1 ? proposta.media : \'\'}}\"><i ng-if=\"proposta.media == null\" class=\"fa fa-file-text-o\"></i> {{proposta.media !== null ? (proposta.media).toFixed(1) * 1 : \'\'}}</div></div><div ng-if=\"(proposta.valutazioneList.length == 0 || proposta.valutazioneRespinta == false) && proposta.numeroRefereeAssociati > 0\"><div class=\"refereeAddedMessage\">Referee inseriti</div></div></div></td><td><span>{{proposta.ruolo && proposta.ruolo.descrizione ? proposta.ruolo.descrizione : \'\'}}</span></td><td><div class=\"finBox\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.finanziamentoRichiesto | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.assegnoRichiesto | number}}</div></div></div></td><td><div class=\"finBox assegnato\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\'\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.esitoValutazione.finanziamentoAssegnato | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.esitoValutazione.assegnoAssegnato | number}}</div></div><a class=\"tableButton comment\" ng-if=\"proposta.esitoValutazione.commento && proposta.esitoValutazione.commento != \'\'\" ng-click=\"vm.mostraCommentoFinanziamento(proposta.esitoValutazione.commento)\"><i class=\"fa fa-file-text-o\" uib-tooltip=\"Commento\"></i></a></div><div class=\"ultimaModifica\" ng-if=\"(proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\') && proposta.esitoValutazione != null\" ng-init=\"utenteFin = proposta.esitoValutazione.ufficioRicerca ? proposta.esitoValutazione.ufficioRicerca.utente : proposta.esitoValutazione.membroCommissione; timestampFin = proposta.esitoValutazione.updatedTimestamp ? proposta.esitoValutazione.updatedTimestamp : proposta.esitoValutazione.createdTimestamp\"><span>{{utenteFin.cognome}} {{utenteFin.nome}}&nbsp;&nbsp; <i class=\"fa fa-clock-o\" uib-tooltip=\"ultima modifica: {{timestampFin | date: \'medium\'}}\"></i></span></div></td><td><div class=\"finBox speso\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\'\"><div ng-repeat=\"step in proposta.stepRendicontazione\" ng-if=\"step.rendicontazione !== null\"><div ng-if=\"step.rendicontazione !== null && step.rendicontazione.status === \'BOZZA\'\"><div class=\"bozzaRendicontazione\"><span>BOZZA</span></div><a class=\"tableButton\" ng-click=\"vm.openRendicontazione(step.rendicontazione.id)\">{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</a></div><div ng-if=\"step.rendicontazione !== null && step.rendicontazione.status !== \'BOZZA\'\"><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{step.rendicontazione.finanziamentoSpeso | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(step.rendicontazione.assegnoSpeso ? step.rendicontazione.assegnoSpeso : 0) | number}}</div><a class=\"tableButton\" ng-click=\"vm.openRendicontazione(step.rendicontazione.id)\">{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</a></div></div></div></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openPropostaView(proposta)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></div></tbody></table></div></div><div class=\"paginationBox\" style=\"margin-top: 5px;\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span></div><div class=\"paginationBox\"><button class=\"btn btn-default pagination-sm\" ui-sref=\"urDettaglioProposte\" style=\"margin: 20px 0;\">Torna indietro</button><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposte(true)\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/listaBandi/listaBandi.html","<h1 class=\"page-header\">Bandi <small>{{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getBandi()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"listaBandiContainer\"><div class=\"spinner\" ng-if=\"vm.bandi == null\"></div><div class=\"bandoContainer panel panel-default\" ng-repeat=\"bando in vm.bandi\"><div class=\"panel-heading\"><h3 class=\"panel-title\"><div class=\"label label-default pull-right\" ng-if=\"bando.files.length > 0\"><span><i class=\"fa fa-file-pdf-o\"></i>scarica il bando in pdf</span><a target=\"_blank\" ng-repeat=\"file in bando.files\" ng-href=\"{{vm.getFileHref(file.URL)}}\"><i class=\"fa fa-file-pdf-o\"></i>{{file.nome}}</a></div>{{bando.nome}}</h3></div><div class=\"panel-body\"><p ng-if=\"bando.descrizione\">{{bando.descrizione}}</p><div class=\"bs-callout bs-callout-sapienza\" ng-repeat=\"tipologia in bando.tipologiaProgetti\"><h4>{{tipologia.nome}}<span style=\"font-size: 16px; color: red; margin-left: 50px;\" ng-if=\"tipologia.id === 5 && tipologia.nome == \'Attrezzature Scientifiche\'\">Scadenza compilazione: <b>20/05/2016 14:00</b></span></h4><p ng-if=\"tipologia.descrizione\">{{tipologia.descrizione}}</p><p class=\"periodoValidita\" ng-if=\"bando.startTimestamp\"><span>Inizio compilazione:</span>{{bando.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}}<br><span>Scadenza compilazione:</span>{{bando.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</p><p class=\"periodoValidita\" ng-if=\"tipologia.startTimestamp\"><span>Inizio compilazione:</span>{{tipologia.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}}<br><span>Scadenza compilazione:</span>{{tipologia.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</p><ul><li ng-repeat=\"classe in tipologia.classi\"><span><b>{{classe.nome}}</b> - {{classe.descrizione}}</span> <a href=\"\" class=\"btn btn-primary\" ui-sref=\"newProposta({classe: classe.id})\" ng-if=\"classe.ammissibilita && classe.ammissibilita.ammissibile\"><i class=\"fa fa-pencil-square-o\"></i> Crea una proposta</a> <a href=\"\" class=\"btn btn-default\" disabled=\"\" ng-if=\"classe.ammissibilita && !classe.ammissibilita.ammissibile\"><i class=\"fa fa-pencil-square-o\"></i> Crea una proposta</a></li></ul></div></div></div></div>");
$templateCache.put("app/components/listaCommissioni/listaCommissioni.html","<h1 class=\"page-header\">Commissioni <small>{{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getCommissioni()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"listaCommissioniContainer\"><div class=\"spinner\" ng-if=\"vm.commissioni == null\"></div><div ng-if=\"vm.commissioni != null\"><table class=\"table table-hover\"><thead><tr><th class=\"statusColumn\"></th><th class=\"commissioneColumn\">Commissione</th><th class=\"tipologieColumn\">Tipologie di progetto</th><th></th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"vm.commissioni.length == 0\"><td colspan=\"4\">Nessuna commissione presente</td></tr><tr class=\"commissioneBox\" ng-repeat=\"commissione in vm.commissioni\" ng-click=\"vm.openCommissione(commissione.id)\"><td class=\"status\"><i class=\"fa fa-users\"></i></td><td><div class=\"titolo\">{{commissione.nome}}</div><div class=\"partecipanti\">Presidente: {{commissione.presidente.cognome}} {{commissione.presidente.nome}}</div><div class=\"partecipanti\"><span><b>{{commissione.nComponenti - (commissione.presidente != null ? 1 : 0)}}</b> membr{{commissione.nComponenti == 1 ? \'o\' : \'i\'}}</span></div></td><td class=\"tipologieProgetto\"><div ng-repeat=\"tipologia in commissione.tipologiaProgettoList\">{{tipologia.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"vm.eliminaCommissione(commissione.id); $event.stopPropagation();\" ng-if=\"!vm.editDisabled\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><button class=\"btn btn-default\" ui-sref=\"urNewCommissione\" ng-if=\"!vm.editDisabled\"><i class=\"fa fa-plus\"></i> Crea nuova commissione</button></div></div>");
$templateCache.put("app/components/listaCommissioniCert/listaCommissioniCert.html","<h1 class=\"page-header\">Commissioni</h1><div class=\"listaCommissioniContainer\"><div class=\"spinner\" ng-if=\"vm.commissioni == null\"></div><div ng-if=\"vm.commissioni != null\"><table class=\"table table-hover\"><thead><tr><th class=\"statusColumn\"></th><th class=\"commissioneColumn\">Commissione</th><th class=\"commissioneColumn\">Validità</th><th class=\"presidenteColumn\">Presidente</th><th></th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"vm.commissioni.length == 0\"><td colspan=\"4\">Nessuna commissione presente</td></tr><tr class=\"commissioneBox\" ng-repeat=\"commissione in vm.commissioni\" ng-click=\"vm.openCommissione(commissione.id)\"><td class=\"status\"><i class=\"fa fa-users\"></i></td><td><div class=\"titolo\">{{commissione.nome}}</div><div class=\"partecipanti\"><span><b>{{commissione.nComponenti - (commissione.presidente != null ? 1 : 0)}}</b> membr{{commissione.nComponenti == 1 ? \'o\' : \'i\'}}</span></div></td><td><div class=\"presidente\"><i class=\"fa fa-calendar\" style=\"margin-right: 5px;\"></i>Data inizio: {{commissione.dataInizio | date:\'dd/MM/yyyy HH:mm\'}}</div><div class=\"presidente\"><i class=\"fa fa-calendar\" style=\"margin-right: 5px;\"></i>Data fine: {{commissione.dataFine | date:\'dd/MM/yyyy HH:mm\'}}</div></td><td><div class=\"presidente\">{{commissione.presidente.cognome}} {{commissione.presidente.nome}}</div></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/listaDaRendicontare/listaDaRendicontare.html","<h1 class=\"page-header\">Rendicontazione Progetti</h1><div class=\"listaDaRendicontareContainer\"><div class=\"spinner\" ng-if=\"dRendListCtrl.rendProgetti == null\"></div><div ng-if=\"dRendListCtrl.rendProgetti != null\"><div class=\"well\"><div class=\"noResults\" ng-if=\"dRendListCtrl.rendProgetti.length == 0\">Al momento non hai nessun progetto da rendicontare</div><table class=\"table\" ng-if=\"(dRendListCtrl.rendProgetti | filter : {esito: {status: \'FINANZIATA\'}} : true).length > 0\"><thead><tr><th class=\"titoloSezione\">Progetti da rendicontare</th></tr></thead><tbody><tr class=\"rendProgettoBox\" ng-repeat=\"progetto in dRendListCtrl.rendProgetti\" ng-class=\"dRendListCtrl.getStatusRendicontazioneClass(progetto)\"><td class=\"centralColumn\"><div><table class=\"detailTable\"><tbody><tr><td><div class=\"titolo\">{{progetto.titolo ? progetto.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{progetto.tipologiaProgetto.nome}} - {{progetto.classe.nome}}</div><div class=\"partecipanti\">Responsabile: <span ng-class=\"{\'striked\': (progetto.titolare != null)}\">{{progetto.responsabile.cognome + \' \' + progetto.responsabile.nome}}</span><span ng-if=\"progetto.titolare != null\">&nbsp;{{progetto.titolare.cognome + \' \' + progetto.titolare.nome}}</span><span ng-repeat=\"componenti in progetto.nComponenti\">&nbsp;- <b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{progetto.numeroProtocollo}}</div><div class=\"margin-div\"><div class=\"open-proposta-btn\" ng-click=\"dRendListCtrl.openPropostaView(progetto)\"><i class=\"fa fa-fw fa-external-link\"></i> VISUALIZZA PROPOSTA</div></div></td><td class=\"data\">Anno finanziario<br>{{progetto.classe.anno}}</td><td class=\"role\">Partecipi al progetto come:<br><span ng-if=\"progetto.isTitolare\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!progetto.isTitolare && progetto.isResponsabile && progetto.titolare === null\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!progetto.isTitolare && progetto.isResponsabile && progetto.titolare !== null\"><i class=\"fa fa-user\"></i> Proponente</span><span ng-if=\"!progetto.isTitolare && !progetto.isResponsabile\"><i class=\"fa fa-users\"></i> {{progetto.categoriaUtente}}</span></td></tr></tbody></table></div><div><table class=\"rendicontazioneTable\" ng-repeat=\"step in progetto.stepRendicontazione\"><tbody><tr><th></th><th ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\">Data inizio</th><th ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\">Data scadenza</th><th ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">Inviata da</th><th ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">in data</th><th>Fin. concesso</th><th ng-if=\"step.rendicontazione !== null\">Fin. speso</th><td class=\"status\" rowspan=\"2\"><span ng-if=\"step.rendicontazione === null && (step.startTimestamp != null && step.startTimestamp < dRendListCtrl.now && step.endTimestamp != null && step.endTimestamp > dRendListCtrl.now)\" class=\"label label-default\">DA COMPILARE</span> <span ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'BOZZA\'\" class=\"label label-warning\">{{step.rendicontazione.status}}</span> <span ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\" class=\"label label-success\">{{step.rendicontazione.status}}</span> <span ng-if=\"step.endTimestamp != null && step.endTimestamp < dRendListCtrl.now && (step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\')\" class=\"label label-danger\">NON INVIATA</span></td><td class=\"withButton\" rowspan=\"2\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status !== \'BOZZA\'\"><button type=\"button\" uib-tooltip=\"Visualizza rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"dRendListCtrl.openRendicontazioneView(step.rendicontazione.id)\"><i class=\"fa fa-file-text-o\"></i></button></td><td class=\"withButton\" rowspan=\"2\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status === \'BOZZA\' && (progetto.isTitolare === true || (progetto.isResponsabile === true && progetto.titolare === null))\"><button type=\"button\" uib-tooltip=\"Compila rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"dRendListCtrl.openRendicontazione(step.rendicontazione.id)\"><i class=\"fa fa-pencil\"></i></button><button type=\"button\" uib-tooltip=\"Elimina rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"dRendListCtrl.eliminaRendicontazione(step.rendicontazione)\" style=\"margin-left: 5px;\"><i class=\"fa fa-times\"></i></button></td><td class=\"withButton\" rowspan=\"2\" ng-if=\"step.rendicontazione === null && (progetto.isTitolare === true || (progetto.isResponsabile === true && progetto.titolare === null)) && (step.startTimestamp != null && step.startTimestamp < dRendListCtrl.now && step.endTimestamp != null && step.endTimestamp > dRendListCtrl.now)\"><button type=\"button\" uib-tooltip=\"Compila rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"dRendListCtrl.newRendicontazione(progetto.id, step.stepId)\"><i class=\"fa fa-pencil\"></i></button></td><td class=\"withMessage\" rowspan=\"2\" ng-if=\"progetto.isTitolare !== true && (progetto.isResponsabile !== true || progetto.titolare !== null) && (step.rendicontazione == null || step.rendicontazione.status == \'BOZZA\')\"><div>La rendicontazione deve essere compilata dal responsabile</div></td></tr><tr class=\"stepRow\"><td class=\"rendLabel\">{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</td><td class=\"dateColumn\" ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\"><div class=\"finBox\" ng-if=\"step.startTimestamp != null\"><i class=\"fa fa-calendar\"></i> {{step.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</div><div class=\"small-text\" ng-if=\"step.startTimestamp == null\">da definire</div></td><td class=\"dateColumn\" ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\"><div class=\"finBox\" ng-if=\"step.endTimestamp != null\"><i class=\"fa fa-calendar\"></i> {{step.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</div><div class=\"small-text\" ng-if=\"step.endTimestamp == null\">da definire</div></td><td class=\"sentColumn\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">{{step.rendicontazione.cognomeResponsabile + \' \' + step.rendicontazione.nomeResponsabile}}</td><td class=\"sentColumn\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">{{step.rendicontazione.sendTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"finColumn\"><div class=\"finBox\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{progetto.esito.finanziamentoAssegnato | number}}</div><div class=\"finBox\" ng-if=\"progetto.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(progetto.esito.assegnoAssegnato ? progetto.esito.assegnoAssegnato : 0) | number}}</div></td><td class=\"finColumn\" ng-if=\"step.rendicontazione !== null\"><div class=\"finBox speso\" ng-if=\"step.rendicontazione != null\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{step.rendicontazione.finanziamentoSpeso | number}}</div><div class=\"finBox\" ng-if=\"step.rendicontazione != null && progetto.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(step.rendicontazione.assegnoSpeso ? step.rendicontazione.assegnoSpeso : 0) | number}}</div></td></tr></tbody></table></div></td></tr></tbody></table></div></div><div>Per vedere le rendicontazioni inviate, <a href=\"\" ui-sref=\"rendicontazioni\"><b><i class=\"fa fa-external-link-square\"></i> visualizza lo storico</b></a></div><div>Per scaricare le istruzioni della rendicontazione <a href=\"https://www.uniroma1.it/sites/default/files/field_file_allegati/istruzioni_rendicontazione_2020-2023_0.pdf\"><b><i class=\"fa fa-external-link-square\"></i>clicca qui</b></a></div></div>");
$templateCache.put("app/components/listaIstanze/listaIstanze.html","<div class=\"archivioIstanze\"><div><h1 class=\"page-header\">Archivio Istanze</h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"statusFilter\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-if=\"vm.isPresidente\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'1\'\" ng-disabled=\"vm.gettingList\">In bozza</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'ALL\'\" ng-disabled=\"vm.gettingList\">Tutte le proposte</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'6\'\" ng-disabled=\"vm.gettingList\">Da Approvare</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'2\'\" ng-disabled=\"vm.gettingList\">Approvata</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'3\'\" ng-disabled=\"vm.gettingList\">Approvata con condizione</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'4\'\" ng-disabled=\"vm.gettingList\">Richiesta Revisione</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'5\'\" ng-disabled=\"vm.gettingList\">Non Approvata</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'7\'\" ng-disabled=\"vm.gettingList\">Non Valutabile</label></div><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\" style=\"margin-right: 7px\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"vm.getProposte()\" placeholder=\"Cognome Responsabile\"></div></div></form></div></div><div class=\"archivioProgettiContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"hiddenHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Feed</div></th><th><div class=\"th-inner\">Commissione</div></th><th><div class=\"th-inner\">Valutazione</div></th><th><div class=\"th-inner\"></div></th></tr><tr class=\"fixedHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Feed</div></th><th><div class=\"th-inner\">Commissione</div></th><th><div class=\"th-inner\" style=\"transform: translateX(-6px)\">Valutazione</div></th><th><div class=\"th-inner\" style=\"right: 75px\"></div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"vm.proposte == null\"></div><div ng-if=\"vm.proposte != null\"><tr ng-if=\"vm.proposte.length == 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"progettoBox\" ng-repeat=\"proposta in vm.proposte\" ng-class=\"vm.getStatusClass(proposta.stato.codice)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta.stato.codice, proposta.stato.descrizione)\" uib-tooltip=\"{{vm.getStatus(proposta.stato.codice, proposta.stato.descrizione)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div><div ng-if=\"proposta.stato.id > 1\" class=\"sottotitolo\">Presentata il: {{proposta.dataInvio | date:\'dd/MM/yyyy HH:mm\'}}</div></td><td><div class=\"titolare\">{{proposta.utenteProponente.cognome}} {{proposta.utenteProponente.nome}}</div><div class=\"dipartimento\">{{proposta.utenteProponente.dipartimento}}</div></td><td class=\"withButton\"><button ng-if=\"proposta.stato.id != \'1\'\" type=\"button\" uib-tooltip=\"Feed Compilati\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openFeedCompilati(proposta.id)\" style=\"margin-left: 5px;\"><i class=\"fa fa-list-alt\"></i></button></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Membri commissione per tipologia\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openCommissioneTipologia(proposta.membroProposta)\" style=\"margin-left: 5px;\"><i class=\"fa fa-users\"></i></button></td><td class=\"withButton\"><div class=\"container-valutazione\"><div class=\"valBox\"><div ng-if=\"proposta.stato.id >= \'2\' && proposta.stato.id <= \'5\'\" class=\"punteggio-cert\" uib-tooltip=\"{{vm.getLabelStatoValutazione(proposta.stato.id)}}\"><p ng-if=\"proposta.stato.id == \'2\'\">A</p><p ng-if=\"proposta.stato.id == \'3\'\">C</p><p ng-if=\"proposta.stato.id == \'4\'\">R</p><p ng-if=\"proposta.stato.id == \'5\'\">N</p></div><button type=\"button\" ng-if=\"vm.visibilitaValutazioneList(proposta)\" uib-tooltip=\"Valuta Istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openIstanza(proposta)\" style=\"margin-left: 5px;\"><i class=\"fa fa-pencil\"></i></button><div style=\"transform: translateX(-4.2%); text-align: unset;\" class=\"read-notes\" ng-if=\"vm.hasNotes(proposta) && vm.visibilitaNote()\"><a href=\"\" ng-click=\"vm.openIstanzaNotes( proposta.id )\">Leggi note</a></div></div></div></td><td class=\"withButton\"><div class=\"btn-group\" uib-dropdown=\"\" ng-if=\"vm.checkDownloadDelibera(proposta.stato.id) && vm.isCert\"><button type=\"button\" class=\"btn btn-sm btn-default dropdown-toggle\" aria-expanded=\"false\" uib-dropdown-toggle=\"\"><i class=\"fa fa-download\"></i> <i class=\"fa fa-caret-down\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"{{vm.downloadDelibera(proposta.fileDeliberaMediaId)}}\">Delibera completa</a></li><li><a href=\"{{vm.downloadDelibera(proposta.fileDeliberaRidottoMediaId)}}\">Delibera ridotta</a></li></ul></div><a type=\"button\" ng-if=\"vm.checkDownloadDelibera(proposta.stato.id) && vm.loggedUser.id == proposta.utenteProponente.id\" uib-tooltip=\"Download Delibera\" target=\"_blank\" class=\"btn btn-sm btn-default\" ng-href=\"{{vm.downloadDelibera(proposta.fileDeliberaRidottoMediaId)}}\"><i class=\"fa fa-download\"></i></a> <a type=\"button\" ng-if=\"vm.checkDownloadDelibera(proposta.stato.id) && vm.loggedUser.presidenteCommissioneCert\" uib-tooltip=\"Download Delibera\" target=\"_blank\" class=\"btn btn-sm btn-default\" ng-href=\"{{vm.downloadDelibera(proposta.fileDeliberaMediaId)}}\"><i class=\"fa fa-download\"></i></a> <button ng-if=\"!vm.isPresidente\" type=\"button\" uib-tooltip=\"Visualizza dettaglio Istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.viewIstanza(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button><div ng-if=\"vm.isPresidente\" class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-default dropdown-toggle\" aria-expanded=\"false\" uib-dropdown-toggle=\"\"><i class=\"fa fa-caret-down\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\" ng-click=\"vm.viewIstanza(proposta.id)\">Visualizza dettaglio Istanza</a></li><li ng-if=\"proposta.stato.id === 6\"><a href=\"\" ng-click=\"vm.riapriIstanza(proposta.id)\">Riapri Istanza</a></li></ul></div></td></tr></div></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span> <a target=\"_new\" ng-if=\"vm.selectedStatusValutazione == \'7\'\" class=\"btn btn-sm btn-default exportButton exportNonValutabile\" uib-tooltip=\"Esporta l\'elenco delle istanze in stato Non Valutabile\" ng-click=\"vm.getCsvExportUrlProposte()\"><i class=\"fa fa-file-o\"></i> Esporta istanze non valutabili</a><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposte(true)\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/listaIstanzeUser/listaIstanzeUser.html","<div class=\"page-header flex-center\"><h1>Istanze</h1><a ng-if=\"vm.loggedUser.utente.profiloValidato == false\" disabled=\"\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square-o\"></i> Crea un\'istanza</a> <a ng-if=\"vm.loggedUser.utente.profiloValidato == true\" ng-click=\"vm.creaNuovaProposta()\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square-o\"></i> Crea un\'istanza</a></div><div class=\"listaProposteContainer\"><div class=\"spinner\" ng-if=\"vm.proposte == null || vm.loading\"></div><div ng-if=\"vm.proposte != null\"><div class=\"noResults\" ng-if=\"vm.proposte.length == 0\">Non hai ancora creato nessuna istanza.</div><table class=\"table table-hover\" ng-if=\"( vm.proposte | filter : { stato: { codice: 1 } } ).length > 0\"><thead><tr><th colspan=\"5\">In Bozza</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 1 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div></td><td class=\"data\">Data ultima modifica:<br>{{proposta.lastUpdate | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.goToPropostaEdit(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button> <button type=\"button\" uib-tooltip=\"Elimina istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.eliminaProposta(proposta.id)\" style=\"margin-left: 5px;\"><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : { stato: { codice: 6 } } ).length > 0\"><thead><tr><th colspan=\"5\">Inviate</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 6 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td class=\"data\">Data invio:<br>{{proposta.lastUpdate | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : { stato: { codice: 2 } } ).length > 0\"><thead><tr><th colspan=\"5\">Approvate</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 2 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td class=\"data\">Data invio:<br>{{proposta.creationTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"data\">Data approvazione:<br>{{proposta.dataValutazione | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><a type=\"button\" uib-tooltip=\"Download Delibera\" target=\"_blank\" class=\"btn btn-sm btn-default\" ng-href=\"{{vm.downloadDelibera(proposta.fileDeliberaRidottoMediaId)}}\"><i class=\"fa fa-download\"></i></a> <button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : { stato: { codice: 3 } } ).length > 0\"><thead><tr><th colspan=\"5\">Approvate con condizione</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 3 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td class=\"data\">Data invio:<br>{{proposta.creationTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"data\">Data approvazione:<br>{{proposta.dataValutazione | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><a type=\"button\" uib-tooltip=\"Download Delibera\" target=\"_blank\" class=\"btn btn-sm btn-default\" ng-href=\"{{vm.downloadDelibera(proposta.fileDeliberaRidottoMediaId)}}\"><i class=\"fa fa-download\"></i></a> <button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : { stato: { codice: 4 } } ).length > 0\"><thead><tr><th colspan=\"5\">Richiesta Revisione</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 4 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td class=\"data\">Data invio:<br>{{proposta.creationTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"data\">Data rifiuto:<br>{{proposta.dataValutazione | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><a type=\"button\" uib-tooltip=\"Download Delibera\" target=\"_blank\" class=\"btn btn-sm btn-default\" ng-href=\"{{vm.downloadDelibera(proposta.fileDeliberaRidottoMediaId)}}\"><i class=\"fa fa-download\"></i></a> <button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : { stato: { codice: 5 } } ).length > 0\"><thead><tr><th colspan=\"5\">Non approvata</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 5 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td class=\"data\">Data invio:<br>{{proposta.creationTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"data\">Data rifiuto:<br>{{proposta.lastUpdate | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><a type=\"button\" uib-tooltip=\"Download Delibera\" target=\"_blank\" class=\"btn btn-sm btn-default\" ng-href=\"{{vm.downloadDelibera(proposta.fileDeliberaRidottoMediaId)}}\"><i class=\"fa fa-download\"></i></a> <button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : { stato: { codice: 7 } } ).length > 0\"><thead><tr><th colspan=\"5\">Non valutabile</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : { stato: { codice: 7 } }\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td class=\"data\">Data invio:<br>{{proposta.creationTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza istanza\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/listaProposte/listaProposte.html","<h1 class=\"page-header\">Proposte <small>{{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getProposteERichieste()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"listaProposteContainer\"><div class=\"spinner\" ng-if=\"vm.proposte == null || vm.richieste == null\"></div><div ng-if=\"vm.proposte != null && vm.richieste != null\"><div class=\"noResults\" ng-if=\"vm.proposte.length == 0 && vm.richieste.length == 0\">Non hai partecipato a nessuna proposta per l\'anno selezionato</div><table class=\"table\" ng-if=\"(vm.richieste | filter : {status: \'PENDING\'}).length > 0\"><thead><tr><th colspan=\"4\">Richieste di partecipazione</th></tr></thead><tbody><tr class=\"richiestaBox\" ng-repeat=\"richiesta in vm.richieste | filter : {status: \'PENDING\'}\" ng-class=\"vm.getStatusClass(richiesta.proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(richiesta.proposta)\"></i></td><td><div class=\"titolo\">{{richiesta.proposta.titolo ? richiesta.proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{richiesta.proposta.tipologiaProgetto.nome}} - {{richiesta.proposta.classe.nome}}</div><div class=\"partecipanti\">Responsabile: {{richiesta.proposta.responsabile.cognome + \' \' + richiesta.proposta.responsabile.nome}} - <a href=\"\" ng-click=\"vm.visualizzaAbstract(richiesta)\">visualizza abstract</a></div></td><td class=\"role\">Sei stato indicato come:<br><span><i class=\"fa fa-users\"></i> {{richiesta.categoria.descrizioneSingolare}}</span></td><td class=\"confirm\"><button class=\"btn btn-default\" ng-click=\"vm.accettaPartecipazione(richiesta)\"><i class=\"fa fa-check\"></i> Accetta</button><button class=\"btn btn-default\" ng-click=\"vm.rifiutaPartecipazione(richiesta)\"><i class=\"fa fa-times\"></i> Rifiuta</button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : {status: \'BOZZA\'}).length > 0\"><thead><tr><th colspan=\"5\">In corso di compilazione</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : {status: \'BOZZA\'}\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\">Responsabile: {{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}<span ng-repeat=\"componenti in proposta.nComponenti\">&nbsp;- <b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div></td><td class=\"data\">ultima modifica:<br>{{proposta.lastUpdate | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"role\">Partecipi al progetto come:<br><span ng-if=\"proposta.isResponsabile\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!proposta.isResponsabile\"><i class=\"fa fa-users\"></i> {{proposta.categoriaUtente}}</span></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Compila proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta)\"><i class=\"fa fa-pencil\"></i></button><button type=\"button\" uib-tooltip=\"Elimina proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.eliminaProposta(proposta)\" ng-if=\"proposta.isResponsabile\" style=\"margin-left: 5px;\"><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : {status: \'INVIATA\', esito: null}).length > 0\"><thead><tr><th colspan=\"5\">Inviate</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : {status: \'INVIATA\', esito: null}\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\">Responsabile: {{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}<span ng-repeat=\"componenti in proposta.nComponenti\">&nbsp;- <b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div><div ng-if=\"proposta.indicatoriValutazione === true\"><a class=\"indicatoriLink\" ng-click=\"vm.openIndicatori(proposta)\"><i class=\"fa fa-table\"></i>Indicatori</a></div></td><td class=\"data\">inviata in data:<br>{{proposta.sendTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"role\">Partecipi al progetto come:<br><span ng-if=\"proposta.isResponsabile\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!proposta.isResponsabile\"><i class=\"fa fa-users\"></i> {{proposta.categoriaUtente}}</span></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openPropostaView(proposta)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : {esito: {status: \'FINANZIATA\'}} : true).length > 0\"><thead><tr><th colspan=\"3\">Finanziate</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : {esito: {status: \'FINANZIATA\'}} : true\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td class=\"centralColumn\"><div><table class=\"detailTable\"><tbody><tr><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\">Responsabile: {{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}<span ng-repeat=\"componenti in proposta.nComponenti\">&nbsp;- <b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div><div ng-if=\"proposta.indicatoriValutazione === true\"><a class=\"indicatoriLink\" ng-click=\"vm.openIndicatori(proposta)\"><i class=\"fa fa-table\"></i>Indicatori</a></div></td><td class=\"data\">inviata in data:<br>{{proposta.sendTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"role\">Partecipi al progetto come:<br><span ng-if=\"proposta.isResponsabile\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!proposta.isResponsabile\"><i class=\"fa fa-users\"></i> {{proposta.categoriaUtente}}</span></td></tr></tbody></table></div><div ng-if=\"proposta.esito != null\"><table class=\"esitoTable\"><thead><tr><th>Valutazione</th><th>Fin. richiesto</th><th>Fin. concesso</th></tr></thead><tbody><tr><td class=\"valColumn\"><div class=\"valBox\"><div class=\"esitoSpeciale\" ng-if=\"proposta.esito.esitoSpeciale == \'NON_AMMISSIBILE\'\">non ammissibile</div><div ng-if=\"proposta.esito.esitoSpeciale != \'NON_AMMISSIBILE\'\"><div class=\"punteggio\" uib-tooltip=\"{{proposta.esito.punteggio*1 != proposta.esito.punteggio.toFixed(1)*1 ? proposta.esito.punteggio : \'\'}}\"><i ng-if=\"proposta.esito.esitoSpeciale == \'RESPINTA\'\" class=\"fa fa-thumbs-o-down\"></i> <i ng-if=\"proposta.esito.esitoSpeciale != \'RESPINTA\' && proposta.esito.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{proposta.esito.punteggio !== null ? (proposta.esito.punteggio).toFixed(1)*1 : \'\'}}</div><div class=\"valutatori\" ng-if=\"proposta.esito.valutazioni != null && proposta.esito.valutazioni.length > 0\"><div ng-repeat=\"valutazione in proposta.esito.valutazioni\" ng-if=\"proposta.esito.valutazioni.length == 1\"><a class=\"tableButton\" ng-click=\"vm.showValutazione(proposta, valutazione)\">visualizza scheda</a></div><div class=\"valRow\" ng-repeat=\"valutazione in proposta.esito.valutazioni\" ng-if=\"proposta.esito.valutazioni.length > 1\">Referee {{$index + 1}} <span class=\"valore\">{{valutazione.punteggio}}<a class=\"tableButton scheda\" ng-click=\"vm.showValutazione(proposta, valutazione)\">scheda</a></span></div></div><div class=\"valutatori\" ng-if=\"proposta.esito.fasiValutazione != null && proposta.esito.fasiValutazione.length > 0\"><div><a class=\"tableButton\" ng-click=\"vm.showDettagliEsito(proposta)\">visualizza dettagli</a></div></div></div></div></td><td class=\"finColumn\"><div class=\"finBox\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.finanziamentoRichiesto | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.assegnoRichiesto | number}}</div></div></div></td><td class=\"finColumn\"><div class=\"finBox assegnato\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.esito.finanziamentoAssegnato | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(proposta.esito.assegnoAssegnato ? proposta.esito.assegnoAssegnato : 0) | number}}</div></div><a class=\"tableButton comment\" ng-if=\"proposta.esito.commento && proposta.esito.commento != \'\'\" ng-click=\"vm.mostraCommentoFinanziamento(proposta.esito.commento)\"><i class=\"fa fa-file-text-o\" uib-tooltip=\"Commento\"></i></a></div></td></tr></tbody></table></div></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openPropostaView(proposta)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table><table class=\"table table-hover\" ng-if=\"(vm.proposte | filter : {esito: {status: \'NON_FINANZIATA\'}} : true).length > 0\"><thead><tr><th colspan=\"3\">Non Finanziate</th></tr></thead><tbody><tr class=\"propostaBox\" ng-repeat=\"proposta in vm.proposte | filter : {esito: {status: \'NON_FINANZIATA\'}} : true\" ng-class=\"vm.getStatusClass(proposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta)\" uib-tooltip=\"{{vm.getStatus(proposta)}}\"></i></td><td class=\"centralColumn\"><div><table class=\"detailTable\"><tbody><tr><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\">Responsabile: {{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}<span ng-repeat=\"componenti in proposta.nComponenti\">&nbsp;- <b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div><div ng-if=\"proposta.indicatoriValutazione === true\"><a class=\"indicatoriLink\" ng-click=\"vm.openIndicatori(proposta)\"><i class=\"fa fa-table\"></i>Indicatori</a></div></td><td class=\"data\">inviata in data:<br>{{proposta.sendTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"role\">Partecipi al progetto come:<br><span ng-if=\"proposta.isResponsabile\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!proposta.isResponsabile\"><i class=\"fa fa-users\"></i> {{proposta.categoriaUtente}}</span></td></tr></tbody></table></div><div ng-if=\"proposta.esito != null\"><table class=\"esitoTable\"><thead><tr><th>Valutazione</th><th>Fin. richiesto</th><th>Fin. concesso</th></tr></thead><tbody><tr><td class=\"valColumn\"><div class=\"valBox\"><div class=\"esitoSpeciale\" ng-if=\"proposta.esito.esitoSpeciale == \'NON_AMMISSIBILE\'\">non ammissibile</div><div ng-if=\"proposta.esito.esitoSpeciale != \'NON_AMMISSIBILE\'\"><div class=\"punteggio\" uib-tooltip=\"{{proposta.esito.punteggio*1 != proposta.esito.punteggio.toFixed(1)*1 ? proposta.esito.punteggio : \'\'}}\"><i ng-if=\"proposta.esito.esitoSpeciale == \'RESPINTA\'\" class=\"fa fa-thumbs-o-down\"></i> <i ng-if=\"proposta.esito.esitoSpeciale != \'RESPINTA\' && proposta.esito.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{proposta.esito.punteggio !== null ? (proposta.esito.punteggio).toFixed(1)*1 : \'\'}}</div><div class=\"valutatori\" ng-if=\"proposta.esito.valutazioni != null && proposta.esito.valutazioni.length > 0\"><div ng-repeat=\"valutazione in proposta.esito.valutazioni\" ng-if=\"proposta.esito.valutazioni.length == 1\"><a class=\"tableButton\" ng-click=\"vm.showValutazione(proposta, valutazione)\">visualizza scheda</a></div><div class=\"valRow\" ng-repeat=\"valutazione in proposta.esito.valutazioni\" ng-if=\"proposta.esito.valutazioni.length > 1\">Referee {{$index + 1}} <span class=\"valore\">{{valutazione.punteggio}}<a class=\"tableButton scheda\" ng-click=\"vm.showValutazione(proposta, valutazione)\">scheda</a></span></div></div><div class=\"valutatori\" ng-if=\"proposta.esito.fasiValutazione != null && proposta.esito.fasiValutazione.length > 0\"><div><a class=\"tableButton\" ng-click=\"vm.showDettagliEsito(proposta)\">visualizza dettagli</a></div></div></div></div></td><td class=\"finColumn\"><div class=\"finBox\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.finanziamentoRichiesto | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.assegnoRichiesto | number}}</div></div></div></td><td class=\"finColumn\"><div class=\"finBox assegnato\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.esito.finanziamentoAssegnato | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(proposta.esito.assegnoAssegnato ? proposta.esito.assegnoAssegnato : 0) | number}}</div></div><a class=\"tableButton comment\" ng-if=\"proposta.esito.commento && proposta.esito.commento != \'\'\" ng-click=\"vm.mostraCommentoFinanziamento(proposta.esito.commento)\"><i class=\"fa fa-file-text-o\" uib-tooltip=\"Commento\"></i></a></div></td></tr></tbody></table></div></td><td class=\"withButton\"><button type=\"button\" uib-tooltip=\"Visualizza proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openPropostaView(proposta)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/listaRad/listaRad.html","<h1 class=\"page-header\">Dipartimenti</h1><div class=\"listaRad\"><div class=\"spinner\" ng-if=\"listaRadCtrl.dipartimenti == null\"></div><div ng-if=\"listaRadCtrl.dipartimenti != null\"><table class=\"table table-hover\"><thead><tr><th class=\"dipartimentoColumn\">Dipartimento</th><th class=\"radColumn\">RAD</th><th></th><th class=\"radColumn\">Referente</th><th></th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"(listaRadCtrl.dipartimenti | filter : {valido: true} : true).length == 0\"><td colspan=\"5\">Nessun dipartimento valido presente</td></tr><tr class=\"dipartimentoBox\" ng-repeat=\"dipartimento in listaRadCtrl.dipartimenti | filter : {valido: true} : true\"><td class=\"dipartimentoColumn\">{{dipartimento.nome}}</td><td class=\"radColumn\"><div ng-repeat=\"rad in dipartimento.radList\">{{rad.cognome + \' \' + rad.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"listaRadCtrl.editRadDipartimento(dipartimento.id)\"><i class=\"fa fa-pencil\"></i></a></td><td class=\"radColumn\"><div ng-repeat=\"referee in dipartimento.refereeList\">{{referee.cognome + \' \' + referee.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"listaRadCtrl.editRefeereDipartimento(dipartimento.id)\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table><div ng-if=\"(listaRadCtrl.dipartimenti | filter : {valido: false} : true).length > 0\"><br><div><strong>Dipartimenti non più validi (perché eliminati, rinominati o fusi)</strong></div><br><table class=\"table table-hover\"><thead><tr><th class=\"dipartimentoColumn\">Dipartimento</th><th class=\"radColumn\">RAD</th><th></th><th class=\"radColumn\">Referente</th><th></th></tr></thead><tbody class=\"dipNonValidi\"><tr class=\"dipartimentoBox\" ng-repeat=\"dipartimento in listaRadCtrl.dipartimenti | filter : {valido: false} : true\"><td class=\"dipartimentoColumn\">{{dipartimento.nome}}</td><td class=\"radColumn\"><div ng-repeat=\"rad in dipartimento.radList\">{{rad.cognome + \' \' + rad.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"listaRadCtrl.editRadDipartimento(dipartimento.id)\"><i class=\"fa fa-pencil\"></i></a></td><td class=\"radColumn\"><div ng-repeat=\"direttore in dipartimento.direttoreList\">{{direttore.cognome + \' \' + direttore.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"listaRadCtrl.editRefeereDipartimento(dipartimento.id)\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/listaRadStrutture/listaRadStrutture.html","<h1 class=\"page-header\">Strutture</h1><div class=\"listaRadStrutture\"><div class=\"spinner\" ng-if=\"listaRadStruttureCtrl.strutture == null\"></div><div ng-if=\"listaRadStruttureCtrl.strutture != null\"><table class=\"table table-hover\"><thead><tr><th class=\"strutturaColumn\">Struttura</th><th class=\"radColumn\">RAD</th><th></th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"listaRadStruttureCtrl.strutture.length == 0\"><td colspan=\"5\">Nessuna struttura valida presente</td></tr><tr class=\"strutturaBox\" ng-repeat=\"struttura in listaRadStruttureCtrl.strutture\"><td class=\"strutturaColumn\">{{struttura.nome}}</td><td class=\"radColumn\"><div ng-repeat=\"rad in struttura.radList\">{{rad.cognome + \' \' + rad.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"listaRadStruttureCtrl.editRadStruttura(struttura.id)\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table><div ng-if=\"(listaRadStruttureCtrl.strutture | filter : {valido: false} : true).length > 0\"><br><div><strong>Strutture non più valide (perché eliminati, rinominati o fusi)</strong></div><br><table class=\"table table-hover\"><thead><tr><th class=\"strutturaColumn\">Struttura</th><th class=\"radColumn\">RAD</th><th></th></tr></thead><tbody class=\"dipNonValidi\"><tr class=\"strutturaBox\" ng-repeat=\"struttura in listaRadStruttureCtrl.strutture | filter : {valido: false} : true\"><td class=\"strutturaColumn\">{{struttura.nome}}</td><td class=\"radColumn\"><div ng-repeat=\"rad in struttura.radList\">{{rad.cognome + \' \' + rad.nome}}</div></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"listaRadStruttureCtrl.editRadStruttura(struttura.id)\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/listaRendicontazioni/listaRendicontazioni.html","<h1 class=\"page-header\">Storico Progetti <small>{{rendListCtrl.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"rendListCtrl.getRendicontazioni()\" ng-model=\"rendListCtrl.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (rendListCtrl.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"listaRendicontazioniContainer\"><div class=\"spinner\" ng-if=\"rendListCtrl.rendProgetti == null\"></div><div ng-if=\"rendListCtrl.rendProgetti != null\"><div class=\"noResults\" ng-if=\"rendListCtrl.rendProgetti.length == 0\">Non hai nessun progetto finanziato per l\'anno finanziario {{rendListCtrl.selectedAnno.anno}}</div><table class=\"table table-hover\" ng-if=\"(rendListCtrl.rendProgetti | filter : {esito: {status: \'FINANZIATA\'}} : true).length > 0\"><tbody><tr class=\"rendProgettoBox\" ng-repeat=\"progetto in rendListCtrl.rendProgetti\" ng-class=\"rendListCtrl.getStatusRendicontazioneClass(progetto)\"><td class=\"centralColumn\"><div><table class=\"detailTable\"><tbody><tr><td><div class=\"titolo\">{{progetto.titolo ? progetto.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{progetto.tipologiaProgetto.nome}} - {{progetto.classe.nome}}</div><div class=\"partecipanti\">Responsabile: <span ng-class=\"{\'striked\': (progetto.titolare != null)}\">{{progetto.responsabile.cognome + \' \' + progetto.responsabile.nome}}</span><span ng-if=\"progetto.titolare != null\">&nbsp;{{progetto.titolare.cognome + \' \' + progetto.titolare.nome}}</span><span ng-repeat=\"componenti in progetto.nComponenti\">&nbsp;- <b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{progetto.numeroProtocollo}}</div><div class=\"margin-div\"><div class=\"open-proposta-btn\" ng-click=\"rendListCtrl.openPropostaView(progetto)\"><i class=\"fa fa-fw fa-external-link\"></i> VISUALIZZA PROPOSTA</div></div></td><td class=\"role\">Partecipi al progetto come:<br><span ng-if=\"progetto.isTitolare\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!progetto.isTitolare && progetto.isResponsabile && progetto.titolare === null\"><i class=\"fa fa-user\"></i> Responsabile</span><span ng-if=\"!progetto.isTitolare && progetto.isResponsabile && progetto.titolare !== null\"><i class=\"fa fa-user\"></i> Proponente</span><span ng-if=\"!progetto.isTitolare && !progetto.isResponsabile\"><i class=\"fa fa-users\"></i> {{progetto.categoriaUtente}}</span></td></tr></tbody></table></div><div><table class=\"rendicontazioneTable\" ng-repeat=\"step in progetto.stepRendicontazione\"><tbody><tr><th></th><th ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\">Data inizio</th><th ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\">Data scadenza</th><th ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">Inviata da</th><th ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">in data</th><th>Fin. concesso</th><th ng-if=\"step.rendicontazione !== null\">Fin. speso</th><td class=\"status\" rowspan=\"2\"><span ng-if=\"step.rendicontazione === null && (step.startTimestamp != null && step.startTimestamp < rendListCtrl.now && step.endTimestamp != null && step.endTimestamp > rendListCtrl.now)\" class=\"label label-default\">DA COMPILARE</span> <span ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'BOZZA\'\" class=\"label label-warning\">{{step.rendicontazione.status}}</span> <span ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\" class=\"label label-success\">{{step.rendicontazione.status}}</span> <span ng-if=\"step.endTimestamp != null && step.endTimestamp < rendListCtrl.now && (step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\')\" class=\"label label-danger\">NON INVIATA</span></td><td class=\"withButton\" rowspan=\"2\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status !== \'BOZZA\'\"><button type=\"button\" uib-tooltip=\"Visualizza rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"rendListCtrl.openRendicontazioneView(step.rendicontazione.id)\"><i class=\"fa fa-file-text-o\"></i></button></td><td class=\"withButton\" rowspan=\"2\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status === \'BOZZA\' && (progetto.isTitolare === true || (progetto.isResponsabile === true && progetto.titolare === null))\"><button type=\"button\" uib-tooltip=\"Compila rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"rendListCtrl.openRendicontazione(step.rendicontazione.id)\"><i class=\"fa fa-pencil\"></i></button><button type=\"button\" uib-tooltip=\"Elimina rendicontazione\" class=\"btn btn-sm btn-default\" ng-click=\"rendListCtrl.eliminaRendicontazione(step.rendicontazione)\" style=\"margin-left: 5px;\"><i class=\"fa fa-times\"></i></button></td><td class=\"withMessage\" rowspan=\"2\" ng-if=\"progetto.isTitolare !== true && (progetto.isResponsabile !== true || progetto.titolare !== null) && (step.rendicontazione == null || step.rendicontazione.status == \'BOZZA\')\"><div>La rendicontazione deve essere compilata dal responsabile</div></td></tr><tr class=\"stepRow\"><td class=\"rendLabel\"><span class=\"sentIcon\" ng-if=\"step.rendicontazione != null && step.rendicontazione.status == \'INVIATA\'\" uib-tooltip=\"Inviata\"><i class=\"fa fa-check\"></i></span>{{step.nome != null ? \'Rend. \' + step.nome : \'Rendicontazione\'}}</td><td class=\"dateColumn\" ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\"><div class=\"finBox\" ng-if=\"step.startTimestamp != null\"><i class=\"fa fa-calendar\"></i> {{step.startTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</div><div class=\"small-text\" ng-if=\"step.startTimestamp == null\">da definire</div></td><td class=\"dateColumn\" ng-if=\"step.rendicontazione === null || step.rendicontazione.status != \'INVIATA\'\"><div class=\"finBox\" ng-if=\"step.endTimestamp != null\"><i class=\"fa fa-calendar\"></i> {{step.endTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</div><div class=\"small-text\" ng-if=\"step.endTimestamp == null\">da definire</div></td><td class=\"sentColumn\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">{{step.rendicontazione.cognomeResponsabile + \' \' + step.rendicontazione.nomeResponsabile}}</td><td class=\"sentColumn\" ng-if=\"step.rendicontazione !== null && step.rendicontazione.status == \'INVIATA\'\">{{step.rendicontazione.sendTimestamp | date:\'dd/MM/yyyy HH:mm\'}}</td><td class=\"finColumn\"><div class=\"finBox\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{progetto.esito.finanziamentoAssegnato | number}}</div><div class=\"finBox\" ng-if=\"progetto.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(progetto.esito.assegnoAssegnato ? progetto.esito.assegnoAssegnato : 0) | number}}</div></td><td class=\"finColumn\" ng-if=\"step.rendicontazione !== null\"><div class=\"finBox speso\" ng-if=\"step.rendicontazione != null\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{step.rendicontazione.finanziamentoSpeso | number}}</div><div class=\"finBox\" ng-if=\"step.rendicontazione != null && progetto.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{(step.rendicontazione.assegnoSpeso ? step.rendicontazione.assegnoSpeso : 0) | number}}</div></td></tr></tbody></table></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/modaleTerzaMissione/modaleTerzaMissione.html","<h3>Rendicontazione</h3><div class=\"well nice-spaces\"><div class=\"form-group\"><label>Titolo</label> <span>{{vm.proposta.titolo}}</span></div><div class=\"form-group\"><label>Responsabile</label> <span>{{vm.proposta.responsabile.cognome}} {{vm.proposta.responsabile.nome | lowercase}}</span></div><div class=\"form-group\"><label>Macroarea</label> <span>{{vm.proposta.responsabile.dipartimento.macroArea.nome}}</span></div><div class=\"form-group\" style=\"margin-bottom: 0;\"><label>Dipartimento</label> <span>{{vm.proposta.responsabile.dipartimento.facolta.nome}}</span></div><div class=\"form-group\" style=\"margin-bottom: 0;\"><label>Tipologia e Classe</label> <label>{{vm.proposta.classe.nome}}</label></div></div><div class=\"input-wrap\"><label><p>La rendicontazione è soddisfacente?</p></label><div class=\"radio-wrap\"><label ng-repeat=\"key in vm.set.valori\" class=\"radio-inline\"><input ng-disabled=\"vm.validita == false\" type=\"radio\" ng-attr-name=\"radio-{{key.id}}\" ng-model=\"vm.set.valoreDatoProposta\" ng-value=\"key.valore\"><p ng-bind-html=\"key.valore\"></p></label></div><div class=\"form-group commentoBox\" style=\"width: 100%\"><label for=\"comment\" style=\"text-align: center;width: 100%;\"><span>Eventuale commento</span></label> <textarea class=\"form-control\" rows=\"4\" ng-if=\"vm.validita !== false\" ng-model=\"vm.set.valoreNota\">\n                    </textarea><div class=\"well readonlyValue\" ng-if=\"vm.validita == false\">{{vm.set.valoreNota}}</div></div></div><div ng-if=\"vm.validita\" class=\"ngdialog-buttons align-end\"><button ng-disabled=\"vm.set.valoreDatoProposta == null\" class=\"btn btn-primary\" ng-click=\"vm.handleSuccess(false)\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>Salva</button> <button ng-disabled=\"vm.set.valoreDatoProposta == null\" class=\"btn btn-primary\" ng-click=\"vm.handleSuccess(true)\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i>Salva e Concludi</button></div>");
$templateCache.put("app/components/profiloUtente/profiloUtente.html","<div class=\"profiloUtente\"><div class=\"spinner\" ng-if=\"profiloCtrl.data == null\"></div><div class=\"alert alert-success\" ng-if=\"profiloCtrl.salvato\"><i class=\"fa fa-check\"></i> Profilo confermato con successo</div><div ng-if=\"profiloCtrl.data != null\"><div class=\"alert alert-warning\" ng-if=\"!profiloCtrl.data.profiloValidato && profiloCtrl.data.ruolo.sistema == \'UGOV\'\"><b><i class=\"fa fa-warning\"></i> ATTENZIONE</b> - Prima di poter creare istanze da presentare al CER devi confermare le informazioni del tuo profilo.<br><br>Per fare ciò devi:<ol class=\"profiloInstructions\"><li><b>controllare la correttezza delle informazioni contenute nella sezione <i>Informazioni prelevate da UGOV</i></b><br><span>Qualora ci fossero informazioni errate, invia un\'e-mail ad uno dei seguenti indirizzi, segnalando gli errori. L\'Ufficio predisposto provvederà a far modificare le informazioni su UGOV.<br><ul><li>Comitato etico ricerca <a href=\"mailto:comitato.cer@uniba.it\">comitato.cer@uniba.it</a></li></ul>Dopo la correzione, affinché tali modifiche siano visibili in questa pagina, clicca sul bottone <i>Aggiorna da UGOV</i>.</span></li><li>compilare la sezione <i>Informazioni dichiarate dall\'utente</i></li><li>cliccare sul bottone <i>Salva</i></li></ol></div><div class=\"alert alert-warning\" ng-if=\"!profiloCtrl.data.profiloValidato && profiloCtrl.data.ruolo.sistema == \'SIGEBA\' && profiloCtrl.data.ruolo.codice != \'S-IN\'\"><b><i class=\"fa fa-warning\"></i> ATTENZIONE</b> - Prima di poter creare istanze da presentare al CER devi confermare le informazioni del tuo profilo.<br><br>Per fare ciò devi:<ol class=\"profiloInstructions\"><li><b>controllare la correttezza delle informazioni contenute nella sezione <i>Informazioni presenti sul sistema</i></b><br><span>Qualora ci fossero informazioni errate, invia un\'e-mail ad uno dei seguenti indirizzi, segnalando gli errori. L\'Ufficio predisposto provvederà a far modificare le informazioni sul sistema.</span><ul><li>Comitato etico ricerca <a href=\"mailto:comitato.cer@uniba.it\">comitato.cer@uniba.it</a></li></ul></li><li>compilare la sezione <i>Informazioni dichiarate dall\'utente</i></li><li>cliccare sul bottone <i>Salva</i></li></ol></div><div class=\"alert alert-danger\" ng-if=\"!profiloCtrl.data.profiloValidato && profiloCtrl.data.ruolo.sistema == \'SIGEBA\' && profiloCtrl.data.ruolo.codice == \'S-IN\' && profiloCtrl.data.esterno == null\"><b><i class=\"fa fa-warning\"></i> ATTENZIONE</b> - Per questo utente, su UGOV non risulta più un ruolo attivo valido ai fini della presentazione delle istanze al CER.<br><br>Puoi provare a prelevare nuovamente le informazioni da UGOV cliccando sul bottone <i>Aggiorna da UGOV</i>.<br>Qualora ci fossero informazioni errate, invia un\'e-mail ad uno dei seguenti indirizzi, segnalando gli errori. L\'Ufficio predisposto provvederà a far modificare le informazioni su UGOV.<br><ul><li>Comitato etico ricerca <a href=\"mailto:comitato.cer@uniba.it\">comitato.cer@uniba.it</a></li></ul>Dopo la correzione, affinché tali modifiche siano visibili in questa pagina, clicca sul bottone <i>Aggiorna da UGOV</i>.</div><h4 ng-if=\"profiloCtrl.data.ruolo.sistema == \'UGOV\'\">Informazioni prelevate da UGOV<button class=\"btn btn-default\" ng-if=\"!profiloCtrl.data.profiloValidato\" ng-click=\"profiloCtrl.aggiornaUgov()\"><i class=\"fa fa-refresh\" style=\"margin-right: 8px;\"></i>Aggiorna da UGOV</button></h4><h4 ng-if=\"profiloCtrl.data.ruolo.sistema == \'SIGEBA\' && profiloCtrl.data.ruolo.codice != \'S-IN\'\">Informazioni presenti sul sistema</h4><h4 ng-if=\"profiloCtrl.data.ruolo.sistema == \'SIGEBA\' && profiloCtrl.data.ruolo.codice == \'S-IN\' && profiloCtrl.data.esterno == null\">Informazioni prelevate da UGOV<button class=\"btn btn-default\" ng-if=\"!profiloCtrl.data.profiloValidato\" ng-click=\"profiloCtrl.aggiornaUgov()\"><i class=\"fa fa-refresh\" style=\"margin-right: 8px;\"></i>Aggiorna da UGOV</button></h4><div class=\"well\"><div class=\"form-group valueRow\"><label>Cognome</label> <span>{{profiloCtrl.data.utente.cognome}}&nbsp;</span></div><div class=\"form-group valueRow\"><label>Nome</label> <span>{{profiloCtrl.data.utente.nome}}&nbsp;</span></div><div class=\"form-group valueRow\"><label>Data di nascita</label> <span>{{profiloCtrl.data.utente.dataDiNascita}}&nbsp;</span></div><div class=\"form-group valueRow\"><label>Codice Fiscale</label> <span>{{profiloCtrl.data.utente.codiceFiscale}}&nbsp;</span></div><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.esterno == null\"><label>Qualifica</label> <span>{{profiloCtrl.data.ruolo.descrizione}}&nbsp;</span></div><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.regime !== null\"><label>Regime</label> <span>{{profiloCtrl.data.regime}}&nbsp;</span></div><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.esterno == null\"><label>Termine Rapporto</label> <span>{{profiloCtrl.data.dataTermineRapporto}}&nbsp;</span></div><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.esterno == null\"><label>Dipartimento</label> <span>{{profiloCtrl.data.dipartimentoManuale && profiloCtrl.data.ruolo.sistema == \'UGOV\' ? \'\' : profiloCtrl.data.dipartimento.nome}}&nbsp;</span></div><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.esterno == null\"><label>Area</label> <span>{{profiloCtrl.data.areaCun ? profiloCtrl.data.areaCun.codice + \' - \' + profiloCtrl.data.areaCun.Nome : \'\'}}</span></div><div class=\"form-group valueRow\"><label>E-mail</label> <span>{{profiloCtrl.data.utente.email}}&nbsp;</span></div></div><br><h4 ng-if=\"profiloCtrl.data.ruolo.codice != \'S-IN\' || profiloCtrl.data.esterno\">Informazioni dichiarate dall\'utente</h4><div class=\"well userDeclared\" ng-if=\"profiloCtrl.data.profiloValidato && !profiloCtrl.data.esterno\"><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.dipartimentoManuale && profiloCtrl.data.ruolo.sistema == \'UGOV\'\"><label>Dipartimento</label> <span>{{profiloCtrl.data.dipartimento.nome}}&nbsp;</span></div><div class=\"form-group valueRow\" ng-if=\"profiloCtrl.data.dipartimentoManuale && profiloCtrl.data.ruolo.sistema == \'UGOV\'\"><label>Area</label> <span>{{profiloCtrl.data.areaCun ? profiloCtrl.data.areaCun.codice + \' - \' + profiloCtrl.data.areaCun.Nome : \'\'}}</span></div><div class=\"form-group\" ng-if=\"profiloCtrl.isSpecializzando(profiloCtrl.data.ruolo)\"><label>Hai già completato il primo triennio di formazione?</label> <span>{{profiloCtrl.data.titoloStudioTerzoLivello == true ? \'Sì\' : (profiloCtrl.data.titoloStudioTerzoLivello == false ? \'No\' : \'\')}}</span></div><div class=\"form-group\" ng-if=\"profiloCtrl.isAssegnista(profiloCtrl.data.ruolo)\"><label>Sei un assegnista di tipo 1 o di tipo 2?</label> <span>{{profiloCtrl.data.tipoSapienza == \'TIPO_1\' ? \'Tipo 1\' : (profiloCtrl.data.tipoSapienza == \'TIPO_2\' ? \'Tipo 2\' : \'\')}}</span></div><div class=\"form-group\" ng-if=\"profiloCtrl.isAssegnista(profiloCtrl.data.ruolo) && (profiloCtrl.data.titoloStudioTerzoLivello !== null || profiloCtrl.data.tipoSapienza == \'TIPO_1\')\"><label>Hai già conseguito il dottorato di ricerca?</label> <span>{{profiloCtrl.data.titoloStudioTerzoLivello == true ? \'Sì\' : (profiloCtrl.data.titoloStudioTerzoLivello == false ? \'No\' : \'\')}}</span></div><div class=\"form-group\"><label>Dichiaro che le informazioni della sezione <i>{{profiloCtrl.data.ruolo.sistema == \'UGOV\' ? \'Informazioni prelevate da UGOV\' : \'Informazioni presenti sul sistema\'}}</i> sono corrette</label> <span>{{profiloCtrl.data.profiloValidato == true ? \'Sì\' : (profiloCtrl.data.profiloValidato == false ? \'No\' : \'\')}}</span></div></div><div ng-if=\"!profiloCtrl.data.profiloValidato && profiloCtrl.data.ruolo.codice != \'S-IN\' && !profiloCtrl.data.esterno\"><form novalidate=\"\" name=\"editProfilo\"><div class=\"well userDeclared toEdit\"><div style=\"margin-bottom: 30px;\" ng-if=\"profiloCtrl.data.dipartimento === null\"><div><div class=\"form-group\">Su UGOV non è presente l\'informazione sul dipartimento. Indica il tuo dipartimento di afferenza.<br><b>Mi raccomando assicurati di inserire informazioni corrette.</b></div><div class=\"form-group row\"><label class=\"col-sm-12\">Dipartimento</label><div class=\"col-sm-8\"><ui-select search-enabled=\"false\" ng-model=\"profiloCtrl.editData.dipartimentoId\" required=\"\"><ui-select-match>{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat=\"item.id as item in profiloCtrl.dipartimenti\"><div ng-bind-html=\"item.nome\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><label class=\"col-sm-12\">Area</label><div class=\"col-sm-8\"><ui-select search-enabled=\"false\" ng-model=\"profiloCtrl.editData.areaId\" required=\"\"><ui-select-match>{{$select.selected.Nome}}</ui-select-match><ui-select-choices repeat=\"item.codice as item in profiloCtrl.areeCun\"><div ng-bind-html=\"item.Nome\"></div></ui-select-choices></ui-select></div></div></div></div><div class=\"form-group\" ng-if=\"profiloCtrl.isSpecializzando(profiloCtrl.data.ruolo)\"><label>Hai già completato il primo triennio di formazione?</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"titoloStudioTerzoLivello\" ng-model=\"profiloCtrl.editData.titoloStudioTerzoLivello\" ng-value=\"true\" required=\"\"> Sì</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"titoloStudioTerzoLivello\" ng-model=\"profiloCtrl.editData.titoloStudioTerzoLivello\" ng-value=\"false\" required=\"\"> No</label></div><div class=\"form-group\" ng-if=\"profiloCtrl.isAssegnista(profiloCtrl.data.ruolo)\"><label>Sei un assegnista di tipo 1 o di tipo 2?</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"tipoSapienza\" ng-model=\"profiloCtrl.editData.tipoSapienza\" ng-value=\"\'TIPO_1\'\" required=\"\"> Tipo 1</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"tipoSapienza\" ng-model=\"profiloCtrl.editData.tipoSapienza\" ng-value=\"\'TIPO_2\'\" required=\"\" ng-change=\"profiloCtrl.editData.titoloStudioTerzoLivello = null;\"> Tipo 2</label></div><div class=\"form-group\" ng-if=\"profiloCtrl.isAssegnista(profiloCtrl.data.ruolo) && profiloCtrl.editData.tipoSapienza == \'TIPO_1\'\"><label>Hai già conseguito il dottorato di ricerca?</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"titoloStudioTerzoLivello\" ng-model=\"profiloCtrl.editData.titoloStudioTerzoLivello\" ng-value=\"true\" required=\"\"> Sì</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"titoloStudioTerzoLivello\" ng-model=\"profiloCtrl.editData.titoloStudioTerzoLivello\" ng-value=\"false\" required=\"\"> No</label></div><div class=\"form-group\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"profiloCtrl.editData.profiloValidato\" required=\"\"> <b>Dichiaro che le informazioni della sezione <i>{{profiloCtrl.data.ruolo.sistema == \'UGOV\' ? \'Informazioni prelevate da UGOV\' : \'Informazioni presenti sul sistema\'}}</i> sono corrette</b></label></div></div><div class=\"form-group\"><span class=\"help-block\">Tutte le informazioni sono obbligatorie</span></div></div><br><div class=\"alert alert-warning\" ng-if=\"profiloCtrl.data.ruolo.sistema == \'UGOV\'\"><b>Prima di salvare, accertati della correttezza di tutte le informazioni del tuo profilo.</b><br>Qualora ci fossero informazioni errate nella sezione <i>Informazioni prelevate da UGOV</i>, invia un\'e-mail all\'indirizzo <a href=\"mailto:comitato.cer@uniba.it\">comitato.cer@uniba.it</a>, segnalando gli errori.<br>Dopo la correzione, affinché tali modifiche siano visibili in questa pagina, clicca sul bottone <i>Aggiorna da UGOV</i>.</div><div class=\"alert alert-warning\" ng-if=\"profiloCtrl.data.ruolo.sistema == \'SIGEBA\'\"><b>Prima di salvare, accertati della correttezza di tutte le informazioni del tuo profilo.</b><br>Qualora ci fossero informazioni errate nella sezione <i>Informazioni presenti sul sistema</i>, invia un\'e-mail all\'indirizzo <a href=\"mailto:comitato.cer@uniba.it\">comitato.cer@uniba.it</a>, segnalando gli errori. L\'Ufficio CER provvederà a far modificare le informazioni sul sistema.</div><button class=\"btn btn-primary\" ng-click=\"profiloCtrl.updateProfilo()\" ng-disabled=\"editProfilo.$invalid\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>Salva</button></form></div><div ng-if=\"profiloCtrl.data.esterno\"><form novalidate=\"\" name=\"editProfilo\"><div class=\"well userDeclared toEdit\"><div style=\"margin-bottom: 30px;\"><div><div class=\"form-group\">Inserisci qui l\'email che servirà per le comunicazioni del sistema.</div><div class=\"form-group row\"><div class=\"col-sm-8\"><label>Email per le comunicazioni*</label> <input type=\"text\" class=\"form-control\" ng-model=\"profiloCtrl.email\"></div></div></div></div><div style=\"margin-bottom: 30px;\"><div><div class=\"form-group row\"><div class=\"col-sm-12\"><label>Affiliazione (ente o azienda)*</label> <textarea class=\"form-control\" ng-model=\"profiloCtrl.affiliazione\" maxlength=\"profiloCtrl.maxLengthSize\" ng-change=\"profiloCtrl.countRemainingChars()\"></textarea><div class=\"input-tip-container\"><span>Caratteri rimanenti: {{profiloCtrl.remainingChars}}</span></div><div ng-if=\"profiloCtrl.alert\"><fpc-alert-block model=\"profiloCtrl.alert\" size=\"0\"></fpc-alert-block></div></div></div></div></div><div class=\"form-group\"><span class=\"help-block\">*Tutte le informazioni sono obbligatorie</span></div></div><br><button class=\"btn btn-primary\" ng-click=\"profiloCtrl.confirmDatiEsterno()\" ng-disabled=\"profiloCtrl.affiliazione == null || !profiloCtrl.affiliazione || profiloCtrl.email == null || !profiloCtrl.email || profiloCtrl.alert\"><i class=\"fa fa-save\" style=\"margin-right: 8px;\"></i>Salva</button></form></div></div></div>");
$templateCache.put("app/components/refereeAccept/refereeAccept.html","<div class=\"refereeAccept\"><div class=\"acceptRequestSmallBox panel panel-default\" ng-if=\"refAcceptCtrl.data.error\"><div class=\"panel-body\"><div class=\"statusIcon\"><i class=\"fa fa-times-circle\"></i></div><div class=\"statusMessage\">{{refAcceptCtrl.data.error}}</div><div class=\"instructionMessage\">Try reloading the page or clicking again on the link we sent you via email. If the error persists, please contact Ufficio Ricerca at <a href=\"mailto:ufficioricerca@uniroma1.it\">ufficioricerca@uniroma1.it</a>.</div></div></div><div class=\"acceptRequestSmallBox panel panel-default\" ng-if=\"refAcceptCtrl.data.disabilitato === true\"><div class=\"panel-body\"><div class=\"statusIcon\"><i class=\"fa fa-ban\"></i></div><div class=\"statusMessage\">This invitation has been disabled.</div><div class=\"thankMessage\">Thank you anyway for your time.</div></div></div><div class=\"acceptRequestSmallBox panel panel-default\" ng-if=\"refAcceptCtrl.data.disabilitato === null && refAcceptCtrl.data.accettato === true\"><div class=\"panel-body\"><div class=\"statusIcon\"><i class=\"fa fa-check-circle\"></i></div><div class=\"statusMessage\">You agreed to be a referee for this project.</div><div class=\"instructionMessage\">We sent you an email with the credentials to access the system to give your evaluation.</div><div class=\"thankMessage\">Thank you very much for your help.</div></div></div><div class=\"acceptRequestSmallBox panel panel-default\" ng-if=\"refAcceptCtrl.data.disabilitato === null && refAcceptCtrl.data.accettato === false\"><div class=\"panel-body\"><div class=\"statusIcon\"><i class=\"fa fa-ban\"></i></div><div class=\"statusMessage\">You declined to be a referee for this project.</div><div class=\"thankMessage\">Thank you anyway for your time.</div></div></div><div class=\"acceptRequestBox panel panel-default\" ng-if=\"refAcceptCtrl.data.accettato === null && refAcceptCtrl.data.disabilitato === null\"><div class=\"panel-body\"><div class=\"statusMessage\">You have been invited to be a referee for the following project:</div><div class=\"projectData bs-callout bs-callout-sapienza\"><div class=\"form-group valueRow\"><div class=\"title\">{{refAcceptCtrl.data.proposta.titolo}}&nbsp;</div></div><div class=\"form-group valueRow\"><label>Principal Investigator</label><div>{{refAcceptCtrl.data.proposta.responsabile.cognome}}&nbsp;{{refAcceptCtrl.data.proposta.responsabile.nome}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=\"refAcceptCtrl.showMembers()\">show research group</a></div></div><div class=\"form-group valueRow\"><label>Abstract</label><div class=\"abstract\">{{refAcceptCtrl.data.proposta.abstract}}&nbsp;</div></div></div><div class=\"question\">Do you agree to evaluate this project?</div><div class=\"declaration\">By agreeing, you declare that you are not in conflict of interest with the Principal Investigator<br>and the other members of the research group.</div><div class=\"acceptButtons\"><button class=\"btn btn-success\" ng-click=\"refAcceptCtrl.acceptReferee()\" ng-disabled=\"refAcceptCtrl.saving\"><i class=\"fa fa-check\" style=\"margin-right: 8px;\"></i>Yes, I agree</button> <button class=\"btn btn-danger\" ng-click=\"refAcceptCtrl.refuseReferee()\" ng-disabled=\"refAcceptCtrl.saving\"><i class=\"fa fa-ban\" style=\"margin-right: 8px;\"></i>No, I decline</button></div></div></div></div>");
$templateCache.put("app/components/sgb-budget/sgb-budget.html","<div class=\"form-group row sgbField sgbBudget\"><label class=\"col-sm-12\">{{bdgt.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"expenseColumn\">Voce di spesa</th><th class=\"assegnoColumn\"></th><th class=\"valueColumn\">Importo</th><th class=\"descriptionColumn\" ng-if=\"!(bdgt.hideDescriptions === \'true\')\">Descrizione</th><th ng-if=\"bdgt.type == \'pnrr\'\" class=\"valueColumn\">Eventuale cofinanziamento (Euro)</th></tr></thead><tbody><tr ng-repeat=\"row in bdgt.model\"><td class=\"expenseColumn\" colspan=\"2\" ng-if=\"row.tipo != \'IMPORTO_FISSO\'\">{{row.nome}}</td><td class=\"expenseColumn\" ng-if=\"row.tipo == \'IMPORTO_FISSO\'\">{{row.nome}}</td><td class=\"assegnoColumn\" ng-if=\"row.tipo == \'IMPORTO_FISSO\'\">n°&nbsp;<ui-select search-enabled=\"false\" ng-model=\"bdgt.selectValues[row.id]\" on-select=\"bdgt.updateImporto($item, row)\"><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in bdgt.getChoices(row)\"><div ng-bind-html=\"item\"></div></ui-select-choices></ui-select></td><td class=\"valueColumn\" ng-if=\"row.tipo != \'IMPORTO_FISSO\'\"><input type=\"text\" class=\"form-control\" ng-model=\"row.finanziamentoRichiesto\" ng-trim=\"false\" integer-field-parser=\"\"></td><td class=\"valueColumn\" ng-if=\"row.tipo == \'IMPORTO_FISSO\'\"><input type=\"text\" class=\"form-control\" ng-model=\"row.finanziamentoRichiesto\" readonly=\"\"></td><td class=\"descriptionColumn\" ng-if=\"!(bdgt.hideDescriptions === \'true\')\"><textarea class=\"form-control\" rows=\"5\" ng-model=\"row.note\"></textarea></td><td class=\"valueColumn\" ng-if=\"row.tipo != \'IMPORTO_FISSO\' && bdgt.type == \'pnrr\'\"><input type=\"text\" class=\"form-control\" ng-model=\"row.eventualeCoFinanziamento\" ng-trim=\"false\" integer-field-parser=\"\"></td></tr><tr class=\"totalRow\"><td class=\"expenseColumn\">TOTALE</td><td></td><td class=\"valueColumn\">{{bdgt.getTotal(bdgt.model)}}</td><td class=\"descriptionColumn\" ng-if=\"!(bdgt.hideDescriptions === \'true\')\"></td><td ng-if=\"bdgt.type == \'pnrr\'\" class=\"valueColumn\"></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\" ng-bind-html=\"bdgt.help\"></span></div></div>");
$templateCache.put("app/components/sgb-calculatedField/sgb-calculatedField.html","<div class=\"form-group row sgbField sgbCalculatedField\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model\" readonly=\"\" calculated-model=\"vm.doCalculation()\"></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-checkbox/sgb-checkbox.html","<div class=\"form-group row sgbField sgbCheckbox\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><label class=\"check-label\"><input type=\"checkbox\" ng-model=\"vm.model\"></label></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-currencyField/sgb-currencyField.html","<div class=\"form-group row sgbField sgbCurrencyField\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model\" ng-trim=\"false\" currency-field-parser=\"\" allow-empty=\"true\"></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-dateField/sgb-dateField.html","<div class=\"form-group row sgbField sgbDateField\"><label class=\"col-sm-12\">{{dateCtrl.label}}</label><div class=\"col-sm-8\"><label class=\"fieldWithIcon\"><input type=\"text\" class=\"form-control\" ng-model=\"dateCtrl.model\" readonly=\"\" date-range-picker=\"\" min-date=\"dateCtrl.minDate\" max-date=\"dateCtrl.maxDate\" non-future=\"dateCtrl.nonFuture\" single-date=\"true\"> <i class=\"fa fa-calendar\"></i></label></div><div class=\"col-sm-12\"><span class=\"help-block\">{{dateCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-dateFieldIndet/sgb-dateFieldIndet.html","<div class=\"form-group row sgbField sgbDateFieldIndet\"><label class=\"col-sm-12\">{{dateIndetCtrl.label}}</label><div class=\"col-sm-8\"><label class=\"fieldWithIcon\" ng-if=\"!dateIndetCtrl.indeterminateCheck\"><input type=\"text\" class=\"form-control\" ng-model=\"dateIndetCtrl.model\" readonly=\"\" date-range-picker=\"\" min-date=\"dateIndetCtrl.minDate\" max-date=\"dateIndetCtrl.maxDate\" non-future=\"dateIndetCtrl.nonFuture\" single-date=\"true\"> <i class=\"fa fa-calendar\"></i></label> <input type=\"text\" class=\"form-control indeterminateField\" ng-model=\"dateIndetCtrl.indeterminateDescription\" readonly=\"\" ng-if=\"dateIndetCtrl.indeterminateCheck\"></div><div class=\"col-sm-12 indeterminate\"><input type=\"checkbox\" ng-model=\"dateIndetCtrl.indeterminateCheck\" ng-checked=\"dateIndetCtrl.model === dateIndetCtrl.indeterminateValue\" ng-click=\"dateIndetCtrl.toggleIndeterminateValue()\"><span>{{dateIndetCtrl.indeterminateDescription}}</span></div><div class=\"col-sm-12\"><span class=\"help-block\">{{dateIndetCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-dateRangeField/sgb-dateRangeField.html","<div class=\"form-group row sgbField sgbDateRangeField\"><label class=\"col-sm-12\">{{dateCtrl.label}}</label><div class=\"col-sm-8\"><label class=\"fieldWithIcon\"><input type=\"text\" class=\"form-control\" ng-model=\"dateCtrl.model\" readonly=\"\" date-range-picker=\"\" min-date=\"dateCtrl.minDate\" max-date=\"dateCtrl.maxDate\"> <i class=\"fa fa-calendar\"></i></label></div><div class=\"col-sm-12\"><span class=\"help-block\">{{dateCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-fileMultipleUpload/sgb-fileMultipleUpload.html","<div class=\"form-group row sgbField sgbFileMultipleUpload\"><label class=\"col-sm-12\">{{fileMUCtrl.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"fileMUCtrl.description\"><span ng-bind-html=\"fileMUCtrl.description\"></span></div><div class=\"col-sm-3\" ng-if=\"fileMUCtrl.fileTemplateUrl\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{ fileMUCtrl.fileTemplateUrl }}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{ fileMUCtrl.fileTemplateLabel }}</a></div><div class=\"col-sm-8\"><div class=\"file-row\" ng-repeat=\"fileModel in fileMUCtrl.model\"><div class=\"btn-group\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{fileMUCtrl.getFileHref(fileModel)}}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{fileModel.nome}}</a> <a class=\"btn btn-danger btn-toggle\" href=\"\" ng-click=\"fileMUCtrl.removeFile($index)\"><i class=\"fa fa-times\"></i></a></div></div><label class=\"btn btn-primary\" ladda=\"fileMUCtrl.loading\" ng-if=\"fileMUCtrl.maxFiles*1 == 0 || fileMUCtrl.model.length < fileMUCtrl.maxFiles*1 || vm.model == null\"><i class=\"fa fa-upload btn-icon\"></i>Seleziona File <input type=\"file\" multiple=\"\" accept=\"{{fileMUCtrl.filetype?fileMUCtrl.filetype:\'application/pdf\'|| \'application/vnd.openxmlformats-officedocument.wordprocessingml.document\'}}\" ng-disabled=\"fileMUCtrl.loading\" onchange=\"angular.element(this).scope().fileMUCtrl.uploadFile(this.files); angular.element(this).scope().$apply();\"></label><div class=\"upload-error\" ng-if=\"fileMUCtrl.uploadError != null\">{{fileMUCtrl.uploadError}}</div></div><div class=\"col-sm-12\"><span class=\"help-block\">{{fileMUCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-complexField/sgb-complexField.html","<div class=\"form-group row sgbField sgbComplexField\"><label class=\"col-sm-12\">{{cplxField.label}}</label><div class=\"col-sm-12\"><div class=\"well\"><div class=\"form-group valueRow\" ng-repeat=\"info in cplxField.info\" ng-if=\"!info.optional || ($eval(info.model, cplxField.model) !== null)\"><label>{{info.label}}</label> <span>{{$eval(info.model, cplxField.model)}}&nbsp;</span></div></div></div><div class=\"col-sm-12\"><span class=\"help-block\">{{cplxField.help}}</span></div></div>");
$templateCache.put("app/components/sgb-fileUpload/sgb-fileUpload.html","<div class=\"form-group row sgbField sgbFileUpload\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"vm.description\"><span ng-bind-html=\"vm.description\"></span></div><div class=\"col-sm-3\" ng-if=\"vm.fileTemplateUrl\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{ vm.fileTemplateUrl }}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{ vm.fileTemplateLabel }}</a></div><div class=\"col-sm-8\"><label class=\"btn btn-primary\" ladda=\"vm.loading\" ng-if=\"vm.model == null\"><i class=\"fa fa-upload btn-icon\"></i>Seleziona File <input type=\"file\" accept=\"application/pdf\" ng-disabled=\"vm.loading\" onchange=\"angular.element(this).scope().vm.uploadFile(this.files); angular.element(this).scope().$apply();\"></label><div class=\"upload-error\" ng-if=\"vm.uploadError != null\">{{vm.uploadError}}</div><div class=\"btn-group\" ng-if=\"vm.model != null\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{vm.getFileHref(vm.model)}}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{vm.model.nome}}</a> <a class=\"btn btn-danger btn-toggle\" href=\"\" ng-click=\"vm.removeFile()\"><i class=\"fa fa-times\"></i></a></div></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-hIndex/sgb-hIndex.html","<div class=\"form-group row sgbField sgbHIndex\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model.hindex\" placeholder=\"h-index\" integer-field-parser=\"\" allow-empty=\"true\"></div><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model.database\" placeholder=\"Database (anche più di uno)\"></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-hIndexPart/sgb-hIndexPart.html","<div class=\"form-group row sgbField sgbHIndexPart\"><label class=\"col-sm-12\">{{hIndPartCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nomeColumn\">Co-Proponente</th><th class=\"hindexColumn\">H-Index</th><th class=\"dbColumn\">Database di riferimento</th></tr></thead><tbody><tr class=\"noCoprop\" ng-if=\"hIndPartCtrl.model == null || hIndPartCtrl.model.length == 0\"><td colspan=\"3\">Nessun co-proponente</td></tr><tr ng-repeat=\"row in hIndPartCtrl.model\"><td class=\"nomeColumn\">{{row.utente.cognome}} {{row.utente.nome}}</td><td class=\"hindexColumn\">{{row.hindex}}</td><td class=\"dbColumn\">{{row.database}}</td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{hIndPartCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-indicatoriImpattoSostenibilita/sgb-indicatoriImpattoSostenibilita.html","<div class=\"form-group row sgbField sgbIndicatoriImpattoSostenibilita\"><label class=\"col-sm-12\">{{indImpSostCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nomeIndicatoreColumn\">Indicatore</th><th class=\"valoreIndicatoreColumn\">Valore</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noIndicatori\" ng-if=\"indImpSostCtrl.model.indicatoriList.length == 0\"><td colspan=\"3\">Nessun Indicatore</td></tr><tr class=\"accepted\" ng-repeat=\"ind in indImpSostCtrl.model.indicatoriList\"><td class=\"nomeIndicatoreColumn\"><input type=\"text\" class=\"form-control\" ng-readonly=\"ind.readOnly\" ng-model=\"ind.indicatore\"></td><td class=\"valoreIndicatoreColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"ind.valore\"></td><td class=\"actionColumn\"><a href=\"\" ng-if=\"!ind.readOnly\" ng-click=\"indImpSostCtrl.removeIndicatore($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"indImpSostCtrl.addIndicatore()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{indImpSostCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-keywords/sgb-keywords.html","<div class=\"form-group row sgbField sgbKeywords\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><ol><li ng-repeat=\"number in vm.range(vm.maxWords)\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model[number-1]\"></li></ol></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-keywordsSelect/sgb-keywordsSelect.html","<div class=\"form-group row sgbField sgbKeywordsSelect\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><ol><li ng-repeat=\"number in vm.range\"><ui-select ng-model=\"vm.model[number-1]\" on-select=\"vm.onSelect(number-1, $item, $model)\"><ui-select-match allow-clear=\"true\"><span title=\"{{$select.selected[vm.choicesLabel]}}\">{{$select.selected[vm.choicesLabel]}}</span></ui-select-match><ui-select-choices repeat=\"item.id as item in vm.choices | filter:vm.choicesFilter($select.search) | limitTo: 40\"><div ng-bind-html=\"item[vm.choicesLabel] | highlight: $select.search\"></div></ui-select-choices></ui-select></li></ol></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-lastFundings/sgb-lastFundings.html","<div class=\"form-group row sgbField sgbLastFundings\"><label class=\"col-sm-12\">{{lastFundsCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"annoColumn\">Anno</th><th class=\"assignedColumn\">Fondo assegnato</th><th class=\"notUsedColumn\">Fondo non ancora utilizzato</th><th class=\"notUsedReasonColumn\">Motivazione per mancato utilizzo fondo</th></tr></thead><tbody><tr ng-repeat=\"row in lastFundsCtrl.model\"><td class=\"annoColumn\">{{row.anno}}</td><td class=\"assignedColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"row.fondo_assegnato\" ng-trim=\"false\" integer-field-parser=\"\"></td><td class=\"notUsedColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"row.fondo_non_utilizzato\" ng-trim=\"false\" integer-field-parser=\"\"></td><td class=\"notUsedReasonColumn\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"row.motivazione_mancato_utilizzo\"></textarea></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{lastFundsCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-lastFundingsNew/sgb-lastFundingsNew.html","<div class=\"form-group row sgbField sgbLastFundingsNew\"><label class=\"col-sm-12\">{{lastFundsNCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"annoColumn\">Anno</th><th class=\"progettoColumn\">Progetto Finanziato</th><th class=\"assignedColumn\">Fondo assegnato</th><th class=\"notUsedColumn\">Fondo non ancora utilizzato</th><th class=\"notUsedReasonColumn\">Motivazione per mancato utilizzo fondo</th></tr></thead><tbody><tr ng-repeat-start=\"row in lastFundsNCtrl.model\"><td class=\"annoColumn\">{{row.anno}}</td><td class=\"annoColumn\" colspan=\"4\"></td></tr><tr ng-repeat=\"proj in row.progettiFinanziati\"><td></td><td class=\"progettoColumn\"><div class=\"titolo\">{{proj.titolo}}</div><div class=\"tipologia\">{{proj.nomeTipologia + \' - \' + proj.nomeClasse}}</div></td><td class=\"assignedColumn\"><div><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proj.finanziamentoAssegnato}}</div><div ng-if=\"proj.assegnoAssegnato > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proj.assegnoAssegnato}}</div></td><td class=\"notUsedColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"proj.fondo_non_utilizzato\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"notUsedReasonColumn\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"proj.motivazione_mancato_utilizzo\"></textarea></td></tr><tr ng-repeat=\"other in row.altro\"><td><a href=\"\" ng-click=\"lastFundsNCtrl.removeFunding(row, $index)\"><i class=\"fa fa-times\"></i></a></td><td class=\"progettoColumn\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"other.progetto\"></textarea></td><td class=\"assignedColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"other.fondo_assegnato\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"notUsedColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"other.fondo_non_utilizzato\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"notUsedReasonColumn\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"other.motivazione_mancato_utilizzo\"></textarea></td></tr><tr ng-repeat-end=\"\"><td></td><td colspan=\"4\"><a href=\"\" ng-click=\"lastFundsNCtrl.addFunding(row)\"><i class=\"fa fa-plus\"></i> aggiungi altro</a></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{lastFundsNCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-lineeTematiche/sgb-lineeTematiche.html","<div class=\"form-group row sgbField sgbParticipantsManual\"><label class=\"col-sm-12\">{{linTemCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"idColumn\">Linea tematica</th><th class=\"nameColumn\">Titolo</th><th class=\"roleColumn\" ng-if=\"linTemCtrl.type !== \'dipartimentali\'\">Co-PI(Cognome, Nome)</th><th class=\"roleColumn\" ng-if=\"linTemCtrl.type == \'dipartimentali\'\">Referente scientifico(Cognome, Nome)</th><th class=\"depColumn\" ng-if=\"linTemCtrl.type !== \'dipartimentali\'\">Co-PI (Dipartimento di afferenza)</th><th class=\"depColumn\" ng-if=\"linTemCtrl.type !== \'dipartimentali\'\">Costo totale previsto (escluso cofinanziamento)</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"linTemCtrl.model.length == 0 || !linTemCtrl.model\"><td colspan=\"5\">Nessun Elemento</td></tr><tr class=\"accepted\" ng-repeat=\"linea in linTemCtrl.model\"><td class=\"idColumn\">{{linea.id}}</td><td class=\"nameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"linea.titolo\"></td><td class=\"roleColumn\"><select class=\"form-control\" ng-model=\"linea.coPiCogNom\"><option ng-repeat=\"copi in linTemCtrl.coPi\" value=\"{{copi.nome}} {{copi.cognome}}\">{{copi.nome}} {{copi.cognome}}</option></select></td><td class=\"depColumn\" ng-if=\"linTemCtrl.type !== \'dipartimentali\'\"><input type=\"text\" class=\"form-control\" ng-model=\"linea.coPiDipartimento\"></td><td class=\"depColumn\" ng-if=\"linTemCtrl.type !== \'dipartimentali\'\"><input integer-field-parser=\"\" type=\"text\" class=\"form-control\" ng-model=\"linea.costo\"></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"linTemCtrl.removeProj($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-if=\"linTemCtrl.numMax == 0 || linTemCtrl.model.length!=linTemCtrl.numMax\" ng-click=\"linTemCtrl.addProj()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{linTemCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-numberField/sgb-numberField.html","<div class=\"form-group row sgbField sgbNumberField\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-otherFundings/sgb-otherFundings.html","<div class=\"form-group row sgbField sgbOtherFundings\"><label class=\"col-sm-12\">{{othFundCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"enteColumn\">Ente finanziatore</th><th class=\"valueColumn\">Contributo ottenuto</th><th class=\"descriptionColumn\">Note</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noFunds\" ng-if=\"othFundCtrl.model == null || othFundCtrl.model.length == 0\"><td colspan=\"4\">Nessun contributo da altri enti</td></tr><tr ng-repeat=\"row in othFundCtrl.model\"><td class=\"enteColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"row.ente\"></td><td class=\"valueColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"row.contributoOttenuto\" ng-trim=\"false\" integer-field-parser=\"\"></td><td class=\"descriptionColumn\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"row.note\"></textarea></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"othFundCtrl.removeFund($index)\"><i class=\"fa fa-times\"></i></a></td></tr><tr class=\"totalRow\"><td class=\"enteColumn\">TOTALE</td><td class=\"valueColumn\">{{othFundCtrl.getTotal(othFundCtrl.model)}}</td><td class=\"descriptionColumn\"></td><td class=\"actionColumn\"></td></tr></tbody></table><a href=\"\" ng-click=\"othFundCtrl.addFund()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{othFundCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-participantsManual/sgb-participantsManual.html","<div class=\"form-group row sgbField sgbParticipantsManual\"><label class=\"col-sm-12\">{{partManCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"surnameColumn\">Cognome</th><th class=\"nameColumn\">Nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento/Organizzazione</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"partManCtrl.model.partecipantiList.length == 0\"><td colspan=\"5\">Nessun componente</td></tr><tr class=\"accepted\" ng-repeat=\"partecipante in partManCtrl.model.partecipantiList\"><td class=\"surnameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.cognome\"></td><td class=\"nameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.nome\"></td><td class=\"roleColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.qualifica\"></td><td class=\"depColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.struttura\"></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"partManCtrl.removeParticipant($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"partManCtrl.addParticipant()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{partManCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-participantsManualRend/sgb-participantsManualRend.html","<div class=\"form-group row sgbField sgbParticipantsManualRend\"><label class=\"col-sm-12\">{{partManRendCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"surnameColumn\">Cognome</th><th class=\"nameColumn\">Nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento/Organizzazione</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"partManRendCtrl.model.length == 0\"><td colspan=\"5\">Nessun componente</td></tr><tr ng-repeat=\"partecipante in partManRendCtrl.model\"><td class=\"surnameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.cognome\"></td><td class=\"nameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.nome\"></td><td class=\"roleColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.qualifica\"></td><td class=\"depColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"partecipante.struttura\"></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"partManRendCtrl.removeParticipant($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"partManRendCtrl.addParticipant()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{partManRendCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-participantsRend/sgb-participantsRend.html","<div class=\"form-group row sgbField sgbParticipantsRend\"><label class=\"col-sm-12\">{{partRendCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><tbody><tr class=\"noParticipants\" ng-if=\"partRendCtrl.model.length == 0\"><td colspan=\"4\">Nessun componente</td></tr><tr class=\"separator\" ng-repeat-start=\"categoria in partRendCtrl.model\" ng-if=\"categoria.partecipantiList.length > 0\"><th colspan=\"4\">{{categoria.descrizione}}</th></tr><tr class=\"tHeader\" ng-if=\"categoria.partecipantiList.length > 0\"><th class=\"nameColumn\">Cognome e nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento/Organizzazione</th><th class=\"actionColumn\">Ha&nbsp;partecipato?</th></tr><tr ng-repeat=\"partecipante in categoria.partecipantiList\" ng-if=\"categoria.partecipantiList.length > 0\" ng-repeat-end=\"\"><td class=\"nameColumn\">{{partecipante.cognome}} {{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.ruolo.descrizione ? partecipante.ruolo.descrizione : partecipante.qualifica}}</td><td class=\"depColumn\">{{partecipante.dipartimento.nome ? partecipante.dipartimento.nome : partecipante.struttura}}</td><td class=\"actionColumn\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"partecipante.partecipazioneEffettiva\" ng-value=\"true\"> Sì</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"partecipante.partecipazioneEffettiva\" ng-value=\"false\"> No</label></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{partRendCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-previousFundings/sgb-previousFundings.html","<div class=\"form-group row sgbField sgbPreviousFundings\"><label class=\"col-sm-12\">{{prevFundCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"titolareColumn\">Titolare</th><th class=\"enteColumn\">Ente finanziatore</th><th class=\"importoColumn\">Importo</th><th class=\"progettoColumn\">Titolo progetto</th><th class=\"dataColumn\" ng-if=\"prevFundCtrl.type == \'withYears\'\">Data inizio</th><th class=\"dataColumn\" ng-if=\"prevFundCtrl.type == \'withYears\'\">Data fine</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"prevFundCtrl.model.length == 0\"><td colspan=\"{{(prevFundCtrl.type == \'withYears\') ? 7 : 5}}\">Nessun finanziamento</td></tr><tr class=\"accepted\" ng-repeat=\"finanziamento in prevFundCtrl.model\"><td class=\"titolareColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.titolare\"></td><td class=\"enteColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.enteFinanziatore\"></td><td class=\"importoColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.importo\" currency-field-parser=\"\"></td><td class=\"progettoColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.titoloProgetto\"></td><td class=\"dataColumn\" ng-if=\"prevFundCtrl.type == \'withYears\'\"><input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.dataInizio\"></td><td class=\"dataColumn\" ng-if=\"prevFundCtrl.type == \'withYears\'\"><input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.dataFine\"></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"prevFundCtrl.removeFunding($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"prevFundCtrl.addFunding()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{prevFundCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-previousFundingsNew/sgb-previousFundingsNew.html","<div class=\"form-group row sgbField sgbPreviousFundingsNew\"><label class=\"col-sm-12\">{{prevFundNCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"finanziamentoColumn\">Finanziamento</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noFundings\" ng-if=\"prevFundNCtrl.model.length == 0\"><td colspan=\"2\">Nessun finanziamento</td></tr><tr ng-repeat=\"finanziamento in prevFundNCtrl.model\"><td class=\"finanziamentoColumn\"><table class=\"finRow\"><tr><td class=\"box boxM\"><span class=\"fieldLabel\">Titolare</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.titolare\"></td><td class=\"box boxL\"><span class=\"fieldLabel\">Ente finanziatore</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.enteFinanziatore\"></td><td class=\"box boxS\"><span class=\"fieldLabel\">Importo</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.importo\" currency-field-parser=\"\"></td><td class=\"box boxS\"><span class=\"fieldLabel\" uib-tooltip=\"Percentuale impegno\">Perc. impegno</span><ui-select search-enabled=\"false\" ng-model=\"finanziamento.percentualeImpegno\"><ui-select-match allow-clear=\"false\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in prevFundNCtrl.percentuali\"><div ng-bind-html=\"item\"></div></ui-select-choices></ui-select></td></tr><tr><td class=\"box boxXL\" colspan=\"2\"><span class=\"fieldLabel\">Titolo progetto</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.titoloProgetto\"></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Inizio</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.dataInizio\"></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Fine</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.dataFine\"></td></tr></table></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"prevFundNCtrl.removeFunding($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"prevFundNCtrl.addFunding()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{prevFundNCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-previousFundingsNewNoPercImpegno/sgb-previousFundingsNewNoPercImpegno.html","<div class=\"form-group row sgbField sgbPreviousFundingsNewNoPercImpegno\"><label class=\"col-sm-12\">{{prevFundNPercImpCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"finanziamentoColumn\">Finanziamento</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noFundings\" ng-if=\"prevFundNPercImpCtrl.model.length == 0\"><td colspan=\"2\">Nessun finanziamento</td></tr><tr ng-repeat=\"finanziamento in prevFundNPercImpCtrl.model\"><td class=\"finanziamentoColumn\"><table class=\"finRow\"><tr><td class=\"box boxM\"><span class=\"fieldLabel\">Titolare</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.titolare\"></td><td class=\"box boxL\"><span class=\"fieldLabel\">Ente finanziatore</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.enteFinanziatore\"></td><td class=\"box boxS\"><span class=\"fieldLabel\">Importo</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.importo\" currency-field-parser=\"\"></td></tr><tr><td class=\"box boxXL\" colspan=\"2\"><span class=\"fieldLabel\">Titolo progetto</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.titoloProgetto\"></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Inizio</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.dataInizio\"></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Fine</span> <input type=\"text\" class=\"form-control\" ng-model=\"finanziamento.dataFine\"></td></tr></table></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"prevFundNPercImpCtrl.removeFunding($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"prevFundNPercImpCtrl.addFunding()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{prevFundNPercImpCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-progettiManual/sgb-progettiManual.html","<div class=\"form-group row sgbField sgbParticipantsManual\"><label class=\"col-sm-12\">{{progManCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"idColumn\">No</th><th ng-if=\"progManCtrl.type != \'brev\'\" class=\"surnameColumn\">Soggetto Finanziatore</th><th ng-if=\"progManCtrl.type == \'brev\'\" class=\"surnameColumn\">Autori</th><th class=\"nameColumn\">Titolo</th><th ng-if=\"progManCtrl.type != \'brev\'\" class=\"roleColumn\">Anno inizio</th><th ng-if=\"progManCtrl.type == \'brev\'\" class=\"roleColumn\">Anno</th><th ng-if=\"progManCtrl.type != \'brev\'\" class=\"depColumn\">Ruolo (PI, Co-PI, Partecipante)</th><th ng-if=\"progManCtrl.type == \'brev\'\" class=\"depColumn\">Brevetto depositato ovvero domanda di brevetto</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"progManCtrl.model.length == 0 || !progManCtrl.model\"><td colspan=\"5\">Nessun Elemento</td></tr><tr class=\"accepted\" ng-repeat=\"progetto in progManCtrl.model\"><td class=\"idColumn\">{{progetto.id}}</td><td ng-if=\"!progManCtrl.type\" class=\"surnameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"progetto.soggettoFinan\"></td><td ng-if=\"progManCtrl.type == \'brev\'\" class=\"surnameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"progetto.autori\"></td><td class=\"nameColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"progetto.titolo\"></td><td class=\"roleColumn\"><input integer-field-parser=\"\" type=\"text\" class=\"form-control\" ng-model=\"progetto.anno\"></td><td ng-if=\"!progManCtrl.type\" class=\"depColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"progetto.ruolo\"></td><td ng-if=\"progManCtrl.type == \'brev\'\" class=\"depColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"progetto.deposito\"></td><td class=\"actionColumn\"><a href=\"\" ng-click=\"progManCtrl.removeProj($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-if=\"linTemCtrl.numMax == 0 || progManCtrl.model.length!=progManCtrl.numMax\" ng-click=\"progManCtrl.addProj()\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{progManCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-publications/sgb-add-publications.html","<div class=\"sgbAddPublications\"><h3>Seleziona pubblicazioni attinenti al progetto</h3><div class=\"resultsContainer well\"><p class=\"noResults\" ng-if=\"addPubblCtrl.results.length == 0\">nessun risultato</p><div class=\"spinner\" ng-if=\"addPubblCtrl.searching\"></div><div class=\"publResult\" ng-repeat=\"result in addPubblCtrl.results\"><div><div class=\"idInfo\"><span ng-if=\"result.pubblicazione.prodottoId\">Id UGOV: {{result.pubblicazione.prodottoId}} -</span><span ng-if=\"result.pubblicazione.handle\">Handle: {{result.pubblicazione.handle}} -</span>{{result.pubblicazione.tipo}}</div><div class=\"titolo\">{{result.pubblicazione.titolo}}</div><div class=\"autori\">{{result.pubblicazione.anno}} - {{result.pubblicazione.autori}}</div><div class=\"descrizione\">{{result.pubblicazione.testo}}</div></div><div class=\"impactFactor\" ng-if=\"addPubblCtrl.options.showImpactFactor\">Impact factor:<div>{{result.pubblicazione.impactFactor ? result.pubblicazione.impactFactor : \'-\'}}</div></div><div class=\"addPublication\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"addPubblCtrl.addPublication(result)\" ng-if=\"!result.isAlreadyRequested && (!addPubblCtrl.numMax || addPubblCtrl.pubblicazioni.length < addPubblCtrl.numMax)\"><i class=\"fa fa-plus\"></i></a><div class=\"notAvailable\" ng-if=\"!result.isAlreadyRequested && (addPubblCtrl.numMax && addPubblCtrl.pubblicazioni.length >= addPubblCtrl.numMax)\">Numero massimo raggiunto</div><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>Pubblicazione selezionata</div></div></div></div><div class=\"nextResults\" ng-if=\"addPubblCtrl.hasNext\"><a href=\"\" ng-click=\"addPubblCtrl.loadPublications()\" ng-if=\"!addPubblCtrl.searching\">carica altre pubblicazioni</a><div class=\"spinner\" ng-if=\"addPubblCtrl.searching\"></div></div><div class=\"errorMessage\" ng-if=\"addPubblCtrl.errorMessage\">Errore nel caricamento delle pubblicazioni da IRIS<br>{{addPubblCtrl.errorMessage}}<br><a href=\"\" ng-click=\"addPubblCtrl.loadPublications()\">riprova</a></div></div></div>");
$templateCache.put("app/components/sgb-publications/sgb-publications.html","<div class=\"form-group row sgbField sgbPublications\"><label class=\"col-sm-12\">{{pubblCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"indexColumn\"></th><th class=\"descrColumn\">Pubblicazione</th><th class=\"ifColumn\" ng-if=\"pubblCtrl.opts.showImpactFactor\">Impact Factor</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noPublications\" ng-if=\"pubblCtrl.model.length == 0\"><td colspan=\"{{pubblCtrl.opts.showImpactFactor ? 4 : 3}}\">Nessuna pubblicazione</td></tr><tr ng-repeat=\"pubblicazione in pubblCtrl.model\"><td class=\"indexColumn\">{{$index + 1}}</td><td class=\"descrColumn\"><div class=\"idInfo\"><span ng-if=\"pubblicazione.pubblicazione.prodottoId\">Id UGOV: {{pubblicazione.pubblicazione.prodottoId}} -</span><span ng-if=\"pubblicazione.pubblicazione.handle\">Handle: {{pubblicazione.pubblicazione.handle}} -</span>{{pubblicazione.pubblicazione.tipo}}</div><div class=\"titolo\">{{pubblicazione.pubblicazione.titolo}}</div><div class=\"autori\"><span class=\"anno\">{{pubblicazione.pubblicazione.anno}}</span> - {{pubblicazione.pubblicazione.autori}}</div><div class=\"descrizione\">{{pubblicazione.pubblicazione.testo}}</div></td><td class=\"ifColumn\" ng-if=\"pubblCtrl.opts.showImpactFactor\">{{pubblicazione.pubblicazione.impactFactor ? pubblicazione.pubblicazione.impactFactor : \'-\'}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"pubblCtrl.removePublication($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"pubblCtrl.addPublication()\" ng-if=\"!pubblCtrl.numMax || pubblCtrl.model.length < pubblCtrl.numMax\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{pubblCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-publicationsPart/sgb-publicationsPart.html","<div class=\"form-group row sgbField sgbPublicationsPart\"><label class=\"col-sm-12\">{{pubblPartCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"indexColumn\"></th><th class=\"descrColumn\">Pubblicazione</th><th class=\"ifColumn\" ng-if=\"pubblPartCtrl.opts.showImpactFactor\">Impact Factor</th><th class=\"participantColumn\">Partecipante</th></tr></thead><tbody><tr class=\"noPublications\" ng-if=\"pubblPartCtrl.model.length == 0\"><td colspan=\"{{pubblPartCtrl.opts.showImpactFactor ? 4 : 3}}\">Nessuna pubblicazione</td></tr><tr ng-repeat=\"pubblicazione in pubblPartCtrl.model\"><td class=\"indexColumn\">{{$index + 1}}</td><td class=\"descrColumn\"><div class=\"idInfo\"><span ng-if=\"pubblicazione.pubblicazione.prodottoId\">Id UGOV: {{pubblicazione.pubblicazione.prodottoId}} -</span><span ng-if=\"pubblicazione.pubblicazione.handle\">Handle: {{pubblicazione.pubblicazione.handle}} -</span>{{pubblicazione.pubblicazione.tipo}}</div><div class=\"titolo\">{{pubblicazione.pubblicazione.titolo}}</div><div class=\"autori\"><span class=\"anno\">{{pubblicazione.pubblicazione.anno}}</span> - {{pubblicazione.pubblicazione.autori}}</div><div class=\"descrizione\">{{pubblicazione.pubblicazione.testo}}</div></td><td class=\"ifColumn\" ng-if=\"pubblPartCtrl.opts.showImpactFactor\">{{pubblicazione.pubblicazione.impactFactor ? pubblicazione.pubblicazione.impactFactor : \'-\'}}</td><td class=\"participantColumn\">{{pubblicazione.utente.cognome}} {{pubblicazione.utente.nome}}</td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{pubblPartCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-publicationsRend/sgb-add-publications-rend-man.html","<div class=\"sgbAddPublicationsRendMan\"><h3 ng-if=\"!addPubblRendManCtrl.pubblicazione\">Aggiungi manualmente una pubblicazione non presente su IRIS</h3><h3 ng-if=\"addPubblRendManCtrl.pubblicazione\">Modifica pubblicazione</h3><form name=\"addPubblRendManCtrl.pubblRendManForm\"><div class=\"values-box\"><div class=\"form-group\"><label>Titolo</label> <textarea type=\"text\" maxlength=\"4000\" placeholder=\"Obbligatorio\" class=\"form-control\" ng-model=\"addPubblRendManCtrl.tempPubblicazione.titolo\" required=\"\">\n            </textarea></div><div class=\"form-group\"><label>Anno</label> <input type=\"text\" placeholder=\"Obbligatorio\" integer-field-parser=\"\" allow-empty=\"true\" class=\"form-control year-input\" ng-model=\"addPubblRendManCtrl.tempPubblicazione.anno\" required=\"\"></div><div class=\"form-group\"><label>Autori</label> <textarea type=\"text\" maxlength=\"4000\" placeholder=\"Obbligatorio\" class=\"form-control\" ng-model=\"addPubblRendManCtrl.tempPubblicazione.autori\" required=\"\">\n            </textarea></div><div class=\"form-group\"><label>Riferimento della rivista, conferenza, libro o altro</label> <textarea type=\"text\" placeholder=\"Obbligatorio\" class=\"form-control\" ng-model=\"addPubblRendManCtrl.tempPubblicazione.testo\" required=\"\">\n            </textarea></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"addPubblRendManCtrl.close()\">Chiudi</button> <button type=\"button\" ng-disabled=\"addPubblRendManCtrl.pubblRendManForm.$invalid\" class=\"ngdialog-button ngdialog-button-primary\" ng-click=\"addPubblRendManCtrl.confirm()\"><span ng-if=\"!addPubblRendManCtrl.pubblicazione\">Aggiungi</span> <span ng-if=\"addPubblRendManCtrl.pubblicazione\">Modifica</span></button></div></form></div>");
$templateCache.put("app/components/sgb-publicationsRend/sgb-add-publications-rend.html","<div class=\"sgbAddPublicationsRend\"><h3>Seleziona le pubblicazioni prodotte nel progetto</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca su IRIS per handle prodotto (ad es. 11573/000000)\" ng-model=\"addPubblRendCtrl.searchInput\" ng-change=\"addPubblRendCtrl.findPublicationDelay(addPubblRendCtrl.searchInput)\"><div class=\"resultsContainer well\"><p class=\"noResults\" ng-if=\"addPubblRendCtrl.results.length == 0\">nessun risultato</p><div class=\"spinner\" ng-if=\"addPubblRendCtrl.searching\"></div><div class=\"publResult\" ng-repeat=\"result in addPubblRendCtrl.results\"><div><div class=\"idInfo\"><span ng-if=\"result.prodottoId\">Id UGOV: {{result.prodottoId}} -</span><span ng-if=\"result.handle\">Handle: {{result.handle}} -</span>{{result.tipo}}</div><div class=\"titolo\">{{result.titolo}}</div><div class=\"autori\">{{result.anno}} - {{result.autori}}</div><div class=\"descrizione\">{{result.testo}}</div></div><div class=\"addPublication\" ng-class=\"{\'selected\': result.isAlreadyRequested}\"><a href=\"\" ng-click=\"addPubblRendCtrl.addPublication(result)\" ng-if=\"!result.isAlreadyRequested && (!addPubblRendCtrl.numMax || addPubblRendCtrl.pubblicazioni.length < addPubblRendCtrl.numMax)\"><i class=\"fa fa-plus\"></i></a><div class=\"notAvailable\" ng-if=\"!result.isAlreadyRequested && (addPubblRendCtrl.numMax && addPubblRendCtrl.pubblicazioni.length >= addPubblRendCtrl.numMax)\">Numero massimo raggiunto</div><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-check\"></i><div>Pubblicazione selezionata</div></div></div></div><div class=\"errorMessage\" ng-if=\"addPubblRendCtrl.errorMessage\">Errore nel caricamento delle pubblicazioni da IRIS<br>{{addPubblRendCtrl.errorMessage}}<br><a href=\"\" ng-click=\"addPubblRendCtrl.findPublication(addPubblRendCtrl.searchInput)\">riprova</a></div></div></div>");
$templateCache.put("app/components/sgb-publicationsRend/sgb-publicationsRend.html","<div class=\"form-group row sgbField sgbPublicationsRend\"><label class=\"col-sm-12\">{{pubblRendCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"indexColumn\"></th><th class=\"descrColumn\">Pubblicazione</th><th class=\"sourceColumn\">Provenienza</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noPublications\" ng-if=\"pubblRendCtrl.model.length == 0\"><td colspan=\"4\">Nessuna pubblicazione</td></tr><tr ng-repeat=\"pubblicazione in pubblRendCtrl.model\"><td class=\"indexColumn\">{{$index + 1}}</td><td class=\"descrColumn\"><div class=\"idInfo\" ng-if=\"pubblicazione.prodottoId || pubblicazione.handle\"><span ng-if=\"pubblicazione.prodottoId\">Id UGOV: {{pubblicazione.prodottoId}} -</span><span ng-if=\"pubblicazione.handle\">Handle: {{pubblicazione.handle}} -</span>{{pubblicazione.tipo}}</div><div class=\"titolo\">{{pubblicazione.titolo}}</div><div class=\"autori\"><span class=\"anno\">{{pubblicazione.anno}}</span> - {{pubblicazione.autori}}</div><div class=\"descrizione\">{{pubblicazione.testo}}</div></td><td class=\"sourceColumn\">{{pubblicazione.prodottoId || pubblicazione.handle ? \'IRIS\' : \'Inserimento manuale\'}}</td><td class=\"actionColumn\"><a href=\"\" ng-if=\"!pubblicazione.prodottoId && !pubblicazione.handle\" ng-click=\"pubblRendCtrl.addEditPublicationManual(pubblicazione)\"><i class=\"fa fa-pencil\"></i></a><a href=\"\" ng-click=\"pubblRendCtrl.removePublication($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"pubblRendCtrl.addPublication()\" ng-if=\"!pubblRendCtrl.numMax || pubblRendCtrl.model.length < pubblRendCtrl.numMax\"><i class=\"fa fa-plus\"></i> aggiungi da IRIS</a> <a href=\"\" ng-click=\"pubblRendCtrl.addEditPublicationManual()\" ng-if=\"!pubblRendCtrl.numMax || pubblRendCtrl.model.length < pubblRendCtrl.numMax\" style=\"margin-left: 30px;\"><i class=\"fa fa-plus\"></i> aggiungi manualmente</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{pubblRendCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-report/sgb-report.html","<div class=\"form-group row sgbField sgbReport\"><label class=\"col-sm-12\">{{reprt.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"expenseColumn\">Voce di spesa</th><th class=\"valueColumn\">Finanziamento richiesto</th><th class=\"valueColumn\">Finanziamento concesso</th><th class=\"valueColumn\">Finanziamento speso</th><th class=\"descriptionColumn\">Descrizione utilizzo fondi</th></tr></thead><tbody><tr ng-repeat=\"row in reprt.model.vociRendicontoList\"><td class=\"expenseColumn\">{{row.nome}}</td><td class=\"valueColumn readonlyValue\">{{row.finanziamentoRichiesto}}</td><td class=\"valueColumn readonlyValue greyValue\">{{(row.finanziamentoRichiesto / reprt.model.totaleRichiesto * reprt.model.totaleConcesso) | currencyFilterNoThousands}}</td><td class=\"valueColumn\"><input type=\"text\" ng-blur=\"reprt.checkPercSpeso(row, $index)\" class=\"form-control\" ng-model=\"row.finanziamentoSpeso\" currency-field-parser=\"\"><span ng-if=\"reprt.checkScostamento && reprt.asteriskRows[$index]\">*</span></td><td class=\"descriptionColumn\"><textarea class=\"form-control\" rows=\"5\" ng-model=\"row.descrizioneSpesa\"></textarea></td></tr><tr class=\"totalRow\"><td class=\"expenseColumn\">TOTALE</td><td class=\"valueColumn\">{{reprt.model.totaleRichiesto | number}}<div style=\"font-size: 10px; font-weight: normal;\">richiesti</div></td><td class=\"valueColumn\">{{reprt.model.totaleConcesso | number}}<div style=\"font-size: 10px; font-weight: normal;\">concessi</div></td><td class=\"valueColumn\" ng-class=\"{\'text-danger\' : reprt.getTotal(reprt.model.vociRendicontoList, \'finanziamentoSpeso\') > reprt.model.totaleConcesso}\">{{reprt.getTotal(reprt.model.vociRendicontoList, \'finanziamentoSpeso\') | currencyFilter }}<div style=\"font-size: 10px; font-weight: normal;\">spesi</div></td><td class=\"descriptionColumn\"></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\" ng-bind-html=\"reprt.help\"></span></div><div class=\"col-sm-12\" ng-if=\"reprt.checkScostamento && reprt.showPercSpesoTextarea()\"><div class=\"perc-speso-label\">* Indicare le motivazioni dello scostamento significativo di alcune voci rispetto alla somma concessa</div><textarea class=\"form-control motivazioneArea\" rows=\"5\" ng-model=\"reprt.modelMotivazione\"></textarea></div></div>");
$templateCache.put("app/components/sgb-researchIndicators/sgb-researchIndicators.html","<div class=\"form-group row sgbField sgbResearchIndicators\"><label class=\"col-sm-12\">{{resIndCtrl.label}}</label><div class=\"col-sm-12 unavailableIndicators\" ng-if=\"resIndCtrl.model.soglia1 == null\"><p class=\"alert alert-warning\">Gli indicatori non sono stati calcolati dall\'Ateneo in quanto non è disponibile un settore concorsuale di riferimento. In genere ciò accade ai docenti che hanno preso servizio in prossimità dell\'apertura del bando e i cui dati non sono ancora censiti nelle anagrafiche di Ateneo. In ogni caso si ricorda che, ai fini della valutazione, verranno considerati i dati che risultano alla data di chiusura del bando.<br>E\' possibile, comunque, comunicare il proprio settore concorsuale e il proprio settore scientifico disciplinare al seguente indirizzo: ufficioricerca@uniroma1.it mettendo in copia gruppo-pubblicazioni@uniroma1.it.</p></div><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"labelColumn\">&nbsp;</th><th class=\"indicatorColumn\">Indicatore A</th><th class=\"indicatorColumn\">Indicatore B</th><th class=\"indicatorColumn\">Indicatore C</th></tr></thead><tbody><tr><th class=\"labelColumn\" ng-if=\"resIndCtrl.model.soglia1 != null\">Valore soglia SC {{resIndCtrl.model.sc}} - SSD {{resIndCtrl.model.ssd}}</th><th class=\"labelColumn\" ng-if=\"resIndCtrl.model.soglia1 == null\">Valore soglia</th><td class=\"indicatorColumn\">{{resIndCtrl.model.soglia1 != null ? resIndCtrl.model.soglia1 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl.model.soglia2 != null ? resIndCtrl.model.soglia2 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl.model.soglia3 != null ? resIndCtrl.model.soglia3 : \'-\'}}</td></tr><tr><th class=\"labelColumn\" ng-if=\"resIndCtrl.model.soglia1 != null\">Valore dell\'indicatore calcolato dall\'Ateneo al {{resIndCtrl.model.dataIndicatore}}</th><th class=\"labelColumn\" ng-if=\"resIndCtrl.model.soglia1 == null\">Valore dell\'indicatore calcolato dall\'Ateneo</th><td class=\"indicatorColumn\">{{resIndCtrl.model.indicatore1 != null ? resIndCtrl.model.indicatore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl.model.indicatore2 != null ? resIndCtrl.model.indicatore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl.model.indicatore3 != null ? resIndCtrl.model.indicatore3 : \'-\'}}</td></tr><tr ng-if=\"resIndCtrl.opts.allowCorrection\"><th class=\"labelColumn\" ng-if=\"resIndCtrl.model.soglia1 != null\">Eventuale rettifica del valore dell\'indicatore, dichiarata dal docente</th><th class=\"labelColumn\" ng-if=\"resIndCtrl.model.soglia1 == null\">Valore dell\'indicatore, dichiarato dal docente</th><td class=\"indicatorColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl.model.valore1\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"indicatorColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl.model.valore2\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"indicatorColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl.model.valore3\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td></tr><tr class=\"separator\"><th colspan=\"4\"></th></tr><tr class=\"borderless\"><th class=\"labelColumn\">Eventuali mesi di congedo ai fini del calcolo dell\'indicatore A</th><td class=\"indicatorColumn\"><ui-select search-enabled=\"false\" ng-model=\"resIndCtrl.model.mesiCongedo1\" on-select=\"resIndCtrl.onSelect1Change($select.selected)\"><ui-select-match allow-clear=\"true\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in resIndCtrl.mesiCongedoRange\"><div ng-bind-html=\"item\"></div></ui-select-choices></ui-select></td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"resIndCtrl.model.soglia1 != null || !resIndCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"resIndCtrl.model.soglia1 == null && resIndCtrl.opts.allowCorrection\">SC</th><td class=\"indicatorColumn\" ng-if=\"resIndCtrl.model.soglia1 == null && resIndCtrl.opts.allowCorrection\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl.model.sc\"></td></tr><tr class=\"borderless\"><th class=\"labelColumn\">Eventuali mesi di congedo ai fini del calcolo degli indicatori B e C</th><td class=\"indicatorColumn\"><ui-select search-enabled=\"false\" ng-model=\"resIndCtrl.model.mesiCongedo2\" ng-required=\"resIndCtrl.model.mesiCongedo1 > 0\"><ui-select-match allow-clear=\"true\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in resIndCtrl.mesiCongedoRange | filter: resIndCtrl.gte(resIndCtrl.model.mesiCongedo1)\"><div ng-bind-html=\"item\"></div></ui-select-choices></ui-select></td><th class=\"labelColumn\" colspan=\"2\" ng-if=\"resIndCtrl.model.soglia1 != null || !resIndCtrl.opts.allowCorrection\"><span class=\"errorMessage\" ng-if=\"resIndCtrl.model.mesiCongedo1 > 0 && resIndCtrl.model.mesiCongedo2 == null\"><i class=\"fa fa-arrow-left\"></i>&nbsp;Obbligatorio</span></th><th class=\"labelRightColumn\" ng-if=\"resIndCtrl.model.soglia1 == null && resIndCtrl.opts.allowCorrection\">SSD</th><td class=\"indicatorColumn\" ng-if=\"resIndCtrl.model.soglia1 == null && resIndCtrl.opts.allowCorrection\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl.model.ssd\"></td></tr></tbody></table></div><div class=\"col-sm-12 authorizationCheck\"><input type=\"checkbox\" ng-model=\"resIndCtrl.model.autorizzazione\" ng-required=\"resIndCtrl.authRequired\"><span>Autorizzo la commissione giudicatrice e gli altri partecipanti la presente proposta progettuale alla visione dei miei valori relativi alla produttività scientifica.</span></div><div class=\"col-sm-12\"><span class=\"help-block\">{{resIndCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-researchIndicators2021/sgb-researchIndicators2021.html","<div class=\"form-group row sgbField sgbResearchIndicators2021\"><label class=\"col-sm-12\">{{resIndCtrl2021.label}}</label><div class=\"col-sm-12 unavailableIndicators\" ng-if=\"resIndCtrl2021.model.soglia1 == null\"><p class=\"alert alert-warning\">Gli indicatori non sono stati calcolati dall\'Ateneo in quanto non è disponibile un settore concorsuale di riferimento. In genere ciò accade ai docenti che hanno preso servizio in prossimità dell\'apertura del bando e i cui dati non sono ancora censiti nelle anagrafiche di Ateneo.<br>E\' possibile, comunque, comunicare il proprio settore concorsuale e il proprio settore scientifico disciplinare al seguente indirizzo: ufficioricerca@uniroma1.it mettendo in copia gruppo-pubblicazioni@uniroma1.it.</p></div><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"labelColumn\">&nbsp;</th><th class=\"indicatorColumn\">Indicatore A</th><th class=\"indicatorColumn\">Indicatore B</th><th class=\"indicatorColumn\">Indicatore C</th></tr></thead><tbody><tr><th class=\"labelColumn\" ng-if=\"resIndCtrl2021.model.soglia1 != null\">Valore soglia SC {{resIndCtrl2021.model.sc}} - SSD {{resIndCtrl2021.model.ssd}}</th><th class=\"labelColumn\" ng-if=\"resIndCtrl2021.model.soglia1 == null\">Valore soglia</th><td class=\"indicatorColumn\">{{resIndCtrl2021.model.soglia1 != null ? resIndCtrl2021.model.soglia1 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl2021.model.soglia2 != null ? resIndCtrl2021.model.soglia2 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl2021.model.soglia3 != null ? resIndCtrl2021.model.soglia3 : \'-\'}}</td></tr><tr><th class=\"labelColumn\" ng-if=\"resIndCtrl2021.model.soglia1 != null\">Valore dell\'indicatore calcolato dall\'Ateneo al {{resIndCtrl2021.model.dataIndicatore}}</th><th class=\"labelColumn\" ng-if=\"resIndCtrl2021.model.soglia1 == null\">Valore dell\'indicatore calcolato dall\'Ateneo</th><td class=\"indicatorColumn\">{{resIndCtrl2021.model.indicatore1 != null ? resIndCtrl2021.model.indicatore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl2021.model.indicatore2 != null ? resIndCtrl2021.model.indicatore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{resIndCtrl2021.model.indicatore3 != null ? resIndCtrl2021.model.indicatore3 : \'-\'}}</td></tr><tr ng-if=\"resIndCtrl2021.opts.allowCorrection\"><th class=\"labelColumn\" ng-if=\"resIndCtrl2021.model.soglia1 != null\">Eventuale rettifica del valore dell\'indicatore, dichiarata dal docente</th><th class=\"labelColumn\" ng-if=\"resIndCtrl2021.model.soglia1 == null\">Valore dell\'indicatore, dichiarato dal docente</th><td class=\"indicatorColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl2021.model.valore1\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"indicatorColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl2021.model.valore2\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td><td class=\"indicatorColumn\"><input type=\"text\" class=\"form-control\" ng-model=\"resIndCtrl2021.model.valore3\" ng-trim=\"false\" integer-field-parser=\"\" allow-empty=\"true\"></td></tr><tr class=\"separator\"><th colspan=\"4\"></th></tr></tbody></table></div><div class=\"col-sm-12 authorizationCheck\"><input type=\"checkbox\" ng-model=\"resIndCtrl2021.model.autorizzazione\" ng-required=\"resIndCtrl2021.authRequired\"><span>Autorizzo la commissione giudicatrice e gli altri partecipanti la presente proposta progettuale alla visione dei miei valori relativi alla produttività scientifica.</span></div><div class=\"col-sm-12\"><span class=\"help-block\">{{resIndCtrl2021.help}}</span></div></div>");
$templateCache.put("app/components/sgb-researchIndicatorsPart/sgb-researchIndicatorsPart.html","<div class=\"form-group row sgbField sgbResearchIndicatorsPart\"><label class=\"col-sm-12\">{{resIndPartCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"labelColumn\">&nbsp;</th><th class=\"indicatorColumn\">Indicatore A</th><th class=\"indicatorColumn\">Indicatore B</th><th class=\"indicatorColumn\">Indicatore C</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"resIndPartCtrl.model.length == 0\"><td colspan=\"5\">Nessun componente</td></tr><tr class=\"userRow\" ng-repeat-start=\"indicatorePart in resIndPartCtrl.model\"><td class=\"nameColumn\" ng-if=\"!indicatorePart.autorizzazione\">{{indicatorePart.utente.cognome}} {{indicatorePart.utente.nome}}</td><td class=\"missingAuthMessage\" colspan=\"4\" ng-if=\"!indicatorePart.autorizzazione\">Il docente non ha ancora autorizzato la visione degli indicatori.</td><td class=\"nameColumn\" rowspan=\"{{resIndPartCtrl.opts.allowCorrection ? 5 : 4}}\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.utente.cognome}} {{indicatorePart.utente.nome}}</td><th class=\"labelColumn\" ng-if=\"indicatorePart.autorizzazione\"><span ng-if=\"indicatorePart.soglia1 != null\">Valore soglia SC {{indicatorePart.sc}} - SSD {{indicatorePart.ssd}}</span> <span ng-if=\"indicatorePart.soglia1 == null\">Valore soglia</span></th><td class=\"indicatorColumn\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.soglia1 != null ? indicatorePart.soglia1 : \'-\'}}</td><td class=\"indicatorColumn\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.soglia2 != null ? indicatorePart.soglia2 : \'-\'}}</td><td class=\"indicatorColumn\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.soglia3 != null ? indicatorePart.soglia3 : \'-\'}}</td></tr><tr ng-if=\"indicatorePart.autorizzazione\"><th class=\"labelColumn\"><span ng-if=\"indicatorePart.soglia1 != null\">Valore calcolato dall\'Ateneo al {{indicatorePart.dataIndicatore}}</span> <span ng-if=\"indicatorePart.soglia1 == null\">Valore calcolato dall\'Ateneo</span></th><td class=\"indicatorColumn\">{{indicatorePart.indicatore1 != null ? indicatorePart.indicatore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.indicatore2 != null ? indicatorePart.indicatore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.indicatore3 != null ? indicatorePart.indicatore3 : \'-\'}}</td></tr><tr ng-if=\"indicatorePart.autorizzazione && resIndPartCtrl.opts.allowCorrection\"><th class=\"labelColumn\"><span ng-if=\"indicatorePart.soglia1 != null\">Eventuale rettifica del valore, dichiarata dal docente</span> <span ng-if=\"indicatorePart.soglia1 == null\">Valore dell\'indicatore, dichiarato dal docente</span></th><td class=\"indicatorColumn\">{{indicatorePart.valore1 != null ? indicatorePart.valore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.valore2 != null ? indicatorePart.valore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.valore3 != null ? indicatorePart.valore3 : \'-\'}}</td></tr><tr ng-if=\"indicatorePart.autorizzazione\"><th class=\"labelColumn\">Eventuali mesi di congedo (indicatore A)</th><td class=\"indicatorColumn\">{{indicatorePart.mesiCongedo1 != null ? indicatorePart.mesiCongedo1 : \'-\'}}</td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"indicatorePart.soglia1 != null || !resIndPartCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"indicatorePart.soglia1 == null && resIndPartCtrl.opts.allowCorrection\">SC</th><td class=\"indicatorColumn\" ng-if=\"indicatorePart.soglia1 == null && resIndPartCtrl.opts.allowCorrection\">{{indicatorePart.sc != null ? indicatorePart.sc : \'-\'}}</td></tr><tr class=\"noBorderTop\" ng-if=\"indicatorePart.autorizzazione\" ng-repeat-end=\"\"><th class=\"labelColumn\">Eventuali mesi di congedo (indicatori B e C)</th><td class=\"indicatorColumn\">{{indicatorePart.mesiCongedo2 != null ? indicatorePart.mesiCongedo2 : \'-\'}}</td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"indicatorePart.soglia1 != null || !resIndPartCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"indicatorePart.soglia1 == null && resIndPartCtrl.opts.allowCorrection\">SSD</th><td class=\"indicatorColumn\" ng-if=\"indicatorePart.soglia1 == null && resIndPartCtrl.opts.allowCorrection\">{{indicatorePart.ssd != null ? indicatorePart.ssd : \'-\'}}</td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{resIndPartCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-richText/sgb-richText.html","<div class=\"form-group row sgbField sgbRichText\"><label class=\"col-sm-12\">{{vm.label}}</label><div ng-class=\"{ \'col-sm-12\': vm.fullWidth === \'true\', \'col-sm-8\' : vm.fullWidth !== \'true\' }\"><textarea class=\"form-control\" rows=\"5\" ng-model=\"vm.model\" ng-trim=\"false\" data-ck-editor=\"\" max-length=\"vm.maxLength\" editor-height=\"400px\"></textarea></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-section/sgb-section.html","<div class=\"sgbSection\"><div class=\"sgbLegend\">{{vm.name}}</div><div ng-transclude=\"\"></div></div>");
$templateCache.put("app/components/sgb-select/sgb-select.html","<div class=\"form-group row sgbField sgbSelect\"><label class=\"col-sm-12\">{{selectCtrl.label}}</label><div class=\"col-sm-8\" ng-if=\"!selectCtrl.simple\"><ui-select search-enabled=\"false\" ng-model=\"selectCtrl.selectedItem.id\" on-select=\"selectCtrl.onSelect($item, $model)\" ng-required=\"selectCtrl.isRequired\"><ui-select-match allow-clear=\"true\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"item.id as item in selectCtrl.choices\"><div ng-bind-html=\"item.label\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-8\" ng-if=\"selectCtrl.simple\"><ui-select search-enabled=\"false\" ng-model=\"selectCtrl.model\" ng-required=\"selectCtrl.isRequired\"><ui-select-match allow-clear=\"true\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in selectCtrl.choices\"><div ng-bind-html=\"item\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-12\"><span class=\"help-block\">{{selectCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-selectFields/sgb-selectFields.html","<div class=\"form-group row sgbField sgbSelectFields\"><label class=\"col-sm-12\">{{selectsCtrl.label}}</label><div class=\"col-sm-8\"><ol><li ng-repeat=\"number in (selectsCtrl.range | filter:selectsCtrl.filter2) track by number\"><ui-select search-enabled=\"false\" ng-model=\"selectsCtrl.model[number-1].id\" on-select=\"selectsCtrl.onSelect(number-1, $item, $model)\"><ui-select-match allow-clear=\"true\"><span title=\"{{$select.selected.label}}\">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat=\"item.id as item in selectsCtrl.choices\"><div ng-bind-html=\"item.label\"></div></ui-select-choices></ui-select></li><a href=\"\" ng-click=\"selectsCtrl.addRow()\" ng-if=\"selectsCtrl.editable===\'true\'\"><i class=\"fa fa-plus\"></i> aggiungi</a></ol></div><div class=\"col-sm-12\"><span class=\"help-block\">{{selectsCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-telephone/sgb-telephone.html","<div class=\"form-group row sgbField sgbTelephone\"><label class=\"col-sm-12\">{{telCtrl.label}}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"telCtrl.model\" telephone-field-parser=\"\"></div><div class=\"col-sm-12\"><span class=\"help-block\">{{telCtrl.help}}</span></div></div>");
$templateCache.put("app/components/sgb-textarea/sgb-textarea.html","<div class=\"form-group row sgbField sgbTextarea\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"vm.description\"><span ng-bind-html=\"vm.description\"></span></div><div class=\"col-sm-8\"><textarea class=\"form-control\" rows=\"{{vm.numRows ? vm.numRows : 5}}\" ng-model=\"vm.model\" ng-trim=\"false\" readonly=\"\" ng-if=\"vm.isReadonly\"></textarea> <textarea class=\"form-control\" rows=\"{{vm.numRows ? vm.numRows : 5}}\" ng-model=\"vm.model\" ng-trim=\"false\" ng-if=\"!vm.isReadonly && !vm.maxLength\"></textarea> <textarea class=\"form-control\" rows=\"{{vm.numRows ? vm.numRows : 5}}\" ng-model=\"vm.model\" ng-trim=\"false\" maxlength=\"{{vm.maxLength * 2}}\" ng-if=\"!vm.isReadonly && !!vm.maxLength\"></textarea><div class=\"charCounter\" ng-class=\"{\'outOfBounds\': vm.model.length > vm.maxLength}\" ng-if=\"!vm.isReadonly && !!vm.maxLength\">{{vm.model.length}} / {{vm.maxLength}}</div></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-textfield/sgb-textfield.html","<div class=\"form-group row sgbField sgbTextfield\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.model\" readonly=\"\" ng-if=\"vm.isReadonly\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.model\" ng-if=\"!vm.isReadonly\"></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/sgb-yesNoRadio/sgb-yesNoRadio.html","<div class=\"form-group row sgbField sgbYesNoRadio\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-8\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"vm.model\" ng-value=\"true\"> Sì</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"vm.model\" ng-value=\"false\"> No</label></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/statisticheProgetti/statisticheProgetti.html","<div class=\"statisticheProgettiContainer\"><div><h1 class=\"page-header\">Statistiche <small>{{statisticheCtrl.selectedAnno.anno}}</small> <a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta le statistiche in csv\" ng-href=\"{{statisticheCtrl.getCsvExportUrl()}}\" ng-if=\"statisticheCtrl.selectedAnno.anno\"><i class=\"fa fa-file-o\"></i> Esporta</a> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"statisticheCtrl.getStatistiche()\" ng-model=\"statisticheCtrl.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (statisticheCtrl.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1></div><div><div class=\"spinner\" ng-if=\"statisticheCtrl.statistiche == null\"></div><div ng-if=\"statisticheCtrl.statistiche != null\"><div ng-repeat=\"(key, value) in statisticheCtrl.statistiche | groupBy: \'nomeBando\'\" class=\"bando\"><h3>{{key}}</h3><statistiche-table statistiche=\"value\"></statistiche-table></div></div></div></div>");
$templateCache.put("app/components/statisticheTable/statisticheTable.html","<div class=\"statisticheTable\" ng-if=\"statTableCtrl.stats != null\"><table class=\"table\"><thead><tr><th class=\"tipologia\">Tipologia</th><th class=\"centerColumn\">Proposte in Bozza</th><th class=\"centerColumn\">Proposte Inviate</th><th class=\"centerColumn\">Proposte Valutate</th><th class=\"centerColumn\">Proposte Finanziate</th><th class=\"centerColumn\">Budget Finanziamento</th><th class=\"centerColumn\">Finanziamento Richiesto</th><th class=\"centerColumn\">Assegno Richiesto</th><th class=\"centerColumn\">Finanziamento Concesso</th><th class=\"centerColumn\">Assegno Concesso</th></tr></thead><tbody><tr ng-repeat=\"row in statTableCtrl.stats\" ng-class=\"\'group\' + row.level\" ng-if=\"!row.showCondition || $eval(row.showCondition)\"><td class=\"labelColumn\"><div ng-if=\"row.level !== \'separator\'\"><span class=\"expandButton\" ng-if=\"row.level == 2 || row.level == 3\"><i class=\"fa fa-caret-right\" ng-if=\"!statTableCtrl.expanded[row.key]\" ng-click=\"statTableCtrl.expanded[row.key] = true\"></i><i class=\"fa fa-caret-down\" ng-if=\"statTableCtrl.expanded[row.key]\" ng-click=\"statTableCtrl.expanded[row.key] = false\"></i></span>{{row.label}}</div></td><td class=\"centerColumn\">{{row.numeroProposteBozza | number}}</td><td class=\"centerColumn\">{{row.numeroProposteInviate | number}}</td><td class=\"centerColumn\">{{row.numeroProposteValutate | number}}</td><td class=\"centerColumn\">{{row.numeroProposteFinanziate | number}}</td><td class=\"centerColumn\"><span ng-if=\"row.totaleFinanziabile != null\">{{row.totaleFinanziabile | number}}</span> <span ng-if=\"row.totaleFinanziabile === null\">-</span></td><td class=\"centerColumn\">{{row.finanziamentoRichiesto | number}}</td><td class=\"centerColumn\">{{row.assegnoRichiesto | number}}&nbsp;({{row.numeroAssegniRichiesti | number}})</td><td class=\"centerColumn\">{{row.finanziamentoConcesso | number}}</td><td class=\"centerColumn\">{{row.assegnoConcesso | number}}&nbsp;({{row.numeroAssegniConcessi | number}})</td></tr><tr class=\"totalGroup\"><td>TOTALE</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.numeroProposteBozza | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.numeroProposteInviate | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.numeroProposteValutate | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.numeroProposteFinanziate | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.totaleFinanziabile | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.finanziamentoRichiesto | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.assegnoRichiesto | number}}&nbsp;({{statTableCtrl.totalStat.numeroAssegniRichiesti | number}})</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.finanziamentoConcesso | number}}</td><td class=\"centerColumn\">{{statTableCtrl.totalStat.assegnoConcesso | number}}&nbsp;({{statTableCtrl.totalStat.numeroAssegniConcessi | number}})</td></tr></tbody></table></div>");
$templateCache.put("app/components/storicoTitolari/storicoTitolari.html","<div class=\"storicoTitolari\"><h3 class=\"title\">Storico Titolari Progetto</h3><div class=\"content\"><div class=\"loading\" ng-if=\"!titCtrl.titolari\"><div class=\"spinner\"></div></div><div ng-if=\"titCtrl.titolari\"><table class=\"table table-hover\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"dataColumn\">Data cambio</th><th class=\"motivazioneColumn\">Motivazione cambio</th><th class=\"allegatoColumn\">Allegato</th></tr></thead><tbody><tr><td class=\"nameColumn\"><div>{{titCtrl.proponente.cognome}} {{titCtrl.proponente.nome}}</div></td><td class=\"dataColumn\" colspan=\"3\">Proponente</td></tr><tr ng-repeat=\"titolare in titCtrl.titolari\"><td class=\"nameColumn\"><div>{{titolare.titolare.cognome}} {{titolare.titolare.nome}}</div></td><td class=\"dataColumn\">{{titolare.createdTimestamp | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"motivazioneColumn\">{{titolare.motivazioneCambio}}</td><td class=\"allegatoColumn\"><a target=\"_blank\" ng-if=\"titolare.allegato !== null\" ng-href=\"{{titCtrl.getFileHref(titolare.allegato)}}\"><i class=\"fa fa-file-pdf-o\"></i></a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/valutaProposta/valutaProposta.html","<form name=\"valutaCtrl.valutaForm\" novalidate=\"\"><div class=\"valutaProposta\"><h3 class=\"title\">{{\"EVALUATE_PROJECT\" | translate}}</h3><div class=\"well\"><div class=\"valueRow\"><label>{{\"TITLE\" | translate}}</label> <span>{{valutaCtrl.proposta.titolo ? valutaCtrl.proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</span></div><div class=\"valueRow\" ng-if=\"valutaCtrl.proposta.responsabile\"><label>{{\"RESPONSIBLE\" | translate}}</label> <span>{{valutaCtrl.proposta.responsabile.cognome + \' \' + valutaCtrl.proposta.responsabile.nome}}</span></div><div class=\"valueRow\" ng-if=\"valutaCtrl.proposta.responsabile.dipartimento\"><label>Macroarea</label> <span>{{valutaCtrl.proposta.responsabile.dipartimento.macroArea.code}} - {{valutaCtrl.proposta.responsabile.dipartimento.macroArea.nome}}</span></div><div class=\"valueRow\" ng-if=\"valutaCtrl.proposta.responsabile.dipartimento\"><label>{{\"DEPARTMENT\" | translate}}</label> <span>{{valutaCtrl.proposta.responsabile.dipartimento.nome}}</span></div><div class=\"valueRow\" ng-if=\"valutaCtrl.proposta.tipologiaProgetto && valutaCtrl.proposta.classe\"><label>{{\"TYPE_AND_CLASS\" | translate}}</label> <span>{{valutaCtrl.proposta.tipologiaProgetto.nome}} - {{valutaCtrl.proposta.classe.nome}}</span></div></div><div class=\"content\"><div class=\"loading\" ng-if=\"!valutaCtrl.valutazione\"><div class=\"spinner\"></div></div><div ng-if=\"valutaCtrl.valutazione\"><div class=\"form-group\"><label><span ng-if=\"!valutaCtrl.senzaPunteggio\">{{\'EVALUTATION\' | translate}}</span> <span ng-if=\"valutaCtrl.senzaPunteggio\">{{\'EVALUATION_CRITERIA\' | translate}}</span></label><div ng-if=\"!valutaCtrl.senzaPunteggio\"><div class=\"criterioPanel\" ng-class=\"{\'disabled\': !criterioObj.enabled}\" ng-repeat=\"criterioObj in valutaCtrl.valutazione.valutazionePunteggioList | orderBy: \'criterio.posizione\'\" ng-init=\"criterioObj.enabled = true;\"><div class=\"descrizioneBox\">{{criterioObj.criterio.descrizione}}</div><div ng-if=\"criterioObj.criterio.valoreList.length > 0\"><div ng-if=\"criterioObj.criterio.tipo == \'MEDIA_REFEREE\'\"><div class=\"well readonlyValue\">{{criterioObj.punteggio}}<span class=\"valutazioneFieldHint\">(media referee)</span></div></div><div ng-if=\"criterioObj.criterio.tipo == \'DIPARTIMENTALI\'\"><div class=\"well readonlyValue\">{{valutaCtrl.getDipartimentoQualificato(criterioObj)}}<span class=\"valutazioneFieldHint\"></span></div></div><div class=\"inputBox\" ng-if=\"criterioObj.criterio.tipo == \'MEDIA_REFEREE_MODIFICABILE\' && criterioObj.criterio.valoreList[0].valore == null && criterioObj.criterio.valoreList[0].valoreTrue === null\"><ng-form name=\"formValore\" class=\"form-group\" ng-class=\"{\'has-error\' : formValore.value.$invalid && formValore.value.$dirty}\"><div class=\"row\"><div class=\"col-xs-3 valueLimit\"><div>Min: <b>{{criterioObj.criterio.valoreList[0].minimo}}</b></div><div>Max: <b>{{criterioObj.criterio.valoreList[0].massimo}}</b></div></div><div class=\"col-xs-9\"><div ng-if=\"valutaCtrl.editMode && criterioObj.punteggio == criterioObj.mediaPrecalcolata && !criterioObj.editValue\"><div class=\"well readonlyValue\" style=\"text-align: left;\" ng-if=\"valutaCtrl.editMode && criterioObj.punteggio == criterioObj.mediaPrecalcolata\">{{criterioObj.punteggio }}<span class=\"valutazioneFieldHint\">(media referee)</span></div><a href=\"\" class=\"linkButton\" ng-click=\"valutaCtrl.modificaMedia(criterioObj)\">modifica</a></div><div ng-if=\"valutaCtrl.editMode && (criterioObj.punteggio != criterioObj.mediaPrecalcolata || criterioObj.editValue)\"><input type=\"text\" name=\"value\" class=\"form-control inputValue\" min=\"criterioObj.criterio.valoreList[0].minimo\" max=\"criterioObj.criterio.valoreList[0].massimo\" ng-model=\"criterioObj.punteggio\" float-field-parser=\"\" decimal-limit=\"2\"><div class=\"valueLimit\"><span style=\"float: left;\">Media referee: <b>{{criterioObj.mediaPrecalcolata}}</b></span><a href=\"\" class=\"linkButton\" ng-click=\"valutaCtrl.usaMedia(criterioObj)\">usa media</a></div></div><div ng-if=\"!valutaCtrl.editMode\"><div class=\"well readonlyValue\">{{criterioObj.punteggio}} <span class=\"valutazioneFieldHint\" ng-if=\"criterioObj.punteggio == criterioObj.mediaPrecalcolata\">(media referee)</span></div><div class=\"valueLimit\" ng-if=\"criterioObj.punteggio != criterioObj.mediaPrecalcolata\"><span style=\"float: left;\">Media referee: <b>{{criterioObj.mediaPrecalcolata}}</b></span>&nbsp;</div></div></div></div></ng-form></div><div ng-if=\"!criterioObj.criterio.tipo && criterioObj.criterio.valoreList[0].valore != null\"><ui-select ng-disabled=\"!criterioObj.enabled\" ng-if=\"valutaCtrl.editMode\" ng-model=\"criterioObj.punteggio\" ng-change=\"valutaCtrl.checkBloccante(criterioObj)\" ng-init=\"valutaCtrl.initBloccante(criterioObj)\" search-enabled=\"false\"><ui-select-match><div>{{$select.selected.valore}} - {{$select.selected.descrizione}}</div></ui-select-match><ui-select-choices repeat=\"item.valore as item in (criterioObj.criterio.valoreList | orderBy : \'posizione\') track by item.id\"><div>{{item.valore}} - {{item.descrizione}}</div></ui-select-choices></ui-select><div class=\"well readonlyValue\" ng-if=\"!valutaCtrl.editMode\"><div ng-repeat=\"elem in criterioObj.criterio.valoreList\" ng-if=\"elem.valore == criterioObj.punteggio\">{{elem.valore}} - {{elem.descrizione}}</div></div></div><div ng-if=\"!criterioObj.criterio.tipo && criterioObj.criterio.valoreList[0].valore == null && criterioObj.criterio.valoreList[0].valoreTrue !== null\"><div class=\"radioInputBox\" ng-if=\"valutaCtrl.editMode\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"criterioObj.punteggio\" ng-value=\"criterioObj.criterio.valoreList[0].valoreTrue\"> Sì</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"criterioObj.punteggio\" ng-value=\"criterioObj.criterio.valoreList[0].valoreFalse\"> No</label></div><div class=\"well readonlyValue\" ng-if=\"!valutaCtrl.editMode\">{{criterioObj.punteggio === criterioObj.criterio.valoreList[0].valoreTrue ? \'Sì\' : \'\'}} {{criterioObj.punteggio == criterioObj.criterio.valoreList[0].valoreFalse ? \'No\' : \'\'}}</div></div><div class=\"inputBox\" ng-if=\"!criterioObj.criterio.tipo && criterioObj.criterio.valoreList[0].valore == null && criterioObj.criterio.valoreList[0].valoreTrue === null\"><ng-form name=\"formValore\" class=\"form-group\" ng-class=\"{\'has-error\' : formValore.value.$invalid && formValore.value.$dirty}\"><div class=\"row\"><div class=\"col-xs-3 valueLimit\"><div>Min: <b>{{criterioObj.criterio.valoreList[0].minimo}}</b></div><div>Max: <b>{{criterioObj.criterio.valoreList[0].massimo}}</b></div></div><div class=\"col-xs-9\"><input ng-if=\"valutaCtrl.editMode\" type=\"text\" name=\"value\" class=\"form-control inputValue\" min=\"criterioObj.criterio.valoreList[0].minimo\" max=\"criterioObj.criterio.valoreList[0].massimo\" ng-model=\"criterioObj.punteggio\" float-field-parser=\"\" decimal-limit=\"2\"><div class=\"well readonlyValue\" ng-if=\"!valutaCtrl.editMode\">{{criterioObj.punteggio == 0? \"N/A\" : criterioObj.punteggio}}</div></div></div></ng-form></div></div></div><div class=\"criterioPanel totalRow\" ng-if=\"!valutaCtrl.senzaPunteggio && !valutaCtrl.booleanEvaluation\">{{\'TOTAL\' | translate}}: <span class=\"punteggioValue\">{{ (valutaCtrl.calcolaPunteggioTotale(valutaCtrl.valutazione.valutazionePunteggioList) | number) == 0 ? \"N/A\" : (valutaCtrl.calcolaPunteggioTotale(valutaCtrl.valutazione.valutazionePunteggioList) | number) }}</span></div></div><div ng-if=\"valutaCtrl.senzaPunteggio\"><ul><li ng-class=\"{\'disabled\': !criterioObj.enabled}\" ng-repeat=\"criterioObj in valutaCtrl.valutazione.valutazionePunteggioList | orderBy: \'criterio.posizione\'\" ng-init=\"criterioObj.enabled = true;\">{{criterioObj.criterio.descrizione}}</li></ul></div></div><div class=\"form-group commentoBox\"><label for=\"comment\"><span ng-if=\"!valutaCtrl.senzaPunteggio && valutaCtrl.valutazione.referee\">{{\'MOTIVATION\' | translate}}</span> <span ng-if=\"!valutaCtrl.senzaPunteggio && !valutaCtrl.valutazione.referee\">{{\'EVAL_COMMENT\' | translate}}</span> <span ng-if=\"valutaCtrl.senzaPunteggio\">{{\'EVALUTATION\' | translate}}</span></label> <textarea class=\"form-control\" rows=\"4\" ng-if=\"valutaCtrl.editMode\" ng-model=\"valutaCtrl.valutazione.motivazione\">\n                    </textarea><div class=\"well readonlyValue\" ng-if=\"!valutaCtrl.editMode\">{{valutaCtrl.valutazione.motivazione}}</div></div></div></div><div class=\"ultimaModifica\" ng-if=\"!valutaCtrl.valutazione.referee && valutaCtrl.valutazione.updatedTimestamp && !valutaCtrl.isUser\">{{\"LAST_MODIFIED\" | translate}}: <span class=\"membroCommissione\"><span ng-if=\"!valutaCtrl.isRef\">{{valutaCtrl.valutazione.membroCommissione.cognome}} {{valutaCtrl.valutazione.membroCommissione.nome}} -</span> {{valutaCtrl.valutazione.updatedTimestamp | date: \'medium\'}}</span></div><div class=\"ultimaModifica\" ng-if=\"valutaCtrl.valutazione.referee && valutaCtrl.valutazione.updatedTimestamp && !valutaCtrl.isRef && !valutaCtrl.isUser\">Referee: <span class=\"membroCommissione\">{{valutaCtrl.valutazione.referee.cognome}} {{valutaCtrl.valutazione.referee.nome}} - {{valutaCtrl.valutazione.updatedTimestamp | date: \'medium\'}}</span></div></div><div class=\"ngdialog-buttons\" ng-if=\"valutaCtrl.editMode && valutaCtrl.valutazione\"><button type=\"button\" ng-click=\"valutaCtrl.concludiValutazione()\" class=\"ngdialog-button ngdialog-button-primary\" ng-class=\"{\'ng-button-invalid\': valutaCtrl.checkConcludiDisable()}\" ng-if=\"!valutaCtrl.draftOnly\" ng-disabled=\"valutaCtrl.saveLoading || valutaCtrl.checkConcludiDisable()\">{{\"SAVE_AND_COMPLETE\" | translate}}</button> <button type=\"button\" ng-click=\"valutaCtrl.salvaInBozzaValutazione()\" class=\"ngdialog-button ngdialog-button-primary\" ng-class=\"{\'ng-button-invalid\': valutaCtrl.valutaForm.$invalid}\" ng-disabled=\"valutaCtrl.saveLoading || valutaCtrl.valutaForm.$invalid\">{{\"SAVE_AS_DRAFT\" | translate}}</button></div><div class=\"ngdialog-buttons\" ng-if=\"!valutaCtrl.editMode && valutaCtrl.valutazione && !valutaCtrl.print\"><button type=\"button\" ng-click=\"valutaCtrl.chiudi()\" class=\"ngdialog-button ngdialog-button-secondary\">{{\"CLOSE\" | translate}}</button> <a target=\"_blank\" ng-href=\"{{valutaCtrl.getPdfExportUrl(valutaCtrl.valutazione)}}\" ng-if=\"valutaCtrl.isUr || (!valutaCtrl.isUser && !valutaCtrl.isRef)\" class=\"ngdialog-button ngdialog-button-primary\">{{\"PRINT_PDF\" | translate}}</a></div></form>");
$templateCache.put("app/components/valutazioneProgetti/valutazioneProgetti.html","<div class=\"valutazioneProgetti\"><div class=\"fixedHeader\"><h1 class=\"page-header\">Valutazione Proposte <small>{{vm.selectedAnno.anno}}</small> <span class=\"annoControl\"><span>anno finanziario</span><ui-select class=\"annoSelect\" on-select=\"vm.getTipologieEProposte()\" ng-model=\"vm.selectedAnno\"><ui-select-match>{{$select.selected.anno}}</ui-select-match><ui-select-choices repeat=\"item in (vm.anni | filter: $select.search) track by item.anno\"><div ng-bind-html=\"item.anno | highlight: $select.search\"></div></ui-select-choices></ui-select></span></h1><div class=\"searchFilter\"><form class=\"form-inline\"><div class=\"form-group tipoClasseSelect\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedTipoClasse\"><ui-select-match><div class=\"group\">{{$select.selected.tipologia}}</div><div class=\"item\">{{$select.selected.classe}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.tipologieEClassi | filter: $select.search) track by item.id\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group areaDipSelect\"><ui-select class=\"hierarchicalSelect\" on-select=\"vm.getProposte()\" ng-model=\"vm.selectedAreaDip\"><ui-select-match><div class=\"group\">{{$select.selected.macroarea}}</div><div class=\"item\">{{$select.selected.dipartimento}}</div></ui-select-match><ui-select-choices repeat=\"item in (vm.macroareeEDipartimenti | filter: $select.search) track by item.id\"><div ng-class=\"{\'group\': item.isGroup, \'item\': !item.isGroup}\" ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group pull-right searchInput\"><i class=\"fa fa-search fa-lg\"></i>&nbsp; <input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedCognome\" ng-model-options=\"{debounce: 800}\" ng-change=\"vm.getProposte()\" placeholder=\"Cognome Responsabile\"></div><a href=\"\" class=\"resetFilter\" ng-if=\"vm.isFiltroAttivo()\" ng-click=\"vm.resetFiltri()\">Reset filtri</a></form></div><div class=\"statusFilter\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'ALL\'\">Tutte le proposte</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'DA_VALUTARE\'\">Da valutare</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'VALUTATE\'\">Valutate</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'FINANZIATE\'\">Finanziate</label> <label class=\"btn btn-sm btn-default\" ng-model=\"vm.selectedStatusValutazione\" ng-click=\"vm.getProposte()\" uib-btn-radio=\"\'NON_FINANZIATE\'\">Non finanziate</label></div></div></div><div class=\"valutazioneProgettiContainer\"><div class=\"fixedTableContainer bottomPagination\"><div class=\"fixedTableContainerInner\"><table class=\"table table-hover\"><thead><tr class=\"hiddenHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Valutazione</div></th><th><div class=\"th-inner\">Fin.&nbsp;rich.</div></th><th><div class=\"th-inner\">Fin.&nbsp;conc.</div></th><th><div class=\"th-inner\">Azioni</div></th></tr><tr class=\"fixedHeader\"><th><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\">Responsabile</div></th><th><div class=\"th-inner\">Valutazione</div></th><th><div class=\"th-inner\">Fin.&nbsp;rich.</div></th><th><div class=\"th-inner\">Fin.&nbsp;conc.</div></th><th><div class=\"th-inner\">Azioni</div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"vm.proposte == null\"></div><div ng-if=\"vm.proposte != null\"><tr ng-if=\"vm.proposte.length == 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"progettoBox\" ng-repeat=\"proposta in vm.proposte\" ng-class=\"vm.getStatusClass(proposta.statusValutazioneProposta)\"><td class=\"status\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(proposta.statusValutazioneProposta)\" uib-tooltip=\"{{vm.getStatus(proposta.statusValutazioneProposta)}}\"></i></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div class=\"tipologia\">{{proposta.tipologiaProgetto.nome}} - {{proposta.classe.nome}}</div><div class=\"partecipanti\"><span ng-repeat=\"componenti in proposta.nComponenti\">{{$index == 0 ? \'\' : \' - \'}}<b>{{componenti.occorrenze}}</b> {{componenti.descrizione}}</span></div><div class=\"protocollo\">Numero protocollo: {{proposta.numeroProtocollo}}</div></td><td><div>{{proposta.responsabile.cognome + \' \' + proposta.responsabile.nome}}</div><div><span class=\"label label-under\" ng-if=\"proposta.etaAllaDomanda < 40\">Under 40</span> <span class=\"label label-ricercatore\" ng-if=\"proposta.responsabileRicercatore\">Ricercatore</span></div><div class=\"dipartimento\">{{proposta.responsabile.dipartimento.nome}}</div></td><td><div ng-if=\"proposta.nonAmmissibile\"><div class=\"refereeAddedMessage\">Non Ammissibile</div></div><div ng-if=\"!proposta.nonAmmissibile && proposta.tipoValutazione != \'ITER_VALUTAZIONE\'\"><div ng-if=\"proposta.valutazioneList.length > 0\" class=\"valBox\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.statusValutazioneProposta)\" uib-tooltip=\"{{proposta.media*1 != proposta.media.toFixed(1)*1 ? proposta.media : \'\'}}\"><i ng-if=\"proposta.media == null\" class=\"fa fa-file-text-o\"></i> {{proposta.media !== null ? (proposta.media !== 0 ? (proposta.media).toFixed(1)*1 : \'N/A\') : \'\'}}</div><div class=\"valutatori\"><div ng-repeat=\"valutazione in proposta.valutazioneList\"><span ng-if=\"!valutazione.referee\">{{valutazione.membroCommissione.cognome}} {{valutazione.membroCommissione.nome}}</span> <span ng-if=\"valutazione.referee\">{{valutazione.referee.cognome}} {{valutazione.referee.nome}} <span class=\"valore\" ng-class=\"{\'bozza\': valutazione.status == \'BOZZA\'}\">{{valutazione.punteggio}}</span></span><div><a class=\"tableButton\" ng-class=\"{\'disabled\' : !proposta.macroAreaValutabile}\" tooltip-enable=\"!proposta.macroAreaValutabile\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{vm.macroAreaNonValutabileMsg}}\" ng-click=\"!proposta.macroAreaValutabile || vm.valutaProposta(proposta, valutazione)\" ng-if=\"proposta.statusValutazioneProposta == null && proposta.classe.refereeAttivi == null && !proposta.tempoValutazioneConclusa\"><i ng-if=\"!proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Modifica</a> <a class=\"tableButton\" ng-click=\"vm.showValutazione(proposta, valutazione)\" ng-if=\"proposta.statusValutazioneProposta != null && proposta.classe.refereeAttivi == null\">Visualizza</a></div></div></div></div><div ng-if=\"proposta.valutazioneList.length == 0 && proposta.numeroRefereeAssociati > 0\"><div class=\"refereeAddedMessage\">Referee inseriti</div></div><div ng-if=\"proposta.classe.refereeAttivi > 0\"><a class=\"tableButton\" ng-click=\"vm.gestioneReferee(proposta)\">Gestione Referee</a></div><div ng-if=\"proposta.valutazioneList.length == 0 && proposta.classe.refereeAttivi == null && !proposta.tempoValutazioneConclusa\"><div><a class=\"tableButton\" ng-class=\"{\'disabled\' : !proposta.macroAreaValutabile}\" tooltip-enable=\"!proposta.macroAreaValutabile\" uib-tooltip=\"{{vm.macroAreaNonValutabileMsg}}\" ng-click=\"!proposta.macroAreaValutabile || vm.valutaProposta(proposta)\"><i ng-if=\"!proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Valuta</a></div></div></div><div ng-if=\"!proposta.nonAmmissibile && proposta.tipoValutazione == \'ITER_VALUTAZIONE\'\"><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == true\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.statusValutazioneProposta)\"><i class=\"fa fa-thumbs-o-down\"></i></div></div><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == false && proposta.numeroRefereeAssociati == 0\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.statusValutazioneProposta)\"><i class=\"fa fa-thumbs-o-up\"></i></div></div><div class=\"valBox\" ng-if=\"proposta.valutazioneList.length > 0 && proposta.valutazioneRespinta == null\"><div class=\"punteggio\" ng-class=\"vm.getStatusClass(proposta.statusValutazioneProposta)\" uib-tooltip=\"{{proposta.media*1 != proposta.media.toFixed(1)*1 ? proposta.media : \'\'}}\"><i ng-if=\"proposta.media == null\" class=\"fa fa-file-text-o\"></i> {{ proposta.media !== null ? (proposta.media === 0 ? \'N/A\' : (proposta.media).toFixed(1)*1) : \'\' }}</div></div><div ng-if=\"(proposta.valutazioneList.length == 0 || proposta.valutazioneRespinta == false) && proposta.numeroRefereeAssociati > 0\"><div class=\"refereeAddedMessage\">Referee inseriti</div></div><a class=\"tableButton\" ng-click=\"vm.openIterValutazione(proposta)\">Iter Valutazione</a></div><a class=\"tableButton indicatori\" ng-if=\"proposta.indicatoriValutazione === true\" ng-click=\"vm.openIndicatoriValutazione(proposta)\"><i class=\"fa fa-table\"></i>Indicatori</a></td><td><div class=\"finBox\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.finanziamentoRichiesto | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.assegnoRichiesto | number}}</div></div></div></td><td><div ng-if=\"proposta.statusValutazioneProposta == \'VALUTATA\' && !proposta.tempoValutazioneConclusa\"><a class=\"tableButton\" ng-class=\"{\'disabled\' : !proposta.macroAreaValutabile}\" tooltip-enable=\"!proposta.macroAreaValutabile\" uib-tooltip=\"{{vm.macroAreaNonValutabileMsg}}\" ng-click=\"!proposta.macroAreaValutabile || vm.concediFinanziamento(proposta)\"><i ng-if=\"!proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Finanziamento</a></div><div class=\"finBox assegnato\" ng-if=\"proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\'\"><div><div class=\"finValue\"><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proposta.esitoValutazione.finanziamentoAssegnato | number}}</div><div class=\"finValue\" ng-if=\"proposta.assegnoRichiesto > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proposta.esitoValutazione.assegnoAssegnato | number}}</div></div><a class=\"tableButton comment\" ng-if=\"proposta.esitoValutazione.commento && proposta.esitoValutazione.commento != \'\'\" ng-click=\"vm.mostraCommentoFinanziamento(proposta.esitoValutazione.commento)\"><i class=\"fa fa-file-text-o\" uib-tooltip=\"Commento\"></i></a></div><div class=\"ultimaModifica\" ng-if=\"(proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\') && proposta.esitoValutazione != null\" ng-init=\"utenteFin = proposta.esitoValutazione.ufficioRicerca ? proposta.esitoValutazione.ufficioRicerca.utente : proposta.esitoValutazione.membroCommissione; timestampFin = proposta.esitoValutazione.updatedTimestamp ? proposta.esitoValutazione.updatedTimestamp : proposta.esitoValutazione.createdTimestamp\"><span>{{utenteFin.cognome}} {{utenteFin.nome}}&nbsp;&nbsp;<i class=\"fa fa-clock-o\" uib-tooltip=\"ultima modifica: {{timestampFin | date: \'medium\'}}\"></i></span></div><div ng-if=\"(proposta.statusValutazioneProposta == \'FINANZIATA\' || proposta.statusValutazioneProposta == \'NON_FINANZIATA\') && !proposta.tempoValutazioneConclusa && (proposta.esitoValutazione == null || proposta.esitoValutazione.esitoConcluso !== true)\"><a class=\"tableButton\" ng-class=\"{\'disabled\' : !proposta.macroAreaValutabile}\" tooltip-enable=\"!proposta.macroAreaValutabile\" uib-tooltip=\"{{vm.macroAreaNonValutabileMsg}}\" ng-click=\"!proposta.macroAreaValutabile || vm.concediFinanziamento(proposta)\"><i ng-if=\"!proposta.macroAreaValutabile\" class=\"fa fa-ban\"></i>Modifica</a></div></td><td class=\"withButton\" ng-if=\"!vm.isCurrentPresidenteCommissione()\"><button type=\"button\" uib-tooltip=\"Visualizza proposta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.openProposta(proposta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td><td class=\"withButton\" ng-if=\"vm.isCurrentPresidenteCommissione()\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-default dropdown-toggle\" aria-expanded=\"false\" uib-dropdown-toggle=\"\"><i class=\"fa fa-caret-down\"></i></button><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\" ng-click=\"vm.openProposta(proposta.id)\">Visualizza Proposta</a></li><li ng-if=\"proposta.statusValutazioneProposta && !proposta.tempoValutazioneConclusa && (proposta.esitoValutazione == null || proposta.esitoValutazione.esitoConcluso !== true)\"><a href=\"\" ng-click=\"vm.riapriValutazione(proposta.id)\">Riapri Valutazione</a></li><li ng-if=\"proposta.statusValutazioneProposta && !proposta.tempoValutazioneConclusa && proposta.esitoValutazione != null && proposta.esitoValutazione.esitoConcluso === true\"><a href=\"\" ng-click=\"vm.riapriEsito(proposta.id)\">Riapri Esito Fin.</a></li></ul></div></td></tr></div></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span><span class=\"centralButtons\"><a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta l\'elenco dei progetti secondo il filtro corrente\" ng-href=\"{{vm.getCsvExportUrl()}}\"><i class=\"fa fa-file-o\"></i> Esporta elenco</a> <a target=\"_new\" class=\"btn btn-sm btn-default exportButton\" uib-tooltip=\"Esporta l\'elenco delle valutazioni dei progetti secondo il filtro corrente\" ng-if=\"vm.selectedAnno.anno >= 2020\" ng-href=\"{{vm.getCsvExportValUrl()}}\"><i class=\"fa fa-file-o\"></i> Esporta elenco val.</a></span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposte(true)\"></uib-pagination></div></div></div>");
$templateCache.put("app/components/valutazioneProgettoReferee/valutazioneProgettoReferee.html","<div class=\"valutazioneProgettoReferee\"><h1 class=\"page-header\">Project evaluation</h1><div class=\"spinner\" ng-if=\"!valutaProgRefCtrl.referee\"></div><div class=\"row\" ng-if=\"valutaProgRefCtrl.referee\"><div class=\"col col-md-12\"><div class=\"instructionMessage\" ng-if=\"valutaProgRefCtrl.referee.valutazione.status != \'CONCLUSA\'\"><div class=\"panel-body\"><div class=\"bigMessage\">Welcome to the project evaluation page. To evaluate the project assigned to you, please follow the steps below.</div><ol><li>Click the <i>Show Proposal</i> link at the bottom of the grey box to read the project proposal.</li><li>Click the <i>Evaluate</i> button on the right of this page and fill in the evaluation form (you can <i>Save as Draft</i> if you want).</li><li>When you have finished your evaluation click the <i>Save and Submit</i> button on the evaluation form.</li></ol></div></div><div class=\"instructionMessage panel panel-default\" ng-if=\"valutaProgRefCtrl.referee.valutazione.status == \'CONCLUSA\'\"><div class=\"panel-body\"><div class=\"bigMessage\"><i class=\"fa fa-check-circle\"></i>Your evaluation has been submitted successfully. Thank you very much for your help.</div></div></div></div><div class=\"col col-xs-7 col-sm-8\"><div class=\"bs-callout bs-callout-sapienza\"><div class=\"boxGroup titolo\">{{valutaProgRefCtrl.referee.proposta.titolo}}</div><div class=\"boxGroup\"><label>Principal Investigator</label><div>{{valutaProgRefCtrl.referee.proposta.responsabile.cognome + \' \' + valutaProgRefCtrl.referee.proposta.responsabile.nome}}</div></div><div class=\"boxGroup\"><label>Abstract</label><div class=\"abstract\">{{valutaProgRefCtrl.referee.proposta.campoAbstract}}</div></div><div class=\"centerButton\"><a class=\"otherButton\" ng-click=\"valutaProgRefCtrl.openProposta(valutaProgRefCtrl.referee.proposta.id)\">Show proposal</a></div></div></div><div class=\"col col-xs-5 col-sm-4\"><div class=\"valutazione\" ng-class=\"valutaProgRefCtrl.getStatusClass(valutaProgRefCtrl.referee.valutazione.status)\"><div class=\"status\"><div class=\"statusLabel\">Evaluation status</div><div class=\"statusValue\">{{valutaProgRefCtrl.getStatus(valutaProgRefCtrl.referee.valutazione.status)}}</div></div><div class=\"punteggio\"><span ng-if=\"valutaProgRefCtrl.referee.valutazione\"><i ng-if=\"valutaProgRefCtrl.referee.valutazione.punteggio == null\" class=\"fa fa-file-text-o\"></i> {{valutaProgRefCtrl.referee.valutazione.punteggio}}</span> <span ng-if=\"!valutaProgRefCtrl.referee.valutazione\">-</span></div></div><div class=\"pull-right\" ng-if=\"valutaProgRefCtrl.referee\"><button class=\"btn btn-primary\" ng-click=\"valutaProgRefCtrl.valutaProposta(valutaProgRefCtrl.referee)\">{{valutaProgRefCtrl.getStatusButtonText(valutaProgRefCtrl.referee.valutazione.status)}}</button></div></div></div></div>");
$templateCache.put("app/components/viewNotesIstanzaUser/viewNotesIstanzaUser.html","<h3>Riepilogo Valutazione</h3><div class=\"status-container\"><div class=\"bg-gray\"><div class=\"detail\"><p class=\"right\"><b>Titolo</b></p><p>Terza Missione</p></div><div class=\"detail\"><p class=\"right\"><b>Responsabile</b></p><p>Licata Giovannuccio</p></div></div></div><div class=\"status-container\"><p><b>Titolo</b></p><div class=\"text-highlight\"><p style=\"font-size: 24px\">Approvata con condizione</p></div></div><div class=\"status-container\"><p><b>Note</b></p><div class=\"text-highlight\"><p>Copy testo nota valutazione istanza</p></div></div><div class=\"ngdialog-buttons\"><button type=\"button\" class=\"ngdialog-button ngdialog-button-secondary\" ng-click=\"vm.handleClose(0)\">Annulla</button></div>");
$templateCache.put("app/components/viewProposta/viewProposta.html","<div class=\"viewProposta\"><div class=\"propostaHeader\" fixed-header=\"\" container=\".mainContainer\" ng-if=\"!viewPropCtrl.print\"><h2>{{\"REQUEST_FOR_FUNDING\" | translate}}</h2><div class=\"tipologia\">{{viewPropCtrl.data.classe.tipologiaProgetto.nome}} - {{viewPropCtrl.data.classe.nome}}</div><div class=\"protocollo bozza\" ng-if=\"viewPropCtrl.data.status == \'BOZZA\'\"><a ui-sref=\"propostaDetail({\'id\': viewPropCtrl.propostaId})\" ng-if=\"viewPropCtrl.userCanEdit()\"><i class=\"fa fa-arrow-left\"></i> torna alla form</a><div>BOZZA</div></div><div class=\"protocollo\" ng-if=\"viewPropCtrl.data.status && viewPropCtrl.data.status != \'BOZZA\'\">Numero protocollo:<span>{{viewPropCtrl.data.numeroProtocollo}}</span></div><div class=\"buttonArea\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{viewPropCtrl.getPdfExportUrl(viewPropCtrl.data)}}\"><i class=\"fa fa-file-pdf-o btn-icon\" style=\"margin-right: 8px;\"></i>{{\"PRINT_PDF\" | translate}}</a></div></div><div class=\"propostaHeader\" ng-if=\"viewPropCtrl.print\"><h2>{{\"REQUEST_FOR_FUNDING\" | translate}}</h2><div class=\"tipologia\">{{viewPropCtrl.data.classe.tipologiaProgetto.nome}} - {{viewPropCtrl.data.classe.nome}}</div><div class=\"protocollo bozza forPrint\" ng-if=\"viewPropCtrl.data.status == \'BOZZA\'\"><div>BOZZA</div></div><div class=\"protocollo forPrint\" ng-if=\"viewPropCtrl.data.status && viewPropCtrl.data.status != \'BOZZA\'\">Numero protocollo:<span>{{viewPropCtrl.data.numeroProtocollo}}</span></div></div><div class=\"spinner\" ng-if=\"viewPropCtrl.template == null || viewPropCtrl.data == null\"></div><div class=\"formContainer\" ng-if=\"viewPropCtrl.template != null && viewPropCtrl.data != null\"><div class=\"formSideMenu\" ng-if=\"!viewPropCtrl.print\"><form-index sezioni=\"viewPropCtrl.template.sezioni\" container=\".mainContainer\"></form-index></div><div class=\"formContent\" ng-class=\"{\'print\': viewPropCtrl.print}\"><sgb-section ng-repeat=\"sezione in viewPropCtrl.template.sezioni\" name=\"{{($index + 1)}}. {{sezione.titolo}}\" id=\"section{{($index + 1)}}\"><div class=\"sgbFieldContainer\" ng-repeat=\"campo in sezione.campi\"><sgb-v-text ng-if=\"campo.tipo == \'textfield\' || campo.tipo == \'textarea\' || campo.tipo == \'telephone\' || campo.tipo == \'numberfield\' || campo.tipo == \'datefield\' || campo.tipo == \'date-range-field\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-text><sgb-v-currency-field ng-if=\"campo.tipo == \'currencyfield\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-currency-field><sgb-v-text ng-if=\"campo.tipo == \'datefield-indet\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.getDateFieldIndetValue(campo.model, campo.indeterminateValue, campo.indeterminateDescription)\"></sgb-v-text><sgb-v-text ng-if=\"campo.tipo == \'select\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.getSelectLabel(campo.model, campo.choices)\"></sgb-v-text><sgb-v-text ng-if=\"campo.tipo == \'yes-no-radio\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.getYesNoValue(campo.model)\"></sgb-v-text><sgb-v-checkbox ng-if=\"campo.tipo == \'checkbox\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-checkbox><sgb-v-rich-text ng-if=\"campo.tipo == \'rich-text\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-rich-text><sgb-v-text ng-if=\"campo.tipo == \'calculatedfield\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\" class=\"calculated\"></sgb-v-text><sgb-v-keywords ng-if=\"campo.tipo == \'keywords\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-keywords><sgb-v-keywords-select ng-if=\"campo.tipo == \'keywords-select\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" choices-label=\"{{campo.choicesLabel}}\"></sgb-v-keywords-select><sgb-v-participants ng-if=\"campo.tipo == \'participants\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\" type=\"{{campo.type}}\"></sgb-v-participants><sgb-v-participants-manual ng-if=\"campo.tipo == \'participants_manual\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-participants-manual><sgb-v-publications ng-if=\"campo.tipo == \'publications\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" num-max=\"{{campo.numMax}}\" options=\"campo.options\"></sgb-v-publications><sgb-v-publications-part ng-if=\"campo.tipo == \'publications-part\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" options=\"campo.options\"></sgb-v-publications-part><sgb-v-complex-field ng-if=\"campo.tipo == \'complex-field\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" info=\"campo.info\"></sgb-v-complex-field><sgb-v-file-upload ng-if=\"campo.tipo == \'file-upload\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\" name-only=\"viewPropCtrl.print\"></sgb-v-file-upload><sgb-v-progetti-manual ng-if=\"campo.tipo == \'progetti_manual\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-progetti-manual><sgb-v-linee-tematiche ng-if=\"campo.tipo == \'linee_tematiche\'\" label=\"{{campo.label}}\" help=\"{{campo.help}}\" num-max=\"{{campo.numMax}}\" type=\"{{campo.type}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-linee-tematiche><sgb-v-file-multiple-upload ng-if=\"campo.tipo == \'file-multiple-upload\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.data[campo.model]\" name-only=\"viewPropCtrl.print\"></sgb-v-file-multiple-upload><sgb-v-h-index ng-if=\"campo.tipo == \'h-index\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-h-index><sgb-v-h-index-part ng-if=\"campo.tipo == \'h-index-part\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-h-index-part><sgb-v-select-fields ng-if=\"campo.tipo == \'select-fields\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" label-format=\"viewPropCtrl.getLabelFormat(campo.choices)\"></sgb-v-select-fields><sgb-v-budget ng-if=\"campo.tipo == \'budget\'\" label=\"{{campo.label}}\" hide-descriptions=\"{{campo.hideDescriptions}}\" type=\"{{campo.type}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-budget><sgb-v-last-fundings ng-if=\"campo.tipo == \'last-fundings\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-last-fundings><sgb-v-last-fundings-new ng-if=\"campo.tipo == \'last-fundings-new\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-last-fundings-new><sgb-v-other-fundings ng-if=\"campo.tipo == \'other-fundings\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-other-fundings><sgb-v-previous-fundings ng-if=\"campo.tipo == \'previous-fundings\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" type=\"{{campo.type}}\"></sgb-v-previous-fundings><sgb-v-previous-fundings-new ng-if=\"campo.tipo == \'previous-fundings-new\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" options=\"campo.options\"></sgb-v-previous-fundings-new><sgb-v-previous-fundings-new-no-perc-impegno ng-if=\"campo.tipo == \'previous-fundings-new-no-perc-impegno\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" options=\"campo.options\"></sgb-v-previous-fundings-new-no-perc-impegno><sgb-v-research-indicators ng-if=\"campo.tipo == \'research-indicators\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" options=\"campo.options\"></sgb-v-research-indicators><sgb-v-research-indicators-2021 ng-if=\"campo.tipo == \'research-indicators-2021\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" options=\"campo.options\"></sgb-v-research-indicators-2021><sgb-v-research-indicators-part ng-if=\"campo.tipo == \'research-indicators-part\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\" options=\"campo.options\"></sgb-v-research-indicators-part><sgb-v-indicatori-impatto-sostenibilita ng-if=\"campo.tipo == \'indicatori-impatto-sostenibilita\'\" label=\"{{campo.label}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-v-indicatori-impatto-sostenibilita><sgb-js-script ng-if=\"campo.tipo == \'js-script\'\" script=\"{{campo.script}}\" model=\"viewPropCtrl.data[campo.model]\"></sgb-js-script><div class=\"form-group row sgbField\" ng-if=\"campo.tipo == \'text-label\'\"><label class=\"col-sm-12\" ng-bind-html=\"campo.text\"></label></div></div></sgb-section></div></div></div>");
$templateCache.put("app/components/viewPropostaCert/viewPropostaCert.html","<form class=\"editProposta cert\"><div class=\"propostaHeader\" fixed-header=\"\" container=\".mainContainer\"><div class=\"titles\"><h2>Domanda per la valutazione CER</h2></div></div><div class=\"spinner\" ng-if=\"form.formulario == null\"></div><div class=\"formContainer\" ng-if=\"form.formulario != null\"><div class=\"formSideMenu\"><form-index sezioni=\"form.formulario.sezioniFormulario\" container=\".mainContainer\"></form-index></div><div id=\"viewFormContainerCert\" class=\"formContent\" style=\"margin-top: 60px\"><div class=\"formSection\" id=\"section{{$index + 1}}\" ng-repeat=\"formItem in form.formulario.sezioniFormulario\"><div class=\"sgbSection\"><div class=\"sgbLegend\" style=\"margin-top: 0; padding-top: 0\">{{$index + 1}}. {{formItem.titolo}}</div><div></div></div><div class=\"atomic-wrapper\"><fpc-recap-display ng-if=\"$index == 0\" model=\"form.readOnlyDisplay\"></fpc-recap-display><fpc-atomic-wrapper model=\"formItem\" esterno=\"form.esterno\"></fpc-atomic-wrapper></div></div></div></div></form>");
$templateCache.put("app/components/viewRendicontazione/viewRendicontazione.html","<div class=\"viewRendicontazione\"><div class=\"rendicontazioneHeader\" fixed-header=\"\" container=\".mainContainer\" ng-if=\"!viewRendCtrl.print\"><h2>{{viewRendCtrl.template.titolo ? viewRendCtrl.template.titolo : \'Rendiconto Progetto\'}}</h2><div class=\"tipologia\">{{viewRendCtrl.data.classe.tipologiaProgetto.nome}} - {{viewRendCtrl.data.classe.nome}}</div><div class=\"protocollo bozza\" ng-if=\"viewRendCtrl.data.status == \'BOZZA\'\"><a ui-sref=\"rendicontazioneDetail({\'id\': viewRendCtrl.rendicontazioneId})\" ng-if=\"viewRendCtrl.userCanEdit()\"><i class=\"fa fa-arrow-left\"></i> torna alla form</a><div>BOZZA</div></div><div class=\"buttonArea\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{viewRendCtrl.getPdfExportUrl(viewRendCtrl.data)}}\"><i class=\"fa fa-file-pdf-o btn-icon\" style=\"margin-right: 8px;\"></i>{{\"PRINT_PDF\" | translate}}</a></div></div><div class=\"rendicontazioneHeader\" ng-if=\"viewRendCtrl.print\"><h2>{{viewRendCtrl.template.titolo ? viewRendCtrl.template.titolo : \'Rendiconto Progetto\'}}</h2><div class=\"tipologia\">{{viewRendCtrl.data.classe.tipologiaProgetto.nome}} - {{viewRendCtrl.data.classe.nome}}</div><div class=\"protocollo bozza forPrint\" ng-if=\"viewRendCtrl.data.status == \'BOZZA\'\"><div>BOZZA</div></div></div><div class=\"spinner\" ng-if=\"viewRendCtrl.template == null || viewRendCtrl.data == null\"></div><div class=\"formContainer\" ng-if=\"viewRendCtrl.template != null && viewRendCtrl.data != null\"><div class=\"formSideMenu\" ng-if=\"!viewRendCtrl.print\"><form-index sezioni=\"viewRendCtrl.template.sezioni\" container=\".mainContainer\"></form-index></div><div class=\"formContent\" ng-class=\"{\'print\': viewRendCtrl.print}\"><sgb-section ng-repeat=\"sezione in viewRendCtrl.template.sezioni\" name=\"{{($index + 1)}}. {{sezione.titolo}}\" id=\"section{{($index + 1)}}\"><div class=\"sgbFieldContainer\" ng-repeat=\"campo in sezione.campi\"><sgb-v-text ng-if=\"campo.tipo == \'textfield\' || campo.tipo == \'textarea\' || campo.tipo == \'telephone\' || campo.tipo == \'numberfield\' || campo.tipo == \'datefield\' || campo.tipo == \'date-range-field\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-text><sgb-v-text ng-if=\"campo.tipo == \'datefield-indet\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewPropCtrl.getDateFieldIndetValue(campo.model, campo.indeterminateValue, campo.indeterminateDescription)\"></sgb-v-text><sgb-v-text ng-if=\"campo.tipo == \'select\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewRendCtrl.getSelectLabel(campo.model, campo.choices)\"></sgb-v-text><sgb-v-text ng-if=\"campo.tipo == \'yes-no-radio\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewRendCtrl.getYesNoValue(campo.model)\"></sgb-v-text><sgb-v-rich-text ng-if=\"campo.tipo == \'rich-text\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-rich-text><sgb-v-text ng-if=\"campo.tipo == \'calculatedfield\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewRendCtrl.data[campo.model]\" class=\"calculated\"></sgb-v-text><sgb-v-keywords ng-if=\"campo.tipo == \'keywords\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-keywords><sgb-v-complex-field ng-if=\"campo.tipo == \'complex-field\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\" info=\"campo.info\"></sgb-v-complex-field><sgb-v-file-upload ng-if=\"campo.tipo == \'file-upload\'\" label=\"{{campo.label}}\" description=\"{{campo.description}}\" model=\"viewRendCtrl.data[campo.model]\" name-only=\"viewRendCtrl.print\"></sgb-v-file-upload><sgb-v-file-multiple-upload ng-if=\"campo.tipo == \'file-multiple-upload\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-file-multiple-upload><sgb-v-report ng-if=\"campo.tipo == \'report\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\" model-motivazione=\"viewRendCtrl.data[campo.modelMotivazione]\" check-scostamento=\"campo.checkScostamento\"></sgb-v-report><sgb-v-text ng-if=\"campo.tipo == \'read-only-text\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-text><sgb-v-participants-rend ng-if=\"campo.tipo == \'participants-rend\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-participants-rend><sgb-v-participants-manual-rend ng-if=\"campo.tipo == \'participants-manual-rend\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\"></sgb-v-participants-manual-rend><sgb-v-publications-rend ng-if=\"campo.tipo == \'publications-rend\'\" label=\"{{campo.label}}\" model=\"viewRendCtrl.data[campo.model]\" num-max=\"{{campo.numMax}}\"></sgb-v-publications-rend></div></sgb-section></div></div></div>");
$templateCache.put("app/helpdesk/home/home.html","<h1 class=\"page-header\">Home</h1><p class=\"lead\">Benvenuto in SPHERE.</p><p class=\"lead\">Tramite questo sistema puoi impersonare chi vuoi :)</p>");
$templateCache.put("app/rad/home/home.html","<h1 class=\"page-header\">Home</h1><p class=\"lead\">Benvenuto in SPHERE.</p><p class=\"lead\">Tramite questo sistema puoi controllare e gestire le domande di finanziamento che afferiscono al tuo dipartimento.</p><p class=\"well\">Per visualizzare tutte le proposte effettuate da persone che afferiscono al tuo dipartimento <a href=\"\" ui-sref=\"radProgetti\"><b><i class=\"fa fa-external-link-square\"></i> vai alla sezione Archivio Progetti</b></a>.</p><p>Nella sezione <b>Archivio Progetti</b>, accessibile tramite il link nel menù di sinistra, puoi accedere alla lista delle proposte presentate per il tuo dipartimento, suddivise tra finanziate e non finanziate. Per ciascuna proposta sarà possibile visualizzare l\'ammontare del finanziamento concesso.</p>");
$templateCache.put("app/rad/progetti/progetti.html","<archivio-progetti-rad></archivio-progetti-rad>");
$templateCache.put("app/referee/home/home.html","<valutazione-progetto-referee></valutazione-progetto-referee>");
$templateCache.put("app/ufficioricerca/commissioni/commissioni.html","<lista-commissioni></lista-commissioni>");
$templateCache.put("app/ufficioricerca/dipartimenti/dipartimenti.html","<lista-rad></lista-rad>");
$templateCache.put("app/ufficioricerca/gestioneBandi/configBandi.html","<creazione-bandi></creazione-bandi>");
$templateCache.put("app/ufficioricerca/gestioneBandi/creazBandi.html","<creazione-bandi></creazione-bandi>");
$templateCache.put("app/ufficioricerca/gestioneutenti/anagrafica.html","<gestione-anagrafica></gestione-anagrafica>");
$templateCache.put("app/ufficioricerca/gestioneutenti/caricamentoMassivo.html","<caricamento-massivo></caricamento-massivo>");
$templateCache.put("app/ufficioricerca/gestioneutenti/dettaglioProposte.html","<dettaglio-proposte></dettaglio-proposte>");
$templateCache.put("app/ufficioricerca/gestioneutenti/gestInattivi.html","<gestione-inattivi></gestione-inattivi>");
$templateCache.put("app/ufficioricerca/home/home.html","<h1 class=\"page-header\">Home</h1><p class=\"lead\">Benvenuto in SPHERE.</p><p class=\"lead\">Tramite questo sistema puoi controllare e gestire le domande di finanziamento per i bandi dell\'università.</p><p class=\"well\">Per visualizzare tutte le proposte <a href=\"\" ui-sref=\"urProgetti\"><b><i class=\"fa fa-external-link-square\"></i> vai alla sezione Archivio Progetti</b></a>, tramite i filtri cerca un progetto e esegui le operazioni desiderate.</p><p class=\"well\">Per visualizzare le statistiche sullo stato dei progetti <a href=\"\" ui-sref=\"urStatistiche\"><i class=\"fa fa-external-link-square\"></i> <b>vai alla sezione Statistiche</b></a>.</p><p>Nella sezione <b>Archivio Progetti</b>, accessibile tramite il link nel menù di sinistra, puoi accedere alla lista delle proposte suddivise per stato di valutazione. Per ciascuna proposta sarà possibile aprire la scheda dettagliata, visualizzare la valutazione del progetto e modificare l\'esito del finanziamento.</p><p>Nella sezione <b>Statistiche</b>, invece, avrai il riepilogo sullo stato delle proposte, raggruppate per tipologia di progetto e classe dimensionale.</p>");
$templateCache.put("app/ufficioricerca/impersona/impersona.html","<impersona></impersona>");
$templateCache.put("app/ufficioricerca/iter/iter.html","<gestione-iter></gestione-iter>");
$templateCache.put("app/ufficioricerca/progetti/progetti.html","<archivio-progetti></archivio-progetti>");
$templateCache.put("app/ufficioricerca/statistiche/statistiche.html","<statistiche-progetti is-ur=\"true\"></statistiche-progetti>");
$templateCache.put("app/ufficioricerca/strutture/strutture.html","<lista-rad-strutture></lista-rad-strutture>");
$templateCache.put("app/utente/bandi/bandi.html","<lista-bandi></lista-bandi>");
$templateCache.put("app/utente/cert/cert.html","<lista-istanze-user></lista-istanze-user>");
$templateCache.put("app/utente/home/home.html","<h1 class=\"page-header\">Home</h1><p class=\"lead\">Benvenuto in SPHERE.</p><p class=\"lead\">Tramite questo sistema puoi creare ed inviare le tue istanze.</p><div class=\"alert alert-warning\" ng-if=\"!main.loggedUser.utente.profiloValidato\"><b><i class=\"fa fa-warning\"></i> ATTENZIONE</b> - Prima di poter creare istanze da presentare al CER devi confermare le informazioni del tuo profilo.&nbsp;&nbsp; <a href=\"\" ui-sref=\"profilo\"><i class=\"fa fa-external-link-square\"></i> <b>vai al profilo</b></a></div><p class=\"well\">Per creare una nuova istanza, <a href=\"\" ui-sref=\"listaIstanzeUser\"><b><i class=\"fa fa-external-link-square\"></i> vai alla sezione Valutazione Etica CER</b></a></p><p class=\"well\">Per accedere alle istanze che hai già iniziato a compilare o a quelle che hai già inviato, <a href=\"\" ui-sref=\"listaIstanzeUser\"><i class=\"fa fa-external-link-square\"></i> <b>vai alla sezione Valutazione Etica CER</b></a>.</p>");
$templateCache.put("app/utente/profilo/profilo.html","<h1 class=\"page-header\">Profilo Utente</h1><profilo-utente></profilo-utente>");
$templateCache.put("app/utente/progetti/progetti.html","<archivio-progetti-rad is-dir-dip=\"true\"></archivio-progetti-rad>");
$templateCache.put("app/utente/proposte/proposte.html","<lista-proposte></lista-proposte>");
$templateCache.put("app/utente/rendicontazione/rendicontazione.html","<lista-da-rendicontare></lista-da-rendicontare>");
$templateCache.put("app/utente/rendicontazioni/rendicontazioni.html","<lista-rendicontazioni></lista-rendicontazioni>");
$templateCache.put("app/utente/statistiche/statistiche.html","<statistiche-progetti></statistiche-progetti>");
$templateCache.put("app/utente/valutazione/valutazione.html","<valutazione-progetti></valutazione-progetti>");
$templateCache.put("app/components/sgb-participants/sgb-add-participants.html","<div class=\"sgbAddParticipants\"><h3>Aggiungi partecipante</h3><input type=\"text\" class=\"form-control searchField\" placeholder=\"Ricerca per cognome (inserire almeno una parola completa)\" ng-model=\"vm.searchText\" ng-model-options=\"{debounce: 800}\" ng-change=\"vm.search(vm.searchText)\"><div class=\"resultsContainer well\"><div class=\"noResults\" ng-if=\"vm.searchText.length > 0 && vm.results.length == 0\">nessun risultato</div><div class=\"alertNoResults\" ng-if=\"vm.searchText.length > 0 && vm.results.length == 0\"><b>ATTENZIONE</b><br>La ricerca viene effettuata solo sugli utenti che si sono già collegati al sistema almeno una volta.<br><br>Se non trovi la persona che stai cercando comunicagli di collegarsi al sistema e confermare il proprio profilo.</div><div class=\"spinner\" ng-if=\"vm.searching\"></div><div class=\"userResult\" ng-repeat=\"result in vm.results\"><div><div class=\"user\"><i class=\"fa fa-user\"></i> {{result.utente.cognome}} {{result.utente.nome}}</div><div class=\"ruolo\">{{result.utente.ruolo.descrizione}}</div><div class=\"dipartimento\">{{result.utente.dipartimento.nome}}</div></div><div class=\"addUser\" ng-class=\"{\'disabled\': !result.ammissibile, \'requested\': result.isAlreadyRequested, \'rejected\': result.isAlreadyRejected, \'accepted\': result.isAlreadyAccepted}\"><a href=\"\" ng-click=\"vm.addPending(result)\" ng-if=\"result.ammissibile && !result.isAlreadyRequested && !result.isAlreadyRejected && !result.isAlreadyAccepted && (!vm.numMax || vm.getNumPartecipantiERichieste() < vm.numMax)\"><i class=\"fa fa-plus\"></i></a><div class=\"notAvailable\" ng-if=\"result.ammissibile && !result.isAlreadyRequested && !result.isAlreadyRejected && !result.isAlreadyAccepted && (vm.numMax && vm.getNumPartecipantiERichieste() >= vm.numMax)\">Numero massimo raggiunto</div><div class=\"notAvailable\" ng-if=\"!result.ammissibile\">Non ammissibile</div><div class=\"alreadyRequested\" ng-if=\"result.isAlreadyRequested\"><i class=\"fa fa-question\"></i><div ng-if=\"!result.isNewRequest\">Richiesta inviata</div><div ng-if=\"result.isNewRequest\">La richiesta sarà inviata al salvataggio</div></div><div class=\"alreadyRejected\" ng-if=\"result.isAlreadyRejected\"><i class=\"fa fa-ban\"></i><div>Richiesta rifiutata</div></div><div class=\"alreadyAccepted\" ng-if=\"result.isAlreadyAccepted\"><i class=\"fa fa-check\"></i><div>Richiesta accettata</div></div></div></div></div></div>");
$templateCache.put("app/components/sgb-participants/sgb-participants.html","<div class=\"form-group row sgbField sgbParticipants\"><label class=\"col-sm-12\">{{vm.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"vm.description\"><span ng-bind-html=\"vm.description\"></span></div><label class=\"col-sm-12\" ng-if=\"vm.type == \'dipartimentali\'\">Il direttore o suo delegato per partecipare al gruppo di ricerca deve aggiungersi tra i componenti</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"statusColumn\"></th><th class=\"nameColumn\">Cognome e Nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\" ng-if=\"vm.type !== \'terza-missione\' && vm.type !== \'dipartimentali\'\">Dipartimento</th><th class=\"macroareaColumn\" ng-if=\"vm.type !== \'terza-missione\'\">Macroarea</th><th class=\"ercColumn\" ng-if=\"vm.type == \'simple\'\"></th><th class=\"ercColumn\" ng-if=\"vm.type == \'pnrr\' || vm.type == \'pnrrPart\'\">Numero di mesi persona impegnati nel progetto</th><th class=\"pnrMasErcColumn\" ng-if=\"vm.type == \'pnrr\' || vm.type == \'pnrrPart\'\">Massa critica (SI/NO)</th><th class=\"ercColumn\" ng-if=\"!vm.type || vm.type == \'\'\">Sett.&nbsp;ERC</th><th class=\"ercColumn\" ng-if=\"vm.type == \'sub-sectors\' || vm.type == \'pi-sostituito\' || vm.type == \'dipartimentali\'\">Sotto&nbsp;sett.&nbsp;ERC</th><th class=\"piSostituitoColumn\" ng-if=\"vm.type == \'pi-sostituito\'\">PI Sostituto</th><th class=\"ssdColumn\" ng-if=\"vm.type === \'terza-missione\'\">SSD</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.model.partecipantiList.length == 0\"><td colspan=\"7\">Nessun componente</td></tr><tr class=\"accepted\" ng-repeat=\"partecipante in vm.model.partecipantiList\"><td class=\"statusColumn\"><i class=\"fa fa-check\"></i></td><td class=\"nameColumn\">{{partecipante.cognome}} {{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.ruolo.descrizione}}</td><td class=\"depColumn\" ng-if=\"vm.type !== \'terza-missione\' && vm.type !== \'dipartimentali\'\">{{partecipante.dipartimento.nome}}</td><td class=\"macroareaColumn\" ng-if=\"vm.type !== \'terza-missione\'\">{{partecipante.dipartimento.macroArea.code}}</td><td class=\"pnrErcColumn\" ng-if=\"vm.type == \'pnrr\'\"><input float-field-parser=\"\" type=\"text\" class=\"form-control\" ng-model=\"partecipante.mesiPersona\"></td><td class=\"pnrErcColumn\" ng-if=\"vm.type == \'pnrrPart\'\">{{partecipante.mesiPersona}}</td><td class=\"pnrErcColumn\" ng-if=\"vm.type == \'pnrr\'\"><select class=\"form-control\" ng-model=\"partecipante.massaCritica\"><option value=\"SI\">SI</option><option value=\"NO\">NO</option></select></td><td class=\"pnrErcColumn\" ng-if=\"vm.type == \'pnrrPart\'\">{{partecipante.massaCritica}}</td><td class=\"ercColumn\" ng-if=\"vm.type == \'simple\'\"></td><td class=\"ercColumn\" ng-if=\"!vm.type || vm.type == \'\'\">{{partecipante.settoreERC.codice}}</td><td class=\"ercColumn\" ng-if=\"vm.type == \'sub-sectors\' || vm.type == \'pi-sostituito\' || vm.type == \'dipartimentali\'\">{{partecipante.sottoSettoreERC.codice}}</td><td class=\"piSostituitoColumn\" ng-if=\"vm.type == \'pi-sostituito\'\"><input type=\"checkbox\" class=\"chkPiSostituito\" ng-model=\"partecipante.piSostituito\" ng-change=\"vm.checkPISelection(vm.model.partecipantiList,partecipante)\"></td><td class=\"ssdColumn\" ng-if=\"vm.type === \'terza-missione\'\">{{partecipante.ssd.codice}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"vm.removeParticipant($index)\" ng-if=\"vm.type != \'pnrrPart\'\"><i class=\"fa fa-times\"></i></a></td></tr><tr class=\"separator\" ng-if=\"vm.model.pendingList.length > 0\"><th colspan=\"7\">Richieste di partecipazione non ancora accettate</th></tr><tr ng-repeat=\"partecipante in vm.model.pendingList\" ng-class=\"vm.getStatusClass(partecipante.status)\"><td class=\"statusColumn\"><i class=\"fa\" ng-class=\"vm.getStatusIcon(partecipante.status)\"></i></td><td class=\"nameColumn\">{{partecipante.utente.cognome}} {{partecipante.utente.nome}}</td><td class=\"roleColumn\">{{partecipante.utente.ruolo.descrizione}}</td><td class=\"depColumn\" ng-if=\"vm.type !== \'terza-missione\' && vm.type !== \'dipartimentali\'\">{{partecipante.utente.dipartimento.nome}}</td><td class=\"macroareaColumn\" ng-if=\"vm.type !== \'terza-missione\'\">{{partecipante.utente.dipartimento.macroArea.code}}</td><td class=\"pnrErcColumn\"><input float-field-parser=\"\" type=\"text\" ng-if=\"vm.type == \'pnrr\'\" class=\"form-control\" ng-model=\"partecipante.mesiPersona\"></td><td class=\"pnrErcColumn\"><select ng-if=\"vm.type == \'pnrr\'\" class=\"form-control\" ng-model=\"partecipante.massaCritica\"><option value=\"SI\">SI</option><option value=\"NO\">NO</option></select></td><td class=\"ercColumn\" ng-if=\"(vm.type == \'simple\') || (!vm.type || vm.type == \'\') || (vm.type == \'sub-sectors\' || vm.type == \'pi-sostituito\' || vm.type == \'dipartimentali\')\"></td><td class=\"ssdColumn\" ng-if=\"vm.type === \'terza-missione\'\">{{partecipante.utente.ssd.codice}}</td><td class=\"actionColumn\"><a href=\"\" ng-click=\"vm.removePending($index)\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><a href=\"\" ng-click=\"vm.addPending()\" ng-if=\"vm.type != \'pnrrPart\' && (!vm.numMax || vm.getNumPartecipantiERichieste() < vm.numMax)\"><i class=\"fa fa-plus\"></i> aggiungi</a></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-alert-block/fpc-alert-block.html","<div ng-if=\"!alert.blocking\" class=\"alert-block cert-input\" ng-class=\"alert.getSizeStyle()\"><div class=\"alert-wrap\"><p style=\"font-size: 16px\" class=\"info\" ng-if=\"alert.model.label\">{{alert.model.label}}</p></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-wrapper/fpc-atomic-wrapper.html","<div><div ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\" hide=\"vm.alternateView( field )\"></fpc-field-switch><div class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><first-layer-assembler model=\"sublayer\"></first-layer-assembler></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-check-group/fpc-check-group.html","<div class=\"cert-input cert-radio-input\" ng-class=\"{ \'campo-fantasma-cert\': vm.campoFantasma }\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div class=\"check-wrap\"><label ng-repeat=\"(idx, key) in vm.set\" class=\"check-label\"><input type=\"checkbox\" ng-change=\"vm.onCheckChange()\" ng-model=\"key.selected\" ng-value=\"key.valore\" ng-disabled=\"vm.readOnly === true\"><p ng-bind-html=\"key.valore\"></p></label></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-currency-input/fpc-currency-input.html","<div class=\"cert-input cert-int-input\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div ng-if=\"vm.readOnly\" class=\"panel panel-default\"><div class=\"panel-body\"><span>{{vm.model.valoreDatoProposta}}</span></div></div><input type=\"text\" ng-if=\"!vm.readOnly\" class=\"form-control\" ng-model=\"vm.model.valoreDatoProposta\" ng-focus=\"vm.handleFocus( vm.model.valoreDatoProposta )\" ng-blur=\"vm.handleBlur( vm.model.valoreDatoProposta )\"><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-datepicker/fpc-datepicker.html","<div class=\"cert-input cert-text-input\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div ng-if=\"vm.readOnly\" class=\"panel panel-default\" style=\"text-align: center\"><div class=\"panel-body\"><span>{{vm.model.valoreDatoProposta}}</span></div></div><label class=\"fieldWithIcon\" ng-if=\"!vm.readOnly\" style=\"max-width: 240px\"><input type=\"text\" class=\"form-control\" ng-change=\"vm.validateString()\" ng-model=\"vm.model.valoreDatoProposta\" readonly=\"\" date-range-picker=\"\" min-date=\"vm.minDate\" single-date=\"true\"> <i class=\"fa fa-calendar\"></i></label><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert && !vm.readOnly\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-drop-list/fpc-drop-list.html","<div class=\"cert-input cert-select-input\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div class=\"cert-select\"><div ng-if=\"vm.readOnly\" class=\"panel panel-default\"><div class=\"panel-body\"><span>{{vm.selectedItem.valore}}</span></div></div><ui-select ng-if=\"!vm.readOnly\" search-enabled=\"false\" ng-model=\"vm.selectedItem\" on-select=\"vm.onSelect($item, $model)\" ng-required=\"vm.isRequired\"><ui-select-match allow-clear=\"true\">{{vm.selectedItem.valore}}</ui-select-match><ui-select-choices repeat=\"item in vm.set\"><div>{{item.valore}}</div></ui-select-choices></ui-select></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-edit-table/fpc-edit-table.html","<div class=\"cert-input\" ng-class=\"{ \'campo-fantasma-cert\': vm.campoFantasma }\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div><table class=\"table\"><thead><tr><th ng-repeat=\"item in vm.set\"><p ng-bind-html=\"item.valore\"></p></th><th ng-if=\"vm.readOnly !== true\">Elimina</th></tr></thead><tbody><tr ng-repeat=\"(tabindex, item) in vm.tableItems\"><td ng-repeat=\"(itemIndex, textItem) in vm.set\"><textarea ng-attr-name=\"text-input-{{item.id}}\" rows=\"2\" style=\"width: 100%\" ng-blur=\"vm.saveItems()\" ng-disabled=\"vm.readOnly === true\" ng-model=\"vm.tableItems[tabindex][itemIndex].valore\">\n                        </textarea></td><td ng-if=\"vm.readOnly !== true\" class=\"remove\"><div ng-click=\"vm.handleRemove( tabindex )\"><i class=\"fa fa-lg fa-trash-o\" aria-hidden=\"true\"></i></div></td></tr></tbody></table></div><div ng-if=\"vm.readOnly !== true\" class=\"actions\"><label ng-click=\"vm.handleAdd()\" class=\"btn btn-primary\" ladda=\"vm.loading\"><i class=\"fa fa-plus-square\" aria-hidden=\"true\" style=\"margin-right: 10px\"></i>Aggiungi un elemento</label></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-email-input/fpc-email-input.html","<div class=\"cert-input cert-text-input\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div ng-if=\"vm.readOnly\" class=\"panel panel-default\"><div class=\"panel-body\"><span>{{vm.model.valoreDatoProposta}}</span></div></div><input ng-if=\"!vm.readOnly\" type=\"text\" class=\"form-control\" ng-blur=\"vm.validateMail(vm.model.valoreDatoProposta)\" ng-model=\"vm.model.valoreDatoProposta\"><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-field-switch/fpc-field-switch.html","<div ng-if=\"!vm.hide\" ng-switch=\"vm.model.tipoCampo\"><fpc-section-title ng-switch-when=\"TITOLO\" model=\"vm.model\" locked=\"vm.locked\"></fpc-section-title><fpc-text-input ng-switch-when=\"TESTO\" model=\"vm.model\" locked=\"vm.locked\"></fpc-text-input><fpc-number-input ng-switch-when=\"INTERO\" model=\"vm.model\" locked=\"vm.locked\"></fpc-number-input><fpc-radio-group ng-switch-when=\"RADIO\" model=\"vm.model\" locked=\"vm.locked\" expansion=\"vm.expansion\" uid=\"vm.model.uid\"></fpc-radio-group><fpc-check-group ng-switch-when=\"SCELTA_MULTIPLA\" model=\"vm.model\" locked=\"vm.locked\" expansion=\"vm.expansion\" uid=\"vm.model.uid\"></fpc-check-group><fpc-drop-list ng-switch-when=\"SCELTA_SINGOLA\" model=\"vm.model\" locked=\"vm.locked\"></fpc-drop-list><fpc-drop-list ng-switch-when=\"SELECT\" model=\"vm.model\" locked=\"vm.locked\"></fpc-drop-list><fpc-currency-input ng-switch-when=\"IMPORTO\" model=\"vm.model\" locked=\"vm.locked\"></fpc-currency-input><fpc-edit-table ng-switch-when=\"TABELLA\" model=\"vm.model\" locked=\"vm.locked\"></fpc-edit-table><fpc-file-upload ng-switch-when=\"UPLOAD_FILE\" model=\"vm.model\" locked=\"vm.locked\"></fpc-file-upload><fpc-alert-block ng-switch-when=\"ALERT\" model=\"vm.model\" locked=\"vm.locked\"></fpc-alert-block><fpc-email-input ng-switch-when=\"EMAIL\" model=\"vm.model\" locked=\"vm.locked\"></fpc-email-input><fpc-parole-cun-input ng-switch-when=\"PAROLE_CUN\" model=\"vm.model\" locked=\"vm.locked\"></fpc-parole-cun-input><fpc-datepicker ng-switch-when=\"DATA\" model=\"vm.model\" locked=\"vm.locked\"></fpc-datepicker></div>");
$templateCache.put("app/components/formPropostaCert/fpc-file-upload/fpc-file-upload.html","<div ng-if=\"vm.checkRender(vm.model)\" class=\"form-group cert-input row sgbField sgbFileUpload\"><label class=\"col-sm-12\"><p ng-bind-html=\"vm.model.label\"></p></label><div class=\"col-sm-12 description-block\"></div><div class=\"col-sm-3\" ng-if=\"vm.selectedFile.fileTemplateUrl\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{ vm.selectedFile.fileTemplateUrl }}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{ vm.selectedFile.fileTemplateLabel }}</a></div><div class=\"col-sm-8\"><label class=\"btn btn-primary\" ladda=\"vm.loading\" ng-if=\"vm.selectedFile == null\"><i class=\"fa fa-upload btn-icon\"></i>Seleziona File <input type=\"file\" accept=\"application/pdf\" ng-disabled=\"vm.loading\" onchange=\"angular.element(this).scope().vm.uploadFile(this.files); angular.element(this).scope().$apply();\"></label><div class=\"upload-error\" ng-if=\"vm.uploadError != null\">{{vm.uploadError}}</div><div class=\"btn-group\" ng-if=\"vm.selectedFile != null\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{vm.getFileHref(vm.model)}}\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{vm.model.nome}}</a> <a ng-if=\"!vm.readOnly\" class=\"btn btn-danger btn-toggle\" href=\"\" ng-click=\"vm.removeFile()\"><i class=\"fa fa-times\"></i></a></div></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-number-input/fpc-number-input.html","<div class=\"cert-input cert-int-input\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div ng-if=\"vm.readOnly\" class=\"panel panel-default\"><div class=\"panel-body\"><span>{{vm.model.valoreDatoProposta}}</span></div></div><input ng-if=\"!vm.readOnly\" type=\"number\" ng-blur=\"vm.validateString()\" class=\"form-control\" ng-model=\"vm.model.valoreDatoProposta\" ng-trim=\"false\" allow-empty=\"true\"><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-parole-cun-input/fpc-parole-cun-input.html","<div class=\"form-group row sgbField sgbKeywordsSelect\"><label class=\"col-sm-12\"><p ng-bind-html=\"vm.model.label\"></p></label><div class=\"col-sm-8\"><ol><li ng-if=\"!vm.readOnly\" ng-repeat=\"number in vm.range\" class=\"spaced\"><ui-select ng-model=\"vm.selectedKeywords[number]\" on-select=\"vm.onSelect(number)\"><ui-select-match allow-clear=\"true\"><span>{{$select.selected.valoreIT}}</span></ui-select-match><ui-select-choices repeat=\"item in vm.setCun | filter:vm.choicesFilter($select.search) | limitTo: 40\"><div ng-bind-html=\"item.valoreIT | highlight: $select.search\"></div></ui-select-choices></ui-select></li><li ng-if=\"vm.readOnly\" ng-repeat=\"keyword in vm.selectedKeywords\" class=\"panel panel-default spaced\"><div class=\"panel-body\"><span>{{keyword.valoreIT}}</span></div></li></ol></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vm.help}}</span></div></div><div style=\"margin-bottom: 20px\" ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div>");
$templateCache.put("app/components/formPropostaCert/fpc-radio-group/fpc-radio-group.html","<div class=\"cert-input cert-radio-input\" ng-class=\"{ \'campo-fantasma-cert\': vm.campoFantasma }\"><div ng-if=\"!vm.columnLayout\"><div class=\"inline-wrap\"><label ng-if=\"vm.model.label\"><p ng-bind-html=\"vm.model.label\"></p></label><div class=\"radio-wrap\"><label ng-repeat=\"key in vm.set\" class=\"radio-inline\"><input type=\"radio\" ng-attr-name=\"radio-{{key.id}}\" ng-change=\"vm.onRadioChange( key.id )\" ng-model=\"vm.model.valoreDatoProposta\" ng-value=\"key.id\" ng-disabled=\"(vm.forceDisable === true || vm.readOnly === true)\"><p ng-bind-html=\"key.valore\"></p></label></div></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div></div><div ng-if=\"vm.columnLayout\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div class=\"radio-wrap column\"><label ng-repeat=\"key in vm.set\" class=\"radio-inline\"><input type=\"radio\" ng-attr-name=\"radio-{{key.id}}\" ng-change=\"vm.onRadioChange( key.id )\" ng-model=\"vm.model.valoreDatoProposta\" ng-value=\"key.id\" ng-disabled=\"(vm.forceDisable === true || vm.readOnly === true)\"><p ng-bind-html=\"key.valore\"></p></label></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-recap-display/fpc-recap-display.html","<div class=\"cert-display\"><label>{{vm.model.title}}</label><div><div class=\"well\"><div class=\"form-group valueRow cert-display-wrapper\" ng-repeat=\"info in vm.model.items\"><label class=\"small-label\">{{info.label}}</label> <span>{{info.value || \"-\"}}</span></div></div></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-section-title/fpc-section-title.html","<div class=\"sgbSection\"><div class=\"sgbLegend\"><p ng-bind-html=\"vm.model.label\"></p></div><div></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-text-input/fpc-text-input.html","<div class=\"cert-input cert-text-input\"><label><p ng-bind-html=\"vm.model.label\"></p></label><div ng-if=\"vm.readOnly\" class=\"panel panel-default\"><div class=\"panel-body\"><span>{{vm.model.valoreDatoProposta}}</span></div></div><div ng-if=\"!vm.readOnly && (!vm.model.numHeight || vm.model.numHeight < 2)\"><input type=\"text\" ng-blur=\"vm.validateString()\" ng-attr-name=\"text-input-{{vm.model.id}}\" class=\"form-control\" maxlength=\"vm.model.maxLengthSize\" ng-keypress=\"vm.debounceValidate()\" ng-disabled=\"vm.model.flagReadOnly\" ng-model=\"vm.model.valoreDatoProposta\"></div><div ng-if=\"!vm.readOnly && (vm.model.numHeight > 1)\"><textarea ng-blur=\"vm.validateString()\" ng-attr-name=\"text-input-{{vm.model.id}}\" rows=\"{{vm.model.numHeight}}\" maxlength=\"vm.model.maxLengthSize\" ng-keyup=\"vm.debounceValidate()\" ng-model=\"vm.model.valoreDatoProposta\">\n        </textarea></div><div ng-if=\"!vm.readOnly && vm.remainingChars\" class=\"input-tip-container\"><span>Caratteri rimanenti: {{vm.remainingChars}}</span></div><div ng-if=\"vm.model.notaCampo\" class=\"input-tip-container\"><span><p ng-bind-html=\"vm.model.notaCampo\"></p></span></div><div ng-if=\"vm.alert\"><fpc-alert-block model=\"vm.alert\" size=\"0\"></fpc-alert-block></div></div>");
$templateCache.put("app/components/seduteCert/listaSeduteCert/listaSeduteCert.html","<div class=\"page-header flex-center\"><h1>Sedute</h1><a ng-click=\"vm.goToDettaglioSeduta()\" class=\"btn btn-primary\"><i class=\"fa fa-pencil-square-o\"></i> Inserisci seduta</a></div><div class=\"listaSeduteContainer\"><div class=\"spinner\" ng-if=\"vm.seduteList == null\"></div><div ng-if=\"vm.seduteList != null\"><table class=\"table table-hover\"><thead><tr><th class=\"commissioneColumn\">Data Delibera</th><th class=\"commissioneColumn\">Commissione</th><th class=\"dettagliColumn\">Dettaglio</th><th></th></tr></thead><tbody><tr class=\"noResults\" ng-if=\"vm.seduteList.length == 0\"><td colspan=\"4\">Nessuna seduta presente</td></tr><tr ng-repeat=\"seduta in vm.seduteList\"><td><div><i class=\"fa fa-calendar\" style=\"margin-right: 5px;\"></i> {{seduta.dataSeduta | date:\'dd/MM/yyyy HH:mm\'}}</div></td><td>{{seduta.certCommissione.nome}}</td><td><button type=\"button\" uib-tooltip=\"Visualizza seduta\" class=\"btn btn-sm btn-default\" ng-click=\"vm.goToDettaglioSeduta(seduta.id)\"><i class=\"fa fa-arrow-right\"></i></button></td></tr></tbody></table></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getSeduteList(true)\">></uib-pagination></div></div>");
$templateCache.put("app/components/seduteCert/sedutaCert/sedutaCert.html","<h1 class=\"page-header\">{{vm.pageHeaderSeduta}}</h1><form class=\"sedutaCertForm\"><div class=\"form-group\"><label>Commissione attiva</label> <input disabled=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.seduta.certCommissione.nome\"></div><div class=\"sedutaContainer\"><div><div><label>{{vm.sedutaId == null || vm.sedutaId.length == 0 ? \'Proposte da associare\' : \'Proposte Associate\'}}</label><table class=\"table sedutaTable\"><thead><tr class=\"fixedHeader\"><th class=\"actionColumn\"><div class=\"th-inner\"></div></th><th><div class=\"th-inner\">Titolo/Oggetto</div></th><th><div class=\"th-inner\" style=\"transform: translateX(-6px)\"></div></th><th><div class=\"th-inner\" style=\"transform: translateX(-6px)\"></div></th></tr></thead><tbody><div class=\"spinner\" ng-if=\"vm.proposteCert == null\"></div><div ng-if=\"vm.proposteCert != null\"><tr ng-if=\"vm.proposteCert.length === 0\" class=\"emptyTable\"><td colspan=\"8\">Nessun risultato</td></tr><tr class=\"sedutaBox\" ng-repeat=\"proposta in vm.proposteCert\"><td class=\"status\"><input type=\"checkbox\" ng-checked=\"vm.checkProposteIncludes(proposta)\" ng-disabled=\"vm.sedutaId != null\" ng-click=\"vm.insertRemoveProposta(proposta)\"></td><td><div class=\"titolo\">{{proposta.titolo ? proposta.titolo : \'&lt;progetto senza titolo&gt;\'}}</div><div ng-if=\"proposta.numeroProtocollo\" class=\"sottotitolo\">ID protocollo proposta: {{proposta.numeroProtocollo}}</div></td><td></td><td class=\"withButton\"></td></tr></div></tbody></table></div></div><div class=\"paginationBox\"><span class=\"itemNumber\">{{vm.pagination.start}}</span> - <span class=\"itemNumber\">{{vm.pagination.end}}</span> di <span class=\"itemNumber\">{{vm.pagination.total}}</span><uib-pagination class=\"pull-right pagination-sm\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.limit\" ng-model=\"vm.pagination.current\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" boundary-link-numbers=\"true\" ng-change=\"vm.getProposteCertForSeduta(true)\"></uib-pagination></div></div><div class=\"form-group\"><label>Presidente</label><table class=\"table sedutaTable\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.seduta.certCommissione.presidente == null\"><td colspan=\"5\">Nessun presidente</td></tr><tr ng-if=\"vm.seduta.certCommissione.presidente != null\"><td class=\"nameColumn\">{{vm.seduta.certCommissione.presidente.cognome}} {{vm.seduta.certCommissione.presidente.nome}}</td></tr></tbody></table></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-2\"><label>Data Delibera</label></div><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\' : vm.seduta.dataSeduta.$invalid}\"><label class=\"fieldWithIcon\" for=\"dataInizio\"><input class=\"form-control\" date-range-picker=\"\" id=\"dataInizio\" name=\"dataInizio\" required=\"\" ng-model=\"vm.seduta.dataSeduta\" readonly=\"\" ng-disabled=\"vm.sedutaId != null\" single-date=\"true\" type=\"text\" max-date=\"vm.minDate\"> <i class=\"fa fa-calendar\"></i></label></div></div></div><div class=\"form-group\"><label>Membri Commissione</label><table class=\"table sedutaTable\"><thead><tr><th>Presente</th><th class=\"nameColumn\">Cognome e Nome</th><th class=\"roleColumn\"></th><th class=\"depColumn\"></th><th class=\"areaColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vm.seduta.certCommissione.membri.length == 0\"><td colspan=\"6\">Nessun membro</td></tr><tr ng-repeat=\"membro in vm.certMembriProposta\"><td class=\"numberColumn\"><input type=\"checkbox\" ng-disabled=\"vm.sedutaId != null\" ng-checked=\"membro.presente\" ng-click=\"membro.presente ? membro.presente = false : membro.presente = true\"></td><td class=\"nameColumn\">{{membro.certMembroCommissioneDTO.cognome}} {{membro.certMembroCommissioneDTO.nome}} {{!membro.isInterno ? \'(Esterno)\' : \"\"}}</td><td class=\"roleColumn\"></td><td class=\"istanzeLink\"></td><td class=\"areaColumn\"></td></tr></tbody></table></div><button ng-if=\"vm.sedutaId == null\" class=\"btn btn-primary\" ng-click=\"vm.saveSeduta()\">Salva seduta</button> <button class=\"btn btn-default\" ui-sref=\"seduteCertList\">{{vm.sedutaId == null ? \'Chiudi senza salvare\' : \'Chiudi\'}}</button></form>");
$templateCache.put("app/components/view/sgb-v-budget/sgb-v-budget.html","<div class=\"form-group row sgbField sgbVBudget\"><label class=\"col-sm-12\">{{vBdgt.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"expenseColumn\">{{\"BUDGET_ITEM\" | translate}}</th><th class=\"assegnoColumn\"></th><th class=\"valueColumn\">{{\"AMOUNT\" | translate}}</th><th class=\"descriptionColumn\" ng-if=\"!(vBdgt.hideDescriptions === \'true\')\">{{\"DESCRIPTION\" | translate}}</th><th ng-if=\"vBdgt.type == \'pnrr\'\" class=\"valueColumn\">Eventuale cofinanziamento (Euro)</th></tr></thead><tbody><tr ng-repeat=\"row in vBdgt.model\"><td class=\"expenseColumn\" colspan=\"2\" ng-if=\"row.tipo != \'IMPORTO_FISSO\'\">{{row.nome}}</td><td class=\"expenseColumn\" ng-if=\"row.tipo == \'IMPORTO_FISSO\'\">{{row.nome}}</td><td class=\"assegnoColumn\" ng-if=\"row.tipo == \'IMPORTO_FISSO\'\">n° {{row.finanziamentoRichiesto ? (row.finanziamentoRichiesto * 1) / row.importo : 0}}</td><td class=\"valueColumn\" ng-if=\"row.tipo != \'IMPORTO_FISSO\'\">{{row.finanziamentoRichiesto}}</td><td class=\"valueColumn\" ng-if=\"row.tipo == \'IMPORTO_FISSO\'\">{{row.finanziamentoRichiesto}}</td><td class=\"descriptionColumn\" ng-if=\"!(vBdgt.hideDescriptions === \'true\')\"><span>{{row.note}}</span></td><td class=\"valueColumn\" ng-if=\"row.tipo != \'IMPORTO_FISSO\' && vBdgt.type == \'pnrr\'\">{{row.eventualeCoFinanziamento}}</td></tr><tr class=\"totalRow\"><td class=\"expenseColumn\">{{\"TOTAL\" | translate}}</td><td></td><td class=\"valueColumn\">{{vBdgt.getTotal(vBdgt.model)}}</td><td class=\"descriptionColumn\" ng-if=\"!(vBdgt.hideDescriptions === \'true\')\"></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-checkbox/sgb-v-checkbox.html","<div class=\"form-group row sgbField sgbVCheckbox\"><label class=\"col-sm-12\">{{sgbVCheckboxCtrl.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"sgbVCheckboxCtrl.description\"><span ng-bind-html=\"sgbVCheckboxCtrl.description\"></span></div><div class=\"col-sm-12\"><label class=\"check-label\"><input type=\"checkbox\" ng-model=\"sgbVCheckboxCtrl.model\" disabled=\"\"></label></div></div>");
$templateCache.put("app/components/view/sgb-v-complexField/sgb-v-complexField.html","<div class=\"form-group row sgbField sgbVComplexField\"><label class=\"col-sm-12\">{{vCplxField.label}}</label><div class=\"col-sm-12\"><div class=\"well\"><div class=\"form-group valueRow\" ng-repeat=\"info in vCplxField.info\" ng-if=\"!info.optional || ($eval(info.model, vCplxField.model) !== null)\"><label>{{info.label}}</label> <span>{{$eval(info.model, vCplxField.model)}}&nbsp;</span></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-currencyField/sgb-v-currencyField.html","<div class=\"form-group row sgbField sgbVCurrencyField\"><label class=\"col-sm-12\">{{sgbVCurrencyField.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"sgbVCurrencyField.description\"><span ng-bind-html=\"sgbVCurrencyField.description\"></span></div><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><span>{{sgbVCurrencyField.model | number : 2}}</span></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-fileMultipleUpload/sgb-v-fileMultipleUpload.html","<div class=\"form-group row sgbField sgbVFileMultipleUpload\"><label class=\"col-sm-12\">{{vFileMUCtrl.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"vFileMUCtrl.description\"><span ng-bind-html=\"vFileMUCtrl.description\"></span></div><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"file-row\" ng-repeat=\"fileModel in vFileMUCtrl.model\"><div class=\"btn-group\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{vFileMUCtrl.getFileHref(fileModel)}}\" ng-if=\"!vFileMUCtrl.nameOnly\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{fileModel.nome}}</a><div class=\"btn btn-primary\" ng-if=\"vFileMUCtrl.nameOnly\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{fileModel.nome}}</div></div></div></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-fileUpload/sgb-v-fileUpload.html","<div class=\"form-group row sgbField sgbVFileUpload\"><label class=\"col-sm-12\">{{vFileUpCtrl.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"vFileUpCtrl.description\"><span ng-bind-html=\"vFileUpCtrl.description\"></span></div><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"btn-group\" ng-if=\"vFileUpCtrl.model != null\"><a target=\"_blank\" class=\"btn btn-primary\" ng-href=\"{{vFileUpCtrl.getFileHref(vFileUpCtrl.model)}}\" ng-if=\"!vFileUpCtrl.nameOnly\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{vFileUpCtrl.model.nome}}</a><div class=\"btn btn-primary\" ng-if=\"vFileUpCtrl.nameOnly\"><i class=\"fa fa-file-pdf-o btn-icon\"></i>{{vFileUpCtrl.model.nome}}</div></div></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-hIndex/sgb-v-hIndex.html","<div class=\"form-group row sgbField sgbVHIndex\"><label class=\"col-sm-12\">{{vHIndexCtrl.label}}</label><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\">{{vHIndexCtrl.model.hindex}}{{(vHIndexCtrl.model.database) ? \' - \' + vHIndexCtrl.model.database : \'\'}}</div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-hIndexPart/sgb-v-hIndexPart.html","<div class=\"form-group row sgbField sgbVHIndexPart\"><label class=\"col-sm-12\">{{vHIndPartCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nomeColumn\">{{\"OTHER_PI\" | translate}}</th><th class=\"hindexColumn\">H-Index</th><th class=\"dbColumn\">{{\"REFERENCE_DATABASE\" | translate}}</th></tr></thead><tbody><tr class=\"noCoprop\" ng-if=\"vHIndPartCtrl.model == null || vHIndPartCtrl.model.length == 0\"><td colspan=\"3\">{{\"NO_OTHER_PI\" | translate}}</td></tr><tr ng-repeat=\"row in vHIndPartCtrl.model\"><td class=\"nomeColumn\">{{row.utente.cognome}} {{row.utente.nome}}</td><td class=\"hindexColumn\">{{row.hindex}}</td><td class=\"dbColumn\">{{row.database}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-indicatoriImpattoSostenibilita/sgb-v-indicatoriImpattoSostenibilita.html","<div class=\"form-group row sgbField sgbIndicatoriImpattoSostenibilita\"><label class=\"col-sm-12\">{{indImpSostCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nomeIndicatoreColumn\">Indicatore</th><th class=\"valoreIndicatoreColumn\">Valore</th></tr></thead><tbody><tr class=\"noIndicatori\" ng-if=\"indImpSostCtrl.model.indicatoriList.length == 0\"><td colspan=\"3\">Nessun Indicatore</td></tr><tr class=\"accepted\" ng-repeat=\"ind in indImpSostCtrl.model.indicatoriList\"><td class=\"nomeIndicatoreColumn\">{{ ind.indicatore }}</td><td class=\"valoreIndicatoreColumn\">{{ ind.valore }}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-keywords/sgb-v-keywords.html","<div class=\"form-group row sgbField sgbVKeywords\"><label class=\"col-sm-12\">{{vKeywordsCtrl.label}}</label><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><ol ng-if=\"vKeywordsCtrl.model != null\"><li ng-repeat=\"keyword in vKeywordsCtrl.model track by $index\" ng-if=\"keyword != null && keyword != \'\'\">{{keyword}}</li></ol></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-keywordsSelect/sgb-v-keywordsSelect.html","<div class=\"form-group row sgbField sgbVKeywordsSelect\"><label class=\"col-sm-12\">{{vKeySelCtrl.label}}</label><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><ol ng-if=\"vKeySelCtrl.model != null\"><li ng-repeat=\"keyword in vKeySelCtrl.model track by $index\" ng-if=\"keyword != null && keyword != \'\'\">{{keyword[vKeySelCtrl.choicesLabel]}}</li></ol></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-lastFundings/sgb-v-lastFundings.html","<div class=\"form-group row sgbField sgbVLastFundings\"><label class=\"col-sm-12\">{{vLastFundsCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"annoColumn\">{{\"YEAR\" | translate}}</th><th class=\"assignedColumn\">{{\"ASSIGNED_FUND\" | translate}}</th><th class=\"notUsedColumn\">{{\"NOT_YET_USED_FUND\" | translate}}</th><th class=\"notUsedReasonColumn\">{{\"REASON_FOR_UNUSED_FUND\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in vLastFundsCtrl.model\"><td class=\"annoColumn\">{{row.anno}}</td><td class=\"assignedColumn\">{{row.fondo_assegnato}}</td><td class=\"notUsedColumn\">{{row.fondo_non_utilizzato}}</td><td class=\"notUsedReasonColumn\"><span>{{row.motivazione_mancato_utilizzo}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-lastFundingsNew/sgb-v-lastFundingsNew.html","<div class=\"form-group row sgbField sgbVLastFundingsNew\"><label class=\"col-sm-12\">{{vLastFundsNCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"annoColumn\">{{\"YEAR\" | translate}}</th><th class=\"progettoColumn\">{{\"FUNDED_PROJECT\" | translate}}</th><th class=\"assignedColumn\">{{\"ASSIGNED_FUND\" | translate}}</th><th class=\"notUsedColumn\">{{\"NOT_YET_USED_FUND\" | translate}}</th><th class=\"notUsedReasonColumn\">{{\"REASON_FOR_UNUSED_FUND\" | translate}}</th></tr></thead><tbody><tr ng-repeat-start=\"row in vLastFundsNCtrl.model\"><td class=\"annoColumn\">{{row.anno}}</td><td class=\"annoColumn\" colspan=\"4\"></td></tr><tr ng-if=\"(!row.progettiFinanziati || row.progettiFinanziati.length == 0) && (!row.altro || row.altro.length == 0)\"><td class=\"noFundings\" colspan=\"5\">Nessun finanziamento</td></tr><tr ng-repeat=\"proj in row.progettiFinanziati\"><td></td><td class=\"progettoColumn\"><div class=\"titolo\">{{proj.titolo}}</div><div class=\"tipologia\">{{proj.nomeTipologia + \' - \' + proj.nomeClasse}}</div></td><td class=\"assignedColumn\"><div><i class=\"fa fa-eur\" uib-tooltip=\"Finanziamento\"></i>&nbsp;{{proj.finanziamentoAssegnato}}</div><div ng-if=\"proj.assegnoAssegnato > 0\"><i class=\"fa fa-list-alt\" uib-tooltip=\"Assegno\"></i>&nbsp;{{proj.assegnoAssegnato}}</div></td><td class=\"notUsedColumn\">{{proj.fondo_non_utilizzato}}</td><td class=\"notUsedReasonColumn\"><span>{{proj.motivazione_mancato_utilizzo}}</span></td></tr><tr ng-repeat=\"other in row.altro\"><td></td><td class=\"progettoColumn\"><span>{{other.progetto}}</span></td><td class=\"assignedColumn\">{{other.fondo_assegnato}}</td><td class=\"notUsedColumn\">{{other.fondo_non_utilizzato}}</td><td class=\"notUsedReasonColumn\"><span>{{other.motivazione_mancato_utilizzo}}</span></td></tr><tr class=\"separator\" ng-repeat-end=\"\"><td colspan=\"5\"></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-lineeTematiche/sgb-v-lineeTematiche.html","<div class=\"form-group row sgbField sgbVParticipantsManual\"><label class=\"col-sm-12\">{{vlinTemCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"idColumn\">Linea tematica</th><th class=\"nameColumn\">Titolo</th><th class=\"roleColumn\" ng-if=\"vlinTemCtrl.type !== \'dipartimentali\'\">Co-PI(Cognome, Nome)</th><th class=\"roleColumn\" ng-if=\"vlinTemCtrl.type == \'dipartimentali\'\">Referente scientifico(Cognome, Nome)</th><th class=\"depColumn\" ng-if=\"vlinTemCtrl.type !== \'dipartimentali\'\">Co-PI (Dipartimento di afferenza)</th><th class=\"depColumn\" ng-if=\"vlinTemCtrl.type !== \'dipartimentali\'\">Costo totale previsto (escluso cofinanziamento)</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vlinTemCtrl.model.length == 0 || !vlinTemCtrl.model\"><td colspan=\"5\">Nessun Elemento</td></tr><tr class=\"accepted\" ng-repeat=\"linea in vlinTemCtrl.model\"><td class=\"idColumn\">{{linea.id}}</td><td class=\"nameColumn\">{{linea.titolo}}</td><td class=\"roleColumn\">{{linea.coPiCogNom}}</td><td class=\"depColumn\" ng-if=\"vlinTemCtrl.type !== \'dipartimentali\'\">{{linea.coPiDipartimento}}</td><td class=\"depColumn\" ng-if=\"vlinTemCtrl.type !== \'dipartimentali\'\">{{linea.costo}}</td><td class=\"actionColumn\"></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vlinTemCtrl.help}}</span></div></div>");
$templateCache.put("app/components/view/sgb-v-otherFundings/sgb-v-otherFundings.html","<div class=\"form-group row sgbField sgbVOtherFundings\"><label class=\"col-sm-12\">{{vOthFundCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"enteColumn\">Ente finanziatore</th><th class=\"valueColumn\">Contributo ottenuto</th><th class=\"descriptionColumn\">Note</th></tr></thead><tbody><tr class=\"noFunds\" ng-if=\"vOthFundCtrl.model == null || vOthFundCtrl.model.length == 0\"><td colspan=\"3\">Nessun contributo da altri enti</td></tr><tr ng-repeat=\"row in vOthFundCtrl.model\"><td class=\"enteColumn\">{{row.ente}}</td><td class=\"valueColumn\">{{row.contributoOttenuto}}</td><td class=\"descriptionColumn\"><span>{{row.note}}</span></td></tr><tr class=\"totalRow\"><td class=\"enteColumn\">TOTALE</td><td class=\"valueColumn\">{{vOthFundCtrl.getTotal(vOthFundCtrl.model)}}</td><td class=\"descriptionColumn\"></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-participants/sgb-v-participants.html","<div class=\"form-group row sgbField sgbVParticipants\"><label class=\"col-sm-12\">{{vPartCtrl.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"vPartCtrl.description\"><span ng-bind-html=\"vPartCtrl.description\"></span></div><label class=\"col-sm-12\" style=\"margin-top: 15px;\" ng-if=\"vPartCtrl.type == \'dipartimentali\'\">Il direttore o suo delegato per partecipare al gruppo di ricerca deve aggiungersi tra i componenti</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nameColumn\">{{\"NAME_AND_SURNAME\" | translate}}</th><th class=\"roleColumn\">{{\"ROLE\" | translate}}</th><th class=\"depColumn\" ng-if=\"vPartCtrl.type !== \'terza-missione\' && vPartCtrl.type !== \'dipartimentali\'\">{{\"DEPARTMENT\" | translate}}</th><th class=\"macroareaColumn\" ng-if=\"vPartCtrl.type !== \'terza-missione\'\">Macroarea</th><th class=\"ercColumn\" ng-if=\"vPartCtrl.type == \'simple\'\"></th><th class=\"ercColumn\" ng-if=\"!vPartCtrl.type || vPartCtrl.type == \'\'\">{{\"ERC_SECTOR\" | translate}}</th><th class=\"ercColumn\" ng-if=\"vPartCtrl.type == \'sub-sectors\' || vPartCtrl.type == \'pi-sostituito\' || vPartCtrl.type == \'dipartimentali\'\">{{\"ERC_SUB_SECTOR\" | translate}}</th><th class=\"piSostituitoColumn\" ng-if=\"vPartCtrl.type == \'pi-sostituito\'\">PI Sostituto</th><th class=\"ssdColumn\" ng-if=\"vPartCtrl.type === \'terza-missione\'\">SSD</th><th class=\"ercColumn\" ng-if=\"vPartCtrl.type == \'pnrr\'\">Numero di mesi persona impegnati nel progetto</th><th class=\"pnrMasErcColumn\" ng-if=\"vPartCtrl.type == \'pnrr\'\">Massa critica (SI/NO)</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vPartCtrl.model.partecipantiList.length == 0\"><td colspan=\"5\">{{\"NO_COMPONENT\" | translate}}</td></tr><tr ng-repeat=\"partecipante in vPartCtrl.model.partecipantiList\"><td class=\"nameColumn\">{{partecipante.cognome}} {{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.ruolo.descrizione}}</td><td class=\"depColumn\" ng-if=\"vPartCtrl.type !== \'terza-missione\' && vPartCtrl.type !== \'dipartimentali\'\">{{partecipante.dipartimento.nome}}</td><td class=\"macroareaColumn\" ng-if=\"vPartCtrl.type !== \'terza-missione\'\">{{partecipante.dipartimento.macroArea.code}}</td><td class=\"ercColumn\" ng-if=\"vPartCtrl.type == \'simple\'\"></td><td class=\"ercColumn\" ng-if=\"!vPartCtrl.type || vPartCtrl.type == \'\'\">{{partecipante.settoreERC.codice}}</td><td class=\"ercColumn\" ng-if=\"vPartCtrl.type == \'sub-sectors\' || vPartCtrl.type == \'pi-sostituito\' || vPartCtrl.type == \'dipartimentali\'\">{{partecipante.sottoSettoreERC.codice}}</td><td class=\"piSostituitoColumn\" ng-if=\"vPartCtrl.type == \'pi-sostituito\'\"><input type=\"checkbox\" disabled=\"\" class=\"chkPiSostituito\" ng-model=\"partecipante.piSostituito\"></td><td class=\"ssdColumn\" ng-if=\"vPartCtrl.type === \'terza-missione\'\">{{partecipante.ssd.codice}}</td><td class=\"pnrErcColumn\" ng-if=\"vPartCtrl.type == \'pnrr\'\">{{partecipante.mesiPersona}}</td><td class=\"pnrMasErcColumn\" ng-if=\"vPartCtrl.type == \'pnrr\'\">{{partecipante.massaCritica}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-participantsManual/sgb-v-participantsManual.html","<div class=\"form-group row sgbField sgbVParticipantsManual\"><label class=\"col-sm-12\">{{vPartManCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"surnameColumn\">{{\"SURNAME\" | translate}}</th><th class=\"nameColumn\">{{\"NAME\" | translate}}</th><th class=\"roleColumn\">{{\"ROLE\" | translate}}</th><th class=\"depColumn\">{{\"DEPARTMENT_ORGANIZATION\" | translate}}</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vPartManCtrl.model.partecipantiList.length == 0\"><td colspan=\"4\">{{\"NO_COMPONENT\" | translate}}</td></tr><tr ng-repeat=\"partecipante in vPartManCtrl.model.partecipantiList\"><td class=\"surnameColumn\">{{partecipante.cognome}}&nbsp;</td><td class=\"nameColumn\">{{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.qualifica}}</td><td class=\"depColumn\">{{partecipante.struttura}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-participantsManualRend/sgb-v-participantsManualRend.html","<div class=\"form-group row sgbField sgbVParticipantsManualRend\"><label class=\"col-sm-12\">{{vPartManRendCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"surnameColumn\">Cognome</th><th class=\"nameColumn\">Nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento/Organizzazione</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vPartManRendCtrl.model.length == 0\"><td colspan=\"4\">Nessun componente</td></tr><tr ng-repeat=\"partecipante in vPartManRendCtrl.model\"><td class=\"surnameColumn\">{{partecipante.cognome}}&nbsp;</td><td class=\"nameColumn\">{{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.qualifica}}</td><td class=\"depColumn\">{{partecipante.struttura}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-participantsRend/sgb-v-participantsRend.html","<div class=\"form-group row sgbField sgbVParticipantsRend\"><label class=\"col-sm-12\">{{vPartRendCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><tbody><tr class=\"noParticipants\" ng-if=\"vPartRendCtrl.model.length == 0\"><td colspan=\"4\">Nessun componente</td></tr><tr class=\"separator\" ng-repeat-start=\"categoria in vPartRendCtrl.model\" ng-if=\"categoria.partecipantiList.length > 0\"><th colspan=\"4\">{{categoria.descrizione}}</th></tr><tr class=\"tHeader\" ng-if=\"categoria.partecipantiList.length > 0\"><th class=\"nameColumn\">Cognome e nome</th><th class=\"roleColumn\">Qualifica</th><th class=\"depColumn\">Dipartimento/Organizzazione</th><th class=\"partColumn\">Ha&nbsp;partecipato?</th></tr><tr ng-repeat=\"partecipante in categoria.partecipantiList\" ng-if=\"categoria.partecipantiList.length > 0\" ng-repeat-end=\"\"><td class=\"nameColumn\">{{partecipante.cognome}} {{partecipante.nome}}</td><td class=\"roleColumn\">{{partecipante.ruolo.descrizione ? partecipante.ruolo.descrizione : partecipante.qualifica}}</td><td class=\"depColumn\">{{partecipante.dipartimento.nome ? partecipante.dipartimento.nome : partecipante.struttura}}</td><td class=\"partColumn\">{{(partecipante.partecipazioneEffettiva === true ? \'Sì\' : (partecipante.partecipazioneEffettiva === false ? \'No\' : \'\') )}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-previousFundings/sgb-v-previousFundings.html","<div class=\"form-group row sgbField sgbVPreviousFundings\"><label class=\"col-sm-12\">{{vPrevFundCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"titolareColumn\">Titolare</th><th class=\"enteColumn\">Ente finanziatore</th><th class=\"importoColumn\">Importo</th><th class=\"progettoColumn\">Titolo progetto</th><th class=\"dataColumn\" ng-if=\"vPrevFundCtrl.type == \'withYears\'\">Data inizio</th><th class=\"dataColumn\" ng-if=\"vPrevFundCtrl.type == \'withYears\'\">Data fine</th></tr></thead><tbody><tr class=\"noFundings\" ng-if=\"vPrevFundCtrl.model == null || vPrevFundCtrl.model.length == 0\"><td colspan=\"{{(vPrevFundCtrl.type == \'withYears\') ? 6 : 4}}\">Nessun finanziamento</td></tr><tr ng-repeat=\"finanziamento in vPrevFundCtrl.model\"><td class=\"titolareColumn\">{{finanziamento.titolare}}</td><td class=\"enteColumn\">{{finanziamento.enteFinanziatore}}</td><td class=\"importoColumn\">{{finanziamento.importo}}</td><td class=\"progettoColumn\">{{finanziamento.titoloProgetto}}</td><td class=\"dataColumn\" ng-if=\"vPrevFundCtrl.type == \'withYears\'\">{{finanziamento.dataInizio}}</td><td class=\"dataColumn\" ng-if=\"vPrevFundCtrl.type == \'withYears\'\">{{finanziamento.dataFine}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-previousFundingsNew/sgb-v-previousFundingsNew.html","<div class=\"form-group row sgbField sgbVPreviousFundingsNew\"><label class=\"col-sm-12\">{{vPrevFundNCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"finanziamentoColumn\">Finanziamento</th></tr></thead><tbody><tr class=\"noFundings\" ng-if=\"vPrevFundNCtrl.model == null || vPrevFundNCtrl.model.length == 0\"><td>Nessun finanziamento</td></tr><tr ng-repeat=\"finanziamento in vPrevFundNCtrl.model\"><td class=\"finanziamentoColumn\"><table class=\"finRow\"><tr><td class=\"box boxM\"><span class=\"fieldLabel\">Titolare</span><div>{{finanziamento.titolare}}</div></td><td class=\"box boxL\"><span class=\"fieldLabel\">Ente finanziatore</span><div>{{finanziamento.enteFinanziatore}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\">Importo</span><div>{{finanziamento.importo}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\" uib-tooltip=\"Percentuale impegno\">Perc. impegno</span><div>{{finanziamento.percentualeImpegno}}</div></td></tr><tr><td class=\"box boxXL\" colspan=\"2\"><span class=\"fieldLabel\">Titolo progetto</span><div>{{finanziamento.titoloProgetto}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Inizio</span><div>{{finanziamento.dataInizio}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Fine</span><div>{{finanziamento.dataFine}}</div></td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-previousFundingsNewNoPercImpegno/sgb-v-previousFundingsNewNoPercImpegno.html","<div class=\"form-group row sgbField sgbVPreviousFundingsNewNoPercImpegno\"><label class=\"col-sm-12\">{{vPrevFundNPercImpCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"finanziamentoColumn\">Finanziamento</th></tr></thead><tbody><tr class=\"noFundings\" ng-if=\"vPrevFundNPercImpCtrl.model == null || vPrevFundNPercImpCtrl.model.length == 0\"><td>Nessun finanziamento</td></tr><tr ng-repeat=\"finanziamento in vPrevFundNPercImpCtrl.model\"><td class=\"finanziamentoColumn\"><table class=\"finRow\"><tr><td class=\"box boxM\"><span class=\"fieldLabel\">Titolare</span><div>{{finanziamento.titolare}}</div></td><td class=\"box boxL\"><span class=\"fieldLabel\">Ente finanziatore</span><div>{{finanziamento.enteFinanziatore}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\">Importo</span><div>{{finanziamento.importo}}</div></td></tr><tr><td class=\"box boxXL\" colspan=\"2\"><span class=\"fieldLabel\">Titolo progetto</span><div>{{finanziamento.titoloProgetto}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Inizio</span><div>{{finanziamento.dataInizio}}</div></td><td class=\"box boxS\"><span class=\"fieldLabel\">Data Fine</span><div>{{finanziamento.dataFine}}</div></td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-progettiManual/sgb-v-progettiManual.html","<div class=\"form-group row sgbField sgbParticipantsManual\"><label class=\"col-sm-12\">{{vprogManCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"idColumn\">No</th><th ng-if=\"vprogManCtrl.type != \'brev\'\" class=\"surnameColumn\">Soggetto Finanziatore</th><th ng-if=\"vprogManCtrl.type == \'brev\'\" class=\"surnameColumn\">Autori</th><th class=\"nameColumn\">Titolo</th><th ng-if=\"vprogManCtrl.type != \'brev\'\" class=\"roleColumn\">Anno inizio</th><th ng-if=\"vprogManCtrl.type == \'brev\'\" class=\"roleColumn\">Anno</th><th ng-if=\"vprogManCtrl.type != \'brev\'\" class=\"depColumn\">Ruolo (PI, Co-PI, Partecipante)</th><th ng-if=\"vprogManCtrl.type == \'brev\'\" class=\"depColumn\">Brevetto depositato ovvero domanda di brevetto</th><th class=\"actionColumn\"></th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vprogManCtrl.model.length == 0 || !vprogManCtrl.model\"><td colspan=\"5\">Nessun Elemento</td></tr><tr class=\"accepted\" ng-repeat=\"progetto in vprogManCtrl.model\"><td class=\"idColumn\">{{progetto.id}}</td><td ng-if=\"!vprogManCtrl.type\" class=\"surnameColumn\">{{progetto.soggettoFinan}}</td><td ng-if=\"vprogManCtrl.type == \'brev\'\" class=\"surnameColumn\">{{progetto.autori}}</td><td class=\"nameColumn\">{{progetto.titolo}}</td><td class=\"roleColumn\">{{progetto.anno}}</td><td ng-if=\"!vprogManCtrl.type\" class=\"depColumn\">{{progetto.ruolo}}</td><td ng-if=\"vprogManCtrl.type == \'brev\'\" class=\"depColumn\">{{progetto.deposito}}</td><td class=\"actionColumn\"></td></tr></tbody></table></div><div class=\"col-sm-12\"><span class=\"help-block\">{{vprogManCtrl.help}}</span></div></div>");
$templateCache.put("app/components/view/sgb-v-publications/sgb-v-publications.html","<div class=\"form-group row sgbField sgbVPublications\"><label class=\"col-sm-12\">{{vPubblCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"indexColumn\"></th><th class=\"descrColumn\">{{\"PUBLICATION\" | translate}}</th><th class=\"ifColumn\" ng-if=\"vPubblCtrl.opts.showImpactFactor\">Impact Factor</th></tr></thead><tbody><tr class=\"noPublications\" ng-if=\"vPubblCtrl.model.length == 0\"><td colspan=\"{{vPubblCtrl.opts.showImpactFactor ? 3 : 2}}\">{{\"NO_PUBLICATION\" | translate}}</td></tr><tr ng-repeat=\"pubblicazione in vPubblCtrl.model\"><td class=\"indexColumn\">{{$index + 1}}</td><td class=\"descrColumn\"><div class=\"idInfo\"><span ng-if=\"pubblicazione.pubblicazione.prodottoId\">Id UGOV: {{pubblicazione.pubblicazione.prodottoId}} -</span><span ng-if=\"pubblicazione.pubblicazione.handle\">Handle: {{pubblicazione.pubblicazione.handle}} -</span>{{pubblicazione.pubblicazione.tipo}}</div><div class=\"titolo\">{{pubblicazione.pubblicazione.titolo}}</div><div class=\"autori\"><span class=\"anno\">{{pubblicazione.pubblicazione.anno}}</span> - {{pubblicazione.pubblicazione.autori}}</div><div class=\"descrizione\">{{pubblicazione.pubblicazione.testo}}</div></td><td class=\"ifColumn\" ng-if=\"vPubblCtrl.opts.showImpactFactor\">{{pubblicazione.pubblicazione.impactFactor ? pubblicazione.pubblicazione.impactFactor : \'-\'}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-publicationsPart/sgb-v-publicationsPart.html","<div class=\"form-group row sgbField sgbVPublicationsPart\"><label class=\"col-sm-12\">{{vPubblPartCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"indexColumn\"></th><th class=\"descrColumn\">{{\"PUBLICATION\" | translate}}</th><th class=\"ifColumn\" ng-if=\"vPubblPartCtrl.opts.showImpactFactor\">Impact Factor</th><th class=\"participantColumn\">{{\"PARTICIPANT\" | translate}}</th></tr></thead><tbody><tr class=\"noPublications\" ng-if=\"vPubblPartCtrl.model.length == 0\"><td colspan=\"{{vPubblPartCtrl.opts.showImpactFactor ? 4 : 3}}\">{{\"NO_PUBLICATION\" | translate}}</td></tr><tr ng-repeat=\"pubblicazione in vPubblPartCtrl.model\"><td class=\"indexColumn\">{{$index + 1}}</td><td class=\"descrColumn\"><div class=\"idInfo\"><span ng-if=\"pubblicazione.pubblicazione.prodottoId\">Id UGOV: {{pubblicazione.pubblicazione.prodottoId}} -</span><span ng-if=\"pubblicazione.pubblicazione.handle\">Handle: {{pubblicazione.pubblicazione.handle}} -</span>{{pubblicazione.pubblicazione.tipo}}</div><div class=\"titolo\">{{pubblicazione.pubblicazione.titolo}}</div><div class=\"autori\"><span class=\"anno\">{{pubblicazione.pubblicazione.anno}}</span> - {{pubblicazione.pubblicazione.autori}}</div><div class=\"descrizione\">{{pubblicazione.pubblicazione.testo}}</div></td><td class=\"ifColumn\" ng-if=\"vPubblPartCtrl.opts.showImpactFactor\">{{pubblicazione.pubblicazione.impactFactor ? pubblicazione.pubblicazione.impactFactor : \'-\'}}</td><td class=\"participantColumn\">{{pubblicazione.utente.cognome}} {{pubblicazione.utente.nome}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-publicationsRend/sgb-v-publicationsRend.html","<div class=\"form-group row sgbField sgbVPublicationsRend\"><label class=\"col-sm-12\">{{vPubblRendCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"indexColumn\"></th><th class=\"descrColumn\">Pubblicazione</th><th class=\"sourceColumn\">Provenienza</th></tr></thead><tbody><tr class=\"noPublications\" ng-if=\"vPubblRendCtrl.model.length == 0\"><td colspan=\"3\">Nessuna pubblicazione</td></tr><tr ng-repeat=\"pubblicazione in vPubblRendCtrl.model\"><td class=\"indexColumn\">{{$index + 1}}</td><td class=\"descrColumn\"><div class=\"idInfo\" ng-if=\"pubblicazione.prodottoId || pubblicazione.handle\"><span ng-if=\"pubblicazione.prodottoId\">Id UGOV: {{pubblicazione.prodottoId}} -</span><span ng-if=\"pubblicazione.handle\">Handle: {{pubblicazione.handle}} -</span>{{pubblicazione.tipo}}</div><div class=\"titolo\">{{pubblicazione.titolo}}</div><div class=\"autori\"><span class=\"anno\">{{pubblicazione.anno}}</span> - {{pubblicazione.autori}}</div><div class=\"descrizione\">{{pubblicazione.testo}}</div></td><td class=\"sourceColumn\">{{pubblicazione.prodottoId || pubblicazione.handle ? \'IRIS\' : \'Inserimento manuale\'}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-report/sgb-v-report.html","<div class=\"form-group row sgbField sgbVReport\"><label class=\"col-sm-12\">{{vReprt.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"expenseColumn\">Voce di spesa</th><th class=\"valueColumn\">Finanziamento richiesto</th><th class=\"valueColumn\">Finanziamento concesso</th><th class=\"valueColumn\">Finanziamento speso</th><th class=\"descriptionColumn\">Descrizione utilizzo fondi</th></tr></thead><tbody><tr ng-repeat=\"row in vReprt.model.vociRendicontoList\"><td class=\"expenseColumn\">{{row.nome}}</td><td class=\"valueColumn\">{{row.finanziamentoRichiesto}}</td><td class=\"valueColumn greyValue\">{{(row.finanziamentoRichiesto / vReprt.model.totaleRichiesto * vReprt.model.totaleConcesso) | currencyFilterNoThousands}}</td><td class=\"valueColumn\">{{row.finanziamentoSpeso}}<span class=\"asterisk\" ng-if=\"vReprt.checkScostamento && vReprt.asteriskRows[$index]\">*</span></td><td class=\"descriptionColumn\"><span>{{row.descrizioneSpesa}}</span></td></tr><tr class=\"totalRow\"><td class=\"expenseColumn\">TOTALE</td><td class=\"valueColumn\">{{vReprt.model.totaleRichiesto | number}}<div style=\"font-size: 10px; font-weight: normal;\">richiesti</div></td><td class=\"valueColumn\">{{vReprt.model.totaleConcesso | number}}<div style=\"font-size: 10px; font-weight: normal;\">concessi</div></td><td class=\"valueColumn\" ng-class=\"{\'text-danger\' : vReprt.getTotal(vReprt.model.vociRendicontoList, \'finanziamentoSpeso\') > vReprt.model.totaleConcesso}\">{{vReprt.getTotal(vReprt.model.vociRendicontoList, \'finanziamentoSpeso\') | currencyFilter }}<div style=\"font-size: 10px; font-weight: normal;\">spesi</div></td><td class=\"descriptionColumn\"></td></tr></tbody></table></div><div class=\"col-sm-12\" ng-if=\"vReprt.modelMotivazione != null\"><div class=\"perc-speso-label\">* Motivazioni dello scostamento significativo di alcune voci rispetto alla somma concessa</div><div class=\"panel panel-default\"><div class=\"panel-body motivazione\"><span>{{vReprt.modelMotivazione}}</span></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-researchIndicators/sgb-v-researchIndicators.html","<div class=\"form-group row sgbField sgbVResearchIndicators\"><label class=\"col-sm-12\">{{vResIndCtrl.label}}</label><div class=\"col-sm-12\" ng-if=\"vResIndCtrl.model.autorizzazione\"><table class=\"table\"><thead><tr><th class=\"labelColumn\">&nbsp;</th><th class=\"indicatorColumn\">Indicatore A</th><th class=\"indicatorColumn\">Indicatore B</th><th class=\"indicatorColumn\">Indicatore C</th></tr></thead><tbody><tr><th class=\"labelColumn\" ng-if=\"vResIndCtrl.model.soglia1 != null\">Valore soglia SC {{vResIndCtrl.model.sc}} - SSD {{vResIndCtrl.model.ssd}}</th><th class=\"labelColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null\">Valore soglia</th><td class=\"indicatorColumn\">{{vResIndCtrl.model.soglia1 != null ? vResIndCtrl.model.soglia1 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl.model.soglia2 != null ? vResIndCtrl.model.soglia2 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl.model.soglia3 != null ? vResIndCtrl.model.soglia3 : \'-\'}}</td></tr><tr><th class=\"labelColumn\" ng-if=\"vResIndCtrl.model.soglia1 != null\">Valore dell\'indicatore calcolato dall\'Ateneo al {{vResIndCtrl.model.dataIndicatore}}</th><th class=\"labelColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null\">Valore dell\'indicatore calcolato dall\'Ateneo</th><td class=\"indicatorColumn\">{{vResIndCtrl.model.indicatore1 != null ? vResIndCtrl.model.indicatore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl.model.indicatore2 != null ? vResIndCtrl.model.indicatore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl.model.indicatore3 != null ? vResIndCtrl.model.indicatore3 : \'-\'}}</td></tr><tr ng-if=\"vResIndCtrl.opts.allowCorrection\"><th class=\"labelColumn\" ng-if=\"vResIndCtrl.model.soglia1 != null\">Eventuale rettifica del valore dell\'indicatore, dichiarata dal docente</th><th class=\"labelColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null\">Valore dell\'indicatore, dichiarato dal docente</th><td class=\"indicatorColumn\">{{vResIndCtrl.model.valore1 != null ? vResIndCtrl.model.valore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl.model.valore2 != null ? vResIndCtrl.model.valore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl.model.valore3 != null ? vResIndCtrl.model.valore3 : \'-\'}}</td></tr><tr class=\"separator\"><th colspan=\"4\"></th></tr><tr class=\"borderless\"><th class=\"labelColumn\">Eventuali mesi di congedo ai fini del calcolo dell\'indicatore A</th><td class=\"indicatorColumn\">{{vResIndCtrl.model.mesiCongedo1 != null ? vResIndCtrl.model.mesiCongedo1 : \'-\'}}</td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"vResIndCtrl.model.soglia1 != null || !vResIndCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null && vResIndCtrl.opts.allowCorrection\">SC</th><td class=\"indicatorColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null && vResIndCtrl.opts.allowCorrection\">{{vResIndCtrl.model.sc != null ? vResIndCtrl.model.sc : \'-\'}}</td></tr><tr class=\"borderless\"><th class=\"labelColumn\">Eventuali mesi di congedo ai fini del calcolo degli indicatori B e C</th><td class=\"indicatorColumn\">{{vResIndCtrl.model.mesiCongedo2 != null ? vResIndCtrl.model.mesiCongedo2 : \'-\'}}</td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"vResIndCtrl.model.soglia1 != null || !vResIndCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null && vResIndCtrl.opts.allowCorrection\">SSD</th><td class=\"indicatorColumn\" ng-if=\"vResIndCtrl.model.soglia1 == null && vResIndCtrl.opts.allowCorrection\">{{vResIndCtrl.model.ssd != null ? vResIndCtrl.model.ssd : \'-\'}}</td></tr></tbody></table></div><div class=\"col-sm-12\" ng-if=\"!vResIndCtrl.model.autorizzazione\"><div class=\"panel panel-default\"><div class=\"panel-body\"><span>Il docente non ha ancora autorizzato la visione degli indicatori.</span></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-researchIndicators2021/sgb-v-researchIndicators2021.html","<div class=\"form-group row sgbField sgbVResearchIndicators\"><label class=\"col-sm-12\">{{vResIndCtrl2021.label}}</label><div class=\"col-sm-12\" ng-if=\"vResIndCtrl2021.model.autorizzazione\"><table class=\"table\"><thead><tr><th class=\"labelColumn\">&nbsp;</th><th class=\"indicatorColumn\">Indicatore A</th><th class=\"indicatorColumn\">Indicatore B</th><th class=\"indicatorColumn\">Indicatore C</th></tr></thead><tbody><tr><th class=\"labelColumn\" ng-if=\"vResIndCtrl2021.model.soglia1 != null\">Valore soglia SC {{vResIndCtrl2021.model.sc}} - SSD {{vResIndCtrl2021.model.ssd}}</th><th class=\"labelColumn\" ng-if=\"vResIndCtrl2021.model.soglia1 == null\">Valore soglia</th><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.soglia1 != null ? vResIndCtrl2021.model.soglia1 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.soglia2 != null ? vResIndCtrl2021.model.soglia2 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.soglia3 != null ? vResIndCtrl2021.model.soglia3 : \'-\'}}</td></tr><tr><th class=\"labelColumn\" ng-if=\"vResIndCtrl2021.model.soglia1 != null\">Valore dell\'indicatore calcolato dall\'Ateneo al {{vResIndCtrl2021.model.dataIndicatore}}</th><th class=\"labelColumn\" ng-if=\"vResIndCtrl2021.model.soglia1 == null\">Valore dell\'indicatore calcolato dall\'Ateneo</th><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.indicatore1 != null ? vResIndCtrl2021.model.indicatore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.indicatore2 != null ? vResIndCtrl2021.model.indicatore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.indicatore3 != null ? vResIndCtrl2021.model.indicatore3 : \'-\'}}</td></tr><tr ng-if=\"vResIndCtrl2021.opts.allowCorrection\"><th class=\"labelColumn\" ng-if=\"vResIndCtrl2021.model.soglia1 != null\">Eventuale rettifica del valore dell\'indicatore, dichiarata dal docente</th><th class=\"labelColumn\" ng-if=\"vResIndCtrl2021.model.soglia1 == null\">Valore dell\'indicatore, dichiarato dal docente</th><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.valore1 != null ? vResIndCtrl2021.model.valore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.valore2 != null ? vResIndCtrl2021.model.valore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{vResIndCtrl2021.model.valore3 != null ? vResIndCtrl2021.model.valore3 : \'-\'}}</td></tr><tr class=\"separator\"><th colspan=\"4\"></th></tr></tbody></table></div><div class=\"col-sm-12\" ng-if=\"!vResIndCtrl2021.model.autorizzazione\"><div class=\"panel panel-default\"><div class=\"panel-body\"><span>Il docente non ha ancora autorizzato la visione degli indicatori.</span></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-researchIndicatorsPart/sgb-v-researchIndicatorsPart.html","<div class=\"form-group row sgbField sgbVResearchIndicatorsPart\"><label class=\"col-sm-12\">{{vResIndPartCtrl.label}}</label><div class=\"col-sm-12\"><table class=\"table\"><thead><tr><th class=\"nameColumn\">Cognome e Nome</th><th class=\"labelColumn\">&nbsp;</th><th class=\"indicatorColumn\">Indicatore A</th><th class=\"indicatorColumn\">Indicatore B</th><th class=\"indicatorColumn\">Indicatore C</th></tr></thead><tbody><tr class=\"noParticipants\" ng-if=\"vResIndPartCtrl.model.length == 0\"><td colspan=\"5\">Nessun componente</td></tr><tr class=\"userRow\" ng-repeat-start=\"indicatorePart in vResIndPartCtrl.model\"><td class=\"nameColumn\" ng-if=\"!indicatorePart.autorizzazione\">{{indicatorePart.utente.cognome}} {{indicatorePart.utente.nome}}</td><td class=\"missingAuthMessage\" colspan=\"4\" ng-if=\"!indicatorePart.autorizzazione\">Il docente non ha ancora autorizzato la visione degli indicatori.</td><td class=\"nameColumn\" rowspan=\"{{vResIndPartCtrl.opts.allowCorrection ? 5 : 4}}\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.utente.cognome}} {{indicatorePart.utente.nome}}</td><th class=\"labelColumn\" ng-if=\"indicatorePart.autorizzazione\"><span ng-if=\"indicatorePart.soglia1 != null\">Valore soglia SC {{indicatorePart.sc}} - SSD {{indicatorePart.ssd}}</span> <span ng-if=\"indicatorePart.soglia1 == null\">Valore soglia</span></th><td class=\"indicatorColumn\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.soglia1 != null ? indicatorePart.soglia1 : \'-\'}}</td><td class=\"indicatorColumn\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.soglia2 != null ? indicatorePart.soglia2 : \'-\'}}</td><td class=\"indicatorColumn\" ng-if=\"indicatorePart.autorizzazione\">{{indicatorePart.soglia3 != null ? indicatorePart.soglia3 : \'-\'}}</td></tr><tr ng-if=\"indicatorePart.autorizzazione\"><th class=\"labelColumn\"><span ng-if=\"indicatorePart.soglia1 != null\">Valore calcolato dall\'Ateneo al {{indicatorePart.dataIndicatore}}</span> <span ng-if=\"indicatorePart.soglia1 == null\">Valore calcolato dall\'Ateneo</span></th><td class=\"indicatorColumn\">{{indicatorePart.indicatore1 != null ? indicatorePart.indicatore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.indicatore2 != null ? indicatorePart.indicatore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.indicatore3 != null ? indicatorePart.indicatore3 : \'-\'}}</td></tr><tr ng-if=\"indicatorePart.autorizzazione && vResIndPartCtrl.opts.allowCorrection\"><th class=\"labelColumn\"><span ng-if=\"indicatorePart.soglia1 != null\">Eventuale rettifica del valore, dichiarata dal docente</span> <span ng-if=\"indicatorePart.soglia1 == null\">Valore dell\'indicatore, dichiarato dal docente</span></th><td class=\"indicatorColumn\">{{indicatorePart.valore1 != null ? indicatorePart.valore1 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.valore2 != null ? indicatorePart.valore2 : \'-\'}}</td><td class=\"indicatorColumn\">{{indicatorePart.valore3 != null ? indicatorePart.valore3 : \'-\'}}</td></tr><tr ng-if=\"indicatorePart.autorizzazione\"><th class=\"labelColumn\">Eventuali mesi di congedo (indicatore A)</th><td class=\"indicatorColumn\">{{indicatorePart.mesiCongedo1 != null ? indicatorePart.mesiCongedo1 : \'-\'}}</td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"indicatorePart.soglia1 != null || !vResIndPartCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"indicatorePart.soglia1 == null && vResIndPartCtrl.opts.allowCorrection\">SC</th><td class=\"indicatorColumn\" ng-if=\"indicatorePart.soglia1 == null && vResIndPartCtrl.opts.allowCorrection\">{{indicatorePart.sc != null ? indicatorePart.sc : \'-\'}}</td></tr><tr class=\"noBorderTop\" ng-if=\"indicatorePart.autorizzazione\" ng-repeat-end=\"\"><th class=\"labelColumn\">Eventuali mesi di congedo (indicatori B e C)</th><td class=\"indicatorColumn\">{{indicatorePart.mesiCongedo2 != null ? indicatorePart.mesiCongedo2 : \'-\'}}</td><td class=\"indicatorColumn\" colspan=\"2\" ng-if=\"indicatorePart.soglia1 != null || !vResIndPartCtrl.opts.allowCorrection\"></td><th class=\"labelRightColumn\" ng-if=\"indicatorePart.soglia1 == null && vResIndPartCtrl.opts.allowCorrection\">SSD</th><td class=\"indicatorColumn\" ng-if=\"indicatorePart.soglia1 == null && vResIndPartCtrl.opts.allowCorrection\">{{indicatorePart.ssd != null ? indicatorePart.ssd : \'-\'}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/view/sgb-v-rich-text/sgb-v-rich-text.html","<div class=\"form-group row sgbField sgbVRichText\"><label class=\"col-sm-12\">{{sgbVRichTextCtrl.label}}</label><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><span ng-bind-html=\"sgbVRichTextCtrl.prepareText(sgbVRichTextCtrl.model)\"></span></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-selectFields/sgb-v-selectFields.html","<div class=\"form-group row sgbField sgbVSelectFields\"><label class=\"col-sm-12\">{{vSelectsCtrl.label}}</label><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><ol ng-if=\"vSelectsCtrl.model != null\"><li ng-repeat=\"value in vSelectsCtrl.model track by $index\" ng-if=\"value != null\">{{$eval(vSelectsCtrl.labelFormat, value)}}</li></ol></div></div></div></div>");
$templateCache.put("app/components/view/sgb-v-text/sgb-v-text.html","<div class=\"form-group row sgbField sgbVText\"><label class=\"col-sm-12\">{{sgbVTextCtrl.label}}</label><div class=\"col-sm-12 description-block\" ng-if=\"sgbVTextCtrl.description\"><span ng-bind-html=\"sgbVTextCtrl.description\"></span></div><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><span>{{sgbVTextCtrl.model}}</span></div></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/eighth-layer/eighth-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"vm.lastNode\"><fpc-section-title ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TITOLO\'\" model=\"vm.model.campoSuccessivo\"></fpc-section-title><fpc-text-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TESTO\'\" model=\"vm.model.campoSuccessivo\"></fpc-text-input><fpc-number-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'INTERO\'\" model=\"vm.model.campoSuccessivo\"></fpc-number-input><fpc-radio-group level=\"vm.level\" expansion=\"vm.expansion\" uid=\"vm.campoUID\" model=\"vm.model.campoSuccessivo\" ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'RADIO\'\"></fpc-radio-group><fpc-check-group ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SCELTA_MULTIPLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-check-group><fpc-drop-list ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SCELTA_SINGOLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-drop-list><fpc-drop-list ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SELECT\'\" model=\"vm.model.campoSuccessivo\"></fpc-drop-list><fpc-currency-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'IMPORTO\'\" model=\"vm.model.campoSuccessivo\"></fpc-currency-input><fpc-edit-table ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TABELLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-edit-table><fpc-file-upload ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'UPLOAD_FILE\'\" model=\"vm.model.campoSuccessivo\"></fpc-file-upload><fpc-alert-block ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'ALERT\'\" message=\"vm.model.campoSuccessivo\"></fpc-alert-block><fpc-email-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'EMAIL\'\" model=\"vm.model.campoSuccessivo\"></fpc-email-input><fpc-parole-cun-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'PAROLE_CUN\'\" model=\"vm.model.campoSuccessivo\"></fpc-parole-cun-input><div class=\"expansion\" ng-if=\"vm.expansion[vm.campoUID]\" ng-repeat=\"sublayer in vm.expansion[vm.campoUID]\"><ninth-layer-assembler model=\"sublayer\"></ninth-layer-assembler></div></div><div ng-if=\"vm.hasDependency && vm.model.sezioneSuccessiva.campi\" class=\"expanded pad-bot\" ng-repeat=\"field in vm.model.sezioneSuccessiva.campi\"><fpc-section-title ng-if=\"field.tipoCampo === \'TITOLO\'\" model=\"field\"></fpc-section-title><fpc-text-input ng-if=\"field.tipoCampo === \'TESTO\'\" model=\"field\"></fpc-text-input><fpc-number-input ng-if=\"field.tipoCampo === \'INTERO\'\" model=\"field\"></fpc-number-input><fpc-radio-group level=\"vm.level\" ng-if=\"field.tipoCampo === \'RADIO\'\" model=\"field\" expansion=\"vm.expansion\" uid=\"field.uid\"></fpc-radio-group><fpc-check-group ng-if=\"field.tipoCampo === \'SCELTA_MULTIPLA\'\" model=\"field\" expansion=\"vm.expansion\" uid=\"field.uid\"></fpc-check-group><fpc-drop-list ng-if=\"field.tipoCampo === \'SCELTA_SINGOLA\'\" model=\"field\"></fpc-drop-list><fpc-drop-list ng-if=\"field.tipoCampo === \'SELECT\'\" model=\"field\"></fpc-drop-list><fpc-currency-input ng-if=\"field.tipoCampo === \'IMPORTO\'\" model=\"field\"></fpc-currency-input><fpc-edit-table ng-if=\"field.tipoCampo === \'TABELLA\'\" model=\"field\"></fpc-edit-table><fpc-file-upload ng-if=\"field.tipoCampo === \'UPLOAD_FILE\'\" model=\"field\"></fpc-file-upload><fpc-alert-block ng-if=\"field.tipoCampo === \'ALERT\'\" model=\"field\"></fpc-alert-block><fpc-email-input ng-if=\"field.tipoCampo === \'EMAIL\'\" model=\"field\"></fpc-email-input><fpc-parole-cun-input ng-if=\"field.tipoCampo === \'PAROLE_CUN\'\" model=\"field\"></fpc-parole-cun-input><div class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><ninth-layer-assembler ng-if=\"!sublayer.length\" model=\"sublayer\"></ninth-layer-assembler><div ng-if=\"sublayer.length\" ng-repeat=\"layer in sublayer\"><ninth-layer-assembler model=\"layer\"></ninth-layer-assembler></div></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/fifth-layer/fifth-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"!vm.iterable\"><fpc-field-switch model=\"vm.model.campoSuccessivo\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[vm.model.campoSuccessivo.uid]\" ng-repeat=\"sublayer in vm.expansion[vm.model.campoSuccessivo.uid]\"><sixth-layer-assembler model=\"sublayer\"></sixth-layer-assembler></div></div><div ng-if=\"vm.iterable\" ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><sixth-layer-assembler model=\"sublayer\"></sixth-layer-assembler></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/first-layer/first-layer.html","<div ng-if=\"!vm.hide\" class=\"cert-expand-container\"><div ng-if=\"!vm.iterable\"><fpc-field-switch model=\"vm.model.campoSuccessivo\" expansion=\"vm.expansion\"></fpc-field-switch><div class=\"expansion\" ng-if=\"vm.expansion[vm.model.campoSuccessivo.uid]\" ng-repeat=\"sublayer in vm.expansion[vm.model.campoSuccessivo.uid]\"><second-layer-assembler model=\"sublayer\"></second-layer-assembler></div></div><div ng-if=\"vm.iterable\" ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\"></fpc-field-switch><div class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><second-layer-assembler model=\"sublayer\"></second-layer-assembler></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/fourth-layer/fourth-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"!vm.iterable\"><fpc-field-switch model=\"vm.model.campoSuccessivo\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[vm.model.campoSuccessivo.uid]\" ng-repeat=\"sublayer in vm.expansion[vm.model.campoSuccessivo.uid]\"><fifth-layer-assembler model=\"sublayer\"></fifth-layer-assembler></div></div><div ng-if=\"vm.iterable\" ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><fifth-layer-assembler model=\"sublayer\"></fifth-layer-assembler></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/ninth-layer/ninth-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"vm.lastNode\"><fpc-section-title ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TITOLO\'\" model=\"vm.model.campoSuccessivo\"></fpc-section-title><fpc-text-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TESTO\'\" model=\"vm.model.campoSuccessivo\"></fpc-text-input><fpc-number-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'INTERO\'\" model=\"vm.model.campoSuccessivo\"></fpc-number-input><fpc-radio-group level=\"vm.level\" expansion=\"vm.expansion\" uid=\"vm.campoUID\" model=\"vm.model.campoSuccessivo\" ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'RADIO\'\"></fpc-radio-group><fpc-check-group ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SCELTA_MULTIPLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-check-group><fpc-drop-list ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SCELTA_SINGOLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-drop-list><fpc-drop-list ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SELECT\'\" model=\"vm.model.campoSuccessivo\"></fpc-drop-list><fpc-currency-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'IMPORTO\'\" model=\"vm.model.campoSuccessivo\"></fpc-currency-input><fpc-edit-table ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TABELLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-edit-table><fpc-file-upload ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'UPLOAD_FILE\'\" model=\"vm.model.campoSuccessivo\"></fpc-file-upload><fpc-alert-block ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'ALERT\'\" message=\"vm.model.campoSuccessivo\"></fpc-alert-block><fpc-email-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'EMAIL\'\" model=\"vm.model.campoSuccessivo\"></fpc-email-input><fpc-parole-cun-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'PAROLE_CUN\'\" model=\"vm.model.campoSuccessivo\"></fpc-parole-cun-input><div class=\"expansion\" ng-if=\"vm.expansion[vm.campoUID]\" ng-repeat=\"sublayer in vm.expansion[vm.campoUID]\"><tenth-layer-assembler model=\"sublayer\"></tenth-layer-assembler></div></div><div ng-if=\"vm.hasDependency && vm.model.sezioneSuccessiva.campi\" class=\"expanded pad-bot\" ng-repeat=\"field in vm.model.sezioneSuccessiva.campi\"><fpc-section-title ng-if=\"field.tipoCampo === \'TITOLO\'\" model=\"field\"></fpc-section-title><fpc-text-input ng-if=\"field.tipoCampo === \'TESTO\'\" model=\"field\"></fpc-text-input><fpc-number-input ng-if=\"field.tipoCampo === \'INTERO\'\" model=\"field\"></fpc-number-input><fpc-radio-group level=\"vm.level\" ng-if=\"field.tipoCampo === \'RADIO\'\" model=\"field\" expansion=\"vm.expansion\" uid=\"field.uid\"></fpc-radio-group><fpc-check-group ng-if=\"field.tipoCampo === \'SCELTA_MULTIPLA\'\" model=\"field\" expansion=\"vm.expansion\" uid=\"field.uid\"></fpc-check-group><fpc-drop-list ng-if=\"field.tipoCampo === \'SCELTA_SINGOLA\'\" model=\"field\"></fpc-drop-list><fpc-drop-list ng-if=\"field.tipoCampo === \'SELECT\'\" model=\"field\"></fpc-drop-list><fpc-currency-input ng-if=\"field.tipoCampo === \'IMPORTO\'\" model=\"field\"></fpc-currency-input><fpc-edit-table ng-if=\"field.tipoCampo === \'TABELLA\'\" model=\"field\"></fpc-edit-table><fpc-file-upload ng-if=\"field.tipoCampo === \'UPLOAD_FILE\'\" model=\"field\"></fpc-file-upload><fpc-alert-block ng-if=\"field.tipoCampo === \'ALERT\'\" model=\"field\"></fpc-alert-block><fpc-email-input ng-if=\"field.tipoCampo === \'EMAIL\'\" model=\"field\"></fpc-email-input><fpc-parole-cun-input ng-if=\"field.tipoCampo === \'PAROLE_CUN\'\" model=\"field\"></fpc-parole-cun-input><div class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><tenth-layer-assembler ng-if=\"!sublayer.length\" model=\"sublayer\"></tenth-layer-assembler><div ng-if=\"sublayer.length\" ng-repeat=\"layer in sublayer\"><tenth-layer-assembler model=\"layer\"></tenth-layer-assembler></div></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/second-layer/second-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"!vm.iterable\"><fpc-field-switch model=\"vm.model.campoSuccessivo\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[vm.model.campoSuccessivo.uid]\" ng-repeat=\"sublayer in vm.expansion[vm.model.campoSuccessivo.uid]\"><third-layer-assembler model=\"sublayer\"></third-layer-assembler></div></div><div ng-if=\"vm.iterable\" ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><third-layer-assembler model=\"sublayer\"></third-layer-assembler></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/seventh-layer/seventh-layer.html","<div class=\"cert-expand-container\">SEVENTH</div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/sixth-layer/sixth-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"!vm.iterable\"><fpc-field-switch model=\"vm.model.campoSuccessivo\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[vm.model.campoSuccessivo.uid]\" ng-repeat=\"sublayer in vm.expansion[vm.model.campoSuccessivo.uid]\"><seventh-layer-assembler model=\"sublayer\"></seventh-layer-assembler></div></div><div ng-if=\"vm.iterable\" ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><seventh-layer-assembler model=\"sublayer\"></seventh-layer-assembler></div></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/tenth-layer/tenth-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"vm.lastNode\"><fpc-section-title ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TITOLO\'\" model=\"vm.model.campoSuccessivo\"></fpc-section-title><fpc-text-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TESTO\'\" model=\"vm.model.campoSuccessivo\"></fpc-text-input><fpc-number-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'INTERO\'\" model=\"vm.model.campoSuccessivo\"></fpc-number-input><fpc-radio-group level=\"vm.level\" expansion=\"vm.expansion\" uid=\"vm.campoUID\" model=\"vm.model.campoSuccessivo\" ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'RADIO\'\"></fpc-radio-group><fpc-check-group ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SCELTA_MULTIPLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-check-group><fpc-drop-list ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SCELTA_SINGOLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-drop-list><fpc-drop-list ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'SELECT\'\" model=\"vm.model.campoSuccessivo\"></fpc-drop-list><fpc-currency-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'IMPORTO\'\" model=\"vm.model.campoSuccessivo\"></fpc-currency-input><fpc-edit-table ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'TABELLA\'\" model=\"vm.model.campoSuccessivo\"></fpc-edit-table><fpc-file-upload ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'UPLOAD_FILE\'\" model=\"vm.model.campoSuccessivo\"></fpc-file-upload><fpc-alert-block ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'ALERT\'\" message=\"vm.model.campoSuccessivo\"></fpc-alert-block><fpc-email-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'EMAIL\'\" model=\"vm.model.campoSuccessivo\"></fpc-email-input><fpc-parole-cun-input ng-if=\"vm.model.campoSuccessivo.tipoCampo === \'PAROLE_CUN\'\" model=\"vm.model.campoSuccessivo\"></fpc-parole-cun-input></div><div ng-if=\"vm.hasDependency && vm.model.sezioneSuccessiva.campi\" class=\"expanded pad-bot\" ng-repeat=\"field in vm.model.sezioneSuccessiva.campi\"><fpc-section-title ng-if=\"field.tipoCampo === \'TITOLO\'\" model=\"field\"></fpc-section-title><fpc-text-input ng-if=\"field.tipoCampo === \'TESTO\'\" model=\"field\"></fpc-text-input><fpc-number-input ng-if=\"field.tipoCampo === \'INTERO\'\" model=\"field\"></fpc-number-input><fpc-radio-group level=\"vm.level\" ng-if=\"field.tipoCampo === \'RADIO\'\" model=\"field\" expansion=\"vm.expansion\" uid=\"field.uid\"></fpc-radio-group><fpc-check-group ng-if=\"field.tipoCampo === \'SCELTA_MULTIPLA\'\" model=\"field\" expansion=\"vm.expansion\" uid=\"field.uid\"></fpc-check-group><fpc-drop-list ng-if=\"field.tipoCampo === \'SCELTA_SINGOLA\'\" model=\"field\"></fpc-drop-list><fpc-drop-list ng-if=\"field.tipoCampo === \'SELECT\'\" model=\"field\"></fpc-drop-list><fpc-currency-input ng-if=\"field.tipoCampo === \'IMPORTO\'\" model=\"field\"></fpc-currency-input><fpc-edit-table ng-if=\"field.tipoCampo === \'TABELLA\'\" model=\"field\"></fpc-edit-table><fpc-file-upload ng-if=\"field.tipoCampo === \'UPLOAD_FILE\'\" model=\"field\"></fpc-file-upload><fpc-alert-block ng-if=\"field.tipoCampo === \'ALERT\'\" model=\"field\"></fpc-alert-block><fpc-email-input ng-if=\"field.tipoCampo === \'EMAIL\'\" model=\"field\"></fpc-email-input><fpc-parole-cun-input ng-if=\"field.tipoCampo === \'PAROLE_CUN\'\" model=\"field\"></fpc-parole-cun-input></div></div>");
$templateCache.put("app/components/formPropostaCert/fpc-atomic-assembler/third-layer/third-layer.html","<div class=\"cert-expand-container\"><div ng-if=\"!vm.iterable\"><fpc-field-switch model=\"vm.model.campoSuccessivo\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[vm.model.campoSuccessivo.uid]\" ng-repeat=\"sublayer in vm.expansion[vm.model.campoSuccessivo.uid]\"><fourth-layer-assembler model=\"sublayer\"></fourth-layer-assembler></div></div><div ng-if=\"vm.iterable\" ng-repeat=\"field in vm.iterable\"><fpc-field-switch model=\"field\" expansion=\"vm.expansion\"></fpc-field-switch><div ng-class=\"{\'hasExportedSection\': vm.hasExportedSection }\" class=\"expansion\" ng-if=\"vm.expansion[field.uid]\" ng-repeat=\"sublayer in vm.expansion[field.uid]\"><fourth-layer-assembler model=\"sublayer\"></fourth-layer-assembler></div></div></div>");}]);